var dT = Object.defineProperty;
var vT = (t, e, r) => e in t ? dT(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var iv = (t, e, r) => (vT(t, typeof e != "symbol" ? e + "" : e, r), r);
import * as Yr from "react";
import Se, { useState as Jo, useCallback as go, useEffect as yp, useMemo as Zo, lazy as yT, createContext as Mr, Component as Pl, isValidElement as kl, createElement as Tr, useContext as ca, forwardRef as Cl, useRef as GS, Suspense as _T, useLayoutEffect as WS, Fragment as mT } from "react";
import { TimestampUnit as HS, DateTimeRange as jl, DateTime as Er } from "@bimone/bimtrack-dates";
import { useTranslation as gT, I18nextProvider as bT } from "react-i18next";
import _p from "i18next";
class wT extends Error {
  constructor() {
    super("The requested has timed out"), this.name = "RequestTimeoutError";
  }
}
class ET extends Error {
  constructor() {
    super("The request was actively canceled"), this.name = "RequestCanceledError";
  }
}
class JS extends Error {
  constructor(e, r, n) {
    super(r), this.code = e, this.props = n, this.name = "HttpError", this.statusCode = e;
    for (const i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (this[i] = n[i]);
  }
}
var Ho = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Kp(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var mp = { exports: {} };
mp.exports;
(function(t, e) {
  var r = 200, n = "Expected a function", i = "__lodash_hash_undefined__", o = 1, s = 2, u = 1 / 0, c = 9007199254740991, a = "[object Arguments]", f = "[object Array]", h = "[object Boolean]", p = "[object Date]", d = "[object Error]", _ = "[object Function]", m = "[object GeneratorFunction]", b = "[object Map]", O = "[object Number]", S = "[object Object]", k = "[object Promise]", T = "[object RegExp]", x = "[object Set]", P = "[object String]", R = "[object Symbol]", D = "[object WeakMap]", I = "[object ArrayBuffer]", j = "[object DataView]", Y = "[object Float32Array]", H = "[object Float64Array]", B = "[object Int8Array]", tt = "[object Int16Array]", lt = "[object Int32Array]", te = "[object Uint8Array]", pt = "[object Uint8ClampedArray]", At = "[object Uint16Array]", ft = "[object Uint32Array]", Lt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, dt = /^\w*$/, mt = /^\./, st = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Nt = /[\\^$.*+?()[\]{}|]/g, Qt = /\\(\\)?/g, Rt = /^\[object .+?Constructor\]$/, xt = /^(?:0|[1-9]\d*)$/, N = {};
  N[Y] = N[H] = N[B] = N[tt] = N[lt] = N[te] = N[pt] = N[At] = N[ft] = !0, N[a] = N[f] = N[I] = N[h] = N[j] = N[p] = N[d] = N[_] = N[b] = N[O] = N[S] = N[T] = N[x] = N[P] = N[D] = !1;
  var ht = typeof Ho == "object" && Ho && Ho.Object === Object && Ho, gt = typeof self == "object" && self && self.Object === Object && self, X = ht || gt || Function("return this")(), wt = e && !e.nodeType && e, jt = wt && !0 && t && !t.nodeType && t, qt = jt && jt.exports === wt, U = qt && ht.process, $ = function() {
    try {
      return U && U.binding("util");
    } catch {
    }
  }(), W = $ && $.isTypedArray;
  function et(l, v) {
    for (var g = -1, E = l ? l.length : 0; ++g < E; )
      if (v(l[g], g, l))
        return !0;
    return !1;
  }
  function ot(l) {
    return function(v) {
      return v == null ? void 0 : v[l];
    };
  }
  function Dt(l, v) {
    for (var g = -1, E = Array(l); ++g < l; )
      E[g] = v(g);
    return E;
  }
  function St(l) {
    return function(v) {
      return l(v);
    };
  }
  function Et(l, v) {
    return l == null ? void 0 : l[v];
  }
  function ue(l) {
    var v = !1;
    if (l != null && typeof l.toString != "function")
      try {
        v = !!(l + "");
      } catch {
      }
    return v;
  }
  function ae(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E, M) {
      g[++v] = [M, E];
    }), g;
  }
  function ce(l, v) {
    return function(g) {
      return l(v(g));
    };
  }
  function Yt(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E) {
      g[++v] = E;
    }), g;
  }
  var Ot = Array.prototype, Oe = Function.prototype, Gt = Object.prototype, se = X["__core-js_shared__"], Zt = function() {
    var l = /[^.]+$/.exec(se && se.keys && se.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), fe = Oe.toString, vt = Gt.hasOwnProperty, Mt = Gt.toString, Fr = RegExp(
    "^" + fe.call(vt).replace(Nt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), We = X.Symbol, He = X.Uint8Array, Nr = Gt.propertyIsEnumerable, Ie = Ot.splice, Je = ce(Object.keys, Object), It = _e(X, "DataView"), Tt = _e(X, "Map"), ee = _e(X, "Promise"), ye = _e(X, "Set"), Ae = _e(X, "WeakMap"), Ut = _e(Object, "create"), zr = ne(It), Ze = ne(Tt), Xe = ne(ee), Lr = ne(ye), Ur = ne(Ae), re = We ? We.prototype : void 0, De = re ? re.valueOf : void 0, tr = re ? re.toString : void 0;
  function Pt(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Br() {
    this.__data__ = Ut ? Ut(null) : {};
  }
  function y(l) {
    return this.has(l) && delete this.__data__[l];
  }
  function w(l) {
    var v = this.__data__;
    if (Ut) {
      var g = v[l];
      return g === i ? void 0 : g;
    }
    return vt.call(v, l) ? v[l] : void 0;
  }
  function A(l) {
    var v = this.__data__;
    return Ut ? v[l] !== void 0 : vt.call(v, l);
  }
  function q(l, v) {
    var g = this.__data__;
    return g[l] = Ut && v === void 0 ? i : v, this;
  }
  Pt.prototype.clear = Br, Pt.prototype.delete = y, Pt.prototype.get = w, Pt.prototype.has = A, Pt.prototype.set = q;
  function F(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Q() {
    this.__data__ = [];
  }
  function L(l) {
    var v = this.__data__, g = nr(v, l);
    if (g < 0)
      return !1;
    var E = v.length - 1;
    return g == E ? v.pop() : Ie.call(v, g, 1), !0;
  }
  function z(l) {
    var v = this.__data__, g = nr(v, l);
    return g < 0 ? void 0 : v[g][1];
  }
  function it(l) {
    return nr(this.__data__, l) > -1;
  }
  function J(l, v) {
    var g = this.__data__, E = nr(g, l);
    return E < 0 ? g.push([l, v]) : g[E][1] = v, this;
  }
  F.prototype.clear = Q, F.prototype.delete = L, F.prototype.get = z, F.prototype.has = it, F.prototype.set = J;
  function K(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function ut() {
    this.__data__ = {
      hash: new Pt(),
      map: new (Tt || F)(),
      string: new Pt()
    };
  }
  function Bt(l) {
    return ir(this, l).delete(l);
  }
  function er(l) {
    return ir(this, l).get(l);
  }
  function bt(l) {
    return ir(this, l).has(l);
  }
  function cs(l, v) {
    return ir(this, l).set(l, v), this;
  }
  K.prototype.clear = ut, K.prototype.delete = Bt, K.prototype.get = er, K.prototype.has = bt, K.prototype.set = cs;
  function rr(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.__data__ = new K(); ++v < g; )
      this.add(l[v]);
  }
  function fs(l) {
    return this.__data__.set(l, i), this;
  }
  function ls(l) {
    return this.__data__.has(l);
  }
  rr.prototype.add = rr.prototype.push = fs, rr.prototype.has = ls;
  function kt(l) {
    this.__data__ = new F(l);
  }
  function hs() {
    this.__data__ = new F();
  }
  function ps(l) {
    return this.__data__.delete(l);
  }
  function ds(l) {
    return this.__data__.get(l);
  }
  function vs(l) {
    return this.__data__.has(l);
  }
  function ys(l, v) {
    var g = this.__data__;
    if (g instanceof F) {
      var E = g.__data__;
      if (!Tt || E.length < r - 1)
        return E.push([l, v]), this;
      g = this.__data__ = new K(E);
    }
    return g.set(l, v), this;
  }
  kt.prototype.clear = hs, kt.prototype.delete = ps, kt.prototype.get = ds, kt.prototype.has = vs, kt.prototype.set = ys;
  function _s(l, v) {
    var g = ie(l) || Jn(l) ? Dt(l.length, String) : [], E = g.length, M = !!E;
    for (var C in l)
      (v || vt.call(l, C)) && !(M && (C == "length" || Yn(C, E))) && g.push(C);
    return g;
  }
  function nr(l, v) {
    for (var g = l.length; g--; )
      if (Hn(l[g][0], v))
        return g;
    return -1;
  }
  var ms = ks();
  function gs(l, v) {
    return l && ms(l, v, cr);
  }
  function Kn(l, v) {
    v = or(v, l) ? [v] : Vn(v);
    for (var g = 0, E = v.length; l != null && g < E; )
      l = l[sr(v[g++])];
    return g && g == E ? l : void 0;
  }
  function bs(l) {
    return Mt.call(l);
  }
  function ws(l, v) {
    return l != null && v in Object(l);
  }
  function $r(l, v, g, E, M) {
    return l === v ? !0 : l == null || v == null || !ar(l) && !ur(v) ? l !== l && v !== v : Es(l, v, $r, g, E, M);
  }
  function Es(l, v, g, E, M, C) {
    var V = ie(l), G = ie(v), Z = f, rt = f;
    V || (Z = $t(l), Z = Z == a ? S : Z), G || (rt = $t(v), rt = rt == a ? S : rt);
    var at = Z == S && !ue(l), ct = rt == S && !ue(v), nt = Z == rt;
    if (nt && !at)
      return C || (C = new kt()), V || Bs(l) ? Qn(l, v, g, E, M, C) : Cs(l, v, Z, g, E, M, C);
    if (!(M & s)) {
      var yt = at && vt.call(l, "__wrapped__"), _t = ct && vt.call(v, "__wrapped__");
      if (yt || _t) {
        var Kt = yt ? l.value() : l, Ct = _t ? v.value() : v;
        return C || (C = new kt()), g(Kt, Ct, E, M, C);
      }
    }
    return nt ? (C || (C = new kt()), js(l, v, g, E, M, C)) : !1;
  }
  function Ss(l, v, g, E) {
    var M = g.length, C = M, V = !E;
    if (l == null)
      return !C;
    for (l = Object(l); M--; ) {
      var G = g[M];
      if (V && G[2] ? G[1] !== l[G[0]] : !(G[0] in l))
        return !1;
    }
    for (; ++M < C; ) {
      G = g[M];
      var Z = G[0], rt = l[Z], at = G[1];
      if (V && G[2]) {
        if (rt === void 0 && !(Z in l))
          return !1;
      } else {
        var ct = new kt();
        if (E)
          var nt = E(rt, at, Z, l, v, ct);
        if (!(nt === void 0 ? $r(at, rt, E, o | s, ct) : nt))
          return !1;
      }
    }
    return !0;
  }
  function Os(l) {
    if (!ar(l) || Ns(l))
      return !1;
    var v = Xn(l) || ue(l) ? Fr : Rt;
    return v.test(ne(l));
  }
  function Is(l) {
    return ur(l) && Vr(l.length) && !!N[Mt.call(l)];
  }
  function As(l) {
    return typeof l == "function" ? l : l == null ? Ys : typeof l == "object" ? ie(l) ? xs(l[0], l[1]) : Rs(l) : Gs(l);
  }
  function Ds(l) {
    if (!zs(l))
      return Je(l);
    var v = [];
    for (var g in Object(l))
      vt.call(l, g) && g != "constructor" && v.push(g);
    return v;
  }
  function Rs(l) {
    var v = qs(l);
    return v.length == 1 && v[0][2] ? Wn(v[0][0], v[0][1]) : function(g) {
      return g === l || Ss(g, l, v);
    };
  }
  function xs(l, v) {
    return or(l) && Gn(v) ? Wn(sr(l), v) : function(g) {
      var E = Ks(g, l);
      return E === void 0 && E === v ? Vs(g, l) : $r(v, E, void 0, o | s);
    };
  }
  function Ts(l) {
    return function(v) {
      return Kn(v, l);
    };
  }
  function Ps(l) {
    if (typeof l == "string")
      return l;
    if (Qr(l))
      return tr ? tr.call(l) : "";
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function Vn(l) {
    return ie(l) ? l : Ls(l);
  }
  function ks(l) {
    return function(v, g, E) {
      for (var M = -1, C = Object(v), V = E(v), G = V.length; G--; ) {
        var Z = V[l ? G : ++M];
        if (g(C[Z], Z, C) === !1)
          break;
      }
      return v;
    };
  }
  function Qn(l, v, g, E, M, C) {
    var V = M & s, G = l.length, Z = v.length;
    if (G != Z && !(V && Z > G))
      return !1;
    var rt = C.get(l);
    if (rt && C.get(v))
      return rt == v;
    var at = -1, ct = !0, nt = M & o ? new rr() : void 0;
    for (C.set(l, v), C.set(v, l); ++at < G; ) {
      var yt = l[at], _t = v[at];
      if (E)
        var Kt = V ? E(_t, yt, at, v, l, C) : E(yt, _t, at, l, v, C);
      if (Kt !== void 0) {
        if (Kt)
          continue;
        ct = !1;
        break;
      }
      if (nt) {
        if (!et(v, function(Ct, oe) {
          if (!nt.has(oe) && (yt === Ct || g(yt, Ct, E, M, C)))
            return nt.add(oe);
        })) {
          ct = !1;
          break;
        }
      } else if (!(yt === _t || g(yt, _t, E, M, C))) {
        ct = !1;
        break;
      }
    }
    return C.delete(l), C.delete(v), ct;
  }
  function Cs(l, v, g, E, M, C, V) {
    switch (g) {
      case j:
        if (l.byteLength != v.byteLength || l.byteOffset != v.byteOffset)
          return !1;
        l = l.buffer, v = v.buffer;
      case I:
        return !(l.byteLength != v.byteLength || !E(new He(l), new He(v)));
      case h:
      case p:
      case O:
        return Hn(+l, +v);
      case d:
        return l.name == v.name && l.message == v.message;
      case T:
      case P:
        return l == v + "";
      case b:
        var G = ae;
      case x:
        var Z = C & s;
        if (G || (G = Yt), l.size != v.size && !Z)
          return !1;
        var rt = V.get(l);
        if (rt)
          return rt == v;
        C |= o, V.set(l, v);
        var at = Qn(G(l), G(v), E, M, C, V);
        return V.delete(l), at;
      case R:
        if (De)
          return De.call(l) == De.call(v);
    }
    return !1;
  }
  function js(l, v, g, E, M, C) {
    var V = M & s, G = cr(l), Z = G.length, rt = cr(v), at = rt.length;
    if (Z != at && !V)
      return !1;
    for (var ct = Z; ct--; ) {
      var nt = G[ct];
      if (!(V ? nt in v : vt.call(v, nt)))
        return !1;
    }
    var yt = C.get(l);
    if (yt && C.get(v))
      return yt == v;
    var _t = !0;
    C.set(l, v), C.set(v, l);
    for (var Kt = V; ++ct < Z; ) {
      nt = G[ct];
      var Ct = l[nt], oe = v[nt];
      if (E)
        var ti = V ? E(oe, Ct, nt, v, l, C) : E(Ct, oe, nt, l, v, C);
      if (!(ti === void 0 ? Ct === oe || g(Ct, oe, E, M, C) : ti)) {
        _t = !1;
        break;
      }
      Kt || (Kt = nt == "constructor");
    }
    if (_t && !Kt) {
      var fr = l.constructor, lr = v.constructor;
      fr != lr && "constructor" in l && "constructor" in v && !(typeof fr == "function" && fr instanceof fr && typeof lr == "function" && lr instanceof lr) && (_t = !1);
    }
    return C.delete(l), C.delete(v), _t;
  }
  function ir(l, v) {
    var g = l.__data__;
    return Fs(v) ? g[typeof v == "string" ? "string" : "hash"] : g.map;
  }
  function qs(l) {
    for (var v = cr(l), g = v.length; g--; ) {
      var E = v[g], M = l[E];
      v[g] = [E, M, Gn(M)];
    }
    return v;
  }
  function _e(l, v) {
    var g = Et(l, v);
    return Os(g) ? g : void 0;
  }
  var $t = bs;
  (It && $t(new It(new ArrayBuffer(1))) != j || Tt && $t(new Tt()) != b || ee && $t(ee.resolve()) != k || ye && $t(new ye()) != x || Ae && $t(new Ae()) != D) && ($t = function(l) {
    var v = Mt.call(l), g = v == S ? l.constructor : void 0, E = g ? ne(g) : void 0;
    if (E)
      switch (E) {
        case zr:
          return j;
        case Ze:
          return b;
        case Xe:
          return k;
        case Lr:
          return x;
        case Ur:
          return D;
      }
    return v;
  });
  function Ms(l, v, g) {
    v = or(v, l) ? [v] : Vn(v);
    for (var E, M = -1, V = v.length; ++M < V; ) {
      var C = sr(v[M]);
      if (!(E = l != null && g(l, C)))
        break;
      l = l[C];
    }
    if (E)
      return E;
    var V = l ? l.length : 0;
    return !!V && Vr(V) && Yn(C, V) && (ie(l) || Jn(l));
  }
  function Yn(l, v) {
    return v = v ?? c, !!v && (typeof l == "number" || xt.test(l)) && l > -1 && l % 1 == 0 && l < v;
  }
  function or(l, v) {
    if (ie(l))
      return !1;
    var g = typeof l;
    return g == "number" || g == "symbol" || g == "boolean" || l == null || Qr(l) ? !0 : dt.test(l) || !Lt.test(l) || v != null && l in Object(v);
  }
  function Fs(l) {
    var v = typeof l;
    return v == "string" || v == "number" || v == "symbol" || v == "boolean" ? l !== "__proto__" : l === null;
  }
  function Ns(l) {
    return !!Zt && Zt in l;
  }
  function zs(l) {
    var v = l && l.constructor, g = typeof v == "function" && v.prototype || Gt;
    return l === g;
  }
  function Gn(l) {
    return l === l && !ar(l);
  }
  function Wn(l, v) {
    return function(g) {
      return g == null ? !1 : g[l] === v && (v !== void 0 || l in Object(g));
    };
  }
  var Ls = Kr(function(l) {
    l = $s(l);
    var v = [];
    return mt.test(l) && v.push(""), l.replace(st, function(g, E, M, C) {
      v.push(M ? C.replace(Qt, "$1") : E || g);
    }), v;
  });
  function sr(l) {
    if (typeof l == "string" || Qr(l))
      return l;
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function ne(l) {
    if (l != null) {
      try {
        return fe.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function Kr(l, v) {
    if (typeof l != "function" || v && typeof v != "function")
      throw new TypeError(n);
    var g = function() {
      var E = arguments, M = v ? v.apply(this, E) : E[0], C = g.cache;
      if (C.has(M))
        return C.get(M);
      var V = l.apply(this, E);
      return g.cache = C.set(M, V), V;
    };
    return g.cache = new (Kr.Cache || K)(), g;
  }
  Kr.Cache = K;
  function Hn(l, v) {
    return l === v || l !== l && v !== v;
  }
  function Jn(l) {
    return Us(l) && vt.call(l, "callee") && (!Nr.call(l, "callee") || Mt.call(l) == a);
  }
  var ie = Array.isArray;
  function Zn(l) {
    return l != null && Vr(l.length) && !Xn(l);
  }
  function Us(l) {
    return ur(l) && Zn(l);
  }
  function Xn(l) {
    var v = ar(l) ? Mt.call(l) : "";
    return v == _ || v == m;
  }
  function Vr(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= c;
  }
  function ar(l) {
    var v = typeof l;
    return !!l && (v == "object" || v == "function");
  }
  function ur(l) {
    return !!l && typeof l == "object";
  }
  function Qr(l) {
    return typeof l == "symbol" || ur(l) && Mt.call(l) == R;
  }
  var Bs = W ? St(W) : Is;
  function $s(l) {
    return l == null ? "" : Ps(l);
  }
  function Ks(l, v, g) {
    var E = l == null ? void 0 : Kn(l, v);
    return E === void 0 ? g : E;
  }
  function Vs(l, v) {
    return l != null && Ms(l, v, ws);
  }
  function cr(l) {
    return Zn(l) ? _s(l) : Ds(l);
  }
  function Qs(l, v) {
    var g = {};
    return v = As(v), gs(l, function(E, M, C) {
      g[v(E, M, C)] = E;
    }), g;
  }
  function Ys(l) {
    return l;
  }
  function Gs(l) {
    return or(l) ? ot(sr(l)) : Ts(l);
  }
  t.exports = Qs;
})(mp, mp.exports);
var ST = mp.exports;
const OT = /* @__PURE__ */ Kp(ST), IT = 6e4;
var ZS = /* @__PURE__ */ ((t) => (t.OMIT = "omit", t.SAME_ORIGIN = "same-origin", t.INCLUDE = "include", t))(ZS || {}), fa = /* @__PURE__ */ ((t) => (t.GET = "GET", t.POST = "POST", t.PUT = "PUT", t.DELETE = "DELETE", t.PATCH = "PATCH", t))(fa || {});
function h1(t) {
  return t.replace(/\/+$/, "");
}
class Zf {
  constructor({
    baseUrl: e = "",
    endpoint: r,
    token: n,
    body: i,
    credentials: o = ZS.SAME_ORIGIN,
    queryParams: s = {},
    headers: u = {},
    captchaToken: c,
    signal: a,
    timeOutMs: f = IT
  }) {
    this.baseUrl = e, this.endpoint = r, this.token = n, this.body = i, this.queryParams = s, this.currentHeaders = u, this.credentials = o, this.captchaToken = c, this.signal = a, this.timeOutMs = f;
  }
  get headers() {
    return this.currentHeaders;
  }
  async performRequest(e) {
    var c;
    const r = this.buildRequestUrl(), n = this.buildRequestHeaders(), i = new AbortController();
    let o;
    const s = this.body ? { method: e, headers: n, credentials: this.credentials, body: this.buildBody(), signal: i == null ? void 0 : i.signal } : { method: e, headers: n, credentials: this.credentials, signal: i == null ? void 0 : i.signal };
    (c = this.signal) == null || c.addEventListener("abort", () => {
      o = new ET(), i.abort();
    });
    const u = setTimeout(() => {
      o = new wT(), i.abort();
    }, this.timeOutMs);
    try {
      return await fetch(r, s);
    } catch (a) {
      throw o ?? a;
    } finally {
      clearTimeout(u);
    }
  }
  buildRequestUrl() {
    const e = Object.keys(this.queryParams).filter((n) => this.queryParams[n] !== void 0 && this.queryParams[n] !== null).map((n) => [n, this.queryParams[n]].map((i) => encodeURIComponent(String(i))).join("=")).join("&"), r = `${h1(this.baseUrl)}/${this.endpoint}`;
    return e.length > 0 ? `${r}?${e}` : r;
  }
  buildRequestHeaders() {
    const e = this.isBodyContainsAFile() ? this.headers : { Accept: "application/json", ...this.headers }, r = this.body && !this.isBodyContainsAFile() ? { "Content-Type": "application/json" } : void 0, n = this.token ? { Authorization: `Bearer ${this.token}` } : void 0, i = this.captchaToken ? { "X-Captcha-Token": this.captchaToken } : void 0;
    return {
      ...e,
      ...n,
      ...r,
      ...i
    };
  }
  setupHeaderForGetRequest() {
    this.currentHeaders = {
      Pragma: "no-cache",
      "Cache-Control": "no-cache",
      ...this.currentHeaders
    };
  }
  static async processErrorInResponse(e) {
    const r = await e.json(), n = OT(r, (i, o) => o.charAt(0).toLowerCase() + o.slice(1));
    return new JS(e.status, n.message ?? n.title, {
      errorCode: n.code,
      //Can't call just "code" as it's already used by HttpError for HTTP status
      data: n.data,
      type: n.type
    });
  }
  isBodyContainsAFile() {
    return this.body instanceof FormData;
  }
  buildBody() {
    return this.body ? this.isBodyContainsAFile() ? this.body : JSON.stringify(this.body) : null;
  }
  /** deprecated **/
  static stripTrailingSlash(e) {
    return h1(e);
  }
}
class XS extends Zf {
  async getBlob() {
    return await this.sendBlobRequest(fa.GET);
  }
  async sendBlobRequest(e) {
    const r = await this.performRequest(e);
    return await XS.handleBlobResponse(r);
  }
  static async handleBlobResponse(e) {
    if (e.ok)
      return await e.blob();
    throw new JS(e.status, e.statusText);
  }
}
class F_ extends Zf {
  async get() {
    return await this.sendRequest(fa.GET);
  }
  async post() {
    return await this.sendRequest(fa.POST);
  }
  async put() {
    return await this.sendRequest(fa.PUT);
  }
  async delete() {
    return await this.sendRequest(fa.DELETE);
  }
  async patch() {
    return await this.sendRequest(fa.PATCH);
  }
  async sendRequest(e) {
    e === fa.GET && this.setupHeaderForGetRequest();
    const r = await this.performRequest(e);
    return await F_.handleResponse(r);
  }
  static async handleResponse(e) {
    if (!e.ok)
      throw await Zf.processErrorInResponse(e);
    switch (e.status) {
      case 204:
        return;
      default:
        return e.body ? e.json() : void 0;
    }
  }
}
const tO = class by extends Zf {
  async head() {
    const e = await this.performRequest(by.HEAD_METHOD);
    return await by.handleHeadResponse(e);
  }
  static async handleHeadResponse(e) {
    if (e.ok)
      return e.headers;
    throw await Zf.processErrorInResponse(e);
  }
};
tO.HEAD_METHOD = "HEAD";
let S9 = tO;
var qu = /* @__PURE__ */ ((t) => (t[t.PENDING = 0] = "PENDING", t[t.READY = 1] = "READY", t[t.FAILED = 2] = "FAILED", t))(qu || {});
const eO = window, AT = "default", DT = "default";
function RT(t) {
  return Array.from(document.querySelectorAll("script")).find((e) => e.src === t ? e : void 0);
}
const Qa = /* @__PURE__ */ new Map();
function xT(t, e, r = !0, n = !1) {
  const i = Qa.get(e);
  if (i)
    return i;
  const o = new Promise((s, u) => {
    try {
      if (e && eO[e]) {
        s(), Qa.delete(e);
        return;
      }
      let c = RT(t);
      if (c) {
        s(), Qa.delete(e);
        return;
      }
      c = document.createElement("script"), c.src = t, c.type = "text/javascript", c.async = n, c.defer = r, c.onload = () => {
        s(), Qa.delete(e);
      }, c.onerror = () => {
        u(new Error("Unable to load the remote module's script!")), Qa.delete(e);
      }, document.head.appendChild(c);
    } catch (c) {
      throw Qa.delete(e), c;
    }
  });
  return Qa.set(e, o), o;
}
const ep = /* @__PURE__ */ new Map();
function p1(t, e, r, n) {
  return `${t}:${e}:${r}/${n}`;
}
async function TT({ url: t, shareScope: e = AT, scope: r, module: n, namedExport: i, defer: o = !0, async: s = !1 }, u = !0) {
  const c = i ?? DT, a = p1(t, r, n, c);
  let f;
  if (!u || !ep.has(a)) {
    await xT(t, r, o, s), await __webpack_init_sharing__(e);
    const h = eO[r];
    await h.init(__webpack_share_scopes__[e]), f = (await h.get(n))()[c], u && ep.set(p1(t, r, n, c), f);
  } else
    f = ep.get(a);
  if (!f)
    throw new Error(`'${c}' export is not defined in module`);
  return f;
}
function O9() {
  ep.clear();
}
function PT({ url: t, scope: e, module: r, namedExport: n, defer: i = !0, async: o = !1 }, s = !1, u = !0) {
  const [c, a] = Jo(void 0), f = go(async () => {
    const h = await TT({ url: t, scope: e, module: r, namedExport: n, defer: i, async: o }, u);
    return a(() => h), h;
  }, [o, u, i, r, n, e, t]);
  return yp(() => {
    s && f().then();
  }, [s, f]), { exportedValue: c, load: f };
}
var wy = { exports: {} }, pf = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d1;
function kT() {
  if (d1)
    return pf;
  d1 = 1;
  var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, c, a) {
    var f, h = {}, p = null, d = null;
    a !== void 0 && (p = "" + a), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (f in c)
      n.call(c, f) && !o.hasOwnProperty(f) && (h[f] = c[f]);
    if (u && u.defaultProps)
      for (f in c = u.defaultProps, c)
        h[f] === void 0 && (h[f] = c[f]);
    return { $$typeof: e, type: u, key: p, ref: d, props: h, _owner: i.current };
  }
  return pf.Fragment = r, pf.jsx = s, pf.jsxs = s, pf;
}
var df = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var v1;
function CT() {
  return v1 || (v1 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), a = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), _ = Symbol.iterator, m = "@@iterator";
    function b(y) {
      if (y === null || typeof y != "object")
        return null;
      var w = _ && y[_] || y[m];
      return typeof w == "function" ? w : null;
    }
    var O = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(y) {
      {
        for (var w = arguments.length, A = new Array(w > 1 ? w - 1 : 0), q = 1; q < w; q++)
          A[q - 1] = arguments[q];
        k("error", y, A);
      }
    }
    function k(y, w, A) {
      {
        var q = O.ReactDebugCurrentFrame, F = q.getStackAddendum();
        F !== "" && (w += "%s", A = A.concat([F]));
        var Q = A.map(function(L) {
          return String(L);
        });
        Q.unshift("Warning: " + w), Function.prototype.apply.call(console[y], console, Q);
      }
    }
    var T = !1, x = !1, P = !1, R = !1, D = !1, I;
    I = Symbol.for("react.module.reference");
    function j(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === n || y === o || D || y === i || y === a || y === f || R || y === d || T || x || P || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === h || y.$$typeof === s || y.$$typeof === u || y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === I || y.getModuleId !== void 0));
    }
    function Y(y, w, A) {
      var q = y.displayName;
      if (q)
        return q;
      var F = w.displayName || w.name || "";
      return F !== "" ? A + "(" + F + ")" : A;
    }
    function H(y) {
      return y.displayName || "Context";
    }
    function B(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case a:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case u:
            var w = y;
            return H(w) + ".Consumer";
          case s:
            var A = y;
            return H(A._context) + ".Provider";
          case c:
            return Y(y, y.render, "ForwardRef");
          case h:
            var q = y.displayName || null;
            return q !== null ? q : B(y.type) || "Memo";
          case p: {
            var F = y, Q = F._payload, L = F._init;
            try {
              return B(L(Q));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var tt = Object.assign, lt = 0, te, pt, At, ft, Lt, dt, mt;
    function st() {
    }
    st.__reactDisabledLog = !0;
    function Nt() {
      {
        if (lt === 0) {
          te = console.log, pt = console.info, At = console.warn, ft = console.error, Lt = console.group, dt = console.groupCollapsed, mt = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: st,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        lt++;
      }
    }
    function Qt() {
      {
        if (lt--, lt === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: tt({}, y, {
              value: te
            }),
            info: tt({}, y, {
              value: pt
            }),
            warn: tt({}, y, {
              value: At
            }),
            error: tt({}, y, {
              value: ft
            }),
            group: tt({}, y, {
              value: Lt
            }),
            groupCollapsed: tt({}, y, {
              value: dt
            }),
            groupEnd: tt({}, y, {
              value: mt
            })
          });
        }
        lt < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Rt = O.ReactCurrentDispatcher, xt;
    function N(y, w, A) {
      {
        if (xt === void 0)
          try {
            throw Error();
          } catch (F) {
            var q = F.stack.trim().match(/\n( *(at )?)/);
            xt = q && q[1] || "";
          }
        return `
` + xt + y;
      }
    }
    var ht = !1, gt;
    {
      var X = typeof WeakMap == "function" ? WeakMap : Map;
      gt = new X();
    }
    function wt(y, w) {
      if (!y || ht)
        return "";
      {
        var A = gt.get(y);
        if (A !== void 0)
          return A;
      }
      var q;
      ht = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Q;
      Q = Rt.current, Rt.current = null, Nt();
      try {
        if (w) {
          var L = function() {
            throw Error();
          };
          if (Object.defineProperty(L.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(L, []);
            } catch (bt) {
              q = bt;
            }
            Reflect.construct(y, [], L);
          } else {
            try {
              L.call();
            } catch (bt) {
              q = bt;
            }
            y.call(L.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bt) {
            q = bt;
          }
          y();
        }
      } catch (bt) {
        if (bt && q && typeof bt.stack == "string") {
          for (var z = bt.stack.split(`
`), it = q.stack.split(`
`), J = z.length - 1, K = it.length - 1; J >= 1 && K >= 0 && z[J] !== it[K]; )
            K--;
          for (; J >= 1 && K >= 0; J--, K--)
            if (z[J] !== it[K]) {
              if (J !== 1 || K !== 1)
                do
                  if (J--, K--, K < 0 || z[J] !== it[K]) {
                    var ut = `
` + z[J].replace(" at new ", " at ");
                    return y.displayName && ut.includes("<anonymous>") && (ut = ut.replace("<anonymous>", y.displayName)), typeof y == "function" && gt.set(y, ut), ut;
                  }
                while (J >= 1 && K >= 0);
              break;
            }
        }
      } finally {
        ht = !1, Rt.current = Q, Qt(), Error.prepareStackTrace = F;
      }
      var Bt = y ? y.displayName || y.name : "", er = Bt ? N(Bt) : "";
      return typeof y == "function" && gt.set(y, er), er;
    }
    function jt(y, w, A) {
      return wt(y, !1);
    }
    function qt(y) {
      var w = y.prototype;
      return !!(w && w.isReactComponent);
    }
    function U(y, w, A) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return wt(y, qt(y));
      if (typeof y == "string")
        return N(y);
      switch (y) {
        case a:
          return N("Suspense");
        case f:
          return N("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case c:
            return jt(y.render);
          case h:
            return U(y.type, w, A);
          case p: {
            var q = y, F = q._payload, Q = q._init;
            try {
              return U(Q(F), w, A);
            } catch {
            }
          }
        }
      return "";
    }
    var $ = Object.prototype.hasOwnProperty, W = {}, et = O.ReactDebugCurrentFrame;
    function ot(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        et.setExtraStackFrame(A);
      } else
        et.setExtraStackFrame(null);
    }
    function Dt(y, w, A, q, F) {
      {
        var Q = Function.call.bind($);
        for (var L in y)
          if (Q(y, L)) {
            var z = void 0;
            try {
              if (typeof y[L] != "function") {
                var it = Error((q || "React class") + ": " + A + " type `" + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[L] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw it.name = "Invariant Violation", it;
              }
              z = y[L](w, L, q, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (J) {
              z = J;
            }
            z && !(z instanceof Error) && (ot(F), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", A, L, typeof z), ot(null)), z instanceof Error && !(z.message in W) && (W[z.message] = !0, ot(F), S("Failed %s type: %s", A, z.message), ot(null));
          }
      }
    }
    var St = Array.isArray;
    function Et(y) {
      return St(y);
    }
    function ue(y) {
      {
        var w = typeof Symbol == "function" && Symbol.toStringTag, A = w && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return A;
      }
    }
    function ae(y) {
      try {
        return ce(y), !1;
      } catch {
        return !0;
      }
    }
    function ce(y) {
      return "" + y;
    }
    function Yt(y) {
      if (ae(y))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ue(y)), ce(y);
    }
    var Ot = O.ReactCurrentOwner, Oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Gt, se, Zt;
    Zt = {};
    function fe(y) {
      if ($.call(y, "ref")) {
        var w = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function vt(y) {
      if ($.call(y, "key")) {
        var w = Object.getOwnPropertyDescriptor(y, "key").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Mt(y, w) {
      if (typeof y.ref == "string" && Ot.current && w && Ot.current.stateNode !== w) {
        var A = B(Ot.current.type);
        Zt[A] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(Ot.current.type), y.ref), Zt[A] = !0);
      }
    }
    function Fr(y, w) {
      {
        var A = function() {
          Gt || (Gt = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: A,
          configurable: !0
        });
      }
    }
    function We(y, w) {
      {
        var A = function() {
          se || (se = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: A,
          configurable: !0
        });
      }
    }
    var He = function(y, w, A, q, F, Q, L) {
      var z = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: y,
        key: w,
        ref: A,
        props: L,
        // Record the component responsible for creating this element.
        _owner: Q
      };
      return z._store = {}, Object.defineProperty(z._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(z, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(z, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(z.props), Object.freeze(z)), z;
    };
    function Nr(y, w, A, q, F) {
      {
        var Q, L = {}, z = null, it = null;
        A !== void 0 && (Yt(A), z = "" + A), vt(w) && (Yt(w.key), z = "" + w.key), fe(w) && (it = w.ref, Mt(w, F));
        for (Q in w)
          $.call(w, Q) && !Oe.hasOwnProperty(Q) && (L[Q] = w[Q]);
        if (y && y.defaultProps) {
          var J = y.defaultProps;
          for (Q in J)
            L[Q] === void 0 && (L[Q] = J[Q]);
        }
        if (z || it) {
          var K = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          z && Fr(L, K), it && We(L, K);
        }
        return He(y, z, it, F, q, Ot.current, L);
      }
    }
    var Ie = O.ReactCurrentOwner, Je = O.ReactDebugCurrentFrame;
    function It(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        Je.setExtraStackFrame(A);
      } else
        Je.setExtraStackFrame(null);
    }
    var Tt;
    Tt = !1;
    function ee(y) {
      return typeof y == "object" && y !== null && y.$$typeof === e;
    }
    function ye() {
      {
        if (Ie.current) {
          var y = B(Ie.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function Ae(y) {
      {
        if (y !== void 0) {
          var w = y.fileName.replace(/^.*[\\\/]/, ""), A = y.lineNumber;
          return `

Check your code at ` + w + ":" + A + ".";
        }
        return "";
      }
    }
    var Ut = {};
    function zr(y) {
      {
        var w = ye();
        if (!w) {
          var A = typeof y == "string" ? y : y.displayName || y.name;
          A && (w = `

Check the top-level render call using <` + A + ">.");
        }
        return w;
      }
    }
    function Ze(y, w) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var A = zr(w);
        if (Ut[A])
          return;
        Ut[A] = !0;
        var q = "";
        y && y._owner && y._owner !== Ie.current && (q = " It was passed a child from " + B(y._owner.type) + "."), It(y), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, q), It(null);
      }
    }
    function Xe(y, w) {
      {
        if (typeof y != "object")
          return;
        if (Et(y))
          for (var A = 0; A < y.length; A++) {
            var q = y[A];
            ee(q) && Ze(q, w);
          }
        else if (ee(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var F = b(y);
          if (typeof F == "function" && F !== y.entries)
            for (var Q = F.call(y), L; !(L = Q.next()).done; )
              ee(L.value) && Ze(L.value, w);
        }
      }
    }
    function Lr(y) {
      {
        var w = y.type;
        if (w == null || typeof w == "string")
          return;
        var A;
        if (typeof w == "function")
          A = w.propTypes;
        else if (typeof w == "object" && (w.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        w.$$typeof === h))
          A = w.propTypes;
        else
          return;
        if (A) {
          var q = B(w);
          Dt(A, y.props, "prop", q, y);
        } else if (w.PropTypes !== void 0 && !Tt) {
          Tt = !0;
          var F = B(w);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof w.getDefaultProps == "function" && !w.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ur(y) {
      {
        for (var w = Object.keys(y.props), A = 0; A < w.length; A++) {
          var q = w[A];
          if (q !== "children" && q !== "key") {
            It(y), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), It(null);
            break;
          }
        }
        y.ref !== null && (It(y), S("Invalid attribute `ref` supplied to `React.Fragment`."), It(null));
      }
    }
    function re(y, w, A, q, F, Q) {
      {
        var L = j(y);
        if (!L) {
          var z = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var it = Ae(F);
          it ? z += it : z += ye();
          var J;
          y === null ? J = "null" : Et(y) ? J = "array" : y !== void 0 && y.$$typeof === e ? (J = "<" + (B(y.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : J = typeof y, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", J, z);
        }
        var K = Nr(y, w, A, F, Q);
        if (K == null)
          return K;
        if (L) {
          var ut = w.children;
          if (ut !== void 0)
            if (q)
              if (Et(ut)) {
                for (var Bt = 0; Bt < ut.length; Bt++)
                  Xe(ut[Bt], y);
                Object.freeze && Object.freeze(ut);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xe(ut, y);
        }
        return y === n ? Ur(K) : Lr(K), K;
      }
    }
    function De(y, w, A) {
      return re(y, w, A, !0);
    }
    function tr(y, w, A) {
      return re(y, w, A, !1);
    }
    var Pt = tr, Br = De;
    df.Fragment = n, df.jsx = Pt, df.jsxs = Br;
  }()), df;
}
process.env.NODE_ENV === "production" ? wy.exports = kT() : wy.exports = CT();
var Ce = wy.exports;
function jT(t, e = !0) {
  const { url: r, module: n } = t, [i, o] = Jo(qu.PENDING), { load: s } = PT(t, e), u = go(async () => {
    try {
      o(qu.PENDING);
      const a = await s();
      return o(qu.READY), { default: a };
    } catch (a) {
      return o(qu.FAILED), console.error(`Unable to load the remote module ${n}' @ '${r} for the following reason:`, a), { default: () => /* @__PURE__ */ Ce.jsx(Ce.Fragment, {}) };
    }
  }, [s, n, r]), c = Zo(() => yT(u), [u]);
  return {
    status: i,
    remoteComponent: c
  };
}
function Vp(t, e, r, n) {
  Object.defineProperty(t, e, { get: r, set: n, enumerable: !0, configurable: !0 });
}
var qT = {};
Vp(qT, "ErrorBoundary", () => z_);
var MT = {};
Vp(MT, "ErrorBoundaryContext", () => N_);
const N_ = Mr(null), ov = {
  didCatch: !1,
  error: null
};
class z_ extends Pl {
  constructor() {
    super(...arguments);
    iv(this, "state", ov);
    iv(this, "resetErrorBoundary", (...r) => {
      var i, o;
      const { error: n } = this.state;
      n !== null && ((o = (i = this.props).onReset) == null || o.call(i, {
        args: r,
        reason: "imperative-api"
      }), this.setState(ov));
    });
  }
  static getDerivedStateFromError(r) {
    return {
      didCatch: !0,
      error: r
    };
  }
  componentDidCatch(r, n) {
    var i, o;
    (o = (i = this.props).onError) == null || o.call(i, r, n);
  }
  componentDidUpdate(r, n) {
    var s, u;
    const { didCatch: i } = this.state, { resetKeys: o } = this.props;
    i && n.error !== null && FT(r.resetKeys, o) && ((u = (s = this.props).onReset) == null || u.call(s, {
      next: o,
      prev: r.resetKeys,
      reason: "keys"
    }), this.setState(ov));
  }
  render() {
    const { children: r, fallbackRender: n, FallbackComponent: i, fallback: o } = this.props, { didCatch: s, error: u } = this.state;
    let c = r;
    if (s) {
      const a = {
        error: u,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (kl(o))
        c = o;
      else if (typeof n == "function")
        c = n(a);
      else if (i)
        c = Tr(i, a);
      else
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return Tr(N_.Provider, {
      value: {
        didCatch: s,
        error: u,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, c);
  }
}
function FT(t = [], e = []) {
  return t.length !== e.length || t.some((r, n) => !Object.is(r, e[n]));
}
var NT = {};
Vp(NT, "useErrorBoundary", () => LT);
function zT(t) {
  if (t == null || typeof t.didCatch != "boolean" || typeof t.resetErrorBoundary != "function")
    throw new Error("ErrorBoundaryContext not found");
  return !0;
}
function LT() {
  const t = ca(N_);
  zT(t);
  const [e, r] = Jo({
    error: null,
    hasError: !1
  }), n = Zo(() => ({
    resetBoundary: () => {
      t == null || t.resetErrorBoundary(), r({
        error: null,
        hasError: !1
      });
    },
    showBoundary: (i) => r({
      error: i,
      hasError: !0
    })
  }), [
    t == null ? void 0 : t.resetErrorBoundary
  ]);
  if (e.hasError)
    throw e.error;
  return n;
}
var UT = {};
Vp(UT, "withErrorBoundary", () => BT);
function BT(t, e) {
  const r = Cl((i, o) => Tr(z_, e, Tr(t, {
    ...i,
    ref: o
  }))), n = t.displayName || t.name || "Unknown";
  return r.displayName = `withErrorBoundary(${n})`, r;
}
function $T({ children: t, onFirstRenderRef: e }) {
  return yp(() => () => {
    var r;
    (r = e.current) == null || r.call(e), e.current = void 0;
  }, [e]), /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: t });
}
function KT(t, e) {
  console.error(`Stack: ${t.stack}`), console.error(`Component Stack: ${e.componentStack}`);
}
function VT({
  remoteEntry: t,
  innerProps: e,
  loadingComponent: r,
  errorComponent: n,
  cached: i,
  onFirstRender: o,
  fallbackRender: s
}) {
  const { status: u, remoteComponent: c } = jT(t, i), a = GS(o), f = go(
    (h) => /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: n }),
    [n]
  );
  return u === qu.FAILED ? /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: n }) : /* @__PURE__ */ Ce.jsx(
    z_,
    {
      fallbackRender: s ?? f,
      onError: KT,
      children: /* @__PURE__ */ Ce.jsx(
        _T,
        {
          fallback: /* @__PURE__ */ Ce.jsx($T, { onFirstRenderRef: a, children: r }),
          children: /* @__PURE__ */ Ce.jsx(c, { ...e ?? {} })
        }
      )
    }
  );
}
VT.displayName = "FederatedComponent";
const Ya = window, QT = "https://web-sdk.aptrinsic.com/api/aptrinsic.js", y1 = "gainSightScript", rO = Mr({
  productKey: void 0,
  locationPathName: "",
  setLocationPathName: () => {
  },
  aptrinsic: () => {
  },
  logDebug: () => {
  },
  isInitialized: !1,
  initialize: () => {
  }
});
function YT({
  debug: t = !1,
  productKey: e,
  children: r
}) {
  const [n, i] = Jo(!1), [o, s] = Jo("");
  Ya.aptrinsic = Ya.aptrinsic || ((...a) => {
    var f, h;
    (h = (f = Ya.aptrinsic) == null ? void 0 : f.q) == null || h.push(a);
  }), Ya.aptrinsic.q = Ya.aptrinsic.q || [], Ya.aptrinsic.p = e;
  const u = go(
    (...a) => {
      t && console.log(...a);
    },
    [t]
  ), c = go(() => {
    if (n)
      return;
    let a = document.getElementById(y1);
    if (a) {
      i(!0);
      return;
    }
    if (!e)
      return;
    u("initialize:createElement"), a = document.createElement("script"), a.id = y1, a.src = QT + "?a=" + e, a.async = !0;
    const f = document.getElementsByTagName("script")[0];
    ((f == null ? void 0 : f.parentNode) ?? document.head ?? document.body).insertBefore(a, f), i(!0);
  }, [n, u, e]);
  return /* @__PURE__ */ Ce.jsx(
    rO.Provider,
    {
      value: {
        productKey: e,
        locationPathName: o,
        setLocationPathName: s,
        aptrinsic: Ya.aptrinsic,
        logDebug: u,
        isInitialized: n,
        initialize: c
      },
      children: r
    }
  );
}
YT.displayName = "GainSightProvider";
function GT(t) {
  return Zo(() => {
    var e, r, n;
    if (t)
      return {
        id: t.globalId,
        hubId: t.localId.toFixed(1),
        name: t.name,
        hubCreationDate: (e = t.creationDate) == null ? void 0 : e.toTimestampAsString(HS.SECONDS),
        hubDataCenter: t.dataCenterInfo.name,
        isTrial: (r = t.subscription) == null ? void 0 : r.isTrial,
        hubUserCount: ((n = t.metrics) == null ? void 0 : n.totalUsers) ?? 0
      };
  }, [t]);
}
function WT(t) {
  return Zo(() => {
    var e, r, n, i;
    if (t)
      return {
        id: t.globalId,
        email: t.email,
        firstName: t.profile.firstName,
        lastName: t.profile.lastName,
        signUpDate: (e = t.activationDate) == null ? void 0 : e.toTimestampAsString(HS.SECONDS),
        lang: (r = t.profile.language) == null ? void 0 : r.id,
        title: t.profile.title,
        timeZone: (n = t.profile.timeZone) == null ? void 0 : n.nameIana,
        countryCode: (i = t.profile.country) == null ? void 0 : i.id
      };
  }, [t]);
}
function HT({ user: t, hub: e }) {
  const { productKey: r, aptrinsic: n, logDebug: i, setLocationPathName: o, isInitialized: s, initialize: u } = ca(rO), c = GT(e), a = WT(t), f = go(() => !!a && !!c, [c, a]), h = go(() => {
    f() && u();
  }, [f, u]), p = go(
    (m, b) => {
      o(m), f() && (i("configureProduct", b ?? r, " on ", m), n("config", "tagKey", b ?? r));
    },
    [n, f, i, r, o]
  ), d = go(() => {
    f() && (i("identity", a, c), n("identify", a, c), i("set:globalContext", c), n("set", "globalContext", c));
  }, [n, f, c, i, a]), _ = go(
    (m, b) => {
      if (!f())
        return;
      const O = { "Event Date": (/* @__PURE__ */ new Date()).toISOString(), ...b };
      i(`track:${m}`, O), n("track", m, O);
    },
    [n, f, i]
  );
  return {
    isInitialized: s,
    initialize: h,
    canIdentify: f,
    configureProduct: p,
    identify: d,
    logEvent: _
  };
}
function JT({ children: t, hub: e, locationPathName: r, user: n }) {
  const { initialize: i, configureProduct: o, canIdentify: s, identify: u } = HT({ hub: e, user: n });
  return WS(() => {
    o(r), u(), i();
  }, [s, o, u, i, r]), /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: t });
}
JT.displayName = "GainSightGate";
var Zs = /* @__PURE__ */ ((t) => (t.EN = "en", t.FR = "fr", t))(Zs || {});
class _1 {
  static getPreferredLanguage() {
    const r = (window.navigator.languages || [
      window.navigator.language || window.navigator.userLanguage
    ])[0].toLowerCase();
    for (const n in Zs)
      if (r.startsWith(n.toLowerCase()))
        return Zs[n];
    return Zs.EN;
  }
  static getPreferredTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
function ZT({
  children: t,
  user: e,
  localeSettings: r,
  fallbackComponent: n
}) {
  const [i, o] = Jo(), s = (e == null ? void 0 : e.profile.language.id) ?? _1.getPreferredLanguage(), u = (e == null ? void 0 : e.profile.timeZone.nameIana) ?? _1.getPreferredTimeZone();
  return WS(() => {
    r && (r.setCurrentLocale(s), r.setCurrentTimeZone(u), o(`${s}, ${u}`));
  }, [r, s, u]), i ? /* @__PURE__ */ Ce.jsx(mT, { children: t }, i) : n ?? null;
}
ZT.displayName = "LocaleSetup";
class ql {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    const r = {
      listener: e
    };
    return this.listeners.add(r), this.onSubscribe(), () => {
      this.listeners.delete(r), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const Xf = typeof window > "u" || "Deno" in window;
function Bi() {
}
function XT(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Ey(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function nO(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function Rf(t, e, r) {
  return Qp(t) ? typeof e == "function" ? {
    ...r,
    queryKey: t,
    queryFn: e
  } : {
    ...e,
    queryKey: t
  } : t;
}
function la(t, e, r) {
  return Qp(t) ? [{
    ...e,
    queryKey: t
  }, r] : [t || {}, e];
}
function m1(t, e) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: i,
    predicate: o,
    queryKey: s,
    stale: u
  } = t;
  if (Qp(s)) {
    if (n) {
      if (e.queryHash !== L_(s, e.options))
        return !1;
    } else if (!Mu(e.queryKey, s))
      return !1;
  }
  if (r !== "all") {
    const c = e.isActive();
    if (r === "active" && !c || r === "inactive" && c)
      return !1;
  }
  return !(typeof u == "boolean" && e.isStale() !== u || typeof i < "u" && i !== e.state.fetchStatus || o && !o(e));
}
function g1(t, e) {
  const {
    exact: r,
    fetching: n,
    predicate: i,
    mutationKey: o
  } = t;
  if (Qp(o)) {
    if (!e.options.mutationKey)
      return !1;
    if (r) {
      if (Xa(e.options.mutationKey) !== Xa(o))
        return !1;
    } else if (!Mu(e.options.mutationKey, o))
      return !1;
  }
  return !(typeof n == "boolean" && e.state.status === "loading" !== n || i && !i(e));
}
function L_(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Xa)(t);
}
function Xa(t) {
  return JSON.stringify(t, (e, r) => Sy(r) ? Object.keys(r).sort().reduce((n, i) => (n[i] = r[i], n), {}) : r);
}
function Mu(t, e) {
  return iO(t, e);
}
function iO(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((r) => !iO(t[r], e[r])) : !1;
}
function oO(t, e) {
  if (t === e)
    return t;
  const r = w1(t) && w1(e);
  if (r || Sy(t) && Sy(e)) {
    const n = r ? t.length : Object.keys(t).length, i = r ? e : Object.keys(e), o = i.length, s = r ? [] : {};
    let u = 0;
    for (let c = 0; c < o; c++) {
      const a = r ? c : i[c];
      s[a] = oO(t[a], e[a]), s[a] === t[a] && u++;
    }
    return n === o && u === n ? t : s;
  }
  return e;
}
function b1(t, e) {
  if (t && !e || e && !t)
    return !1;
  for (const r in t)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function w1(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function Sy(t) {
  if (!E1(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const r = e.prototype;
  return !(!E1(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function E1(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Qp(t) {
  return Array.isArray(t);
}
function sO(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function S1(t) {
  sO(0).then(t);
}
function tP() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function Oy(t, e, r) {
  return r.isDataEqual != null && r.isDataEqual(t, e) ? t : typeof r.structuralSharing == "function" ? r.structuralSharing(t, e) : r.structuralSharing !== !1 ? oO(t, e) : e;
}
class eP extends ql {
  constructor() {
    super(), this.setup = (e) => {
      if (!Xf && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("visibilitychange", r, !1), window.addEventListener("focus", r, !1), () => {
          window.removeEventListener("visibilitychange", r), window.removeEventListener("focus", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused = e, e && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const gp = new eP();
class rP extends ql {
  constructor() {
    super(), this.setup = (e) => {
      if (!Xf && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("online", r, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setOnline(n) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online = e, e && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const bp = new rP();
function nP(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function Yp(t) {
  return (t ?? "online") === "online" ? bp.isOnline() : !0;
}
class aO {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
}
function rp(t) {
  return t instanceof aO;
}
function uO(t) {
  let e = !1, r = 0, n = !1, i, o, s;
  const u = new Promise((b, O) => {
    o = b, s = O;
  }), c = (b) => {
    n || (d(new aO(b)), t.abort == null || t.abort());
  }, a = () => {
    e = !0;
  }, f = () => {
    e = !1;
  }, h = () => !gp.isFocused() || t.networkMode !== "always" && !bp.isOnline(), p = (b) => {
    n || (n = !0, t.onSuccess == null || t.onSuccess(b), i == null || i(), o(b));
  }, d = (b) => {
    n || (n = !0, t.onError == null || t.onError(b), i == null || i(), s(b));
  }, _ = () => new Promise((b) => {
    i = (O) => {
      const S = n || !h();
      return S && b(O), S;
    }, t.onPause == null || t.onPause();
  }).then(() => {
    i = void 0, n || t.onContinue == null || t.onContinue();
  }), m = () => {
    if (n)
      return;
    let b;
    try {
      b = t.fn();
    } catch (O) {
      b = Promise.reject(O);
    }
    Promise.resolve(b).then(p).catch((O) => {
      var S, k;
      if (n)
        return;
      const T = (S = t.retry) != null ? S : 3, x = (k = t.retryDelay) != null ? k : nP, P = typeof x == "function" ? x(r, O) : x, R = T === !0 || typeof T == "number" && r < T || typeof T == "function" && T(r, O);
      if (e || !R) {
        d(O);
        return;
      }
      r++, t.onFail == null || t.onFail(r, O), sO(P).then(() => {
        if (h())
          return _();
      }).then(() => {
        e ? d(O) : m();
      });
    });
  };
  return Yp(t.networkMode) ? m() : _().then(m), {
    promise: u,
    cancel: c,
    continue: () => (i == null ? void 0 : i()) ? u : Promise.resolve(),
    cancelRetry: a,
    continueRetry: f
  };
}
const U_ = console;
function iP() {
  let t = [], e = 0, r = (f) => {
    f();
  }, n = (f) => {
    f();
  };
  const i = (f) => {
    let h;
    e++;
    try {
      h = f();
    } finally {
      e--, e || u();
    }
    return h;
  }, o = (f) => {
    e ? t.push(f) : S1(() => {
      r(f);
    });
  }, s = (f) => (...h) => {
    o(() => {
      f(...h);
    });
  }, u = () => {
    const f = t;
    t = [], f.length && S1(() => {
      n(() => {
        f.forEach((h) => {
          r(h);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: s,
    schedule: o,
    setNotifyFunction: (f) => {
      r = f;
    },
    setBatchNotifyFunction: (f) => {
      n = f;
    }
  };
}
const xr = iP();
class cO {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Ey(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (Xf ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class oP extends cO {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || U_, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || sP(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, r) {
    const n = Oy(this.state.data, e, this.options);
    return this.dispatch({
      data: n,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), n;
  }
  setState(e, r) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: r
    });
  }
  cancel(e) {
    var r;
    const n = this.promise;
    return (r = this.retryer) == null || r.cancel(e), n ? n.then(Bi).catch(Bi) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !nO(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnReconnect());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.indexOf(e) !== -1 && (this.observers = this.observers.filter((r) => r !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, r) {
    var n, i;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && r != null && r.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var o;
        return (o = this.retryer) == null || o.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const d = this.observers.find((_) => _.options.queryFn);
      d && this.setOptions(d.options);
    }
    Array.isArray(this.options.queryKey) || process.env.NODE_ENV !== "production" && this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
    const s = tP(), u = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, c = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => {
          if (s)
            return this.abortSignalConsumed = !0, s.signal;
        }
      });
    };
    c(u);
    const a = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(u)) : Promise.reject("Missing queryFn"), f = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: a
    };
    if (c(f), (n = this.options.behavior) == null || n.onFetch(f), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((i = f.fetchOptions) == null ? void 0 : i.meta)) {
      var h;
      this.dispatch({
        type: "fetch",
        meta: (h = f.fetchOptions) == null ? void 0 : h.meta
      });
    }
    const p = (d) => {
      if (rp(d) && d.silent || this.dispatch({
        type: "error",
        error: d
      }), !rp(d)) {
        var _, m, b, O;
        (_ = (m = this.cache.config).onError) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, this.state.data, d, this), process.env.NODE_ENV !== "production" && this.logger.error(d);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = uO({
      fn: f.fetchFn,
      abort: s == null ? void 0 : s.abort.bind(s),
      onSuccess: (d) => {
        var _, m, b, O;
        if (typeof d > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), p(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(d), (_ = (m = this.cache.config).onSuccess) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, d, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: p,
      onFail: (d, _) => {
        this.dispatch({
          type: "failed",
          failureCount: d,
          error: _
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: f.options.retry,
      retryDelay: f.options.retryDelay,
      networkMode: f.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const r = (n) => {
      var i, o;
      switch (e.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (i = e.meta) != null ? i : null,
            fetchStatus: Yp(this.options.networkMode) ? "fetching" : "paused",
            ...!n.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...n,
            data: e.data,
            dataUpdateCount: n.dataUpdateCount + 1,
            dataUpdatedAt: (o = e.dataUpdatedAt) != null ? o : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const s = e.error;
          return rp(s) && s.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...n,
            error: s,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: s,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), xr.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
}
function sP(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = typeof e < "u", n = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class aP extends ql {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, r, n) {
    var i;
    const o = r.queryKey, s = (i = r.queryHash) != null ? i : L_(o, r);
    let u = this.get(s);
    return u || (u = new oP({
      cache: this,
      logger: e.getLogger(),
      queryKey: o,
      queryHash: s,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(o)
    }), this.add(u)), u;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = this.queriesMap[e.queryHash];
    r && (e.destroy(), this.queries = this.queries.filter((n) => n !== e), r === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    xr.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  find(e, r) {
    const [n] = la(e, r);
    return typeof n.exact > "u" && (n.exact = !0), this.queries.find((i) => m1(n, i));
  }
  findAll(e, r) {
    const [n] = la(e, r);
    return Object.keys(n).length > 0 ? this.queries.filter((i) => m1(n, i)) : this.queries;
  }
  notify(e) {
    xr.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  onFocus() {
    xr.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    xr.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
class uP extends cO {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || U_, this.observers = [], this.state = e.state || cP(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((r) => r !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, r;
    return (e = (r = this.retryer) == null ? void 0 : r.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var R;
      return this.retryer = uO({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (D, I) => {
          this.dispatch({
            type: "failed",
            failureCount: D,
            error: I
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (R = this.options.retry) != null ? R : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, r = this.state.status === "loading";
    try {
      var n, i, o, s, u, c, a, f;
      if (!r) {
        var h, p, d, _;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((h = (p = this.mutationCache.config).onMutate) == null ? void 0 : h.call(p, this.state.variables, this));
        const D = await ((d = (_ = this.options).onMutate) == null ? void 0 : d.call(_, this.state.variables));
        D !== this.state.context && this.dispatch({
          type: "loading",
          context: D,
          variables: this.state.variables
        });
      }
      const R = await e();
      return await ((n = (i = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(i, R, this.state.variables, this.state.context, this)), await ((o = (s = this.options).onSuccess) == null ? void 0 : o.call(s, R, this.state.variables, this.state.context)), await ((u = (c = this.mutationCache.config).onSettled) == null ? void 0 : u.call(c, R, null, this.state.variables, this.state.context, this)), await ((a = (f = this.options).onSettled) == null ? void 0 : a.call(f, R, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: R
      }), R;
    } catch (R) {
      try {
        var m, b, O, S, k, T, x, P;
        throw await ((m = (b = this.mutationCache.config).onError) == null ? void 0 : m.call(b, R, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(R), await ((O = (S = this.options).onError) == null ? void 0 : O.call(S, R, this.state.variables, this.state.context)), await ((k = (T = this.mutationCache.config).onSettled) == null ? void 0 : k.call(T, void 0, R, this.state.variables, this.state.context, this)), await ((x = (P = this.options).onSettled) == null ? void 0 : x.call(P, void 0, R, this.state.variables, this.state.context)), R;
      } finally {
        this.dispatch({
          type: "error",
          error: R
        });
      }
    }
  }
  dispatch(e) {
    const r = (n) => {
      switch (e.type) {
        case "failed":
          return {
            ...n,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "loading":
          return {
            ...n,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !Yp(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...n,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: e.error,
            failureCount: n.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), xr.batch(() => {
      this.observers.forEach((n) => {
        n.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function cP() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class fP extends ql {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, r, n) {
    const i = new uP({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(r),
      state: n,
      defaultOptions: r.mutationKey ? e.getMutationDefaults(r.mutationKey) : void 0
    });
    return this.add(i), i;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((r) => r !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    xr.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((r) => g1(e, r));
  }
  findAll(e) {
    return this.mutations.filter((r) => g1(e, r));
  }
  notify(e) {
    xr.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const r = this.mutations.filter((n) => n.state.isPaused);
      return xr.batch(() => r.reduce((n, i) => n.then(() => i.continue().catch(Bi)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function lP() {
  return {
    onFetch: (t) => {
      t.fetchFn = () => {
        var e, r, n, i, o, s;
        const u = (e = t.fetchOptions) == null || (r = e.meta) == null ? void 0 : r.refetchPage, c = (n = t.fetchOptions) == null || (i = n.meta) == null ? void 0 : i.fetchMore, a = c == null ? void 0 : c.pageParam, f = (c == null ? void 0 : c.direction) === "forward", h = (c == null ? void 0 : c.direction) === "backward", p = ((o = t.state.data) == null ? void 0 : o.pages) || [], d = ((s = t.state.data) == null ? void 0 : s.pageParams) || [];
        let _ = d, m = !1;
        const b = (P) => {
          Object.defineProperty(P, "signal", {
            enumerable: !0,
            get: () => {
              var R;
              if ((R = t.signal) != null && R.aborted)
                m = !0;
              else {
                var D;
                (D = t.signal) == null || D.addEventListener("abort", () => {
                  m = !0;
                });
              }
              return t.signal;
            }
          });
        }, O = t.options.queryFn || (() => Promise.reject("Missing queryFn")), S = (P, R, D, I) => (_ = I ? [R, ..._] : [..._, R], I ? [D, ...P] : [...P, D]), k = (P, R, D, I) => {
          if (m)
            return Promise.reject("Cancelled");
          if (typeof D > "u" && !R && P.length)
            return Promise.resolve(P);
          const j = {
            queryKey: t.queryKey,
            pageParam: D,
            meta: t.options.meta
          };
          b(j);
          const Y = O(j);
          return Promise.resolve(Y).then((B) => S(P, D, B, I));
        };
        let T;
        if (!p.length)
          T = k([]);
        else if (f) {
          const P = typeof a < "u", R = P ? a : O1(t.options, p);
          T = k(p, P, R);
        } else if (h) {
          const P = typeof a < "u", R = P ? a : hP(t.options, p);
          T = k(p, P, R, !0);
        } else {
          _ = [];
          const P = typeof t.options.getNextPageParam > "u";
          T = (u && p[0] ? u(p[0], 0, p) : !0) ? k([], P, d[0]) : Promise.resolve(S([], d[0], p[0]));
          for (let D = 1; D < p.length; D++)
            T = T.then((I) => {
              if (u && p[D] ? u(p[D], D, p) : !0) {
                const Y = P ? d[D] : O1(t.options, I);
                return k(I, P, Y);
              }
              return Promise.resolve(S(I, d[D], p[D]));
            });
        }
        return T.then((P) => ({
          pages: P,
          pageParams: _
        }));
      };
    }
  };
}
function O1(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}
function hP(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}
class pP {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new aP(), this.mutationCache = e.mutationCache || new fP(), this.logger = e.logger || U_, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && e.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = gp.subscribe(() => {
      gp.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = bp.subscribe(() => {
      bp.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, r;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (r = this.unsubscribeOnline) == null || r.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(e, r) {
    const [n] = la(e, r);
    return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  getQueryData(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e, r, n) {
    const i = Rf(e, r, n), o = this.getQueryData(i.queryKey);
    return o ? Promise.resolve(o) : this.fetchQuery(i);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: r,
      state: n
    }) => {
      const i = n.data;
      return [r, i];
    });
  }
  setQueryData(e, r, n) {
    const i = this.queryCache.find(e), o = i == null ? void 0 : i.state.data, s = XT(r, o);
    if (typeof s > "u")
      return;
    const u = Rf(e), c = this.defaultQueryOptions(u);
    return this.queryCache.build(this, c).setData(s, {
      ...n,
      manual: !0
    });
  }
  setQueriesData(e, r, n) {
    return xr.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: i
    }) => [i, this.setQueryData(i, r, n)]));
  }
  getQueryState(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state;
  }
  removeQueries(e, r) {
    const [n] = la(e, r), i = this.queryCache;
    xr.batch(() => {
      i.findAll(n).forEach((o) => {
        i.remove(o);
      });
    });
  }
  resetQueries(e, r, n) {
    const [i, o] = la(e, r, n), s = this.queryCache, u = {
      type: "active",
      ...i
    };
    return xr.batch(() => (s.findAll(i).forEach((c) => {
      c.reset();
    }), this.refetchQueries(u, o)));
  }
  cancelQueries(e, r, n) {
    const [i, o = {}] = la(e, r, n);
    typeof o.revert > "u" && (o.revert = !0);
    const s = xr.batch(() => this.queryCache.findAll(i).map((u) => u.cancel(o)));
    return Promise.all(s).then(Bi).catch(Bi);
  }
  invalidateQueries(e, r, n) {
    const [i, o] = la(e, r, n);
    return xr.batch(() => {
      var s, u;
      if (this.queryCache.findAll(i).forEach((a) => {
        a.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const c = {
        ...i,
        type: (s = (u = i.refetchType) != null ? u : i.type) != null ? s : "active"
      };
      return this.refetchQueries(c, o);
    });
  }
  refetchQueries(e, r, n) {
    const [i, o] = la(e, r, n), s = xr.batch(() => this.queryCache.findAll(i).filter((c) => !c.isDisabled()).map((c) => {
      var a;
      return c.fetch(void 0, {
        ...o,
        cancelRefetch: (a = o == null ? void 0 : o.cancelRefetch) != null ? a : !0,
        meta: {
          refetchPage: i.refetchPage
        }
      });
    }));
    let u = Promise.all(s).then(Bi);
    return o != null && o.throwOnError || (u = u.catch(Bi)), u;
  }
  fetchQuery(e, r, n) {
    const i = Rf(e, r, n), o = this.defaultQueryOptions(i);
    typeof o.retry > "u" && (o.retry = !1);
    const s = this.queryCache.build(this, o);
    return s.isStaleByTime(o.staleTime) ? s.fetch(o) : Promise.resolve(s.state.data);
  }
  prefetchQuery(e, r, n) {
    return this.fetchQuery(e, r, n).then(Bi).catch(Bi);
  }
  fetchInfiniteQuery(e, r, n) {
    const i = Rf(e, r, n);
    return i.behavior = lP(), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(e, r, n) {
    return this.fetchInfiniteQuery(e, r, n).then(Bi).catch(Bi);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, r) {
    const n = this.queryDefaults.find((i) => Xa(e) === Xa(i.queryKey));
    n ? n.defaultOptions = r : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: r
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const r = this.queryDefaults.find((n) => Mu(e, n.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((i) => Mu(e, i.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(e) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), r == null ? void 0 : r.defaultOptions;
  }
  setMutationDefaults(e, r) {
    const n = this.mutationDefaults.find((i) => Xa(e) === Xa(i.mutationKey));
    n ? n.defaultOptions = r : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: r
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const r = this.mutationDefaults.find((n) => Mu(e, n.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((i) => Mu(e, i.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(e) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), r == null ? void 0 : r.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const r = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e == null ? void 0 : e.queryKey),
      ...e,
      _defaulted: !0
    };
    return !r.queryHash && r.queryKey && (r.queryHash = L_(r.queryKey, r)), typeof r.refetchOnReconnect > "u" && (r.refetchOnReconnect = r.networkMode !== "always"), typeof r.useErrorBoundary > "u" && (r.useErrorBoundary = !!r.suspense), r;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e == null ? void 0 : e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class dP extends ql {
  constructor(e, r) {
    super(), this.client = e, this.options = r, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), I1(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Iy(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return Iy(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(e, r) {
    const n = this.options, i = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(e), process.env.NODE_ENV !== "production" && typeof (e == null ? void 0 : e.isDataEqual) < "u" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), b1(n, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = n.queryKey), this.updateQuery();
    const o = this.hasListeners();
    o && A1(this.currentQuery, i, this.options, n) && this.executeFetch(), this.updateResult(r), o && (this.currentQuery !== i || this.options.enabled !== n.enabled || this.options.staleTime !== n.staleTime) && this.updateStaleTimeout();
    const s = this.computeRefetchInterval();
    o && (this.currentQuery !== i || this.options.enabled !== n.enabled || s !== this.currentRefetchInterval) && this.updateRefetchInterval(s);
  }
  getOptimisticResult(e) {
    const r = this.client.getQueryCache().build(this.client, e);
    return this.createResult(r, e);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(e) {
    const r = {};
    return Object.keys(e).forEach((n) => {
      Object.defineProperty(r, n, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(n), e[n])
      });
    }), r;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: e,
    ...r
  } = {}) {
    return this.fetch({
      ...r,
      meta: {
        refetchPage: e
      }
    });
  }
  fetchOptimistic(e) {
    const r = this.client.defaultQueryOptions(e), n = this.client.getQueryCache().build(this.client, r);
    return n.isFetchingOptimistic = !0, n.fetch().then(() => this.createResult(n, r));
  }
  fetch(e) {
    var r;
    return this.executeFetch({
      ...e,
      cancelRefetch: (r = e.cancelRefetch) != null ? r : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(e) {
    this.updateQuery();
    let r = this.currentQuery.fetch(this.options, e);
    return e != null && e.throwOnError || (r = r.catch(Bi)), r;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), Xf || this.currentResult.isStale || !Ey(this.options.staleTime))
      return;
    const r = nO(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, r);
  }
  computeRefetchInterval() {
    var e;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (e = this.options.refetchInterval) != null ? e : !1;
  }
  updateRefetchInterval(e) {
    this.clearRefetchInterval(), this.currentRefetchInterval = e, !(Xf || this.options.enabled === !1 || !Ey(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || gp.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(e, r) {
    const n = this.currentQuery, i = this.options, o = this.currentResult, s = this.currentResultState, u = this.currentResultOptions, c = e !== n, a = c ? e.state : this.currentQueryInitialState, f = c ? this.currentResult : this.previousQueryResult, {
      state: h
    } = e;
    let {
      dataUpdatedAt: p,
      error: d,
      errorUpdatedAt: _,
      fetchStatus: m,
      status: b
    } = h, O = !1, S = !1, k;
    if (r._optimisticResults) {
      const D = this.hasListeners(), I = !D && I1(e, r), j = D && A1(e, n, r, i);
      (I || j) && (m = Yp(e.options.networkMode) ? "fetching" : "paused", p || (b = "loading")), r._optimisticResults === "isRestoring" && (m = "idle");
    }
    if (r.keepPreviousData && !h.dataUpdatedAt && f != null && f.isSuccess && b !== "error")
      k = f.data, p = f.dataUpdatedAt, b = f.status, O = !0;
    else if (r.select && typeof h.data < "u")
      if (o && h.data === (s == null ? void 0 : s.data) && r.select === this.selectFn)
        k = this.selectResult;
      else
        try {
          this.selectFn = r.select, k = r.select(h.data), k = Oy(o == null ? void 0 : o.data, k, r), this.selectResult = k, this.selectError = null;
        } catch (D) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(D), this.selectError = D;
        }
    else
      k = h.data;
    if (typeof r.placeholderData < "u" && typeof k > "u" && b === "loading") {
      let D;
      if (o != null && o.isPlaceholderData && r.placeholderData === (u == null ? void 0 : u.placeholderData))
        D = o.data;
      else if (D = typeof r.placeholderData == "function" ? r.placeholderData() : r.placeholderData, r.select && typeof D < "u")
        try {
          D = r.select(D), this.selectError = null;
        } catch (I) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(I), this.selectError = I;
        }
      typeof D < "u" && (b = "success", k = Oy(o == null ? void 0 : o.data, D, r), S = !0);
    }
    this.selectError && (d = this.selectError, k = this.selectResult, _ = Date.now(), b = "error");
    const T = m === "fetching", x = b === "loading", P = b === "error";
    return {
      status: b,
      fetchStatus: m,
      isLoading: x,
      isSuccess: b === "success",
      isError: P,
      isInitialLoading: x && T,
      data: k,
      dataUpdatedAt: p,
      error: d,
      errorUpdatedAt: _,
      failureCount: h.fetchFailureCount,
      failureReason: h.fetchFailureReason,
      errorUpdateCount: h.errorUpdateCount,
      isFetched: h.dataUpdateCount > 0 || h.errorUpdateCount > 0,
      isFetchedAfterMount: h.dataUpdateCount > a.dataUpdateCount || h.errorUpdateCount > a.errorUpdateCount,
      isFetching: T,
      isRefetching: T && !x,
      isLoadingError: P && h.dataUpdatedAt === 0,
      isPaused: m === "paused",
      isPlaceholderData: S,
      isPreviousData: O,
      isRefetchError: P && h.dataUpdatedAt !== 0,
      isStale: B_(e, r),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(e) {
    const r = this.currentResult, n = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, b1(n, r))
      return;
    this.currentResult = n;
    const i = {
      cache: !0
    }, o = () => {
      if (!r)
        return !0;
      const {
        notifyOnChangeProps: s
      } = this.options;
      if (s === "all" || !s && !this.trackedProps.size)
        return !0;
      const u = new Set(s ?? this.trackedProps);
      return this.options.useErrorBoundary && u.add("error"), Object.keys(this.currentResult).some((c) => {
        const a = c;
        return this.currentResult[a] !== r[a] && u.has(a);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && o() && (i.listeners = !0), this.notify({
      ...i,
      ...e
    });
  }
  updateQuery() {
    const e = this.client.getQueryCache().build(this.client, this.options);
    if (e === this.currentQuery)
      return;
    const r = this.currentQuery;
    this.currentQuery = e, this.currentQueryInitialState = e.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (r == null || r.removeObserver(this), e.addObserver(this));
  }
  onQueryUpdate(e) {
    const r = {};
    e.type === "success" ? r.onSuccess = !e.manual : e.type === "error" && !rp(e.error) && (r.onError = !0), this.updateResult(r), this.hasListeners() && this.updateTimers();
  }
  notify(e) {
    xr.batch(() => {
      if (e.onSuccess) {
        var r, n, i, o;
        (r = (n = this.options).onSuccess) == null || r.call(n, this.currentResult.data), (i = (o = this.options).onSettled) == null || i.call(o, this.currentResult.data, null);
      } else if (e.onError) {
        var s, u, c, a;
        (s = (u = this.options).onError) == null || s.call(u, this.currentResult.error), (c = (a = this.options).onSettled) == null || c.call(a, void 0, this.currentResult.error);
      }
      e.listeners && this.listeners.forEach(({
        listener: f
      }) => {
        f(this.currentResult);
      }), e.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function vP(t, e) {
  return e.enabled !== !1 && !t.state.dataUpdatedAt && !(t.state.status === "error" && e.retryOnMount === !1);
}
function I1(t, e) {
  return vP(t, e) || t.state.dataUpdatedAt > 0 && Iy(t, e, e.refetchOnMount);
}
function Iy(t, e, r) {
  if (e.enabled !== !1) {
    const n = typeof r == "function" ? r(t) : r;
    return n === "always" || n !== !1 && B_(t, e);
  }
  return !1;
}
function A1(t, e, r, n) {
  return r.enabled !== !1 && (t !== e || n.enabled === !1) && (!r.suspense || t.state.status !== "error") && B_(t, r);
}
function B_(t, e) {
  return t.isStaleByTime(e.staleTime);
}
var Ay = { exports: {} }, sv = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var D1;
function yP() {
  if (D1)
    return sv;
  D1 = 1;
  var t = Se;
  function e(h, p) {
    return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, i = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
  function u(h, p) {
    var d = p(), _ = n({ inst: { value: d, getSnapshot: p } }), m = _[0].inst, b = _[1];
    return o(function() {
      m.value = d, m.getSnapshot = p, c(m) && b({ inst: m });
    }, [h, d, p]), i(function() {
      return c(m) && b({ inst: m }), h(function() {
        c(m) && b({ inst: m });
      });
    }, [h]), s(d), d;
  }
  function c(h) {
    var p = h.getSnapshot;
    h = h.value;
    try {
      var d = p();
      return !r(h, d);
    } catch {
      return !0;
    }
  }
  function a(h, p) {
    return p();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : u;
  return sv.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : f, sv;
}
var av = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var R1;
function _P() {
  return R1 || (R1 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Se, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(k) {
      {
        for (var T = arguments.length, x = new Array(T > 1 ? T - 1 : 0), P = 1; P < T; P++)
          x[P - 1] = arguments[P];
        n("error", k, x);
      }
    }
    function n(k, T, x) {
      {
        var P = e.ReactDebugCurrentFrame, R = P.getStackAddendum();
        R !== "" && (T += "%s", x = x.concat([R]));
        var D = x.map(function(I) {
          return String(I);
        });
        D.unshift("Warning: " + T), Function.prototype.apply.call(console[k], console, D);
      }
    }
    function i(k, T) {
      return k === T && (k !== 0 || 1 / k === 1 / T) || k !== k && T !== T;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = t.useState, u = t.useEffect, c = t.useLayoutEffect, a = t.useDebugValue, f = !1, h = !1;
    function p(k, T, x) {
      f || t.startTransition !== void 0 && (f = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var P = T();
      if (!h) {
        var R = T();
        o(P, R) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), h = !0);
      }
      var D = s({
        inst: {
          value: P,
          getSnapshot: T
        }
      }), I = D[0].inst, j = D[1];
      return c(function() {
        I.value = P, I.getSnapshot = T, d(I) && j({
          inst: I
        });
      }, [k, P, T]), u(function() {
        d(I) && j({
          inst: I
        });
        var Y = function() {
          d(I) && j({
            inst: I
          });
        };
        return k(Y);
      }, [k]), a(P), P;
    }
    function d(k) {
      var T = k.getSnapshot, x = k.value;
      try {
        var P = T();
        return !o(x, P);
      } catch {
        return !0;
      }
    }
    function _(k, T, x) {
      return T();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", b = !m, O = b ? _ : p, S = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : O;
    av.useSyncExternalStore = S, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), av;
}
process.env.NODE_ENV === "production" ? Ay.exports = yP() : Ay.exports = _P();
var mP = Ay.exports;
const gP = mP.useSyncExternalStore, x1 = /* @__PURE__ */ Yr.createContext(void 0), fO = /* @__PURE__ */ Yr.createContext(!1);
function lO(t, e) {
  return t || (e && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = x1), window.ReactQueryClientContext) : x1);
}
const bP = ({
  context: t
} = {}) => {
  const e = Yr.useContext(lO(t, Yr.useContext(fO)));
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, wP = ({
  client: t,
  children: e,
  context: r,
  contextSharing: n = !1
}) => {
  Yr.useEffect(() => (t.mount(), () => {
    t.unmount();
  }), [t]), process.env.NODE_ENV !== "production" && n && t.getLogger().error("The contextSharing option has been deprecated and will be removed in the next major version");
  const i = lO(r, n);
  return /* @__PURE__ */ Yr.createElement(fO.Provider, {
    value: !r && n
  }, /* @__PURE__ */ Yr.createElement(i.Provider, {
    value: t
  }, e));
}, hO = /* @__PURE__ */ Yr.createContext(!1), EP = () => Yr.useContext(hO);
hO.Provider;
function SP() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
const OP = /* @__PURE__ */ Yr.createContext(SP()), IP = () => Yr.useContext(OP);
function AP(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
const DP = (t, e) => {
  (t.suspense || t.useErrorBoundary) && (e.isReset() || (t.retryOnMount = !1));
}, RP = (t) => {
  Yr.useEffect(() => {
    t.clearReset();
  }, [t]);
}, xP = ({
  result: t,
  errorResetBoundary: e,
  useErrorBoundary: r,
  query: n
}) => t.isError && !e.isReset() && !t.isFetching && AP(r, [t.error, n]), TP = (t) => {
  t.suspense && typeof t.staleTime != "number" && (t.staleTime = 1e3);
}, PP = (t, e) => t.isLoading && t.isFetching && !e, kP = (t, e, r) => (t == null ? void 0 : t.suspense) && PP(e, r), CP = (t, e, r) => e.fetchOptimistic(t).then(({
  data: n
}) => {
  t.onSuccess == null || t.onSuccess(n), t.onSettled == null || t.onSettled(n, null);
}).catch((n) => {
  r.clearReset(), t.onError == null || t.onError(n), t.onSettled == null || t.onSettled(void 0, n);
});
function jP(t, e) {
  const r = bP({
    context: t.context
  }), n = EP(), i = IP(), o = r.defaultQueryOptions(t);
  o._optimisticResults = n ? "isRestoring" : "optimistic", o.onError && (o.onError = xr.batchCalls(o.onError)), o.onSuccess && (o.onSuccess = xr.batchCalls(o.onSuccess)), o.onSettled && (o.onSettled = xr.batchCalls(o.onSettled)), TP(o), DP(o, i), RP(i);
  const [s] = Yr.useState(() => new e(r, o)), u = s.getOptimisticResult(o);
  if (gP(Yr.useCallback((c) => n ? () => {
  } : s.subscribe(xr.batchCalls(c)), [s, n]), () => s.getCurrentResult(), () => s.getCurrentResult()), Yr.useEffect(() => {
    s.setOptions(o, {
      listeners: !1
    });
  }, [o, s]), kP(o, u, n))
    throw CP(o, s, i);
  if (xP({
    result: u,
    errorResetBoundary: i,
    useErrorBoundary: o.useErrorBoundary,
    query: s.getCurrentQuery()
  }))
    throw u.error;
  return o.notifyOnChangeProps ? u : s.trackResult(u);
}
function pO(t, e, r) {
  const n = Rf(t, e, r);
  return jP(n, dP);
}
const qP = new pP(), $_ = Mr(void 0);
function dO(t, e) {
  const r = (n) => /* @__PURE__ */ Ce.jsx(
    wP,
    {
      client: qP,
      context: $_,
      children: /* @__PURE__ */ Ce.jsx(t, { ...n })
    }
  );
  return r.displayName = e, r;
}
function cu(t) {
  function e(r, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = r, this.code = n;
  }
  return e.prototype = new Error(), e.prototype.name = t, e.prototype.constructor = e, e;
}
const MP = cu("LaunchDarklyUnexpectedResponseError"), FP = cu("LaunchDarklyInvalidEnvironmentIdError"), NP = cu("LaunchDarklyInvalidUserError"), zP = cu("LaunchDarklyInvalidEventKeyError"), LP = cu("LaunchDarklyInvalidArgumentError"), UP = cu("LaunchDarklyFlagFetchError");
for (var Rr = { LDUnexpectedResponseError: MP, LDInvalidEnvironmentIdError: FP, LDInvalidUserError: NP, LDInvalidEventKeyError: zP, LDInvalidArgumentError: LP, LDInvalidDataError: cu("LaunchDarklyInvalidDataError"), LDFlagFetchError: UP, isHttpErrorRecoverable: function(t) {
  return !(t >= 400 && t < 500) || t === 400 || t === 408 || t === 429;
} }, BP = function(t) {
  var e = T1(t), r = e[0], n = e[1];
  return 3 * (r + n) / 4 - n;
}, $P = function(t) {
  var e, r, n = T1(t), i = n[0], o = n[1], s = new VP(function(a, f, h) {
    return 3 * (f + h) / 4 - h;
  }(0, i, o)), u = 0, c = o > 0 ? i - 4 : i;
  for (r = 0; r < c; r += 4)
    e = ki[t.charCodeAt(r)] << 18 | ki[t.charCodeAt(r + 1)] << 12 | ki[t.charCodeAt(r + 2)] << 6 | ki[t.charCodeAt(r + 3)], s[u++] = e >> 16 & 255, s[u++] = e >> 8 & 255, s[u++] = 255 & e;
  return o === 2 && (e = ki[t.charCodeAt(r)] << 2 | ki[t.charCodeAt(r + 1)] >> 4, s[u++] = 255 & e), o === 1 && (e = ki[t.charCodeAt(r)] << 10 | ki[t.charCodeAt(r + 1)] << 4 | ki[t.charCodeAt(r + 2)] >> 2, s[u++] = e >> 8 & 255, s[u++] = 255 & e), s;
}, KP = function(t) {
  for (var e, r = t.length, n = r % 3, i = [], o = 16383, s = 0, u = r - n; s < u; s += o)
    i.push(YP(t, s, s + o > u ? u : s + o));
  return n === 1 ? (e = t[r - 1], i.push(Lo[e >> 2] + Lo[e << 4 & 63] + "==")) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(Lo[e >> 10] + Lo[e >> 4 & 63] + Lo[e << 2 & 63] + "=")), i.join("");
}, Lo = [], ki = [], VP = typeof Uint8Array < "u" ? Uint8Array : Array, uv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", xu = 0, QP = uv.length; xu < QP; ++xu)
  Lo[xu] = uv[xu], ki[uv.charCodeAt(xu)] = xu;
function T1(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  return r === -1 && (r = e), [r, r === e ? 0 : 4 - r % 4];
}
function YP(t, e, r) {
  for (var n, i, o = [], s = e; s < r; s += 3)
    n = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), o.push(Lo[(i = n) >> 18 & 63] + Lo[i >> 12 & 63] + Lo[i >> 6 & 63] + Lo[63 & i]);
  return o.join("");
}
ki["-".charCodeAt(0)] = 62, ki["_".charCodeAt(0)] = 63;
var GP = { byteLength: BP, toByteArray: $P, fromByteArray: KP }, P1 = Array.isArray, k1 = Object.keys, WP = Object.prototype.hasOwnProperty, HP = function t(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    var n, i, o, s = P1(e), u = P1(r);
    if (s && u) {
      if ((i = e.length) != r.length)
        return !1;
      for (n = i; n-- != 0; )
        if (!t(e[n], r[n]))
          return !1;
      return !0;
    }
    if (s != u)
      return !1;
    var c = e instanceof Date, a = r instanceof Date;
    if (c != a)
      return !1;
    if (c && a)
      return e.getTime() == r.getTime();
    var f = e instanceof RegExp, h = r instanceof RegExp;
    if (f != h)
      return !1;
    if (f && h)
      return e.toString() == r.toString();
    var p = k1(e);
    if ((i = p.length) !== k1(r).length)
      return !1;
    for (n = i; n-- != 0; )
      if (!WP.call(r, p[n]))
        return !1;
    for (n = i; n-- != 0; )
      if (!t(e[o = p[n]], r[o]))
        return !1;
    return !0;
  }
  return e != e && r != r;
};
const JP = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function vO(t) {
  const e = unescape(encodeURIComponent(t));
  return GP.fromByteArray(function(r) {
    const n = [];
    for (let i = 0; i < r.length; i++)
      n.push(r.charCodeAt(i));
    return n;
  }(e));
}
function C1(t) {
  return vO(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function cv(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
var fv, zt = { appendUrlPath: function(t, e) {
  return (t.endsWith("/") ? t.substring(0, t.length - 1) : t) + (e.startsWith("/") ? "" : "/") + e;
}, base64URLEncode: C1, btoa: vO, chunkEventsForUrl: function(t, e) {
  const r = e.slice(0), n = [];
  let i, o = t;
  for (; r.length > 0; ) {
    for (i = []; o > 0; ) {
      const s = r.shift();
      if (!s)
        break;
      o -= C1(JSON.stringify(s)).length, o < 0 && i.length > 0 ? r.unshift(s) : i.push(s);
    }
    o = t, n.push(i);
  }
  return n;
}, clone: function(t) {
  return JSON.parse(JSON.stringify(t));
}, deepEquals: function(t, e) {
  return HP(t, e);
}, extend: function(...t) {
  return t.reduce((e, r) => ({ ...e, ...r }), {});
}, getLDUserAgentString: function(t) {
  const e = t.version || "?";
  return t.userAgent + "/" + e;
}, objectHasOwnProperty: cv, onNextTick: function(t) {
  setTimeout(t, 0);
}, sanitizeContext: function(t) {
  if (!t)
    return t;
  let e;
  return t.kind !== null && t.kind !== void 0 || JP.forEach((r) => {
    const n = t[r];
    n !== void 0 && typeof n != "string" && (e = e || { ...t }, e[r] = String(n));
  }), e || t;
}, transformValuesToVersionedValues: function(t) {
  const e = {};
  for (const r in t)
    cv(t, r) && (e[r] = { value: t[r], version: 0 });
  return e;
}, transformVersionedValuesToValues: function(t) {
  const e = {};
  for (const r in t)
    cv(t, r) && (e[r] = t[r].value);
  return e;
}, wrapPromiseCallback: function(t, e) {
  const r = t.then((n) => (e && setTimeout(() => {
    e(null, n);
  }, 0), n), (n) => {
    if (!e)
      return Promise.reject(n);
    setTimeout(() => {
      e(n, null);
    }, 0);
  });
  return e ? void 0 : r;
} }, ZP = new Uint8Array(16);
function j1() {
  if (!fv && !(fv = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto)))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return fv(ZP);
}
var XP = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function wp(t) {
  return typeof t == "string" && XP.test(t);
}
for (var q1, lv, Gr = [], hv = 0; hv < 256; ++hv)
  Gr.push((hv + 256).toString(16).substr(1));
function np(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Gr[t[e + 0]] + Gr[t[e + 1]] + Gr[t[e + 2]] + Gr[t[e + 3]] + "-" + Gr[t[e + 4]] + Gr[t[e + 5]] + "-" + Gr[t[e + 6]] + Gr[t[e + 7]] + "-" + Gr[t[e + 8]] + Gr[t[e + 9]] + "-" + Gr[t[e + 10]] + Gr[t[e + 11]] + Gr[t[e + 12]] + Gr[t[e + 13]] + Gr[t[e + 14]] + Gr[t[e + 15]]).toLowerCase();
  if (!wp(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
var pv = 0, dv = 0;
function yO(t) {
  if (!wp(t))
    throw TypeError("Invalid UUID");
  var e, r = new Uint8Array(16);
  return r[0] = (e = parseInt(t.slice(0, 8), 16)) >>> 24, r[1] = e >>> 16 & 255, r[2] = e >>> 8 & 255, r[3] = 255 & e, r[4] = (e = parseInt(t.slice(9, 13), 16)) >>> 8, r[5] = 255 & e, r[6] = (e = parseInt(t.slice(14, 18), 16)) >>> 8, r[7] = 255 & e, r[8] = (e = parseInt(t.slice(19, 23), 16)) >>> 8, r[9] = 255 & e, r[10] = (e = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = e / 4294967296 & 255, r[12] = e >>> 24 & 255, r[13] = e >>> 16 & 255, r[14] = e >>> 8 & 255, r[15] = 255 & e, r;
}
function _O(t, e, r) {
  function n(i, o, s, u) {
    if (typeof i == "string" && (i = function(f) {
      f = unescape(encodeURIComponent(f));
      for (var h = [], p = 0; p < f.length; ++p)
        h.push(f.charCodeAt(p));
      return h;
    }(i)), typeof o == "string" && (o = yO(o)), o.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + i.length);
    if (c.set(o), c.set(i, o.length), (c = r(c))[6] = 15 & c[6] | e, c[8] = 63 & c[8] | 128, s) {
      u = u || 0;
      for (var a = 0; a < 16; ++a)
        s[u + a] = c[a];
      return s;
    }
    return np(c);
  }
  try {
    n.name = t;
  } catch {
  }
  return n.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", n.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", n;
}
function M1(t) {
  return 14 + (t + 64 >>> 9 << 4) + 1;
}
function wa(t, e) {
  var r = (65535 & t) + (65535 & e);
  return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
}
function Gp(t, e, r, n, i, o) {
  return wa((s = wa(wa(e, t), wa(n, o))) << (u = i) | s >>> 32 - u, r);
  var s, u;
}
function on(t, e, r, n, i, o, s) {
  return Gp(e & r | ~e & n, t, e, i, o, s);
}
function sn(t, e, r, n, i, o, s) {
  return Gp(e & n | r & ~n, t, e, i, o, s);
}
function an(t, e, r, n, i, o, s) {
  return Gp(e ^ r ^ n, t, e, i, o, s);
}
function un(t, e, r, n, i, o, s) {
  return Gp(r ^ (e | ~n), t, e, i, o, s);
}
var tk = _O("v3", 48, function(t) {
  if (typeof t == "string") {
    var e = unescape(encodeURIComponent(t));
    t = new Uint8Array(e.length);
    for (var r = 0; r < e.length; ++r)
      t[r] = e.charCodeAt(r);
  }
  return function(n) {
    for (var i = [], o = 32 * n.length, s = "0123456789abcdef", u = 0; u < o; u += 8) {
      var c = n[u >> 5] >>> u % 32 & 255, a = parseInt(s.charAt(c >>> 4 & 15) + s.charAt(15 & c), 16);
      i.push(a);
    }
    return i;
  }(function(n, i) {
    n[i >> 5] |= 128 << i % 32, n[M1(i) - 1] = i;
    for (var o = 1732584193, s = -271733879, u = -1732584194, c = 271733878, a = 0; a < n.length; a += 16) {
      var f = o, h = s, p = u, d = c;
      o = on(o, s, u, c, n[a], 7, -680876936), c = on(c, o, s, u, n[a + 1], 12, -389564586), u = on(u, c, o, s, n[a + 2], 17, 606105819), s = on(s, u, c, o, n[a + 3], 22, -1044525330), o = on(o, s, u, c, n[a + 4], 7, -176418897), c = on(c, o, s, u, n[a + 5], 12, 1200080426), u = on(u, c, o, s, n[a + 6], 17, -1473231341), s = on(s, u, c, o, n[a + 7], 22, -45705983), o = on(o, s, u, c, n[a + 8], 7, 1770035416), c = on(c, o, s, u, n[a + 9], 12, -1958414417), u = on(u, c, o, s, n[a + 10], 17, -42063), s = on(s, u, c, o, n[a + 11], 22, -1990404162), o = on(o, s, u, c, n[a + 12], 7, 1804603682), c = on(c, o, s, u, n[a + 13], 12, -40341101), u = on(u, c, o, s, n[a + 14], 17, -1502002290), o = sn(o, s = on(s, u, c, o, n[a + 15], 22, 1236535329), u, c, n[a + 1], 5, -165796510), c = sn(c, o, s, u, n[a + 6], 9, -1069501632), u = sn(u, c, o, s, n[a + 11], 14, 643717713), s = sn(s, u, c, o, n[a], 20, -373897302), o = sn(o, s, u, c, n[a + 5], 5, -701558691), c = sn(c, o, s, u, n[a + 10], 9, 38016083), u = sn(u, c, o, s, n[a + 15], 14, -660478335), s = sn(s, u, c, o, n[a + 4], 20, -405537848), o = sn(o, s, u, c, n[a + 9], 5, 568446438), c = sn(c, o, s, u, n[a + 14], 9, -1019803690), u = sn(u, c, o, s, n[a + 3], 14, -187363961), s = sn(s, u, c, o, n[a + 8], 20, 1163531501), o = sn(o, s, u, c, n[a + 13], 5, -1444681467), c = sn(c, o, s, u, n[a + 2], 9, -51403784), u = sn(u, c, o, s, n[a + 7], 14, 1735328473), o = an(o, s = sn(s, u, c, o, n[a + 12], 20, -1926607734), u, c, n[a + 5], 4, -378558), c = an(c, o, s, u, n[a + 8], 11, -2022574463), u = an(u, c, o, s, n[a + 11], 16, 1839030562), s = an(s, u, c, o, n[a + 14], 23, -35309556), o = an(o, s, u, c, n[a + 1], 4, -1530992060), c = an(c, o, s, u, n[a + 4], 11, 1272893353), u = an(u, c, o, s, n[a + 7], 16, -155497632), s = an(s, u, c, o, n[a + 10], 23, -1094730640), o = an(o, s, u, c, n[a + 13], 4, 681279174), c = an(c, o, s, u, n[a], 11, -358537222), u = an(u, c, o, s, n[a + 3], 16, -722521979), s = an(s, u, c, o, n[a + 6], 23, 76029189), o = an(o, s, u, c, n[a + 9], 4, -640364487), c = an(c, o, s, u, n[a + 12], 11, -421815835), u = an(u, c, o, s, n[a + 15], 16, 530742520), o = un(o, s = an(s, u, c, o, n[a + 2], 23, -995338651), u, c, n[a], 6, -198630844), c = un(c, o, s, u, n[a + 7], 10, 1126891415), u = un(u, c, o, s, n[a + 14], 15, -1416354905), s = un(s, u, c, o, n[a + 5], 21, -57434055), o = un(o, s, u, c, n[a + 12], 6, 1700485571), c = un(c, o, s, u, n[a + 3], 10, -1894986606), u = un(u, c, o, s, n[a + 10], 15, -1051523), s = un(s, u, c, o, n[a + 1], 21, -2054922799), o = un(o, s, u, c, n[a + 8], 6, 1873313359), c = un(c, o, s, u, n[a + 15], 10, -30611744), u = un(u, c, o, s, n[a + 6], 15, -1560198380), s = un(s, u, c, o, n[a + 13], 21, 1309151649), o = un(o, s, u, c, n[a + 4], 6, -145523070), c = un(c, o, s, u, n[a + 11], 10, -1120210379), u = un(u, c, o, s, n[a + 2], 15, 718787259), s = un(s, u, c, o, n[a + 9], 21, -343485551), o = wa(o, f), s = wa(s, h), u = wa(u, p), c = wa(c, d);
    }
    return [o, s, u, c];
  }(function(n) {
    if (n.length === 0)
      return [];
    for (var i = 8 * n.length, o = new Uint32Array(M1(i)), s = 0; s < i; s += 8)
      o[s >> 5] |= (255 & n[s / 8]) << s % 32;
    return o;
  }(t), 8 * t.length));
}), ek = tk;
function rk(t, e, r, n) {
  switch (t) {
    case 0:
      return e & r ^ ~e & n;
    case 1:
    case 3:
      return e ^ r ^ n;
    case 2:
      return e & r ^ e & n ^ r & n;
  }
}
function vv(t, e) {
  return t << e | t >>> 32 - e;
}
var nk = _O("v5", 80, function(t) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var n = unescape(encodeURIComponent(t));
    t = [];
    for (var i = 0; i < n.length; ++i)
      t.push(n.charCodeAt(i));
  } else
    Array.isArray(t) || (t = Array.prototype.slice.call(t));
  t.push(128);
  for (var o = t.length / 4 + 2, s = Math.ceil(o / 16), u = new Array(s), c = 0; c < s; ++c) {
    for (var a = new Uint32Array(16), f = 0; f < 16; ++f)
      a[f] = t[64 * c + 4 * f] << 24 | t[64 * c + 4 * f + 1] << 16 | t[64 * c + 4 * f + 2] << 8 | t[64 * c + 4 * f + 3];
    u[c] = a;
  }
  u[s - 1][14] = 8 * (t.length - 1) / Math.pow(2, 32), u[s - 1][14] = Math.floor(u[s - 1][14]), u[s - 1][15] = 8 * (t.length - 1) & 4294967295;
  for (var h = 0; h < s; ++h) {
    for (var p = new Uint32Array(80), d = 0; d < 16; ++d)
      p[d] = u[h][d];
    for (var _ = 16; _ < 80; ++_)
      p[_] = vv(p[_ - 3] ^ p[_ - 8] ^ p[_ - 14] ^ p[_ - 16], 1);
    for (var m = r[0], b = r[1], O = r[2], S = r[3], k = r[4], T = 0; T < 80; ++T) {
      var x = Math.floor(T / 20), P = vv(m, 5) + rk(x, b, O, S) + k + e[x] + p[T] >>> 0;
      k = S, S = O, O = vv(b, 30) >>> 0, b = m, m = P;
    }
    r[0] = r[0] + m >>> 0, r[1] = r[1] + b >>> 0, r[2] = r[2] + O >>> 0, r[3] = r[3] + S >>> 0, r[4] = r[4] + k >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, 255 & r[0], r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, 255 & r[1], r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, 255 & r[2], r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, 255 & r[3], r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, 255 & r[4]];
}), ik = nk, K_ = Object.freeze({ __proto__: null, v1: function(t, e, r) {
  var n = e && r || 0, i = e || new Array(16), o = (t = t || {}).node || q1, s = t.clockseq !== void 0 ? t.clockseq : lv;
  if (o == null || s == null) {
    var u = t.random || (t.rng || j1)();
    o == null && (o = q1 = [1 | u[0], u[1], u[2], u[3], u[4], u[5]]), s == null && (s = lv = 16383 & (u[6] << 8 | u[7]));
  }
  var c = t.msecs !== void 0 ? t.msecs : Date.now(), a = t.nsecs !== void 0 ? t.nsecs : dv + 1, f = c - pv + (a - dv) / 1e4;
  if (f < 0 && t.clockseq === void 0 && (s = s + 1 & 16383), (f < 0 || c > pv) && t.nsecs === void 0 && (a = 0), a >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  pv = c, dv = a, lv = s;
  var h = (1e4 * (268435455 & (c += 122192928e5)) + a) % 4294967296;
  i[n++] = h >>> 24 & 255, i[n++] = h >>> 16 & 255, i[n++] = h >>> 8 & 255, i[n++] = 255 & h;
  var p = c / 4294967296 * 1e4 & 268435455;
  i[n++] = p >>> 8 & 255, i[n++] = 255 & p, i[n++] = p >>> 24 & 15 | 16, i[n++] = p >>> 16 & 255, i[n++] = s >>> 8 | 128, i[n++] = 255 & s;
  for (var d = 0; d < 6; ++d)
    i[n + d] = o[d];
  return e || np(i);
}, v3: ek, v4: function(t, e, r) {
  var n = (t = t || {}).random || (t.rng || j1)();
  if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, e) {
    r = r || 0;
    for (var i = 0; i < 16; ++i)
      e[r + i] = n[i];
    return e;
  }
  return np(n);
}, v5: ik, NIL: "00000000-0000-0000-0000-000000000000", version: function(t) {
  if (!wp(t))
    throw TypeError("Invalid UUID");
  return parseInt(t.substr(14, 1), 16);
}, validate: wp, stringify: np, parse: yO });
const vf = ["debug", "info", "warn", "error", "none"];
var V_ = { commonBasicLogger: function(t, e) {
  if (t && t.destination && typeof t.destination != "function")
    throw new Error("destination for basicLogger was set to a non-function");
  function r(a) {
    return function(f) {
      console && console[a] && console[a].call(console, f);
    };
  }
  const n = t && t.destination ? [t.destination, t.destination, t.destination, t.destination] : [r("log"), r("info"), r("warn"), r("error")], i = !(!t || !t.destination), o = t && t.prefix !== void 0 && t.prefix !== null ? t.prefix : "[LaunchDarkly] ";
  let s = 1;
  if (t && t.level)
    for (let a = 0; a < vf.length; a++)
      vf[a] === t.level && (s = a);
  function u(a, f, h) {
    if (h.length < 1)
      return;
    let p;
    const d = i ? f + ": " + o : o;
    if (h.length !== 1 && e) {
      const _ = [...h];
      _[0] = d + _[0], p = e(..._);
    } else
      p = d + h[0];
    try {
      n[a](p);
    } catch (_) {
      console && console.log && console.log("[LaunchDarkly] Configured logger's " + f + " method threw an exception: " + _);
    }
  }
  const c = {};
  for (let a = 0; a < vf.length; a++) {
    const f = vf[a];
    if (f !== "none")
      if (a < s)
        c[f] = () => {
        };
      else {
        const h = a;
        c[f] = function() {
          u(h, f, arguments);
        };
      }
  }
  return c;
}, validateLogger: function(t) {
  vf.forEach((e) => {
    if (e !== "none" && (!t[e] || typeof t[e] != "function"))
      throw new Error("Provided logger instance must support logger." + e + "(...) method");
  });
} };
function _h(t) {
  return t && t.message ? t.message : typeof t == "string" || t instanceof String ? t : JSON.stringify(t);
}
const Tu = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initializing-the-client for instructions on SDK initialization.";
var Ft = { bootstrapInvalid: function() {
  return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
}, bootstrapOldFormat: function() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + Tu;
}, clientInitialized: function() {
  return "LaunchDarkly client initialized";
}, clientNotReady: function() {
  return "LaunchDarkly client is not ready";
}, debugEnqueueingEvent: function(t) {
  return 'enqueueing "' + t + '" event';
}, debugPostingDiagnosticEvent: function(t) {
  return "sending diagnostic event (" + t.kind + ")";
}, debugPostingEvents: function(t) {
  return "sending " + t + " events";
}, debugStreamDelete: function(t) {
  return 'received streaming deletion for flag "' + t + '"';
}, debugStreamDeleteIgnored: function(t) {
  return 'received streaming deletion for flag "' + t + '" but ignored due to version check';
}, debugStreamPatch: function(t) {
  return 'received streaming update for flag "' + t + '"';
}, debugStreamPatchIgnored: function(t) {
  return 'received streaming update for flag "' + t + '" but ignored due to version check';
}, debugStreamPing: function() {
  return "received ping message from stream";
}, debugPolling: function(t) {
  return "polling for feature flags at " + t;
}, debugStreamPut: function() {
  return "received streaming update for all flags";
}, deprecated: function(t, e) {
  return e ? '"' + t + '" is deprecated, please use "' + e + '"' : '"' + t + '" is deprecated';
}, environmentNotFound: function() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + Tu;
}, environmentNotSpecified: function() {
  return "No environment/client-side ID was specified." + Tu;
}, errorFetchingFlags: function(t) {
  return "Error fetching flag settings: " + _h(t);
}, eventCapacityExceeded: function() {
  return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
}, eventWithoutContext: function() {
  return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
}, httpErrorMessage: function(t, e, r) {
  return "Received error " + t + (t === 401 ? " (invalid SDK key)" : "") + " for " + e + " - " + (Rr.isHttpErrorRecoverable(t) ? r : "giving up permanently");
}, httpUnavailable: function() {
  return "Cannot make HTTP requests in this environment." + Tu;
}, identifyDisabled: function() {
  return "identify() has no effect here; it must be called on the main client instance";
}, inspectorMethodError: (t, e) => `an inspector: "${e}" of type: "${t}" generated an exception`, invalidContentType: function(t) {
  return 'Expected application/json content type but got "' + t + '"';
}, invalidData: function() {
  return "Invalid data received from LaunchDarkly; connection may have been interrupted";
}, invalidInspector: (t, e) => `an inspector: "${e}" of an invalid type (${t}) was configured`, invalidKey: function() {
  return "Event key must be a string";
}, invalidContext: function() {
  return "Invalid context specified." + Tu;
}, invalidTagValue: (t) => `Config option "${t}" must only contain letters, numbers, ., _ or -.`, localStorageUnavailable: function(t) {
  return "local storage is unavailable: " + _h(t);
}, networkError: (t) => "network error" + (t ? " (" + t + ")" : ""), optionBelowMinimum: (t, e, r) => 'Config option "' + t + '" was set to ' + e + ", changing to minimum value of " + r, streamClosing: function() {
  return "Closing stream connection";
}, streamConnecting: function(t) {
  return "Opening stream connection to " + t;
}, streamError: function(t, e) {
  return "Error on stream connection: " + _h(t) + ", will continue retrying after " + e + " milliseconds.";
}, tagValueTooLong: (t) => `Value of "${t}" was longer than 64 characters and was discarded.`, unknownCustomEventKey: function(t) {
  return 'Custom event "' + t + '" does not exist';
}, unknownOption: (t) => 'Ignoring unknown config option "' + t + '"', contextNotSpecified: function() {
  return "No context specified." + Tu;
}, unrecoverableStreamError: (t) => `Error on stream connection ${_h(t)}, giving up permanently`, wrongOptionType: (t, e, r) => 'Config option "' + t + '" should be of type ' + e + ", got " + r + ", using default value", wrongOptionTypeBoolean: (t, e) => 'Config option "' + t + '" should be a boolean, got ' + e + ", converting to boolean" };
const { validateLogger: ok } = V_, F1 = { baseUrl: { default: "https://app.launchdarkly.com" }, streamUrl: { default: "https://clientstream.launchdarkly.com" }, eventsUrl: { default: "https://events.launchdarkly.com" }, sendEvents: { default: !0 }, streaming: { type: "boolean" }, sendLDHeaders: { default: !0 }, requestHeaderTransform: { type: "function" }, sendEventsOnlyForVariation: { default: !1 }, useReport: { default: !1 }, evaluationReasons: { default: !1 }, eventCapacity: { default: 100, minimum: 1 }, flushInterval: { default: 2e3, minimum: 2e3 }, samplingInterval: { default: 0, minimum: 0 }, streamReconnectDelay: { default: 1e3, minimum: 0 }, allAttributesPrivate: { default: !1 }, privateAttributes: { default: [] }, bootstrap: { type: "string|object" }, diagnosticRecordingInterval: { default: 9e5, minimum: 2e3 }, diagnosticOptOut: { default: !1 }, wrapperName: { type: "string" }, wrapperVersion: { type: "string" }, stateProvider: { type: "object" }, application: { validator: function(t, e, r) {
  const n = {};
  return e.id && (n.id = N1(`${t}.id`, e.id, r)), e.version && (n.version = N1(`${t}.version`, e.version, r)), n;
} }, inspectors: { default: [] } }, sk = /^(\w|\.|-)+$/;
function yv(t) {
  return t && t.replace(/\/+$/, "");
}
function N1(t, e, r) {
  if (typeof e == "string" && e.match(sk)) {
    if (!(e.length > 64))
      return e;
    r.warn(Ft.tagValueTooLong(t));
  } else
    r.warn(Ft.invalidTagValue(t));
}
var Q_ = { baseOptionDefs: F1, validate: function(t, e, r, n) {
  const i = zt.extend({ logger: { default: n } }, F1, r), o = {};
  function s(c) {
    zt.onNextTick(() => {
      e && e.maybeReportError(new Rr.LDInvalidArgumentError(c));
    });
  }
  let u = zt.extend({}, t || {});
  return function(c) {
    const a = c;
    Object.keys(o).forEach((f) => {
      if (a[f] !== void 0) {
        const h = o[f];
        n && n.warn(Ft.deprecated(f, h)), h && (a[h] === void 0 && (a[h] = a[f]), delete a[f]);
      }
    });
  }(u), u = function(c) {
    const a = zt.extend({}, c);
    return Object.keys(i).forEach((f) => {
      a[f] !== void 0 && a[f] !== null || (a[f] = i[f] && i[f].default);
    }), a;
  }(u), u = function(c) {
    const a = zt.extend({}, c), f = (h) => {
      if (h === null)
        return "any";
      if (h === void 0)
        return;
      if (Array.isArray(h))
        return "array";
      const p = typeof h;
      return p === "boolean" || p === "string" || p === "number" || p === "function" ? p : "object";
    };
    return Object.keys(c).forEach((h) => {
      const p = c[h];
      if (p != null) {
        const d = i[h];
        if (d === void 0)
          s(Ft.unknownOption(h));
        else {
          const _ = d.type || f(d.default), m = d.validator;
          if (m) {
            const b = m(h, c[h], n);
            b !== void 0 ? a[h] = b : delete a[h];
          } else if (_ !== "any") {
            const b = _.split("|"), O = f(p);
            b.indexOf(O) < 0 ? _ === "boolean" ? (a[h] = !!p, s(Ft.wrongOptionTypeBoolean(h, O))) : (s(Ft.wrongOptionType(h, _, O)), a[h] = d.default) : O === "number" && d.minimum !== void 0 && p < d.minimum && (s(Ft.optionBelowMinimum(h, p, d.minimum)), a[h] = d.minimum);
          }
        }
      }
    }), a.baseUrl = yv(a.baseUrl), a.streamUrl = yv(a.streamUrl), a.eventsUrl = yv(a.eventsUrl), a;
  }(u), ok(u.logger), u;
}, getTags: function(t) {
  const e = {};
  return t && (t.application && t.application.id !== void 0 && t.application.id !== null && (e["application-id"] = [t.application.id]), t.application && t.application.version !== void 0 && t.application.id !== null && (e["application-version"] = [t.application.version])), e;
} };
const { getLDUserAgentString: ak } = zt;
var Y_ = { getLDHeaders: function(t, e) {
  if (e && !e.sendLDHeaders)
    return {};
  const r = {};
  r[t.userAgentHeaderName || "User-Agent"] = ak(t), e && e.wrapperName && (r["X-LaunchDarkly-Wrapper"] = e.wrapperVersion ? e.wrapperName + "/" + e.wrapperVersion : e.wrapperName);
  const n = Q_.getTags(e), i = Object.keys(n);
  return i.length && (r["x-launchdarkly-tags"] = i.sort().map((o) => Array.isArray(n[o]) ? n[o].sort().map((s) => `${o}/${s}`) : [`${o}/${n[o]}`]).reduce((o, s) => o.concat(s), []).join(" ")), r;
}, transformHeaders: function(t, e) {
  return e && e.requestHeaderTransform ? e.requestHeaderTransform({ ...t }) : t;
} };
const { v1: uk } = K_, { getLDHeaders: ck, transformHeaders: fk } = Y_;
var mO = function(t, e, r) {
  const n = "/a/" + e + ".gif", i = zt.extend({ "Content-Type": "application/json" }, ck(t, r)), o = t.httpFallbackPing, s = {};
  return s.sendChunk = (u, c, a, f) => {
    const h = JSON.stringify(u), p = a ? null : uk();
    return f ? function d(_) {
      const m = a ? i : zt.extend({}, i, { "X-LaunchDarkly-Event-Schema": "4", "X-LaunchDarkly-Payload-ID": p });
      return t.httpRequest("POST", c, fk(m, r), h).promise.then((b) => {
        if (b)
          return b.status >= 400 && Rr.isHttpErrorRecoverable(b.status) && _ ? d(!1) : function(O) {
            const S = { status: O.status }, k = O.header("date");
            if (k) {
              const T = Date.parse(k);
              T && (S.serverTime = T);
            }
            return S;
          }(b);
      }).catch(() => _ ? d(!1) : Promise.reject());
    }(!0).catch(() => {
    }) : (o && o(c + n + "?d=" + zt.base64URLEncode(h)), Promise.resolve());
  }, s.sendEvents = function(u, c, a) {
    if (!t.httpRequest)
      return Promise.resolve();
    const f = t.httpAllowsPost();
    let h;
    h = f ? [u] : zt.chunkEventsForUrl(2e3 - c.length, u);
    const p = [];
    for (let d = 0; d < h.length; d++)
      p.push(s.sendChunk(h[d], c, a, f));
    return Promise.all(p);
  }, s;
};
const { commonBasicLogger: lk } = V_;
function z1(t) {
  return typeof t == "string" && t !== "kind" && t.match(/^(\w|\.|-)+$/);
}
function L1(t) {
  return t.includes("%") || t.includes(":") ? t.replace(/%/g, "%25").replace(/:/g, "%3A") : t;
}
var Wp = { checkContext: function(t, e) {
  if (t) {
    if (e && (t.kind === void 0 || t.kind === null))
      return t.key !== void 0 && t.key !== null;
    const r = t.key, n = t.kind === void 0 ? "user" : t.kind, i = z1(n), o = n === "multi" || r != null && r !== "";
    if (n === "multi") {
      const s = Object.keys(t).filter((u) => u !== "kind");
      return o && s.every((u) => z1(u)) && s.every((u) => {
        const c = t[u].key;
        return c != null && c !== "";
      });
    }
    return o && i;
  }
  return !1;
}, getContextKeys: function(t, e = lk()) {
  if (!t)
    return;
  const r = {}, { kind: n, key: i } = t;
  switch (n) {
    case void 0:
      r.user = `${i}`;
      break;
    case "multi":
      Object.entries(t).filter(([o]) => o !== "kind").forEach(([o, s]) => {
        s && s.key && (r[o] = s.key);
      });
      break;
    case null:
      e.warn(`null is not a valid context kind: ${t}`);
      break;
    case "":
      e.warn(`'' is not a valid context kind: ${t}`);
      break;
    default:
      r[n] = `${i}`;
  }
  return r;
}, getContextKinds: function(t) {
  return t ? t.kind === null || t.kind === void 0 ? ["user"] : t.kind !== "multi" ? [t.kind] : Object.keys(t).filter((e) => e !== "kind") : [];
}, getCanonicalKey: function(t) {
  if (t) {
    if ((t.kind === void 0 || t.kind === null || t.kind === "user") && t.key)
      return t.key;
    if (t.kind !== "multi" && t.key)
      return `${t.kind}:${L1(t.key)}`;
    if (t.kind === "multi")
      return Object.keys(t).sort().filter((e) => e !== "kind").map((e) => `${e}:${L1(t[e].key)}`).join(":");
  }
} };
const { getContextKinds: hk } = Wp;
var pk = function() {
  const t = {};
  let e = 0, r = 0, n = {}, i = {};
  return t.summarizeEvent = (o) => {
    if (o.kind === "feature") {
      const s = o.key + ":" + (o.variation !== null && o.variation !== void 0 ? o.variation : "") + ":" + (o.version !== null && o.version !== void 0 ? o.version : ""), u = n[s];
      let c = i[o.key];
      c || (c = /* @__PURE__ */ new Set(), i[o.key] = c), function(a) {
        return a.context ? hk(a.context) : a.contextKeys ? Object.keys(a.contextKeys) : [];
      }(o).forEach((a) => c.add(a)), u ? u.count = u.count + 1 : n[s] = { count: 1, key: o.key, version: o.version, variation: o.variation, value: o.value, default: o.default }, (e === 0 || o.creationDate < e) && (e = o.creationDate), o.creationDate > r && (r = o.creationDate);
    }
  }, t.getSummary = () => {
    const o = {};
    let s = !0;
    for (const u of Object.values(n)) {
      let c = o[u.key];
      c || (c = { default: u.default, counters: [], contextKinds: [...i[u.key]] }, o[u.key] = c);
      const a = { value: u.value, count: u.count };
      u.variation !== void 0 && u.variation !== null && (a.variation = u.variation), u.version !== void 0 && u.version !== null ? a.version = u.version : a.unknown = !0, c.counters.push(a), s = !1;
    }
    return s ? null : { startDate: e, endDate: r, features: o };
  }, t.clearSummary = () => {
    e = 0, r = 0, n = {}, i = {};
  }, t;
};
function gO(t) {
  return t.replace(/~/g, "~0").replace(/\//g, "~1");
}
function U1(t) {
  return (t.startsWith("/") ? t.substring(1) : t).split("/").map((e) => e.indexOf("~") >= 0 ? e.replace(/~1/g, "/").replace(/~0/g, "~") : e);
}
function B1(t) {
  return !t.startsWith("/");
}
function $1(t, e) {
  const r = B1(t), n = B1(e);
  if (r && n)
    return t === e;
  if (r) {
    const i = U1(e);
    return i.length === 1 && t === i[0];
  }
  if (n) {
    const i = U1(t);
    return i.length === 1 && e === i[0];
  }
  return t === e;
}
function K1(t) {
  return `/${gO(t)}`;
}
var _v = { cloneExcluding: function(t, e) {
  const r = [], n = {}, i = [];
  for (r.push(...Object.keys(t).map((o) => ({ key: o, ptr: K1(o), source: t, parent: n, visited: [t] }))); r.length; ) {
    const o = r.pop();
    if (e.some((s) => $1(s, o.ptr)))
      i.push(o.ptr);
    else {
      const s = o.source[o.key];
      if (s === null)
        o.parent[o.key] = s;
      else if (Array.isArray(s))
        o.parent[o.key] = [...s];
      else if (typeof s == "object") {
        if (o.visited.includes(s))
          continue;
        o.parent[o.key] = {}, r.push(...Object.keys(s).map((u) => {
          return { key: u, ptr: (c = o.ptr, a = gO(u), `${c}/${a}`), source: s, parent: o.parent[o.key], visited: [...o.visited, s] };
          var c, a;
        }));
      } else
        o.parent[o.key] = s;
    }
  }
  return { cloned: n, excluded: i.sort() };
}, compare: $1, literalToReference: K1 }, dk = function(t) {
  const e = {}, r = t.allAttributesPrivate, n = t.privateAttributes || [], i = ["key", "kind", "_meta", "anonymous"], o = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"], s = (u) => {
    if (typeof u != "object" || u === null || Array.isArray(u))
      return;
    const { cloned: c, excluded: a } = _v.cloneExcluding(u, ((f) => (r ? Object.keys(f) : [...n, ...f._meta && f._meta.privateAttributes || []]).filter((h) => !i.some((p) => _v.compare(h, p))))(u));
    return c.key = String(c.key), a.length && (c._meta || (c._meta = {}), c._meta.redactedAttributes = a), c._meta && (delete c._meta.privateAttributes, Object.keys(c._meta).length === 0 && delete c._meta), c.anonymous !== void 0 && (c.anonymous = !!c.anonymous), c;
  };
  return e.filter = (u) => u.kind === void 0 || u.kind === null ? s(((c) => {
    const a = { ...c.custom || {}, kind: "user", key: c.key };
    c.anonymous !== void 0 && (a.anonymous = !!c.anonymous);
    for (const f of o)
      delete a[f], c[f] !== void 0 && c[f] !== null && (a[f] = String(c[f]));
    return c.privateAttributeNames !== void 0 && c.privateAttributeNames !== null && (a._meta = a._meta || {}, a._meta.privateAttributes = c.privateAttributeNames.map((f) => f.startsWith("/") ? _v.literalToReference(f) : f)), a;
  })(u)) : u.kind === "multi" ? ((c) => {
    const a = { kind: c.kind }, f = Object.keys(c);
    for (const h of f)
      if (h !== "kind") {
        const p = s(c[h]);
        p && (a[h] = p);
      }
    return a;
  })(u) : s(u), e;
};
const { getContextKeys: vk } = Wp;
var yk = function(t, e, r, n = null, i = null, o = null) {
  const s = {}, u = o || mO(t, r, e), c = zt.appendUrlPath(e.eventsUrl, "/events/bulk/" + r), a = pk(), f = dk(e), h = e.samplingInterval, p = e.eventCapacity, d = e.flushInterval, _ = e.logger;
  let m, b = [], O = 0, S = !1, k = !1;
  function T() {
    return h === 0 || Math.floor(Math.random() * h) === 0;
  }
  function x(R) {
    const D = zt.extend({}, R);
    return R.kind === "identify" ? D.context = f.filter(R.context) : (D.contextKeys = vk(R.context, _), delete D.context), R.kind === "feature" && (delete D.trackEvents, delete D.debugEventsUntilDate), D;
  }
  function P(R) {
    b.length < p ? (b.push(R), k = !1) : (k || (k = !0, _.warn(Ft.eventCapacityExceeded())), n && n.incrementDroppedEvents());
  }
  return s.enqueue = function(R) {
    if (S)
      return;
    let D = !1, I = !1;
    var j;
    if (a.summarizeEvent(R), R.kind === "feature" ? T() && (D = !!R.trackEvents, I = !!(j = R).debugEventsUntilDate && j.debugEventsUntilDate > O && j.debugEventsUntilDate > (/* @__PURE__ */ new Date()).getTime()) : D = T(), D && P(x(R)), I) {
      const Y = zt.extend({}, R, { kind: "debug" });
      Y.context = f.filter(Y.context), delete Y.trackEvents, delete Y.debugEventsUntilDate, P(Y);
    }
  }, s.flush = function() {
    if (S)
      return Promise.resolve();
    const R = b, D = a.getSummary();
    return a.clearSummary(), D && (D.kind = "summary", R.push(D)), n && n.setEventsInLastBatch(R.length), R.length === 0 ? Promise.resolve() : (b = [], _.debug(Ft.debugPostingEvents(R.length)), u.sendEvents(R, c).then((I) => {
      const j = I && I[0];
      j && (j.serverTime && (O = j.serverTime), Rr.isHttpErrorRecoverable(j.status) || (S = !0), j.status >= 400 && zt.onNextTick(() => {
        i.maybeReportError(new Rr.LDUnexpectedResponseError(Ft.httpErrorMessage(j.status, "event posting", "some events were dropped")));
      }));
    }));
  }, s.start = function() {
    const R = () => {
      s.flush(), m = setTimeout(R, d);
    };
    m = setTimeout(R, d);
  }, s.stop = function() {
    clearTimeout(m);
  }, s;
}, _k = function(t) {
  const e = {}, r = {};
  return e.on = function(n, i, o) {
    r[n] = r[n] || [], r[n] = r[n].concat({ handler: i, context: o });
  }, e.off = function(n, i, o) {
    if (r[n])
      for (let s = 0; s < r[n].length; s++)
        r[n][s].handler === i && r[n][s].context === o && (r[n] = r[n].slice(0, s).concat(r[n].slice(s + 1)));
  }, e.emit = function(n) {
    if (!r[n])
      return;
    const i = r[n].slice(0);
    for (let o = 0; o < i.length; o++)
      i[o].handler.apply(i[o].context, Array.prototype.slice.call(arguments, 1));
  }, e.getEvents = function() {
    return Object.keys(r);
  }, e.getEventListenerCount = function(n) {
    return r[n] ? r[n].length : 0;
  }, e.maybeReportError = function(n) {
    n && (r.error ? this.emit("error", n) : (t || console).error(n.message));
  }, e;
};
const mh = "ready", mv = "initialized", gv = "failed";
var mk = function(t) {
  let e = !1, r = !1, n = null, i = null;
  const o = new Promise((s) => {
    const u = () => {
      t.off(mh, u), s();
    };
    t.on(mh, u);
  }).catch(() => {
  });
  return { getInitializationPromise: () => i || (e ? Promise.resolve() : r ? Promise.reject(n) : (i = new Promise((s, u) => {
    const c = () => {
      t.off(mv, c), s();
    }, a = (f) => {
      t.off(gv, a), u(f);
    };
    t.on(mv, c), t.on(gv, a);
  }), i)), getReadyPromise: () => o, signalSuccess: () => {
    e || r || (e = !0, t.emit(mv), t.emit(mh));
  }, signalFailure: (s) => {
    e || r || (r = !0, n = s, t.emit(gv, s), t.emit(mh)), t.maybeReportError(s);
  } };
}, gk = function(t, e, r, n) {
  const i = {};
  function o() {
    let s = "";
    const u = n.getContext();
    return u && (s = r || zt.btoa(JSON.stringify(u))), "ld:" + e + ":" + s;
  }
  return i.loadFlags = () => t.get(o()).then((s) => {
    if (s == null)
      return null;
    try {
      let u = JSON.parse(s);
      if (u) {
        const c = u.$schema;
        c === void 0 || c < 1 ? u = zt.transformValuesToVersionedValues(u) : delete u.$schema;
      }
      return u;
    } catch {
      return i.clearFlags().then(() => null);
    }
  }), i.saveFlags = (s) => {
    const u = zt.extend({}, s, { $schema: 1 });
    return t.set(o(), JSON.stringify(u));
  }, i.clearFlags = () => t.clear(o()), i;
}, bk = function(t, e) {
  const r = {};
  let n = !1;
  const i = (o) => {
    n || (n = !0, e.warn(Ft.localStorageUnavailable(o)));
  };
  return r.isEnabled = () => !!t, r.get = (o) => new Promise((s) => {
    t ? t.get(o).then(s).catch((u) => {
      i(u), s(void 0);
    }) : s(void 0);
  }), r.set = (o, s) => new Promise((u) => {
    t ? t.set(o, s).then(() => u(!0)).catch((c) => {
      i(c), u(!1);
    }) : u(!1);
  }), r.clear = (o) => new Promise((s) => {
    t ? t.clear(o).then(() => s(!0)).catch((u) => {
      i(u), s(!1);
    }) : s(!1);
  }), r;
};
const { appendUrlPath: V1, base64URLEncode: wk, objectHasOwnProperty: Ek } = zt, { getLDHeaders: Sk, transformHeaders: Ok } = Y_, { isHttpErrorRecoverable: Ik } = Rr;
var Ak = function(t, e, r, n) {
  const i = e.streamUrl, o = e.logger, s = {}, u = V1(i, "/eval/" + r), c = e.useReport, a = e.evaluationReasons, f = e.streamReconnectDelay, h = Sk(t, e);
  let p, d = !1, _ = null, m = null, b = null, O = null, S = null, k = 0;
  function T() {
    const j = (Y = function() {
      const H = f * Math.pow(2, k);
      return H > 3e4 ? 3e4 : H;
    }(), Y - Math.trunc(0.5 * Math.random() * Y));
    var Y;
    return k += 1, j;
  }
  function x(j) {
    if (j.status && typeof j.status == "number" && !Ik(j.status))
      return D(), o.error(Ft.unrecoverableStreamError(j)), void (m && (clearTimeout(m), m = null));
    const Y = T();
    d || (o.warn(Ft.streamError(j, Y)), d = !0), I(!1), D(), P(Y);
  }
  function P(j) {
    m || (j ? m = setTimeout(R, j) : R());
  }
  function R() {
    let j;
    m = null;
    let Y = "";
    const H = { headers: h, readTimeoutMillis: 3e5 };
    if (t.eventSourceFactory) {
      O != null && (Y = "h=" + O), c ? t.eventSourceAllowsReport ? (j = u, H.method = "REPORT", H.headers["Content-Type"] = "application/json", H.body = JSON.stringify(b)) : (j = V1(i, "/ping/" + r), Y = "") : j = u + "/" + wk(JSON.stringify(b)), H.headers = Ok(H.headers, e), a && (Y = Y + (Y ? "&" : "") + "withReasons=true"), j = j + (Y ? "?" : "") + Y, D(), o.info(Ft.streamConnecting(j)), p = (/* @__PURE__ */ new Date()).getTime(), _ = t.eventSourceFactory(j, H);
      for (const B in S)
        Ek(S, B) && _.addEventListener(B, S[B]);
      _.onerror = x, _.onopen = () => {
        k = 0;
      };
    }
  }
  function D() {
    _ && (o.info(Ft.streamClosing()), _.close(), _ = null);
  }
  function I(j) {
    p && n && n.recordStreamInit(p, !j, (/* @__PURE__ */ new Date()).getTime() - p), p = null;
  }
  return s.connect = function(j, Y, H) {
    b = j, O = Y, S = {};
    for (const B in H || {})
      S[B] = function(tt) {
        d = !1, I(!0), H[B] && H[B](tt);
      };
    P();
  }, s.disconnect = function() {
    clearTimeout(m), m = null, D();
  }, s.isConnected = function() {
    return !!(_ && t.eventSourceIsActive && t.eventSourceIsActive(_));
  }, s;
}, Dk = function(t) {
  let e, r, n, i;
  const o = { addPromise: (s, u) => {
    e = s, r && r(), r = u, s.then((c) => {
      e === s && (n(c), t && t());
    }, (c) => {
      e === s && (i(c), t && t());
    });
  } };
  return o.resultPromise = new Promise((s, u) => {
    n = s, i = u;
  }), o;
};
const { transformHeaders: Rk, getLDHeaders: xk } = Y_, bv = "application/json";
var Tk = function(t, e, r) {
  const n = e.baseUrl, i = e.useReport, o = e.evaluationReasons, s = e.logger, u = {}, c = {};
  function a(f, h) {
    if (!t.httpRequest)
      return new Promise((O, S) => {
        S(new Rr.LDFlagFetchError(Ft.httpUnavailable()));
      });
    const p = h ? "REPORT" : "GET", d = xk(t, e);
    h && (d["Content-Type"] = bv);
    let _ = c[f];
    _ || (_ = Dk(() => {
      delete c[f];
    }), c[f] = _);
    const m = t.httpRequest(p, f, Rk(d, e), h), b = m.promise.then((O) => {
      if (O.status === 200) {
        if (O.header("content-type") && O.header("content-type").substring(0, bv.length) === bv)
          return JSON.parse(O.body);
        {
          const S = Ft.invalidContentType(O.header("content-type") || "");
          return Promise.reject(new Rr.LDFlagFetchError(S));
        }
      }
      return Promise.reject(function(S) {
        return S.status === 404 ? new Rr.LDInvalidEnvironmentIdError(Ft.environmentNotFound()) : new Rr.LDFlagFetchError(Ft.errorFetchingFlags(S.statusText || String(S.status)));
      }(O));
    }, (O) => Promise.reject(new Rr.LDFlagFetchError(Ft.networkError(O))));
    return _.addPromise(b, () => {
      m.cancel && m.cancel();
    }), _.resultPromise;
  }
  return u.fetchJSON = function(f) {
    return a(zt.appendUrlPath(n, f), null);
  }, u.fetchFlagSettings = function(f, h) {
    let p, d, _, m = "";
    return i ? (d = [n, "/sdk/evalx/", r, "/context"].join(""), _ = JSON.stringify(f)) : (p = zt.base64URLEncode(JSON.stringify(f)), d = [n, "/sdk/evalx/", r, "/contexts/", p].join("")), h && (m = "h=" + h), o && (m = m + (m ? "&" : "") + "withReasons=true"), d = d + (m ? "?" : "") + m, s.debug(Ft.debugPolling(d)), a(d, _);
  }, u;
}, Pk = function(t, e) {
  const r = {};
  let n;
  return r.setContext = function(i) {
    n = zt.sanitizeContext(i), n && e && e(zt.clone(n));
  }, r.getContext = function() {
    return n ? zt.clone(n) : null;
  }, t && r.setContext(t), r;
};
const { v1: kk } = K_, { getContextKinds: Ck } = Wp;
var jk = function(t) {
  function e(n) {
    return n == null || n === "user" ? "ld:$anonUserId" : `ld:$contextKey:${n}`;
  }
  function r(n, i) {
    return i.key !== null && i.key !== void 0 ? (i.key = i.key.toString(), Promise.resolve(i)) : i.anonymous ? function(o) {
      return t.get(e(o));
    }(n).then((o) => {
      if (o)
        return i.key = o, i;
      {
        const s = kk();
        return i.key = s, function(u, c) {
          return t.set(e(c), u);
        }(s, n).then(() => i);
      }
    }) : Promise.reject(new Rr.LDInvalidUserError(Ft.invalidContext()));
  }
  this.processContext = (n) => {
    if (!n)
      return Promise.reject(new Rr.LDInvalidUserError(Ft.contextNotSpecified()));
    const i = zt.clone(n);
    if (n.kind === "multi") {
      const o = Ck(i);
      return Promise.all(o.map((s) => r(s, i[s]))).then(() => i);
    }
    return r(n.kind, i);
  };
};
const { v1: qk } = K_, { baseOptionDefs: wv } = Q_, { appendUrlPath: Mk } = zt;
var Ev = { DiagnosticId: function(t) {
  const e = { diagnosticId: qk() };
  return t && (e.sdkKeySuffix = t.length > 6 ? t.substring(t.length - 6) : t), e;
}, DiagnosticsAccumulator: function(t) {
  let e, r, n, i;
  function o(s) {
    e = s, r = 0, n = 0, i = [];
  }
  return o(t), { getProps: () => ({ dataSinceDate: e, droppedEvents: r, eventsInLastBatch: n, streamInits: i }), setProps: (s) => {
    e = s.dataSinceDate, r = s.droppedEvents || 0, n = s.eventsInLastBatch || 0, i = s.streamInits || [];
  }, incrementDroppedEvents: () => {
    r++;
  }, setEventsInLastBatch: (s) => {
    n = s;
  }, recordStreamInit: (s, u, c) => {
    const a = { timestamp: s, failed: u, durationMillis: c };
    i.push(a);
  }, reset: o };
}, DiagnosticsManager: function(t, e, r, n, i, o, s) {
  const u = !!t.diagnosticUseCombinedEvent, c = "ld:" + i + ":$diagnostics", a = Mk(o.eventsUrl, "/events/diagnostic/" + i), f = o.diagnosticRecordingInterval, h = r;
  let p, d, _ = !!o.streaming;
  const m = {};
  function b() {
    return { sdk: k(), configuration: T(), platform: t.diagnosticPlatformData };
  }
  function O(x) {
    o.logger && o.logger.debug(Ft.debugPostingDiagnosticEvent(x)), n.sendEvents(x, a, !0).then(() => {
    }).catch(() => {
    });
  }
  function S() {
    O(function() {
      const x = (/* @__PURE__ */ new Date()).getTime();
      let P = { kind: u ? "diagnostic-combined" : "diagnostic", id: s, creationDate: x, ...h.getProps() };
      return u && (P = { ...P, ...b() }), h.reset(x), P;
    }()), d = setTimeout(S, f), p = (/* @__PURE__ */ new Date()).getTime(), u && function() {
      if (e.isEnabled()) {
        const x = { ...h.getProps() };
        e.set(c, JSON.stringify(x));
      }
    }();
  }
  function k() {
    const x = { ...t.diagnosticSdkData };
    return o.wrapperName && (x.wrapperName = o.wrapperName), o.wrapperVersion && (x.wrapperVersion = o.wrapperVersion), x;
  }
  function T() {
    return { customBaseURI: o.baseUrl !== wv.baseUrl.default, customStreamURI: o.streamUrl !== wv.streamUrl.default, customEventsURI: o.eventsUrl !== wv.eventsUrl.default, eventsCapacity: o.eventCapacity, eventsFlushIntervalMillis: o.flushInterval, reconnectTimeMillis: o.streamReconnectDelay, streamingDisabled: !_, allAttributesPrivate: !!o.allAttributesPrivate, diagnosticRecordingIntervalMillis: o.diagnosticRecordingInterval, usingSecureMode: !!o.hash, bootstrapMode: !!o.bootstrap, fetchGoalsDisabled: !o.fetchGoals, sendEventsOnlyForVariation: !!o.sendEventsOnlyForVariation };
  }
  return m.start = () => {
    u ? function(x) {
      if (!e.isEnabled())
        return x(!1);
      e.get(c).then((P) => {
        if (P)
          try {
            const R = JSON.parse(P);
            h.setProps(R), p = R.dataSinceDate;
          } catch {
          }
        x(!0);
      }).catch(() => {
        x(!1);
      });
    }((x) => {
      if (x) {
        const P = (p || 0) + f, R = (/* @__PURE__ */ new Date()).getTime();
        R >= P ? S() : d = setTimeout(S, P - R);
      } else
        Math.floor(4 * Math.random()) === 0 ? S() : d = setTimeout(S, f);
    }) : (O({ kind: "diagnostic-init", id: s, creationDate: h.getProps().dataSinceDate, ...b() }), d = setTimeout(S, f));
  }, m.stop = () => {
    d && clearTimeout(d);
  }, m.setStreaming = (x) => {
    _ = x;
  }, m;
} }, Fk = function(t, e) {
  let r = !1;
  const n = { type: t.type, name: t.name, method: (...i) => {
    try {
      t.method(...i);
    } catch {
      r || (r = !0, e.warn(Ft.inspectorMethodError(n.type, n.name)));
    }
  } };
  return n;
};
const { onNextTick: gh } = zt, ei = { flagUsed: "flag-used", flagDetailsChanged: "flag-details-changed", flagDetailChanged: "flag-detail-changed", clientIdentityChanged: "client-identity-changed" };
Object.freeze(ei);
var Nk = { InspectorTypes: ei, InspectorManager: function(t, e) {
  const r = {}, n = { [ei.flagUsed]: [], [ei.flagDetailsChanged]: [], [ei.flagDetailChanged]: [], [ei.clientIdentityChanged]: [] }, i = t && t.map((o) => Fk(o, e));
  return i && i.forEach((o) => {
    Object.prototype.hasOwnProperty.call(n, o.type) ? n[o.type].push(o) : e.warn(Ft.invalidInspector(o.type, o.name));
  }), r.hasListeners = (o) => n[o] && n[o].length, r.onFlagUsed = (o, s, u) => {
    n[ei.flagUsed].length && gh(() => {
      n[ei.flagUsed].forEach((c) => c.method(o, s, u));
    });
  }, r.onFlags = (o) => {
    n[ei.flagDetailsChanged].length && gh(() => {
      n[ei.flagDetailsChanged].forEach((s) => s.method(o));
    });
  }, r.onFlagChanged = (o, s) => {
    n[ei.flagDetailChanged].length && gh(() => {
      n[ei.flagDetailChanged].forEach((u) => u.method(o, s));
    });
  }, r.onIdentityChanged = (o) => {
    n[ei.clientIdentityChanged].length && gh(() => {
      n[ei.clientIdentityChanged].forEach((s) => s.method(o));
    });
  }, r;
} };
const { commonBasicLogger: Q1 } = V_, { checkContext: zk, getContextKeys: Lk } = Wp, { InspectorTypes: bh, InspectorManager: Uk } = Nk, yf = "change", Y1 = "internal-change";
var bO = { initialize: function(t, e, r, n, i) {
  const o = function() {
    return r && r.logger ? r.logger : i && i.logger && i.logger.default || Q1("warn");
  }(), s = _k(o), u = mk(s), c = Q_.validate(r, s, i, o), a = Uk(c.inspectors, o), f = c.sendEvents;
  let h = t, p = c.hash;
  const d = bk(n.localStorage, o), _ = mO(n, h, c), m = c.sendEvents && !c.diagnosticOptOut, b = m ? Ev.DiagnosticId(h) : null, O = m ? Ev.DiagnosticsAccumulator((/* @__PURE__ */ new Date()).getTime()) : null, S = m ? Ev.DiagnosticsManager(n, d, O, _, h, c, b) : null, k = Ak(n, c, h, O), T = c.eventProcessor || yk(n, c, h, O, s, _), x = Tk(n, c, h);
  let P, R, D, I = {}, j = c.streaming, Y = !1, H = !1, B = !0;
  const tt = c.stateProvider, lt = Pk(null, function(U) {
    (function($) {
      tt || $ && At({ kind: "identify", context: $, creationDate: (/* @__PURE__ */ new Date()).getTime() });
    })(U), a.hasListeners(bh.clientIdentityChanged) && a.onIdentityChanged(lt.getContext());
  }), te = new jk(d), pt = d.isEnabled() ? gk(d, h, p, lt) : null;
  function At(U) {
    h && (tt && tt.enqueueEvent && tt.enqueueEvent(U) || (U.context ? (B = !1, !f || H || n.isDoNotTrack() || (o.debug(Ft.debugEnqueueingEvent(U.kind)), T.enqueue(U))) : B && (o.warn(Ft.eventWithoutContext()), B = !1)));
  }
  function ft(U, $) {
    a.hasListeners(bh.flagDetailChanged) && a.onFlagChanged(U.key, Nt($));
  }
  function Lt() {
    a.hasListeners(bh.flagDetailsChanged) && a.onFlags(Object.entries(I).map(([U, $]) => ({ key: U, detail: Nt($) })).reduce((U, $) => (U[$.key] = $.detail, U), {}));
  }
  function dt(U, $, W, et) {
    const ot = lt.getContext(), Dt = /* @__PURE__ */ new Date(), St = { kind: "feature", key: U, context: ot, value: $ ? $.value : null, variation: $ ? $.variationIndex : null, default: W, creationDate: Dt.getTime() }, Et = I[U];
    Et && (St.version = Et.flagVersion ? Et.flagVersion : Et.version, St.trackEvents = Et.trackEvents, St.debugEventsUntilDate = Et.debugEventsUntilDate), (et || Et && Et.trackReason) && $ && (St.reason = $.reason), At(St);
  }
  function mt(U) {
    return zk(U, !1) ? Promise.resolve(U) : Promise.reject(new Rr.LDInvalidUserError(Ft.invalidContext()));
  }
  function st(U, $, W, et, ot) {
    let Dt;
    if (I && zt.objectHasOwnProperty(I, U) && I[U] && !I[U].deleted) {
      const St = I[U];
      Dt = Nt(St), St.value !== null && St.value !== void 0 || (Dt.value = $);
    } else
      Dt = { value: $, variationIndex: null, reason: { kind: "ERROR", errorKind: "FLAG_NOT_FOUND" } };
    return W && dt(U, Dt, $, et), ot || function(St, Et) {
      a.hasListeners(bh.flagUsed) && a.onFlagUsed(St, Et, lt.getContext());
    }(U, Dt), Dt;
  }
  function Nt(U) {
    return { value: U.value, variationIndex: U.variation === void 0 ? null : U.variation, reason: U.reason || null };
  }
  function Qt() {
    if (R = !0, !lt.getContext())
      return;
    const U = ($) => {
      try {
        return JSON.parse($);
      } catch {
        return void s.maybeReportError(new Rr.LDInvalidDataError(Ft.invalidData()));
      }
    };
    k.connect(lt.getContext(), p, { ping: function() {
      o.debug(Ft.debugStreamPing());
      const $ = lt.getContext();
      x.fetchFlagSettings($, p).then((W) => {
        zt.deepEquals($, lt.getContext()) && xt(W || {});
      }).catch((W) => {
        s.maybeReportError(new Rr.LDFlagFetchError(Ft.errorFetchingFlags(W)));
      });
    }, put: function($) {
      const W = U($.data);
      W && (o.debug(Ft.debugStreamPut()), xt(W));
    }, patch: function($) {
      const W = U($.data);
      if (!W)
        return;
      const et = I[W.key];
      if (!et || !et.version || !W.version || et.version < W.version) {
        o.debug(Ft.debugStreamPatch(W.key));
        const ot = {}, Dt = zt.extend({}, W);
        delete Dt.key, I[W.key] = Dt;
        const St = Nt(Dt);
        ot[W.key] = et ? { previous: et.value, current: St } : { current: St }, N(ot), ft(W, Dt);
      } else
        o.debug(Ft.debugStreamPatchIgnored(W.key));
    }, delete: function($) {
      const W = U($.data);
      if (W)
        if (!I[W.key] || I[W.key].version < W.version) {
          o.debug(Ft.debugStreamDelete(W.key));
          const et = {};
          I[W.key] && !I[W.key].deleted && (et[W.key] = { previous: I[W.key].value }), I[W.key] = { version: W.version, deleted: !0 }, ft(W, I[W.key]), N(et);
        } else
          o.debug(Ft.debugStreamDeleteIgnored(W.key));
    } });
  }
  function Rt() {
    R && (k.disconnect(), R = !1);
  }
  function xt(U) {
    const $ = {};
    if (!U)
      return Promise.resolve();
    for (const W in I)
      zt.objectHasOwnProperty(I, W) && I[W] && (U[W] && !zt.deepEquals(U[W].value, I[W].value) ? $[W] = { previous: I[W].value, current: Nt(U[W]) } : U[W] && !U[W].deleted || ($[W] = { previous: I[W].value }));
    for (const W in U)
      zt.objectHasOwnProperty(U, W) && U[W] && (!I[W] || I[W].deleted) && ($[W] = { current: Nt(U[W]) });
    return I = { ...U }, Lt(), N($).catch(() => {
    });
  }
  function N(U) {
    const $ = Object.keys(U);
    if ($.length > 0) {
      const W = {};
      $.forEach((et) => {
        const ot = U[et].current, Dt = ot ? ot.value : void 0, St = U[et].previous;
        s.emit(yf + ":" + et, Dt, St), W[et] = ot ? { current: Dt, previous: St } : { previous: St };
      }), s.emit(yf, W), s.emit(Y1, I), c.sendEventsOnlyForVariation || tt || $.forEach((et) => {
        dt(et, U[et].current);
      });
    }
    return P && pt ? pt.saveFlags(I) : Promise.resolve();
  }
  function ht() {
    const U = j || D && j === void 0;
    U && !R ? Qt() : !U && R && Rt(), S && S.setStreaming(U);
  }
  function gt(U) {
    return U === yf || U.substr(0, yf.length + 1) === yf + ":";
  }
  if (typeof c.bootstrap == "string" && c.bootstrap.toUpperCase() === "LOCALSTORAGE" && (pt ? P = !0 : o.warn(Ft.localStorageUnavailable())), typeof c.bootstrap == "object" && (I = function(U) {
    const $ = Object.keys(U), W = "$flagsState", et = "$valid", ot = U[W];
    !ot && $.length && o.warn(Ft.bootstrapOldFormat()), U[et] === !1 && o.warn(Ft.bootstrapInvalid());
    const Dt = {};
    return $.forEach((St) => {
      if (St !== W && St !== et) {
        let Et = { value: U[St] };
        ot && ot[St] ? Et = zt.extend(Et, ot[St]) : Et.version = 0, Dt[St] = Et;
      }
    }), Dt;
  }(c.bootstrap)), tt) {
    const U = tt.getInitialState();
    U ? X(U) : tt.on("init", X), tt.on("update", function($) {
      $.context && lt.setContext($.context), $.flags && xt($.flags);
    });
  } else
    (function() {
      return t ? te.processContext(e).then(mt).then((U) => (lt.setContext(U), typeof c.bootstrap == "object" ? wt() : P ? pt.loadFlags().then(($) => $ == null ? (I = {}, x.fetchFlagSettings(lt.getContext(), p).then((W) => xt(W || {})).then(wt).catch((W) => {
        jt(new Rr.LDFlagFetchError(Ft.errorFetchingFlags(W)));
      })) : (I = $, zt.onNextTick(wt), x.fetchFlagSettings(lt.getContext(), p).then((W) => xt(W)).catch((W) => s.maybeReportError(W)))) : x.fetchFlagSettings(lt.getContext(), p).then(($) => {
        I = $ || {}, Lt(), wt();
      }).catch(($) => {
        I = {}, jt($);
      }))) : Promise.reject(new Rr.LDInvalidEnvironmentIdError(Ft.environmentNotSpecified()));
    })().catch(jt);
  function X(U) {
    h = U.environment, lt.setContext(U.context), I = { ...U.flags }, zt.onNextTick(wt);
  }
  function wt() {
    o.info(Ft.clientInitialized()), Y = !0, ht(), u.signalSuccess();
  }
  function jt(U) {
    u.signalFailure(U);
  }
  return { client: { waitForInitialization: () => u.getInitializationPromise(), waitUntilReady: () => u.getReadyPromise(), identify: function(U, $, W) {
    if (H)
      return zt.wrapPromiseCallback(Promise.resolve({}), W);
    if (tt)
      return o.warn(Ft.identifyDisabled()), zt.wrapPromiseCallback(Promise.resolve(zt.transformVersionedValuesToValues(I)), W);
    const et = P && pt ? pt.clearFlags() : Promise.resolve();
    return zt.wrapPromiseCallback(et.then(() => te.processContext(U)).then(mt).then((ot) => x.fetchFlagSettings(ot, $).then((Dt) => {
      const St = zt.transformVersionedValuesToValues(Dt);
      return lt.setContext(ot), p = $, Dt ? xt(Dt).then(() => St) : St;
    })).then((ot) => (R && Qt(), ot)).catch((ot) => (s.maybeReportError(ot), Promise.reject(ot))), W);
  }, getContext: function() {
    return lt.getContext();
  }, variation: function(U, $) {
    return st(U, $, !0, !1, !1).value;
  }, variationDetail: function(U, $) {
    return st(U, $, !0, !0, !1);
  }, track: function(U, $, W) {
    if (typeof U != "string")
      return void s.maybeReportError(new Rr.LDInvalidEventKeyError(Ft.unknownCustomEventKey(U)));
    n.customEventFilter && !n.customEventFilter(U) && o.warn(Ft.unknownCustomEventKey(U));
    const et = lt.getContext(), ot = { kind: "custom", key: U, context: et, url: n.getCurrentUrl(), creationDate: (/* @__PURE__ */ new Date()).getTime() };
    et && et.anonymous && (ot.contextKind = et.anonymous ? "anonymousUser" : "user"), $ != null && (ot.data = $), W != null && (ot.metricValue = W), At(ot);
  }, on: function(U, $, W) {
    gt(U) ? (D = !0, Y && ht(), s.on(U, $, W)) : s.on(...arguments);
  }, off: function(U) {
    if (s.off(...arguments), gt(U)) {
      let $ = !1;
      s.getEvents().forEach((W) => {
        gt(W) && s.getEventListenerCount(W) > 0 && ($ = !0);
      }), $ || (D = !1, R && j === void 0 && Rt());
    }
  }, setStreaming: function(U) {
    const $ = U === null ? void 0 : U;
    $ !== j && (j = $, ht());
  }, flush: function(U) {
    return zt.wrapPromiseCallback(f ? T.flush() : Promise.resolve(), U);
  }, allFlags: function() {
    const U = {};
    if (!I)
      return U;
    for (const $ in I)
      zt.objectHasOwnProperty(I, $) && !I[$].deleted && (U[$] = st($, null, !c.sendEventsOnlyForVariation, !1, !0).value);
    return U;
  }, close: function(U) {
    if (H)
      return zt.wrapPromiseCallback(Promise.resolve(), U);
    const $ = () => {
      H = !0, I = {};
    }, W = Promise.resolve().then(() => {
      if (Rt(), S && S.stop(), f)
        return T.stop(), T.flush();
    }).then($).catch($);
    return zt.wrapPromiseCallback(W, U);
  } }, options: c, emitter: s, ident: lt, logger: o, requestor: x, start: function() {
    f && (S && S.start(), T.start());
  }, enqueueEvent: At, getFlagsInternal: function() {
    return I;
  }, getEnvironmentId: () => h, internalChangeEventName: Y1 };
}, commonBasicLogger: Q1, errors: Rr, messages: Ft, utils: zt, getContextKeys: Lk }, Bk = bO.initialize, $k = bO.errors;
function G1(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function W1(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? G1(Object(r), !0).forEach(function(n) {
      Kk(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : G1(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Kk(t, e, r) {
  return (e = function(n) {
    var i = function(o, s) {
      if (typeof o != "object" || o === null)
        return o;
      var u = o[Symbol.toPrimitive];
      if (u !== void 0) {
        var c = u.call(o, s || "default");
        if (typeof c != "object")
          return c;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (s === "string" ? String : Number)(o);
    }(n, "string");
    return typeof i == "symbol" ? i : String(i);
  }(e)) in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var H1 = { promise: Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null }) };
function Vk(t, e, r, n, i) {
  if (i && !function() {
    var a = window.navigator && window.navigator.userAgent;
    if (a) {
      var f = a.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (f)
        return parseInt(f[2], 10) < 73;
    }
    return !0;
  }())
    return H1;
  var o = new window.XMLHttpRequest();
  for (var s in o.open(t, e, !i), r || {})
    Object.prototype.hasOwnProperty.call(r, s) && o.setRequestHeader(s, r[s]);
  if (i)
    return o.send(n), H1;
  var u, c = new Promise(function(a, f) {
    o.addEventListener("load", function() {
      u || a({ status: o.status, header: function(h) {
        return o.getResponseHeader(h);
      }, body: o.responseText });
    }), o.addEventListener("error", function() {
      u || f(new Error());
    }), o.send(n);
  });
  return { promise: c, cancel: function() {
    u = !0, o.abort();
  } };
}
var Sv = (t) => {
  if (typeof t != "string")
    throw new TypeError("Expected a string");
  return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function Qk(t, e, r, n) {
  var i, o, s = ((t.kind === "substring" || t.kind === "regex") && n.includes("/") ? e : e.replace(n, "")).replace(r, "");
  switch (t.kind) {
    case "exact":
      o = e, i = new RegExp("^" + Sv(t.url) + "/?$");
      break;
    case "canonical":
      o = s, i = new RegExp("^" + Sv(t.url) + "/?$");
      break;
    case "substring":
      o = s, i = new RegExp(".*" + Sv(t.substring) + ".*$");
      break;
    case "regex":
      o = s, i = new RegExp(t.pattern);
      break;
    default:
      return !1;
  }
  return i.test(o);
}
function J1(t, e) {
  for (var r = {}, n = null, i = [], o = 0; o < t.length; o++)
    for (var s = t[o], u = s.urls || [], c = 0; c < u.length; c++)
      if (Qk(u[c], window.location.href, window.location.search, window.location.hash)) {
        s.kind === "pageview" ? e("pageview", s) : (i.push(s), e("click_pageview", s));
        break;
      }
  return i.length > 0 && (n = function(a) {
    for (var f = function(p, d) {
      for (var _ = [], m = 0; m < d.length; m++)
        for (var b = p.target, O = d[m], S = O.selector, k = document.querySelectorAll(S); b && k.length > 0; ) {
          for (var T = 0; T < k.length; T++)
            b === k[T] && _.push(O);
          b = b.parentNode;
        }
      return _;
    }(a, i), h = 0; h < f.length; h++)
      e("click", f[h]);
  }, document.addEventListener("click", n)), r.dispose = function() {
    document.removeEventListener("click", n);
  }, r;
}
var Yk = 300;
function Gk(t, e) {
  var r, n;
  function i() {
    n && n.dispose(), r && r.length && (n = J1(r, o));
  }
  function o(s, u) {
    var c = t.ident.getContext(), a = { kind: s, key: u.key, data: null, url: window.location.href, creationDate: (/* @__PURE__ */ new Date()).getTime(), context: c };
    return s === "click" && (a.selector = u.selector), t.enqueueEvent(a);
  }
  return t.requestor.fetchJSON("/sdk/goals/" + t.getEnvironmentId()).then(function(s) {
    s && s.length > 0 && (n = J1(r = s, o), function(u, c) {
      var a, f = window.location.href;
      function h() {
        (a = window.location.href) !== f && (f = a, c());
      }
      (function p(d, _) {
        d(), setTimeout(function() {
          p(d, _);
        }, _);
      })(h, u), window.history && window.history.pushState ? window.addEventListener("popstate", h) : window.addEventListener("hashchange", h);
    }(Yk, i)), e();
  }).catch(function(s) {
    t.emitter.maybeReportError(new $k.LDUnexpectedResponseError((s && s.message, s.message))), e();
  }), {};
}
var wh = "goalsReady", Wk = { fetchGoals: { default: !0 }, hash: { type: "string" }, eventProcessor: { type: "object" }, eventUrlTransformer: { type: "function" }, disableSyncEventPost: { default: !1 } };
function Hk(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = function(f) {
    var h, p = { userAgentHeaderName: "X-LaunchDarkly-User-Agent", synchronousFlush: !1 };
    if (window.XMLHttpRequest) {
      var d = f && f.disableSyncEventPost;
      p.httpRequest = function(O, S, k, T) {
        var x = p.synchronousFlush & !d;
        return p.synchronousFlush = !1, Vk(O, S, k, T, x);
      };
    }
    p.httpAllowsPost = function() {
      return h === void 0 && (h = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), h;
    }, p.httpFallbackPing = function(O) {
      new window.Image().src = O;
    };
    var _, m = f && f.eventUrlTransformer;
    p.getCurrentUrl = function() {
      return m ? m(window.location.href) : window.location.href;
    }, p.isDoNotTrack = function() {
      var O;
      return (O = window.navigator && window.navigator.doNotTrack !== void 0 ? window.navigator.doNotTrack : window.navigator && window.navigator.msDoNotTrack !== void 0 ? window.navigator.msDoNotTrack : window.doNotTrack) === 1 || O === !0 || O === "1" || O === "yes";
    };
    try {
      window.localStorage && (p.localStorage = { get: function(O) {
        return new Promise(function(S) {
          S(window.localStorage.getItem(O));
        });
      }, set: function(O, S) {
        return new Promise(function(k) {
          window.localStorage.setItem(O, S), k();
        });
      }, clear: function(O) {
        return new Promise(function(S) {
          window.localStorage.removeItem(O), S();
        });
      } });
    } catch {
      p.localStorage = null;
    }
    if (f && f.useReport && typeof window.EventSourcePolyfill == "function" && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (p.eventSourceAllowsReport = !0, _ = window.EventSourcePolyfill) : (p.eventSourceAllowsReport = !1, _ = window.EventSource), window.EventSource) {
      var b = 3e5;
      p.eventSourceFactory = function(O, S) {
        var k = W1(W1({}, { heartbeatTimeout: b, silentTimeout: b, skipDefaultHeaders: !0 }), S);
        return new _(O, k);
      }, p.eventSourceIsActive = function(O) {
        return O.readyState === window.EventSource.OPEN || O.readyState === window.EventSource.CONNECTING;
      };
    }
    return p.userAgent = "JSClient", p.version = "3.1.3", p.diagnosticSdkData = { name: "js-client-sdk", version: "3.1.3" }, p.diagnosticPlatformData = { name: "JS" }, p.diagnosticUseCombinedEvent = !0, p;
  }(r), i = Bk(t, e, r, n, Wk), o = i.client, s = i.options, u = i.emitter, c = new Promise(function(f) {
    var h = u.on(wh, function() {
      u.off(wh, h), f();
    });
  });
  o.waitUntilGoalsReady = function() {
    return c;
  }, s.fetchGoals ? Gk(i, function() {
    return u.emit(wh);
  }) : u.emit(wh), document.readyState !== "complete" ? window.addEventListener("load", i.start) : i.start();
  var a = function() {
    n.synchronousFlush = !0, o.flush().catch(function() {
    }), n.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && a();
  }), window.addEventListener("pagehide", a), o;
}
const Jk = (t, e) => (t = t == null ? void 0 : t.toLowerCase(), e ? (e = e == null ? void 0 : e.toLowerCase(), {
  kind: "user",
  key: `${t}_${e}`,
  name: `${t} (Hub ${e})`,
  email: t,
  HubName: e
}) : {
  kind: "user",
  key: t,
  name: t,
  email: t
}), Zk = ({ clientSideId: t, userEmail: e, hubName: r }) => {
  const n = GS(null);
  yp(() => {
    if (!(e && t))
      return;
    const c = Jk(e, r), a = Hk(t, c);
    return n.current = a, () => {
      (async () => {
        await a.close();
      })();
    };
  }, [t, r, e]), yp(() => {
    const c = async () => {
      var a;
      await ((a = n.current) == null ? void 0 : a.close());
    };
    return window.addEventListener("unload", c), () => {
      window.removeEventListener("unload", c);
    };
  }, []);
  const {
    data: i,
    error: o,
    refetch: s,
    status: u
  } = pO(
    ["LDK.waitForInitialization", t, e, r],
    async () => n.current ? (await n.current.waitForInitialization(), !0) : !1,
    {
      enabled: !!t && !!e,
      context: $_
    }
  );
  return {
    client: n.current,
    error: o,
    status: u,
    isInitialized: i === !0,
    retry: async () => {
      await s();
    }
  };
}, wO = (t, e) => e ?? !1, ip = Se.createContext({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  checkFlag: wO
}), I9 = dO(
  ({
    clientSideId: t,
    userEmail: e,
    hubName: r,
    loadingComponent: n,
    errorComponent: i,
    children: o
  }) => {
    const { client: s, error: u, status: c, isInitialized: a, retry: f } = Zk({
      clientSideId: t,
      userEmail: e,
      hubName: r
    });
    s && a || f();
    const h = Zo(
      () => ({
        isInitialized: a,
        isLoading: c === "loading",
        error: u ?? void 0,
        retry: f,
        checkFlag: a && s ? (p, d) => s.variation(p, d) ?? !1 : wO
      }),
      [s, u, a, f, c]
    );
    return c === "loading" && n ? /* @__PURE__ */ Ce.jsx(ip.Provider, { value: h, children: n }) : c === "error" && i ? /* @__PURE__ */ Ce.jsx(ip.Provider, { value: h, children: i }) : /* @__PURE__ */ Ce.jsx(ip.Provider, { value: h, children: o });
  },
  "LaunchDarklyProvider"
);
function A9() {
  const { isInitialized: t, isLoading: e, error: r, retry: n, checkFlag: i } = ca(ip), o = go(
    (s, u) => i(s, u),
    [i]
  );
  return {
    isInitialized: t,
    isLoading: e,
    error: r,
    retry: n,
    hasFeature: o
  };
}
var Ml = "delete", ze = 5, $i = 1 << ze, jn = $i - 1, le = {};
function Dy() {
  return { value: !1 };
}
function Ki(t) {
  t && (t.value = !0);
}
function G_() {
}
function Vu(t) {
  return t.size === void 0 && (t.size = t.__iterate(EO)), t.size;
}
function Pa(t, e) {
  if (typeof e != "number") {
    var r = e >>> 0;
    if ("" + r !== e || r === 4294967295)
      return NaN;
    e = r;
  }
  return e < 0 ? Vu(t) + e : e;
}
function EO() {
  return !0;
}
function Hp(t, e, r) {
  return (t === 0 && !OO(t) || r !== void 0 && t <= -r) && (e === void 0 || r !== void 0 && e >= r);
}
function Fl(t, e) {
  return SO(t, e, 0);
}
function Jp(t, e) {
  return SO(t, e, e);
}
function SO(t, e, r) {
  return t === void 0 ? r : OO(t) ? e === 1 / 0 ? e : Math.max(0, e + t) | 0 : e === void 0 || e === t ? t : Math.min(e, t) | 0;
}
function OO(t) {
  return t < 0 || t === 0 && 1 / t === -1 / 0;
}
var IO = "@@__IMMUTABLE_ITERABLE__@@";
function ai(t) {
  return !!(t && t[IO]);
}
var AO = "@@__IMMUTABLE_KEYED__@@";
function hr(t) {
  return !!(t && t[AO]);
}
var DO = "@@__IMMUTABLE_INDEXED__@@";
function ri(t) {
  return !!(t && t[DO]);
}
function Zp(t) {
  return hr(t) || ri(t);
}
var Sr = function(e) {
  return ai(e) ? e : Di(e);
}, co = /* @__PURE__ */ function(t) {
  function e(r) {
    return hr(r) ? r : Ua(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Sr), fu = /* @__PURE__ */ function(t) {
  function e(r) {
    return ri(r) ? r : qo(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Sr), Ac = /* @__PURE__ */ function(t) {
  function e(r) {
    return ai(r) && !Zp(r) ? r : Tc(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Sr);
Sr.Keyed = co;
Sr.Indexed = fu;
Sr.Set = Ac;
var RO = "@@__IMMUTABLE_SEQ__@@";
function W_(t) {
  return !!(t && t[RO]);
}
var xO = "@@__IMMUTABLE_RECORD__@@";
function Dc(t) {
  return !!(t && t[xO]);
}
function Xo(t) {
  return ai(t) || Dc(t);
}
var Rc = "@@__IMMUTABLE_ORDERED__@@";
function Io(t) {
  return !!(t && t[Rc]);
}
var Nl = 0, To = 1, io = 2, Ry = typeof Symbol == "function" && Symbol.iterator, TO = "@@iterator", Xp = Ry || TO, me = function(e) {
  this.next = e;
};
me.prototype.toString = function() {
  return "[Iterator]";
};
me.KEYS = Nl;
me.VALUES = To;
me.ENTRIES = io;
me.prototype.inspect = me.prototype.toSource = function() {
  return this.toString();
};
me.prototype[Xp] = function() {
  return this;
};
function _r(t, e, r, n) {
  var i = t === 0 ? e : t === 1 ? r : [e, r];
  return n ? n.value = i : n = {
    value: i,
    done: !1
  }, n;
}
function ui() {
  return { value: void 0, done: !0 };
}
function PO(t) {
  return Array.isArray(t) ? !0 : !!td(t);
}
function Z1(t) {
  return t && typeof t.next == "function";
}
function xy(t) {
  var e = td(t);
  return e && e.call(t);
}
function td(t) {
  var e = t && (Ry && t[Ry] || t[TO]);
  if (typeof e == "function")
    return e;
}
function Xk(t) {
  var e = td(t);
  return e && e === t.entries;
}
function t2(t) {
  var e = td(t);
  return e && e === t.keys;
}
var xc = Object.prototype.hasOwnProperty;
function kO(t) {
  return Array.isArray(t) || typeof t == "string" ? !0 : t && typeof t == "object" && Number.isInteger(t.length) && t.length >= 0 && (t.length === 0 ? (
    // Only {length: 0} is considered Array-like.
    Object.keys(t).length === 1
  ) : (
    // An object is only Array-like if it has a property where the last value
    // in the array-like may be found (which could be undefined).
    t.hasOwnProperty(t.length - 1)
  ));
}
var Di = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? J_() : Xo(r) ? r.toSeq() : r2(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, e.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, e.prototype.__iterate = function(n, i) {
    var o = this._cache;
    if (o) {
      for (var s = o.length, u = 0; u !== s; ) {
        var c = o[i ? s - ++u : u++];
        if (n(c[1], c[0], this) === !1)
          break;
      }
      return u;
    }
    return this.__iterateUncached(n, i);
  }, e.prototype.__iterator = function(n, i) {
    var o = this._cache;
    if (o) {
      var s = o.length, u = 0;
      return new me(function() {
        if (u === s)
          return ui();
        var c = o[i ? s - ++u : u++];
        return _r(n, c[0], c[1]);
      });
    }
    return this.__iteratorUncached(n, i);
  }, e;
}(Sr), Ua = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? J_().toKeyedSeq() : ai(r) ? hr(r) ? r.toSeq() : r.fromEntrySeq() : Dc(r) ? r.toSeq() : Z_(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toKeyedSeq = function() {
    return this;
  }, e;
}(Di), qo = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? J_() : ai(r) ? hr(r) ? r.entrySeq() : r.toIndexedSeq() : Dc(r) ? r.toSeq().entrySeq() : CO(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toIndexedSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, e;
}(Di), Tc = /* @__PURE__ */ function(t) {
  function e(r) {
    return (ai(r) && !Zp(r) ? r : qo(r)).toSetSeq();
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toSetSeq = function() {
    return this;
  }, e;
}(Di);
Di.isSeq = W_;
Di.Keyed = Ua;
Di.Set = Tc;
Di.Indexed = qo;
Di.prototype[RO] = !0;
var iu = /* @__PURE__ */ function(t) {
  function e(r) {
    this._array = r, this.size = r.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(n, i) {
    return this.has(n) ? this._array[Pa(this, n)] : i;
  }, e.prototype.__iterate = function(n, i) {
    for (var o = this._array, s = o.length, u = 0; u !== s; ) {
      var c = i ? s - ++u : u++;
      if (n(o[c], c, this) === !1)
        break;
    }
    return u;
  }, e.prototype.__iterator = function(n, i) {
    var o = this._array, s = o.length, u = 0;
    return new me(function() {
      if (u === s)
        return ui();
      var c = i ? s - ++u : u++;
      return _r(n, c, o[c]);
    });
  }, e;
}(qo), H_ = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = Object.keys(r).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(r) : []
    );
    this._object = r, this._keys = n, this.size = n.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(n, i) {
    return i !== void 0 && !this.has(n) ? i : this._object[n];
  }, e.prototype.has = function(n) {
    return xc.call(this._object, n);
  }, e.prototype.__iterate = function(n, i) {
    for (var o = this._object, s = this._keys, u = s.length, c = 0; c !== u; ) {
      var a = s[i ? u - ++c : c++];
      if (n(o[a], a, this) === !1)
        break;
    }
    return c;
  }, e.prototype.__iterator = function(n, i) {
    var o = this._object, s = this._keys, u = s.length, c = 0;
    return new me(function() {
      if (c === u)
        return ui();
      var a = s[i ? u - ++c : c++];
      return _r(n, a, o[a]);
    });
  }, e;
}(Ua);
H_.prototype[Rc] = !0;
var e2 = /* @__PURE__ */ function(t) {
  function e(r) {
    this._collection = r, this.size = r.length || r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.__iterateUncached = function(n, i) {
    if (i)
      return this.cacheResult().__iterate(n, i);
    var o = this._collection, s = xy(o), u = 0;
    if (Z1(s))
      for (var c; !(c = s.next()).done && n(c.value, u++, this) !== !1; )
        ;
    return u;
  }, e.prototype.__iteratorUncached = function(n, i) {
    if (i)
      return this.cacheResult().__iterator(n, i);
    var o = this._collection, s = xy(o);
    if (!Z1(s))
      return new me(ui);
    var u = 0;
    return new me(function() {
      var c = s.next();
      return c.done ? c : _r(n, u++, c.value);
    });
  }, e;
}(qo), X1;
function J_() {
  return X1 || (X1 = new iu([]));
}
function Z_(t) {
  var e = X_(t);
  if (e)
    return e.fromEntrySeq();
  if (typeof t == "object")
    return new H_(t);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + t
  );
}
function CO(t) {
  var e = X_(t);
  if (e)
    return e;
  throw new TypeError(
    "Expected Array or collection object of values: " + t
  );
}
function r2(t) {
  var e = X_(t);
  if (e)
    return Xk(t) ? e.fromEntrySeq() : t2(t) ? e.toSetSeq() : e;
  if (typeof t == "object")
    return new H_(t);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + t
  );
}
function X_(t) {
  return kO(t) ? new iu(t) : PO(t) ? new e2(t) : void 0;
}
var jO = "@@__IMMUTABLE_MAP__@@";
function t0(t) {
  return !!(t && t[jO]);
}
function qO(t) {
  return t0(t) && Io(t);
}
function tb(t) {
  return !!(t && typeof t.equals == "function" && typeof t.hashCode == "function");
}
function Ei(t, e) {
  if (t === e || t !== t && e !== e)
    return !0;
  if (!t || !e)
    return !1;
  if (typeof t.valueOf == "function" && typeof e.valueOf == "function") {
    if (t = t.valueOf(), e = e.valueOf(), t === e || t !== t && e !== e)
      return !0;
    if (!t || !e)
      return !1;
  }
  return !!(tb(t) && tb(e) && t.equals(e));
}
var _f = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(e, r) {
  e |= 0, r |= 0;
  var n = e & 65535, i = r & 65535;
  return n * i + ((e >>> 16) * i + n * (r >>> 16) << 16 >>> 0) | 0;
};
function ed(t) {
  return t >>> 1 & 1073741824 | t & 3221225471;
}
var n2 = Object.prototype.valueOf;
function _i(t) {
  if (t == null)
    return eb(t);
  if (typeof t.hashCode == "function")
    return ed(t.hashCode(t));
  var e = c2(t);
  if (e == null)
    return eb(e);
  switch (typeof e) {
    case "boolean":
      return e ? 1108378657 : 1108378656;
    case "number":
      return i2(e);
    case "string":
      return e.length > f2 ? o2(e) : Ty(e);
    case "object":
    case "function":
      return a2(e);
    case "symbol":
      return s2(e);
    default:
      if (typeof e.toString == "function")
        return Ty(e.toString());
      throw new Error("Value type " + typeof e + " cannot be hashed.");
  }
}
function eb(t) {
  return t === null ? 1108378658 : (
    /* undefined */
    1108378659
  );
}
function i2(t) {
  if (t !== t || t === 1 / 0)
    return 0;
  var e = t | 0;
  for (e !== t && (e ^= t * 4294967295); t > 4294967295; )
    t /= 4294967295, e ^= t;
  return ed(e);
}
function o2(t) {
  var e = Av[t];
  return e === void 0 && (e = Ty(t), Iv === l2 && (Iv = 0, Av = {}), Iv++, Av[t] = e), e;
}
function Ty(t) {
  for (var e = 0, r = 0; r < t.length; r++)
    e = 31 * e + t.charCodeAt(r) | 0;
  return ed(e);
}
function s2(t) {
  var e = ib[t];
  return e !== void 0 || (e = MO(), ib[t] = e), e;
}
function a2(t) {
  var e;
  if (Py && (e = ky.get(t), e !== void 0) || (e = t[Ga], e !== void 0) || !nb && (e = t.propertyIsEnumerable && t.propertyIsEnumerable[Ga], e !== void 0 || (e = u2(t), e !== void 0)))
    return e;
  if (e = MO(), Py)
    ky.set(t, e);
  else {
    if (rb !== void 0 && rb(t) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (nb)
      Object.defineProperty(t, Ga, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: e
      });
    else if (t.propertyIsEnumerable !== void 0 && t.propertyIsEnumerable === t.constructor.prototype.propertyIsEnumerable)
      t.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, t.propertyIsEnumerable[Ga] = e;
    else if (t.nodeType !== void 0)
      t[Ga] = e;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return e;
}
var rb = Object.isExtensible, nb = function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
}();
function u2(t) {
  if (t && t.nodeType > 0)
    switch (t.nodeType) {
      case 1:
        return t.uniqueID;
      case 9:
        return t.documentElement && t.documentElement.uniqueID;
    }
}
function c2(t) {
  return t.valueOf !== n2 && typeof t.valueOf == "function" ? t.valueOf(t) : t;
}
function MO() {
  var t = ++Ov;
  return Ov & 1073741824 && (Ov = 0), t;
}
var Py = typeof WeakMap == "function", ky;
Py && (ky = /* @__PURE__ */ new WeakMap());
var ib = /* @__PURE__ */ Object.create(null), Ov = 0, Ga = "__immutablehash__";
typeof Symbol == "function" && (Ga = Symbol(Ga));
var f2 = 16, l2 = 255, Iv = 0, Av = {}, rd = /* @__PURE__ */ function(t) {
  function e(r, n) {
    this._iter = r, this._useKeys = n, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(n, i) {
    return this._iter.get(n, i);
  }, e.prototype.has = function(n) {
    return this._iter.has(n);
  }, e.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, e.prototype.reverse = function() {
    var n = this, i = e0(this, !0);
    return this._useKeys || (i.valueSeq = function() {
      return n._iter.toSeq().reverse();
    }), i;
  }, e.prototype.map = function(n, i) {
    var o = this, s = UO(this, n, i);
    return this._useKeys || (s.valueSeq = function() {
      return o._iter.toSeq().map(n, i);
    }), s;
  }, e.prototype.__iterate = function(n, i) {
    var o = this;
    return this._iter.__iterate(function(s, u) {
      return n(s, u, o);
    }, i);
  }, e.prototype.__iterator = function(n, i) {
    return this._iter.__iterator(n, i);
  }, e;
}(Ua);
rd.prototype[Rc] = !0;
var FO = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.includes = function(n) {
    return this._iter.includes(n);
  }, e.prototype.__iterate = function(n, i) {
    var o = this, s = 0;
    return i && Vu(this), this._iter.__iterate(
      function(u) {
        return n(u, i ? o.size - ++s : s++, o);
      },
      i
    );
  }, e.prototype.__iterator = function(n, i) {
    var o = this, s = this._iter.__iterator(To, i), u = 0;
    return i && Vu(this), new me(function() {
      var c = s.next();
      return c.done ? c : _r(
        n,
        i ? o.size - ++u : u++,
        c.value,
        c
      );
    });
  }, e;
}(qo), NO = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.has = function(n) {
    return this._iter.includes(n);
  }, e.prototype.__iterate = function(n, i) {
    var o = this;
    return this._iter.__iterate(function(s) {
      return n(s, s, o);
    }, i);
  }, e.prototype.__iterator = function(n, i) {
    var o = this._iter.__iterator(To, i);
    return new me(function() {
      var s = o.next();
      return s.done ? s : _r(n, s.value, s.value, s);
    });
  }, e;
}(Tc), zO = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, e.prototype.__iterate = function(n, i) {
    var o = this;
    return this._iter.__iterate(function(s) {
      if (s) {
        sb(s);
        var u = ai(s);
        return n(
          u ? s.get(1) : s[1],
          u ? s.get(0) : s[0],
          o
        );
      }
    }, i);
  }, e.prototype.__iterator = function(n, i) {
    var o = this._iter.__iterator(To, i);
    return new me(function() {
      for (; ; ) {
        var s = o.next();
        if (s.done)
          return s;
        var u = s.value;
        if (u) {
          sb(u);
          var c = ai(u);
          return _r(
            n,
            c ? u.get(0) : u[0],
            c ? u.get(1) : u[1],
            s
          );
        }
      }
    });
  }, e;
}(Ua);
FO.prototype.cacheResult = rd.prototype.cacheResult = NO.prototype.cacheResult = zO.prototype.cacheResult = i0;
function LO(t) {
  var e = ts(t);
  return e._iter = t, e.size = t.size, e.flip = function() {
    return t;
  }, e.reverse = function() {
    var r = t.reverse.apply(this);
    return r.flip = function() {
      return t.reverse();
    }, r;
  }, e.has = function(r) {
    return t.includes(r);
  }, e.includes = function(r) {
    return t.has(r);
  }, e.cacheResult = i0, e.__iterateUncached = function(r, n) {
    var i = this;
    return t.__iterate(function(o, s) {
      return r(s, o, i) !== !1;
    }, n);
  }, e.__iteratorUncached = function(r, n) {
    if (r === io) {
      var i = t.__iterator(r, n);
      return new me(function() {
        var o = i.next();
        if (!o.done) {
          var s = o.value[0];
          o.value[0] = o.value[1], o.value[1] = s;
        }
        return o;
      });
    }
    return t.__iterator(
      r === To ? Nl : To,
      n
    );
  }, e;
}
function UO(t, e, r) {
  var n = ts(t);
  return n.size = t.size, n.has = function(i) {
    return t.has(i);
  }, n.get = function(i, o) {
    var s = t.get(i, le);
    return s === le ? o : e.call(r, s, i, t);
  }, n.__iterateUncached = function(i, o) {
    var s = this;
    return t.__iterate(
      function(u, c, a) {
        return i(e.call(r, u, c, a), c, s) !== !1;
      },
      o
    );
  }, n.__iteratorUncached = function(i, o) {
    var s = t.__iterator(io, o);
    return new me(function() {
      var u = s.next();
      if (u.done)
        return u;
      var c = u.value, a = c[0];
      return _r(
        i,
        a,
        e.call(r, c[1], a, t),
        u
      );
    });
  }, n;
}
function e0(t, e) {
  var r = this, n = ts(t);
  return n._iter = t, n.size = t.size, n.reverse = function() {
    return t;
  }, t.flip && (n.flip = function() {
    var i = LO(t);
    return i.reverse = function() {
      return t.flip();
    }, i;
  }), n.get = function(i, o) {
    return t.get(e ? i : -1 - i, o);
  }, n.has = function(i) {
    return t.has(e ? i : -1 - i);
  }, n.includes = function(i) {
    return t.includes(i);
  }, n.cacheResult = i0, n.__iterate = function(i, o) {
    var s = this, u = 0;
    return o && Vu(t), t.__iterate(
      function(c, a) {
        return i(c, e ? a : o ? s.size - ++u : u++, s);
      },
      !o
    );
  }, n.__iterator = function(i, o) {
    var s = 0;
    o && Vu(t);
    var u = t.__iterator(io, !o);
    return new me(function() {
      var c = u.next();
      if (c.done)
        return c;
      var a = c.value;
      return _r(
        i,
        e ? a[0] : o ? r.size - ++s : s++,
        a[1],
        c
      );
    });
  }, n;
}
function BO(t, e, r, n) {
  var i = ts(t);
  return n && (i.has = function(o) {
    var s = t.get(o, le);
    return s !== le && !!e.call(r, s, o, t);
  }, i.get = function(o, s) {
    var u = t.get(o, le);
    return u !== le && e.call(r, u, o, t) ? u : s;
  }), i.__iterateUncached = function(o, s) {
    var u = this, c = 0;
    return t.__iterate(function(a, f, h) {
      if (e.call(r, a, f, h))
        return c++, o(a, n ? f : c - 1, u);
    }, s), c;
  }, i.__iteratorUncached = function(o, s) {
    var u = t.__iterator(io, s), c = 0;
    return new me(function() {
      for (; ; ) {
        var a = u.next();
        if (a.done)
          return a;
        var f = a.value, h = f[0], p = f[1];
        if (e.call(r, p, h, t))
          return _r(o, n ? h : c++, p, a);
      }
    });
  }, i;
}
function h2(t, e, r) {
  var n = kc().asMutable();
  return t.__iterate(function(i, o) {
    n.update(e.call(r, i, o, t), 0, function(s) {
      return s + 1;
    });
  }), n.asImmutable();
}
function p2(t, e, r) {
  var n = hr(t), i = (Io(t) ? ta() : kc()).asMutable();
  t.__iterate(function(s, u) {
    i.update(
      e.call(r, s, u, t),
      function(c) {
        return c = c || [], c.push(n ? [u, s] : s), c;
      }
    );
  });
  var o = n0(t);
  return i.map(function(s) {
    return Re(t, o(s));
  }).asImmutable();
}
function d2(t, e, r) {
  var n = hr(t), i = [[], []];
  t.__iterate(function(s, u) {
    i[e.call(r, s, u, t) ? 1 : 0].push(
      n ? [u, s] : s
    );
  });
  var o = n0(t);
  return i.map(function(s) {
    return Re(t, o(s));
  });
}
function r0(t, e, r, n) {
  var i = t.size;
  if (Hp(e, r, i))
    return t;
  var o = Fl(e, i), s = Jp(r, i);
  if (o !== o || s !== s)
    return r0(t.toSeq().cacheResult(), e, r, n);
  var u = s - o, c;
  u === u && (c = u < 0 ? 0 : u);
  var a = ts(t);
  return a.size = c === 0 ? c : t.size && c || void 0, !n && W_(t) && c >= 0 && (a.get = function(f, h) {
    return f = Pa(this, f), f >= 0 && f < c ? t.get(f + o, h) : h;
  }), a.__iterateUncached = function(f, h) {
    var p = this;
    if (c === 0)
      return 0;
    if (h)
      return this.cacheResult().__iterate(f, h);
    var d = 0, _ = !0, m = 0;
    return t.__iterate(function(b, O) {
      if (!(_ && (_ = d++ < o)))
        return m++, f(b, n ? O : m - 1, p) !== !1 && m !== c;
    }), m;
  }, a.__iteratorUncached = function(f, h) {
    if (c !== 0 && h)
      return this.cacheResult().__iterator(f, h);
    if (c === 0)
      return new me(ui);
    var p = t.__iterator(f, h), d = 0, _ = 0;
    return new me(function() {
      for (; d++ < o; )
        p.next();
      if (++_ > c)
        return ui();
      var m = p.next();
      return n || f === To || m.done ? m : f === Nl ? _r(f, _ - 1, void 0, m) : _r(f, _ - 1, m.value[1], m);
    });
  }, a;
}
function v2(t, e, r) {
  var n = ts(t);
  return n.__iterateUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterate(i, o);
    var u = 0;
    return t.__iterate(
      function(c, a, f) {
        return e.call(r, c, a, f) && ++u && i(c, a, s);
      }
    ), u;
  }, n.__iteratorUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterator(i, o);
    var u = t.__iterator(io, o), c = !0;
    return new me(function() {
      if (!c)
        return ui();
      var a = u.next();
      if (a.done)
        return a;
      var f = a.value, h = f[0], p = f[1];
      return e.call(r, p, h, s) ? i === io ? a : _r(i, h, p, a) : (c = !1, ui());
    });
  }, n;
}
function $O(t, e, r, n) {
  var i = ts(t);
  return i.__iterateUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterate(o, s);
    var c = !0, a = 0;
    return t.__iterate(function(f, h, p) {
      if (!(c && (c = e.call(r, f, h, p))))
        return a++, o(f, n ? h : a - 1, u);
    }), a;
  }, i.__iteratorUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterator(o, s);
    var c = t.__iterator(io, s), a = !0, f = 0;
    return new me(function() {
      var h, p, d;
      do {
        if (h = c.next(), h.done)
          return n || o === To ? h : o === Nl ? _r(o, f++, void 0, h) : _r(o, f++, h.value[1], h);
        var _ = h.value;
        p = _[0], d = _[1], a && (a = e.call(r, d, p, u));
      } while (a);
      return o === io ? h : _r(o, p, d, h);
    });
  }, i;
}
function y2(t, e) {
  var r = hr(t), n = [t].concat(e).map(function(s) {
    return ai(s) ? r && (s = co(s)) : s = r ? Z_(s) : CO(Array.isArray(s) ? s : [s]), s;
  }).filter(function(s) {
    return s.size !== 0;
  });
  if (n.length === 0)
    return t;
  if (n.length === 1) {
    var i = n[0];
    if (i === t || r && hr(i) || ri(t) && ri(i))
      return i;
  }
  var o = new iu(n);
  return r ? o = o.toKeyedSeq() : ri(t) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = n.reduce(function(s, u) {
    if (s !== void 0) {
      var c = u.size;
      if (c !== void 0)
        return s + c;
    }
  }, 0), o;
}
function KO(t, e, r) {
  var n = ts(t);
  return n.__iterateUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterate(i, o);
    var s = 0, u = !1;
    function c(a, f) {
      a.__iterate(function(h, p) {
        return (!e || f < e) && ai(h) ? c(h, f + 1) : (s++, i(h, r ? p : s - 1, n) === !1 && (u = !0)), !u;
      }, o);
    }
    return c(t, 0), s;
  }, n.__iteratorUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterator(i, o);
    var s = t.__iterator(i, o), u = [], c = 0;
    return new me(function() {
      for (; s; ) {
        var a = s.next();
        if (a.done !== !1) {
          s = u.pop();
          continue;
        }
        var f = a.value;
        if (i === io && (f = f[1]), (!e || u.length < e) && ai(f))
          u.push(s), s = f.__iterator(i, o);
        else
          return r ? a : _r(i, c++, f, a);
      }
      return ui();
    });
  }, n;
}
function _2(t, e, r) {
  var n = n0(t);
  return t.toSeq().map(function(i, o) {
    return n(e.call(r, i, o, t));
  }).flatten(!0);
}
function m2(t, e) {
  var r = ts(t);
  return r.size = t.size && t.size * 2 - 1, r.__iterateUncached = function(n, i) {
    var o = this, s = 0;
    return t.__iterate(
      function(u) {
        return (!s || n(e, s++, o) !== !1) && n(u, s++, o) !== !1;
      },
      i
    ), s;
  }, r.__iteratorUncached = function(n, i) {
    var o = t.__iterator(To, i), s = 0, u;
    return new me(function() {
      return (!u || s % 2) && (u = o.next(), u.done) ? u : s % 2 ? _r(n, s++, e) : _r(n, s++, u.value, u);
    });
  }, r;
}
function Qu(t, e, r) {
  e || (e = VO);
  var n = hr(t), i = 0, o = t.toSeq().map(function(s, u) {
    return [u, s, i++, r ? r(s, u, t) : s];
  }).valueSeq().toArray();
  return o.sort(function(s, u) {
    return e(s[3], u[3]) || s[2] - u[2];
  }).forEach(
    n ? function(s, u) {
      o[u].length = 2;
    } : function(s, u) {
      o[u] = s[1];
    }
  ), n ? Ua(o) : ri(t) ? qo(o) : Tc(o);
}
function Eh(t, e, r) {
  if (e || (e = VO), r) {
    var n = t.toSeq().map(function(i, o) {
      return [i, r(i, o, t)];
    }).reduce(function(i, o) {
      return ob(e, i[1], o[1]) ? o : i;
    });
    return n && n[0];
  }
  return t.reduce(function(i, o) {
    return ob(e, i, o) ? o : i;
  });
}
function ob(t, e, r) {
  var n = t(r, e);
  return n === 0 && r !== e && (r == null || r !== r) || n > 0;
}
function Sh(t, e, r, n) {
  var i = ts(t), o = new iu(r).map(function(s) {
    return s.size;
  });
  return i.size = n ? o.max() : o.min(), i.__iterate = function(s, u) {
    for (var c = this.__iterator(To, u), a, f = 0; !(a = c.next()).done && s(a.value, f++, this) !== !1; )
      ;
    return f;
  }, i.__iteratorUncached = function(s, u) {
    var c = r.map(
      function(h) {
        return h = Sr(h), xy(u ? h.reverse() : h);
      }
    ), a = 0, f = !1;
    return new me(function() {
      var h;
      return f || (h = c.map(function(p) {
        return p.next();
      }), f = n ? h.every(function(p) {
        return p.done;
      }) : h.some(function(p) {
        return p.done;
      })), f ? ui() : _r(
        s,
        a++,
        e.apply(
          null,
          h.map(function(p) {
            return p.value;
          })
        )
      );
    });
  }, i;
}
function Re(t, e) {
  return t === e ? t : W_(t) ? e : t.constructor(e);
}
function sb(t) {
  if (t !== Object(t))
    throw new TypeError("Expected [K, V] tuple: " + t);
}
function n0(t) {
  return hr(t) ? co : ri(t) ? fu : Ac;
}
function ts(t) {
  return Object.create(
    (hr(t) ? Ua : ri(t) ? qo : Tc).prototype
  );
}
function i0() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : Di.prototype.cacheResult.call(this);
}
function VO(t, e) {
  return t === void 0 && e === void 0 ? 0 : t === void 0 ? 1 : e === void 0 ? -1 : t > e ? 1 : t < e ? -1 : 0;
}
function Vo(t, e) {
  e = e || 0;
  for (var r = Math.max(0, t.length - e), n = new Array(r), i = 0; i < r; i++)
    n[i] = t[i + e];
  return n;
}
function o0(t, e) {
  if (!t)
    throw new Error(e);
}
function Vi(t) {
  o0(
    t !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function QO(t) {
  if (kO(t) && typeof t != "string")
    return t;
  if (Io(t))
    return t.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + t
  );
}
var g2 = Object.prototype.toString;
function b2(t) {
  if (!t || typeof t != "object" || g2.call(t) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(t);
  if (e === null)
    return !0;
  for (var r = e, n = Object.getPrototypeOf(e); n !== null; )
    r = n, n = Object.getPrototypeOf(r);
  return r === e;
}
function ka(t) {
  return typeof t == "object" && (Xo(t) || Array.isArray(t) || b2(t));
}
function tl(t) {
  try {
    return typeof t == "string" ? JSON.stringify(t) : String(t);
  } catch {
    return JSON.stringify(t);
  }
}
function w2(t, e) {
  return Xo(t) ? t.has(e) : ka(t) && xc.call(t, e);
}
function YO(t, e, r) {
  return Xo(t) ? t.get(e, r) : w2(t, e) ? typeof t.get == "function" ? t.get(e) : t[e] : r;
}
function Ep(t) {
  if (Array.isArray(t))
    return Vo(t);
  var e = {};
  for (var r in t)
    xc.call(t, r) && (e[r] = t[r]);
  return e;
}
function E2(t, e) {
  if (!ka(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (Xo(t)) {
    if (!t.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + t
      );
    return t.remove(e);
  }
  if (!xc.call(t, e))
    return t;
  var r = Ep(t);
  return Array.isArray(r) ? r.splice(e, 1) : delete r[e], r;
}
function S2(t, e, r) {
  if (!ka(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (Xo(t)) {
    if (!t.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + t
      );
    return t.set(e, r);
  }
  if (xc.call(t, e) && r === t[e])
    return t;
  var n = Ep(t);
  return n[e] = r, n;
}
function Pc(t, e, r, n) {
  n || (n = r, r = void 0);
  var i = GO(
    Xo(t),
    t,
    QO(e),
    0,
    r,
    n
  );
  return i === le ? r : i;
}
function GO(t, e, r, n, i, o) {
  var s = e === le;
  if (n === r.length) {
    var u = s ? i : e, c = o(u);
    return c === u ? e : c;
  }
  if (!s && !ka(e))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + r.slice(0, n).map(tl) + "]: " + e
    );
  var a = r[n], f = s ? le : YO(e, a, le), h = GO(
    f === le ? t : Xo(f),
    f,
    r,
    n + 1,
    i,
    o
  );
  return h === f ? e : h === le ? E2(e, a) : S2(
    s ? t ? bo() : {} : e,
    a,
    h
  );
}
function O2(t, e, r) {
  return Pc(t, e, le, function() {
    return r;
  });
}
function s0(t, e) {
  return O2(this, t, e);
}
function I2(t, e) {
  return Pc(t, e, function() {
    return le;
  });
}
function a0(t) {
  return I2(this, t);
}
function WO(t, e, r, n) {
  return Pc(t, [e], r, n);
}
function u0(t, e, r) {
  return arguments.length === 1 ? t(this) : WO(this, t, e, r);
}
function c0(t, e, r) {
  return Pc(this, t, e, r);
}
function HO() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return ZO(this, t);
}
function JO(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  if (typeof t != "function")
    throw new TypeError("Invalid merger function: " + t);
  return ZO(this, e, t);
}
function ZO(t, e, r) {
  for (var n = [], i = 0; i < e.length; i++) {
    var o = co(e[i]);
    o.size !== 0 && n.push(o);
  }
  return n.length === 0 ? t : t.toSeq().size === 0 && !t.__ownerID && n.length === 1 ? t.constructor(n[0]) : t.withMutations(function(s) {
    for (var u = r ? function(a, f) {
      WO(
        s,
        f,
        le,
        function(h) {
          return h === le ? a : r(h, a, f);
        }
      );
    } : function(a, f) {
      s.set(f, a);
    }, c = 0; c < n.length; c++)
      n[c].forEach(u);
  });
}
function f0(t, e, r) {
  return l0(t, e, A2(r));
}
function l0(t, e, r) {
  if (!ka(t))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + t
    );
  if (Xo(t))
    return typeof r == "function" && t.mergeWith ? t.mergeWith.apply(t, [r].concat(e)) : t.merge ? t.merge.apply(t, e) : t.concat.apply(t, e);
  for (var n = Array.isArray(t), i = t, o = n ? fu : co, s = n ? function(c) {
    i === t && (i = Ep(i)), i.push(c);
  } : function(c, a) {
    var f = xc.call(i, a), h = f && r ? r(i[a], c, a) : c;
    (!f || h !== i[a]) && (i === t && (i = Ep(i)), i[a] = h);
  }, u = 0; u < e.length; u++)
    o(e[u]).forEach(s);
  return i;
}
function A2(t) {
  function e(r, n, i) {
    return ka(r) && ka(n) && D2(r, n) ? l0(r, [n], e) : t ? t(r, n, i) : n;
  }
  return e;
}
function D2(t, e) {
  var r = Di(t), n = Di(e);
  return ri(r) === ri(n) && hr(r) === hr(n);
}
function XO() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return f0(this, t);
}
function tI(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return f0(this, e, t);
}
function h0(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return Pc(this, t, bo(), function(n) {
    return l0(n, e);
  });
}
function p0(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return Pc(
    this,
    t,
    bo(),
    function(n) {
      return f0(n, e);
    }
  );
}
function zl(t) {
  var e = this.asMutable();
  return t(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
}
function Ll() {
  return this.__ownerID ? this : this.__ensureOwner(new G_());
}
function Ul() {
  return this.__ensureOwner();
}
function d0() {
  return this.__altered;
}
var kc = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? bo() : t0(r) && !Io(r) ? r : bo().withMutations(function(n) {
      var i = t(r);
      Vi(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    for (var n = [], i = arguments.length; i--; )
      n[i] = arguments[i];
    return bo().withMutations(function(o) {
      for (var s = 0; s < n.length; s += 2) {
        if (s + 1 >= n.length)
          throw new Error("Missing value for key: " + n[s]);
        o.set(n[s], n[s + 1]);
      }
    });
  }, e.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, e.prototype.get = function(n, i) {
    return this._root ? this._root.get(0, void 0, n, i) : i;
  }, e.prototype.set = function(n, i) {
    return cb(this, n, i);
  }, e.prototype.remove = function(n) {
    return cb(this, n, le);
  }, e.prototype.deleteAll = function(n) {
    var i = Sr(n);
    return i.size === 0 ? this : this.withMutations(function(o) {
      i.forEach(function(s) {
        return o.remove(s);
      });
    });
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : bo();
  }, e.prototype.sort = function(n) {
    return ta(Qu(this, n));
  }, e.prototype.sortBy = function(n, i) {
    return ta(Qu(this, i, n));
  }, e.prototype.map = function(n, i) {
    var o = this;
    return this.withMutations(function(s) {
      s.forEach(function(u, c) {
        s.set(c, n.call(i, u, c, o));
      });
    });
  }, e.prototype.__iterator = function(n, i) {
    return new R2(this, n, i);
  }, e.prototype.__iterate = function(n, i) {
    var o = this, s = 0;
    return this._root && this._root.iterate(function(u) {
      return s++, n(u[1], u[0], o);
    }, i), s;
  }, e.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? v0(this.size, this._root, n, this.__hash) : this.size === 0 ? bo() : (this.__ownerID = n, this.__altered = !1, this);
  }, e;
}(co);
kc.isMap = t0;
var Ke = kc.prototype;
Ke[jO] = !0;
Ke[Ml] = Ke.remove;
Ke.removeAll = Ke.deleteAll;
Ke.setIn = s0;
Ke.removeIn = Ke.deleteIn = a0;
Ke.update = u0;
Ke.updateIn = c0;
Ke.merge = Ke.concat = HO;
Ke.mergeWith = JO;
Ke.mergeDeep = XO;
Ke.mergeDeepWith = tI;
Ke.mergeIn = h0;
Ke.mergeDeepIn = p0;
Ke.withMutations = zl;
Ke.wasAltered = d0;
Ke.asImmutable = Ul;
Ke["@@transducer/init"] = Ke.asMutable = Ll;
Ke["@@transducer/step"] = function(t, e) {
  return t.set(e[0], e[1]);
};
Ke["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var el = function(e, r) {
  this.ownerID = e, this.entries = r;
};
el.prototype.get = function(e, r, n, i) {
  for (var o = this.entries, s = 0, u = o.length; s < u; s++)
    if (Ei(n, o[s][0]))
      return o[s][1];
  return i;
};
el.prototype.update = function(e, r, n, i, o, s, u) {
  for (var c = o === le, a = this.entries, f = 0, h = a.length; f < h && !Ei(i, a[f][0]); f++)
    ;
  var p = f < h;
  if (p ? a[f][1] === o : c)
    return this;
  if (Ki(u), (c || !p) && Ki(s), !(c && a.length === 1)) {
    if (!p && !c && a.length >= j2)
      return x2(e, a, i, o);
    var d = e && e === this.ownerID, _ = d ? a : Vo(a);
    return p ? c ? f === h - 1 ? _.pop() : _[f] = _.pop() : _[f] = [i, o] : _.push([i, o]), d ? (this.entries = _, this) : new el(e, _);
  }
};
var Yu = function(e, r, n) {
  this.ownerID = e, this.bitmap = r, this.nodes = n;
};
Yu.prototype.get = function(e, r, n, i) {
  r === void 0 && (r = _i(n));
  var o = 1 << ((e === 0 ? r : r >>> e) & jn), s = this.bitmap;
  return s & o ? this.nodes[eI(s & o - 1)].get(
    e + ze,
    r,
    n,
    i
  ) : i;
};
Yu.prototype.update = function(e, r, n, i, o, s, u) {
  n === void 0 && (n = _i(i));
  var c = (r === 0 ? n : n >>> r) & jn, a = 1 << c, f = this.bitmap, h = (f & a) !== 0;
  if (!h && o === le)
    return this;
  var p = eI(f & a - 1), d = this.nodes, _ = h ? d[p] : void 0, m = y0(
    _,
    e,
    r + ze,
    n,
    i,
    o,
    s,
    u
  );
  if (m === _)
    return this;
  if (!h && m && d.length >= q2)
    return P2(e, d, f, c, m);
  if (h && !m && d.length === 2 && fb(d[p ^ 1]))
    return d[p ^ 1];
  if (h && m && d.length === 1 && fb(m))
    return m;
  var b = e && e === this.ownerID, O = h ? m ? f : f ^ a : f | a, S = h ? m ? rI(d, p, m, b) : C2(d, p, b) : k2(d, p, m, b);
  return b ? (this.bitmap = O, this.nodes = S, this) : new Yu(e, O, S);
};
var rl = function(e, r, n) {
  this.ownerID = e, this.count = r, this.nodes = n;
};
rl.prototype.get = function(e, r, n, i) {
  r === void 0 && (r = _i(n));
  var o = (e === 0 ? r : r >>> e) & jn, s = this.nodes[o];
  return s ? s.get(e + ze, r, n, i) : i;
};
rl.prototype.update = function(e, r, n, i, o, s, u) {
  n === void 0 && (n = _i(i));
  var c = (r === 0 ? n : n >>> r) & jn, a = o === le, f = this.nodes, h = f[c];
  if (a && !h)
    return this;
  var p = y0(
    h,
    e,
    r + ze,
    n,
    i,
    o,
    s,
    u
  );
  if (p === h)
    return this;
  var d = this.count;
  if (!h)
    d++;
  else if (!p && (d--, d < M2))
    return T2(e, f, d, c);
  var _ = e && e === this.ownerID, m = rI(f, c, p, _);
  return _ ? (this.count = d, this.nodes = m, this) : new rl(e, d, m);
};
var Gu = function(e, r, n) {
  this.ownerID = e, this.keyHash = r, this.entries = n;
};
Gu.prototype.get = function(e, r, n, i) {
  for (var o = this.entries, s = 0, u = o.length; s < u; s++)
    if (Ei(n, o[s][0]))
      return o[s][1];
  return i;
};
Gu.prototype.update = function(e, r, n, i, o, s, u) {
  n === void 0 && (n = _i(i));
  var c = o === le;
  if (n !== this.keyHash)
    return c ? this : (Ki(u), Ki(s), _0(this, e, r, n, [i, o]));
  for (var a = this.entries, f = 0, h = a.length; f < h && !Ei(i, a[f][0]); f++)
    ;
  var p = f < h;
  if (p ? a[f][1] === o : c)
    return this;
  if (Ki(u), (c || !p) && Ki(s), c && h === 2)
    return new Xs(e, this.keyHash, a[f ^ 1]);
  var d = e && e === this.ownerID, _ = d ? a : Vo(a);
  return p ? c ? f === h - 1 ? _.pop() : _[f] = _.pop() : _[f] = [i, o] : _.push([i, o]), d ? (this.entries = _, this) : new Gu(e, this.keyHash, _);
};
var Xs = function(e, r, n) {
  this.ownerID = e, this.keyHash = r, this.entry = n;
};
Xs.prototype.get = function(e, r, n, i) {
  return Ei(n, this.entry[0]) ? this.entry[1] : i;
};
Xs.prototype.update = function(e, r, n, i, o, s, u) {
  var c = o === le, a = Ei(i, this.entry[0]);
  if (a ? o === this.entry[1] : c)
    return this;
  if (Ki(u), c) {
    Ki(s);
    return;
  }
  return a ? e && e === this.ownerID ? (this.entry[1] = o, this) : new Xs(e, this.keyHash, [i, o]) : (Ki(s), _0(this, e, r, _i(i), [i, o]));
};
el.prototype.iterate = Gu.prototype.iterate = function(t, e) {
  for (var r = this.entries, n = 0, i = r.length - 1; n <= i; n++)
    if (t(r[e ? i - n : n]) === !1)
      return !1;
};
Yu.prototype.iterate = rl.prototype.iterate = function(t, e) {
  for (var r = this.nodes, n = 0, i = r.length - 1; n <= i; n++) {
    var o = r[e ? i - n : n];
    if (o && o.iterate(t, e) === !1)
      return !1;
  }
};
Xs.prototype.iterate = function(t, e) {
  return t(this.entry);
};
var R2 = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    this._type = n, this._reverse = i, this._stack = r._root && ab(r._root);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function() {
    for (var n = this._type, i = this._stack; i; ) {
      var o = i.node, s = i.index++, u = void 0;
      if (o.entry) {
        if (s === 0)
          return Dv(n, o.entry);
      } else if (o.entries) {
        if (u = o.entries.length - 1, s <= u)
          return Dv(
            n,
            o.entries[this._reverse ? u - s : s]
          );
      } else if (u = o.nodes.length - 1, s <= u) {
        var c = o.nodes[this._reverse ? u - s : s];
        if (c) {
          if (c.entry)
            return Dv(n, c.entry);
          i = this._stack = ab(c, i);
        }
        continue;
      }
      i = this._stack = this._stack.__prev;
    }
    return ui();
  }, e;
}(me);
function Dv(t, e) {
  return _r(t, e[0], e[1]);
}
function ab(t, e) {
  return {
    node: t,
    index: 0,
    __prev: e
  };
}
function v0(t, e, r, n) {
  var i = Object.create(Ke);
  return i.size = t, i._root = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var ub;
function bo() {
  return ub || (ub = v0(0));
}
function cb(t, e, r) {
  var n, i;
  if (t._root) {
    var o = Dy(), s = Dy();
    if (n = y0(
      t._root,
      t.__ownerID,
      0,
      void 0,
      e,
      r,
      o,
      s
    ), !s.value)
      return t;
    i = t.size + (o.value ? r === le ? -1 : 1 : 0);
  } else {
    if (r === le)
      return t;
    i = 1, n = new el(t.__ownerID, [[e, r]]);
  }
  return t.__ownerID ? (t.size = i, t._root = n, t.__hash = void 0, t.__altered = !0, t) : n ? v0(i, n) : bo();
}
function y0(t, e, r, n, i, o, s, u) {
  return t ? t.update(
    e,
    r,
    n,
    i,
    o,
    s,
    u
  ) : o === le ? t : (Ki(u), Ki(s), new Xs(e, n, [i, o]));
}
function fb(t) {
  return t.constructor === Xs || t.constructor === Gu;
}
function _0(t, e, r, n, i) {
  if (t.keyHash === n)
    return new Gu(e, n, [t.entry, i]);
  var o = (r === 0 ? t.keyHash : t.keyHash >>> r) & jn, s = (r === 0 ? n : n >>> r) & jn, u, c = o === s ? [_0(t, e, r + ze, n, i)] : (u = new Xs(e, n, i), o < s ? [t, u] : [u, t]);
  return new Yu(e, 1 << o | 1 << s, c);
}
function x2(t, e, r, n) {
  t || (t = new G_());
  for (var i = new Xs(t, _i(r), [r, n]), o = 0; o < e.length; o++) {
    var s = e[o];
    i = i.update(t, 0, void 0, s[0], s[1]);
  }
  return i;
}
function T2(t, e, r, n) {
  for (var i = 0, o = 0, s = new Array(r), u = 0, c = 1, a = e.length; u < a; u++, c <<= 1) {
    var f = e[u];
    f !== void 0 && u !== n && (i |= c, s[o++] = f);
  }
  return new Yu(t, i, s);
}
function P2(t, e, r, n, i) {
  for (var o = 0, s = new Array($i), u = 0; r !== 0; u++, r >>>= 1)
    s[u] = r & 1 ? e[o++] : void 0;
  return s[n] = i, new rl(t, o + 1, s);
}
function eI(t) {
  return t -= t >> 1 & 1431655765, t = (t & 858993459) + (t >> 2 & 858993459), t = t + (t >> 4) & 252645135, t += t >> 8, t += t >> 16, t & 127;
}
function rI(t, e, r, n) {
  var i = n ? t : Vo(t);
  return i[e] = r, i;
}
function k2(t, e, r, n) {
  var i = t.length + 1;
  if (n && e + 1 === i)
    return t[e] = r, t;
  for (var o = new Array(i), s = 0, u = 0; u < i; u++)
    u === e ? (o[u] = r, s = -1) : o[u] = t[u + s];
  return o;
}
function C2(t, e, r) {
  var n = t.length - 1;
  if (r && e === n)
    return t.pop(), t;
  for (var i = new Array(n), o = 0, s = 0; s < n; s++)
    s === e && (o = 1), i[s] = t[s + o];
  return i;
}
var j2 = $i / 4, q2 = $i / 2, M2 = $i / 4, nI = "@@__IMMUTABLE_LIST__@@";
function iI(t) {
  return !!(t && t[nI]);
}
var nd = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = op();
    if (r == null)
      return n;
    if (iI(r))
      return r;
    var i = t(r), o = i.size;
    return o === 0 ? n : (Vi(o), o > 0 && o < $i ? nl(0, o, ze, null, new Aa(i.toArray())) : n.withMutations(function(s) {
      s.setSize(o), i.forEach(function(u, c) {
        return s.set(c, u);
      });
    }));
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, e.prototype.get = function(n, i) {
    if (n = Pa(this, n), n >= 0 && n < this.size) {
      n += this._origin;
      var o = oI(this, n);
      return o && o.array[n & jn];
    }
    return i;
  }, e.prototype.set = function(n, i) {
    return F2(this, n, i);
  }, e.prototype.remove = function(n) {
    return this.has(n) ? n === 0 ? this.shift() : n === this.size - 1 ? this.pop() : this.splice(n, 1) : this;
  }, e.prototype.insert = function(n, i) {
    return this.splice(n, 0, i);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = ze, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : op();
  }, e.prototype.push = function() {
    var n = arguments, i = this.size;
    return this.withMutations(function(o) {
      ha(o, 0, i + n.length);
      for (var s = 0; s < n.length; s++)
        o.set(i + s, n[s]);
    });
  }, e.prototype.pop = function() {
    return ha(this, 0, -1);
  }, e.prototype.unshift = function() {
    var n = arguments;
    return this.withMutations(function(i) {
      ha(i, -n.length);
      for (var o = 0; o < n.length; o++)
        i.set(o, n[o]);
    });
  }, e.prototype.shift = function() {
    return ha(this, 1);
  }, e.prototype.concat = function() {
    for (var n = arguments, i = [], o = 0; o < arguments.length; o++) {
      var s = n[o], u = t(
        typeof s != "string" && PO(s) ? s : [s]
      );
      u.size !== 0 && i.push(u);
    }
    return i.length === 0 ? this : this.size === 0 && !this.__ownerID && i.length === 1 ? this.constructor(i[0]) : this.withMutations(function(c) {
      i.forEach(function(a) {
        return a.forEach(function(f) {
          return c.push(f);
        });
      });
    });
  }, e.prototype.setSize = function(n) {
    return ha(this, 0, n);
  }, e.prototype.map = function(n, i) {
    var o = this;
    return this.withMutations(function(s) {
      for (var u = 0; u < o.size; u++)
        s.set(u, n.call(i, s.get(u), u, o));
    });
  }, e.prototype.slice = function(n, i) {
    var o = this.size;
    return Hp(n, i, o) ? this : ha(
      this,
      Fl(n, o),
      Jp(i, o)
    );
  }, e.prototype.__iterator = function(n, i) {
    var o = i ? this.size : 0, s = lb(this, i);
    return new me(function() {
      var u = s();
      return u === Qf ? ui() : _r(n, i ? --o : o++, u);
    });
  }, e.prototype.__iterate = function(n, i) {
    for (var o = i ? this.size : 0, s = lb(this, i), u; (u = s()) !== Qf && n(u, i ? --o : o++, this) !== !1; )
      ;
    return o;
  }, e.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? nl(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      n,
      this.__hash
    ) : this.size === 0 ? op() : (this.__ownerID = n, this.__altered = !1, this);
  }, e;
}(fu);
nd.isList = iI;
var Pr = nd.prototype;
Pr[nI] = !0;
Pr[Ml] = Pr.remove;
Pr.merge = Pr.concat;
Pr.setIn = s0;
Pr.deleteIn = Pr.removeIn = a0;
Pr.update = u0;
Pr.updateIn = c0;
Pr.mergeIn = h0;
Pr.mergeDeepIn = p0;
Pr.withMutations = zl;
Pr.wasAltered = d0;
Pr.asImmutable = Ul;
Pr["@@transducer/init"] = Pr.asMutable = Ll;
Pr["@@transducer/step"] = function(t, e) {
  return t.push(e);
};
Pr["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var Aa = function(e, r) {
  this.array = e, this.ownerID = r;
};
Aa.prototype.removeBefore = function(e, r, n) {
  if (n === r ? 1 << r : this.array.length === 0)
    return this;
  var i = n >>> r & jn;
  if (i >= this.array.length)
    return new Aa([], e);
  var o = i === 0, s;
  if (r > 0) {
    var u = this.array[i];
    if (s = u && u.removeBefore(e, r - ze, n), s === u && o)
      return this;
  }
  if (o && !s)
    return this;
  var c = Wu(this, e);
  if (!o)
    for (var a = 0; a < i; a++)
      c.array[a] = void 0;
  return s && (c.array[i] = s), c;
};
Aa.prototype.removeAfter = function(e, r, n) {
  if (n === (r ? 1 << r : 0) || this.array.length === 0)
    return this;
  var i = n - 1 >>> r & jn;
  if (i >= this.array.length)
    return this;
  var o;
  if (r > 0) {
    var s = this.array[i];
    if (o = s && s.removeAfter(e, r - ze, n), o === s && i === this.array.length - 1)
      return this;
  }
  var u = Wu(this, e);
  return u.array.splice(i + 1), o && (u.array[i] = o), u;
};
var Qf = {};
function lb(t, e) {
  var r = t._origin, n = t._capacity, i = il(n), o = t._tail;
  return s(t._root, t._level, 0);
  function s(a, f, h) {
    return f === 0 ? u(a, h) : c(a, f, h);
  }
  function u(a, f) {
    var h = f === i ? o && o.array : a && a.array, p = f > r ? 0 : r - f, d = n - f;
    return d > $i && (d = $i), function() {
      if (p === d)
        return Qf;
      var _ = e ? --d : p++;
      return h && h[_];
    };
  }
  function c(a, f, h) {
    var p, d = a && a.array, _ = h > r ? 0 : r - h >> f, m = (n - h >> f) + 1;
    return m > $i && (m = $i), function() {
      for (; ; ) {
        if (p) {
          var b = p();
          if (b !== Qf)
            return b;
          p = null;
        }
        if (_ === m)
          return Qf;
        var O = e ? --m : _++;
        p = s(
          d && d[O],
          f - ze,
          h + (O << f)
        );
      }
    };
  }
}
function nl(t, e, r, n, i, o, s) {
  var u = Object.create(Pr);
  return u.size = e - t, u._origin = t, u._capacity = e, u._level = r, u._root = n, u._tail = i, u.__ownerID = o, u.__hash = s, u.__altered = !1, u;
}
var hb;
function op() {
  return hb || (hb = nl(0, 0, ze));
}
function F2(t, e, r) {
  if (e = Pa(t, e), e !== e)
    return t;
  if (e >= t.size || e < 0)
    return t.withMutations(function(s) {
      e < 0 ? ha(s, e).set(0, r) : ha(s, 0, e + 1).set(e, r);
    });
  e += t._origin;
  var n = t._tail, i = t._root, o = Dy();
  return e >= il(t._capacity) ? n = Cy(n, t.__ownerID, 0, e, r, o) : i = Cy(
    i,
    t.__ownerID,
    t._level,
    e,
    r,
    o
  ), o.value ? t.__ownerID ? (t._root = i, t._tail = n, t.__hash = void 0, t.__altered = !0, t) : nl(t._origin, t._capacity, t._level, i, n) : t;
}
function Cy(t, e, r, n, i, o) {
  var s = n >>> r & jn, u = t && s < t.array.length;
  if (!u && i === void 0)
    return t;
  var c;
  if (r > 0) {
    var a = t && t.array[s], f = Cy(
      a,
      e,
      r - ze,
      n,
      i,
      o
    );
    return f === a ? t : (c = Wu(t, e), c.array[s] = f, c);
  }
  return u && t.array[s] === i ? t : (o && Ki(o), c = Wu(t, e), i === void 0 && s === c.array.length - 1 ? c.array.pop() : c.array[s] = i, c);
}
function Wu(t, e) {
  return e && t && e === t.ownerID ? t : new Aa(t ? t.array.slice() : [], e);
}
function oI(t, e) {
  if (e >= il(t._capacity))
    return t._tail;
  if (e < 1 << t._level + ze) {
    for (var r = t._root, n = t._level; r && n > 0; )
      r = r.array[e >>> n & jn], n -= ze;
    return r;
  }
}
function ha(t, e, r) {
  e !== void 0 && (e |= 0), r !== void 0 && (r |= 0);
  var n = t.__ownerID || new G_(), i = t._origin, o = t._capacity, s = i + e, u = r === void 0 ? o : r < 0 ? o + r : i + r;
  if (s === i && u === o)
    return t;
  if (s >= u)
    return t.clear();
  for (var c = t._level, a = t._root, f = 0; s + f < 0; )
    a = new Aa(
      a && a.array.length ? [void 0, a] : [],
      n
    ), c += ze, f += 1 << c;
  f && (s += f, i += f, u += f, o += f);
  for (var h = il(o), p = il(u); p >= 1 << c + ze; )
    a = new Aa(
      a && a.array.length ? [a] : [],
      n
    ), c += ze;
  var d = t._tail, _ = p < h ? oI(t, u - 1) : p > h ? new Aa([], n) : d;
  if (d && p > h && s < o && d.array.length) {
    a = Wu(a, n);
    for (var m = a, b = c; b > ze; b -= ze) {
      var O = h >>> b & jn;
      m = m.array[O] = Wu(m.array[O], n);
    }
    m.array[h >>> ze & jn] = d;
  }
  if (u < o && (_ = _ && _.removeAfter(n, 0, u)), s >= p)
    s -= p, u -= p, c = ze, a = null, _ = _ && _.removeBefore(n, 0, s);
  else if (s > i || p < h) {
    for (f = 0; a; ) {
      var S = s >>> c & jn;
      if (S !== p >>> c & jn)
        break;
      S && (f += (1 << c) * S), c -= ze, a = a.array[S];
    }
    a && s > i && (a = a.removeBefore(n, c, s - f)), a && p < h && (a = a.removeAfter(
      n,
      c,
      p - f
    )), f && (s -= f, u -= f);
  }
  return t.__ownerID ? (t.size = u - s, t._origin = s, t._capacity = u, t._level = c, t._root = a, t._tail = _, t.__hash = void 0, t.__altered = !0, t) : nl(s, u, c, a, _);
}
function il(t) {
  return t < $i ? 0 : t - 1 >>> ze << ze;
}
var ta = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? xf() : qO(r) ? r : xf().withMutations(function(n) {
      var i = co(r);
      Vi(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, e.prototype.get = function(n, i) {
    var o = this._map.get(n);
    return o !== void 0 ? this._list.get(o)[1] : i;
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : xf();
  }, e.prototype.set = function(n, i) {
    return db(this, n, i);
  }, e.prototype.remove = function(n) {
    return db(this, n, le);
  }, e.prototype.__iterate = function(n, i) {
    var o = this;
    return this._list.__iterate(
      function(s) {
        return s && n(s[1], s[0], o);
      },
      i
    );
  }, e.prototype.__iterator = function(n, i) {
    return this._list.fromEntrySeq().__iterator(n, i);
  }, e.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var i = this._map.__ensureOwner(n), o = this._list.__ensureOwner(n);
    return n ? m0(i, o, n, this.__hash) : this.size === 0 ? xf() : (this.__ownerID = n, this.__altered = !1, this._map = i, this._list = o, this);
  }, e;
}(kc);
ta.isOrderedMap = qO;
ta.prototype[Rc] = !0;
ta.prototype[Ml] = ta.prototype.remove;
function m0(t, e, r, n) {
  var i = Object.create(ta.prototype);
  return i.size = t ? t.size : 0, i._map = t, i._list = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var pb;
function xf() {
  return pb || (pb = m0(bo(), op()));
}
function db(t, e, r) {
  var n = t._map, i = t._list, o = n.get(e), s = o !== void 0, u, c;
  if (r === le) {
    if (!s)
      return t;
    i.size >= $i && i.size >= n.size * 2 ? (c = i.filter(function(a, f) {
      return a !== void 0 && o !== f;
    }), u = c.toKeyedSeq().map(function(a) {
      return a[0];
    }).flip().toMap(), t.__ownerID && (u.__ownerID = c.__ownerID = t.__ownerID)) : (u = n.remove(e), c = o === i.size - 1 ? i.pop() : i.set(o, void 0));
  } else if (s) {
    if (r === i.get(o)[1])
      return t;
    u = n, c = i.set(o, [e, r]);
  } else
    u = n.set(e, i.size), c = i.set(i.size, [e, r]);
  return t.__ownerID ? (t.size = u.size, t._map = u, t._list = c, t.__hash = void 0, t.__altered = !0, t) : m0(u, c);
}
var sI = "@@__IMMUTABLE_STACK__@@";
function jy(t) {
  return !!(t && t[sI]);
}
var g0 = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Oh() : jy(r) ? r : Oh().pushAll(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, e.prototype.get = function(n, i) {
    var o = this._head;
    for (n = Pa(this, n); o && n--; )
      o = o.next;
    return o ? o.value : i;
  }, e.prototype.peek = function() {
    return this._head && this._head.value;
  }, e.prototype.push = function() {
    var n = arguments;
    if (arguments.length === 0)
      return this;
    for (var i = this.size + arguments.length, o = this._head, s = arguments.length - 1; s >= 0; s--)
      o = {
        value: n[s],
        next: o
      };
    return this.__ownerID ? (this.size = i, this._head = o, this.__hash = void 0, this.__altered = !0, this) : Tf(i, o);
  }, e.prototype.pushAll = function(n) {
    if (n = t(n), n.size === 0)
      return this;
    if (this.size === 0 && jy(n))
      return n;
    Vi(n.size);
    var i = this.size, o = this._head;
    return n.__iterate(
      function(s) {
        i++, o = {
          value: s,
          next: o
        };
      },
      /* reverse */
      !0
    ), this.__ownerID ? (this.size = i, this._head = o, this.__hash = void 0, this.__altered = !0, this) : Tf(i, o);
  }, e.prototype.pop = function() {
    return this.slice(1);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Oh();
  }, e.prototype.slice = function(n, i) {
    if (Hp(n, i, this.size))
      return this;
    var o = Fl(n, this.size), s = Jp(i, this.size);
    if (s !== this.size)
      return t.prototype.slice.call(this, n, i);
    for (var u = this.size - o, c = this._head; o--; )
      c = c.next;
    return this.__ownerID ? (this.size = u, this._head = c, this.__hash = void 0, this.__altered = !0, this) : Tf(u, c);
  }, e.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Tf(this.size, this._head, n, this.__hash) : this.size === 0 ? Oh() : (this.__ownerID = n, this.__altered = !1, this);
  }, e.prototype.__iterate = function(n, i) {
    var o = this;
    if (i)
      return new iu(this.toArray()).__iterate(
        function(c, a) {
          return n(c, a, o);
        },
        i
      );
    for (var s = 0, u = this._head; u && n(u.value, s++, this) !== !1; )
      u = u.next;
    return s;
  }, e.prototype.__iterator = function(n, i) {
    if (i)
      return new iu(this.toArray()).__iterator(n, i);
    var o = 0, s = this._head;
    return new me(function() {
      if (s) {
        var u = s.value;
        return s = s.next, _r(n, o++, u);
      }
      return ui();
    });
  }, e;
}(fu);
g0.isStack = jy;
var zn = g0.prototype;
zn[sI] = !0;
zn.shift = zn.pop;
zn.unshift = zn.push;
zn.unshiftAll = zn.pushAll;
zn.withMutations = zl;
zn.wasAltered = d0;
zn.asImmutable = Ul;
zn["@@transducer/init"] = zn.asMutable = Ll;
zn["@@transducer/step"] = function(t, e) {
  return t.unshift(e);
};
zn["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
function Tf(t, e, r, n) {
  var i = Object.create(zn);
  return i.size = t, i._head = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var vb;
function Oh() {
  return vb || (vb = Tf(0));
}
var aI = "@@__IMMUTABLE_SET__@@";
function b0(t) {
  return !!(t && t[aI]);
}
function uI(t) {
  return b0(t) && Io(t);
}
function cI(t, e) {
  if (t === e)
    return !0;
  if (!ai(e) || t.size !== void 0 && e.size !== void 0 && t.size !== e.size || t.__hash !== void 0 && e.__hash !== void 0 && t.__hash !== e.__hash || hr(t) !== hr(e) || ri(t) !== ri(e) || Io(t) !== Io(e))
    return !1;
  if (t.size === 0 && e.size === 0)
    return !0;
  var r = !Zp(t);
  if (Io(t)) {
    var n = t.entries();
    return e.every(function(c, a) {
      var f = n.next().value;
      return f && Ei(f[1], c) && (r || Ei(f[0], a));
    }) && n.next().done;
  }
  var i = !1;
  if (t.size === void 0)
    if (e.size === void 0)
      typeof t.cacheResult == "function" && t.cacheResult();
    else {
      i = !0;
      var o = t;
      t = e, e = o;
    }
  var s = !0, u = e.__iterate(function(c, a) {
    if (r ? !t.has(c) : i ? !Ei(c, t.get(a, le)) : !Ei(t.get(a, le), c))
      return s = !1, !1;
  });
  return s && t.size === u;
}
function lu(t, e) {
  var r = function(n) {
    t.prototype[n] = e[n];
  };
  return Object.keys(e).forEach(r), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(r), t;
}
function Sp(t) {
  if (!t || typeof t != "object")
    return t;
  if (!ai(t)) {
    if (!ka(t))
      return t;
    t = Di(t);
  }
  if (hr(t)) {
    var e = {};
    return t.__iterate(function(n, i) {
      e[i] = Sp(n);
    }), e;
  }
  var r = [];
  return t.__iterate(function(n) {
    r.push(Sp(n));
  }), r;
}
var id = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Pf() : b0(r) && !Io(r) ? r : Pf().withMutations(function(n) {
      var i = t(r);
      Vi(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(n) {
    return this(co(n).keySeq());
  }, e.intersect = function(n) {
    return n = Sr(n).toArray(), n.length ? Xr.intersect.apply(e(n.pop()), n) : Pf();
  }, e.union = function(n) {
    return n = Sr(n).toArray(), n.length ? Xr.union.apply(e(n.pop()), n) : Pf();
  }, e.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, e.prototype.has = function(n) {
    return this._map.has(n);
  }, e.prototype.add = function(n) {
    return Ih(this, this._map.set(n, n));
  }, e.prototype.remove = function(n) {
    return Ih(this, this._map.remove(n));
  }, e.prototype.clear = function() {
    return Ih(this, this._map.clear());
  }, e.prototype.map = function(n, i) {
    var o = this, s = !1, u = Ih(
      this,
      this._map.mapEntries(function(c) {
        var a = c[1], f = n.call(i, a, a, o);
        return f !== a && (s = !0), [f, f];
      }, i)
    );
    return s ? u : this;
  }, e.prototype.union = function() {
    for (var n = [], i = arguments.length; i--; )
      n[i] = arguments[i];
    return n = n.filter(function(o) {
      return o.size !== 0;
    }), n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(o) {
      for (var s = 0; s < n.length; s++)
        typeof n[s] == "string" ? o.add(n[s]) : t(n[s]).forEach(function(u) {
          return o.add(u);
        });
    });
  }, e.prototype.intersect = function() {
    for (var n = [], i = arguments.length; i--; )
      n[i] = arguments[i];
    if (n.length === 0)
      return this;
    n = n.map(function(s) {
      return t(s);
    });
    var o = [];
    return this.forEach(function(s) {
      n.every(function(u) {
        return u.includes(s);
      }) || o.push(s);
    }), this.withMutations(function(s) {
      o.forEach(function(u) {
        s.remove(u);
      });
    });
  }, e.prototype.subtract = function() {
    for (var n = [], i = arguments.length; i--; )
      n[i] = arguments[i];
    if (n.length === 0)
      return this;
    n = n.map(function(s) {
      return t(s);
    });
    var o = [];
    return this.forEach(function(s) {
      n.some(function(u) {
        return u.includes(s);
      }) && o.push(s);
    }), this.withMutations(function(s) {
      o.forEach(function(u) {
        s.remove(u);
      });
    });
  }, e.prototype.sort = function(n) {
    return ol(Qu(this, n));
  }, e.prototype.sortBy = function(n, i) {
    return ol(Qu(this, i, n));
  }, e.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, e.prototype.__iterate = function(n, i) {
    var o = this;
    return this._map.__iterate(function(s) {
      return n(s, s, o);
    }, i);
  }, e.prototype.__iterator = function(n, i) {
    return this._map.__iterator(n, i);
  }, e.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var i = this._map.__ensureOwner(n);
    return n ? this.__make(i, n) : this.size === 0 ? this.__empty() : (this.__ownerID = n, this._map = i, this);
  }, e;
}(Ac);
id.isSet = b0;
var Xr = id.prototype;
Xr[aI] = !0;
Xr[Ml] = Xr.remove;
Xr.merge = Xr.concat = Xr.union;
Xr.withMutations = zl;
Xr.asImmutable = Ul;
Xr["@@transducer/init"] = Xr.asMutable = Ll;
Xr["@@transducer/step"] = function(t, e) {
  return t.add(e);
};
Xr["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
Xr.__empty = Pf;
Xr.__make = fI;
function Ih(t, e) {
  return t.__ownerID ? (t.size = e.size, t._map = e, t) : e === t._map ? t : e.size === 0 ? t.__empty() : t.__make(e);
}
function fI(t, e) {
  var r = Object.create(Xr);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var yb;
function Pf() {
  return yb || (yb = fI(bo()));
}
var N2 = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    if (!(this instanceof e))
      return new e(r, n, i);
    if (o0(i !== 0, "Cannot step a Range by 0"), r = r || 0, n === void 0 && (n = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), n < r && (i = -i), this._start = r, this._end = n, this._step = i, this.size = Math.max(0, Math.ceil((n - r) / i - 1) + 1), this.size === 0) {
      if (Rv)
        return Rv;
      Rv = this;
    }
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, e.prototype.get = function(n, i) {
    return this.has(n) ? this._start + Pa(this, n) * this._step : i;
  }, e.prototype.includes = function(n) {
    var i = (n - this._start) / this._step;
    return i >= 0 && i < this.size && i === Math.floor(i);
  }, e.prototype.slice = function(n, i) {
    return Hp(n, i, this.size) ? this : (n = Fl(n, this.size), i = Jp(i, this.size), i <= n ? new e(0, 0) : new e(
      this.get(n, this._end),
      this.get(i, this._end),
      this._step
    ));
  }, e.prototype.indexOf = function(n) {
    var i = n - this._start;
    if (i % this._step === 0) {
      var o = i / this._step;
      if (o >= 0 && o < this.size)
        return o;
    }
    return -1;
  }, e.prototype.lastIndexOf = function(n) {
    return this.indexOf(n);
  }, e.prototype.__iterate = function(n, i) {
    for (var o = this.size, s = this._step, u = i ? this._start + (o - 1) * s : this._start, c = 0; c !== o && n(u, i ? o - ++c : c++, this) !== !1; )
      u += i ? -s : s;
    return c;
  }, e.prototype.__iterator = function(n, i) {
    var o = this.size, s = this._step, u = i ? this._start + (o - 1) * s : this._start, c = 0;
    return new me(function() {
      if (c === o)
        return ui();
      var a = u;
      return u += i ? -s : s, _r(n, i ? o - ++c : c++, a);
    });
  }, e.prototype.equals = function(n) {
    return n instanceof e ? this._start === n._start && this._end === n._end && this._step === n._step : cI(this, n);
  }, e;
}(qo), Rv;
function lI(t, e, r) {
  for (var n = QO(e), i = 0; i !== n.length; )
    if (t = YO(t, n[i++], le), t === le)
      return r;
  return t;
}
function hI(t, e) {
  return lI(this, t, e);
}
function z2(t, e) {
  return lI(t, e, le) !== le;
}
function L2(t) {
  return z2(this, t);
}
function pI() {
  Vi(this.size);
  var t = {};
  return this.__iterate(function(e, r) {
    t[r] = e;
  }), t;
}
Sr.isIterable = ai;
Sr.isKeyed = hr;
Sr.isIndexed = ri;
Sr.isAssociative = Zp;
Sr.isOrdered = Io;
Sr.Iterator = me;
lu(Sr, {
  // ### Conversion to other types
  toArray: function() {
    Vi(this.size);
    var e = new Array(this.size || 0), r = hr(this), n = 0;
    return this.__iterate(function(i, o) {
      e[n++] = r ? [o, i] : i;
    }), e;
  },
  toIndexedSeq: function() {
    return new FO(this);
  },
  toJS: function() {
    return Sp(this);
  },
  toKeyedSeq: function() {
    return new rd(this, !0);
  },
  toMap: function() {
    return kc(this.toKeyedSeq());
  },
  toObject: pI,
  toOrderedMap: function() {
    return ta(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return ol(hr(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return id(hr(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new NO(this);
  },
  toSeq: function() {
    return ri(this) ? this.toIndexedSeq() : hr(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return g0(hr(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return nd(hr(this) ? this.valueSeq() : this);
  },
  // ### Common JavaScript methods and properties
  toString: function() {
    return "[Collection]";
  },
  __toString: function(e, r) {
    return this.size === 0 ? e + r : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + r;
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  concat: function() {
    for (var e = [], r = arguments.length; r--; )
      e[r] = arguments[r];
    return Re(this, y2(this, e));
  },
  includes: function(e) {
    return this.some(function(r) {
      return Ei(r, e);
    });
  },
  entries: function() {
    return this.__iterator(io);
  },
  every: function(e, r) {
    Vi(this.size);
    var n = !0;
    return this.__iterate(function(i, o, s) {
      if (!e.call(r, i, o, s))
        return n = !1, !1;
    }), n;
  },
  filter: function(e, r) {
    return Re(this, BO(this, e, r, !0));
  },
  partition: function(e, r) {
    return d2(this, e, r);
  },
  find: function(e, r, n) {
    var i = this.findEntry(e, r);
    return i ? i[1] : n;
  },
  forEach: function(e, r) {
    return Vi(this.size), this.__iterate(r ? e.bind(r) : e);
  },
  join: function(e) {
    Vi(this.size), e = e !== void 0 ? "" + e : ",";
    var r = "", n = !0;
    return this.__iterate(function(i) {
      n ? n = !1 : r += e, r += i != null ? i.toString() : "";
    }), r;
  },
  keys: function() {
    return this.__iterator(Nl);
  },
  map: function(e, r) {
    return Re(this, UO(this, e, r));
  },
  reduce: function(e, r, n) {
    return _b(
      this,
      e,
      r,
      n,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(e, r, n) {
    return _b(
      this,
      e,
      r,
      n,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return Re(this, e0(this, !0));
  },
  slice: function(e, r) {
    return Re(this, r0(this, e, r, !0));
  },
  some: function(e, r) {
    return !this.every(Ah(e), r);
  },
  sort: function(e) {
    return Re(this, Qu(this, e));
  },
  values: function() {
    return this.__iterator(To);
  },
  // ### More sequential methods
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(e, r) {
    return Vu(
      e ? this.toSeq().filter(e, r) : this
    );
  },
  countBy: function(e, r) {
    return h2(this, e, r);
  },
  equals: function(e) {
    return cI(this, e);
  },
  entrySeq: function() {
    var e = this;
    if (e._cache)
      return new iu(e._cache);
    var r = e.toSeq().map(B2).toIndexedSeq();
    return r.fromEntrySeq = function() {
      return e.toSeq();
    }, r;
  },
  filterNot: function(e, r) {
    return this.filter(Ah(e), r);
  },
  findEntry: function(e, r, n) {
    var i = n;
    return this.__iterate(function(o, s, u) {
      if (e.call(r, o, s, u))
        return i = [s, o], !1;
    }), i;
  },
  findKey: function(e, r) {
    var n = this.findEntry(e, r);
    return n && n[0];
  },
  findLast: function(e, r, n) {
    return this.toKeyedSeq().reverse().find(e, r, n);
  },
  findLastEntry: function(e, r, n) {
    return this.toKeyedSeq().reverse().findEntry(e, r, n);
  },
  findLastKey: function(e, r) {
    return this.toKeyedSeq().reverse().findKey(e, r);
  },
  first: function(e) {
    return this.find(EO, null, e);
  },
  flatMap: function(e, r) {
    return Re(this, _2(this, e, r));
  },
  flatten: function(e) {
    return Re(this, KO(this, e, !0));
  },
  fromEntrySeq: function() {
    return new zO(this);
  },
  get: function(e, r) {
    return this.find(function(n, i) {
      return Ei(i, e);
    }, void 0, r);
  },
  getIn: hI,
  groupBy: function(e, r) {
    return p2(this, e, r);
  },
  has: function(e) {
    return this.get(e, le) !== le;
  },
  hasIn: L2,
  isSubset: function(e) {
    return e = typeof e.includes == "function" ? e : Sr(e), this.every(function(r) {
      return e.includes(r);
    });
  },
  isSuperset: function(e) {
    return e = typeof e.isSubset == "function" ? e : Sr(e), e.isSubset(this);
  },
  keyOf: function(e) {
    return this.findKey(function(r) {
      return Ei(r, e);
    });
  },
  keySeq: function() {
    return this.toSeq().map(U2).toIndexedSeq();
  },
  last: function(e) {
    return this.toSeq().reverse().first(e);
  },
  lastKeyOf: function(e) {
    return this.toKeyedSeq().reverse().keyOf(e);
  },
  max: function(e) {
    return Eh(this, e);
  },
  maxBy: function(e, r) {
    return Eh(this, r, e);
  },
  min: function(e) {
    return Eh(
      this,
      e ? mb(e) : bb
    );
  },
  minBy: function(e, r) {
    return Eh(
      this,
      r ? mb(r) : bb,
      e
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(e) {
    return e === 0 ? this : this.slice(Math.max(0, e));
  },
  skipLast: function(e) {
    return e === 0 ? this : this.slice(0, -Math.max(0, e));
  },
  skipWhile: function(e, r) {
    return Re(this, $O(this, e, r, !0));
  },
  skipUntil: function(e, r) {
    return this.skipWhile(Ah(e), r);
  },
  sortBy: function(e, r) {
    return Re(this, Qu(this, r, e));
  },
  take: function(e) {
    return this.slice(0, Math.max(0, e));
  },
  takeLast: function(e) {
    return this.slice(-Math.max(0, e));
  },
  takeWhile: function(e, r) {
    return Re(this, v2(this, e, r));
  },
  takeUntil: function(e, r) {
    return this.takeWhile(Ah(e), r);
  },
  update: function(e) {
    return e(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  // ### Hashable Object
  hashCode: function() {
    return this.__hash || (this.__hash = $2(this));
  }
  // ### Internal
  // abstract __iterate(fn, reverse)
  // abstract __iterator(type, reverse)
});
var In = Sr.prototype;
In[IO] = !0;
In[Xp] = In.values;
In.toJSON = In.toArray;
In.__toStringMapper = tl;
In.inspect = In.toSource = function() {
  return this.toString();
};
In.chain = In.flatMap;
In.contains = In.includes;
lu(co, {
  // ### More sequential methods
  flip: function() {
    return Re(this, LO(this));
  },
  mapEntries: function(e, r) {
    var n = this, i = 0;
    return Re(
      this,
      this.toSeq().map(function(o, s) {
        return e.call(r, [s, o], i++, n);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(e, r) {
    var n = this;
    return Re(
      this,
      this.toSeq().flip().map(function(i, o) {
        return e.call(r, i, o, n);
      }).flip()
    );
  }
});
var Bl = co.prototype;
Bl[AO] = !0;
Bl[Xp] = In.entries;
Bl.toJSON = pI;
Bl.__toStringMapper = function(t, e) {
  return tl(e) + ": " + tl(t);
};
lu(fu, {
  // ### Conversion to other types
  toKeyedSeq: function() {
    return new rd(this, !1);
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  filter: function(e, r) {
    return Re(this, BO(this, e, r, !1));
  },
  findIndex: function(e, r) {
    var n = this.findEntry(e, r);
    return n ? n[0] : -1;
  },
  indexOf: function(e) {
    var r = this.keyOf(e);
    return r === void 0 ? -1 : r;
  },
  lastIndexOf: function(e) {
    var r = this.lastKeyOf(e);
    return r === void 0 ? -1 : r;
  },
  reverse: function() {
    return Re(this, e0(this, !1));
  },
  slice: function(e, r) {
    return Re(this, r0(this, e, r, !1));
  },
  splice: function(e, r) {
    var n = arguments.length;
    if (r = Math.max(r || 0, 0), n === 0 || n === 2 && !r)
      return this;
    e = Fl(e, e < 0 ? this.count() : this.size);
    var i = this.slice(0, e);
    return Re(
      this,
      n === 1 ? i : i.concat(Vo(arguments, 2), this.slice(e + r))
    );
  },
  // ### More collection methods
  findLastIndex: function(e, r) {
    var n = this.findLastEntry(e, r);
    return n ? n[0] : -1;
  },
  first: function(e) {
    return this.get(0, e);
  },
  flatten: function(e) {
    return Re(this, KO(this, e, !1));
  },
  get: function(e, r) {
    return e = Pa(this, e), e < 0 || this.size === 1 / 0 || this.size !== void 0 && e > this.size ? r : this.find(function(n, i) {
      return i === e;
    }, void 0, r);
  },
  has: function(e) {
    return e = Pa(this, e), e >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || e < this.size : this.indexOf(e) !== -1);
  },
  interpose: function(e) {
    return Re(this, m2(this, e));
  },
  interleave: function() {
    var e = [this].concat(Vo(arguments)), r = Sh(this.toSeq(), qo.of, e), n = r.flatten(!0);
    return r.size && (n.size = r.size * e.length), Re(this, n);
  },
  keySeq: function() {
    return N2(0, this.size);
  },
  last: function(e) {
    return this.get(-1, e);
  },
  skipWhile: function(e, r) {
    return Re(this, $O(this, e, r, !1));
  },
  zip: function() {
    var e = [this].concat(Vo(arguments));
    return Re(this, Sh(this, gb, e));
  },
  zipAll: function() {
    var e = [this].concat(Vo(arguments));
    return Re(this, Sh(this, gb, e, !0));
  },
  zipWith: function(e) {
    var r = Vo(arguments);
    return r[0] = this, Re(this, Sh(this, e, r));
  }
});
var Cc = fu.prototype;
Cc[DO] = !0;
Cc[Rc] = !0;
lu(Ac, {
  // ### ES6 Collection methods (ES6 Array and Map)
  get: function(e, r) {
    return this.has(e) ? e : r;
  },
  includes: function(e) {
    return this.has(e);
  },
  // ### More sequential methods
  keySeq: function() {
    return this.valueSeq();
  }
});
var Hu = Ac.prototype;
Hu.has = In.includes;
Hu.contains = Hu.includes;
Hu.keys = Hu.values;
lu(Ua, Bl);
lu(qo, Cc);
lu(Tc, Hu);
function _b(t, e, r, n, i, o) {
  return Vi(t.size), t.__iterate(function(s, u, c) {
    i ? (i = !1, r = s) : r = e.call(n, r, s, u, c);
  }, o), r;
}
function U2(t, e) {
  return e;
}
function B2(t, e) {
  return [e, t];
}
function Ah(t) {
  return function() {
    return !t.apply(this, arguments);
  };
}
function mb(t) {
  return function() {
    return -t.apply(this, arguments);
  };
}
function gb() {
  return Vo(arguments);
}
function bb(t, e) {
  return t < e ? 1 : t > e ? -1 : 0;
}
function $2(t) {
  if (t.size === 1 / 0)
    return 0;
  var e = Io(t), r = hr(t), n = e ? 1 : 0, i = t.__iterate(
    r ? e ? function(o, s) {
      n = 31 * n + wb(_i(o), _i(s)) | 0;
    } : function(o, s) {
      n = n + wb(_i(o), _i(s)) | 0;
    } : e ? function(o) {
      n = 31 * n + _i(o) | 0;
    } : function(o) {
      n = n + _i(o) | 0;
    }
  );
  return K2(i, n);
}
function K2(t, e) {
  return e = _f(e, 3432918353), e = _f(e << 15 | e >>> -15, 461845907), e = _f(e << 13 | e >>> -13, 5), e = (e + 3864292196 | 0) ^ t, e = _f(e ^ e >>> 16, 2246822507), e = _f(e ^ e >>> 13, 3266489909), e = ed(e ^ e >>> 16), e;
}
function wb(t, e) {
  return t ^ e + 2654435769 + (t << 6) + (t >> 2) | 0;
}
var ol = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? qy() : uI(r) ? r : qy().withMutations(function(n) {
      var i = Ac(r);
      Vi(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(n) {
    return this(co(n).keySeq());
  }, e.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, e;
}(id);
ol.isOrderedSet = uI;
var hu = ol.prototype;
hu[Rc] = !0;
hu.zip = Cc.zip;
hu.zipWith = Cc.zipWith;
hu.zipAll = Cc.zipAll;
hu.__empty = qy;
hu.__make = dI;
function dI(t, e) {
  var r = Object.create(hu);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var Eb;
function qy() {
  return Eb || (Eb = dI(xf()));
}
function V2(t) {
  if (Dc(t))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (Xo(t))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (t === null || typeof t != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var Vt = function(e, r) {
  var n;
  V2(e);
  var i = function(u) {
    var c = this;
    if (u instanceof i)
      return u;
    if (!(this instanceof i))
      return new i(u);
    if (!n) {
      n = !0;
      var a = Object.keys(e), f = o._indices = {};
      o._name = r, o._keys = a, o._defaultValues = e;
      for (var h = 0; h < a.length; h++) {
        var p = a[h];
        f[p] = h, o[p] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + E0(this) + ' with property "' + p + '" since that property name is part of the Record API.'
        ) : Q2(o, p);
      }
    }
    return this.__ownerID = void 0, this._values = nd().withMutations(function(d) {
      d.setSize(c._keys.length), co(u).forEach(function(_, m) {
        d.set(c._indices[m], _ === c._defaultValues[m] ? void 0 : _);
      });
    }), this;
  }, o = i.prototype = Object.create(je);
  return o.constructor = i, r && (i.displayName = r), i;
};
Vt.prototype.toString = function() {
  for (var e = E0(this) + " { ", r = this._keys, n, i = 0, o = r.length; i !== o; i++)
    n = r[i], e += (i ? ", " : "") + n + ": " + tl(this.get(n));
  return e + " }";
};
Vt.prototype.equals = function(e) {
  return this === e || Dc(e) && Ju(this).equals(Ju(e));
};
Vt.prototype.hashCode = function() {
  return Ju(this).hashCode();
};
Vt.prototype.has = function(e) {
  return this._indices.hasOwnProperty(e);
};
Vt.prototype.get = function(e, r) {
  if (!this.has(e))
    return r;
  var n = this._indices[e], i = this._values.get(n);
  return i === void 0 ? this._defaultValues[e] : i;
};
Vt.prototype.set = function(e, r) {
  if (this.has(e)) {
    var n = this._values.set(
      this._indices[e],
      r === this._defaultValues[e] ? void 0 : r
    );
    if (n !== this._values && !this.__ownerID)
      return w0(this, n);
  }
  return this;
};
Vt.prototype.remove = function(e) {
  return this.set(e);
};
Vt.prototype.clear = function() {
  var e = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : w0(this, e);
};
Vt.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
Vt.prototype.toSeq = function() {
  return Ju(this);
};
Vt.prototype.toJS = function() {
  return Sp(this);
};
Vt.prototype.entries = function() {
  return this.__iterator(io);
};
Vt.prototype.__iterator = function(e, r) {
  return Ju(this).__iterator(e, r);
};
Vt.prototype.__iterate = function(e, r) {
  return Ju(this).__iterate(e, r);
};
Vt.prototype.__ensureOwner = function(e) {
  if (e === this.__ownerID)
    return this;
  var r = this._values.__ensureOwner(e);
  return e ? w0(this, r, e) : (this.__ownerID = e, this._values = r, this);
};
Vt.isRecord = Dc;
Vt.getDescriptiveName = E0;
var je = Vt.prototype;
je[xO] = !0;
je[Ml] = je.remove;
je.deleteIn = je.removeIn = a0;
je.getIn = hI;
je.hasIn = In.hasIn;
je.merge = HO;
je.mergeWith = JO;
je.mergeIn = h0;
je.mergeDeep = XO;
je.mergeDeepWith = tI;
je.mergeDeepIn = p0;
je.setIn = s0;
je.update = u0;
je.updateIn = c0;
je.withMutations = zl;
je.asMutable = Ll;
je.asImmutable = Ul;
je[Xp] = je.entries;
je.toJSON = je.toObject = In.toObject;
je.inspect = je.toSource = function() {
  return this.toString();
};
function w0(t, e, r) {
  var n = Object.create(Object.getPrototypeOf(t));
  return n._values = e, n.__ownerID = r, n;
}
function E0(t) {
  return t.constructor.displayName || t.constructor.name || "Record";
}
function Ju(t) {
  return Z_(t._keys.map(function(e) {
    return [e, t.get(e)];
  }));
}
function Q2(t, e) {
  try {
    Object.defineProperty(t, e, {
      get: function() {
        return this.get(e);
      },
      set: function(r) {
        o0(this.__ownerID, "Cannot set on an immutable record."), this.set(e, r);
      }
    });
  } catch {
  }
}
const Y2 = {
  startDate: void 0,
  endDate: void 0,
  userLimit: 0,
  projectLimit: 0,
  isTrial: !1,
  isExpired: !1,
  functionalities: []
};
class Op extends Vt(Y2, "Subscription") {
  get isValid() {
    return !!this.startDate && !!this.endDate;
  }
  get isActive() {
    return !this.startDate || !this.endDate ? !1 : new jl(this.startDate, this.endDate).contains(Er.now());
  }
  get daysLeft() {
    return this.endDate ? this.endDate.getAbsoluteDifferenceInDays(Er.now()) : 0;
  }
  hasEndDateIncoming() {
    return this.endDate ? this.endDate.isAfterInDays(Er.now()) : !1;
  }
}
class G2 {
  toDomain(e) {
    if (e)
      return e.map((r) => {
        var n;
        return (n = r.id) == null ? void 0 : n.toLowerCase();
      }).filter((r) => !!r) ?? [];
  }
}
const W2 = new G2();
class H2 {
  toDomain(e) {
    return new Op({
      startDate: Er.fromISOStringSafe(e.startDate),
      endDate: Er.fromISOStringSafe(e.endDate),
      userLimit: e.limitUsers,
      projectLimit: e.limitProjects,
      isTrial: e.isTrial,
      isExpired: e.isExpired,
      functionalities: W2.toDomain(e.functionalities)
    });
  }
}
const J2 = new H2();
class Z2 {
  static async fetchSubscription({ accessToken: e, baseUrl: r }, n) {
    const o = await new F_({
      token: e,
      baseUrl: r,
      endpoint: `v1/subscriptions/${n}`
    }).get();
    return J2.toDomain(o);
  }
}
function D9(t, e) {
  const { t: r } = gT(t);
  return {
    getErrorMessage: (n) => {
      let i;
      const o = n.name, s = n.code;
      s ? i = `HTTP_${s}` : i = o;
      const u = r(i);
      return u !== i ? u : r(e);
    }
  };
}
class R9 extends Error {
  constructor() {
    super("Not implemented"), this.name = "NotImplementedError";
  }
}
class x9 extends Error {
  constructor() {
    super("The specified value is not supported"), this.name = "NotSupportedValueError";
  }
}
function vI(t) {
  const e = t;
  return e == null ? void 0 : e.code;
}
const X2 = 3;
function tC(t, e = X2) {
  return (r, n) => {
    const i = vI(n);
    if (!i)
      return !1;
    let o;
    return Array.isArray(t) ? o = t.includes(i) : o = t === i, r <= e && o;
  };
}
var S0 = /* @__PURE__ */ ((t) => (t[t.Continue = 100] = "Continue", t[t.SwitchingProtocols = 101] = "SwitchingProtocols", t[t.Processing = 102] = "Processing", t[t.EarlyHints = 103] = "EarlyHints", t[t.OK = 200] = "OK", t[t.Created = 201] = "Created", t[t.Accepted = 202] = "Accepted", t[t.NonAuthoritativeInformation = 203] = "NonAuthoritativeInformation", t[t.NoContent = 204] = "NoContent", t[t.ResetContent = 205] = "ResetContent", t[t.PartialContent = 206] = "PartialContent", t[t.MultiStatus = 207] = "MultiStatus", t[t.AlreadyReported = 208] = "AlreadyReported", t[t.IMUsed = 226] = "IMUsed", t[t.MultipleChoices = 300] = "MultipleChoices", t[t.MovedPermanently = 301] = "MovedPermanently", t[t.Found = 302] = "Found", t[t.SeeOther = 303] = "SeeOther", t[t.NotModified = 304] = "NotModified", t[t.UseProxy = 305] = "UseProxy", t[t.TemporaryRedirect = 307] = "TemporaryRedirect", t[t.PermanentRedirect = 308] = "PermanentRedirect", t[t.BadRequest = 400] = "BadRequest", t[t.Unauthorized = 401] = "Unauthorized", t[t.PaymentRequired = 402] = "PaymentRequired", t[t.Forbidden = 403] = "Forbidden", t[t.NotFound = 404] = "NotFound", t[t.MethodNotAllowed = 405] = "MethodNotAllowed", t[t.NotAcceptable = 406] = "NotAcceptable", t[t.ProxyAuthenticationRequired = 407] = "ProxyAuthenticationRequired", t[t.RequestTimeout = 408] = "RequestTimeout", t[t.Conflict = 409] = "Conflict", t[t.Gone = 410] = "Gone", t[t.LengthRequired = 411] = "LengthRequired", t[t.PreconditionFailed = 412] = "PreconditionFailed", t[t.PayloadTooLarge = 413] = "PayloadTooLarge", t[t.URITooLong = 414] = "URITooLong", t[t.UnsupportedMediaType = 415] = "UnsupportedMediaType", t[t.RangeNotSatisfiable = 416] = "RangeNotSatisfiable", t[t.ExpectationFailed = 417] = "ExpectationFailed", t[t.ImATeapot = 418] = "ImATeapot", t[t.MisdirectedRequest = 421] = "MisdirectedRequest", t[t.UnprocessableEntity = 422] = "UnprocessableEntity", t[t.Locked = 423] = "Locked", t[t.FailedDependency = 424] = "FailedDependency", t[t.TooEarly = 425] = "TooEarly", t[t.UpgradeRequired = 426] = "UpgradeRequired", t[t.PreconditionRequired = 428] = "PreconditionRequired", t[t.TooManyRequests = 429] = "TooManyRequests", t[t.RequestHeaderFieldsTooLarge = 431] = "RequestHeaderFieldsTooLarge", t[t.UnavailableForLegalReasons = 451] = "UnavailableForLegalReasons", t[t.InternalServerError = 500] = "InternalServerError", t[t.NotImplemented = 501] = "NotImplemented", t[t.BadGateway = 502] = "BadGateway", t[t.ServiceUnavailable = 503] = "ServiceUnavailable", t[t.GatewayTimeout = 504] = "GatewayTimeout", t[t.HTTPVersionNotSupported = 505] = "HTTPVersionNotSupported", t[t.VariantAlsoNegotiates = 506] = "VariantAlsoNegotiates", t[t.InsufficientStorage = 507] = "InsufficientStorage", t[t.LoopDetected = 508] = "LoopDetected", t[t.NotExtended = 510] = "NotExtended", t[t.NetworkAuthenticationRequired = 511] = "NetworkAuthenticationRequired", t))(S0 || {});
const xv = 3e5, yI = new Op(), sp = Mr({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  subscription: yI,
  hasFunctionality: () => !1
}), eC = tC(S0.TooManyRequests), T9 = dO(
  ({
    apiConnectionInfo: t,
    children: e,
    hubHashId: r,
    loadingComponent: n,
    errorComponent: i
  }) => {
    const { accessToken: o, baseUrl: s } = t ?? {}, u = async () => {
      if (!t || !r)
        return Promise.resolve(new Op());
      try {
        return await Z2.fetchSubscription(t, r);
      } catch (d) {
        if (vI(d) === S0.NotFound)
          return Promise.resolve(new Op());
        throw d;
      }
    }, { data: c, error: a, refetch: f, status: h } = pO(
      ["fetchSubscription", o, r, s],
      u,
      {
        enabled: !!o && !!s && !!r,
        cacheTime: xv,
        staleTime: xv,
        refetchInterval: xv,
        retry: eC,
        context: $_
      }
    ), p = Zo(() => ({
      isInitialized: !!c,
      isLoading: h === "loading",
      error: a || void 0,
      subscription: c ?? yI,
      retry: async () => {
        await f();
      },
      hasFunctionality: (d) => (c == null ? void 0 : c.functionalities.includes(d.toLowerCase())) ?? !1
    }), [c, a, f, h]);
    return h === "loading" && n ? /* @__PURE__ */ Ce.jsx(sp.Provider, { value: p, children: n }) : h === "error" && i ? /* @__PURE__ */ Ce.jsx(sp.Provider, { value: p, children: i }) : /* @__PURE__ */ Ce.jsx(sp.Provider, { value: p, children: e });
  },
  "SubscriptionProvider"
);
function P9() {
  const { isInitialized: t, isLoading: e, error: r, retry: n, subscription: i, hasFunctionality: o } = ca(sp);
  return {
    isInitialized: t,
    isLoading: e,
    error: r,
    retry: n,
    subscription: i,
    hasFunctionality: o
  };
}
const _I = Se.createContext({
  i18n: void 0
});
function k9() {
  const { i18n: t } = ca(_I);
  return t;
}
function C9({ children: t, i18n: e }) {
  const { Provider: r } = _I;
  return /* @__PURE__ */ Ce.jsx(r, { value: { i18n: e }, children: /* @__PURE__ */ Ce.jsx(bT, { i18n: e.wrapped, children: t }) });
}
var mI = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(t) {
  (function(e, r) {
    t.exports ? t.exports = r() : e.numeral = r();
  })(Ho, function() {
    var e, r, n = "2.0.6", i = {}, o = {}, s = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, u = {
      currentLocale: s.currentLocale,
      zeroFormat: s.zeroFormat,
      nullFormat: s.nullFormat,
      defaultFormat: s.defaultFormat,
      scalePercentBy100: s.scalePercentBy100
    };
    function c(a, f) {
      this._input = a, this._value = f;
    }
    return e = function(a) {
      var f, h, p, d;
      if (e.isNumeral(a))
        f = a.value();
      else if (a === 0 || typeof a > "u")
        f = 0;
      else if (a === null || r.isNaN(a))
        f = null;
      else if (typeof a == "string")
        if (u.zeroFormat && a === u.zeroFormat)
          f = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          f = null;
        else {
          for (h in i)
            if (d = typeof i[h].regexps.unformat == "function" ? i[h].regexps.unformat() : i[h].regexps.unformat, d && a.match(d)) {
              p = i[h].unformat;
              break;
            }
          p = p || e._.stringToNumber, f = p(a);
        }
      else
        f = Number(a) || null;
      return new c(a, f);
    }, e.version = n, e.isNumeral = function(a) {
      return a instanceof c;
    }, e._ = r = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(a, f, h) {
        var p = o[e.options.currentLocale], d = !1, _ = !1, m = 0, b = "", O = 1e12, S = 1e9, k = 1e6, T = 1e3, x = "", P = !1, R, D, I, j, Y, H, B;
        if (a = a || 0, D = Math.abs(a), e._.includes(f, "(") ? (d = !0, f = f.replace(/[\(|\)]/g, "")) : (e._.includes(f, "+") || e._.includes(f, "-")) && (Y = e._.includes(f, "+") ? f.indexOf("+") : a < 0 ? f.indexOf("-") : -1, f = f.replace(/[\+|\-]/g, "")), e._.includes(f, "a") && (R = f.match(/a(k|m|b|t)?/), R = R ? R[1] : !1, e._.includes(f, " a") && (b = " "), f = f.replace(new RegExp(b + "a[kmbt]?"), ""), D >= O && !R || R === "t" ? (b += p.abbreviations.trillion, a = a / O) : D < O && D >= S && !R || R === "b" ? (b += p.abbreviations.billion, a = a / S) : D < S && D >= k && !R || R === "m" ? (b += p.abbreviations.million, a = a / k) : (D < k && D >= T && !R || R === "k") && (b += p.abbreviations.thousand, a = a / T)), e._.includes(f, "[.]") && (_ = !0, f = f.replace("[.]", ".")), I = a.toString().split(".")[0], j = f.split(".")[1], H = f.indexOf(","), m = (f.split(".")[0].split(",")[0].match(/0/g) || []).length, j ? (e._.includes(j, "[") ? (j = j.replace("]", ""), j = j.split("["), x = e._.toFixed(a, j[0].length + j[1].length, h, j[1].length)) : x = e._.toFixed(a, j.length, h), I = x.split(".")[0], e._.includes(x, ".") ? x = p.delimiters.decimal + x.split(".")[1] : x = "", _ && Number(x.slice(1)) === 0 && (x = "")) : I = e._.toFixed(a, 0, h), b && !R && Number(I) >= 1e3 && b !== p.abbreviations.trillion)
          switch (I = String(Number(I) / 1e3), b) {
            case p.abbreviations.thousand:
              b = p.abbreviations.million;
              break;
            case p.abbreviations.million:
              b = p.abbreviations.billion;
              break;
            case p.abbreviations.billion:
              b = p.abbreviations.trillion;
              break;
          }
        if (e._.includes(I, "-") && (I = I.slice(1), P = !0), I.length < m)
          for (var tt = m - I.length; tt > 0; tt--)
            I = "0" + I;
        return H > -1 && (I = I.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + p.delimiters.thousands)), f.indexOf(".") === 0 && (I = ""), B = I + x + (b || ""), d ? B = (d && P ? "(" : "") + B + (d && P ? ")" : "") : Y >= 0 ? B = Y === 0 ? (P ? "-" : "+") + B : B + (P ? "-" : "+") : P && (B = "-" + B), B;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(a) {
        var f = o[u.currentLocale], h = a, p = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, d, _, m;
        if (u.zeroFormat && a === u.zeroFormat)
          _ = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          _ = null;
        else {
          _ = 1, f.delimiters.decimal !== "." && (a = a.replace(/\./g, "").replace(f.delimiters.decimal, "."));
          for (d in p)
            if (m = new RegExp("[^a-zA-Z]" + f.abbreviations[d] + "(?:\\)|(\\" + f.currency.symbol + ")?(?:\\))?)?$"), h.match(m)) {
              _ *= Math.pow(10, p[d]);
              break;
            }
          _ *= (a.split("-").length + Math.min(a.split("(").length - 1, a.split(")").length - 1)) % 2 ? 1 : -1, a = a.replace(/[^0-9\.]+/g, ""), _ *= Number(a);
        }
        return _;
      },
      isNaN: function(a) {
        return typeof a == "number" && isNaN(a);
      },
      includes: function(a, f) {
        return a.indexOf(f) !== -1;
      },
      insert: function(a, f, h) {
        return a.slice(0, h) + f + a.slice(h);
      },
      reduce: function(a, f) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof f != "function")
          throw new TypeError(f + " is not a function");
        var h = Object(a), p = h.length >>> 0, d = 0, _;
        if (arguments.length === 3)
          _ = arguments[2];
        else {
          for (; d < p && !(d in h); )
            d++;
          if (d >= p)
            throw new TypeError("Reduce of empty array with no initial value");
          _ = h[d++];
        }
        for (; d < p; d++)
          d in h && (_ = f(_, h[d], d, h));
        return _;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(a) {
        var f = a.toString().split(".");
        return f.length < 2 ? 1 : Math.pow(10, f[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var a = Array.prototype.slice.call(arguments);
        return a.reduce(function(f, h) {
          var p = r.multiplier(h);
          return f > p ? f : p;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(a, f, h, p) {
        var d = a.toString().split("."), _ = f - (p || 0), m, b, O, S;
        return d.length === 2 ? m = Math.min(Math.max(d[1].length, _), f) : m = _, O = Math.pow(10, m), S = (h(a + "e+" + m) / O).toFixed(m), p > f - m && (b = new RegExp("\\.?0{1," + (p - (f - m)) + "}$"), S = S.replace(b, "")), S;
      }
    }, e.options = u, e.formats = i, e.locales = o, e.locale = function(a) {
      return a && (u.currentLocale = a.toLowerCase()), u.currentLocale;
    }, e.localeData = function(a) {
      if (!a)
        return o[u.currentLocale];
      if (a = a.toLowerCase(), !o[a])
        throw new Error("Unknown locale : " + a);
      return o[a];
    }, e.reset = function() {
      for (var a in s)
        u[a] = s[a];
    }, e.zeroFormat = function(a) {
      u.zeroFormat = typeof a == "string" ? a : null;
    }, e.nullFormat = function(a) {
      u.nullFormat = typeof a == "string" ? a : null;
    }, e.defaultFormat = function(a) {
      u.defaultFormat = typeof a == "string" ? a : "0.0";
    }, e.register = function(a, f, h) {
      if (f = f.toLowerCase(), this[a + "s"][f])
        throw new TypeError(f + " " + a + " already registered.");
      return this[a + "s"][f] = h, h;
    }, e.validate = function(a, f) {
      var h, p, d, _, m, b, O, S;
      if (typeof a != "string" && (a += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", a)), a = a.trim(), a.match(/^\d+$/))
        return !0;
      if (a === "")
        return !1;
      try {
        O = e.localeData(f);
      } catch {
        O = e.localeData(e.locale());
      }
      return d = O.currency.symbol, m = O.abbreviations, h = O.delimiters.decimal, O.delimiters.thousands === "." ? p = "\\." : p = O.delimiters.thousands, S = a.match(/^[^\d]+/), S !== null && (a = a.substr(1), S[0] !== d) || (S = a.match(/[^\d]+$/), S !== null && (a = a.slice(0, -1), S[0] !== m.thousand && S[0] !== m.million && S[0] !== m.billion && S[0] !== m.trillion)) ? !1 : (b = new RegExp(p + "{2}"), a.match(/[^\d.,]/g) ? !1 : (_ = a.split(h), _.length > 2 ? !1 : _.length < 2 ? !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) : _[0].length === 1 ? !!_[0].match(/^\d+$/) && !_[0].match(b) && !!_[1].match(/^\d+$/) : !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) && !!_[1].match(/^\d+$/)));
    }, e.fn = c.prototype = {
      clone: function() {
        return e(this);
      },
      format: function(a, f) {
        var h = this._value, p = a || u.defaultFormat, d, _, m;
        if (f = f || Math.round, h === 0 && u.zeroFormat !== null)
          _ = u.zeroFormat;
        else if (h === null && u.nullFormat !== null)
          _ = u.nullFormat;
        else {
          for (d in i)
            if (p.match(i[d].regexps.format)) {
              m = i[d].format;
              break;
            }
          m = m || e._.numberToFormat, _ = m(h, p, f);
        }
        return _;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(a) {
        return this._value = Number(a), this;
      },
      add: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p + Math.round(f * d);
        }
        return this._value = r.reduce([this._value, a], h, 0) / f, this;
      },
      subtract: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p - Math.round(f * d);
        }
        return this._value = r.reduce([a], h, Math.round(this._value * f)) / f, this;
      },
      multiply: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) * Math.round(p * m) / Math.round(m * m);
        }
        return this._value = r.reduce([this._value, a], f, 1), this;
      },
      divide: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) / Math.round(p * m);
        }
        return this._value = r.reduce([this._value, a], f), this;
      },
      difference: function(a) {
        return Math.abs(e(this._value).subtract(a).value());
      }
    }, e.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(a) {
        var f = a % 10;
        return ~~(a % 100 / 10) === 1 ? "th" : f === 1 ? "st" : f === 2 ? "nd" : f === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      e.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " BPS") ? " " : "", d;
          return a = a * 1e4, f = f.replace(/\s?BPS/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "BPS"), d = d.join("")) : d = d + p + "BPS", d;
        },
        unformat: function(a) {
          return +(e._.stringToNumber(a) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var a = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, f = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, h = a.suffixes.concat(f.suffixes.filter(function(d) {
        return a.suffixes.indexOf(d) < 0;
      })), p = h.join("|");
      p = "(" + p.replace("B", "B(?!PS)") + ")", e.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(p)
        },
        format: function(d, _, m) {
          var b, O = e._.includes(_, "ib") ? f : a, S = e._.includes(_, " b") || e._.includes(_, " ib") ? " " : "", k, T, x;
          for (_ = _.replace(/\s?i?b/, ""), k = 0; k <= O.suffixes.length; k++)
            if (T = Math.pow(O.base, k), x = Math.pow(O.base, k + 1), d === null || d === 0 || d >= T && d < x) {
              S += O.suffixes[k], T > 0 && (d = d / T);
              break;
            }
          return b = e._.numberToFormat(d, _, m), b + S;
        },
        unformat: function(d) {
          var _ = e._.stringToNumber(d), m, b;
          if (_) {
            for (m = a.suffixes.length - 1; m >= 0; m--) {
              if (e._.includes(d, a.suffixes[m])) {
                b = Math.pow(a.base, m);
                break;
              }
              if (e._.includes(d, f.suffixes[m])) {
                b = Math.pow(f.base, m);
                break;
              }
            }
            _ *= b || 1;
          }
          return _;
        }
      });
    }(), function() {
      e.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d = {
            before: f.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: f.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, _, m, b;
          for (f = f.replace(/\s?\$\s?/, ""), _ = e._.numberToFormat(a, f, h), a >= 0 ? (d.before = d.before.replace(/[\-\(]/, ""), d.after = d.after.replace(/[\-\)]/, "")) : a < 0 && !e._.includes(d.before, "-") && !e._.includes(d.before, "(") && (d.before = "-" + d.before), b = 0; b < d.before.length; b++)
            switch (m = d.before[b], m) {
              case "$":
                _ = e._.insert(_, p.currency.symbol, b);
                break;
              case " ":
                _ = e._.insert(_, " ", b + p.currency.symbol.length - 1);
                break;
            }
          for (b = d.after.length - 1; b >= 0; b--)
            switch (m = d.after[b], m) {
              case "$":
                _ = b === d.after.length - 1 ? _ + p.currency.symbol : e._.insert(_, p.currency.symbol, -(d.after.length - (1 + b)));
                break;
              case " ":
                _ = b === d.after.length - 1 ? _ + " " : e._.insert(_, " ", -(d.after.length - (1 + b) + p.currency.symbol.length - 1));
                break;
            }
          return _;
        }
      });
    }(), function() {
      e.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(a, f, h) {
          var p, d = typeof a == "number" && !e._.isNaN(a) ? a.toExponential() : "0e+0", _ = d.split("e");
          return f = f.replace(/e[\+|\-]{1}0/, ""), p = e._.numberToFormat(Number(_[0]), f, h), p + "e" + _[1];
        },
        unformat: function(a) {
          var f = e._.includes(a, "e+") ? a.split("e+") : a.split("e-"), h = Number(f[0]), p = Number(f[1]);
          p = e._.includes(a, "e-") ? p *= -1 : p;
          function d(_, m, b, O) {
            var S = e._.correctionFactor(_, m), k = _ * S * (m * S) / (S * S);
            return k;
          }
          return e._.reduce([h, Math.pow(10, p)], d, 1);
        }
      });
    }(), function() {
      e.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d, _ = e._.includes(f, " o") ? " " : "";
          return f = f.replace(/\s?o/, ""), _ += p.ordinal(a), d = e._.numberToFormat(a, f, h), d + _;
        }
      });
    }(), function() {
      e.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " %") ? " " : "", d;
          return e.options.scalePercentBy100 && (a = a * 100), f = f.replace(/\s?\%/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "%"), d = d.join("")) : d = d + p + "%", d;
        },
        unformat: function(a) {
          var f = e._.stringToNumber(a);
          return e.options.scalePercentBy100 ? f * 0.01 : f;
        }
      });
    }(), function() {
      e.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(a, f, h) {
          var p = Math.floor(a / 60 / 60), d = Math.floor((a - p * 60 * 60) / 60), _ = Math.round(a - p * 60 * 60 - d * 60);
          return p + ":" + (d < 10 ? "0" + d : d) + ":" + (_ < 10 ? "0" + _ : _);
        },
        unformat: function(a) {
          var f = a.split(":"), h = 0;
          return f.length === 3 ? (h = h + Number(f[0]) * 60 * 60, h = h + Number(f[1]) * 60, h = h + Number(f[2])) : f.length === 2 && (h = h + Number(f[0]) * 60, h = h + Number(f[1])), Number(h);
        }
      });
    }(), e;
  });
})(mI);
var rC = mI.exports;
const nC = /* @__PURE__ */ Kp(rC);
function iC(t, e, r) {
  return e === "uppercase" ? t.toUpperCase() : Er.isDateTime(t) ? t.formatWithLocale(e, r) : typeof t == "number" ? nC(Number(t)).format(e) : t;
}
class sl {
  constructor(e) {
    this.wrappedInstance = e;
  }
  static async createOther(e, r, n, i) {
    const o = sl.buildOptions(e, r, n, i), s = _p.createInstance(o);
    return await s.init(), new sl(s);
  }
  get wrapped() {
    return this.wrappedInstance;
  }
  get language() {
    return this.wrappedInstance.language;
  }
  changeLanguage(e) {
    var r;
    (r = this.wrappedInstance) == null || r.changeLanguage(e);
  }
  static buildOptions(e, r, n, i, o) {
    return {
      returnNull: !1,
      lng: o ?? _p.language,
      supportedLngs: [Zs.EN, Zs.FR],
      nonExplicitSupportedLngs: !0,
      fallbackLng: Zs.EN,
      debug: !1,
      resources: e,
      defaultNS: r,
      fallbackNS: n,
      pluralSeparator: "_",
      interpolation: {
        escapeValue: !1,
        // not needed for react
        format: i ?? iC
      },
      react: {
        defaultTransParent: "span"
      },
      detection: {
        order: ["querystring", "localStorage", "navigator", "htmlTag"],
        lookupQuerystring: "lang",
        lookupLocalStorage: "lang",
        caches: ["localStorage"],
        excludeCacheFor: ["cimode"]
      }
    };
  }
}
const Sb = "user_language", oC = Zs.EN;
class kf extends sl {
  constructor(e, r) {
    super(e), this.storage = r;
  }
  static async createMain(e, r, n, i, o) {
    const s = kf.loadLanguage(i) || oC;
    kf.saveLanguage(s, i);
    const u = sl.buildOptions(e, r, n, o, s);
    return await _p.init(u), new kf(_p, i);
  }
  changeLanguage(e) {
    super.changeLanguage(e), kf.saveLanguage(e, this.storage);
  }
  static loadLanguage(e) {
    return e == null ? void 0 : e.readString(Sb);
  }
  static saveLanguage(e, r) {
    r == null || r.writeString(Sb, e);
  }
}
var gI = /* @__PURE__ */ ((t) => (t[t.LOCAL = -1] = "LOCAL", t[t.CANADA = 0] = "CANADA", t[t.NORTH_EUROPE = 1] = "NORTH_EUROPE", t[t.EUROPE = 2] = "EUROPE", t[t.USA = 3] = "USA", t))(gI || {});
const sC = {
  id: gI.LOCAL,
  name: ""
};
class aC extends Vt(sC, "DataCenterAttribute") {
}
var bI = /* @__PURE__ */ ((t) => (t.EN_US = "M/D/YYYY h:mm A", t.EN_CA = "YYYY-MM-DD h:mm A", t.FR_CA = "DD/MM/YYYY HH:mm", t))(bI || {}), Uu = /* @__PURE__ */ ((t) => (t.GUEST = "Guest", t.ADMIN = "Admin", t))(Uu || {}), ap = /* @__PURE__ */ ((t) => (t.UTC = "UTC", t.NEW_YORK = "America/New_York", t.DUBAI = "Asia/Asia/Dubai", t))(ap || {}), wI = /* @__PURE__ */ ((t) => (t.ACTIVE = "Active", t.INACTIVE = "Inactive", t))(wI || {});
const uC = {
  role: Uu.GUEST
};
class cC extends Vt(uC, "HubUserPermissions") {
}
const fC = {
  globalId: void 0,
  hashId: "",
  localId: -1,
  name: "",
  creationDate: Er.MIN_VALUE,
  demoDaysLeft: void 0,
  owner: "",
  dataCenterInfo: new aC(),
  metrics: void 0,
  projects: [],
  avatarImage: void 0,
  isLinkedToOrganization: !1,
  url: "",
  subscription: void 0,
  projectTemplates: void 0,
  bimTrackRegionalApiUrl: void 0,
  requestingUserPermissions: new cC()
};
class j9 extends Vt(fC, "Hub") {
  /**
   * @deprecated use hashId instead.
   */
  get id() {
    return this.hashId;
  }
  /**
   * @deprecated use dataCenterInfo.id instead.
   */
  get dataCenter() {
    return this.dataCenterInfo.id;
  }
  get avatarImageWithDefault() {
    return this.avatarImage;
  }
  get isSubscriptionExpired() {
    return this.subscription ? this.subscription.isExpired : !1;
  }
  get subscriptionPlanProjectLimit() {
    return this.subscription ? this.subscription.projectLimit : 0;
  }
  is(e) {
    return e ? this.id === e.id && this.localId === e.localId : !1;
  }
}
const lC = {
  totalUsers: void 0
};
class q9 extends Vt(lC, "HubMetrics") {
}
var hC = /* @__PURE__ */ ((t) => (t.PROCORE = "Procore", t))(hC || {}), Ci = /* @__PURE__ */ ((t) => (t.TEXT = "text", t.PREDEFINED = "predefined", t.TITLE = "title", t.DESCRIPTION = "description", t.STATUS = "status", t.TYPE = "type", t.PRIORITY = "priority", t.DISCIPLINE = "discipline", t.ZONE = "zone", t.PHASE = "phase", t.ASSIGNED_TO = "assignedto", t.DUE_DATE = "duedate", t.ISSUE_GROUP = "issuegroup", t.TEAM = "team", t.NOTIFY = "notify", t.CONFIDENTIALITY = "confidentiality", t.VISIBILITY = "visibility", t))(Ci || {}), O0 = /* @__PURE__ */ ((t) => (t.ADMIN = "Admin", t.EDITOR = "Editor", t.READER = "Reader", t))(O0 || {}), EI = /* @__PURE__ */ ((t) => (t[t.ACTIVE = 0] = "ACTIVE", t[t.ON_HOLD = 1] = "ON_HOLD", t[t.COMPLETION_PENDING = 2] = "COMPLETION_PENDING", t[t.COMPLETED = 3] = "COMPLETED", t))(EI || {}), pC = /* @__PURE__ */ ((t) => (t[t.None = 0] = "None", t[t.FileManagement = 2] = "FileManagement", t))(pC || {});
const dC = {
  statuses: [],
  types: [],
  priorities: [],
  zones: [],
  phases: [],
  disciplines: [],
  customAttributes: []
};
class vC extends Vt(dC, "IssueAttributeOptions") {
}
const yC = {
  id: -1,
  name: "",
  type: Ci.TEXT,
  values: void 0
};
class _C extends Vt(yC, "ProjectAttribute") {
}
const mC = {
  attributes: [],
  selectedColorAttributeForIssue: new _C(),
  integrations: [],
  issueMandatoryAttributes: []
};
class gC extends Vt(mC, "ProjectSettings") {
}
const bC = {
  role: O0.READER,
  teams: [],
  isReviewer: !1
};
class wC extends Vt(bC, "ProjectUserPermissions") {
}
const EC = {
  id: -1,
  name: "",
  number: "",
  status: EI.ACTIVE,
  settings: new gC(),
  users: [],
  teams: [],
  requestingUserPermissions: new wC()
};
class M9 extends Vt(EC, "Project") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
  getIssueGroupsOptions() {
    return this.getOptionsFor(Ci.ISSUE_GROUP);
  }
  getAttributesFor(e) {
    return this.settings.attributes.filter(
      (n) => n.type === e
    ) || [];
  }
  getSortedCustomAttributes() {
    return [
      ...this.getAttributesFor(Ci.TEXT),
      ...this.getAttributesFor(Ci.PREDEFINED)
    ].sort((r, n) => r.id - n.id);
  }
  getOptionsFor(e) {
    const r = this.settings.attributes.find(
      (n) => n.type === e
    );
    return r && r.values ? r.values : [];
  }
  getOptionsForIssue() {
    const e = this.getOptionsFor(Ci.STATUS), r = this.getOptionsFor(Ci.TYPE), n = this.getOptionsFor(Ci.PRIORITY), i = this.getOptionsFor(Ci.ZONE), o = this.getOptionsFor(Ci.PHASE), s = this.getOptionsFor(Ci.DISCIPLINE), u = this.getSortedCustomAttributes();
    return new vC({
      statuses: e,
      types: r,
      priorities: n,
      zones: i,
      phases: o,
      disciplines: s,
      customAttributes: u
    });
  }
  getStatusesBaseOnUser(e, r) {
    const n = e.teams ?? [];
    let i = this.getOptionsFor(Ci.STATUS).filter((o) => {
      const s = o.teams ? o.teams.map((u) => u.id) : [];
      return s.length === 0 || n.some((u) => s.indexOf(u.id) !== -1);
    });
    return i.some((o) => o.id === r.id) || (i = [...i, r].sort((o, s) => o.name.localeCompare(s.name))), i;
  }
  getIntegrationFor(e) {
    return this.settings.integrations.find(
      (r) => r.integration.name.toLowerCase() === e.toLowerCase()
    );
  }
  getIssueMandatoryAttributes() {
    return this.settings.issueMandatoryAttributes;
  }
  getAttributes() {
    return this.settings.attributes;
  }
}
const SC = {
  id: -1,
  name: ""
};
class F9 extends Vt(SC, "ProjectTemplate") {
}
const OC = {
  id: -1,
  name: ""
};
class N9 extends Vt(OC, "ProjectTeam") {
}
const IC = {
  id: -1,
  name: "",
  siteUrl: ""
};
class AC extends Vt(IC, "Integration") {
}
const DC = {
  id: -1,
  name: "",
  color: void 0,
  teams: void 0
};
class z9 extends Vt(DC, "ProjectAttributeValue") {
}
const RC = {
  companyId: -1,
  companyName: "",
  projectId: -1,
  projectName: "",
  createRFIComment: !1
};
class L9 extends Vt(RC, "ProcoreIntegrationData") {
}
const xC = {
  id: -1,
  integration: new AC(),
  data: {}
};
class U9 extends Vt(xC, "ProjectIntegration") {
}
const TC = {
  id: "",
  name: ""
};
class B9 extends Vt(TC, "PropertyAttribute") {
}
const PC = {
  user: void 0,
  hub: void 0,
  project: void 0,
  bimTrackApiUrl: ""
};
class $9 extends Vt(PC, "Session") {
}
const K9 = {
  trial: "ea0b2704-81d5-46e2-b4fd-b21dcbabbbc8"
}, V9 = {
  viewer3D: {
    access3dViewer: "DC7C3D37-B1F5-4D37-A845-D0142456C63C"
  },
  channels: {
    channelsManagement: "B45F232D-A47A-4A74-8C1C-261225EFFA33"
  },
  email: {
    emailManagement: "F4A0BF34-DBD0-4EB0-9816-2BE2F98FE8D9",
    noDeleteEmail: "C1C96C15-59CD-48F8-9DBF-EFFF5D415784"
  },
  rfi: {
    workflow: "76A6ED51-6F7C-40FE-B61A-09254BA2E217"
  },
  changeManagement: {
    accessChangeManagement: "EFF42D92-E59E-44C7-A703-6DA7B2F5BF17"
  },
  edmsConnector: {
    sharingData: "649BD28E-E95F-4C4A-ADCA-5AC4A7D29297"
  },
  documentControl: {
    accessDocumentControl: "80d35536-1690-4ddd-80d1-dafc400ec3a4"
  }
}, kC = {
  id: "",
  name: "",
  format: bI.EN_US
};
class CC extends Vt(kC, "DateFormatAttribute") {
}
const jC = {
  id: Zs.EN,
  name: ""
};
class qC extends Vt(jC, "LanguageAttribute") {
}
const MC = {
  id: ap.NEW_YORK,
  name: ap.NEW_YORK,
  nameIana: ap.NEW_YORK,
  offset: void 0
};
class FC extends Vt(MC, "TimeZoneAttribute") {
}
const NC = {
  firstName: "",
  lastName: "",
  title: "",
  company: "",
  country: void 0,
  industry: void 0,
  jobTitle: "",
  dateFormat: new CC(),
  avatarImage: "",
  language: new qC(),
  website: void 0,
  timeZone: new FC()
};
class zC extends Vt(NC, "UserProfile") {
  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
  get initials() {
    return this.firstName && this.lastName ? `${Array.from(this.firstName)[0]}${Array.from(this.lastName)[0]}` : "";
  }
  getDateTimeFormat() {
    return this.dateFormat.format;
  }
  getDateFormat() {
    return this.dateFormat.format.replace(/ .*/, "");
  }
  getTimeFormat() {
    return this.dateFormat.format.replace(/([^\s]+) /, "");
  }
}
const LC = {
  id: 0,
  globalId: void 0,
  email: "",
  profile: new zC(),
  status: wI.INACTIVE,
  activationDate: void 0,
  invitationPending: !1,
  isPending: !1,
  lastHubProjectActivity: void 0,
  canResendInvite: void 0,
  hubOwner: !1,
  hubRole: Uu.GUEST,
  projectOwner: !1,
  projectReviewer: !1,
  projectRole: void 0,
  projects: [],
  teams: [],
  isProviderExternal: !1,
  isLoggedWithSso: !1,
  isHubUserSsoRestricted: !1,
  isEmailChangeMandatory: !1
};
class Q9 extends Vt(LC, "User") {
  get fullName() {
    return this.isValid() ? this.profile.fullName : `${this.profile.title}`.trim();
  }
  get fullNameAndEmail() {
    return `${this.fullName} (${this.email})`.trim();
  }
  get initials() {
    return this.profile.initials;
  }
  isNew() {
    return this.id === 0;
  }
  isOwner() {
    return this.hubOwner;
  }
  isAdmin() {
    return this.hubRole === Uu.ADMIN;
  }
  isGuest() {
    return this.hubRole === Uu.GUEST;
  }
  isProjectAdmin() {
    return this.projectRole === O0.ADMIN;
  }
  isProjectOwner() {
    return this.projectOwner;
  }
  isTeamMember(e) {
    return this.teams.some((r) => r.id === e);
  }
  canEditUser(e) {
    return this.is(e) || this.hubRole === Uu.GUEST ? !1 : this.isOwner() || !e.isOwner();
  }
  is(e) {
    return e ? this.globalId && e.globalId ? this.globalId === e.globalId : this.id === e.id : !1;
  }
  getDateTimeFormat() {
    return this.profile.getDateTimeFormat();
  }
  getDateFormat() {
    return this.profile.getDateFormat();
  }
  getTimeFormat() {
    return this.profile.getTimeFormat();
  }
  isValid() {
    return this.id > 0 || !!this.globalId;
  }
}
const UC = {
  id: -1,
  name: ""
};
class Y9 extends Vt(UC, "UserProject") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
}
function G9(t) {
  return Object.keys(t).filter((e) => Number.isNaN(+e));
}
function W9(t) {
  if (t == null)
    throw new Error(`Expected 'val' to be defined, but received ${t}`);
}
function SI(t) {
  if (Vt.isRecord(t))
    switch (Vt.getDescriptiveName(t)) {
      case "Session": {
        const { hub: e, project: r } = t;
        return {
          hubHashId: (e == null ? void 0 : e.hashId) ?? null,
          projectId: (r == null ? void 0 : r.id) ?? null
        };
      }
      case "Hub": {
        const e = t;
        return {
          hubHashId: (e == null ? void 0 : e.hashId) ?? null
        };
      }
      case "Project": {
        const e = t;
        return {
          projectId: (e == null ? void 0 : e.id) ?? null
        };
      }
    }
}
function H9(...t) {
  const e = [];
  let r, n = 0;
  typeof t[n] == "string" && e.push(t[n++]), r = t[n++], Array.isArray(r) || (r = [r]);
  for (const i of r)
    e.push(i == null ? void 0 : i.accessToken), e.push(i == null ? void 0 : i.baseUrl);
  for (; n < t.length; ++n) {
    const i = t[n], o = SI(i);
    if (!o) {
      e.push(i);
      continue;
    }
    o.hubHashId !== void 0 && e.push((o == null ? void 0 : o.hubHashId) ?? void 0), o.projectId !== void 0 && e.push(o.projectId ?? void 0);
  }
  return e;
}
function mf(t) {
  return typeof t == "number" ? !0 : !!t;
}
function J9(...t) {
  let e, r = 0;
  e = t[r++], Array.isArray(e) || (e = [e]);
  for (const n of e)
    if (!mf(n == null ? void 0 : n.accessToken) || !mf(n == null ? void 0 : n.baseUrl))
      return !1;
  for (; r < t.length; ++r) {
    const n = t[r], i = SI(n);
    if (!i) {
      if (!mf(t[r]))
        return !1;
      continue;
    }
    if (i.hubHashId !== void 0 && !mf(i.hubHashId) || i.projectId !== void 0 && !mf(i.projectId))
      return !1;
  }
  return !0;
}
function Z9(t) {
  return t.replace(/(\/v\d+\/*$)|(\/+$)/is, "");
}
var BC = Object.defineProperty, $C = (t, e, r) => e in t ? BC(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Ob = (t, e, r) => ($C(t, typeof e != "symbol" ? e + "" : e, r), r), Ws = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ip = { exports: {} };
Ip.exports;
(function(t, e) {
  var r = 200, n = "Expected a function", i = "__lodash_hash_undefined__", o = 1, s = 2, u = 1 / 0, c = 9007199254740991, a = "[object Arguments]", f = "[object Array]", h = "[object Boolean]", p = "[object Date]", d = "[object Error]", _ = "[object Function]", m = "[object GeneratorFunction]", b = "[object Map]", O = "[object Number]", S = "[object Object]", k = "[object Promise]", T = "[object RegExp]", x = "[object Set]", P = "[object String]", R = "[object Symbol]", D = "[object WeakMap]", I = "[object ArrayBuffer]", j = "[object DataView]", Y = "[object Float32Array]", H = "[object Float64Array]", B = "[object Int8Array]", tt = "[object Int16Array]", lt = "[object Int32Array]", te = "[object Uint8Array]", pt = "[object Uint8ClampedArray]", At = "[object Uint16Array]", ft = "[object Uint32Array]", Lt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, dt = /^\w*$/, mt = /^\./, st = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Nt = /[\\^$.*+?()[\]{}|]/g, Qt = /\\(\\)?/g, Rt = /^\[object .+?Constructor\]$/, xt = /^(?:0|[1-9]\d*)$/, N = {};
  N[Y] = N[H] = N[B] = N[tt] = N[lt] = N[te] = N[pt] = N[At] = N[ft] = !0, N[a] = N[f] = N[I] = N[h] = N[j] = N[p] = N[d] = N[_] = N[b] = N[O] = N[S] = N[T] = N[x] = N[P] = N[D] = !1;
  var ht = typeof Ws == "object" && Ws && Ws.Object === Object && Ws, gt = typeof self == "object" && self && self.Object === Object && self, X = ht || gt || Function("return this")(), wt = e && !e.nodeType && e, jt = wt && !0 && t && !t.nodeType && t, qt = jt && jt.exports === wt, U = qt && ht.process, $ = function() {
    try {
      return U && U.binding("util");
    } catch {
    }
  }(), W = $ && $.isTypedArray;
  function et(l, v) {
    for (var g = -1, E = l ? l.length : 0; ++g < E; )
      if (v(l[g], g, l))
        return !0;
    return !1;
  }
  function ot(l) {
    return function(v) {
      return v == null ? void 0 : v[l];
    };
  }
  function Dt(l, v) {
    for (var g = -1, E = Array(l); ++g < l; )
      E[g] = v(g);
    return E;
  }
  function St(l) {
    return function(v) {
      return l(v);
    };
  }
  function Et(l, v) {
    return l == null ? void 0 : l[v];
  }
  function ue(l) {
    var v = !1;
    if (l != null && typeof l.toString != "function")
      try {
        v = !!(l + "");
      } catch {
      }
    return v;
  }
  function ae(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E, M) {
      g[++v] = [M, E];
    }), g;
  }
  function ce(l, v) {
    return function(g) {
      return l(v(g));
    };
  }
  function Yt(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E) {
      g[++v] = E;
    }), g;
  }
  var Ot = Array.prototype, Oe = Function.prototype, Gt = Object.prototype, se = X["__core-js_shared__"], Zt = function() {
    var l = /[^.]+$/.exec(se && se.keys && se.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), fe = Oe.toString, vt = Gt.hasOwnProperty, Mt = Gt.toString, Fr = RegExp(
    "^" + fe.call(vt).replace(Nt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), We = X.Symbol, He = X.Uint8Array, Nr = Gt.propertyIsEnumerable, Ie = Ot.splice, Je = ce(Object.keys, Object), It = _e(X, "DataView"), Tt = _e(X, "Map"), ee = _e(X, "Promise"), ye = _e(X, "Set"), Ae = _e(X, "WeakMap"), Ut = _e(Object, "create"), zr = ne(It), Ze = ne(Tt), Xe = ne(ee), Lr = ne(ye), Ur = ne(Ae), re = We ? We.prototype : void 0, De = re ? re.valueOf : void 0, tr = re ? re.toString : void 0;
  function Pt(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Br() {
    this.__data__ = Ut ? Ut(null) : {};
  }
  function y(l) {
    return this.has(l) && delete this.__data__[l];
  }
  function w(l) {
    var v = this.__data__;
    if (Ut) {
      var g = v[l];
      return g === i ? void 0 : g;
    }
    return vt.call(v, l) ? v[l] : void 0;
  }
  function A(l) {
    var v = this.__data__;
    return Ut ? v[l] !== void 0 : vt.call(v, l);
  }
  function q(l, v) {
    var g = this.__data__;
    return g[l] = Ut && v === void 0 ? i : v, this;
  }
  Pt.prototype.clear = Br, Pt.prototype.delete = y, Pt.prototype.get = w, Pt.prototype.has = A, Pt.prototype.set = q;
  function F(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Q() {
    this.__data__ = [];
  }
  function L(l) {
    var v = this.__data__, g = nr(v, l);
    if (g < 0)
      return !1;
    var E = v.length - 1;
    return g == E ? v.pop() : Ie.call(v, g, 1), !0;
  }
  function z(l) {
    var v = this.__data__, g = nr(v, l);
    return g < 0 ? void 0 : v[g][1];
  }
  function it(l) {
    return nr(this.__data__, l) > -1;
  }
  function J(l, v) {
    var g = this.__data__, E = nr(g, l);
    return E < 0 ? g.push([l, v]) : g[E][1] = v, this;
  }
  F.prototype.clear = Q, F.prototype.delete = L, F.prototype.get = z, F.prototype.has = it, F.prototype.set = J;
  function K(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function ut() {
    this.__data__ = {
      hash: new Pt(),
      map: new (Tt || F)(),
      string: new Pt()
    };
  }
  function Bt(l) {
    return ir(this, l).delete(l);
  }
  function er(l) {
    return ir(this, l).get(l);
  }
  function bt(l) {
    return ir(this, l).has(l);
  }
  function cs(l, v) {
    return ir(this, l).set(l, v), this;
  }
  K.prototype.clear = ut, K.prototype.delete = Bt, K.prototype.get = er, K.prototype.has = bt, K.prototype.set = cs;
  function rr(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.__data__ = new K(); ++v < g; )
      this.add(l[v]);
  }
  function fs(l) {
    return this.__data__.set(l, i), this;
  }
  function ls(l) {
    return this.__data__.has(l);
  }
  rr.prototype.add = rr.prototype.push = fs, rr.prototype.has = ls;
  function kt(l) {
    this.__data__ = new F(l);
  }
  function hs() {
    this.__data__ = new F();
  }
  function ps(l) {
    return this.__data__.delete(l);
  }
  function ds(l) {
    return this.__data__.get(l);
  }
  function vs(l) {
    return this.__data__.has(l);
  }
  function ys(l, v) {
    var g = this.__data__;
    if (g instanceof F) {
      var E = g.__data__;
      if (!Tt || E.length < r - 1)
        return E.push([l, v]), this;
      g = this.__data__ = new K(E);
    }
    return g.set(l, v), this;
  }
  kt.prototype.clear = hs, kt.prototype.delete = ps, kt.prototype.get = ds, kt.prototype.has = vs, kt.prototype.set = ys;
  function _s(l, v) {
    var g = ie(l) || Jn(l) ? Dt(l.length, String) : [], E = g.length, M = !!E;
    for (var C in l)
      (v || vt.call(l, C)) && !(M && (C == "length" || Yn(C, E))) && g.push(C);
    return g;
  }
  function nr(l, v) {
    for (var g = l.length; g--; )
      if (Hn(l[g][0], v))
        return g;
    return -1;
  }
  var ms = ks();
  function gs(l, v) {
    return l && ms(l, v, cr);
  }
  function Kn(l, v) {
    v = or(v, l) ? [v] : Vn(v);
    for (var g = 0, E = v.length; l != null && g < E; )
      l = l[sr(v[g++])];
    return g && g == E ? l : void 0;
  }
  function bs(l) {
    return Mt.call(l);
  }
  function ws(l, v) {
    return l != null && v in Object(l);
  }
  function $r(l, v, g, E, M) {
    return l === v ? !0 : l == null || v == null || !ar(l) && !ur(v) ? l !== l && v !== v : Es(l, v, $r, g, E, M);
  }
  function Es(l, v, g, E, M, C) {
    var V = ie(l), G = ie(v), Z = f, rt = f;
    V || (Z = $t(l), Z = Z == a ? S : Z), G || (rt = $t(v), rt = rt == a ? S : rt);
    var at = Z == S && !ue(l), ct = rt == S && !ue(v), nt = Z == rt;
    if (nt && !at)
      return C || (C = new kt()), V || Bs(l) ? Qn(l, v, g, E, M, C) : Cs(l, v, Z, g, E, M, C);
    if (!(M & s)) {
      var yt = at && vt.call(l, "__wrapped__"), _t = ct && vt.call(v, "__wrapped__");
      if (yt || _t) {
        var Kt = yt ? l.value() : l, Ct = _t ? v.value() : v;
        return C || (C = new kt()), g(Kt, Ct, E, M, C);
      }
    }
    return nt ? (C || (C = new kt()), js(l, v, g, E, M, C)) : !1;
  }
  function Ss(l, v, g, E) {
    var M = g.length, C = M, V = !E;
    if (l == null)
      return !C;
    for (l = Object(l); M--; ) {
      var G = g[M];
      if (V && G[2] ? G[1] !== l[G[0]] : !(G[0] in l))
        return !1;
    }
    for (; ++M < C; ) {
      G = g[M];
      var Z = G[0], rt = l[Z], at = G[1];
      if (V && G[2]) {
        if (rt === void 0 && !(Z in l))
          return !1;
      } else {
        var ct = new kt();
        if (E)
          var nt = E(rt, at, Z, l, v, ct);
        if (!(nt === void 0 ? $r(at, rt, E, o | s, ct) : nt))
          return !1;
      }
    }
    return !0;
  }
  function Os(l) {
    if (!ar(l) || Ns(l))
      return !1;
    var v = Xn(l) || ue(l) ? Fr : Rt;
    return v.test(ne(l));
  }
  function Is(l) {
    return ur(l) && Vr(l.length) && !!N[Mt.call(l)];
  }
  function As(l) {
    return typeof l == "function" ? l : l == null ? Ys : typeof l == "object" ? ie(l) ? xs(l[0], l[1]) : Rs(l) : Gs(l);
  }
  function Ds(l) {
    if (!zs(l))
      return Je(l);
    var v = [];
    for (var g in Object(l))
      vt.call(l, g) && g != "constructor" && v.push(g);
    return v;
  }
  function Rs(l) {
    var v = qs(l);
    return v.length == 1 && v[0][2] ? Wn(v[0][0], v[0][1]) : function(g) {
      return g === l || Ss(g, l, v);
    };
  }
  function xs(l, v) {
    return or(l) && Gn(v) ? Wn(sr(l), v) : function(g) {
      var E = Ks(g, l);
      return E === void 0 && E === v ? Vs(g, l) : $r(v, E, void 0, o | s);
    };
  }
  function Ts(l) {
    return function(v) {
      return Kn(v, l);
    };
  }
  function Ps(l) {
    if (typeof l == "string")
      return l;
    if (Qr(l))
      return tr ? tr.call(l) : "";
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function Vn(l) {
    return ie(l) ? l : Ls(l);
  }
  function ks(l) {
    return function(v, g, E) {
      for (var M = -1, C = Object(v), V = E(v), G = V.length; G--; ) {
        var Z = V[l ? G : ++M];
        if (g(C[Z], Z, C) === !1)
          break;
      }
      return v;
    };
  }
  function Qn(l, v, g, E, M, C) {
    var V = M & s, G = l.length, Z = v.length;
    if (G != Z && !(V && Z > G))
      return !1;
    var rt = C.get(l);
    if (rt && C.get(v))
      return rt == v;
    var at = -1, ct = !0, nt = M & o ? new rr() : void 0;
    for (C.set(l, v), C.set(v, l); ++at < G; ) {
      var yt = l[at], _t = v[at];
      if (E)
        var Kt = V ? E(_t, yt, at, v, l, C) : E(yt, _t, at, l, v, C);
      if (Kt !== void 0) {
        if (Kt)
          continue;
        ct = !1;
        break;
      }
      if (nt) {
        if (!et(v, function(Ct, oe) {
          if (!nt.has(oe) && (yt === Ct || g(yt, Ct, E, M, C)))
            return nt.add(oe);
        })) {
          ct = !1;
          break;
        }
      } else if (!(yt === _t || g(yt, _t, E, M, C))) {
        ct = !1;
        break;
      }
    }
    return C.delete(l), C.delete(v), ct;
  }
  function Cs(l, v, g, E, M, C, V) {
    switch (g) {
      case j:
        if (l.byteLength != v.byteLength || l.byteOffset != v.byteOffset)
          return !1;
        l = l.buffer, v = v.buffer;
      case I:
        return !(l.byteLength != v.byteLength || !E(new He(l), new He(v)));
      case h:
      case p:
      case O:
        return Hn(+l, +v);
      case d:
        return l.name == v.name && l.message == v.message;
      case T:
      case P:
        return l == v + "";
      case b:
        var G = ae;
      case x:
        var Z = C & s;
        if (G || (G = Yt), l.size != v.size && !Z)
          return !1;
        var rt = V.get(l);
        if (rt)
          return rt == v;
        C |= o, V.set(l, v);
        var at = Qn(G(l), G(v), E, M, C, V);
        return V.delete(l), at;
      case R:
        if (De)
          return De.call(l) == De.call(v);
    }
    return !1;
  }
  function js(l, v, g, E, M, C) {
    var V = M & s, G = cr(l), Z = G.length, rt = cr(v), at = rt.length;
    if (Z != at && !V)
      return !1;
    for (var ct = Z; ct--; ) {
      var nt = G[ct];
      if (!(V ? nt in v : vt.call(v, nt)))
        return !1;
    }
    var yt = C.get(l);
    if (yt && C.get(v))
      return yt == v;
    var _t = !0;
    C.set(l, v), C.set(v, l);
    for (var Kt = V; ++ct < Z; ) {
      nt = G[ct];
      var Ct = l[nt], oe = v[nt];
      if (E)
        var ti = V ? E(oe, Ct, nt, v, l, C) : E(Ct, oe, nt, l, v, C);
      if (!(ti === void 0 ? Ct === oe || g(Ct, oe, E, M, C) : ti)) {
        _t = !1;
        break;
      }
      Kt || (Kt = nt == "constructor");
    }
    if (_t && !Kt) {
      var fr = l.constructor, lr = v.constructor;
      fr != lr && "constructor" in l && "constructor" in v && !(typeof fr == "function" && fr instanceof fr && typeof lr == "function" && lr instanceof lr) && (_t = !1);
    }
    return C.delete(l), C.delete(v), _t;
  }
  function ir(l, v) {
    var g = l.__data__;
    return Fs(v) ? g[typeof v == "string" ? "string" : "hash"] : g.map;
  }
  function qs(l) {
    for (var v = cr(l), g = v.length; g--; ) {
      var E = v[g], M = l[E];
      v[g] = [E, M, Gn(M)];
    }
    return v;
  }
  function _e(l, v) {
    var g = Et(l, v);
    return Os(g) ? g : void 0;
  }
  var $t = bs;
  (It && $t(new It(new ArrayBuffer(1))) != j || Tt && $t(new Tt()) != b || ee && $t(ee.resolve()) != k || ye && $t(new ye()) != x || Ae && $t(new Ae()) != D) && ($t = function(l) {
    var v = Mt.call(l), g = v == S ? l.constructor : void 0, E = g ? ne(g) : void 0;
    if (E)
      switch (E) {
        case zr:
          return j;
        case Ze:
          return b;
        case Xe:
          return k;
        case Lr:
          return x;
        case Ur:
          return D;
      }
    return v;
  });
  function Ms(l, v, g) {
    v = or(v, l) ? [v] : Vn(v);
    for (var E, M = -1, V = v.length; ++M < V; ) {
      var C = sr(v[M]);
      if (!(E = l != null && g(l, C)))
        break;
      l = l[C];
    }
    if (E)
      return E;
    var V = l ? l.length : 0;
    return !!V && Vr(V) && Yn(C, V) && (ie(l) || Jn(l));
  }
  function Yn(l, v) {
    return v = v ?? c, !!v && (typeof l == "number" || xt.test(l)) && l > -1 && l % 1 == 0 && l < v;
  }
  function or(l, v) {
    if (ie(l))
      return !1;
    var g = typeof l;
    return g == "number" || g == "symbol" || g == "boolean" || l == null || Qr(l) ? !0 : dt.test(l) || !Lt.test(l) || v != null && l in Object(v);
  }
  function Fs(l) {
    var v = typeof l;
    return v == "string" || v == "number" || v == "symbol" || v == "boolean" ? l !== "__proto__" : l === null;
  }
  function Ns(l) {
    return !!Zt && Zt in l;
  }
  function zs(l) {
    var v = l && l.constructor, g = typeof v == "function" && v.prototype || Gt;
    return l === g;
  }
  function Gn(l) {
    return l === l && !ar(l);
  }
  function Wn(l, v) {
    return function(g) {
      return g == null ? !1 : g[l] === v && (v !== void 0 || l in Object(g));
    };
  }
  var Ls = Kr(function(l) {
    l = $s(l);
    var v = [];
    return mt.test(l) && v.push(""), l.replace(st, function(g, E, M, C) {
      v.push(M ? C.replace(Qt, "$1") : E || g);
    }), v;
  });
  function sr(l) {
    if (typeof l == "string" || Qr(l))
      return l;
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function ne(l) {
    if (l != null) {
      try {
        return fe.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function Kr(l, v) {
    if (typeof l != "function" || v && typeof v != "function")
      throw new TypeError(n);
    var g = function() {
      var E = arguments, M = v ? v.apply(this, E) : E[0], C = g.cache;
      if (C.has(M))
        return C.get(M);
      var V = l.apply(this, E);
      return g.cache = C.set(M, V), V;
    };
    return g.cache = new (Kr.Cache || K)(), g;
  }
  Kr.Cache = K;
  function Hn(l, v) {
    return l === v || l !== l && v !== v;
  }
  function Jn(l) {
    return Us(l) && vt.call(l, "callee") && (!Nr.call(l, "callee") || Mt.call(l) == a);
  }
  var ie = Array.isArray;
  function Zn(l) {
    return l != null && Vr(l.length) && !Xn(l);
  }
  function Us(l) {
    return ur(l) && Zn(l);
  }
  function Xn(l) {
    var v = ar(l) ? Mt.call(l) : "";
    return v == _ || v == m;
  }
  function Vr(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= c;
  }
  function ar(l) {
    var v = typeof l;
    return !!l && (v == "object" || v == "function");
  }
  function ur(l) {
    return !!l && typeof l == "object";
  }
  function Qr(l) {
    return typeof l == "symbol" || ur(l) && Mt.call(l) == R;
  }
  var Bs = W ? St(W) : Is;
  function $s(l) {
    return l == null ? "" : Ps(l);
  }
  function Ks(l, v, g) {
    var E = l == null ? void 0 : Kn(l, v);
    return E === void 0 ? g : E;
  }
  function Vs(l, v) {
    return l != null && Ms(l, v, ws);
  }
  function cr(l) {
    return Zn(l) ? _s(l) : Ds(l);
  }
  function Qs(l, v) {
    var g = {};
    return v = As(v), gs(l, function(E, M, C) {
      g[v(E, M, C)] = E;
    }), g;
  }
  function Ys(l) {
    return l;
  }
  function Gs(l) {
    return or(l) ? ot(sr(l)) : Ts(l);
  }
  t.exports = Qs;
})(Ip, Ip.exports);
Ip.exports;
var gf = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ib;
function KC() {
  if (Ib)
    return gf;
  Ib = 1;
  var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, c, a) {
    var f, h = {}, p = null, d = null;
    a !== void 0 && (p = "" + a), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (f in c)
      n.call(c, f) && !o.hasOwnProperty(f) && (h[f] = c[f]);
    if (u && u.defaultProps)
      for (f in c = u.defaultProps, c)
        h[f] === void 0 && (h[f] = c[f]);
    return { $$typeof: e, type: u, key: p, ref: d, props: h, _owner: i.current };
  }
  return gf.Fragment = r, gf.jsx = s, gf.jsxs = s, gf;
}
var Dh = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ab;
function VC() {
  return Ab || (Ab = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), a = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), _ = Symbol.iterator, m = "@@iterator";
    function b(y) {
      if (y === null || typeof y != "object")
        return null;
      var w = _ && y[_] || y[m];
      return typeof w == "function" ? w : null;
    }
    var O = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(y) {
      {
        for (var w = arguments.length, A = new Array(w > 1 ? w - 1 : 0), q = 1; q < w; q++)
          A[q - 1] = arguments[q];
        k("error", y, A);
      }
    }
    function k(y, w, A) {
      {
        var q = O.ReactDebugCurrentFrame, F = q.getStackAddendum();
        F !== "" && (w += "%s", A = A.concat([F]));
        var Q = A.map(function(L) {
          return String(L);
        });
        Q.unshift("Warning: " + w), Function.prototype.apply.call(console[y], console, Q);
      }
    }
    var T = !1, x = !1, P = !1, R = !1, D = !1, I;
    I = Symbol.for("react.module.reference");
    function j(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === n || y === o || D || y === i || y === a || y === f || R || y === d || T || x || P || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === h || y.$$typeof === s || y.$$typeof === u || y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === I || y.getModuleId !== void 0));
    }
    function Y(y, w, A) {
      var q = y.displayName;
      if (q)
        return q;
      var F = w.displayName || w.name || "";
      return F !== "" ? A + "(" + F + ")" : A;
    }
    function H(y) {
      return y.displayName || "Context";
    }
    function B(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case a:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case u:
            var w = y;
            return H(w) + ".Consumer";
          case s:
            var A = y;
            return H(A._context) + ".Provider";
          case c:
            return Y(y, y.render, "ForwardRef");
          case h:
            var q = y.displayName || null;
            return q !== null ? q : B(y.type) || "Memo";
          case p: {
            var F = y, Q = F._payload, L = F._init;
            try {
              return B(L(Q));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var tt = Object.assign, lt = 0, te, pt, At, ft, Lt, dt, mt;
    function st() {
    }
    st.__reactDisabledLog = !0;
    function Nt() {
      {
        if (lt === 0) {
          te = console.log, pt = console.info, At = console.warn, ft = console.error, Lt = console.group, dt = console.groupCollapsed, mt = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: st,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        lt++;
      }
    }
    function Qt() {
      {
        if (lt--, lt === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: tt({}, y, {
              value: te
            }),
            info: tt({}, y, {
              value: pt
            }),
            warn: tt({}, y, {
              value: At
            }),
            error: tt({}, y, {
              value: ft
            }),
            group: tt({}, y, {
              value: Lt
            }),
            groupCollapsed: tt({}, y, {
              value: dt
            }),
            groupEnd: tt({}, y, {
              value: mt
            })
          });
        }
        lt < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Rt = O.ReactCurrentDispatcher, xt;
    function N(y, w, A) {
      {
        if (xt === void 0)
          try {
            throw Error();
          } catch (F) {
            var q = F.stack.trim().match(/\n( *(at )?)/);
            xt = q && q[1] || "";
          }
        return `
` + xt + y;
      }
    }
    var ht = !1, gt;
    {
      var X = typeof WeakMap == "function" ? WeakMap : Map;
      gt = new X();
    }
    function wt(y, w) {
      if (!y || ht)
        return "";
      {
        var A = gt.get(y);
        if (A !== void 0)
          return A;
      }
      var q;
      ht = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Q;
      Q = Rt.current, Rt.current = null, Nt();
      try {
        if (w) {
          var L = function() {
            throw Error();
          };
          if (Object.defineProperty(L.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(L, []);
            } catch (bt) {
              q = bt;
            }
            Reflect.construct(y, [], L);
          } else {
            try {
              L.call();
            } catch (bt) {
              q = bt;
            }
            y.call(L.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bt) {
            q = bt;
          }
          y();
        }
      } catch (bt) {
        if (bt && q && typeof bt.stack == "string") {
          for (var z = bt.stack.split(`
`), it = q.stack.split(`
`), J = z.length - 1, K = it.length - 1; J >= 1 && K >= 0 && z[J] !== it[K]; )
            K--;
          for (; J >= 1 && K >= 0; J--, K--)
            if (z[J] !== it[K]) {
              if (J !== 1 || K !== 1)
                do
                  if (J--, K--, K < 0 || z[J] !== it[K]) {
                    var ut = `
` + z[J].replace(" at new ", " at ");
                    return y.displayName && ut.includes("<anonymous>") && (ut = ut.replace("<anonymous>", y.displayName)), typeof y == "function" && gt.set(y, ut), ut;
                  }
                while (J >= 1 && K >= 0);
              break;
            }
        }
      } finally {
        ht = !1, Rt.current = Q, Qt(), Error.prepareStackTrace = F;
      }
      var Bt = y ? y.displayName || y.name : "", er = Bt ? N(Bt) : "";
      return typeof y == "function" && gt.set(y, er), er;
    }
    function jt(y, w, A) {
      return wt(y, !1);
    }
    function qt(y) {
      var w = y.prototype;
      return !!(w && w.isReactComponent);
    }
    function U(y, w, A) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return wt(y, qt(y));
      if (typeof y == "string")
        return N(y);
      switch (y) {
        case a:
          return N("Suspense");
        case f:
          return N("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case c:
            return jt(y.render);
          case h:
            return U(y.type, w, A);
          case p: {
            var q = y, F = q._payload, Q = q._init;
            try {
              return U(Q(F), w, A);
            } catch {
            }
          }
        }
      return "";
    }
    var $ = Object.prototype.hasOwnProperty, W = {}, et = O.ReactDebugCurrentFrame;
    function ot(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        et.setExtraStackFrame(A);
      } else
        et.setExtraStackFrame(null);
    }
    function Dt(y, w, A, q, F) {
      {
        var Q = Function.call.bind($);
        for (var L in y)
          if (Q(y, L)) {
            var z = void 0;
            try {
              if (typeof y[L] != "function") {
                var it = Error((q || "React class") + ": " + A + " type `" + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[L] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw it.name = "Invariant Violation", it;
              }
              z = y[L](w, L, q, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (J) {
              z = J;
            }
            z && !(z instanceof Error) && (ot(F), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", A, L, typeof z), ot(null)), z instanceof Error && !(z.message in W) && (W[z.message] = !0, ot(F), S("Failed %s type: %s", A, z.message), ot(null));
          }
      }
    }
    var St = Array.isArray;
    function Et(y) {
      return St(y);
    }
    function ue(y) {
      {
        var w = typeof Symbol == "function" && Symbol.toStringTag, A = w && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return A;
      }
    }
    function ae(y) {
      try {
        return ce(y), !1;
      } catch {
        return !0;
      }
    }
    function ce(y) {
      return "" + y;
    }
    function Yt(y) {
      if (ae(y))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ue(y)), ce(y);
    }
    var Ot = O.ReactCurrentOwner, Oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Gt, se, Zt;
    Zt = {};
    function fe(y) {
      if ($.call(y, "ref")) {
        var w = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function vt(y) {
      if ($.call(y, "key")) {
        var w = Object.getOwnPropertyDescriptor(y, "key").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Mt(y, w) {
      if (typeof y.ref == "string" && Ot.current && w && Ot.current.stateNode !== w) {
        var A = B(Ot.current.type);
        Zt[A] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(Ot.current.type), y.ref), Zt[A] = !0);
      }
    }
    function Fr(y, w) {
      {
        var A = function() {
          Gt || (Gt = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: A,
          configurable: !0
        });
      }
    }
    function We(y, w) {
      {
        var A = function() {
          se || (se = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: A,
          configurable: !0
        });
      }
    }
    var He = function(y, w, A, q, F, Q, L) {
      var z = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: y,
        key: w,
        ref: A,
        props: L,
        // Record the component responsible for creating this element.
        _owner: Q
      };
      return z._store = {}, Object.defineProperty(z._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(z, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(z, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(z.props), Object.freeze(z)), z;
    };
    function Nr(y, w, A, q, F) {
      {
        var Q, L = {}, z = null, it = null;
        A !== void 0 && (Yt(A), z = "" + A), vt(w) && (Yt(w.key), z = "" + w.key), fe(w) && (it = w.ref, Mt(w, F));
        for (Q in w)
          $.call(w, Q) && !Oe.hasOwnProperty(Q) && (L[Q] = w[Q]);
        if (y && y.defaultProps) {
          var J = y.defaultProps;
          for (Q in J)
            L[Q] === void 0 && (L[Q] = J[Q]);
        }
        if (z || it) {
          var K = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          z && Fr(L, K), it && We(L, K);
        }
        return He(y, z, it, F, q, Ot.current, L);
      }
    }
    var Ie = O.ReactCurrentOwner, Je = O.ReactDebugCurrentFrame;
    function It(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        Je.setExtraStackFrame(A);
      } else
        Je.setExtraStackFrame(null);
    }
    var Tt;
    Tt = !1;
    function ee(y) {
      return typeof y == "object" && y !== null && y.$$typeof === e;
    }
    function ye() {
      {
        if (Ie.current) {
          var y = B(Ie.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function Ae(y) {
      {
        if (y !== void 0) {
          var w = y.fileName.replace(/^.*[\\\/]/, ""), A = y.lineNumber;
          return `

Check your code at ` + w + ":" + A + ".";
        }
        return "";
      }
    }
    var Ut = {};
    function zr(y) {
      {
        var w = ye();
        if (!w) {
          var A = typeof y == "string" ? y : y.displayName || y.name;
          A && (w = `

Check the top-level render call using <` + A + ">.");
        }
        return w;
      }
    }
    function Ze(y, w) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var A = zr(w);
        if (Ut[A])
          return;
        Ut[A] = !0;
        var q = "";
        y && y._owner && y._owner !== Ie.current && (q = " It was passed a child from " + B(y._owner.type) + "."), It(y), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, q), It(null);
      }
    }
    function Xe(y, w) {
      {
        if (typeof y != "object")
          return;
        if (Et(y))
          for (var A = 0; A < y.length; A++) {
            var q = y[A];
            ee(q) && Ze(q, w);
          }
        else if (ee(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var F = b(y);
          if (typeof F == "function" && F !== y.entries)
            for (var Q = F.call(y), L; !(L = Q.next()).done; )
              ee(L.value) && Ze(L.value, w);
        }
      }
    }
    function Lr(y) {
      {
        var w = y.type;
        if (w == null || typeof w == "string")
          return;
        var A;
        if (typeof w == "function")
          A = w.propTypes;
        else if (typeof w == "object" && (w.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        w.$$typeof === h))
          A = w.propTypes;
        else
          return;
        if (A) {
          var q = B(w);
          Dt(A, y.props, "prop", q, y);
        } else if (w.PropTypes !== void 0 && !Tt) {
          Tt = !0;
          var F = B(w);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof w.getDefaultProps == "function" && !w.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ur(y) {
      {
        for (var w = Object.keys(y.props), A = 0; A < w.length; A++) {
          var q = w[A];
          if (q !== "children" && q !== "key") {
            It(y), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), It(null);
            break;
          }
        }
        y.ref !== null && (It(y), S("Invalid attribute `ref` supplied to `React.Fragment`."), It(null));
      }
    }
    function re(y, w, A, q, F, Q) {
      {
        var L = j(y);
        if (!L) {
          var z = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var it = Ae(F);
          it ? z += it : z += ye();
          var J;
          y === null ? J = "null" : Et(y) ? J = "array" : y !== void 0 && y.$$typeof === e ? (J = "<" + (B(y.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : J = typeof y, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", J, z);
        }
        var K = Nr(y, w, A, F, Q);
        if (K == null)
          return K;
        if (L) {
          var ut = w.children;
          if (ut !== void 0)
            if (q)
              if (Et(ut)) {
                for (var Bt = 0; Bt < ut.length; Bt++)
                  Xe(ut[Bt], y);
                Object.freeze && Object.freeze(ut);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xe(ut, y);
        }
        return y === n ? Ur(K) : Lr(K), K;
      }
    }
    function De(y, w, A) {
      return re(y, w, A, !0);
    }
    function tr(y, w, A) {
      return re(y, w, A, !1);
    }
    var Pt = tr, Br = De;
    Dh.Fragment = n, Dh.jsx = Pt, Dh.jsxs = Br;
  }()), Dh;
}
process.env.NODE_ENV === "production" ? KC() : VC();
function od(t, e, r, n) {
  Object.defineProperty(t, e, { get: r, set: n, enumerable: !0, configurable: !0 });
}
var QC = {};
od(QC, "ErrorBoundary", () => OI);
var YC = {};
od(YC, "ErrorBoundaryContext", () => I0);
const I0 = Mr(null), Tv = {
  didCatch: !1,
  error: null
};
class OI extends Pl {
  constructor() {
    super(...arguments), Ob(this, "state", Tv), Ob(this, "resetErrorBoundary", (...e) => {
      var r, n;
      const { error: i } = this.state;
      i !== null && ((n = (r = this.props).onReset) == null || n.call(r, {
        args: e,
        reason: "imperative-api"
      }), this.setState(Tv));
    });
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  componentDidCatch(e, r) {
    var n, i;
    (i = (n = this.props).onError) == null || i.call(n, e, r);
  }
  componentDidUpdate(e, r) {
    var n, i;
    const { didCatch: o } = this.state, { resetKeys: s } = this.props;
    o && r.error !== null && GC(e.resetKeys, s) && ((i = (n = this.props).onReset) == null || i.call(n, {
      next: s,
      prev: e.resetKeys,
      reason: "keys"
    }), this.setState(Tv));
  }
  render() {
    const { children: e, fallbackRender: r, FallbackComponent: n, fallback: i } = this.props, { didCatch: o, error: s } = this.state;
    let u = e;
    if (o) {
      const c = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (kl(i))
        u = i;
      else if (typeof r == "function")
        u = r(c);
      else if (n)
        u = Tr(n, c);
      else
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return Tr(I0.Provider, {
      value: {
        didCatch: o,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, u);
  }
}
function GC(t = [], e = []) {
  return t.length !== e.length || t.some((r, n) => !Object.is(r, e[n]));
}
var WC = {};
od(WC, "useErrorBoundary", () => JC);
function HC(t) {
  if (t == null || typeof t.didCatch != "boolean" || typeof t.resetErrorBoundary != "function")
    throw new Error("ErrorBoundaryContext not found");
  return !0;
}
function JC() {
  const t = ca(I0);
  HC(t);
  const [e, r] = Jo({
    error: null,
    hasError: !1
  }), n = Zo(() => ({
    resetBoundary: () => {
      t == null || t.resetErrorBoundary(), r({
        error: null,
        hasError: !1
      });
    },
    showBoundary: (i) => r({
      error: i,
      hasError: !0
    })
  }), [
    t == null ? void 0 : t.resetErrorBoundary
  ]);
  if (e.hasError)
    throw e.error;
  return n;
}
var ZC = {};
od(ZC, "withErrorBoundary", () => XC);
function XC(t, e) {
  const r = Cl((i, o) => Tr(OI, e, Tr(t, {
    ...i,
    ref: o
  }))), n = t.displayName || t.name || "Unknown";
  return r.displayName = `withErrorBoundary(${n})`, r;
}
Mr({
  productKey: void 0,
  locationPathName: "",
  setLocationPathName: () => {
  },
  aptrinsic: () => {
  },
  logDebug: () => {
  },
  isInitialized: !1,
  initialize: () => {
  }
});
var A0 = /* @__PURE__ */ ((t) => (t.EN = "en", t.FR = "fr", t))(A0 || {});
class sd {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    const r = {
      listener: e
    };
    return this.listeners.add(r), this.onSubscribe(), () => {
      this.listeners.delete(r), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const D0 = typeof window > "u" || "Deno" in window;
function vo() {
}
function t5(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function e5(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function r5(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function Rh(t, e, r) {
  return ad(t) ? typeof e == "function" ? {
    ...r,
    queryKey: t,
    queryFn: e
  } : {
    ...e,
    queryKey: t
  } : t;
}
function pa(t, e, r) {
  return ad(t) ? [{
    ...e,
    queryKey: t
  }, r] : [t || {}, e];
}
function Db(t, e) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: i,
    predicate: o,
    queryKey: s,
    stale: u
  } = t;
  if (ad(s)) {
    if (n) {
      if (e.queryHash !== R0(s, e.options))
        return !1;
    } else if (!Fu(e.queryKey, s))
      return !1;
  }
  if (r !== "all") {
    const c = e.isActive();
    if (r === "active" && !c || r === "inactive" && c)
      return !1;
  }
  return !(typeof u == "boolean" && e.isStale() !== u || typeof i < "u" && i !== e.state.fetchStatus || o && !o(e));
}
function Rb(t, e) {
  const {
    exact: r,
    fetching: n,
    predicate: i,
    mutationKey: o
  } = t;
  if (ad(o)) {
    if (!e.options.mutationKey)
      return !1;
    if (r) {
      if (tu(e.options.mutationKey) !== tu(o))
        return !1;
    } else if (!Fu(e.options.mutationKey, o))
      return !1;
  }
  return !(typeof n == "boolean" && e.state.status === "loading" !== n || i && !i(e));
}
function R0(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || tu)(t);
}
function tu(t) {
  return JSON.stringify(t, (e, r) => My(r) ? Object.keys(r).sort().reduce((n, i) => (n[i] = r[i], n), {}) : r);
}
function Fu(t, e) {
  return II(t, e);
}
function II(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((r) => !II(t[r], e[r])) : !1;
}
function AI(t, e) {
  if (t === e)
    return t;
  const r = xb(t) && xb(e);
  if (r || My(t) && My(e)) {
    const n = r ? t.length : Object.keys(t).length, i = r ? e : Object.keys(e), o = i.length, s = r ? [] : {};
    let u = 0;
    for (let c = 0; c < o; c++) {
      const a = r ? c : i[c];
      s[a] = AI(t[a], e[a]), s[a] === t[a] && u++;
    }
    return n === o && u === n ? t : s;
  }
  return e;
}
function xb(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function My(t) {
  if (!Tb(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const r = e.prototype;
  return !(!Tb(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function Tb(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function ad(t) {
  return Array.isArray(t);
}
function DI(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function Pb(t) {
  DI(0).then(t);
}
function n5() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function i5(t, e, r) {
  return r.isDataEqual != null && r.isDataEqual(t, e) ? t : typeof r.structuralSharing == "function" ? r.structuralSharing(t, e) : r.structuralSharing !== !1 ? AI(t, e) : e;
}
class o5 extends sd {
  constructor() {
    super(), this.setup = (e) => {
      if (!D0 && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("visibilitychange", r, !1), window.addEventListener("focus", r, !1), () => {
          window.removeEventListener("visibilitychange", r), window.removeEventListener("focus", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused = e, e && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const Fy = new o5();
class s5 extends sd {
  constructor() {
    super(), this.setup = (e) => {
      if (!D0 && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("online", r, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setOnline(n) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online = e, e && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const Ap = new s5();
function a5(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function x0(t) {
  return (t ?? "online") === "online" ? Ap.isOnline() : !0;
}
class RI {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
}
function Pv(t) {
  return t instanceof RI;
}
function xI(t) {
  let e = !1, r = 0, n = !1, i, o, s;
  const u = new Promise((b, O) => {
    o = b, s = O;
  }), c = (b) => {
    n || (d(new RI(b)), t.abort == null || t.abort());
  }, a = () => {
    e = !0;
  }, f = () => {
    e = !1;
  }, h = () => !Fy.isFocused() || t.networkMode !== "always" && !Ap.isOnline(), p = (b) => {
    n || (n = !0, t.onSuccess == null || t.onSuccess(b), i == null || i(), o(b));
  }, d = (b) => {
    n || (n = !0, t.onError == null || t.onError(b), i == null || i(), s(b));
  }, _ = () => new Promise((b) => {
    i = (O) => {
      const S = n || !h();
      return S && b(O), S;
    }, t.onPause == null || t.onPause();
  }).then(() => {
    i = void 0, n || t.onContinue == null || t.onContinue();
  }), m = () => {
    if (n)
      return;
    let b;
    try {
      b = t.fn();
    } catch (O) {
      b = Promise.reject(O);
    }
    Promise.resolve(b).then(p).catch((O) => {
      var S, k;
      if (n)
        return;
      const T = (S = t.retry) != null ? S : 3, x = (k = t.retryDelay) != null ? k : a5, P = typeof x == "function" ? x(r, O) : x, R = T === !0 || typeof T == "number" && r < T || typeof T == "function" && T(r, O);
      if (e || !R) {
        d(O);
        return;
      }
      r++, t.onFail == null || t.onFail(r, O), DI(P).then(() => {
        if (h())
          return _();
      }).then(() => {
        e ? d(O) : m();
      });
    });
  };
  return x0(t.networkMode) ? m() : _().then(m), {
    promise: u,
    cancel: c,
    continue: () => i != null && i() ? u : Promise.resolve(),
    cancelRetry: a,
    continueRetry: f
  };
}
const T0 = console;
function u5() {
  let t = [], e = 0, r = (c) => {
    c();
  }, n = (c) => {
    c();
  };
  const i = (c) => {
    let a;
    e++;
    try {
      a = c();
    } finally {
      e--, e || u();
    }
    return a;
  }, o = (c) => {
    e ? t.push(c) : Pb(() => {
      r(c);
    });
  }, s = (c) => (...a) => {
    o(() => {
      c(...a);
    });
  }, u = () => {
    const c = t;
    t = [], c.length && Pb(() => {
      n(() => {
        c.forEach((a) => {
          r(a);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: s,
    schedule: o,
    setNotifyFunction: (c) => {
      r = c;
    },
    setBatchNotifyFunction: (c) => {
      n = c;
    }
  };
}
const Tn = u5();
class TI {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), e5(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (D0 ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class c5 extends TI {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || T0, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || f5(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, r) {
    const n = i5(this.state.data, e, this.options);
    return this.dispatch({
      data: n,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), n;
  }
  setState(e, r) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: r
    });
  }
  cancel(e) {
    var r;
    const n = this.promise;
    return (r = this.retryer) == null || r.cancel(e), n ? n.then(vo).catch(vo) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !r5(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnReconnect());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.indexOf(e) !== -1 && (this.observers = this.observers.filter((r) => r !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, r) {
    var n, i;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && r != null && r.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var o;
        return (o = this.retryer) == null || o.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const d = this.observers.find((_) => _.options.queryFn);
      d && this.setOptions(d.options);
    }
    Array.isArray(this.options.queryKey) || process.env.NODE_ENV !== "production" && this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
    const s = n5(), u = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, c = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => {
          if (s)
            return this.abortSignalConsumed = !0, s.signal;
        }
      });
    };
    c(u);
    const a = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(u)) : Promise.reject("Missing queryFn"), f = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: a
    };
    if (c(f), (n = this.options.behavior) == null || n.onFetch(f), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((i = f.fetchOptions) == null ? void 0 : i.meta)) {
      var h;
      this.dispatch({
        type: "fetch",
        meta: (h = f.fetchOptions) == null ? void 0 : h.meta
      });
    }
    const p = (d) => {
      if (Pv(d) && d.silent || this.dispatch({
        type: "error",
        error: d
      }), !Pv(d)) {
        var _, m, b, O;
        (_ = (m = this.cache.config).onError) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, this.state.data, d, this), process.env.NODE_ENV !== "production" && this.logger.error(d);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = xI({
      fn: f.fetchFn,
      abort: s == null ? void 0 : s.abort.bind(s),
      onSuccess: (d) => {
        var _, m, b, O;
        if (typeof d > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), p(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(d), (_ = (m = this.cache.config).onSuccess) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, d, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: p,
      onFail: (d, _) => {
        this.dispatch({
          type: "failed",
          failureCount: d,
          error: _
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: f.options.retry,
      retryDelay: f.options.retryDelay,
      networkMode: f.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const r = (n) => {
      var i, o;
      switch (e.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (i = e.meta) != null ? i : null,
            fetchStatus: x0(this.options.networkMode) ? "fetching" : "paused",
            ...!n.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...n,
            data: e.data,
            dataUpdateCount: n.dataUpdateCount + 1,
            dataUpdatedAt: (o = e.dataUpdatedAt) != null ? o : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const s = e.error;
          return Pv(s) && s.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...n,
            error: s,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: s,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), Tn.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
}
function f5(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = typeof e < "u", n = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class l5 extends sd {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, r, n) {
    var i;
    const o = r.queryKey, s = (i = r.queryHash) != null ? i : R0(o, r);
    let u = this.get(s);
    return u || (u = new c5({
      cache: this,
      logger: e.getLogger(),
      queryKey: o,
      queryHash: s,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(o)
    }), this.add(u)), u;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = this.queriesMap[e.queryHash];
    r && (e.destroy(), this.queries = this.queries.filter((n) => n !== e), r === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    Tn.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  find(e, r) {
    const [n] = pa(e, r);
    return typeof n.exact > "u" && (n.exact = !0), this.queries.find((i) => Db(n, i));
  }
  findAll(e, r) {
    const [n] = pa(e, r);
    return Object.keys(n).length > 0 ? this.queries.filter((i) => Db(n, i)) : this.queries;
  }
  notify(e) {
    Tn.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  onFocus() {
    Tn.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    Tn.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
class h5 extends TI {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || T0, this.observers = [], this.state = e.state || p5(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((r) => r !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, r;
    return (e = (r = this.retryer) == null ? void 0 : r.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var R;
      return this.retryer = xI({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (D, I) => {
          this.dispatch({
            type: "failed",
            failureCount: D,
            error: I
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (R = this.options.retry) != null ? R : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, r = this.state.status === "loading";
    try {
      var n, i, o, s, u, c, a, f;
      if (!r) {
        var h, p, d, _;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((h = (p = this.mutationCache.config).onMutate) == null ? void 0 : h.call(p, this.state.variables, this));
        const D = await ((d = (_ = this.options).onMutate) == null ? void 0 : d.call(_, this.state.variables));
        D !== this.state.context && this.dispatch({
          type: "loading",
          context: D,
          variables: this.state.variables
        });
      }
      const R = await e();
      return await ((n = (i = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(i, R, this.state.variables, this.state.context, this)), await ((o = (s = this.options).onSuccess) == null ? void 0 : o.call(s, R, this.state.variables, this.state.context)), await ((u = (c = this.mutationCache.config).onSettled) == null ? void 0 : u.call(c, R, null, this.state.variables, this.state.context, this)), await ((a = (f = this.options).onSettled) == null ? void 0 : a.call(f, R, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: R
      }), R;
    } catch (R) {
      try {
        var m, b, O, S, k, T, x, P;
        throw await ((m = (b = this.mutationCache.config).onError) == null ? void 0 : m.call(b, R, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(R), await ((O = (S = this.options).onError) == null ? void 0 : O.call(S, R, this.state.variables, this.state.context)), await ((k = (T = this.mutationCache.config).onSettled) == null ? void 0 : k.call(T, void 0, R, this.state.variables, this.state.context, this)), await ((x = (P = this.options).onSettled) == null ? void 0 : x.call(P, void 0, R, this.state.variables, this.state.context)), R;
      } finally {
        this.dispatch({
          type: "error",
          error: R
        });
      }
    }
  }
  dispatch(e) {
    const r = (n) => {
      switch (e.type) {
        case "failed":
          return {
            ...n,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "loading":
          return {
            ...n,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !x0(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...n,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: e.error,
            failureCount: n.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), Tn.batch(() => {
      this.observers.forEach((n) => {
        n.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function p5() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class d5 extends sd {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, r, n) {
    const i = new h5({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(r),
      state: n,
      defaultOptions: r.mutationKey ? e.getMutationDefaults(r.mutationKey) : void 0
    });
    return this.add(i), i;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((r) => r !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    Tn.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((r) => Rb(e, r));
  }
  findAll(e) {
    return this.mutations.filter((r) => Rb(e, r));
  }
  notify(e) {
    Tn.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const r = this.mutations.filter((n) => n.state.isPaused);
      return Tn.batch(() => r.reduce((n, i) => n.then(() => i.continue().catch(vo)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function v5() {
  return {
    onFetch: (t) => {
      t.fetchFn = () => {
        var e, r, n, i, o, s;
        const u = (e = t.fetchOptions) == null || (r = e.meta) == null ? void 0 : r.refetchPage, c = (n = t.fetchOptions) == null || (i = n.meta) == null ? void 0 : i.fetchMore, a = c == null ? void 0 : c.pageParam, f = (c == null ? void 0 : c.direction) === "forward", h = (c == null ? void 0 : c.direction) === "backward", p = ((o = t.state.data) == null ? void 0 : o.pages) || [], d = ((s = t.state.data) == null ? void 0 : s.pageParams) || [];
        let _ = d, m = !1;
        const b = (x) => {
          Object.defineProperty(x, "signal", {
            enumerable: !0,
            get: () => {
              var P;
              if ((P = t.signal) != null && P.aborted)
                m = !0;
              else {
                var R;
                (R = t.signal) == null || R.addEventListener("abort", () => {
                  m = !0;
                });
              }
              return t.signal;
            }
          });
        }, O = t.options.queryFn || (() => Promise.reject("Missing queryFn")), S = (x, P, R, D) => (_ = D ? [P, ..._] : [..._, P], D ? [R, ...x] : [...x, R]), k = (x, P, R, D) => {
          if (m)
            return Promise.reject("Cancelled");
          if (typeof R > "u" && !P && x.length)
            return Promise.resolve(x);
          const I = {
            queryKey: t.queryKey,
            pageParam: R,
            meta: t.options.meta
          };
          b(I);
          const j = O(I);
          return Promise.resolve(j).then((Y) => S(x, R, Y, D));
        };
        let T;
        if (!p.length)
          T = k([]);
        else if (f) {
          const x = typeof a < "u", P = x ? a : kb(t.options, p);
          T = k(p, x, P);
        } else if (h) {
          const x = typeof a < "u", P = x ? a : y5(t.options, p);
          T = k(p, x, P, !0);
        } else {
          _ = [];
          const x = typeof t.options.getNextPageParam > "u";
          T = !(u && p[0]) || u(p[0], 0, p) ? k([], x, d[0]) : Promise.resolve(S([], d[0], p[0]));
          for (let P = 1; P < p.length; P++)
            T = T.then((R) => {
              if (!(u && p[P]) || u(p[P], P, p)) {
                const D = x ? d[P] : kb(t.options, R);
                return k(R, x, D);
              }
              return Promise.resolve(S(R, d[P], p[P]));
            });
        }
        return T.then((x) => ({
          pages: x,
          pageParams: _
        }));
      };
    }
  };
}
function kb(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}
function y5(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}
class _5 {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new l5(), this.mutationCache = e.mutationCache || new d5(), this.logger = e.logger || T0, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && e.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = Fy.subscribe(() => {
      Fy.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = Ap.subscribe(() => {
      Ap.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, r;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (r = this.unsubscribeOnline) == null || r.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(e, r) {
    const [n] = pa(e, r);
    return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  getQueryData(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e, r, n) {
    const i = Rh(e, r, n), o = this.getQueryData(i.queryKey);
    return o ? Promise.resolve(o) : this.fetchQuery(i);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: r,
      state: n
    }) => {
      const i = n.data;
      return [r, i];
    });
  }
  setQueryData(e, r, n) {
    const i = this.queryCache.find(e), o = i == null ? void 0 : i.state.data, s = t5(r, o);
    if (typeof s > "u")
      return;
    const u = Rh(e), c = this.defaultQueryOptions(u);
    return this.queryCache.build(this, c).setData(s, {
      ...n,
      manual: !0
    });
  }
  setQueriesData(e, r, n) {
    return Tn.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: i
    }) => [i, this.setQueryData(i, r, n)]));
  }
  getQueryState(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state;
  }
  removeQueries(e, r) {
    const [n] = pa(e, r), i = this.queryCache;
    Tn.batch(() => {
      i.findAll(n).forEach((o) => {
        i.remove(o);
      });
    });
  }
  resetQueries(e, r, n) {
    const [i, o] = pa(e, r, n), s = this.queryCache, u = {
      type: "active",
      ...i
    };
    return Tn.batch(() => (s.findAll(i).forEach((c) => {
      c.reset();
    }), this.refetchQueries(u, o)));
  }
  cancelQueries(e, r, n) {
    const [i, o = {}] = pa(e, r, n);
    typeof o.revert > "u" && (o.revert = !0);
    const s = Tn.batch(() => this.queryCache.findAll(i).map((u) => u.cancel(o)));
    return Promise.all(s).then(vo).catch(vo);
  }
  invalidateQueries(e, r, n) {
    const [i, o] = pa(e, r, n);
    return Tn.batch(() => {
      var s, u;
      if (this.queryCache.findAll(i).forEach((a) => {
        a.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const c = {
        ...i,
        type: (s = (u = i.refetchType) != null ? u : i.type) != null ? s : "active"
      };
      return this.refetchQueries(c, o);
    });
  }
  refetchQueries(e, r, n) {
    const [i, o] = pa(e, r, n), s = Tn.batch(() => this.queryCache.findAll(i).filter((c) => !c.isDisabled()).map((c) => {
      var a;
      return c.fetch(void 0, {
        ...o,
        cancelRefetch: (a = o == null ? void 0 : o.cancelRefetch) != null ? a : !0,
        meta: {
          refetchPage: i.refetchPage
        }
      });
    }));
    let u = Promise.all(s).then(vo);
    return o != null && o.throwOnError || (u = u.catch(vo)), u;
  }
  fetchQuery(e, r, n) {
    const i = Rh(e, r, n), o = this.defaultQueryOptions(i);
    typeof o.retry > "u" && (o.retry = !1);
    const s = this.queryCache.build(this, o);
    return s.isStaleByTime(o.staleTime) ? s.fetch(o) : Promise.resolve(s.state.data);
  }
  prefetchQuery(e, r, n) {
    return this.fetchQuery(e, r, n).then(vo).catch(vo);
  }
  fetchInfiniteQuery(e, r, n) {
    const i = Rh(e, r, n);
    return i.behavior = v5(), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(e, r, n) {
    return this.fetchInfiniteQuery(e, r, n).then(vo).catch(vo);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, r) {
    const n = this.queryDefaults.find((i) => tu(e) === tu(i.queryKey));
    n ? n.defaultOptions = r : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: r
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const r = this.queryDefaults.find((n) => Fu(e, n.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((n) => Fu(e, n.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(e) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), r == null ? void 0 : r.defaultOptions;
  }
  setMutationDefaults(e, r) {
    const n = this.mutationDefaults.find((i) => tu(e) === tu(i.mutationKey));
    n ? n.defaultOptions = r : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: r
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const r = this.mutationDefaults.find((n) => Fu(e, n.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((n) => Fu(e, n.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(e) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), r == null ? void 0 : r.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const r = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e == null ? void 0 : e.queryKey),
      ...e,
      _defaulted: !0
    };
    return !r.queryHash && r.queryKey && (r.queryHash = R0(r.queryKey, r)), typeof r.refetchOnReconnect > "u" && (r.refetchOnReconnect = r.networkMode !== "always"), typeof r.useErrorBoundary > "u" && (r.useErrorBoundary = !!r.suspense), r;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e == null ? void 0 : e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
var Ny = { exports: {} }, kv = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cb;
function m5() {
  if (Cb)
    return kv;
  Cb = 1;
  var t = Se;
  function e(h, p) {
    return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, i = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
  function u(h, p) {
    var d = p(), _ = n({ inst: { value: d, getSnapshot: p } }), m = _[0].inst, b = _[1];
    return o(function() {
      m.value = d, m.getSnapshot = p, c(m) && b({ inst: m });
    }, [h, d, p]), i(function() {
      return c(m) && b({ inst: m }), h(function() {
        c(m) && b({ inst: m });
      });
    }, [h]), s(d), d;
  }
  function c(h) {
    var p = h.getSnapshot;
    h = h.value;
    try {
      var d = p();
      return !r(h, d);
    } catch {
      return !0;
    }
  }
  function a(h, p) {
    return p();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : u;
  return kv.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : f, kv;
}
var jb = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qb;
function g5() {
  return qb || (qb = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Se, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(k) {
      {
        for (var T = arguments.length, x = new Array(T > 1 ? T - 1 : 0), P = 1; P < T; P++)
          x[P - 1] = arguments[P];
        n("error", k, x);
      }
    }
    function n(k, T, x) {
      {
        var P = e.ReactDebugCurrentFrame, R = P.getStackAddendum();
        R !== "" && (T += "%s", x = x.concat([R]));
        var D = x.map(function(I) {
          return String(I);
        });
        D.unshift("Warning: " + T), Function.prototype.apply.call(console[k], console, D);
      }
    }
    function i(k, T) {
      return k === T && (k !== 0 || 1 / k === 1 / T) || k !== k && T !== T;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = t.useState, u = t.useEffect, c = t.useLayoutEffect, a = t.useDebugValue, f = !1, h = !1;
    function p(k, T, x) {
      f || t.startTransition !== void 0 && (f = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var P = T();
      if (!h) {
        var R = T();
        o(P, R) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), h = !0);
      }
      var D = s({
        inst: {
          value: P,
          getSnapshot: T
        }
      }), I = D[0].inst, j = D[1];
      return c(function() {
        I.value = P, I.getSnapshot = T, d(I) && j({
          inst: I
        });
      }, [k, P, T]), u(function() {
        d(I) && j({
          inst: I
        });
        var Y = function() {
          d(I) && j({
            inst: I
          });
        };
        return k(Y);
      }, [k]), a(P), P;
    }
    function d(k) {
      var T = k.getSnapshot, x = k.value;
      try {
        var P = T();
        return !o(x, P);
      } catch {
        return !0;
      }
    }
    function _(k, T, x) {
      return T();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", b = !m, O = b ? _ : p, S = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : O;
    jb.useSyncExternalStore = S, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), jb;
}
process.env.NODE_ENV === "production" ? Ny.exports = m5() : Ny.exports = g5();
var b5 = Ny.exports;
b5.useSyncExternalStore;
const w5 = /* @__PURE__ */ Yr.createContext(!1);
w5.Provider;
new _5();
Mr(void 0);
function pu(t) {
  function e(r, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = r, this.code = n;
  }
  return e.prototype = new Error(), e.prototype.name = t, e.prototype.constructor = e, e;
}
const E5 = pu("LaunchDarklyUnexpectedResponseError"), S5 = pu("LaunchDarklyInvalidEnvironmentIdError"), O5 = pu("LaunchDarklyInvalidUserError"), I5 = pu("LaunchDarklyInvalidEventKeyError"), A5 = pu("LaunchDarklyInvalidArgumentError"), D5 = pu("LaunchDarklyFlagFetchError");
for (var X9 = { LDUnexpectedResponseError: E5, LDInvalidEnvironmentIdError: S5, LDInvalidUserError: O5, LDInvalidEventKeyError: I5, LDInvalidArgumentError: A5, LDInvalidDataError: pu("LaunchDarklyInvalidDataError"), LDFlagFetchError: D5, isHttpErrorRecoverable: function(t) {
  return !(t >= 400 && t < 500) || t === 400 || t === 408 || t === 429;
} }, tB = function(t) {
  var e = Mb(t), r = e[0], n = e[1];
  return 3 * (r + n) / 4 - n;
}, eB = function(t) {
  var e, r, n = Mb(t), i = n[0], o = n[1], s = new R5(function(a, f, h) {
    return 3 * (f + h) / 4 - h;
  }(0, i, o)), u = 0, c = o > 0 ? i - 4 : i;
  for (r = 0; r < c; r += 4)
    e = ji[t.charCodeAt(r)] << 18 | ji[t.charCodeAt(r + 1)] << 12 | ji[t.charCodeAt(r + 2)] << 6 | ji[t.charCodeAt(r + 3)], s[u++] = e >> 16 & 255, s[u++] = e >> 8 & 255, s[u++] = 255 & e;
  return o === 2 && (e = ji[t.charCodeAt(r)] << 2 | ji[t.charCodeAt(r + 1)] >> 4, s[u++] = 255 & e), o === 1 && (e = ji[t.charCodeAt(r)] << 10 | ji[t.charCodeAt(r + 1)] << 4 | ji[t.charCodeAt(r + 2)] >> 2, s[u++] = e >> 8 & 255, s[u++] = 255 & e), s;
}, rB = function(t) {
  for (var e, r = t.length, n = r % 3, i = [], o = 16383, s = 0, u = r - n; s < u; s += o)
    i.push(T5(t, s, s + o > u ? u : s + o));
  return n === 1 ? (e = t[r - 1], i.push(Uo[e >> 2] + Uo[e << 4 & 63] + "==")) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(Uo[e >> 10] + Uo[e >> 4 & 63] + Uo[e << 2 & 63] + "=")), i.join("");
}, Uo = [], ji = [], R5 = typeof Uint8Array < "u" ? Uint8Array : Array, Cv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Pu = 0, x5 = Cv.length; Pu < x5; ++Pu)
  Uo[Pu] = Cv[Pu], ji[Cv.charCodeAt(Pu)] = Pu;
function Mb(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  return r === -1 && (r = e), [r, r === e ? 0 : 4 - r % 4];
}
function T5(t, e, r) {
  for (var n, i, o = [], s = e; s < r; s += 3)
    n = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), o.push(Uo[(i = n) >> 18 & 63] + Uo[i >> 12 & 63] + Uo[i >> 6 & 63] + Uo[63 & i]);
  return o.join("");
}
ji["-".charCodeAt(0)] = 62, ji["_".charCodeAt(0)] = 63;
var P5 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function PI(t) {
  return typeof t == "string" && P5.test(t);
}
for (var nB, iB, Wr = [], jv = 0; jv < 256; ++jv)
  Wr.push((jv + 256).toString(16).substr(1));
function k5(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Wr[t[e + 0]] + Wr[t[e + 1]] + Wr[t[e + 2]] + Wr[t[e + 3]] + "-" + Wr[t[e + 4]] + Wr[t[e + 5]] + "-" + Wr[t[e + 6]] + Wr[t[e + 7]] + "-" + Wr[t[e + 8]] + Wr[t[e + 9]] + "-" + Wr[t[e + 10]] + Wr[t[e + 11]] + Wr[t[e + 12]] + Wr[t[e + 13]] + Wr[t[e + 14]] + Wr[t[e + 15]]).toLowerCase();
  if (!PI(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function C5(t) {
  if (!PI(t))
    throw TypeError("Invalid UUID");
  var e, r = new Uint8Array(16);
  return r[0] = (e = parseInt(t.slice(0, 8), 16)) >>> 24, r[1] = e >>> 16 & 255, r[2] = e >>> 8 & 255, r[3] = 255 & e, r[4] = (e = parseInt(t.slice(9, 13), 16)) >>> 8, r[5] = 255 & e, r[6] = (e = parseInt(t.slice(14, 18), 16)) >>> 8, r[7] = 255 & e, r[8] = (e = parseInt(t.slice(19, 23), 16)) >>> 8, r[9] = 255 & e, r[10] = (e = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = e / 4294967296 & 255, r[12] = e >>> 24 & 255, r[13] = e >>> 16 & 255, r[14] = e >>> 8 & 255, r[15] = 255 & e, r;
}
function kI(t, e, r) {
  function n(i, o, s, u) {
    if (typeof i == "string" && (i = function(f) {
      f = unescape(encodeURIComponent(f));
      for (var h = [], p = 0; p < f.length; ++p)
        h.push(f.charCodeAt(p));
      return h;
    }(i)), typeof o == "string" && (o = C5(o)), o.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + i.length);
    if (c.set(o), c.set(i, o.length), (c = r(c))[6] = 15 & c[6] | e, c[8] = 63 & c[8] | 128, s) {
      u = u || 0;
      for (var a = 0; a < 16; ++a)
        s[u + a] = c[a];
      return s;
    }
    return k5(c);
  }
  try {
    n.name = t;
  } catch {
  }
  return n.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", n.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", n;
}
function Fb(t) {
  return 14 + (t + 64 >>> 9 << 4) + 1;
}
function Ea(t, e) {
  var r = (65535 & t) + (65535 & e);
  return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
}
function ud(t, e, r, n, i, o) {
  return Ea((s = Ea(Ea(e, t), Ea(n, o))) << (u = i) | s >>> 32 - u, r);
  var s, u;
}
function cn(t, e, r, n, i, o, s) {
  return ud(e & r | ~e & n, t, e, i, o, s);
}
function fn(t, e, r, n, i, o, s) {
  return ud(e & n | r & ~n, t, e, i, o, s);
}
function ln(t, e, r, n, i, o, s) {
  return ud(e ^ r ^ n, t, e, i, o, s);
}
function hn(t, e, r, n, i, o, s) {
  return ud(r ^ (e | ~n), t, e, i, o, s);
}
kI("v3", 48, function(t) {
  if (typeof t == "string") {
    var e = unescape(encodeURIComponent(t));
    t = new Uint8Array(e.length);
    for (var r = 0; r < e.length; ++r)
      t[r] = e.charCodeAt(r);
  }
  return function(n) {
    for (var i = [], o = 32 * n.length, s = "0123456789abcdef", u = 0; u < o; u += 8) {
      var c = n[u >> 5] >>> u % 32 & 255, a = parseInt(s.charAt(c >>> 4 & 15) + s.charAt(15 & c), 16);
      i.push(a);
    }
    return i;
  }(function(n, i) {
    n[i >> 5] |= 128 << i % 32, n[Fb(i) - 1] = i;
    for (var o = 1732584193, s = -271733879, u = -1732584194, c = 271733878, a = 0; a < n.length; a += 16) {
      var f = o, h = s, p = u, d = c;
      o = cn(o, s, u, c, n[a], 7, -680876936), c = cn(c, o, s, u, n[a + 1], 12, -389564586), u = cn(u, c, o, s, n[a + 2], 17, 606105819), s = cn(s, u, c, o, n[a + 3], 22, -1044525330), o = cn(o, s, u, c, n[a + 4], 7, -176418897), c = cn(c, o, s, u, n[a + 5], 12, 1200080426), u = cn(u, c, o, s, n[a + 6], 17, -1473231341), s = cn(s, u, c, o, n[a + 7], 22, -45705983), o = cn(o, s, u, c, n[a + 8], 7, 1770035416), c = cn(c, o, s, u, n[a + 9], 12, -1958414417), u = cn(u, c, o, s, n[a + 10], 17, -42063), s = cn(s, u, c, o, n[a + 11], 22, -1990404162), o = cn(o, s, u, c, n[a + 12], 7, 1804603682), c = cn(c, o, s, u, n[a + 13], 12, -40341101), u = cn(u, c, o, s, n[a + 14], 17, -1502002290), o = fn(o, s = cn(s, u, c, o, n[a + 15], 22, 1236535329), u, c, n[a + 1], 5, -165796510), c = fn(c, o, s, u, n[a + 6], 9, -1069501632), u = fn(u, c, o, s, n[a + 11], 14, 643717713), s = fn(s, u, c, o, n[a], 20, -373897302), o = fn(o, s, u, c, n[a + 5], 5, -701558691), c = fn(c, o, s, u, n[a + 10], 9, 38016083), u = fn(u, c, o, s, n[a + 15], 14, -660478335), s = fn(s, u, c, o, n[a + 4], 20, -405537848), o = fn(o, s, u, c, n[a + 9], 5, 568446438), c = fn(c, o, s, u, n[a + 14], 9, -1019803690), u = fn(u, c, o, s, n[a + 3], 14, -187363961), s = fn(s, u, c, o, n[a + 8], 20, 1163531501), o = fn(o, s, u, c, n[a + 13], 5, -1444681467), c = fn(c, o, s, u, n[a + 2], 9, -51403784), u = fn(u, c, o, s, n[a + 7], 14, 1735328473), o = ln(o, s = fn(s, u, c, o, n[a + 12], 20, -1926607734), u, c, n[a + 5], 4, -378558), c = ln(c, o, s, u, n[a + 8], 11, -2022574463), u = ln(u, c, o, s, n[a + 11], 16, 1839030562), s = ln(s, u, c, o, n[a + 14], 23, -35309556), o = ln(o, s, u, c, n[a + 1], 4, -1530992060), c = ln(c, o, s, u, n[a + 4], 11, 1272893353), u = ln(u, c, o, s, n[a + 7], 16, -155497632), s = ln(s, u, c, o, n[a + 10], 23, -1094730640), o = ln(o, s, u, c, n[a + 13], 4, 681279174), c = ln(c, o, s, u, n[a], 11, -358537222), u = ln(u, c, o, s, n[a + 3], 16, -722521979), s = ln(s, u, c, o, n[a + 6], 23, 76029189), o = ln(o, s, u, c, n[a + 9], 4, -640364487), c = ln(c, o, s, u, n[a + 12], 11, -421815835), u = ln(u, c, o, s, n[a + 15], 16, 530742520), o = hn(o, s = ln(s, u, c, o, n[a + 2], 23, -995338651), u, c, n[a], 6, -198630844), c = hn(c, o, s, u, n[a + 7], 10, 1126891415), u = hn(u, c, o, s, n[a + 14], 15, -1416354905), s = hn(s, u, c, o, n[a + 5], 21, -57434055), o = hn(o, s, u, c, n[a + 12], 6, 1700485571), c = hn(c, o, s, u, n[a + 3], 10, -1894986606), u = hn(u, c, o, s, n[a + 10], 15, -1051523), s = hn(s, u, c, o, n[a + 1], 21, -2054922799), o = hn(o, s, u, c, n[a + 8], 6, 1873313359), c = hn(c, o, s, u, n[a + 15], 10, -30611744), u = hn(u, c, o, s, n[a + 6], 15, -1560198380), s = hn(s, u, c, o, n[a + 13], 21, 1309151649), o = hn(o, s, u, c, n[a + 4], 6, -145523070), c = hn(c, o, s, u, n[a + 11], 10, -1120210379), u = hn(u, c, o, s, n[a + 2], 15, 718787259), s = hn(s, u, c, o, n[a + 9], 21, -343485551), o = Ea(o, f), s = Ea(s, h), u = Ea(u, p), c = Ea(c, d);
    }
    return [o, s, u, c];
  }(function(n) {
    if (n.length === 0)
      return [];
    for (var i = 8 * n.length, o = new Uint32Array(Fb(i)), s = 0; s < i; s += 8)
      o[s >> 5] |= (255 & n[s / 8]) << s % 32;
    return o;
  }(t), 8 * t.length));
});
function j5(t, e, r, n) {
  switch (t) {
    case 0:
      return e & r ^ ~e & n;
    case 1:
    case 3:
      return e ^ r ^ n;
    case 2:
      return e & r ^ e & n ^ r & n;
  }
}
function qv(t, e) {
  return t << e | t >>> 32 - e;
}
kI("v5", 80, function(t) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var n = unescape(encodeURIComponent(t));
    t = [];
    for (var i = 0; i < n.length; ++i)
      t.push(n.charCodeAt(i));
  } else
    Array.isArray(t) || (t = Array.prototype.slice.call(t));
  t.push(128);
  for (var o = t.length / 4 + 2, s = Math.ceil(o / 16), u = new Array(s), c = 0; c < s; ++c) {
    for (var a = new Uint32Array(16), f = 0; f < 16; ++f)
      a[f] = t[64 * c + 4 * f] << 24 | t[64 * c + 4 * f + 1] << 16 | t[64 * c + 4 * f + 2] << 8 | t[64 * c + 4 * f + 3];
    u[c] = a;
  }
  u[s - 1][14] = 8 * (t.length - 1) / Math.pow(2, 32), u[s - 1][14] = Math.floor(u[s - 1][14]), u[s - 1][15] = 8 * (t.length - 1) & 4294967295;
  for (var h = 0; h < s; ++h) {
    for (var p = new Uint32Array(80), d = 0; d < 16; ++d)
      p[d] = u[h][d];
    for (var _ = 16; _ < 80; ++_)
      p[_] = qv(p[_ - 3] ^ p[_ - 8] ^ p[_ - 14] ^ p[_ - 16], 1);
    for (var m = r[0], b = r[1], O = r[2], S = r[3], k = r[4], T = 0; T < 80; ++T) {
      var x = Math.floor(T / 20), P = qv(m, 5) + j5(x, b, O, S) + k + e[x] + p[T] >>> 0;
      k = S, S = O, O = qv(b, 30) >>> 0, b = m, m = P;
    }
    r[0] = r[0] + m >>> 0, r[1] = r[1] + b >>> 0, r[2] = r[2] + O >>> 0, r[3] = r[3] + S >>> 0, r[4] = r[4] + k >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, 255 & r[0], r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, 255 & r[1], r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, 255 & r[2], r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, 255 & r[3], r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, 255 & r[4]];
});
Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null });
const q5 = (t, e) => e ?? !1;
Se.createContext({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  checkFlag: q5
});
var $l = "delete", Le = 5, Qi = 1 << Le, qn = Qi - 1, he = {};
function zy() {
  return { value: !1 };
}
function Yi(t) {
  t && (t.value = !0);
}
function P0() {
}
function Zu(t) {
  return t.size === void 0 && (t.size = t.__iterate(CI)), t.size;
}
function Ca(t, e) {
  if (typeof e != "number") {
    var r = e >>> 0;
    if ("" + r !== e || r === 4294967295)
      return NaN;
    e = r;
  }
  return e < 0 ? Zu(t) + e : e;
}
function CI() {
  return !0;
}
function cd(t, e, r) {
  return (t === 0 && !qI(t) || r !== void 0 && t <= -r) && (e === void 0 || r !== void 0 && e >= r);
}
function Kl(t, e) {
  return jI(t, e, 0);
}
function fd(t, e) {
  return jI(t, e, e);
}
function jI(t, e, r) {
  return t === void 0 ? r : qI(t) ? e === 1 / 0 ? e : Math.max(0, e + t) | 0 : e === void 0 || e === t ? t : Math.min(e, t) | 0;
}
function qI(t) {
  return t < 0 || t === 0 && 1 / t === -1 / 0;
}
var MI = "@@__IMMUTABLE_ITERABLE__@@";
function ci(t) {
  return !!(t && t[MI]);
}
var FI = "@@__IMMUTABLE_KEYED__@@";
function pr(t) {
  return !!(t && t[FI]);
}
var NI = "@@__IMMUTABLE_INDEXED__@@";
function ni(t) {
  return !!(t && t[NI]);
}
function ld(t) {
  return pr(t) || ni(t);
}
var Or = function(t) {
  return ci(t) ? t : Ri(t);
}, fo = /* @__PURE__ */ function(t) {
  function e(r) {
    return pr(r) ? r : Ba(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Or), du = /* @__PURE__ */ function(t) {
  function e(r) {
    return ni(r) ? r : Mo(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Or), jc = /* @__PURE__ */ function(t) {
  function e(r) {
    return ci(r) && !ld(r) ? r : Nc(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Or);
Or.Keyed = fo;
Or.Indexed = du;
Or.Set = jc;
var zI = "@@__IMMUTABLE_SEQ__@@";
function k0(t) {
  return !!(t && t[zI]);
}
var LI = "@@__IMMUTABLE_RECORD__@@";
function qc(t) {
  return !!(t && t[LI]);
}
function es(t) {
  return ci(t) || qc(t);
}
var Mc = "@@__IMMUTABLE_ORDERED__@@";
function Ao(t) {
  return !!(t && t[Mc]);
}
var Vl = 0, Po = 1, oo = 2, Ly = typeof Symbol == "function" && Symbol.iterator, UI = "@@iterator", hd = Ly || UI, ge = function(t) {
  this.next = t;
};
ge.prototype.toString = function() {
  return "[Iterator]";
};
ge.KEYS = Vl;
ge.VALUES = Po;
ge.ENTRIES = oo;
ge.prototype.inspect = ge.prototype.toSource = function() {
  return this.toString();
};
ge.prototype[hd] = function() {
  return this;
};
function mr(t, e, r, n) {
  var i = t === 0 ? e : t === 1 ? r : [e, r];
  return n ? n.value = i : n = {
    value: i,
    done: !1
  }, n;
}
function fi() {
  return { value: void 0, done: !0 };
}
function BI(t) {
  return Array.isArray(t) ? !0 : !!pd(t);
}
function Nb(t) {
  return t && typeof t.next == "function";
}
function Uy(t) {
  var e = pd(t);
  return e && e.call(t);
}
function pd(t) {
  var e = t && (Ly && t[Ly] || t[UI]);
  if (typeof e == "function")
    return e;
}
function M5(t) {
  var e = pd(t);
  return e && e === t.entries;
}
function F5(t) {
  var e = pd(t);
  return e && e === t.keys;
}
var Fc = Object.prototype.hasOwnProperty;
function $I(t) {
  return Array.isArray(t) || typeof t == "string" ? !0 : t && typeof t == "object" && Number.isInteger(t.length) && t.length >= 0 && (t.length === 0 ? (
    // Only {length: 0} is considered Array-like.
    Object.keys(t).length === 1
  ) : (
    // An object is only Array-like if it has a property where the last value
    // in the array-like may be found (which could be undefined).
    t.hasOwnProperty(t.length - 1)
  ));
}
var Ri = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? j0() : es(r) ? r.toSeq() : z5(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, e.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, e.prototype.__iterate = function(r, n) {
    var i = this._cache;
    if (i) {
      for (var o = i.length, s = 0; s !== o; ) {
        var u = i[n ? o - ++s : s++];
        if (r(u[1], u[0], this) === !1)
          break;
      }
      return s;
    }
    return this.__iterateUncached(r, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._cache;
    if (i) {
      var o = i.length, s = 0;
      return new ge(function() {
        if (s === o)
          return fi();
        var u = i[n ? o - ++s : s++];
        return mr(r, u[0], u[1]);
      });
    }
    return this.__iteratorUncached(r, n);
  }, e;
}(Or), Ba = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? j0().toKeyedSeq() : ci(r) ? pr(r) ? r.toSeq() : r.fromEntrySeq() : qc(r) ? r.toSeq() : q0(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toKeyedSeq = function() {
    return this;
  }, e;
}(Ri), Mo = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? j0() : ci(r) ? pr(r) ? r.entrySeq() : r.toIndexedSeq() : qc(r) ? r.toSeq().entrySeq() : KI(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toIndexedSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, e;
}(Ri), Nc = /* @__PURE__ */ function(t) {
  function e(r) {
    return (ci(r) && !ld(r) ? r : Mo(r)).toSetSeq();
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toSetSeq = function() {
    return this;
  }, e;
}(Ri);
Ri.isSeq = k0;
Ri.Keyed = Ba;
Ri.Set = Nc;
Ri.Indexed = Mo;
Ri.prototype[zI] = !0;
var ou = /* @__PURE__ */ function(t) {
  function e(r) {
    this._array = r, this.size = r.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return this.has(r) ? this._array[Ca(this, r)] : n;
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this._array, o = i.length, s = 0; s !== o; ) {
      var u = n ? o - ++s : s++;
      if (r(i[u], u, this) === !1)
        break;
    }
    return s;
  }, e.prototype.__iterator = function(r, n) {
    var i = this._array, o = i.length, s = 0;
    return new ge(function() {
      if (s === o)
        return fi();
      var u = n ? o - ++s : s++;
      return mr(r, u, i[u]);
    });
  }, e;
}(Mo), C0 = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = Object.keys(r).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(r) : []
    );
    this._object = r, this._keys = n, this.size = n.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return n !== void 0 && !this.has(r) ? n : this._object[r];
  }, e.prototype.has = function(r) {
    return Fc.call(this._object, r);
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this._object, o = this._keys, s = o.length, u = 0; u !== s; ) {
      var c = o[n ? s - ++u : u++];
      if (r(i[c], c, this) === !1)
        break;
    }
    return u;
  }, e.prototype.__iterator = function(r, n) {
    var i = this._object, o = this._keys, s = o.length, u = 0;
    return new ge(function() {
      if (u === s)
        return fi();
      var c = o[n ? s - ++u : u++];
      return mr(r, c, i[c]);
    });
  }, e;
}(Ba);
C0.prototype[Mc] = !0;
var N5 = /* @__PURE__ */ function(t) {
  function e(r) {
    this._collection = r, this.size = r.length || r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.__iterateUncached = function(r, n) {
    if (n)
      return this.cacheResult().__iterate(r, n);
    var i = this._collection, o = Uy(i), s = 0;
    if (Nb(o))
      for (var u; !(u = o.next()).done && r(u.value, s++, this) !== !1; )
        ;
    return s;
  }, e.prototype.__iteratorUncached = function(r, n) {
    if (n)
      return this.cacheResult().__iterator(r, n);
    var i = this._collection, o = Uy(i);
    if (!Nb(o))
      return new ge(fi);
    var s = 0;
    return new ge(function() {
      var u = o.next();
      return u.done ? u : mr(r, s++, u.value);
    });
  }, e;
}(Mo), zb;
function j0() {
  return zb || (zb = new ou([]));
}
function q0(t) {
  var e = M0(t);
  if (e)
    return e.fromEntrySeq();
  if (typeof t == "object")
    return new C0(t);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + t
  );
}
function KI(t) {
  var e = M0(t);
  if (e)
    return e;
  throw new TypeError(
    "Expected Array or collection object of values: " + t
  );
}
function z5(t) {
  var e = M0(t);
  if (e)
    return M5(t) ? e.fromEntrySeq() : F5(t) ? e.toSetSeq() : e;
  if (typeof t == "object")
    return new C0(t);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + t
  );
}
function M0(t) {
  return $I(t) ? new ou(t) : BI(t) ? new N5(t) : void 0;
}
var VI = "@@__IMMUTABLE_MAP__@@";
function F0(t) {
  return !!(t && t[VI]);
}
function QI(t) {
  return F0(t) && Ao(t);
}
function Lb(t) {
  return !!(t && typeof t.equals == "function" && typeof t.hashCode == "function");
}
function Si(t, e) {
  if (t === e || t !== t && e !== e)
    return !0;
  if (!t || !e)
    return !1;
  if (typeof t.valueOf == "function" && typeof e.valueOf == "function") {
    if (t = t.valueOf(), e = e.valueOf(), t === e || t !== t && e !== e)
      return !0;
    if (!t || !e)
      return !1;
  }
  return !!(Lb(t) && Lb(e) && t.equals(e));
}
var bf = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(t, e) {
  t |= 0, e |= 0;
  var r = t & 65535, n = e & 65535;
  return r * n + ((t >>> 16) * n + r * (e >>> 16) << 16 >>> 0) | 0;
};
function dd(t) {
  return t >>> 1 & 1073741824 | t & 3221225471;
}
var L5 = Object.prototype.valueOf;
function mi(t) {
  if (t == null)
    return Ub(t);
  if (typeof t.hashCode == "function")
    return dd(t.hashCode(t));
  var e = Q5(t);
  if (e == null)
    return Ub(e);
  switch (typeof e) {
    case "boolean":
      return e ? 1108378657 : 1108378656;
    case "number":
      return U5(e);
    case "string":
      return e.length > Y5 ? B5(e) : By(e);
    case "object":
    case "function":
      return K5(e);
    case "symbol":
      return $5(e);
    default:
      if (typeof e.toString == "function")
        return By(e.toString());
      throw new Error("Value type " + typeof e + " cannot be hashed.");
  }
}
function Ub(t) {
  return t === null ? 1108378658 : (
    /* undefined */
    1108378659
  );
}
function U5(t) {
  if (t !== t || t === 1 / 0)
    return 0;
  var e = t | 0;
  for (e !== t && (e ^= t * 4294967295); t > 4294967295; )
    t /= 4294967295, e ^= t;
  return dd(e);
}
function B5(t) {
  var e = Nv[t];
  return e === void 0 && (e = By(t), Fv === G5 && (Fv = 0, Nv = {}), Fv++, Nv[t] = e), e;
}
function By(t) {
  for (var e = 0, r = 0; r < t.length; r++)
    e = 31 * e + t.charCodeAt(r) | 0;
  return dd(e);
}
function $5(t) {
  var e = Kb[t];
  return e !== void 0 || (e = YI(), Kb[t] = e), e;
}
function K5(t) {
  var e;
  if ($y && (e = Ky.get(t), e !== void 0) || (e = t[Wa], e !== void 0) || !$b && (e = t.propertyIsEnumerable && t.propertyIsEnumerable[Wa], e !== void 0 || (e = V5(t), e !== void 0)))
    return e;
  if (e = YI(), $y)
    Ky.set(t, e);
  else {
    if (Bb !== void 0 && Bb(t) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if ($b)
      Object.defineProperty(t, Wa, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: e
      });
    else if (t.propertyIsEnumerable !== void 0 && t.propertyIsEnumerable === t.constructor.prototype.propertyIsEnumerable)
      t.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, t.propertyIsEnumerable[Wa] = e;
    else if (t.nodeType !== void 0)
      t[Wa] = e;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return e;
}
var Bb = Object.isExtensible, $b = function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
}();
function V5(t) {
  if (t && t.nodeType > 0)
    switch (t.nodeType) {
      case 1:
        return t.uniqueID;
      case 9:
        return t.documentElement && t.documentElement.uniqueID;
    }
}
function Q5(t) {
  return t.valueOf !== L5 && typeof t.valueOf == "function" ? t.valueOf(t) : t;
}
function YI() {
  var t = ++Mv;
  return Mv & 1073741824 && (Mv = 0), t;
}
var $y = typeof WeakMap == "function", Ky;
$y && (Ky = /* @__PURE__ */ new WeakMap());
var Kb = /* @__PURE__ */ Object.create(null), Mv = 0, Wa = "__immutablehash__";
typeof Symbol == "function" && (Wa = Symbol(Wa));
var Y5 = 16, G5 = 255, Fv = 0, Nv = {}, vd = /* @__PURE__ */ function(t) {
  function e(r, n) {
    this._iter = r, this._useKeys = n, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return this._iter.get(r, n);
  }, e.prototype.has = function(r) {
    return this._iter.has(r);
  }, e.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, e.prototype.reverse = function() {
    var r = this, n = N0(this, !0);
    return this._useKeys || (n.valueSeq = function() {
      return r._iter.toSeq().reverse();
    }), n;
  }, e.prototype.map = function(r, n) {
    var i = this, o = ZI(this, r, n);
    return this._useKeys || (o.valueSeq = function() {
      return i._iter.toSeq().map(r, n);
    }), o;
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o, s) {
      return r(o, s, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    return this._iter.__iterator(r, n);
  }, e;
}(Ba);
vd.prototype[Mc] = !0;
var GI = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.includes = function(r) {
    return this._iter.includes(r);
  }, e.prototype.__iterate = function(r, n) {
    var i = this, o = 0;
    return n && Zu(this), this._iter.__iterate(
      function(s) {
        return r(s, n ? i.size - ++o : o++, i);
      },
      n
    );
  }, e.prototype.__iterator = function(r, n) {
    var i = this, o = this._iter.__iterator(Po, n), s = 0;
    return n && Zu(this), new ge(function() {
      var u = o.next();
      return u.done ? u : mr(
        r,
        n ? i.size - ++s : s++,
        u.value,
        u
      );
    });
  }, e;
}(Mo), WI = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.has = function(r) {
    return this._iter.includes(r);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o) {
      return r(o, o, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._iter.__iterator(Po, n);
    return new ge(function() {
      var o = i.next();
      return o.done ? o : mr(r, o.value, o.value, o);
    });
  }, e;
}(Nc), HI = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o) {
      if (o) {
        Qb(o);
        var s = ci(o);
        return r(
          s ? o.get(1) : o[1],
          s ? o.get(0) : o[0],
          i
        );
      }
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._iter.__iterator(Po, n);
    return new ge(function() {
      for (; ; ) {
        var o = i.next();
        if (o.done)
          return o;
        var s = o.value;
        if (s) {
          Qb(s);
          var u = ci(s);
          return mr(
            r,
            u ? s.get(0) : s[0],
            u ? s.get(1) : s[1],
            o
          );
        }
      }
    });
  }, e;
}(Ba);
GI.prototype.cacheResult = vd.prototype.cacheResult = WI.prototype.cacheResult = HI.prototype.cacheResult = U0;
function JI(t) {
  var e = rs(t);
  return e._iter = t, e.size = t.size, e.flip = function() {
    return t;
  }, e.reverse = function() {
    var r = t.reverse.apply(this);
    return r.flip = function() {
      return t.reverse();
    }, r;
  }, e.has = function(r) {
    return t.includes(r);
  }, e.includes = function(r) {
    return t.has(r);
  }, e.cacheResult = U0, e.__iterateUncached = function(r, n) {
    var i = this;
    return t.__iterate(function(o, s) {
      return r(s, o, i) !== !1;
    }, n);
  }, e.__iteratorUncached = function(r, n) {
    if (r === oo) {
      var i = t.__iterator(r, n);
      return new ge(function() {
        var o = i.next();
        if (!o.done) {
          var s = o.value[0];
          o.value[0] = o.value[1], o.value[1] = s;
        }
        return o;
      });
    }
    return t.__iterator(
      r === Po ? Vl : Po,
      n
    );
  }, e;
}
function ZI(t, e, r) {
  var n = rs(t);
  return n.size = t.size, n.has = function(i) {
    return t.has(i);
  }, n.get = function(i, o) {
    var s = t.get(i, he);
    return s === he ? o : e.call(r, s, i, t);
  }, n.__iterateUncached = function(i, o) {
    var s = this;
    return t.__iterate(
      function(u, c, a) {
        return i(e.call(r, u, c, a), c, s) !== !1;
      },
      o
    );
  }, n.__iteratorUncached = function(i, o) {
    var s = t.__iterator(oo, o);
    return new ge(function() {
      var u = s.next();
      if (u.done)
        return u;
      var c = u.value, a = c[0];
      return mr(
        i,
        a,
        e.call(r, c[1], a, t),
        u
      );
    });
  }, n;
}
function N0(t, e) {
  var r = this, n = rs(t);
  return n._iter = t, n.size = t.size, n.reverse = function() {
    return t;
  }, t.flip && (n.flip = function() {
    var i = JI(t);
    return i.reverse = function() {
      return t.flip();
    }, i;
  }), n.get = function(i, o) {
    return t.get(e ? i : -1 - i, o);
  }, n.has = function(i) {
    return t.has(e ? i : -1 - i);
  }, n.includes = function(i) {
    return t.includes(i);
  }, n.cacheResult = U0, n.__iterate = function(i, o) {
    var s = this, u = 0;
    return o && Zu(t), t.__iterate(
      function(c, a) {
        return i(c, e ? a : o ? s.size - ++u : u++, s);
      },
      !o
    );
  }, n.__iterator = function(i, o) {
    var s = 0;
    o && Zu(t);
    var u = t.__iterator(oo, !o);
    return new ge(function() {
      var c = u.next();
      if (c.done)
        return c;
      var a = c.value;
      return mr(
        i,
        e ? a[0] : o ? r.size - ++s : s++,
        a[1],
        c
      );
    });
  }, n;
}
function XI(t, e, r, n) {
  var i = rs(t);
  return n && (i.has = function(o) {
    var s = t.get(o, he);
    return s !== he && !!e.call(r, s, o, t);
  }, i.get = function(o, s) {
    var u = t.get(o, he);
    return u !== he && e.call(r, u, o, t) ? u : s;
  }), i.__iterateUncached = function(o, s) {
    var u = this, c = 0;
    return t.__iterate(function(a, f, h) {
      if (e.call(r, a, f, h))
        return c++, o(a, n ? f : c - 1, u);
    }, s), c;
  }, i.__iteratorUncached = function(o, s) {
    var u = t.__iterator(oo, s), c = 0;
    return new ge(function() {
      for (; ; ) {
        var a = u.next();
        if (a.done)
          return a;
        var f = a.value, h = f[0], p = f[1];
        if (e.call(r, p, h, t))
          return mr(o, n ? h : c++, p, a);
      }
    });
  }, i;
}
function W5(t, e, r) {
  var n = Lc().asMutable();
  return t.__iterate(function(i, o) {
    n.update(e.call(r, i, o, t), 0, function(s) {
      return s + 1;
    });
  }), n.asImmutable();
}
function H5(t, e, r) {
  var n = pr(t), i = (Ao(t) ? ra() : Lc()).asMutable();
  t.__iterate(function(s, u) {
    i.update(
      e.call(r, s, u, t),
      function(c) {
        return c = c || [], c.push(n ? [u, s] : s), c;
      }
    );
  });
  var o = L0(t);
  return i.map(function(s) {
    return xe(t, o(s));
  }).asImmutable();
}
function J5(t, e, r) {
  var n = pr(t), i = [[], []];
  t.__iterate(function(s, u) {
    i[e.call(r, s, u, t) ? 1 : 0].push(
      n ? [u, s] : s
    );
  });
  var o = L0(t);
  return i.map(function(s) {
    return xe(t, o(s));
  });
}
function z0(t, e, r, n) {
  var i = t.size;
  if (cd(e, r, i))
    return t;
  var o = Kl(e, i), s = fd(r, i);
  if (o !== o || s !== s)
    return z0(t.toSeq().cacheResult(), e, r, n);
  var u = s - o, c;
  u === u && (c = u < 0 ? 0 : u);
  var a = rs(t);
  return a.size = c === 0 ? c : t.size && c || void 0, !n && k0(t) && c >= 0 && (a.get = function(f, h) {
    return f = Ca(this, f), f >= 0 && f < c ? t.get(f + o, h) : h;
  }), a.__iterateUncached = function(f, h) {
    var p = this;
    if (c === 0)
      return 0;
    if (h)
      return this.cacheResult().__iterate(f, h);
    var d = 0, _ = !0, m = 0;
    return t.__iterate(function(b, O) {
      if (!(_ && (_ = d++ < o)))
        return m++, f(b, n ? O : m - 1, p) !== !1 && m !== c;
    }), m;
  }, a.__iteratorUncached = function(f, h) {
    if (c !== 0 && h)
      return this.cacheResult().__iterator(f, h);
    if (c === 0)
      return new ge(fi);
    var p = t.__iterator(f, h), d = 0, _ = 0;
    return new ge(function() {
      for (; d++ < o; )
        p.next();
      if (++_ > c)
        return fi();
      var m = p.next();
      return n || f === Po || m.done ? m : f === Vl ? mr(f, _ - 1, void 0, m) : mr(f, _ - 1, m.value[1], m);
    });
  }, a;
}
function Z5(t, e, r) {
  var n = rs(t);
  return n.__iterateUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterate(i, o);
    var u = 0;
    return t.__iterate(
      function(c, a, f) {
        return e.call(r, c, a, f) && ++u && i(c, a, s);
      }
    ), u;
  }, n.__iteratorUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterator(i, o);
    var u = t.__iterator(oo, o), c = !0;
    return new ge(function() {
      if (!c)
        return fi();
      var a = u.next();
      if (a.done)
        return a;
      var f = a.value, h = f[0], p = f[1];
      return e.call(r, p, h, s) ? i === oo ? a : mr(i, h, p, a) : (c = !1, fi());
    });
  }, n;
}
function tA(t, e, r, n) {
  var i = rs(t);
  return i.__iterateUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterate(o, s);
    var c = !0, a = 0;
    return t.__iterate(function(f, h, p) {
      if (!(c && (c = e.call(r, f, h, p))))
        return a++, o(f, n ? h : a - 1, u);
    }), a;
  }, i.__iteratorUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterator(o, s);
    var c = t.__iterator(oo, s), a = !0, f = 0;
    return new ge(function() {
      var h, p, d;
      do {
        if (h = c.next(), h.done)
          return n || o === Po ? h : o === Vl ? mr(o, f++, void 0, h) : mr(o, f++, h.value[1], h);
        var _ = h.value;
        p = _[0], d = _[1], a && (a = e.call(r, d, p, u));
      } while (a);
      return o === oo ? h : mr(o, p, d, h);
    });
  }, i;
}
function X5(t, e) {
  var r = pr(t), n = [t].concat(e).map(function(s) {
    return ci(s) ? r && (s = fo(s)) : s = r ? q0(s) : KI(Array.isArray(s) ? s : [s]), s;
  }).filter(function(s) {
    return s.size !== 0;
  });
  if (n.length === 0)
    return t;
  if (n.length === 1) {
    var i = n[0];
    if (i === t || r && pr(i) || ni(t) && ni(i))
      return i;
  }
  var o = new ou(n);
  return r ? o = o.toKeyedSeq() : ni(t) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = n.reduce(function(s, u) {
    if (s !== void 0) {
      var c = u.size;
      if (c !== void 0)
        return s + c;
    }
  }, 0), o;
}
function eA(t, e, r) {
  var n = rs(t);
  return n.__iterateUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterate(i, o);
    var s = 0, u = !1;
    function c(a, f) {
      a.__iterate(function(h, p) {
        return (!e || f < e) && ci(h) ? c(h, f + 1) : (s++, i(h, r ? p : s - 1, n) === !1 && (u = !0)), !u;
      }, o);
    }
    return c(t, 0), s;
  }, n.__iteratorUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterator(i, o);
    var s = t.__iterator(i, o), u = [], c = 0;
    return new ge(function() {
      for (; s; ) {
        var a = s.next();
        if (a.done !== !1) {
          s = u.pop();
          continue;
        }
        var f = a.value;
        if (i === oo && (f = f[1]), (!e || u.length < e) && ci(f))
          u.push(s), s = f.__iterator(i, o);
        else
          return r ? a : mr(i, c++, f, a);
      }
      return fi();
    });
  }, n;
}
function tj(t, e, r) {
  var n = L0(t);
  return t.toSeq().map(function(i, o) {
    return n(e.call(r, i, o, t));
  }).flatten(!0);
}
function ej(t, e) {
  var r = rs(t);
  return r.size = t.size && t.size * 2 - 1, r.__iterateUncached = function(n, i) {
    var o = this, s = 0;
    return t.__iterate(
      function(u) {
        return (!s || n(e, s++, o) !== !1) && n(u, s++, o) !== !1;
      },
      i
    ), s;
  }, r.__iteratorUncached = function(n, i) {
    var o = t.__iterator(Po, i), s = 0, u;
    return new ge(function() {
      return (!u || s % 2) && (u = o.next(), u.done) ? u : s % 2 ? mr(n, s++, e) : mr(n, s++, u.value, u);
    });
  }, r;
}
function Xu(t, e, r) {
  e || (e = rA);
  var n = pr(t), i = 0, o = t.toSeq().map(function(s, u) {
    return [u, s, i++, r ? r(s, u, t) : s];
  }).valueSeq().toArray();
  return o.sort(function(s, u) {
    return e(s[3], u[3]) || s[2] - u[2];
  }).forEach(
    n ? function(s, u) {
      o[u].length = 2;
    } : function(s, u) {
      o[u] = s[1];
    }
  ), n ? Ba(o) : ni(t) ? Mo(o) : Nc(o);
}
function xh(t, e, r) {
  if (e || (e = rA), r) {
    var n = t.toSeq().map(function(i, o) {
      return [i, r(i, o, t)];
    }).reduce(function(i, o) {
      return Vb(e, i[1], o[1]) ? o : i;
    });
    return n && n[0];
  }
  return t.reduce(function(i, o) {
    return Vb(e, i, o) ? o : i;
  });
}
function Vb(t, e, r) {
  var n = t(r, e);
  return n === 0 && r !== e && (r == null || r !== r) || n > 0;
}
function Th(t, e, r, n) {
  var i = rs(t), o = new ou(r).map(function(s) {
    return s.size;
  });
  return i.size = n ? o.max() : o.min(), i.__iterate = function(s, u) {
    for (var c = this.__iterator(Po, u), a, f = 0; !(a = c.next()).done && s(a.value, f++, this) !== !1; )
      ;
    return f;
  }, i.__iteratorUncached = function(s, u) {
    var c = r.map(
      function(h) {
        return h = Or(h), Uy(u ? h.reverse() : h);
      }
    ), a = 0, f = !1;
    return new ge(function() {
      var h;
      return f || (h = c.map(function(p) {
        return p.next();
      }), f = n ? h.every(function(p) {
        return p.done;
      }) : h.some(function(p) {
        return p.done;
      })), f ? fi() : mr(
        s,
        a++,
        e.apply(
          null,
          h.map(function(p) {
            return p.value;
          })
        )
      );
    });
  }, i;
}
function xe(t, e) {
  return t === e ? t : k0(t) ? e : t.constructor(e);
}
function Qb(t) {
  if (t !== Object(t))
    throw new TypeError("Expected [K, V] tuple: " + t);
}
function L0(t) {
  return pr(t) ? fo : ni(t) ? du : jc;
}
function rs(t) {
  return Object.create(
    (pr(t) ? Ba : ni(t) ? Mo : Nc).prototype
  );
}
function U0() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : Ri.prototype.cacheResult.call(this);
}
function rA(t, e) {
  return t === void 0 && e === void 0 ? 0 : t === void 0 ? 1 : e === void 0 ? -1 : t > e ? 1 : t < e ? -1 : 0;
}
function Qo(t, e) {
  e = e || 0;
  for (var r = Math.max(0, t.length - e), n = new Array(r), i = 0; i < r; i++)
    n[i] = t[i + e];
  return n;
}
function B0(t, e) {
  if (!t)
    throw new Error(e);
}
function Gi(t) {
  B0(
    t !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function nA(t) {
  if ($I(t) && typeof t != "string")
    return t;
  if (Ao(t))
    return t.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + t
  );
}
var rj = Object.prototype.toString;
function nj(t) {
  if (!t || typeof t != "object" || rj.call(t) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(t);
  if (e === null)
    return !0;
  for (var r = e, n = Object.getPrototypeOf(e); n !== null; )
    r = n, n = Object.getPrototypeOf(r);
  return r === e;
}
function ja(t) {
  return typeof t == "object" && (es(t) || Array.isArray(t) || nj(t));
}
function al(t) {
  try {
    return typeof t == "string" ? JSON.stringify(t) : String(t);
  } catch {
    return JSON.stringify(t);
  }
}
function ij(t, e) {
  return es(t) ? t.has(e) : ja(t) && Fc.call(t, e);
}
function iA(t, e, r) {
  return es(t) ? t.get(e, r) : ij(t, e) ? typeof t.get == "function" ? t.get(e) : t[e] : r;
}
function Dp(t) {
  if (Array.isArray(t))
    return Qo(t);
  var e = {};
  for (var r in t)
    Fc.call(t, r) && (e[r] = t[r]);
  return e;
}
function oj(t, e) {
  if (!ja(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (es(t)) {
    if (!t.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + t
      );
    return t.remove(e);
  }
  if (!Fc.call(t, e))
    return t;
  var r = Dp(t);
  return Array.isArray(r) ? r.splice(e, 1) : delete r[e], r;
}
function sj(t, e, r) {
  if (!ja(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (es(t)) {
    if (!t.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + t
      );
    return t.set(e, r);
  }
  if (Fc.call(t, e) && r === t[e])
    return t;
  var n = Dp(t);
  return n[e] = r, n;
}
function zc(t, e, r, n) {
  n || (n = r, r = void 0);
  var i = oA(
    es(t),
    t,
    nA(e),
    0,
    r,
    n
  );
  return i === he ? r : i;
}
function oA(t, e, r, n, i, o) {
  var s = e === he;
  if (n === r.length) {
    var u = s ? i : e, c = o(u);
    return c === u ? e : c;
  }
  if (!s && !ja(e))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + r.slice(0, n).map(al) + "]: " + e
    );
  var a = r[n], f = s ? he : iA(e, a, he), h = oA(
    f === he ? t : es(f),
    f,
    r,
    n + 1,
    i,
    o
  );
  return h === f ? e : h === he ? oj(e, a) : sj(
    s ? t ? wo() : {} : e,
    a,
    h
  );
}
function aj(t, e, r) {
  return zc(t, e, he, function() {
    return r;
  });
}
function $0(t, e) {
  return aj(this, t, e);
}
function uj(t, e) {
  return zc(t, e, function() {
    return he;
  });
}
function K0(t) {
  return uj(this, t);
}
function sA(t, e, r, n) {
  return zc(t, [e], r, n);
}
function V0(t, e, r) {
  return arguments.length === 1 ? t(this) : sA(this, t, e, r);
}
function Q0(t, e, r) {
  return zc(this, t, e, r);
}
function aA() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return cA(this, t);
}
function uA(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  if (typeof t != "function")
    throw new TypeError("Invalid merger function: " + t);
  return cA(this, e, t);
}
function cA(t, e, r) {
  for (var n = [], i = 0; i < e.length; i++) {
    var o = fo(e[i]);
    o.size !== 0 && n.push(o);
  }
  return n.length === 0 ? t : t.toSeq().size === 0 && !t.__ownerID && n.length === 1 ? t.constructor(n[0]) : t.withMutations(function(s) {
    for (var u = r ? function(a, f) {
      sA(
        s,
        f,
        he,
        function(h) {
          return h === he ? a : r(h, a, f);
        }
      );
    } : function(a, f) {
      s.set(f, a);
    }, c = 0; c < n.length; c++)
      n[c].forEach(u);
  });
}
function Y0(t, e, r) {
  return G0(t, e, cj(r));
}
function G0(t, e, r) {
  if (!ja(t))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + t
    );
  if (es(t))
    return typeof r == "function" && t.mergeWith ? t.mergeWith.apply(t, [r].concat(e)) : t.merge ? t.merge.apply(t, e) : t.concat.apply(t, e);
  for (var n = Array.isArray(t), i = t, o = n ? du : fo, s = n ? function(c) {
    i === t && (i = Dp(i)), i.push(c);
  } : function(c, a) {
    var f = Fc.call(i, a), h = f && r ? r(i[a], c, a) : c;
    (!f || h !== i[a]) && (i === t && (i = Dp(i)), i[a] = h);
  }, u = 0; u < e.length; u++)
    o(e[u]).forEach(s);
  return i;
}
function cj(t) {
  function e(r, n, i) {
    return ja(r) && ja(n) && fj(r, n) ? G0(r, [n], e) : t ? t(r, n, i) : n;
  }
  return e;
}
function fj(t, e) {
  var r = Ri(t), n = Ri(e);
  return ni(r) === ni(n) && pr(r) === pr(n);
}
function fA() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return Y0(this, t);
}
function lA(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return Y0(this, e, t);
}
function W0(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return zc(this, t, wo(), function(n) {
    return G0(n, e);
  });
}
function H0(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return zc(
    this,
    t,
    wo(),
    function(n) {
      return Y0(n, e);
    }
  );
}
function Ql(t) {
  var e = this.asMutable();
  return t(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
}
function Yl() {
  return this.__ownerID ? this : this.__ensureOwner(new P0());
}
function Gl() {
  return this.__ensureOwner();
}
function J0() {
  return this.__altered;
}
var Lc = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? wo() : F0(r) && !Ao(r) ? r : wo().withMutations(function(n) {
      var i = t(r);
      Gi(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    return wo().withMutations(function(i) {
      for (var o = 0; o < r.length; o += 2) {
        if (o + 1 >= r.length)
          throw new Error("Missing value for key: " + r[o]);
        i.set(r[o], r[o + 1]);
      }
    });
  }, e.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, e.prototype.get = function(r, n) {
    return this._root ? this._root.get(0, void 0, r, n) : n;
  }, e.prototype.set = function(r, n) {
    return Wb(this, r, n);
  }, e.prototype.remove = function(r) {
    return Wb(this, r, he);
  }, e.prototype.deleteAll = function(r) {
    var n = Or(r);
    return n.size === 0 ? this : this.withMutations(function(i) {
      n.forEach(function(o) {
        return i.remove(o);
      });
    });
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : wo();
  }, e.prototype.sort = function(r) {
    return ra(Xu(this, r));
  }, e.prototype.sortBy = function(r, n) {
    return ra(Xu(this, n, r));
  }, e.prototype.map = function(r, n) {
    var i = this;
    return this.withMutations(function(o) {
      o.forEach(function(s, u) {
        o.set(u, r.call(n, s, u, i));
      });
    });
  }, e.prototype.__iterator = function(r, n) {
    return new lj(this, r, n);
  }, e.prototype.__iterate = function(r, n) {
    var i = this, o = 0;
    return this._root && this._root.iterate(function(s) {
      return o++, r(s[1], s[0], i);
    }, n), o;
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? Z0(this.size, this._root, r, this.__hash) : this.size === 0 ? wo() : (this.__ownerID = r, this.__altered = !1, this);
  }, e;
}(fo);
Lc.isMap = F0;
var Ve = Lc.prototype;
Ve[VI] = !0;
Ve[$l] = Ve.remove;
Ve.removeAll = Ve.deleteAll;
Ve.setIn = $0;
Ve.removeIn = Ve.deleteIn = K0;
Ve.update = V0;
Ve.updateIn = Q0;
Ve.merge = Ve.concat = aA;
Ve.mergeWith = uA;
Ve.mergeDeep = fA;
Ve.mergeDeepWith = lA;
Ve.mergeIn = W0;
Ve.mergeDeepIn = H0;
Ve.withMutations = Ql;
Ve.wasAltered = J0;
Ve.asImmutable = Gl;
Ve["@@transducer/init"] = Ve.asMutable = Yl;
Ve["@@transducer/step"] = function(t, e) {
  return t.set(e[0], e[1]);
};
Ve["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var ul = function(t, e) {
  this.ownerID = t, this.entries = e;
};
ul.prototype.get = function(t, e, r, n) {
  for (var i = this.entries, o = 0, s = i.length; o < s; o++)
    if (Si(r, i[o][0]))
      return i[o][1];
  return n;
};
ul.prototype.update = function(t, e, r, n, i, o, s) {
  for (var u = i === he, c = this.entries, a = 0, f = c.length; a < f && !Si(n, c[a][0]); a++)
    ;
  var h = a < f;
  if (h ? c[a][1] === i : u)
    return this;
  if (Yi(s), (u || !h) && Yi(o), !(u && c.length === 1)) {
    if (!h && !u && c.length >= _j)
      return hj(t, c, n, i);
    var p = t && t === this.ownerID, d = p ? c : Qo(c);
    return h ? u ? a === f - 1 ? d.pop() : d[a] = d.pop() : d[a] = [n, i] : d.push([n, i]), p ? (this.entries = d, this) : new ul(t, d);
  }
};
var tc = function(t, e, r) {
  this.ownerID = t, this.bitmap = e, this.nodes = r;
};
tc.prototype.get = function(t, e, r, n) {
  e === void 0 && (e = mi(r));
  var i = 1 << ((t === 0 ? e : e >>> t) & qn), o = this.bitmap;
  return o & i ? this.nodes[hA(o & i - 1)].get(
    t + Le,
    e,
    r,
    n
  ) : n;
};
tc.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = mi(n));
  var u = (e === 0 ? r : r >>> e) & qn, c = 1 << u, a = this.bitmap, f = (a & c) !== 0;
  if (!f && i === he)
    return this;
  var h = hA(a & c - 1), p = this.nodes, d = f ? p[h] : void 0, _ = X0(
    d,
    t,
    e + Le,
    r,
    n,
    i,
    o,
    s
  );
  if (_ === d)
    return this;
  if (!f && _ && p.length >= mj)
    return dj(t, p, a, u, _);
  if (f && !_ && p.length === 2 && Hb(p[h ^ 1]))
    return p[h ^ 1];
  if (f && _ && p.length === 1 && Hb(_))
    return _;
  var m = t && t === this.ownerID, b = f ? _ ? a : a ^ c : a | c, O = f ? _ ? pA(p, h, _, m) : yj(p, h, m) : vj(p, h, _, m);
  return m ? (this.bitmap = b, this.nodes = O, this) : new tc(t, b, O);
};
var cl = function(t, e, r) {
  this.ownerID = t, this.count = e, this.nodes = r;
};
cl.prototype.get = function(t, e, r, n) {
  e === void 0 && (e = mi(r));
  var i = (t === 0 ? e : e >>> t) & qn, o = this.nodes[i];
  return o ? o.get(t + Le, e, r, n) : n;
};
cl.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = mi(n));
  var u = (e === 0 ? r : r >>> e) & qn, c = i === he, a = this.nodes, f = a[u];
  if (c && !f)
    return this;
  var h = X0(
    f,
    t,
    e + Le,
    r,
    n,
    i,
    o,
    s
  );
  if (h === f)
    return this;
  var p = this.count;
  if (!f)
    p++;
  else if (!h && (p--, p < gj))
    return pj(t, a, p, u);
  var d = t && t === this.ownerID, _ = pA(a, u, h, d);
  return d ? (this.count = p, this.nodes = _, this) : new cl(t, p, _);
};
var ec = function(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entries = r;
};
ec.prototype.get = function(t, e, r, n) {
  for (var i = this.entries, o = 0, s = i.length; o < s; o++)
    if (Si(r, i[o][0]))
      return i[o][1];
  return n;
};
ec.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = mi(n));
  var u = i === he;
  if (r !== this.keyHash)
    return u ? this : (Yi(s), Yi(o), tm(this, t, e, r, [n, i]));
  for (var c = this.entries, a = 0, f = c.length; a < f && !Si(n, c[a][0]); a++)
    ;
  var h = a < f;
  if (h ? c[a][1] === i : u)
    return this;
  if (Yi(s), (u || !h) && Yi(o), u && f === 2)
    return new ea(t, this.keyHash, c[a ^ 1]);
  var p = t && t === this.ownerID, d = p ? c : Qo(c);
  return h ? u ? a === f - 1 ? d.pop() : d[a] = d.pop() : d[a] = [n, i] : d.push([n, i]), p ? (this.entries = d, this) : new ec(t, this.keyHash, d);
};
var ea = function(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entry = r;
};
ea.prototype.get = function(t, e, r, n) {
  return Si(r, this.entry[0]) ? this.entry[1] : n;
};
ea.prototype.update = function(t, e, r, n, i, o, s) {
  var u = i === he, c = Si(n, this.entry[0]);
  if (c ? i === this.entry[1] : u)
    return this;
  if (Yi(s), u) {
    Yi(o);
    return;
  }
  return c ? t && t === this.ownerID ? (this.entry[1] = i, this) : new ea(t, this.keyHash, [n, i]) : (Yi(o), tm(this, t, e, mi(n), [n, i]));
};
ul.prototype.iterate = ec.prototype.iterate = function(t, e) {
  for (var r = this.entries, n = 0, i = r.length - 1; n <= i; n++)
    if (t(r[e ? i - n : n]) === !1)
      return !1;
};
tc.prototype.iterate = cl.prototype.iterate = function(t, e) {
  for (var r = this.nodes, n = 0, i = r.length - 1; n <= i; n++) {
    var o = r[e ? i - n : n];
    if (o && o.iterate(t, e) === !1)
      return !1;
  }
};
ea.prototype.iterate = function(t, e) {
  return t(this.entry);
};
var lj = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    this._type = n, this._reverse = i, this._stack = r._root && Yb(r._root);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function() {
    for (var r = this._type, n = this._stack; n; ) {
      var i = n.node, o = n.index++, s = void 0;
      if (i.entry) {
        if (o === 0)
          return zv(r, i.entry);
      } else if (i.entries) {
        if (s = i.entries.length - 1, o <= s)
          return zv(
            r,
            i.entries[this._reverse ? s - o : o]
          );
      } else if (s = i.nodes.length - 1, o <= s) {
        var u = i.nodes[this._reverse ? s - o : o];
        if (u) {
          if (u.entry)
            return zv(r, u.entry);
          n = this._stack = Yb(u, n);
        }
        continue;
      }
      n = this._stack = this._stack.__prev;
    }
    return fi();
  }, e;
}(ge);
function zv(t, e) {
  return mr(t, e[0], e[1]);
}
function Yb(t, e) {
  return {
    node: t,
    index: 0,
    __prev: e
  };
}
function Z0(t, e, r, n) {
  var i = Object.create(Ve);
  return i.size = t, i._root = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var Gb;
function wo() {
  return Gb || (Gb = Z0(0));
}
function Wb(t, e, r) {
  var n, i;
  if (t._root) {
    var o = zy(), s = zy();
    if (n = X0(
      t._root,
      t.__ownerID,
      0,
      void 0,
      e,
      r,
      o,
      s
    ), !s.value)
      return t;
    i = t.size + (o.value ? r === he ? -1 : 1 : 0);
  } else {
    if (r === he)
      return t;
    i = 1, n = new ul(t.__ownerID, [[e, r]]);
  }
  return t.__ownerID ? (t.size = i, t._root = n, t.__hash = void 0, t.__altered = !0, t) : n ? Z0(i, n) : wo();
}
function X0(t, e, r, n, i, o, s, u) {
  return t ? t.update(
    e,
    r,
    n,
    i,
    o,
    s,
    u
  ) : o === he ? t : (Yi(u), Yi(s), new ea(e, n, [i, o]));
}
function Hb(t) {
  return t.constructor === ea || t.constructor === ec;
}
function tm(t, e, r, n, i) {
  if (t.keyHash === n)
    return new ec(e, n, [t.entry, i]);
  var o = (r === 0 ? t.keyHash : t.keyHash >>> r) & qn, s = (r === 0 ? n : n >>> r) & qn, u, c = o === s ? [tm(t, e, r + Le, n, i)] : (u = new ea(e, n, i), o < s ? [t, u] : [u, t]);
  return new tc(e, 1 << o | 1 << s, c);
}
function hj(t, e, r, n) {
  t || (t = new P0());
  for (var i = new ea(t, mi(r), [r, n]), o = 0; o < e.length; o++) {
    var s = e[o];
    i = i.update(t, 0, void 0, s[0], s[1]);
  }
  return i;
}
function pj(t, e, r, n) {
  for (var i = 0, o = 0, s = new Array(r), u = 0, c = 1, a = e.length; u < a; u++, c <<= 1) {
    var f = e[u];
    f !== void 0 && u !== n && (i |= c, s[o++] = f);
  }
  return new tc(t, i, s);
}
function dj(t, e, r, n, i) {
  for (var o = 0, s = new Array(Qi), u = 0; r !== 0; u++, r >>>= 1)
    s[u] = r & 1 ? e[o++] : void 0;
  return s[n] = i, new cl(t, o + 1, s);
}
function hA(t) {
  return t -= t >> 1 & 1431655765, t = (t & 858993459) + (t >> 2 & 858993459), t = t + (t >> 4) & 252645135, t += t >> 8, t += t >> 16, t & 127;
}
function pA(t, e, r, n) {
  var i = n ? t : Qo(t);
  return i[e] = r, i;
}
function vj(t, e, r, n) {
  var i = t.length + 1;
  if (n && e + 1 === i)
    return t[e] = r, t;
  for (var o = new Array(i), s = 0, u = 0; u < i; u++)
    u === e ? (o[u] = r, s = -1) : o[u] = t[u + s];
  return o;
}
function yj(t, e, r) {
  var n = t.length - 1;
  if (r && e === n)
    return t.pop(), t;
  for (var i = new Array(n), o = 0, s = 0; s < n; s++)
    s === e && (o = 1), i[s] = t[s + o];
  return i;
}
var _j = Qi / 4, mj = Qi / 2, gj = Qi / 4, dA = "@@__IMMUTABLE_LIST__@@";
function vA(t) {
  return !!(t && t[dA]);
}
var yd = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = up();
    if (r == null)
      return n;
    if (vA(r))
      return r;
    var i = t(r), o = i.size;
    return o === 0 ? n : (Gi(o), o > 0 && o < Qi ? fl(0, o, Le, null, new Da(i.toArray())) : n.withMutations(function(s) {
      s.setSize(o), i.forEach(function(u, c) {
        return s.set(c, u);
      });
    }));
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, e.prototype.get = function(r, n) {
    if (r = Ca(this, r), r >= 0 && r < this.size) {
      r += this._origin;
      var i = yA(this, r);
      return i && i.array[r & qn];
    }
    return n;
  }, e.prototype.set = function(r, n) {
    return bj(this, r, n);
  }, e.prototype.remove = function(r) {
    return this.has(r) ? r === 0 ? this.shift() : r === this.size - 1 ? this.pop() : this.splice(r, 1) : this;
  }, e.prototype.insert = function(r, n) {
    return this.splice(r, 0, n);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = Le, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : up();
  }, e.prototype.push = function() {
    var r = arguments, n = this.size;
    return this.withMutations(function(i) {
      da(i, 0, n + r.length);
      for (var o = 0; o < r.length; o++)
        i.set(n + o, r[o]);
    });
  }, e.prototype.pop = function() {
    return da(this, 0, -1);
  }, e.prototype.unshift = function() {
    var r = arguments;
    return this.withMutations(function(n) {
      da(n, -r.length);
      for (var i = 0; i < r.length; i++)
        n.set(i, r[i]);
    });
  }, e.prototype.shift = function() {
    return da(this, 1);
  }, e.prototype.concat = function() {
    for (var r = arguments, n = [], i = 0; i < arguments.length; i++) {
      var o = r[i], s = t(
        typeof o != "string" && BI(o) ? o : [o]
      );
      s.size !== 0 && n.push(s);
    }
    return n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(u) {
      n.forEach(function(c) {
        return c.forEach(function(a) {
          return u.push(a);
        });
      });
    });
  }, e.prototype.setSize = function(r) {
    return da(this, 0, r);
  }, e.prototype.map = function(r, n) {
    var i = this;
    return this.withMutations(function(o) {
      for (var s = 0; s < i.size; s++)
        o.set(s, r.call(n, o.get(s), s, i));
    });
  }, e.prototype.slice = function(r, n) {
    var i = this.size;
    return cd(r, n, i) ? this : da(
      this,
      Kl(r, i),
      fd(n, i)
    );
  }, e.prototype.__iterator = function(r, n) {
    var i = n ? this.size : 0, o = Jb(this, n);
    return new ge(function() {
      var s = o();
      return s === Yf ? fi() : mr(r, n ? --i : i++, s);
    });
  }, e.prototype.__iterate = function(r, n) {
    for (var i = n ? this.size : 0, o = Jb(this, n), s; (s = o()) !== Yf && r(s, n ? --i : i++, this) !== !1; )
      ;
    return i;
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? fl(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      r,
      this.__hash
    ) : this.size === 0 ? up() : (this.__ownerID = r, this.__altered = !1, this);
  }, e;
}(du);
yd.isList = vA;
var kr = yd.prototype;
kr[dA] = !0;
kr[$l] = kr.remove;
kr.merge = kr.concat;
kr.setIn = $0;
kr.deleteIn = kr.removeIn = K0;
kr.update = V0;
kr.updateIn = Q0;
kr.mergeIn = W0;
kr.mergeDeepIn = H0;
kr.withMutations = Ql;
kr.wasAltered = J0;
kr.asImmutable = Gl;
kr["@@transducer/init"] = kr.asMutable = Yl;
kr["@@transducer/step"] = function(t, e) {
  return t.push(e);
};
kr["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var Da = function(t, e) {
  this.array = t, this.ownerID = e;
};
Da.prototype.removeBefore = function(t, e, r) {
  if (r === e ? 1 << e : this.array.length === 0)
    return this;
  var n = r >>> e & qn;
  if (n >= this.array.length)
    return new Da([], t);
  var i = n === 0, o;
  if (e > 0) {
    var s = this.array[n];
    if (o = s && s.removeBefore(t, e - Le, r), o === s && i)
      return this;
  }
  if (i && !o)
    return this;
  var u = rc(this, t);
  if (!i)
    for (var c = 0; c < n; c++)
      u.array[c] = void 0;
  return o && (u.array[n] = o), u;
};
Da.prototype.removeAfter = function(t, e, r) {
  if (r === (e ? 1 << e : 0) || this.array.length === 0)
    return this;
  var n = r - 1 >>> e & qn;
  if (n >= this.array.length)
    return this;
  var i;
  if (e > 0) {
    var o = this.array[n];
    if (i = o && o.removeAfter(t, e - Le, r), i === o && n === this.array.length - 1)
      return this;
  }
  var s = rc(this, t);
  return s.array.splice(n + 1), i && (s.array[n] = i), s;
};
var Yf = {};
function Jb(t, e) {
  var r = t._origin, n = t._capacity, i = ll(n), o = t._tail;
  return s(t._root, t._level, 0);
  function s(a, f, h) {
    return f === 0 ? u(a, h) : c(a, f, h);
  }
  function u(a, f) {
    var h = f === i ? o && o.array : a && a.array, p = f > r ? 0 : r - f, d = n - f;
    return d > Qi && (d = Qi), function() {
      if (p === d)
        return Yf;
      var _ = e ? --d : p++;
      return h && h[_];
    };
  }
  function c(a, f, h) {
    var p, d = a && a.array, _ = h > r ? 0 : r - h >> f, m = (n - h >> f) + 1;
    return m > Qi && (m = Qi), function() {
      for (; ; ) {
        if (p) {
          var b = p();
          if (b !== Yf)
            return b;
          p = null;
        }
        if (_ === m)
          return Yf;
        var O = e ? --m : _++;
        p = s(
          d && d[O],
          f - Le,
          h + (O << f)
        );
      }
    };
  }
}
function fl(t, e, r, n, i, o, s) {
  var u = Object.create(kr);
  return u.size = e - t, u._origin = t, u._capacity = e, u._level = r, u._root = n, u._tail = i, u.__ownerID = o, u.__hash = s, u.__altered = !1, u;
}
var Zb;
function up() {
  return Zb || (Zb = fl(0, 0, Le));
}
function bj(t, e, r) {
  if (e = Ca(t, e), e !== e)
    return t;
  if (e >= t.size || e < 0)
    return t.withMutations(function(s) {
      e < 0 ? da(s, e).set(0, r) : da(s, 0, e + 1).set(e, r);
    });
  e += t._origin;
  var n = t._tail, i = t._root, o = zy();
  return e >= ll(t._capacity) ? n = Vy(n, t.__ownerID, 0, e, r, o) : i = Vy(
    i,
    t.__ownerID,
    t._level,
    e,
    r,
    o
  ), o.value ? t.__ownerID ? (t._root = i, t._tail = n, t.__hash = void 0, t.__altered = !0, t) : fl(t._origin, t._capacity, t._level, i, n) : t;
}
function Vy(t, e, r, n, i, o) {
  var s = n >>> r & qn, u = t && s < t.array.length;
  if (!u && i === void 0)
    return t;
  var c;
  if (r > 0) {
    var a = t && t.array[s], f = Vy(
      a,
      e,
      r - Le,
      n,
      i,
      o
    );
    return f === a ? t : (c = rc(t, e), c.array[s] = f, c);
  }
  return u && t.array[s] === i ? t : (o && Yi(o), c = rc(t, e), i === void 0 && s === c.array.length - 1 ? c.array.pop() : c.array[s] = i, c);
}
function rc(t, e) {
  return e && t && e === t.ownerID ? t : new Da(t ? t.array.slice() : [], e);
}
function yA(t, e) {
  if (e >= ll(t._capacity))
    return t._tail;
  if (e < 1 << t._level + Le) {
    for (var r = t._root, n = t._level; r && n > 0; )
      r = r.array[e >>> n & qn], n -= Le;
    return r;
  }
}
function da(t, e, r) {
  e !== void 0 && (e |= 0), r !== void 0 && (r |= 0);
  var n = t.__ownerID || new P0(), i = t._origin, o = t._capacity, s = i + e, u = r === void 0 ? o : r < 0 ? o + r : i + r;
  if (s === i && u === o)
    return t;
  if (s >= u)
    return t.clear();
  for (var c = t._level, a = t._root, f = 0; s + f < 0; )
    a = new Da(
      a && a.array.length ? [void 0, a] : [],
      n
    ), c += Le, f += 1 << c;
  f && (s += f, i += f, u += f, o += f);
  for (var h = ll(o), p = ll(u); p >= 1 << c + Le; )
    a = new Da(
      a && a.array.length ? [a] : [],
      n
    ), c += Le;
  var d = t._tail, _ = p < h ? yA(t, u - 1) : p > h ? new Da([], n) : d;
  if (d && p > h && s < o && d.array.length) {
    a = rc(a, n);
    for (var m = a, b = c; b > Le; b -= Le) {
      var O = h >>> b & qn;
      m = m.array[O] = rc(m.array[O], n);
    }
    m.array[h >>> Le & qn] = d;
  }
  if (u < o && (_ = _ && _.removeAfter(n, 0, u)), s >= p)
    s -= p, u -= p, c = Le, a = null, _ = _ && _.removeBefore(n, 0, s);
  else if (s > i || p < h) {
    for (f = 0; a; ) {
      var S = s >>> c & qn;
      if (S !== p >>> c & qn)
        break;
      S && (f += (1 << c) * S), c -= Le, a = a.array[S];
    }
    a && s > i && (a = a.removeBefore(n, c, s - f)), a && p < h && (a = a.removeAfter(
      n,
      c,
      p - f
    )), f && (s -= f, u -= f);
  }
  return t.__ownerID ? (t.size = u - s, t._origin = s, t._capacity = u, t._level = c, t._root = a, t._tail = _, t.__hash = void 0, t.__altered = !0, t) : fl(s, u, c, a, _);
}
function ll(t) {
  return t < Qi ? 0 : t - 1 >>> Le << Le;
}
var ra = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Cf() : QI(r) ? r : Cf().withMutations(function(n) {
      var i = fo(r);
      Gi(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, e.prototype.get = function(r, n) {
    var i = this._map.get(r);
    return i !== void 0 ? this._list.get(i)[1] : n;
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : Cf();
  }, e.prototype.set = function(r, n) {
    return tw(this, r, n);
  }, e.prototype.remove = function(r) {
    return tw(this, r, he);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._list.__iterate(
      function(o) {
        return o && r(o[1], o[0], i);
      },
      n
    );
  }, e.prototype.__iterator = function(r, n) {
    return this._list.fromEntrySeq().__iterator(r, n);
  }, e.prototype.__ensureOwner = function(r) {
    if (r === this.__ownerID)
      return this;
    var n = this._map.__ensureOwner(r), i = this._list.__ensureOwner(r);
    return r ? em(n, i, r, this.__hash) : this.size === 0 ? Cf() : (this.__ownerID = r, this.__altered = !1, this._map = n, this._list = i, this);
  }, e;
}(Lc);
ra.isOrderedMap = QI;
ra.prototype[Mc] = !0;
ra.prototype[$l] = ra.prototype.remove;
function em(t, e, r, n) {
  var i = Object.create(ra.prototype);
  return i.size = t ? t.size : 0, i._map = t, i._list = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var Xb;
function Cf() {
  return Xb || (Xb = em(wo(), up()));
}
function tw(t, e, r) {
  var n = t._map, i = t._list, o = n.get(e), s = o !== void 0, u, c;
  if (r === he) {
    if (!s)
      return t;
    i.size >= Qi && i.size >= n.size * 2 ? (c = i.filter(function(a, f) {
      return a !== void 0 && o !== f;
    }), u = c.toKeyedSeq().map(function(a) {
      return a[0];
    }).flip().toMap(), t.__ownerID && (u.__ownerID = c.__ownerID = t.__ownerID)) : (u = n.remove(e), c = o === i.size - 1 ? i.pop() : i.set(o, void 0));
  } else if (s) {
    if (r === i.get(o)[1])
      return t;
    u = n, c = i.set(o, [e, r]);
  } else
    u = n.set(e, i.size), c = i.set(i.size, [e, r]);
  return t.__ownerID ? (t.size = u.size, t._map = u, t._list = c, t.__hash = void 0, t.__altered = !0, t) : em(u, c);
}
var _A = "@@__IMMUTABLE_STACK__@@";
function Qy(t) {
  return !!(t && t[_A]);
}
var rm = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Ph() : Qy(r) ? r : Ph().pushAll(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, e.prototype.get = function(r, n) {
    var i = this._head;
    for (r = Ca(this, r); i && r--; )
      i = i.next;
    return i ? i.value : n;
  }, e.prototype.peek = function() {
    return this._head && this._head.value;
  }, e.prototype.push = function() {
    var r = arguments;
    if (arguments.length === 0)
      return this;
    for (var n = this.size + arguments.length, i = this._head, o = arguments.length - 1; o >= 0; o--)
      i = {
        value: r[o],
        next: i
      };
    return this.__ownerID ? (this.size = n, this._head = i, this.__hash = void 0, this.__altered = !0, this) : jf(n, i);
  }, e.prototype.pushAll = function(r) {
    if (r = t(r), r.size === 0)
      return this;
    if (this.size === 0 && Qy(r))
      return r;
    Gi(r.size);
    var n = this.size, i = this._head;
    return r.__iterate(
      function(o) {
        n++, i = {
          value: o,
          next: i
        };
      },
      /* reverse */
      !0
    ), this.__ownerID ? (this.size = n, this._head = i, this.__hash = void 0, this.__altered = !0, this) : jf(n, i);
  }, e.prototype.pop = function() {
    return this.slice(1);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Ph();
  }, e.prototype.slice = function(r, n) {
    if (cd(r, n, this.size))
      return this;
    var i = Kl(r, this.size), o = fd(n, this.size);
    if (o !== this.size)
      return t.prototype.slice.call(this, r, n);
    for (var s = this.size - i, u = this._head; i--; )
      u = u.next;
    return this.__ownerID ? (this.size = s, this._head = u, this.__hash = void 0, this.__altered = !0, this) : jf(s, u);
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? jf(this.size, this._head, r, this.__hash) : this.size === 0 ? Ph() : (this.__ownerID = r, this.__altered = !1, this);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    if (n)
      return new ou(this.toArray()).__iterate(
        function(u, c) {
          return r(u, c, i);
        },
        n
      );
    for (var o = 0, s = this._head; s && r(s.value, o++, this) !== !1; )
      s = s.next;
    return o;
  }, e.prototype.__iterator = function(r, n) {
    if (n)
      return new ou(this.toArray()).__iterator(r, n);
    var i = 0, o = this._head;
    return new ge(function() {
      if (o) {
        var s = o.value;
        return o = o.next, mr(r, i++, s);
      }
      return fi();
    });
  }, e;
}(du);
rm.isStack = Qy;
var Ln = rm.prototype;
Ln[_A] = !0;
Ln.shift = Ln.pop;
Ln.unshift = Ln.push;
Ln.unshiftAll = Ln.pushAll;
Ln.withMutations = Ql;
Ln.wasAltered = J0;
Ln.asImmutable = Gl;
Ln["@@transducer/init"] = Ln.asMutable = Yl;
Ln["@@transducer/step"] = function(t, e) {
  return t.unshift(e);
};
Ln["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
function jf(t, e, r, n) {
  var i = Object.create(Ln);
  return i.size = t, i._head = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var ew;
function Ph() {
  return ew || (ew = jf(0));
}
var mA = "@@__IMMUTABLE_SET__@@";
function nm(t) {
  return !!(t && t[mA]);
}
function gA(t) {
  return nm(t) && Ao(t);
}
function bA(t, e) {
  if (t === e)
    return !0;
  if (!ci(e) || t.size !== void 0 && e.size !== void 0 && t.size !== e.size || t.__hash !== void 0 && e.__hash !== void 0 && t.__hash !== e.__hash || pr(t) !== pr(e) || ni(t) !== ni(e) || Ao(t) !== Ao(e))
    return !1;
  if (t.size === 0 && e.size === 0)
    return !0;
  var r = !ld(t);
  if (Ao(t)) {
    var n = t.entries();
    return e.every(function(c, a) {
      var f = n.next().value;
      return f && Si(f[1], c) && (r || Si(f[0], a));
    }) && n.next().done;
  }
  var i = !1;
  if (t.size === void 0)
    if (e.size === void 0)
      typeof t.cacheResult == "function" && t.cacheResult();
    else {
      i = !0;
      var o = t;
      t = e, e = o;
    }
  var s = !0, u = e.__iterate(function(c, a) {
    if (r ? !t.has(c) : i ? !Si(c, t.get(a, he)) : !Si(t.get(a, he), c))
      return s = !1, !1;
  });
  return s && t.size === u;
}
function vu(t, e) {
  var r = function(n) {
    t.prototype[n] = e[n];
  };
  return Object.keys(e).forEach(r), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(r), t;
}
function Rp(t) {
  if (!t || typeof t != "object")
    return t;
  if (!ci(t)) {
    if (!ja(t))
      return t;
    t = Ri(t);
  }
  if (pr(t)) {
    var e = {};
    return t.__iterate(function(n, i) {
      e[i] = Rp(n);
    }), e;
  }
  var r = [];
  return t.__iterate(function(n) {
    r.push(Rp(n));
  }), r;
}
var _d = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? qf() : nm(r) && !Ao(r) ? r : qf().withMutations(function(n) {
      var i = t(r);
      Gi(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(r) {
    return this(fo(r).keySeq());
  }, e.intersect = function(r) {
    return r = Or(r).toArray(), r.length ? tn.intersect.apply(e(r.pop()), r) : qf();
  }, e.union = function(r) {
    return r = Or(r).toArray(), r.length ? tn.union.apply(e(r.pop()), r) : qf();
  }, e.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, e.prototype.has = function(r) {
    return this._map.has(r);
  }, e.prototype.add = function(r) {
    return kh(this, this._map.set(r, r));
  }, e.prototype.remove = function(r) {
    return kh(this, this._map.remove(r));
  }, e.prototype.clear = function() {
    return kh(this, this._map.clear());
  }, e.prototype.map = function(r, n) {
    var i = this, o = !1, s = kh(
      this,
      this._map.mapEntries(function(u) {
        var c = u[1], a = r.call(n, c, c, i);
        return a !== c && (o = !0), [a, a];
      }, n)
    );
    return o ? s : this;
  }, e.prototype.union = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    return r = r.filter(function(i) {
      return i.size !== 0;
    }), r.length === 0 ? this : this.size === 0 && !this.__ownerID && r.length === 1 ? this.constructor(r[0]) : this.withMutations(function(i) {
      for (var o = 0; o < r.length; o++)
        typeof r[o] == "string" ? i.add(r[o]) : t(r[o]).forEach(function(s) {
          return i.add(s);
        });
    });
  }, e.prototype.intersect = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (r.length === 0)
      return this;
    r = r.map(function(o) {
      return t(o);
    });
    var i = [];
    return this.forEach(function(o) {
      r.every(function(s) {
        return s.includes(o);
      }) || i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(s) {
        o.remove(s);
      });
    });
  }, e.prototype.subtract = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (r.length === 0)
      return this;
    r = r.map(function(o) {
      return t(o);
    });
    var i = [];
    return this.forEach(function(o) {
      r.some(function(s) {
        return s.includes(o);
      }) && i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(s) {
        o.remove(s);
      });
    });
  }, e.prototype.sort = function(r) {
    return hl(Xu(this, r));
  }, e.prototype.sortBy = function(r, n) {
    return hl(Xu(this, n, r));
  }, e.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._map.__iterate(function(o) {
      return r(o, o, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    return this._map.__iterator(r, n);
  }, e.prototype.__ensureOwner = function(r) {
    if (r === this.__ownerID)
      return this;
    var n = this._map.__ensureOwner(r);
    return r ? this.__make(n, r) : this.size === 0 ? this.__empty() : (this.__ownerID = r, this._map = n, this);
  }, e;
}(jc);
_d.isSet = nm;
var tn = _d.prototype;
tn[mA] = !0;
tn[$l] = tn.remove;
tn.merge = tn.concat = tn.union;
tn.withMutations = Ql;
tn.asImmutable = Gl;
tn["@@transducer/init"] = tn.asMutable = Yl;
tn["@@transducer/step"] = function(t, e) {
  return t.add(e);
};
tn["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
tn.__empty = qf;
tn.__make = wA;
function kh(t, e) {
  return t.__ownerID ? (t.size = e.size, t._map = e, t) : e === t._map ? t : e.size === 0 ? t.__empty() : t.__make(e);
}
function wA(t, e) {
  var r = Object.create(tn);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var rw;
function qf() {
  return rw || (rw = wA(wo()));
}
var wj = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    if (!(this instanceof e))
      return new e(r, n, i);
    if (B0(i !== 0, "Cannot step a Range by 0"), r = r || 0, n === void 0 && (n = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), n < r && (i = -i), this._start = r, this._end = n, this._step = i, this.size = Math.max(0, Math.ceil((n - r) / i - 1) + 1), this.size === 0) {
      if (Lv)
        return Lv;
      Lv = this;
    }
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, e.prototype.get = function(r, n) {
    return this.has(r) ? this._start + Ca(this, r) * this._step : n;
  }, e.prototype.includes = function(r) {
    var n = (r - this._start) / this._step;
    return n >= 0 && n < this.size && n === Math.floor(n);
  }, e.prototype.slice = function(r, n) {
    return cd(r, n, this.size) ? this : (r = Kl(r, this.size), n = fd(n, this.size), n <= r ? new e(0, 0) : new e(
      this.get(r, this._end),
      this.get(n, this._end),
      this._step
    ));
  }, e.prototype.indexOf = function(r) {
    var n = r - this._start;
    if (n % this._step === 0) {
      var i = n / this._step;
      if (i >= 0 && i < this.size)
        return i;
    }
    return -1;
  }, e.prototype.lastIndexOf = function(r) {
    return this.indexOf(r);
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this.size, o = this._step, s = n ? this._start + (i - 1) * o : this._start, u = 0; u !== i && r(s, n ? i - ++u : u++, this) !== !1; )
      s += n ? -o : o;
    return u;
  }, e.prototype.__iterator = function(r, n) {
    var i = this.size, o = this._step, s = n ? this._start + (i - 1) * o : this._start, u = 0;
    return new ge(function() {
      if (u === i)
        return fi();
      var c = s;
      return s += n ? -o : o, mr(r, n ? i - ++u : u++, c);
    });
  }, e.prototype.equals = function(r) {
    return r instanceof e ? this._start === r._start && this._end === r._end && this._step === r._step : bA(this, r);
  }, e;
}(Mo), Lv;
function EA(t, e, r) {
  for (var n = nA(e), i = 0; i !== n.length; )
    if (t = iA(t, n[i++], he), t === he)
      return r;
  return t;
}
function SA(t, e) {
  return EA(this, t, e);
}
function Ej(t, e) {
  return EA(t, e, he) !== he;
}
function Sj(t) {
  return Ej(this, t);
}
function OA() {
  Gi(this.size);
  var t = {};
  return this.__iterate(function(e, r) {
    t[r] = e;
  }), t;
}
Or.isIterable = ci;
Or.isKeyed = pr;
Or.isIndexed = ni;
Or.isAssociative = ld;
Or.isOrdered = Ao;
Or.Iterator = ge;
vu(Or, {
  // ### Conversion to other types
  toArray: function() {
    Gi(this.size);
    var t = new Array(this.size || 0), e = pr(this), r = 0;
    return this.__iterate(function(n, i) {
      t[r++] = e ? [i, n] : n;
    }), t;
  },
  toIndexedSeq: function() {
    return new GI(this);
  },
  toJS: function() {
    return Rp(this);
  },
  toKeyedSeq: function() {
    return new vd(this, !0);
  },
  toMap: function() {
    return Lc(this.toKeyedSeq());
  },
  toObject: OA,
  toOrderedMap: function() {
    return ra(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return hl(pr(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return _d(pr(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new WI(this);
  },
  toSeq: function() {
    return ni(this) ? this.toIndexedSeq() : pr(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return rm(pr(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return yd(pr(this) ? this.valueSeq() : this);
  },
  // ### Common JavaScript methods and properties
  toString: function() {
    return "[Collection]";
  },
  __toString: function(t, e) {
    return this.size === 0 ? t + e : t + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  concat: function() {
    for (var t = [], e = arguments.length; e--; )
      t[e] = arguments[e];
    return xe(this, X5(this, t));
  },
  includes: function(t) {
    return this.some(function(e) {
      return Si(e, t);
    });
  },
  entries: function() {
    return this.__iterator(oo);
  },
  every: function(t, e) {
    Gi(this.size);
    var r = !0;
    return this.__iterate(function(n, i, o) {
      if (!t.call(e, n, i, o))
        return r = !1, !1;
    }), r;
  },
  filter: function(t, e) {
    return xe(this, XI(this, t, e, !0));
  },
  partition: function(t, e) {
    return J5(this, t, e);
  },
  find: function(t, e, r) {
    var n = this.findEntry(t, e);
    return n ? n[1] : r;
  },
  forEach: function(t, e) {
    return Gi(this.size), this.__iterate(e ? t.bind(e) : t);
  },
  join: function(t) {
    Gi(this.size), t = t !== void 0 ? "" + t : ",";
    var e = "", r = !0;
    return this.__iterate(function(n) {
      r ? r = !1 : e += t, e += n != null ? n.toString() : "";
    }), e;
  },
  keys: function() {
    return this.__iterator(Vl);
  },
  map: function(t, e) {
    return xe(this, ZI(this, t, e));
  },
  reduce: function(t, e, r) {
    return nw(
      this,
      t,
      e,
      r,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(t, e, r) {
    return nw(
      this,
      t,
      e,
      r,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return xe(this, N0(this, !0));
  },
  slice: function(t, e) {
    return xe(this, z0(this, t, e, !0));
  },
  some: function(t, e) {
    return !this.every(Ch(t), e);
  },
  sort: function(t) {
    return xe(this, Xu(this, t));
  },
  values: function() {
    return this.__iterator(Po);
  },
  // ### More sequential methods
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(t, e) {
    return Zu(
      t ? this.toSeq().filter(t, e) : this
    );
  },
  countBy: function(t, e) {
    return W5(this, t, e);
  },
  equals: function(t) {
    return bA(this, t);
  },
  entrySeq: function() {
    var t = this;
    if (t._cache)
      return new ou(t._cache);
    var e = t.toSeq().map(Ij).toIndexedSeq();
    return e.fromEntrySeq = function() {
      return t.toSeq();
    }, e;
  },
  filterNot: function(t, e) {
    return this.filter(Ch(t), e);
  },
  findEntry: function(t, e, r) {
    var n = r;
    return this.__iterate(function(i, o, s) {
      if (t.call(e, i, o, s))
        return n = [o, i], !1;
    }), n;
  },
  findKey: function(t, e) {
    var r = this.findEntry(t, e);
    return r && r[0];
  },
  findLast: function(t, e, r) {
    return this.toKeyedSeq().reverse().find(t, e, r);
  },
  findLastEntry: function(t, e, r) {
    return this.toKeyedSeq().reverse().findEntry(t, e, r);
  },
  findLastKey: function(t, e) {
    return this.toKeyedSeq().reverse().findKey(t, e);
  },
  first: function(t) {
    return this.find(CI, null, t);
  },
  flatMap: function(t, e) {
    return xe(this, tj(this, t, e));
  },
  flatten: function(t) {
    return xe(this, eA(this, t, !0));
  },
  fromEntrySeq: function() {
    return new HI(this);
  },
  get: function(t, e) {
    return this.find(function(r, n) {
      return Si(n, t);
    }, void 0, e);
  },
  getIn: SA,
  groupBy: function(t, e) {
    return H5(this, t, e);
  },
  has: function(t) {
    return this.get(t, he) !== he;
  },
  hasIn: Sj,
  isSubset: function(t) {
    return t = typeof t.includes == "function" ? t : Or(t), this.every(function(e) {
      return t.includes(e);
    });
  },
  isSuperset: function(t) {
    return t = typeof t.isSubset == "function" ? t : Or(t), t.isSubset(this);
  },
  keyOf: function(t) {
    return this.findKey(function(e) {
      return Si(e, t);
    });
  },
  keySeq: function() {
    return this.toSeq().map(Oj).toIndexedSeq();
  },
  last: function(t) {
    return this.toSeq().reverse().first(t);
  },
  lastKeyOf: function(t) {
    return this.toKeyedSeq().reverse().keyOf(t);
  },
  max: function(t) {
    return xh(this, t);
  },
  maxBy: function(t, e) {
    return xh(this, e, t);
  },
  min: function(t) {
    return xh(
      this,
      t ? iw(t) : sw
    );
  },
  minBy: function(t, e) {
    return xh(
      this,
      e ? iw(e) : sw,
      t
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(t) {
    return t === 0 ? this : this.slice(Math.max(0, t));
  },
  skipLast: function(t) {
    return t === 0 ? this : this.slice(0, -Math.max(0, t));
  },
  skipWhile: function(t, e) {
    return xe(this, tA(this, t, e, !0));
  },
  skipUntil: function(t, e) {
    return this.skipWhile(Ch(t), e);
  },
  sortBy: function(t, e) {
    return xe(this, Xu(this, e, t));
  },
  take: function(t) {
    return this.slice(0, Math.max(0, t));
  },
  takeLast: function(t) {
    return this.slice(-Math.max(0, t));
  },
  takeWhile: function(t, e) {
    return xe(this, Z5(this, t, e));
  },
  takeUntil: function(t, e) {
    return this.takeWhile(Ch(t), e);
  },
  update: function(t) {
    return t(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  // ### Hashable Object
  hashCode: function() {
    return this.__hash || (this.__hash = Aj(this));
  }
  // ### Internal
  // abstract __iterate(fn, reverse)
  // abstract __iterator(type, reverse)
});
var An = Or.prototype;
An[MI] = !0;
An[hd] = An.values;
An.toJSON = An.toArray;
An.__toStringMapper = al;
An.inspect = An.toSource = function() {
  return this.toString();
};
An.chain = An.flatMap;
An.contains = An.includes;
vu(fo, {
  // ### More sequential methods
  flip: function() {
    return xe(this, JI(this));
  },
  mapEntries: function(t, e) {
    var r = this, n = 0;
    return xe(
      this,
      this.toSeq().map(function(i, o) {
        return t.call(e, [o, i], n++, r);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(t, e) {
    var r = this;
    return xe(
      this,
      this.toSeq().flip().map(function(n, i) {
        return t.call(e, n, i, r);
      }).flip()
    );
  }
});
var Wl = fo.prototype;
Wl[FI] = !0;
Wl[hd] = An.entries;
Wl.toJSON = OA;
Wl.__toStringMapper = function(t, e) {
  return al(e) + ": " + al(t);
};
vu(du, {
  // ### Conversion to other types
  toKeyedSeq: function() {
    return new vd(this, !1);
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  filter: function(t, e) {
    return xe(this, XI(this, t, e, !1));
  },
  findIndex: function(t, e) {
    var r = this.findEntry(t, e);
    return r ? r[0] : -1;
  },
  indexOf: function(t) {
    var e = this.keyOf(t);
    return e === void 0 ? -1 : e;
  },
  lastIndexOf: function(t) {
    var e = this.lastKeyOf(t);
    return e === void 0 ? -1 : e;
  },
  reverse: function() {
    return xe(this, N0(this, !1));
  },
  slice: function(t, e) {
    return xe(this, z0(this, t, e, !1));
  },
  splice: function(t, e) {
    var r = arguments.length;
    if (e = Math.max(e || 0, 0), r === 0 || r === 2 && !e)
      return this;
    t = Kl(t, t < 0 ? this.count() : this.size);
    var n = this.slice(0, t);
    return xe(
      this,
      r === 1 ? n : n.concat(Qo(arguments, 2), this.slice(t + e))
    );
  },
  // ### More collection methods
  findLastIndex: function(t, e) {
    var r = this.findLastEntry(t, e);
    return r ? r[0] : -1;
  },
  first: function(t) {
    return this.get(0, t);
  },
  flatten: function(t) {
    return xe(this, eA(this, t, !1));
  },
  get: function(t, e) {
    return t = Ca(this, t), t < 0 || this.size === 1 / 0 || this.size !== void 0 && t > this.size ? e : this.find(function(r, n) {
      return n === t;
    }, void 0, e);
  },
  has: function(t) {
    return t = Ca(this, t), t >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || t < this.size : this.indexOf(t) !== -1);
  },
  interpose: function(t) {
    return xe(this, ej(this, t));
  },
  interleave: function() {
    var t = [this].concat(Qo(arguments)), e = Th(this.toSeq(), Mo.of, t), r = e.flatten(!0);
    return e.size && (r.size = e.size * t.length), xe(this, r);
  },
  keySeq: function() {
    return wj(0, this.size);
  },
  last: function(t) {
    return this.get(-1, t);
  },
  skipWhile: function(t, e) {
    return xe(this, tA(this, t, e, !1));
  },
  zip: function() {
    var t = [this].concat(Qo(arguments));
    return xe(this, Th(this, ow, t));
  },
  zipAll: function() {
    var t = [this].concat(Qo(arguments));
    return xe(this, Th(this, ow, t, !0));
  },
  zipWith: function(t) {
    var e = Qo(arguments);
    return e[0] = this, xe(this, Th(this, t, e));
  }
});
var Uc = du.prototype;
Uc[NI] = !0;
Uc[Mc] = !0;
vu(jc, {
  // ### ES6 Collection methods (ES6 Array and Map)
  get: function(t, e) {
    return this.has(t) ? t : e;
  },
  includes: function(t) {
    return this.has(t);
  },
  // ### More sequential methods
  keySeq: function() {
    return this.valueSeq();
  }
});
var nc = jc.prototype;
nc.has = An.includes;
nc.contains = nc.includes;
nc.keys = nc.values;
vu(Ba, Wl);
vu(Mo, Uc);
vu(Nc, nc);
function nw(t, e, r, n, i, o) {
  return Gi(t.size), t.__iterate(function(s, u, c) {
    i ? (i = !1, r = s) : r = e.call(n, r, s, u, c);
  }, o), r;
}
function Oj(t, e) {
  return e;
}
function Ij(t, e) {
  return [e, t];
}
function Ch(t) {
  return function() {
    return !t.apply(this, arguments);
  };
}
function iw(t) {
  return function() {
    return -t.apply(this, arguments);
  };
}
function ow() {
  return Qo(arguments);
}
function sw(t, e) {
  return t < e ? 1 : t > e ? -1 : 0;
}
function Aj(t) {
  if (t.size === 1 / 0)
    return 0;
  var e = Ao(t), r = pr(t), n = e ? 1 : 0, i = t.__iterate(
    r ? e ? function(o, s) {
      n = 31 * n + aw(mi(o), mi(s)) | 0;
    } : function(o, s) {
      n = n + aw(mi(o), mi(s)) | 0;
    } : e ? function(o) {
      n = 31 * n + mi(o) | 0;
    } : function(o) {
      n = n + mi(o) | 0;
    }
  );
  return Dj(i, n);
}
function Dj(t, e) {
  return e = bf(e, 3432918353), e = bf(e << 15 | e >>> -15, 461845907), e = bf(e << 13 | e >>> -13, 5), e = (e + 3864292196 | 0) ^ t, e = bf(e ^ e >>> 16, 2246822507), e = bf(e ^ e >>> 13, 3266489909), e = dd(e ^ e >>> 16), e;
}
function aw(t, e) {
  return t ^ e + 2654435769 + (t << 6) + (t >> 2) | 0;
}
var hl = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Yy() : gA(r) ? r : Yy().withMutations(function(n) {
      var i = jc(r);
      Gi(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(r) {
    return this(fo(r).keySeq());
  }, e.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, e;
}(_d);
hl.isOrderedSet = gA;
var yu = hl.prototype;
yu[Mc] = !0;
yu.zip = Uc.zip;
yu.zipWith = Uc.zipWith;
yu.zipAll = Uc.zipAll;
yu.__empty = Yy;
yu.__make = IA;
function IA(t, e) {
  var r = Object.create(yu);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var uw;
function Yy() {
  return uw || (uw = IA(Cf()));
}
function Rj(t) {
  if (qc(t))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (es(t))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (t === null || typeof t != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var Wt = function(t, e) {
  var r;
  Rj(t);
  var n = function(o) {
    var s = this;
    if (o instanceof n)
      return o;
    if (!(this instanceof n))
      return new n(o);
    if (!r) {
      r = !0;
      var u = Object.keys(t), c = i._indices = {};
      i._name = e, i._keys = u, i._defaultValues = t;
      for (var a = 0; a < u.length; a++) {
        var f = u[a];
        c[f] = a, i[f] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + om(this) + ' with property "' + f + '" since that property name is part of the Record API.'
        ) : xj(i, f);
      }
    }
    return this.__ownerID = void 0, this._values = yd().withMutations(function(h) {
      h.setSize(s._keys.length), fo(o).forEach(function(p, d) {
        h.set(s._indices[d], p === s._defaultValues[d] ? void 0 : p);
      });
    }), this;
  }, i = n.prototype = Object.create(qe);
  return i.constructor = n, e && (n.displayName = e), n;
};
Wt.prototype.toString = function() {
  for (var t = om(this) + " { ", e = this._keys, r, n = 0, i = e.length; n !== i; n++)
    r = e[n], t += (n ? ", " : "") + r + ": " + al(this.get(r));
  return t + " }";
};
Wt.prototype.equals = function(t) {
  return this === t || qc(t) && ic(this).equals(ic(t));
};
Wt.prototype.hashCode = function() {
  return ic(this).hashCode();
};
Wt.prototype.has = function(t) {
  return this._indices.hasOwnProperty(t);
};
Wt.prototype.get = function(t, e) {
  if (!this.has(t))
    return e;
  var r = this._indices[t], n = this._values.get(r);
  return n === void 0 ? this._defaultValues[t] : n;
};
Wt.prototype.set = function(t, e) {
  if (this.has(t)) {
    var r = this._values.set(
      this._indices[t],
      e === this._defaultValues[t] ? void 0 : e
    );
    if (r !== this._values && !this.__ownerID)
      return im(this, r);
  }
  return this;
};
Wt.prototype.remove = function(t) {
  return this.set(t);
};
Wt.prototype.clear = function() {
  var t = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : im(this, t);
};
Wt.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
Wt.prototype.toSeq = function() {
  return ic(this);
};
Wt.prototype.toJS = function() {
  return Rp(this);
};
Wt.prototype.entries = function() {
  return this.__iterator(oo);
};
Wt.prototype.__iterator = function(t, e) {
  return ic(this).__iterator(t, e);
};
Wt.prototype.__iterate = function(t, e) {
  return ic(this).__iterate(t, e);
};
Wt.prototype.__ensureOwner = function(t) {
  if (t === this.__ownerID)
    return this;
  var e = this._values.__ensureOwner(t);
  return t ? im(this, e, t) : (this.__ownerID = t, this._values = e, this);
};
Wt.isRecord = qc;
Wt.getDescriptiveName = om;
var qe = Wt.prototype;
qe[LI] = !0;
qe[$l] = qe.remove;
qe.deleteIn = qe.removeIn = K0;
qe.getIn = SA;
qe.hasIn = An.hasIn;
qe.merge = aA;
qe.mergeWith = uA;
qe.mergeIn = W0;
qe.mergeDeep = fA;
qe.mergeDeepWith = lA;
qe.mergeDeepIn = H0;
qe.setIn = $0;
qe.update = V0;
qe.updateIn = Q0;
qe.withMutations = Ql;
qe.asMutable = Yl;
qe.asImmutable = Gl;
qe[hd] = qe.entries;
qe.toJSON = qe.toObject = An.toObject;
qe.inspect = qe.toSource = function() {
  return this.toString();
};
function im(t, e, r) {
  var n = Object.create(Object.getPrototypeOf(t));
  return n._values = e, n.__ownerID = r, n;
}
function om(t) {
  return t.constructor.displayName || t.constructor.name || "Record";
}
function ic(t) {
  return q0(t._keys.map(function(e) {
    return [e, t.get(e)];
  }));
}
function xj(t, e) {
  try {
    Object.defineProperty(t, e, {
      get: function() {
        return this.get(e);
      },
      set: function(r) {
        B0(this.__ownerID, "Cannot set on an immutable record."), this.set(e, r);
      }
    });
  } catch {
  }
}
const Tj = {
  startDate: void 0,
  endDate: void 0,
  userLimit: 0,
  projectLimit: 0,
  isTrial: !1,
  isExpired: !1,
  functionalities: []
};
class Pj extends Wt(Tj, "Subscription") {
  get isValid() {
    return !!this.startDate && !!this.endDate;
  }
  get isActive() {
    return !this.startDate || !this.endDate ? !1 : new jl(this.startDate, this.endDate).contains(Er.now());
  }
  get daysLeft() {
    return this.endDate ? this.endDate.getAbsoluteDifferenceInDays(Er.now()) : 0;
  }
  hasEndDateIncoming() {
    return this.endDate ? this.endDate.isAfterInDays(Er.now()) : !1;
  }
}
function kj(t) {
  const e = t;
  return e == null ? void 0 : e.code;
}
const Cj = 3;
function jj(t, e = Cj) {
  return (r, n) => {
    const i = kj(n);
    if (!i)
      return !1;
    let o;
    return Array.isArray(t) ? o = t.includes(i) : o = t === i, r <= e && o;
  };
}
var AA = /* @__PURE__ */ ((t) => (t[t.Continue = 100] = "Continue", t[t.SwitchingProtocols = 101] = "SwitchingProtocols", t[t.Processing = 102] = "Processing", t[t.EarlyHints = 103] = "EarlyHints", t[t.OK = 200] = "OK", t[t.Created = 201] = "Created", t[t.Accepted = 202] = "Accepted", t[t.NonAuthoritativeInformation = 203] = "NonAuthoritativeInformation", t[t.NoContent = 204] = "NoContent", t[t.ResetContent = 205] = "ResetContent", t[t.PartialContent = 206] = "PartialContent", t[t.MultiStatus = 207] = "MultiStatus", t[t.AlreadyReported = 208] = "AlreadyReported", t[t.IMUsed = 226] = "IMUsed", t[t.MultipleChoices = 300] = "MultipleChoices", t[t.MovedPermanently = 301] = "MovedPermanently", t[t.Found = 302] = "Found", t[t.SeeOther = 303] = "SeeOther", t[t.NotModified = 304] = "NotModified", t[t.UseProxy = 305] = "UseProxy", t[t.TemporaryRedirect = 307] = "TemporaryRedirect", t[t.PermanentRedirect = 308] = "PermanentRedirect", t[t.BadRequest = 400] = "BadRequest", t[t.Unauthorized = 401] = "Unauthorized", t[t.PaymentRequired = 402] = "PaymentRequired", t[t.Forbidden = 403] = "Forbidden", t[t.NotFound = 404] = "NotFound", t[t.MethodNotAllowed = 405] = "MethodNotAllowed", t[t.NotAcceptable = 406] = "NotAcceptable", t[t.ProxyAuthenticationRequired = 407] = "ProxyAuthenticationRequired", t[t.RequestTimeout = 408] = "RequestTimeout", t[t.Conflict = 409] = "Conflict", t[t.Gone = 410] = "Gone", t[t.LengthRequired = 411] = "LengthRequired", t[t.PreconditionFailed = 412] = "PreconditionFailed", t[t.PayloadTooLarge = 413] = "PayloadTooLarge", t[t.URITooLong = 414] = "URITooLong", t[t.UnsupportedMediaType = 415] = "UnsupportedMediaType", t[t.RangeNotSatisfiable = 416] = "RangeNotSatisfiable", t[t.ExpectationFailed = 417] = "ExpectationFailed", t[t.ImATeapot = 418] = "ImATeapot", t[t.MisdirectedRequest = 421] = "MisdirectedRequest", t[t.UnprocessableEntity = 422] = "UnprocessableEntity", t[t.Locked = 423] = "Locked", t[t.FailedDependency = 424] = "FailedDependency", t[t.TooEarly = 425] = "TooEarly", t[t.UpgradeRequired = 426] = "UpgradeRequired", t[t.PreconditionRequired = 428] = "PreconditionRequired", t[t.TooManyRequests = 429] = "TooManyRequests", t[t.RequestHeaderFieldsTooLarge = 431] = "RequestHeaderFieldsTooLarge", t[t.UnavailableForLegalReasons = 451] = "UnavailableForLegalReasons", t[t.InternalServerError = 500] = "InternalServerError", t[t.NotImplemented = 501] = "NotImplemented", t[t.BadGateway = 502] = "BadGateway", t[t.ServiceUnavailable = 503] = "ServiceUnavailable", t[t.GatewayTimeout = 504] = "GatewayTimeout", t[t.HTTPVersionNotSupported = 505] = "HTTPVersionNotSupported", t[t.VariantAlsoNegotiates = 506] = "VariantAlsoNegotiates", t[t.InsufficientStorage = 507] = "InsufficientStorage", t[t.LoopDetected = 508] = "LoopDetected", t[t.NotExtended = 510] = "NotExtended", t[t.NetworkAuthenticationRequired = 511] = "NetworkAuthenticationRequired", t))(AA || {});
const qj = new Pj();
Mr({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  subscription: qj,
  hasFunctionality: () => !1
});
jj(AA.TooManyRequests);
Se.createContext({
  i18n: void 0
});
var Mj = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(t) {
  (function(e, r) {
    t.exports ? t.exports = r() : e.numeral = r();
  })(Ws, function() {
    var e, r, n = "2.0.6", i = {}, o = {}, s = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, u = {
      currentLocale: s.currentLocale,
      zeroFormat: s.zeroFormat,
      nullFormat: s.nullFormat,
      defaultFormat: s.defaultFormat,
      scalePercentBy100: s.scalePercentBy100
    };
    function c(a, f) {
      this._input = a, this._value = f;
    }
    return e = function(a) {
      var f, h, p, d;
      if (e.isNumeral(a))
        f = a.value();
      else if (a === 0 || typeof a > "u")
        f = 0;
      else if (a === null || r.isNaN(a))
        f = null;
      else if (typeof a == "string")
        if (u.zeroFormat && a === u.zeroFormat)
          f = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          f = null;
        else {
          for (h in i)
            if (d = typeof i[h].regexps.unformat == "function" ? i[h].regexps.unformat() : i[h].regexps.unformat, d && a.match(d)) {
              p = i[h].unformat;
              break;
            }
          p = p || e._.stringToNumber, f = p(a);
        }
      else
        f = Number(a) || null;
      return new c(a, f);
    }, e.version = n, e.isNumeral = function(a) {
      return a instanceof c;
    }, e._ = r = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(a, f, h) {
        var p = o[e.options.currentLocale], d = !1, _ = !1, m = 0, b = "", O = 1e12, S = 1e9, k = 1e6, T = 1e3, x = "", P = !1, R, D, I, j, Y, H, B;
        if (a = a || 0, D = Math.abs(a), e._.includes(f, "(") ? (d = !0, f = f.replace(/[\(|\)]/g, "")) : (e._.includes(f, "+") || e._.includes(f, "-")) && (Y = e._.includes(f, "+") ? f.indexOf("+") : a < 0 ? f.indexOf("-") : -1, f = f.replace(/[\+|\-]/g, "")), e._.includes(f, "a") && (R = f.match(/a(k|m|b|t)?/), R = R ? R[1] : !1, e._.includes(f, " a") && (b = " "), f = f.replace(new RegExp(b + "a[kmbt]?"), ""), D >= O && !R || R === "t" ? (b += p.abbreviations.trillion, a = a / O) : D < O && D >= S && !R || R === "b" ? (b += p.abbreviations.billion, a = a / S) : D < S && D >= k && !R || R === "m" ? (b += p.abbreviations.million, a = a / k) : (D < k && D >= T && !R || R === "k") && (b += p.abbreviations.thousand, a = a / T)), e._.includes(f, "[.]") && (_ = !0, f = f.replace("[.]", ".")), I = a.toString().split(".")[0], j = f.split(".")[1], H = f.indexOf(","), m = (f.split(".")[0].split(",")[0].match(/0/g) || []).length, j ? (e._.includes(j, "[") ? (j = j.replace("]", ""), j = j.split("["), x = e._.toFixed(a, j[0].length + j[1].length, h, j[1].length)) : x = e._.toFixed(a, j.length, h), I = x.split(".")[0], e._.includes(x, ".") ? x = p.delimiters.decimal + x.split(".")[1] : x = "", _ && Number(x.slice(1)) === 0 && (x = "")) : I = e._.toFixed(a, 0, h), b && !R && Number(I) >= 1e3 && b !== p.abbreviations.trillion)
          switch (I = String(Number(I) / 1e3), b) {
            case p.abbreviations.thousand:
              b = p.abbreviations.million;
              break;
            case p.abbreviations.million:
              b = p.abbreviations.billion;
              break;
            case p.abbreviations.billion:
              b = p.abbreviations.trillion;
              break;
          }
        if (e._.includes(I, "-") && (I = I.slice(1), P = !0), I.length < m)
          for (var tt = m - I.length; tt > 0; tt--)
            I = "0" + I;
        return H > -1 && (I = I.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + p.delimiters.thousands)), f.indexOf(".") === 0 && (I = ""), B = I + x + (b || ""), d ? B = (d && P ? "(" : "") + B + (d && P ? ")" : "") : Y >= 0 ? B = Y === 0 ? (P ? "-" : "+") + B : B + (P ? "-" : "+") : P && (B = "-" + B), B;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(a) {
        var f = o[u.currentLocale], h = a, p = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, d, _, m;
        if (u.zeroFormat && a === u.zeroFormat)
          _ = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          _ = null;
        else {
          _ = 1, f.delimiters.decimal !== "." && (a = a.replace(/\./g, "").replace(f.delimiters.decimal, "."));
          for (d in p)
            if (m = new RegExp("[^a-zA-Z]" + f.abbreviations[d] + "(?:\\)|(\\" + f.currency.symbol + ")?(?:\\))?)?$"), h.match(m)) {
              _ *= Math.pow(10, p[d]);
              break;
            }
          _ *= (a.split("-").length + Math.min(a.split("(").length - 1, a.split(")").length - 1)) % 2 ? 1 : -1, a = a.replace(/[^0-9\.]+/g, ""), _ *= Number(a);
        }
        return _;
      },
      isNaN: function(a) {
        return typeof a == "number" && isNaN(a);
      },
      includes: function(a, f) {
        return a.indexOf(f) !== -1;
      },
      insert: function(a, f, h) {
        return a.slice(0, h) + f + a.slice(h);
      },
      reduce: function(a, f) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof f != "function")
          throw new TypeError(f + " is not a function");
        var h = Object(a), p = h.length >>> 0, d = 0, _;
        if (arguments.length === 3)
          _ = arguments[2];
        else {
          for (; d < p && !(d in h); )
            d++;
          if (d >= p)
            throw new TypeError("Reduce of empty array with no initial value");
          _ = h[d++];
        }
        for (; d < p; d++)
          d in h && (_ = f(_, h[d], d, h));
        return _;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(a) {
        var f = a.toString().split(".");
        return f.length < 2 ? 1 : Math.pow(10, f[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var a = Array.prototype.slice.call(arguments);
        return a.reduce(function(f, h) {
          var p = r.multiplier(h);
          return f > p ? f : p;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(a, f, h, p) {
        var d = a.toString().split("."), _ = f - (p || 0), m, b, O, S;
        return d.length === 2 ? m = Math.min(Math.max(d[1].length, _), f) : m = _, O = Math.pow(10, m), S = (h(a + "e+" + m) / O).toFixed(m), p > f - m && (b = new RegExp("\\.?0{1," + (p - (f - m)) + "}$"), S = S.replace(b, "")), S;
      }
    }, e.options = u, e.formats = i, e.locales = o, e.locale = function(a) {
      return a && (u.currentLocale = a.toLowerCase()), u.currentLocale;
    }, e.localeData = function(a) {
      if (!a)
        return o[u.currentLocale];
      if (a = a.toLowerCase(), !o[a])
        throw new Error("Unknown locale : " + a);
      return o[a];
    }, e.reset = function() {
      for (var a in s)
        u[a] = s[a];
    }, e.zeroFormat = function(a) {
      u.zeroFormat = typeof a == "string" ? a : null;
    }, e.nullFormat = function(a) {
      u.nullFormat = typeof a == "string" ? a : null;
    }, e.defaultFormat = function(a) {
      u.defaultFormat = typeof a == "string" ? a : "0.0";
    }, e.register = function(a, f, h) {
      if (f = f.toLowerCase(), this[a + "s"][f])
        throw new TypeError(f + " " + a + " already registered.");
      return this[a + "s"][f] = h, h;
    }, e.validate = function(a, f) {
      var h, p, d, _, m, b, O, S;
      if (typeof a != "string" && (a += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", a)), a = a.trim(), a.match(/^\d+$/))
        return !0;
      if (a === "")
        return !1;
      try {
        O = e.localeData(f);
      } catch {
        O = e.localeData(e.locale());
      }
      return d = O.currency.symbol, m = O.abbreviations, h = O.delimiters.decimal, O.delimiters.thousands === "." ? p = "\\." : p = O.delimiters.thousands, S = a.match(/^[^\d]+/), S !== null && (a = a.substr(1), S[0] !== d) || (S = a.match(/[^\d]+$/), S !== null && (a = a.slice(0, -1), S[0] !== m.thousand && S[0] !== m.million && S[0] !== m.billion && S[0] !== m.trillion)) ? !1 : (b = new RegExp(p + "{2}"), a.match(/[^\d.,]/g) ? !1 : (_ = a.split(h), _.length > 2 ? !1 : _.length < 2 ? !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) : _[0].length === 1 ? !!_[0].match(/^\d+$/) && !_[0].match(b) && !!_[1].match(/^\d+$/) : !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) && !!_[1].match(/^\d+$/)));
    }, e.fn = c.prototype = {
      clone: function() {
        return e(this);
      },
      format: function(a, f) {
        var h = this._value, p = a || u.defaultFormat, d, _, m;
        if (f = f || Math.round, h === 0 && u.zeroFormat !== null)
          _ = u.zeroFormat;
        else if (h === null && u.nullFormat !== null)
          _ = u.nullFormat;
        else {
          for (d in i)
            if (p.match(i[d].regexps.format)) {
              m = i[d].format;
              break;
            }
          m = m || e._.numberToFormat, _ = m(h, p, f);
        }
        return _;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(a) {
        return this._value = Number(a), this;
      },
      add: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p + Math.round(f * d);
        }
        return this._value = r.reduce([this._value, a], h, 0) / f, this;
      },
      subtract: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p - Math.round(f * d);
        }
        return this._value = r.reduce([a], h, Math.round(this._value * f)) / f, this;
      },
      multiply: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) * Math.round(p * m) / Math.round(m * m);
        }
        return this._value = r.reduce([this._value, a], f, 1), this;
      },
      divide: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) / Math.round(p * m);
        }
        return this._value = r.reduce([this._value, a], f), this;
      },
      difference: function(a) {
        return Math.abs(e(this._value).subtract(a).value());
      }
    }, e.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(a) {
        var f = a % 10;
        return ~~(a % 100 / 10) === 1 ? "th" : f === 1 ? "st" : f === 2 ? "nd" : f === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      e.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " BPS") ? " " : "", d;
          return a = a * 1e4, f = f.replace(/\s?BPS/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "BPS"), d = d.join("")) : d = d + p + "BPS", d;
        },
        unformat: function(a) {
          return +(e._.stringToNumber(a) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var a = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, f = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, h = a.suffixes.concat(f.suffixes.filter(function(d) {
        return a.suffixes.indexOf(d) < 0;
      })), p = h.join("|");
      p = "(" + p.replace("B", "B(?!PS)") + ")", e.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(p)
        },
        format: function(d, _, m) {
          var b, O = e._.includes(_, "ib") ? f : a, S = e._.includes(_, " b") || e._.includes(_, " ib") ? " " : "", k, T, x;
          for (_ = _.replace(/\s?i?b/, ""), k = 0; k <= O.suffixes.length; k++)
            if (T = Math.pow(O.base, k), x = Math.pow(O.base, k + 1), d === null || d === 0 || d >= T && d < x) {
              S += O.suffixes[k], T > 0 && (d = d / T);
              break;
            }
          return b = e._.numberToFormat(d, _, m), b + S;
        },
        unformat: function(d) {
          var _ = e._.stringToNumber(d), m, b;
          if (_) {
            for (m = a.suffixes.length - 1; m >= 0; m--) {
              if (e._.includes(d, a.suffixes[m])) {
                b = Math.pow(a.base, m);
                break;
              }
              if (e._.includes(d, f.suffixes[m])) {
                b = Math.pow(f.base, m);
                break;
              }
            }
            _ *= b || 1;
          }
          return _;
        }
      });
    }(), function() {
      e.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d = {
            before: f.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: f.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, _, m, b;
          for (f = f.replace(/\s?\$\s?/, ""), _ = e._.numberToFormat(a, f, h), a >= 0 ? (d.before = d.before.replace(/[\-\(]/, ""), d.after = d.after.replace(/[\-\)]/, "")) : a < 0 && !e._.includes(d.before, "-") && !e._.includes(d.before, "(") && (d.before = "-" + d.before), b = 0; b < d.before.length; b++)
            switch (m = d.before[b], m) {
              case "$":
                _ = e._.insert(_, p.currency.symbol, b);
                break;
              case " ":
                _ = e._.insert(_, " ", b + p.currency.symbol.length - 1);
                break;
            }
          for (b = d.after.length - 1; b >= 0; b--)
            switch (m = d.after[b], m) {
              case "$":
                _ = b === d.after.length - 1 ? _ + p.currency.symbol : e._.insert(_, p.currency.symbol, -(d.after.length - (1 + b)));
                break;
              case " ":
                _ = b === d.after.length - 1 ? _ + " " : e._.insert(_, " ", -(d.after.length - (1 + b) + p.currency.symbol.length - 1));
                break;
            }
          return _;
        }
      });
    }(), function() {
      e.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(a, f, h) {
          var p, d = typeof a == "number" && !e._.isNaN(a) ? a.toExponential() : "0e+0", _ = d.split("e");
          return f = f.replace(/e[\+|\-]{1}0/, ""), p = e._.numberToFormat(Number(_[0]), f, h), p + "e" + _[1];
        },
        unformat: function(a) {
          var f = e._.includes(a, "e+") ? a.split("e+") : a.split("e-"), h = Number(f[0]), p = Number(f[1]);
          p = e._.includes(a, "e-") ? p *= -1 : p;
          function d(_, m, b, O) {
            var S = e._.correctionFactor(_, m), k = _ * S * (m * S) / (S * S);
            return k;
          }
          return e._.reduce([h, Math.pow(10, p)], d, 1);
        }
      });
    }(), function() {
      e.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d, _ = e._.includes(f, " o") ? " " : "";
          return f = f.replace(/\s?o/, ""), _ += p.ordinal(a), d = e._.numberToFormat(a, f, h), d + _;
        }
      });
    }(), function() {
      e.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " %") ? " " : "", d;
          return e.options.scalePercentBy100 && (a = a * 100), f = f.replace(/\s?\%/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "%"), d = d.join("")) : d = d + p + "%", d;
        },
        unformat: function(a) {
          var f = e._.stringToNumber(a);
          return e.options.scalePercentBy100 ? f * 0.01 : f;
        }
      });
    }(), function() {
      e.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(a, f, h) {
          var p = Math.floor(a / 60 / 60), d = Math.floor((a - p * 60 * 60) / 60), _ = Math.round(a - p * 60 * 60 - d * 60);
          return p + ":" + (d < 10 ? "0" + d : d) + ":" + (_ < 10 ? "0" + _ : _);
        },
        unformat: function(a) {
          var f = a.split(":"), h = 0;
          return f.length === 3 ? (h = h + Number(f[0]) * 60 * 60, h = h + Number(f[1]) * 60, h = h + Number(f[2])) : f.length === 2 && (h = h + Number(f[0]) * 60, h = h + Number(f[1])), Number(h);
        }
      });
    }(), e;
  });
})(Mj);
A0.EN;
var md = /* @__PURE__ */ ((t) => (t[t.LOCAL = -1] = "LOCAL", t[t.CANADA = 0] = "CANADA", t[t.NORTH_EUROPE = 1] = "NORTH_EUROPE", t[t.EUROPE = 2] = "EUROPE", t[t.USA = 3] = "USA", t))(md || {});
const Fj = {
  id: md.LOCAL,
  name: ""
};
class Nj extends Wt(Fj, "DataCenterAttribute") {
}
var DA = /* @__PURE__ */ ((t) => (t.EN_US = "M/D/YYYY h:mm A", t.EN_CA = "YYYY-MM-DD h:mm A", t.FR_CA = "DD/MM/YYYY HH:mm", t))(DA || {}), Bu = /* @__PURE__ */ ((t) => (t.GUEST = "Guest", t.ADMIN = "Admin", t))(Bu || {}), cp = /* @__PURE__ */ ((t) => (t.UTC = "UTC", t.NEW_YORK = "America/New_York", t.DUBAI = "Asia/Asia/Dubai", t))(cp || {}), RA = /* @__PURE__ */ ((t) => (t.ACTIVE = "Active", t.INACTIVE = "Inactive", t))(RA || {});
const zj = {
  role: Bu.GUEST
};
class Lj extends Wt(zj, "HubUserPermissions") {
}
const Uj = {
  globalId: void 0,
  hashId: "",
  localId: -1,
  name: "",
  creationDate: Er.MIN_VALUE,
  demoDaysLeft: void 0,
  owner: "",
  dataCenterInfo: new Nj(),
  metrics: void 0,
  projects: [],
  avatarImage: void 0,
  isLinkedToOrganization: !1,
  url: "",
  subscription: void 0,
  projectTemplates: void 0,
  bimTrackRegionalApiUrl: void 0,
  requestingUserPermissions: new Lj()
};
class oB extends Wt(Uj, "Hub") {
  /**
   * @deprecated use hashId instead.
   */
  get id() {
    return this.hashId;
  }
  /**
   * @deprecated use dataCenterInfo.id instead.
   */
  get dataCenter() {
    return this.dataCenterInfo.id;
  }
  get avatarImageWithDefault() {
    return this.avatarImage;
  }
  get isSubscriptionExpired() {
    return this.subscription ? this.subscription.isExpired : !1;
  }
  get subscriptionPlanProjectLimit() {
    return this.subscription ? this.subscription.projectLimit : 0;
  }
  is(e) {
    return e ? this.id === e.id && this.localId === e.localId : !1;
  }
}
const Bj = {
  totalUsers: void 0
};
class sB extends Wt(Bj, "HubMetrics") {
}
var qi = /* @__PURE__ */ ((t) => (t.TEXT = "text", t.PREDEFINED = "predefined", t.TITLE = "title", t.DESCRIPTION = "description", t.STATUS = "status", t.TYPE = "type", t.PRIORITY = "priority", t.DISCIPLINE = "discipline", t.ZONE = "zone", t.PHASE = "phase", t.ASSIGNED_TO = "assignedto", t.DUE_DATE = "duedate", t.ISSUE_GROUP = "issuegroup", t.TEAM = "team", t.NOTIFY = "notify", t.CONFIDENTIALITY = "confidentiality", t.VISIBILITY = "visibility", t))(qi || {}), sm = /* @__PURE__ */ ((t) => (t.ADMIN = "Admin", t.EDITOR = "Editor", t.READER = "Reader", t))(sm || {}), xA = /* @__PURE__ */ ((t) => (t[t.ACTIVE = 0] = "ACTIVE", t[t.ON_HOLD = 1] = "ON_HOLD", t[t.COMPLETION_PENDING = 2] = "COMPLETION_PENDING", t[t.COMPLETED = 3] = "COMPLETED", t))(xA || {});
const $j = {
  statuses: [],
  types: [],
  priorities: [],
  zones: [],
  phases: [],
  disciplines: [],
  customAttributes: []
};
class Kj extends Wt($j, "IssueAttributeOptions") {
}
const Vj = {
  id: -1,
  name: "",
  type: qi.TEXT,
  values: void 0
};
class Qj extends Wt(Vj, "ProjectAttribute") {
}
const Yj = {
  attributes: [],
  selectedColorAttributeForIssue: new Qj(),
  integrations: [],
  issueMandatoryAttributes: []
};
class Gj extends Wt(Yj, "ProjectSettings") {
}
const Wj = {
  role: sm.READER,
  teams: [],
  isReviewer: !1
};
class Hj extends Wt(Wj, "ProjectUserPermissions") {
}
const Jj = {
  id: -1,
  name: "",
  number: "",
  status: xA.ACTIVE,
  settings: new Gj(),
  users: [],
  teams: [],
  requestingUserPermissions: new Hj()
};
class aB extends Wt(Jj, "Project") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
  getIssueGroupsOptions() {
    return this.getOptionsFor(qi.ISSUE_GROUP);
  }
  getAttributesFor(e) {
    return this.settings.attributes.filter(
      (r) => r.type === e
    ) || [];
  }
  getSortedCustomAttributes() {
    return [
      ...this.getAttributesFor(qi.TEXT),
      ...this.getAttributesFor(qi.PREDEFINED)
    ].sort((e, r) => e.id - r.id);
  }
  getOptionsFor(e) {
    const r = this.settings.attributes.find(
      (n) => n.type === e
    );
    return r && r.values ? r.values : [];
  }
  getOptionsForIssue() {
    const e = this.getOptionsFor(qi.STATUS), r = this.getOptionsFor(qi.TYPE), n = this.getOptionsFor(qi.PRIORITY), i = this.getOptionsFor(qi.ZONE), o = this.getOptionsFor(qi.PHASE), s = this.getOptionsFor(qi.DISCIPLINE), u = this.getSortedCustomAttributes();
    return new Kj({
      statuses: e,
      types: r,
      priorities: n,
      zones: i,
      phases: o,
      disciplines: s,
      customAttributes: u
    });
  }
  getStatusesBaseOnUser(e, r) {
    const n = e.teams ?? [];
    let i = this.getOptionsFor(qi.STATUS).filter((o) => {
      const s = o.teams ? o.teams.map((u) => u.id) : [];
      return s.length === 0 || n.some((u) => s.indexOf(u.id) !== -1);
    });
    return i.some((o) => o.id === r.id) || (i = [...i, r].sort((o, s) => o.name.localeCompare(s.name))), i;
  }
  getIntegrationFor(e) {
    return this.settings.integrations.find(
      (r) => r.integration.name.toLowerCase() === e.toLowerCase()
    );
  }
  getIssueMandatoryAttributes() {
    return this.settings.issueMandatoryAttributes;
  }
  getAttributes() {
    return this.settings.attributes;
  }
}
const Zj = {
  id: -1,
  name: ""
};
class uB extends Wt(Zj, "ProjectTemplate") {
}
const Xj = {
  id: -1,
  name: ""
};
class cB extends Wt(Xj, "ProjectTeam") {
}
const tq = {
  id: -1,
  name: "",
  siteUrl: ""
};
class eq extends Wt(tq, "Integration") {
}
const rq = {
  id: -1,
  name: "",
  color: void 0,
  teams: void 0
};
class fB extends Wt(rq, "ProjectAttributeValue") {
}
const nq = {
  companyId: -1,
  companyName: "",
  projectId: -1,
  projectName: "",
  createRFIComment: !1
};
class lB extends Wt(nq, "ProcoreIntegrationData") {
}
const iq = {
  id: -1,
  integration: new eq(),
  data: {}
};
class hB extends Wt(iq, "ProjectIntegration") {
}
const oq = {
  id: "",
  name: ""
};
class pB extends Wt(oq, "PropertyAttribute") {
}
const sq = {
  user: void 0,
  hub: void 0,
  project: void 0,
  bimTrackApiUrl: ""
};
class dB extends Wt(sq, "Session") {
}
const aq = {
  id: "",
  name: "",
  format: DA.EN_US
};
class uq extends Wt(aq, "DateFormatAttribute") {
}
const cq = {
  id: A0.EN,
  name: ""
};
class fq extends Wt(cq, "LanguageAttribute") {
}
const lq = {
  id: cp.NEW_YORK,
  name: cp.NEW_YORK,
  nameIana: cp.NEW_YORK,
  offset: void 0
};
class hq extends Wt(lq, "TimeZoneAttribute") {
}
const pq = {
  firstName: "",
  lastName: "",
  title: "",
  company: "",
  country: void 0,
  industry: void 0,
  jobTitle: "",
  dateFormat: new uq(),
  avatarImage: "",
  language: new fq(),
  website: void 0,
  timeZone: new hq()
};
class dq extends Wt(pq, "UserProfile") {
  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
  get initials() {
    return this.firstName && this.lastName ? `${Array.from(this.firstName)[0]}${Array.from(this.lastName)[0]}` : "";
  }
  getDateTimeFormat() {
    return this.dateFormat.format;
  }
  getDateFormat() {
    return this.dateFormat.format.replace(/ .*/, "");
  }
  getTimeFormat() {
    return this.dateFormat.format.replace(/([^\s]+) /, "");
  }
}
const vq = {
  id: 0,
  globalId: void 0,
  email: "",
  profile: new dq(),
  status: RA.INACTIVE,
  activationDate: void 0,
  invitationPending: !1,
  isPending: !1,
  lastHubProjectActivity: void 0,
  canResendInvite: void 0,
  hubOwner: !1,
  hubRole: Bu.GUEST,
  projectOwner: !1,
  projectReviewer: !1,
  projectRole: void 0,
  projects: [],
  teams: [],
  isProviderExternal: !1,
  isLoggedWithSso: !1,
  isHubUserSsoRestricted: !1,
  isEmailChangeMandatory: !1
};
class vB extends Wt(vq, "User") {
  get fullName() {
    return this.isValid() ? this.profile.fullName : `${this.profile.title}`.trim();
  }
  get fullNameAndEmail() {
    return `${this.fullName} (${this.email})`.trim();
  }
  get initials() {
    return this.profile.initials;
  }
  isNew() {
    return this.id === 0;
  }
  isOwner() {
    return this.hubOwner;
  }
  isAdmin() {
    return this.hubRole === Bu.ADMIN;
  }
  isGuest() {
    return this.hubRole === Bu.GUEST;
  }
  isProjectAdmin() {
    return this.projectRole === sm.ADMIN;
  }
  isProjectOwner() {
    return this.projectOwner;
  }
  isTeamMember(e) {
    return this.teams.some((r) => r.id === e);
  }
  canEditUser(e) {
    return this.is(e) || this.hubRole === Bu.GUEST ? !1 : this.isOwner() || !e.isOwner();
  }
  is(e) {
    return e ? this.globalId && e.globalId ? this.globalId === e.globalId : this.id === e.id : !1;
  }
  getDateTimeFormat() {
    return this.profile.getDateTimeFormat();
  }
  getDateFormat() {
    return this.profile.getDateFormat();
  }
  getTimeFormat() {
    return this.profile.getTimeFormat();
  }
  isValid() {
    return this.id > 0 || !!this.globalId;
  }
}
const yq = {
  id: -1,
  name: ""
};
class yB extends Wt(yq, "UserProject") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
}
var _q = Object.defineProperty, mq = (t, e, r) => e in t ? _q(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, cw = (t, e, r) => (mq(t, typeof e != "symbol" ? e + "" : e, r), r), Hs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function gq(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Gy = { exports: {} }, fw = Object.hasOwnProperty, bq = Object.getPrototypeOf, lw = Error.captureStackTrace, wq = xp;
function xp(t, e) {
  if (t && typeof t == "object" ? (e = t, t = void 0) : this.message = t, e)
    for (var r in e)
      this[r] = e[r];
  fw.call(this, "name") || (this.name = fw.call(bq(this), "name") ? this.name : this.constructor.name), lw && !("stack" in this) && lw(this, this.constructor);
}
xp.prototype = Object.create(Error.prototype, {
  constructor: { value: xp, configurable: !0, writable: !0 }
});
xp.prototype.name = "StandardError";
const Eq = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non-Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi-Status",
  208: "Already Reported",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  307: "Temporary Redirect",
  308: "Permanent Redirect",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "URI Too Long",
  415: "Unsupported Media Type",
  416: "Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  421: "Misdirected Request",
  422: "Unprocessable Entity",
  423: "Locked",
  424: "Failed Dependency",
  425: "Unordered Collection",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  509: "Bandwidth Limit Exceeded",
  510: "Not Extended",
  511: "Network Authentication Required"
};
(function(t, e) {
  e = t.exports = o;
  var r = wq, n = Eq, i = e;
  function o(a, f, h) {
    if (typeof a == "string" && (a = i[a]), typeof a != "number")
      throw new TypeError("Non-numeric HTTP code");
    typeof f == "object" && f != null && (h = f, f = null), r.call(this, f || n[a], h), this.code = a;
  }
  o.prototype = Object.create(r.prototype, {
    constructor: { value: o, configurable: !0, writable: !0 }
  }), o.prototype.name = "HttpError", Object.defineProperties(o.prototype, {
    statusCode: c("code"),
    statusMessage: c("message"),
    status: {
      configurable: !0,
      get: function() {
        return this.code;
      },
      set: function(a) {
        Object.defineProperty(this, "status", {
          value: a,
          configurable: !0,
          enumerable: !0,
          writable: !0
        });
      }
    }
  }), o.prototype.toString = function() {
    return this.name + ": " + this.code + " " + this.message;
  };
  for (var s in n) {
    var u = n[s];
    e[u.replace("'", "").replace(/[- ]/g, "_").toUpperCase()] = +s;
  }
  function c(a) {
    return {
      configurable: !0,
      get: function() {
        return this[a];
      },
      set: function(f) {
        return this[a] = f;
      }
    };
  }
})(Gy, Gy.exports);
var Sq = Gy.exports;
const Oq = /* @__PURE__ */ gq(Sq);
var Tp = { exports: {} };
Tp.exports;
(function(t, e) {
  var r = 200, n = "Expected a function", i = "__lodash_hash_undefined__", o = 1, s = 2, u = 1 / 0, c = 9007199254740991, a = "[object Arguments]", f = "[object Array]", h = "[object Boolean]", p = "[object Date]", d = "[object Error]", _ = "[object Function]", m = "[object GeneratorFunction]", b = "[object Map]", O = "[object Number]", S = "[object Object]", k = "[object Promise]", T = "[object RegExp]", x = "[object Set]", P = "[object String]", R = "[object Symbol]", D = "[object WeakMap]", I = "[object ArrayBuffer]", j = "[object DataView]", Y = "[object Float32Array]", H = "[object Float64Array]", B = "[object Int8Array]", tt = "[object Int16Array]", lt = "[object Int32Array]", te = "[object Uint8Array]", pt = "[object Uint8ClampedArray]", At = "[object Uint16Array]", ft = "[object Uint32Array]", Lt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, dt = /^\w*$/, mt = /^\./, st = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Nt = /[\\^$.*+?()[\]{}|]/g, Qt = /\\(\\)?/g, Rt = /^\[object .+?Constructor\]$/, xt = /^(?:0|[1-9]\d*)$/, N = {};
  N[Y] = N[H] = N[B] = N[tt] = N[lt] = N[te] = N[pt] = N[At] = N[ft] = !0, N[a] = N[f] = N[I] = N[h] = N[j] = N[p] = N[d] = N[_] = N[b] = N[O] = N[S] = N[T] = N[x] = N[P] = N[D] = !1;
  var ht = typeof Hs == "object" && Hs && Hs.Object === Object && Hs, gt = typeof self == "object" && self && self.Object === Object && self, X = ht || gt || Function("return this")(), wt = e && !e.nodeType && e, jt = wt && !0 && t && !t.nodeType && t, qt = jt && jt.exports === wt, U = qt && ht.process, $ = function() {
    try {
      return U && U.binding("util");
    } catch {
    }
  }(), W = $ && $.isTypedArray;
  function et(l, v) {
    for (var g = -1, E = l ? l.length : 0; ++g < E; )
      if (v(l[g], g, l))
        return !0;
    return !1;
  }
  function ot(l) {
    return function(v) {
      return v == null ? void 0 : v[l];
    };
  }
  function Dt(l, v) {
    for (var g = -1, E = Array(l); ++g < l; )
      E[g] = v(g);
    return E;
  }
  function St(l) {
    return function(v) {
      return l(v);
    };
  }
  function Et(l, v) {
    return l == null ? void 0 : l[v];
  }
  function ue(l) {
    var v = !1;
    if (l != null && typeof l.toString != "function")
      try {
        v = !!(l + "");
      } catch {
      }
    return v;
  }
  function ae(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E, M) {
      g[++v] = [M, E];
    }), g;
  }
  function ce(l, v) {
    return function(g) {
      return l(v(g));
    };
  }
  function Yt(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E) {
      g[++v] = E;
    }), g;
  }
  var Ot = Array.prototype, Oe = Function.prototype, Gt = Object.prototype, se = X["__core-js_shared__"], Zt = function() {
    var l = /[^.]+$/.exec(se && se.keys && se.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), fe = Oe.toString, vt = Gt.hasOwnProperty, Mt = Gt.toString, Fr = RegExp(
    "^" + fe.call(vt).replace(Nt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), We = X.Symbol, He = X.Uint8Array, Nr = Gt.propertyIsEnumerable, Ie = Ot.splice, Je = ce(Object.keys, Object), It = _e(X, "DataView"), Tt = _e(X, "Map"), ee = _e(X, "Promise"), ye = _e(X, "Set"), Ae = _e(X, "WeakMap"), Ut = _e(Object, "create"), zr = ne(It), Ze = ne(Tt), Xe = ne(ee), Lr = ne(ye), Ur = ne(Ae), re = We ? We.prototype : void 0, De = re ? re.valueOf : void 0, tr = re ? re.toString : void 0;
  function Pt(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Br() {
    this.__data__ = Ut ? Ut(null) : {};
  }
  function y(l) {
    return this.has(l) && delete this.__data__[l];
  }
  function w(l) {
    var v = this.__data__;
    if (Ut) {
      var g = v[l];
      return g === i ? void 0 : g;
    }
    return vt.call(v, l) ? v[l] : void 0;
  }
  function A(l) {
    var v = this.__data__;
    return Ut ? v[l] !== void 0 : vt.call(v, l);
  }
  function q(l, v) {
    var g = this.__data__;
    return g[l] = Ut && v === void 0 ? i : v, this;
  }
  Pt.prototype.clear = Br, Pt.prototype.delete = y, Pt.prototype.get = w, Pt.prototype.has = A, Pt.prototype.set = q;
  function F(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Q() {
    this.__data__ = [];
  }
  function L(l) {
    var v = this.__data__, g = nr(v, l);
    if (g < 0)
      return !1;
    var E = v.length - 1;
    return g == E ? v.pop() : Ie.call(v, g, 1), !0;
  }
  function z(l) {
    var v = this.__data__, g = nr(v, l);
    return g < 0 ? void 0 : v[g][1];
  }
  function it(l) {
    return nr(this.__data__, l) > -1;
  }
  function J(l, v) {
    var g = this.__data__, E = nr(g, l);
    return E < 0 ? g.push([l, v]) : g[E][1] = v, this;
  }
  F.prototype.clear = Q, F.prototype.delete = L, F.prototype.get = z, F.prototype.has = it, F.prototype.set = J;
  function K(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function ut() {
    this.__data__ = {
      hash: new Pt(),
      map: new (Tt || F)(),
      string: new Pt()
    };
  }
  function Bt(l) {
    return ir(this, l).delete(l);
  }
  function er(l) {
    return ir(this, l).get(l);
  }
  function bt(l) {
    return ir(this, l).has(l);
  }
  function cs(l, v) {
    return ir(this, l).set(l, v), this;
  }
  K.prototype.clear = ut, K.prototype.delete = Bt, K.prototype.get = er, K.prototype.has = bt, K.prototype.set = cs;
  function rr(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.__data__ = new K(); ++v < g; )
      this.add(l[v]);
  }
  function fs(l) {
    return this.__data__.set(l, i), this;
  }
  function ls(l) {
    return this.__data__.has(l);
  }
  rr.prototype.add = rr.prototype.push = fs, rr.prototype.has = ls;
  function kt(l) {
    this.__data__ = new F(l);
  }
  function hs() {
    this.__data__ = new F();
  }
  function ps(l) {
    return this.__data__.delete(l);
  }
  function ds(l) {
    return this.__data__.get(l);
  }
  function vs(l) {
    return this.__data__.has(l);
  }
  function ys(l, v) {
    var g = this.__data__;
    if (g instanceof F) {
      var E = g.__data__;
      if (!Tt || E.length < r - 1)
        return E.push([l, v]), this;
      g = this.__data__ = new K(E);
    }
    return g.set(l, v), this;
  }
  kt.prototype.clear = hs, kt.prototype.delete = ps, kt.prototype.get = ds, kt.prototype.has = vs, kt.prototype.set = ys;
  function _s(l, v) {
    var g = ie(l) || Jn(l) ? Dt(l.length, String) : [], E = g.length, M = !!E;
    for (var C in l)
      (v || vt.call(l, C)) && !(M && (C == "length" || Yn(C, E))) && g.push(C);
    return g;
  }
  function nr(l, v) {
    for (var g = l.length; g--; )
      if (Hn(l[g][0], v))
        return g;
    return -1;
  }
  var ms = ks();
  function gs(l, v) {
    return l && ms(l, v, cr);
  }
  function Kn(l, v) {
    v = or(v, l) ? [v] : Vn(v);
    for (var g = 0, E = v.length; l != null && g < E; )
      l = l[sr(v[g++])];
    return g && g == E ? l : void 0;
  }
  function bs(l) {
    return Mt.call(l);
  }
  function ws(l, v) {
    return l != null && v in Object(l);
  }
  function $r(l, v, g, E, M) {
    return l === v ? !0 : l == null || v == null || !ar(l) && !ur(v) ? l !== l && v !== v : Es(l, v, $r, g, E, M);
  }
  function Es(l, v, g, E, M, C) {
    var V = ie(l), G = ie(v), Z = f, rt = f;
    V || (Z = $t(l), Z = Z == a ? S : Z), G || (rt = $t(v), rt = rt == a ? S : rt);
    var at = Z == S && !ue(l), ct = rt == S && !ue(v), nt = Z == rt;
    if (nt && !at)
      return C || (C = new kt()), V || Bs(l) ? Qn(l, v, g, E, M, C) : Cs(l, v, Z, g, E, M, C);
    if (!(M & s)) {
      var yt = at && vt.call(l, "__wrapped__"), _t = ct && vt.call(v, "__wrapped__");
      if (yt || _t) {
        var Kt = yt ? l.value() : l, Ct = _t ? v.value() : v;
        return C || (C = new kt()), g(Kt, Ct, E, M, C);
      }
    }
    return nt ? (C || (C = new kt()), js(l, v, g, E, M, C)) : !1;
  }
  function Ss(l, v, g, E) {
    var M = g.length, C = M, V = !E;
    if (l == null)
      return !C;
    for (l = Object(l); M--; ) {
      var G = g[M];
      if (V && G[2] ? G[1] !== l[G[0]] : !(G[0] in l))
        return !1;
    }
    for (; ++M < C; ) {
      G = g[M];
      var Z = G[0], rt = l[Z], at = G[1];
      if (V && G[2]) {
        if (rt === void 0 && !(Z in l))
          return !1;
      } else {
        var ct = new kt();
        if (E)
          var nt = E(rt, at, Z, l, v, ct);
        if (!(nt === void 0 ? $r(at, rt, E, o | s, ct) : nt))
          return !1;
      }
    }
    return !0;
  }
  function Os(l) {
    if (!ar(l) || Ns(l))
      return !1;
    var v = Xn(l) || ue(l) ? Fr : Rt;
    return v.test(ne(l));
  }
  function Is(l) {
    return ur(l) && Vr(l.length) && !!N[Mt.call(l)];
  }
  function As(l) {
    return typeof l == "function" ? l : l == null ? Ys : typeof l == "object" ? ie(l) ? xs(l[0], l[1]) : Rs(l) : Gs(l);
  }
  function Ds(l) {
    if (!zs(l))
      return Je(l);
    var v = [];
    for (var g in Object(l))
      vt.call(l, g) && g != "constructor" && v.push(g);
    return v;
  }
  function Rs(l) {
    var v = qs(l);
    return v.length == 1 && v[0][2] ? Wn(v[0][0], v[0][1]) : function(g) {
      return g === l || Ss(g, l, v);
    };
  }
  function xs(l, v) {
    return or(l) && Gn(v) ? Wn(sr(l), v) : function(g) {
      var E = Ks(g, l);
      return E === void 0 && E === v ? Vs(g, l) : $r(v, E, void 0, o | s);
    };
  }
  function Ts(l) {
    return function(v) {
      return Kn(v, l);
    };
  }
  function Ps(l) {
    if (typeof l == "string")
      return l;
    if (Qr(l))
      return tr ? tr.call(l) : "";
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function Vn(l) {
    return ie(l) ? l : Ls(l);
  }
  function ks(l) {
    return function(v, g, E) {
      for (var M = -1, C = Object(v), V = E(v), G = V.length; G--; ) {
        var Z = V[l ? G : ++M];
        if (g(C[Z], Z, C) === !1)
          break;
      }
      return v;
    };
  }
  function Qn(l, v, g, E, M, C) {
    var V = M & s, G = l.length, Z = v.length;
    if (G != Z && !(V && Z > G))
      return !1;
    var rt = C.get(l);
    if (rt && C.get(v))
      return rt == v;
    var at = -1, ct = !0, nt = M & o ? new rr() : void 0;
    for (C.set(l, v), C.set(v, l); ++at < G; ) {
      var yt = l[at], _t = v[at];
      if (E)
        var Kt = V ? E(_t, yt, at, v, l, C) : E(yt, _t, at, l, v, C);
      if (Kt !== void 0) {
        if (Kt)
          continue;
        ct = !1;
        break;
      }
      if (nt) {
        if (!et(v, function(Ct, oe) {
          if (!nt.has(oe) && (yt === Ct || g(yt, Ct, E, M, C)))
            return nt.add(oe);
        })) {
          ct = !1;
          break;
        }
      } else if (!(yt === _t || g(yt, _t, E, M, C))) {
        ct = !1;
        break;
      }
    }
    return C.delete(l), C.delete(v), ct;
  }
  function Cs(l, v, g, E, M, C, V) {
    switch (g) {
      case j:
        if (l.byteLength != v.byteLength || l.byteOffset != v.byteOffset)
          return !1;
        l = l.buffer, v = v.buffer;
      case I:
        return !(l.byteLength != v.byteLength || !E(new He(l), new He(v)));
      case h:
      case p:
      case O:
        return Hn(+l, +v);
      case d:
        return l.name == v.name && l.message == v.message;
      case T:
      case P:
        return l == v + "";
      case b:
        var G = ae;
      case x:
        var Z = C & s;
        if (G || (G = Yt), l.size != v.size && !Z)
          return !1;
        var rt = V.get(l);
        if (rt)
          return rt == v;
        C |= o, V.set(l, v);
        var at = Qn(G(l), G(v), E, M, C, V);
        return V.delete(l), at;
      case R:
        if (De)
          return De.call(l) == De.call(v);
    }
    return !1;
  }
  function js(l, v, g, E, M, C) {
    var V = M & s, G = cr(l), Z = G.length, rt = cr(v), at = rt.length;
    if (Z != at && !V)
      return !1;
    for (var ct = Z; ct--; ) {
      var nt = G[ct];
      if (!(V ? nt in v : vt.call(v, nt)))
        return !1;
    }
    var yt = C.get(l);
    if (yt && C.get(v))
      return yt == v;
    var _t = !0;
    C.set(l, v), C.set(v, l);
    for (var Kt = V; ++ct < Z; ) {
      nt = G[ct];
      var Ct = l[nt], oe = v[nt];
      if (E)
        var ti = V ? E(oe, Ct, nt, v, l, C) : E(Ct, oe, nt, l, v, C);
      if (!(ti === void 0 ? Ct === oe || g(Ct, oe, E, M, C) : ti)) {
        _t = !1;
        break;
      }
      Kt || (Kt = nt == "constructor");
    }
    if (_t && !Kt) {
      var fr = l.constructor, lr = v.constructor;
      fr != lr && "constructor" in l && "constructor" in v && !(typeof fr == "function" && fr instanceof fr && typeof lr == "function" && lr instanceof lr) && (_t = !1);
    }
    return C.delete(l), C.delete(v), _t;
  }
  function ir(l, v) {
    var g = l.__data__;
    return Fs(v) ? g[typeof v == "string" ? "string" : "hash"] : g.map;
  }
  function qs(l) {
    for (var v = cr(l), g = v.length; g--; ) {
      var E = v[g], M = l[E];
      v[g] = [E, M, Gn(M)];
    }
    return v;
  }
  function _e(l, v) {
    var g = Et(l, v);
    return Os(g) ? g : void 0;
  }
  var $t = bs;
  (It && $t(new It(new ArrayBuffer(1))) != j || Tt && $t(new Tt()) != b || ee && $t(ee.resolve()) != k || ye && $t(new ye()) != x || Ae && $t(new Ae()) != D) && ($t = function(l) {
    var v = Mt.call(l), g = v == S ? l.constructor : void 0, E = g ? ne(g) : void 0;
    if (E)
      switch (E) {
        case zr:
          return j;
        case Ze:
          return b;
        case Xe:
          return k;
        case Lr:
          return x;
        case Ur:
          return D;
      }
    return v;
  });
  function Ms(l, v, g) {
    v = or(v, l) ? [v] : Vn(v);
    for (var E, M = -1, V = v.length; ++M < V; ) {
      var C = sr(v[M]);
      if (!(E = l != null && g(l, C)))
        break;
      l = l[C];
    }
    if (E)
      return E;
    var V = l ? l.length : 0;
    return !!V && Vr(V) && Yn(C, V) && (ie(l) || Jn(l));
  }
  function Yn(l, v) {
    return v = v ?? c, !!v && (typeof l == "number" || xt.test(l)) && l > -1 && l % 1 == 0 && l < v;
  }
  function or(l, v) {
    if (ie(l))
      return !1;
    var g = typeof l;
    return g == "number" || g == "symbol" || g == "boolean" || l == null || Qr(l) ? !0 : dt.test(l) || !Lt.test(l) || v != null && l in Object(v);
  }
  function Fs(l) {
    var v = typeof l;
    return v == "string" || v == "number" || v == "symbol" || v == "boolean" ? l !== "__proto__" : l === null;
  }
  function Ns(l) {
    return !!Zt && Zt in l;
  }
  function zs(l) {
    var v = l && l.constructor, g = typeof v == "function" && v.prototype || Gt;
    return l === g;
  }
  function Gn(l) {
    return l === l && !ar(l);
  }
  function Wn(l, v) {
    return function(g) {
      return g == null ? !1 : g[l] === v && (v !== void 0 || l in Object(g));
    };
  }
  var Ls = Kr(function(l) {
    l = $s(l);
    var v = [];
    return mt.test(l) && v.push(""), l.replace(st, function(g, E, M, C) {
      v.push(M ? C.replace(Qt, "$1") : E || g);
    }), v;
  });
  function sr(l) {
    if (typeof l == "string" || Qr(l))
      return l;
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function ne(l) {
    if (l != null) {
      try {
        return fe.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function Kr(l, v) {
    if (typeof l != "function" || v && typeof v != "function")
      throw new TypeError(n);
    var g = function() {
      var E = arguments, M = v ? v.apply(this, E) : E[0], C = g.cache;
      if (C.has(M))
        return C.get(M);
      var V = l.apply(this, E);
      return g.cache = C.set(M, V), V;
    };
    return g.cache = new (Kr.Cache || K)(), g;
  }
  Kr.Cache = K;
  function Hn(l, v) {
    return l === v || l !== l && v !== v;
  }
  function Jn(l) {
    return Us(l) && vt.call(l, "callee") && (!Nr.call(l, "callee") || Mt.call(l) == a);
  }
  var ie = Array.isArray;
  function Zn(l) {
    return l != null && Vr(l.length) && !Xn(l);
  }
  function Us(l) {
    return ur(l) && Zn(l);
  }
  function Xn(l) {
    var v = ar(l) ? Mt.call(l) : "";
    return v == _ || v == m;
  }
  function Vr(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= c;
  }
  function ar(l) {
    var v = typeof l;
    return !!l && (v == "object" || v == "function");
  }
  function ur(l) {
    return !!l && typeof l == "object";
  }
  function Qr(l) {
    return typeof l == "symbol" || ur(l) && Mt.call(l) == R;
  }
  var Bs = W ? St(W) : Is;
  function $s(l) {
    return l == null ? "" : Ps(l);
  }
  function Ks(l, v, g) {
    var E = l == null ? void 0 : Kn(l, v);
    return E === void 0 ? g : E;
  }
  function Vs(l, v) {
    return l != null && Ms(l, v, ws);
  }
  function cr(l) {
    return Zn(l) ? _s(l) : Ds(l);
  }
  function Qs(l, v) {
    var g = {};
    return v = As(v), gs(l, function(E, M, C) {
      g[v(E, M, C)] = E;
    }), g;
  }
  function Ys(l) {
    return l;
  }
  function Gs(l) {
    return or(l) ? ot(sr(l)) : Ts(l);
  }
  t.exports = Qs;
})(Tp, Tp.exports);
Tp.exports;
var wf = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hw;
function Iq() {
  if (hw)
    return wf;
  hw = 1;
  var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, c, a) {
    var f, h = {}, p = null, d = null;
    a !== void 0 && (p = "" + a), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (f in c)
      n.call(c, f) && !o.hasOwnProperty(f) && (h[f] = c[f]);
    if (u && u.defaultProps)
      for (f in c = u.defaultProps, c)
        h[f] === void 0 && (h[f] = c[f]);
    return { $$typeof: e, type: u, key: p, ref: d, props: h, _owner: i.current };
  }
  return wf.Fragment = r, wf.jsx = s, wf.jsxs = s, wf;
}
var jh = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pw;
function Aq() {
  return pw || (pw = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), a = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), _ = Symbol.iterator, m = "@@iterator";
    function b(y) {
      if (y === null || typeof y != "object")
        return null;
      var w = _ && y[_] || y[m];
      return typeof w == "function" ? w : null;
    }
    var O = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(y) {
      {
        for (var w = arguments.length, A = new Array(w > 1 ? w - 1 : 0), q = 1; q < w; q++)
          A[q - 1] = arguments[q];
        k("error", y, A);
      }
    }
    function k(y, w, A) {
      {
        var q = O.ReactDebugCurrentFrame, F = q.getStackAddendum();
        F !== "" && (w += "%s", A = A.concat([F]));
        var Q = A.map(function(L) {
          return String(L);
        });
        Q.unshift("Warning: " + w), Function.prototype.apply.call(console[y], console, Q);
      }
    }
    var T = !1, x = !1, P = !1, R = !1, D = !1, I;
    I = Symbol.for("react.module.reference");
    function j(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === n || y === o || D || y === i || y === a || y === f || R || y === d || T || x || P || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === h || y.$$typeof === s || y.$$typeof === u || y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === I || y.getModuleId !== void 0));
    }
    function Y(y, w, A) {
      var q = y.displayName;
      if (q)
        return q;
      var F = w.displayName || w.name || "";
      return F !== "" ? A + "(" + F + ")" : A;
    }
    function H(y) {
      return y.displayName || "Context";
    }
    function B(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case a:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case u:
            var w = y;
            return H(w) + ".Consumer";
          case s:
            var A = y;
            return H(A._context) + ".Provider";
          case c:
            return Y(y, y.render, "ForwardRef");
          case h:
            var q = y.displayName || null;
            return q !== null ? q : B(y.type) || "Memo";
          case p: {
            var F = y, Q = F._payload, L = F._init;
            try {
              return B(L(Q));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var tt = Object.assign, lt = 0, te, pt, At, ft, Lt, dt, mt;
    function st() {
    }
    st.__reactDisabledLog = !0;
    function Nt() {
      {
        if (lt === 0) {
          te = console.log, pt = console.info, At = console.warn, ft = console.error, Lt = console.group, dt = console.groupCollapsed, mt = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: st,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        lt++;
      }
    }
    function Qt() {
      {
        if (lt--, lt === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: tt({}, y, {
              value: te
            }),
            info: tt({}, y, {
              value: pt
            }),
            warn: tt({}, y, {
              value: At
            }),
            error: tt({}, y, {
              value: ft
            }),
            group: tt({}, y, {
              value: Lt
            }),
            groupCollapsed: tt({}, y, {
              value: dt
            }),
            groupEnd: tt({}, y, {
              value: mt
            })
          });
        }
        lt < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Rt = O.ReactCurrentDispatcher, xt;
    function N(y, w, A) {
      {
        if (xt === void 0)
          try {
            throw Error();
          } catch (F) {
            var q = F.stack.trim().match(/\n( *(at )?)/);
            xt = q && q[1] || "";
          }
        return `
` + xt + y;
      }
    }
    var ht = !1, gt;
    {
      var X = typeof WeakMap == "function" ? WeakMap : Map;
      gt = new X();
    }
    function wt(y, w) {
      if (!y || ht)
        return "";
      {
        var A = gt.get(y);
        if (A !== void 0)
          return A;
      }
      var q;
      ht = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Q;
      Q = Rt.current, Rt.current = null, Nt();
      try {
        if (w) {
          var L = function() {
            throw Error();
          };
          if (Object.defineProperty(L.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(L, []);
            } catch (bt) {
              q = bt;
            }
            Reflect.construct(y, [], L);
          } else {
            try {
              L.call();
            } catch (bt) {
              q = bt;
            }
            y.call(L.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bt) {
            q = bt;
          }
          y();
        }
      } catch (bt) {
        if (bt && q && typeof bt.stack == "string") {
          for (var z = bt.stack.split(`
`), it = q.stack.split(`
`), J = z.length - 1, K = it.length - 1; J >= 1 && K >= 0 && z[J] !== it[K]; )
            K--;
          for (; J >= 1 && K >= 0; J--, K--)
            if (z[J] !== it[K]) {
              if (J !== 1 || K !== 1)
                do
                  if (J--, K--, K < 0 || z[J] !== it[K]) {
                    var ut = `
` + z[J].replace(" at new ", " at ");
                    return y.displayName && ut.includes("<anonymous>") && (ut = ut.replace("<anonymous>", y.displayName)), typeof y == "function" && gt.set(y, ut), ut;
                  }
                while (J >= 1 && K >= 0);
              break;
            }
        }
      } finally {
        ht = !1, Rt.current = Q, Qt(), Error.prepareStackTrace = F;
      }
      var Bt = y ? y.displayName || y.name : "", er = Bt ? N(Bt) : "";
      return typeof y == "function" && gt.set(y, er), er;
    }
    function jt(y, w, A) {
      return wt(y, !1);
    }
    function qt(y) {
      var w = y.prototype;
      return !!(w && w.isReactComponent);
    }
    function U(y, w, A) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return wt(y, qt(y));
      if (typeof y == "string")
        return N(y);
      switch (y) {
        case a:
          return N("Suspense");
        case f:
          return N("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case c:
            return jt(y.render);
          case h:
            return U(y.type, w, A);
          case p: {
            var q = y, F = q._payload, Q = q._init;
            try {
              return U(Q(F), w, A);
            } catch {
            }
          }
        }
      return "";
    }
    var $ = Object.prototype.hasOwnProperty, W = {}, et = O.ReactDebugCurrentFrame;
    function ot(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        et.setExtraStackFrame(A);
      } else
        et.setExtraStackFrame(null);
    }
    function Dt(y, w, A, q, F) {
      {
        var Q = Function.call.bind($);
        for (var L in y)
          if (Q(y, L)) {
            var z = void 0;
            try {
              if (typeof y[L] != "function") {
                var it = Error((q || "React class") + ": " + A + " type `" + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[L] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw it.name = "Invariant Violation", it;
              }
              z = y[L](w, L, q, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (J) {
              z = J;
            }
            z && !(z instanceof Error) && (ot(F), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", A, L, typeof z), ot(null)), z instanceof Error && !(z.message in W) && (W[z.message] = !0, ot(F), S("Failed %s type: %s", A, z.message), ot(null));
          }
      }
    }
    var St = Array.isArray;
    function Et(y) {
      return St(y);
    }
    function ue(y) {
      {
        var w = typeof Symbol == "function" && Symbol.toStringTag, A = w && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return A;
      }
    }
    function ae(y) {
      try {
        return ce(y), !1;
      } catch {
        return !0;
      }
    }
    function ce(y) {
      return "" + y;
    }
    function Yt(y) {
      if (ae(y))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ue(y)), ce(y);
    }
    var Ot = O.ReactCurrentOwner, Oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Gt, se, Zt;
    Zt = {};
    function fe(y) {
      if ($.call(y, "ref")) {
        var w = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function vt(y) {
      if ($.call(y, "key")) {
        var w = Object.getOwnPropertyDescriptor(y, "key").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Mt(y, w) {
      if (typeof y.ref == "string" && Ot.current && w && Ot.current.stateNode !== w) {
        var A = B(Ot.current.type);
        Zt[A] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(Ot.current.type), y.ref), Zt[A] = !0);
      }
    }
    function Fr(y, w) {
      {
        var A = function() {
          Gt || (Gt = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: A,
          configurable: !0
        });
      }
    }
    function We(y, w) {
      {
        var A = function() {
          se || (se = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: A,
          configurable: !0
        });
      }
    }
    var He = function(y, w, A, q, F, Q, L) {
      var z = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: y,
        key: w,
        ref: A,
        props: L,
        // Record the component responsible for creating this element.
        _owner: Q
      };
      return z._store = {}, Object.defineProperty(z._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(z, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(z, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(z.props), Object.freeze(z)), z;
    };
    function Nr(y, w, A, q, F) {
      {
        var Q, L = {}, z = null, it = null;
        A !== void 0 && (Yt(A), z = "" + A), vt(w) && (Yt(w.key), z = "" + w.key), fe(w) && (it = w.ref, Mt(w, F));
        for (Q in w)
          $.call(w, Q) && !Oe.hasOwnProperty(Q) && (L[Q] = w[Q]);
        if (y && y.defaultProps) {
          var J = y.defaultProps;
          for (Q in J)
            L[Q] === void 0 && (L[Q] = J[Q]);
        }
        if (z || it) {
          var K = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          z && Fr(L, K), it && We(L, K);
        }
        return He(y, z, it, F, q, Ot.current, L);
      }
    }
    var Ie = O.ReactCurrentOwner, Je = O.ReactDebugCurrentFrame;
    function It(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        Je.setExtraStackFrame(A);
      } else
        Je.setExtraStackFrame(null);
    }
    var Tt;
    Tt = !1;
    function ee(y) {
      return typeof y == "object" && y !== null && y.$$typeof === e;
    }
    function ye() {
      {
        if (Ie.current) {
          var y = B(Ie.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function Ae(y) {
      {
        if (y !== void 0) {
          var w = y.fileName.replace(/^.*[\\\/]/, ""), A = y.lineNumber;
          return `

Check your code at ` + w + ":" + A + ".";
        }
        return "";
      }
    }
    var Ut = {};
    function zr(y) {
      {
        var w = ye();
        if (!w) {
          var A = typeof y == "string" ? y : y.displayName || y.name;
          A && (w = `

Check the top-level render call using <` + A + ">.");
        }
        return w;
      }
    }
    function Ze(y, w) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var A = zr(w);
        if (Ut[A])
          return;
        Ut[A] = !0;
        var q = "";
        y && y._owner && y._owner !== Ie.current && (q = " It was passed a child from " + B(y._owner.type) + "."), It(y), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, q), It(null);
      }
    }
    function Xe(y, w) {
      {
        if (typeof y != "object")
          return;
        if (Et(y))
          for (var A = 0; A < y.length; A++) {
            var q = y[A];
            ee(q) && Ze(q, w);
          }
        else if (ee(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var F = b(y);
          if (typeof F == "function" && F !== y.entries)
            for (var Q = F.call(y), L; !(L = Q.next()).done; )
              ee(L.value) && Ze(L.value, w);
        }
      }
    }
    function Lr(y) {
      {
        var w = y.type;
        if (w == null || typeof w == "string")
          return;
        var A;
        if (typeof w == "function")
          A = w.propTypes;
        else if (typeof w == "object" && (w.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        w.$$typeof === h))
          A = w.propTypes;
        else
          return;
        if (A) {
          var q = B(w);
          Dt(A, y.props, "prop", q, y);
        } else if (w.PropTypes !== void 0 && !Tt) {
          Tt = !0;
          var F = B(w);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof w.getDefaultProps == "function" && !w.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ur(y) {
      {
        for (var w = Object.keys(y.props), A = 0; A < w.length; A++) {
          var q = w[A];
          if (q !== "children" && q !== "key") {
            It(y), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), It(null);
            break;
          }
        }
        y.ref !== null && (It(y), S("Invalid attribute `ref` supplied to `React.Fragment`."), It(null));
      }
    }
    function re(y, w, A, q, F, Q) {
      {
        var L = j(y);
        if (!L) {
          var z = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var it = Ae(F);
          it ? z += it : z += ye();
          var J;
          y === null ? J = "null" : Et(y) ? J = "array" : y !== void 0 && y.$$typeof === e ? (J = "<" + (B(y.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : J = typeof y, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", J, z);
        }
        var K = Nr(y, w, A, F, Q);
        if (K == null)
          return K;
        if (L) {
          var ut = w.children;
          if (ut !== void 0)
            if (q)
              if (Et(ut)) {
                for (var Bt = 0; Bt < ut.length; Bt++)
                  Xe(ut[Bt], y);
                Object.freeze && Object.freeze(ut);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xe(ut, y);
        }
        return y === n ? Ur(K) : Lr(K), K;
      }
    }
    function De(y, w, A) {
      return re(y, w, A, !0);
    }
    function tr(y, w, A) {
      return re(y, w, A, !1);
    }
    var Pt = tr, Br = De;
    jh.Fragment = n, jh.jsx = Pt, jh.jsxs = Br;
  }()), jh;
}
process.env.NODE_ENV === "production" ? Iq() : Aq();
function gd(t, e, r, n) {
  Object.defineProperty(t, e, { get: r, set: n, enumerable: !0, configurable: !0 });
}
var Dq = {};
gd(Dq, "ErrorBoundary", () => TA);
var Rq = {};
gd(Rq, "ErrorBoundaryContext", () => am);
const am = Mr(null), Uv = {
  didCatch: !1,
  error: null
};
class TA extends Pl {
  constructor() {
    super(...arguments), cw(this, "state", Uv), cw(this, "resetErrorBoundary", (...e) => {
      var r, n;
      const { error: i } = this.state;
      i !== null && ((n = (r = this.props).onReset) == null || n.call(r, {
        args: e,
        reason: "imperative-api"
      }), this.setState(Uv));
    });
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  componentDidCatch(e, r) {
    var n, i;
    (i = (n = this.props).onError) == null || i.call(n, e, r);
  }
  componentDidUpdate(e, r) {
    var n, i;
    const { didCatch: o } = this.state, { resetKeys: s } = this.props;
    o && r.error !== null && xq(e.resetKeys, s) && ((i = (n = this.props).onReset) == null || i.call(n, {
      next: s,
      prev: e.resetKeys,
      reason: "keys"
    }), this.setState(Uv));
  }
  render() {
    const { children: e, fallbackRender: r, FallbackComponent: n, fallback: i } = this.props, { didCatch: o, error: s } = this.state;
    let u = e;
    if (o) {
      const c = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (kl(i))
        u = i;
      else if (typeof r == "function")
        u = r(c);
      else if (n)
        u = Tr(n, c);
      else
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return Tr(am.Provider, {
      value: {
        didCatch: o,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, u);
  }
}
function xq(t = [], e = []) {
  return t.length !== e.length || t.some((r, n) => !Object.is(r, e[n]));
}
var Tq = {};
gd(Tq, "useErrorBoundary", () => kq);
function Pq(t) {
  if (t == null || typeof t.didCatch != "boolean" || typeof t.resetErrorBoundary != "function")
    throw new Error("ErrorBoundaryContext not found");
  return !0;
}
function kq() {
  const t = ca(am);
  Pq(t);
  const [e, r] = Jo({
    error: null,
    hasError: !1
  }), n = Zo(() => ({
    resetBoundary: () => {
      t == null || t.resetErrorBoundary(), r({
        error: null,
        hasError: !1
      });
    },
    showBoundary: (i) => r({
      error: i,
      hasError: !0
    })
  }), [
    t == null ? void 0 : t.resetErrorBoundary
  ]);
  if (e.hasError)
    throw e.error;
  return n;
}
var Cq = {};
gd(Cq, "withErrorBoundary", () => jq);
function jq(t, e) {
  const r = Cl((i, o) => Tr(TA, e, Tr(t, {
    ...i,
    ref: o
  }))), n = t.displayName || t.name || "Unknown";
  return r.displayName = `withErrorBoundary(${n})`, r;
}
Mr({
  productKey: void 0,
  locationPathName: "",
  setLocationPathName: () => {
  },
  aptrinsic: () => {
  },
  logDebug: () => {
  },
  isInitialized: !1,
  initialize: () => {
  }
});
var um = /* @__PURE__ */ ((t) => (t.EN = "en", t.FR = "fr", t))(um || {});
class bd {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    const r = {
      listener: e
    };
    return this.listeners.add(r), this.onSubscribe(), () => {
      this.listeners.delete(r), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const cm = typeof window > "u" || "Deno" in window;
function yo() {
}
function qq(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Mq(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function Fq(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function qh(t, e, r) {
  return wd(t) ? typeof e == "function" ? {
    ...r,
    queryKey: t,
    queryFn: e
  } : {
    ...e,
    queryKey: t
  } : t;
}
function va(t, e, r) {
  return wd(t) ? [{
    ...e,
    queryKey: t
  }, r] : [t || {}, e];
}
function dw(t, e) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: i,
    predicate: o,
    queryKey: s,
    stale: u
  } = t;
  if (wd(s)) {
    if (n) {
      if (e.queryHash !== fm(s, e.options))
        return !1;
    } else if (!Nu(e.queryKey, s))
      return !1;
  }
  if (r !== "all") {
    const c = e.isActive();
    if (r === "active" && !c || r === "inactive" && c)
      return !1;
  }
  return !(typeof u == "boolean" && e.isStale() !== u || typeof i < "u" && i !== e.state.fetchStatus || o && !o(e));
}
function vw(t, e) {
  const {
    exact: r,
    fetching: n,
    predicate: i,
    mutationKey: o
  } = t;
  if (wd(o)) {
    if (!e.options.mutationKey)
      return !1;
    if (r) {
      if (eu(e.options.mutationKey) !== eu(o))
        return !1;
    } else if (!Nu(e.options.mutationKey, o))
      return !1;
  }
  return !(typeof n == "boolean" && e.state.status === "loading" !== n || i && !i(e));
}
function fm(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || eu)(t);
}
function eu(t) {
  return JSON.stringify(t, (e, r) => Wy(r) ? Object.keys(r).sort().reduce((n, i) => (n[i] = r[i], n), {}) : r);
}
function Nu(t, e) {
  return PA(t, e);
}
function PA(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((r) => !PA(t[r], e[r])) : !1;
}
function kA(t, e) {
  if (t === e)
    return t;
  const r = yw(t) && yw(e);
  if (r || Wy(t) && Wy(e)) {
    const n = r ? t.length : Object.keys(t).length, i = r ? e : Object.keys(e), o = i.length, s = r ? [] : {};
    let u = 0;
    for (let c = 0; c < o; c++) {
      const a = r ? c : i[c];
      s[a] = kA(t[a], e[a]), s[a] === t[a] && u++;
    }
    return n === o && u === n ? t : s;
  }
  return e;
}
function yw(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function Wy(t) {
  if (!_w(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const r = e.prototype;
  return !(!_w(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function _w(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function wd(t) {
  return Array.isArray(t);
}
function CA(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function mw(t) {
  CA(0).then(t);
}
function Nq() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function zq(t, e, r) {
  return r.isDataEqual != null && r.isDataEqual(t, e) ? t : typeof r.structuralSharing == "function" ? r.structuralSharing(t, e) : r.structuralSharing !== !1 ? kA(t, e) : e;
}
class Lq extends bd {
  constructor() {
    super(), this.setup = (e) => {
      if (!cm && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("visibilitychange", r, !1), window.addEventListener("focus", r, !1), () => {
          window.removeEventListener("visibilitychange", r), window.removeEventListener("focus", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused = e, e && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const Hy = new Lq();
class Uq extends bd {
  constructor() {
    super(), this.setup = (e) => {
      if (!cm && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("online", r, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setOnline(n) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online = e, e && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const Pp = new Uq();
function Bq(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function lm(t) {
  return (t ?? "online") === "online" ? Pp.isOnline() : !0;
}
class jA {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
}
function Bv(t) {
  return t instanceof jA;
}
function qA(t) {
  let e = !1, r = 0, n = !1, i, o, s;
  const u = new Promise((b, O) => {
    o = b, s = O;
  }), c = (b) => {
    n || (d(new jA(b)), t.abort == null || t.abort());
  }, a = () => {
    e = !0;
  }, f = () => {
    e = !1;
  }, h = () => !Hy.isFocused() || t.networkMode !== "always" && !Pp.isOnline(), p = (b) => {
    n || (n = !0, t.onSuccess == null || t.onSuccess(b), i == null || i(), o(b));
  }, d = (b) => {
    n || (n = !0, t.onError == null || t.onError(b), i == null || i(), s(b));
  }, _ = () => new Promise((b) => {
    i = (O) => {
      const S = n || !h();
      return S && b(O), S;
    }, t.onPause == null || t.onPause();
  }).then(() => {
    i = void 0, n || t.onContinue == null || t.onContinue();
  }), m = () => {
    if (n)
      return;
    let b;
    try {
      b = t.fn();
    } catch (O) {
      b = Promise.reject(O);
    }
    Promise.resolve(b).then(p).catch((O) => {
      var S, k;
      if (n)
        return;
      const T = (S = t.retry) != null ? S : 3, x = (k = t.retryDelay) != null ? k : Bq, P = typeof x == "function" ? x(r, O) : x, R = T === !0 || typeof T == "number" && r < T || typeof T == "function" && T(r, O);
      if (e || !R) {
        d(O);
        return;
      }
      r++, t.onFail == null || t.onFail(r, O), CA(P).then(() => {
        if (h())
          return _();
      }).then(() => {
        e ? d(O) : m();
      });
    });
  };
  return lm(t.networkMode) ? m() : _().then(m), {
    promise: u,
    cancel: c,
    continue: () => i != null && i() ? u : Promise.resolve(),
    cancelRetry: a,
    continueRetry: f
  };
}
const hm = console;
function $q() {
  let t = [], e = 0, r = (c) => {
    c();
  }, n = (c) => {
    c();
  };
  const i = (c) => {
    let a;
    e++;
    try {
      a = c();
    } finally {
      e--, e || u();
    }
    return a;
  }, o = (c) => {
    e ? t.push(c) : mw(() => {
      r(c);
    });
  }, s = (c) => (...a) => {
    o(() => {
      c(...a);
    });
  }, u = () => {
    const c = t;
    t = [], c.length && mw(() => {
      n(() => {
        c.forEach((a) => {
          r(a);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: s,
    schedule: o,
    setNotifyFunction: (c) => {
      r = c;
    },
    setBatchNotifyFunction: (c) => {
      n = c;
    }
  };
}
const Pn = $q();
class MA {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Mq(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (cm ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class Kq extends MA {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || hm, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || Vq(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, r) {
    const n = zq(this.state.data, e, this.options);
    return this.dispatch({
      data: n,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), n;
  }
  setState(e, r) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: r
    });
  }
  cancel(e) {
    var r;
    const n = this.promise;
    return (r = this.retryer) == null || r.cancel(e), n ? n.then(yo).catch(yo) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !Fq(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnReconnect());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.indexOf(e) !== -1 && (this.observers = this.observers.filter((r) => r !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, r) {
    var n, i;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && r != null && r.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var o;
        return (o = this.retryer) == null || o.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const d = this.observers.find((_) => _.options.queryFn);
      d && this.setOptions(d.options);
    }
    Array.isArray(this.options.queryKey) || process.env.NODE_ENV !== "production" && this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
    const s = Nq(), u = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, c = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => {
          if (s)
            return this.abortSignalConsumed = !0, s.signal;
        }
      });
    };
    c(u);
    const a = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(u)) : Promise.reject("Missing queryFn"), f = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: a
    };
    if (c(f), (n = this.options.behavior) == null || n.onFetch(f), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((i = f.fetchOptions) == null ? void 0 : i.meta)) {
      var h;
      this.dispatch({
        type: "fetch",
        meta: (h = f.fetchOptions) == null ? void 0 : h.meta
      });
    }
    const p = (d) => {
      if (Bv(d) && d.silent || this.dispatch({
        type: "error",
        error: d
      }), !Bv(d)) {
        var _, m, b, O;
        (_ = (m = this.cache.config).onError) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, this.state.data, d, this), process.env.NODE_ENV !== "production" && this.logger.error(d);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = qA({
      fn: f.fetchFn,
      abort: s == null ? void 0 : s.abort.bind(s),
      onSuccess: (d) => {
        var _, m, b, O;
        if (typeof d > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), p(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(d), (_ = (m = this.cache.config).onSuccess) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, d, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: p,
      onFail: (d, _) => {
        this.dispatch({
          type: "failed",
          failureCount: d,
          error: _
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: f.options.retry,
      retryDelay: f.options.retryDelay,
      networkMode: f.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const r = (n) => {
      var i, o;
      switch (e.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (i = e.meta) != null ? i : null,
            fetchStatus: lm(this.options.networkMode) ? "fetching" : "paused",
            ...!n.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...n,
            data: e.data,
            dataUpdateCount: n.dataUpdateCount + 1,
            dataUpdatedAt: (o = e.dataUpdatedAt) != null ? o : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const s = e.error;
          return Bv(s) && s.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...n,
            error: s,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: s,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), Pn.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
}
function Vq(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = typeof e < "u", n = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class Qq extends bd {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, r, n) {
    var i;
    const o = r.queryKey, s = (i = r.queryHash) != null ? i : fm(o, r);
    let u = this.get(s);
    return u || (u = new Kq({
      cache: this,
      logger: e.getLogger(),
      queryKey: o,
      queryHash: s,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(o)
    }), this.add(u)), u;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = this.queriesMap[e.queryHash];
    r && (e.destroy(), this.queries = this.queries.filter((n) => n !== e), r === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    Pn.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  find(e, r) {
    const [n] = va(e, r);
    return typeof n.exact > "u" && (n.exact = !0), this.queries.find((i) => dw(n, i));
  }
  findAll(e, r) {
    const [n] = va(e, r);
    return Object.keys(n).length > 0 ? this.queries.filter((i) => dw(n, i)) : this.queries;
  }
  notify(e) {
    Pn.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  onFocus() {
    Pn.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    Pn.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
class Yq extends MA {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || hm, this.observers = [], this.state = e.state || Gq(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((r) => r !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, r;
    return (e = (r = this.retryer) == null ? void 0 : r.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var R;
      return this.retryer = qA({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (D, I) => {
          this.dispatch({
            type: "failed",
            failureCount: D,
            error: I
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (R = this.options.retry) != null ? R : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, r = this.state.status === "loading";
    try {
      var n, i, o, s, u, c, a, f;
      if (!r) {
        var h, p, d, _;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((h = (p = this.mutationCache.config).onMutate) == null ? void 0 : h.call(p, this.state.variables, this));
        const D = await ((d = (_ = this.options).onMutate) == null ? void 0 : d.call(_, this.state.variables));
        D !== this.state.context && this.dispatch({
          type: "loading",
          context: D,
          variables: this.state.variables
        });
      }
      const R = await e();
      return await ((n = (i = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(i, R, this.state.variables, this.state.context, this)), await ((o = (s = this.options).onSuccess) == null ? void 0 : o.call(s, R, this.state.variables, this.state.context)), await ((u = (c = this.mutationCache.config).onSettled) == null ? void 0 : u.call(c, R, null, this.state.variables, this.state.context, this)), await ((a = (f = this.options).onSettled) == null ? void 0 : a.call(f, R, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: R
      }), R;
    } catch (R) {
      try {
        var m, b, O, S, k, T, x, P;
        throw await ((m = (b = this.mutationCache.config).onError) == null ? void 0 : m.call(b, R, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(R), await ((O = (S = this.options).onError) == null ? void 0 : O.call(S, R, this.state.variables, this.state.context)), await ((k = (T = this.mutationCache.config).onSettled) == null ? void 0 : k.call(T, void 0, R, this.state.variables, this.state.context, this)), await ((x = (P = this.options).onSettled) == null ? void 0 : x.call(P, void 0, R, this.state.variables, this.state.context)), R;
      } finally {
        this.dispatch({
          type: "error",
          error: R
        });
      }
    }
  }
  dispatch(e) {
    const r = (n) => {
      switch (e.type) {
        case "failed":
          return {
            ...n,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "loading":
          return {
            ...n,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !lm(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...n,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: e.error,
            failureCount: n.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), Pn.batch(() => {
      this.observers.forEach((n) => {
        n.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function Gq() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class Wq extends bd {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, r, n) {
    const i = new Yq({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(r),
      state: n,
      defaultOptions: r.mutationKey ? e.getMutationDefaults(r.mutationKey) : void 0
    });
    return this.add(i), i;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((r) => r !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    Pn.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((r) => vw(e, r));
  }
  findAll(e) {
    return this.mutations.filter((r) => vw(e, r));
  }
  notify(e) {
    Pn.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const r = this.mutations.filter((n) => n.state.isPaused);
      return Pn.batch(() => r.reduce((n, i) => n.then(() => i.continue().catch(yo)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function Hq() {
  return {
    onFetch: (t) => {
      t.fetchFn = () => {
        var e, r, n, i, o, s;
        const u = (e = t.fetchOptions) == null || (r = e.meta) == null ? void 0 : r.refetchPage, c = (n = t.fetchOptions) == null || (i = n.meta) == null ? void 0 : i.fetchMore, a = c == null ? void 0 : c.pageParam, f = (c == null ? void 0 : c.direction) === "forward", h = (c == null ? void 0 : c.direction) === "backward", p = ((o = t.state.data) == null ? void 0 : o.pages) || [], d = ((s = t.state.data) == null ? void 0 : s.pageParams) || [];
        let _ = d, m = !1;
        const b = (x) => {
          Object.defineProperty(x, "signal", {
            enumerable: !0,
            get: () => {
              var P;
              if ((P = t.signal) != null && P.aborted)
                m = !0;
              else {
                var R;
                (R = t.signal) == null || R.addEventListener("abort", () => {
                  m = !0;
                });
              }
              return t.signal;
            }
          });
        }, O = t.options.queryFn || (() => Promise.reject("Missing queryFn")), S = (x, P, R, D) => (_ = D ? [P, ..._] : [..._, P], D ? [R, ...x] : [...x, R]), k = (x, P, R, D) => {
          if (m)
            return Promise.reject("Cancelled");
          if (typeof R > "u" && !P && x.length)
            return Promise.resolve(x);
          const I = {
            queryKey: t.queryKey,
            pageParam: R,
            meta: t.options.meta
          };
          b(I);
          const j = O(I);
          return Promise.resolve(j).then((Y) => S(x, R, Y, D));
        };
        let T;
        if (!p.length)
          T = k([]);
        else if (f) {
          const x = typeof a < "u", P = x ? a : gw(t.options, p);
          T = k(p, x, P);
        } else if (h) {
          const x = typeof a < "u", P = x ? a : Jq(t.options, p);
          T = k(p, x, P, !0);
        } else {
          _ = [];
          const x = typeof t.options.getNextPageParam > "u";
          T = !(u && p[0]) || u(p[0], 0, p) ? k([], x, d[0]) : Promise.resolve(S([], d[0], p[0]));
          for (let P = 1; P < p.length; P++)
            T = T.then((R) => {
              if (!(u && p[P]) || u(p[P], P, p)) {
                const D = x ? d[P] : gw(t.options, R);
                return k(R, x, D);
              }
              return Promise.resolve(S(R, d[P], p[P]));
            });
        }
        return T.then((x) => ({
          pages: x,
          pageParams: _
        }));
      };
    }
  };
}
function gw(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}
function Jq(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}
class Zq {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new Qq(), this.mutationCache = e.mutationCache || new Wq(), this.logger = e.logger || hm, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && e.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = Hy.subscribe(() => {
      Hy.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = Pp.subscribe(() => {
      Pp.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, r;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (r = this.unsubscribeOnline) == null || r.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(e, r) {
    const [n] = va(e, r);
    return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  getQueryData(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e, r, n) {
    const i = qh(e, r, n), o = this.getQueryData(i.queryKey);
    return o ? Promise.resolve(o) : this.fetchQuery(i);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: r,
      state: n
    }) => {
      const i = n.data;
      return [r, i];
    });
  }
  setQueryData(e, r, n) {
    const i = this.queryCache.find(e), o = i == null ? void 0 : i.state.data, s = qq(r, o);
    if (typeof s > "u")
      return;
    const u = qh(e), c = this.defaultQueryOptions(u);
    return this.queryCache.build(this, c).setData(s, {
      ...n,
      manual: !0
    });
  }
  setQueriesData(e, r, n) {
    return Pn.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: i
    }) => [i, this.setQueryData(i, r, n)]));
  }
  getQueryState(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state;
  }
  removeQueries(e, r) {
    const [n] = va(e, r), i = this.queryCache;
    Pn.batch(() => {
      i.findAll(n).forEach((o) => {
        i.remove(o);
      });
    });
  }
  resetQueries(e, r, n) {
    const [i, o] = va(e, r, n), s = this.queryCache, u = {
      type: "active",
      ...i
    };
    return Pn.batch(() => (s.findAll(i).forEach((c) => {
      c.reset();
    }), this.refetchQueries(u, o)));
  }
  cancelQueries(e, r, n) {
    const [i, o = {}] = va(e, r, n);
    typeof o.revert > "u" && (o.revert = !0);
    const s = Pn.batch(() => this.queryCache.findAll(i).map((u) => u.cancel(o)));
    return Promise.all(s).then(yo).catch(yo);
  }
  invalidateQueries(e, r, n) {
    const [i, o] = va(e, r, n);
    return Pn.batch(() => {
      var s, u;
      if (this.queryCache.findAll(i).forEach((a) => {
        a.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const c = {
        ...i,
        type: (s = (u = i.refetchType) != null ? u : i.type) != null ? s : "active"
      };
      return this.refetchQueries(c, o);
    });
  }
  refetchQueries(e, r, n) {
    const [i, o] = va(e, r, n), s = Pn.batch(() => this.queryCache.findAll(i).filter((c) => !c.isDisabled()).map((c) => {
      var a;
      return c.fetch(void 0, {
        ...o,
        cancelRefetch: (a = o == null ? void 0 : o.cancelRefetch) != null ? a : !0,
        meta: {
          refetchPage: i.refetchPage
        }
      });
    }));
    let u = Promise.all(s).then(yo);
    return o != null && o.throwOnError || (u = u.catch(yo)), u;
  }
  fetchQuery(e, r, n) {
    const i = qh(e, r, n), o = this.defaultQueryOptions(i);
    typeof o.retry > "u" && (o.retry = !1);
    const s = this.queryCache.build(this, o);
    return s.isStaleByTime(o.staleTime) ? s.fetch(o) : Promise.resolve(s.state.data);
  }
  prefetchQuery(e, r, n) {
    return this.fetchQuery(e, r, n).then(yo).catch(yo);
  }
  fetchInfiniteQuery(e, r, n) {
    const i = qh(e, r, n);
    return i.behavior = Hq(), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(e, r, n) {
    return this.fetchInfiniteQuery(e, r, n).then(yo).catch(yo);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, r) {
    const n = this.queryDefaults.find((i) => eu(e) === eu(i.queryKey));
    n ? n.defaultOptions = r : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: r
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const r = this.queryDefaults.find((n) => Nu(e, n.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((n) => Nu(e, n.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(e) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), r == null ? void 0 : r.defaultOptions;
  }
  setMutationDefaults(e, r) {
    const n = this.mutationDefaults.find((i) => eu(e) === eu(i.mutationKey));
    n ? n.defaultOptions = r : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: r
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const r = this.mutationDefaults.find((n) => Nu(e, n.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((n) => Nu(e, n.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(e) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), r == null ? void 0 : r.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const r = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e == null ? void 0 : e.queryKey),
      ...e,
      _defaulted: !0
    };
    return !r.queryHash && r.queryKey && (r.queryHash = fm(r.queryKey, r)), typeof r.refetchOnReconnect > "u" && (r.refetchOnReconnect = r.networkMode !== "always"), typeof r.useErrorBoundary > "u" && (r.useErrorBoundary = !!r.suspense), r;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e == null ? void 0 : e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
var Jy = { exports: {} }, $v = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bw;
function Xq() {
  if (bw)
    return $v;
  bw = 1;
  var t = Se;
  function e(h, p) {
    return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, i = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
  function u(h, p) {
    var d = p(), _ = n({ inst: { value: d, getSnapshot: p } }), m = _[0].inst, b = _[1];
    return o(function() {
      m.value = d, m.getSnapshot = p, c(m) && b({ inst: m });
    }, [h, d, p]), i(function() {
      return c(m) && b({ inst: m }), h(function() {
        c(m) && b({ inst: m });
      });
    }, [h]), s(d), d;
  }
  function c(h) {
    var p = h.getSnapshot;
    h = h.value;
    try {
      var d = p();
      return !r(h, d);
    } catch {
      return !0;
    }
  }
  function a(h, p) {
    return p();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : u;
  return $v.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : f, $v;
}
var ww = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ew;
function tM() {
  return Ew || (Ew = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Se, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(k) {
      {
        for (var T = arguments.length, x = new Array(T > 1 ? T - 1 : 0), P = 1; P < T; P++)
          x[P - 1] = arguments[P];
        n("error", k, x);
      }
    }
    function n(k, T, x) {
      {
        var P = e.ReactDebugCurrentFrame, R = P.getStackAddendum();
        R !== "" && (T += "%s", x = x.concat([R]));
        var D = x.map(function(I) {
          return String(I);
        });
        D.unshift("Warning: " + T), Function.prototype.apply.call(console[k], console, D);
      }
    }
    function i(k, T) {
      return k === T && (k !== 0 || 1 / k === 1 / T) || k !== k && T !== T;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = t.useState, u = t.useEffect, c = t.useLayoutEffect, a = t.useDebugValue, f = !1, h = !1;
    function p(k, T, x) {
      f || t.startTransition !== void 0 && (f = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var P = T();
      if (!h) {
        var R = T();
        o(P, R) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), h = !0);
      }
      var D = s({
        inst: {
          value: P,
          getSnapshot: T
        }
      }), I = D[0].inst, j = D[1];
      return c(function() {
        I.value = P, I.getSnapshot = T, d(I) && j({
          inst: I
        });
      }, [k, P, T]), u(function() {
        d(I) && j({
          inst: I
        });
        var Y = function() {
          d(I) && j({
            inst: I
          });
        };
        return k(Y);
      }, [k]), a(P), P;
    }
    function d(k) {
      var T = k.getSnapshot, x = k.value;
      try {
        var P = T();
        return !o(x, P);
      } catch {
        return !0;
      }
    }
    function _(k, T, x) {
      return T();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", b = !m, O = b ? _ : p, S = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : O;
    ww.useSyncExternalStore = S, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ww;
}
process.env.NODE_ENV === "production" ? Jy.exports = Xq() : Jy.exports = tM();
var eM = Jy.exports;
eM.useSyncExternalStore;
const rM = /* @__PURE__ */ Yr.createContext(!1);
rM.Provider;
new Zq();
Mr(void 0);
function _u(t) {
  function e(r, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = r, this.code = n;
  }
  return e.prototype = new Error(), e.prototype.name = t, e.prototype.constructor = e, e;
}
const nM = _u("LaunchDarklyUnexpectedResponseError"), iM = _u("LaunchDarklyInvalidEnvironmentIdError"), oM = _u("LaunchDarklyInvalidUserError"), sM = _u("LaunchDarklyInvalidEventKeyError"), aM = _u("LaunchDarklyInvalidArgumentError"), uM = _u("LaunchDarklyFlagFetchError");
for (var _B = { LDUnexpectedResponseError: nM, LDInvalidEnvironmentIdError: iM, LDInvalidUserError: oM, LDInvalidEventKeyError: sM, LDInvalidArgumentError: aM, LDInvalidDataError: _u("LaunchDarklyInvalidDataError"), LDFlagFetchError: uM, isHttpErrorRecoverable: function(t) {
  return !(t >= 400 && t < 500) || t === 400 || t === 408 || t === 429;
} }, mB = function(t) {
  var e = Sw(t), r = e[0], n = e[1];
  return 3 * (r + n) / 4 - n;
}, gB = function(t) {
  var e, r, n = Sw(t), i = n[0], o = n[1], s = new cM(function(a, f, h) {
    return 3 * (f + h) / 4 - h;
  }(0, i, o)), u = 0, c = o > 0 ? i - 4 : i;
  for (r = 0; r < c; r += 4)
    e = Mi[t.charCodeAt(r)] << 18 | Mi[t.charCodeAt(r + 1)] << 12 | Mi[t.charCodeAt(r + 2)] << 6 | Mi[t.charCodeAt(r + 3)], s[u++] = e >> 16 & 255, s[u++] = e >> 8 & 255, s[u++] = 255 & e;
  return o === 2 && (e = Mi[t.charCodeAt(r)] << 2 | Mi[t.charCodeAt(r + 1)] >> 4, s[u++] = 255 & e), o === 1 && (e = Mi[t.charCodeAt(r)] << 10 | Mi[t.charCodeAt(r + 1)] << 4 | Mi[t.charCodeAt(r + 2)] >> 2, s[u++] = e >> 8 & 255, s[u++] = 255 & e), s;
}, bB = function(t) {
  for (var e, r = t.length, n = r % 3, i = [], o = 16383, s = 0, u = r - n; s < u; s += o)
    i.push(lM(t, s, s + o > u ? u : s + o));
  return n === 1 ? (e = t[r - 1], i.push(Bo[e >> 2] + Bo[e << 4 & 63] + "==")) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(Bo[e >> 10] + Bo[e >> 4 & 63] + Bo[e << 2 & 63] + "=")), i.join("");
}, Bo = [], Mi = [], cM = typeof Uint8Array < "u" ? Uint8Array : Array, Kv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ku = 0, fM = Kv.length; ku < fM; ++ku)
  Bo[ku] = Kv[ku], Mi[Kv.charCodeAt(ku)] = ku;
function Sw(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  return r === -1 && (r = e), [r, r === e ? 0 : 4 - r % 4];
}
function lM(t, e, r) {
  for (var n, i, o = [], s = e; s < r; s += 3)
    n = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), o.push(Bo[(i = n) >> 18 & 63] + Bo[i >> 12 & 63] + Bo[i >> 6 & 63] + Bo[63 & i]);
  return o.join("");
}
Mi["-".charCodeAt(0)] = 62, Mi["_".charCodeAt(0)] = 63;
var hM = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function FA(t) {
  return typeof t == "string" && hM.test(t);
}
for (var wB, EB, Hr = [], Vv = 0; Vv < 256; ++Vv)
  Hr.push((Vv + 256).toString(16).substr(1));
function pM(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Hr[t[e + 0]] + Hr[t[e + 1]] + Hr[t[e + 2]] + Hr[t[e + 3]] + "-" + Hr[t[e + 4]] + Hr[t[e + 5]] + "-" + Hr[t[e + 6]] + Hr[t[e + 7]] + "-" + Hr[t[e + 8]] + Hr[t[e + 9]] + "-" + Hr[t[e + 10]] + Hr[t[e + 11]] + Hr[t[e + 12]] + Hr[t[e + 13]] + Hr[t[e + 14]] + Hr[t[e + 15]]).toLowerCase();
  if (!FA(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function dM(t) {
  if (!FA(t))
    throw TypeError("Invalid UUID");
  var e, r = new Uint8Array(16);
  return r[0] = (e = parseInt(t.slice(0, 8), 16)) >>> 24, r[1] = e >>> 16 & 255, r[2] = e >>> 8 & 255, r[3] = 255 & e, r[4] = (e = parseInt(t.slice(9, 13), 16)) >>> 8, r[5] = 255 & e, r[6] = (e = parseInt(t.slice(14, 18), 16)) >>> 8, r[7] = 255 & e, r[8] = (e = parseInt(t.slice(19, 23), 16)) >>> 8, r[9] = 255 & e, r[10] = (e = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = e / 4294967296 & 255, r[12] = e >>> 24 & 255, r[13] = e >>> 16 & 255, r[14] = e >>> 8 & 255, r[15] = 255 & e, r;
}
function NA(t, e, r) {
  function n(i, o, s, u) {
    if (typeof i == "string" && (i = function(f) {
      f = unescape(encodeURIComponent(f));
      for (var h = [], p = 0; p < f.length; ++p)
        h.push(f.charCodeAt(p));
      return h;
    }(i)), typeof o == "string" && (o = dM(o)), o.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + i.length);
    if (c.set(o), c.set(i, o.length), (c = r(c))[6] = 15 & c[6] | e, c[8] = 63 & c[8] | 128, s) {
      u = u || 0;
      for (var a = 0; a < 16; ++a)
        s[u + a] = c[a];
      return s;
    }
    return pM(c);
  }
  try {
    n.name = t;
  } catch {
  }
  return n.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", n.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", n;
}
function Ow(t) {
  return 14 + (t + 64 >>> 9 << 4) + 1;
}
function Sa(t, e) {
  var r = (65535 & t) + (65535 & e);
  return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
}
function Ed(t, e, r, n, i, o) {
  return Sa((s = Sa(Sa(e, t), Sa(n, o))) << (u = i) | s >>> 32 - u, r);
  var s, u;
}
function pn(t, e, r, n, i, o, s) {
  return Ed(e & r | ~e & n, t, e, i, o, s);
}
function dn(t, e, r, n, i, o, s) {
  return Ed(e & n | r & ~n, t, e, i, o, s);
}
function vn(t, e, r, n, i, o, s) {
  return Ed(e ^ r ^ n, t, e, i, o, s);
}
function yn(t, e, r, n, i, o, s) {
  return Ed(r ^ (e | ~n), t, e, i, o, s);
}
NA("v3", 48, function(t) {
  if (typeof t == "string") {
    var e = unescape(encodeURIComponent(t));
    t = new Uint8Array(e.length);
    for (var r = 0; r < e.length; ++r)
      t[r] = e.charCodeAt(r);
  }
  return function(n) {
    for (var i = [], o = 32 * n.length, s = "0123456789abcdef", u = 0; u < o; u += 8) {
      var c = n[u >> 5] >>> u % 32 & 255, a = parseInt(s.charAt(c >>> 4 & 15) + s.charAt(15 & c), 16);
      i.push(a);
    }
    return i;
  }(function(n, i) {
    n[i >> 5] |= 128 << i % 32, n[Ow(i) - 1] = i;
    for (var o = 1732584193, s = -271733879, u = -1732584194, c = 271733878, a = 0; a < n.length; a += 16) {
      var f = o, h = s, p = u, d = c;
      o = pn(o, s, u, c, n[a], 7, -680876936), c = pn(c, o, s, u, n[a + 1], 12, -389564586), u = pn(u, c, o, s, n[a + 2], 17, 606105819), s = pn(s, u, c, o, n[a + 3], 22, -1044525330), o = pn(o, s, u, c, n[a + 4], 7, -176418897), c = pn(c, o, s, u, n[a + 5], 12, 1200080426), u = pn(u, c, o, s, n[a + 6], 17, -1473231341), s = pn(s, u, c, o, n[a + 7], 22, -45705983), o = pn(o, s, u, c, n[a + 8], 7, 1770035416), c = pn(c, o, s, u, n[a + 9], 12, -1958414417), u = pn(u, c, o, s, n[a + 10], 17, -42063), s = pn(s, u, c, o, n[a + 11], 22, -1990404162), o = pn(o, s, u, c, n[a + 12], 7, 1804603682), c = pn(c, o, s, u, n[a + 13], 12, -40341101), u = pn(u, c, o, s, n[a + 14], 17, -1502002290), o = dn(o, s = pn(s, u, c, o, n[a + 15], 22, 1236535329), u, c, n[a + 1], 5, -165796510), c = dn(c, o, s, u, n[a + 6], 9, -1069501632), u = dn(u, c, o, s, n[a + 11], 14, 643717713), s = dn(s, u, c, o, n[a], 20, -373897302), o = dn(o, s, u, c, n[a + 5], 5, -701558691), c = dn(c, o, s, u, n[a + 10], 9, 38016083), u = dn(u, c, o, s, n[a + 15], 14, -660478335), s = dn(s, u, c, o, n[a + 4], 20, -405537848), o = dn(o, s, u, c, n[a + 9], 5, 568446438), c = dn(c, o, s, u, n[a + 14], 9, -1019803690), u = dn(u, c, o, s, n[a + 3], 14, -187363961), s = dn(s, u, c, o, n[a + 8], 20, 1163531501), o = dn(o, s, u, c, n[a + 13], 5, -1444681467), c = dn(c, o, s, u, n[a + 2], 9, -51403784), u = dn(u, c, o, s, n[a + 7], 14, 1735328473), o = vn(o, s = dn(s, u, c, o, n[a + 12], 20, -1926607734), u, c, n[a + 5], 4, -378558), c = vn(c, o, s, u, n[a + 8], 11, -2022574463), u = vn(u, c, o, s, n[a + 11], 16, 1839030562), s = vn(s, u, c, o, n[a + 14], 23, -35309556), o = vn(o, s, u, c, n[a + 1], 4, -1530992060), c = vn(c, o, s, u, n[a + 4], 11, 1272893353), u = vn(u, c, o, s, n[a + 7], 16, -155497632), s = vn(s, u, c, o, n[a + 10], 23, -1094730640), o = vn(o, s, u, c, n[a + 13], 4, 681279174), c = vn(c, o, s, u, n[a], 11, -358537222), u = vn(u, c, o, s, n[a + 3], 16, -722521979), s = vn(s, u, c, o, n[a + 6], 23, 76029189), o = vn(o, s, u, c, n[a + 9], 4, -640364487), c = vn(c, o, s, u, n[a + 12], 11, -421815835), u = vn(u, c, o, s, n[a + 15], 16, 530742520), o = yn(o, s = vn(s, u, c, o, n[a + 2], 23, -995338651), u, c, n[a], 6, -198630844), c = yn(c, o, s, u, n[a + 7], 10, 1126891415), u = yn(u, c, o, s, n[a + 14], 15, -1416354905), s = yn(s, u, c, o, n[a + 5], 21, -57434055), o = yn(o, s, u, c, n[a + 12], 6, 1700485571), c = yn(c, o, s, u, n[a + 3], 10, -1894986606), u = yn(u, c, o, s, n[a + 10], 15, -1051523), s = yn(s, u, c, o, n[a + 1], 21, -2054922799), o = yn(o, s, u, c, n[a + 8], 6, 1873313359), c = yn(c, o, s, u, n[a + 15], 10, -30611744), u = yn(u, c, o, s, n[a + 6], 15, -1560198380), s = yn(s, u, c, o, n[a + 13], 21, 1309151649), o = yn(o, s, u, c, n[a + 4], 6, -145523070), c = yn(c, o, s, u, n[a + 11], 10, -1120210379), u = yn(u, c, o, s, n[a + 2], 15, 718787259), s = yn(s, u, c, o, n[a + 9], 21, -343485551), o = Sa(o, f), s = Sa(s, h), u = Sa(u, p), c = Sa(c, d);
    }
    return [o, s, u, c];
  }(function(n) {
    if (n.length === 0)
      return [];
    for (var i = 8 * n.length, o = new Uint32Array(Ow(i)), s = 0; s < i; s += 8)
      o[s >> 5] |= (255 & n[s / 8]) << s % 32;
    return o;
  }(t), 8 * t.length));
});
function vM(t, e, r, n) {
  switch (t) {
    case 0:
      return e & r ^ ~e & n;
    case 1:
    case 3:
      return e ^ r ^ n;
    case 2:
      return e & r ^ e & n ^ r & n;
  }
}
function Qv(t, e) {
  return t << e | t >>> 32 - e;
}
NA("v5", 80, function(t) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var n = unescape(encodeURIComponent(t));
    t = [];
    for (var i = 0; i < n.length; ++i)
      t.push(n.charCodeAt(i));
  } else
    Array.isArray(t) || (t = Array.prototype.slice.call(t));
  t.push(128);
  for (var o = t.length / 4 + 2, s = Math.ceil(o / 16), u = new Array(s), c = 0; c < s; ++c) {
    for (var a = new Uint32Array(16), f = 0; f < 16; ++f)
      a[f] = t[64 * c + 4 * f] << 24 | t[64 * c + 4 * f + 1] << 16 | t[64 * c + 4 * f + 2] << 8 | t[64 * c + 4 * f + 3];
    u[c] = a;
  }
  u[s - 1][14] = 8 * (t.length - 1) / Math.pow(2, 32), u[s - 1][14] = Math.floor(u[s - 1][14]), u[s - 1][15] = 8 * (t.length - 1) & 4294967295;
  for (var h = 0; h < s; ++h) {
    for (var p = new Uint32Array(80), d = 0; d < 16; ++d)
      p[d] = u[h][d];
    for (var _ = 16; _ < 80; ++_)
      p[_] = Qv(p[_ - 3] ^ p[_ - 8] ^ p[_ - 14] ^ p[_ - 16], 1);
    for (var m = r[0], b = r[1], O = r[2], S = r[3], k = r[4], T = 0; T < 80; ++T) {
      var x = Math.floor(T / 20), P = Qv(m, 5) + vM(x, b, O, S) + k + e[x] + p[T] >>> 0;
      k = S, S = O, O = Qv(b, 30) >>> 0, b = m, m = P;
    }
    r[0] = r[0] + m >>> 0, r[1] = r[1] + b >>> 0, r[2] = r[2] + O >>> 0, r[3] = r[3] + S >>> 0, r[4] = r[4] + k >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, 255 & r[0], r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, 255 & r[1], r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, 255 & r[2], r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, 255 & r[3], r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, 255 & r[4]];
});
Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null });
const yM = (t, e) => e ?? !1;
Se.createContext({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  checkFlag: yM
});
var Hl = "delete", Ue = 5, Wi = 1 << Ue, Mn = Wi - 1, pe = {};
function Zy() {
  return { value: !1 };
}
function Hi(t) {
  t && (t.value = !0);
}
function pm() {
}
function oc(t) {
  return t.size === void 0 && (t.size = t.__iterate(zA)), t.size;
}
function qa(t, e) {
  if (typeof e != "number") {
    var r = e >>> 0;
    if ("" + r !== e || r === 4294967295)
      return NaN;
    e = r;
  }
  return e < 0 ? oc(t) + e : e;
}
function zA() {
  return !0;
}
function Sd(t, e, r) {
  return (t === 0 && !UA(t) || r !== void 0 && t <= -r) && (e === void 0 || r !== void 0 && e >= r);
}
function Jl(t, e) {
  return LA(t, e, 0);
}
function Od(t, e) {
  return LA(t, e, e);
}
function LA(t, e, r) {
  return t === void 0 ? r : UA(t) ? e === 1 / 0 ? e : Math.max(0, e + t) | 0 : e === void 0 || e === t ? t : Math.min(e, t) | 0;
}
function UA(t) {
  return t < 0 || t === 0 && 1 / t === -1 / 0;
}
var BA = "@@__IMMUTABLE_ITERABLE__@@";
function li(t) {
  return !!(t && t[BA]);
}
var $A = "@@__IMMUTABLE_KEYED__@@";
function dr(t) {
  return !!(t && t[$A]);
}
var KA = "@@__IMMUTABLE_INDEXED__@@";
function ii(t) {
  return !!(t && t[KA]);
}
function Id(t) {
  return dr(t) || ii(t);
}
var Ir = function(t) {
  return li(t) ? t : xi(t);
}, lo = /* @__PURE__ */ function(t) {
  function e(r) {
    return dr(r) ? r : $a(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Ir), mu = /* @__PURE__ */ function(t) {
  function e(r) {
    return ii(r) ? r : Fo(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Ir), Bc = /* @__PURE__ */ function(t) {
  function e(r) {
    return li(r) && !Id(r) ? r : Qc(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Ir);
Ir.Keyed = lo;
Ir.Indexed = mu;
Ir.Set = Bc;
var VA = "@@__IMMUTABLE_SEQ__@@";
function dm(t) {
  return !!(t && t[VA]);
}
var QA = "@@__IMMUTABLE_RECORD__@@";
function $c(t) {
  return !!(t && t[QA]);
}
function ns(t) {
  return li(t) || $c(t);
}
var Kc = "@@__IMMUTABLE_ORDERED__@@";
function Do(t) {
  return !!(t && t[Kc]);
}
var Zl = 0, ko = 1, so = 2, Xy = typeof Symbol == "function" && Symbol.iterator, YA = "@@iterator", Ad = Xy || YA, be = function(t) {
  this.next = t;
};
be.prototype.toString = function() {
  return "[Iterator]";
};
be.KEYS = Zl;
be.VALUES = ko;
be.ENTRIES = so;
be.prototype.inspect = be.prototype.toSource = function() {
  return this.toString();
};
be.prototype[Ad] = function() {
  return this;
};
function gr(t, e, r, n) {
  var i = t === 0 ? e : t === 1 ? r : [e, r];
  return n ? n.value = i : n = {
    value: i,
    done: !1
  }, n;
}
function hi() {
  return { value: void 0, done: !0 };
}
function GA(t) {
  return Array.isArray(t) ? !0 : !!Dd(t);
}
function Iw(t) {
  return t && typeof t.next == "function";
}
function t_(t) {
  var e = Dd(t);
  return e && e.call(t);
}
function Dd(t) {
  var e = t && (Xy && t[Xy] || t[YA]);
  if (typeof e == "function")
    return e;
}
function _M(t) {
  var e = Dd(t);
  return e && e === t.entries;
}
function mM(t) {
  var e = Dd(t);
  return e && e === t.keys;
}
var Vc = Object.prototype.hasOwnProperty;
function WA(t) {
  return Array.isArray(t) || typeof t == "string" ? !0 : t && typeof t == "object" && Number.isInteger(t.length) && t.length >= 0 && (t.length === 0 ? (
    // Only {length: 0} is considered Array-like.
    Object.keys(t).length === 1
  ) : (
    // An object is only Array-like if it has a property where the last value
    // in the array-like may be found (which could be undefined).
    t.hasOwnProperty(t.length - 1)
  ));
}
var xi = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? ym() : ns(r) ? r.toSeq() : bM(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, e.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, e.prototype.__iterate = function(r, n) {
    var i = this._cache;
    if (i) {
      for (var o = i.length, s = 0; s !== o; ) {
        var u = i[n ? o - ++s : s++];
        if (r(u[1], u[0], this) === !1)
          break;
      }
      return s;
    }
    return this.__iterateUncached(r, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._cache;
    if (i) {
      var o = i.length, s = 0;
      return new be(function() {
        if (s === o)
          return hi();
        var u = i[n ? o - ++s : s++];
        return gr(r, u[0], u[1]);
      });
    }
    return this.__iteratorUncached(r, n);
  }, e;
}(Ir), $a = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? ym().toKeyedSeq() : li(r) ? dr(r) ? r.toSeq() : r.fromEntrySeq() : $c(r) ? r.toSeq() : _m(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toKeyedSeq = function() {
    return this;
  }, e;
}(xi), Fo = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? ym() : li(r) ? dr(r) ? r.entrySeq() : r.toIndexedSeq() : $c(r) ? r.toSeq().entrySeq() : HA(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toIndexedSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, e;
}(xi), Qc = /* @__PURE__ */ function(t) {
  function e(r) {
    return (li(r) && !Id(r) ? r : Fo(r)).toSetSeq();
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toSetSeq = function() {
    return this;
  }, e;
}(xi);
xi.isSeq = dm;
xi.Keyed = $a;
xi.Set = Qc;
xi.Indexed = Fo;
xi.prototype[VA] = !0;
var su = /* @__PURE__ */ function(t) {
  function e(r) {
    this._array = r, this.size = r.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return this.has(r) ? this._array[qa(this, r)] : n;
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this._array, o = i.length, s = 0; s !== o; ) {
      var u = n ? o - ++s : s++;
      if (r(i[u], u, this) === !1)
        break;
    }
    return s;
  }, e.prototype.__iterator = function(r, n) {
    var i = this._array, o = i.length, s = 0;
    return new be(function() {
      if (s === o)
        return hi();
      var u = n ? o - ++s : s++;
      return gr(r, u, i[u]);
    });
  }, e;
}(Fo), vm = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = Object.keys(r).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(r) : []
    );
    this._object = r, this._keys = n, this.size = n.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return n !== void 0 && !this.has(r) ? n : this._object[r];
  }, e.prototype.has = function(r) {
    return Vc.call(this._object, r);
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this._object, o = this._keys, s = o.length, u = 0; u !== s; ) {
      var c = o[n ? s - ++u : u++];
      if (r(i[c], c, this) === !1)
        break;
    }
    return u;
  }, e.prototype.__iterator = function(r, n) {
    var i = this._object, o = this._keys, s = o.length, u = 0;
    return new be(function() {
      if (u === s)
        return hi();
      var c = o[n ? s - ++u : u++];
      return gr(r, c, i[c]);
    });
  }, e;
}($a);
vm.prototype[Kc] = !0;
var gM = /* @__PURE__ */ function(t) {
  function e(r) {
    this._collection = r, this.size = r.length || r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.__iterateUncached = function(r, n) {
    if (n)
      return this.cacheResult().__iterate(r, n);
    var i = this._collection, o = t_(i), s = 0;
    if (Iw(o))
      for (var u; !(u = o.next()).done && r(u.value, s++, this) !== !1; )
        ;
    return s;
  }, e.prototype.__iteratorUncached = function(r, n) {
    if (n)
      return this.cacheResult().__iterator(r, n);
    var i = this._collection, o = t_(i);
    if (!Iw(o))
      return new be(hi);
    var s = 0;
    return new be(function() {
      var u = o.next();
      return u.done ? u : gr(r, s++, u.value);
    });
  }, e;
}(Fo), Aw;
function ym() {
  return Aw || (Aw = new su([]));
}
function _m(t) {
  var e = mm(t);
  if (e)
    return e.fromEntrySeq();
  if (typeof t == "object")
    return new vm(t);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + t
  );
}
function HA(t) {
  var e = mm(t);
  if (e)
    return e;
  throw new TypeError(
    "Expected Array or collection object of values: " + t
  );
}
function bM(t) {
  var e = mm(t);
  if (e)
    return _M(t) ? e.fromEntrySeq() : mM(t) ? e.toSetSeq() : e;
  if (typeof t == "object")
    return new vm(t);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + t
  );
}
function mm(t) {
  return WA(t) ? new su(t) : GA(t) ? new gM(t) : void 0;
}
var JA = "@@__IMMUTABLE_MAP__@@";
function gm(t) {
  return !!(t && t[JA]);
}
function ZA(t) {
  return gm(t) && Do(t);
}
function Dw(t) {
  return !!(t && typeof t.equals == "function" && typeof t.hashCode == "function");
}
function Oi(t, e) {
  if (t === e || t !== t && e !== e)
    return !0;
  if (!t || !e)
    return !1;
  if (typeof t.valueOf == "function" && typeof e.valueOf == "function") {
    if (t = t.valueOf(), e = e.valueOf(), t === e || t !== t && e !== e)
      return !0;
    if (!t || !e)
      return !1;
  }
  return !!(Dw(t) && Dw(e) && t.equals(e));
}
var Ef = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(t, e) {
  t |= 0, e |= 0;
  var r = t & 65535, n = e & 65535;
  return r * n + ((t >>> 16) * n + r * (e >>> 16) << 16 >>> 0) | 0;
};
function Rd(t) {
  return t >>> 1 & 1073741824 | t & 3221225471;
}
var wM = Object.prototype.valueOf;
function gi(t) {
  if (t == null)
    return Rw(t);
  if (typeof t.hashCode == "function")
    return Rd(t.hashCode(t));
  var e = DM(t);
  if (e == null)
    return Rw(e);
  switch (typeof e) {
    case "boolean":
      return e ? 1108378657 : 1108378656;
    case "number":
      return EM(e);
    case "string":
      return e.length > RM ? SM(e) : e_(e);
    case "object":
    case "function":
      return IM(e);
    case "symbol":
      return OM(e);
    default:
      if (typeof e.toString == "function")
        return e_(e.toString());
      throw new Error("Value type " + typeof e + " cannot be hashed.");
  }
}
function Rw(t) {
  return t === null ? 1108378658 : (
    /* undefined */
    1108378659
  );
}
function EM(t) {
  if (t !== t || t === 1 / 0)
    return 0;
  var e = t | 0;
  for (e !== t && (e ^= t * 4294967295); t > 4294967295; )
    t /= 4294967295, e ^= t;
  return Rd(e);
}
function SM(t) {
  var e = Wv[t];
  return e === void 0 && (e = e_(t), Gv === xM && (Gv = 0, Wv = {}), Gv++, Wv[t] = e), e;
}
function e_(t) {
  for (var e = 0, r = 0; r < t.length; r++)
    e = 31 * e + t.charCodeAt(r) | 0;
  return Rd(e);
}
function OM(t) {
  var e = Pw[t];
  return e !== void 0 || (e = XA(), Pw[t] = e), e;
}
function IM(t) {
  var e;
  if (r_ && (e = n_.get(t), e !== void 0) || (e = t[Ha], e !== void 0) || !Tw && (e = t.propertyIsEnumerable && t.propertyIsEnumerable[Ha], e !== void 0 || (e = AM(t), e !== void 0)))
    return e;
  if (e = XA(), r_)
    n_.set(t, e);
  else {
    if (xw !== void 0 && xw(t) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (Tw)
      Object.defineProperty(t, Ha, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: e
      });
    else if (t.propertyIsEnumerable !== void 0 && t.propertyIsEnumerable === t.constructor.prototype.propertyIsEnumerable)
      t.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, t.propertyIsEnumerable[Ha] = e;
    else if (t.nodeType !== void 0)
      t[Ha] = e;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return e;
}
var xw = Object.isExtensible, Tw = function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
}();
function AM(t) {
  if (t && t.nodeType > 0)
    switch (t.nodeType) {
      case 1:
        return t.uniqueID;
      case 9:
        return t.documentElement && t.documentElement.uniqueID;
    }
}
function DM(t) {
  return t.valueOf !== wM && typeof t.valueOf == "function" ? t.valueOf(t) : t;
}
function XA() {
  var t = ++Yv;
  return Yv & 1073741824 && (Yv = 0), t;
}
var r_ = typeof WeakMap == "function", n_;
r_ && (n_ = /* @__PURE__ */ new WeakMap());
var Pw = /* @__PURE__ */ Object.create(null), Yv = 0, Ha = "__immutablehash__";
typeof Symbol == "function" && (Ha = Symbol(Ha));
var RM = 16, xM = 255, Gv = 0, Wv = {}, xd = /* @__PURE__ */ function(t) {
  function e(r, n) {
    this._iter = r, this._useKeys = n, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return this._iter.get(r, n);
  }, e.prototype.has = function(r) {
    return this._iter.has(r);
  }, e.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, e.prototype.reverse = function() {
    var r = this, n = bm(this, !0);
    return this._useKeys || (n.valueSeq = function() {
      return r._iter.toSeq().reverse();
    }), n;
  }, e.prototype.map = function(r, n) {
    var i = this, o = iD(this, r, n);
    return this._useKeys || (o.valueSeq = function() {
      return i._iter.toSeq().map(r, n);
    }), o;
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o, s) {
      return r(o, s, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    return this._iter.__iterator(r, n);
  }, e;
}($a);
xd.prototype[Kc] = !0;
var tD = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.includes = function(r) {
    return this._iter.includes(r);
  }, e.prototype.__iterate = function(r, n) {
    var i = this, o = 0;
    return n && oc(this), this._iter.__iterate(
      function(s) {
        return r(s, n ? i.size - ++o : o++, i);
      },
      n
    );
  }, e.prototype.__iterator = function(r, n) {
    var i = this, o = this._iter.__iterator(ko, n), s = 0;
    return n && oc(this), new be(function() {
      var u = o.next();
      return u.done ? u : gr(
        r,
        n ? i.size - ++s : s++,
        u.value,
        u
      );
    });
  }, e;
}(Fo), eD = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.has = function(r) {
    return this._iter.includes(r);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o) {
      return r(o, o, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._iter.__iterator(ko, n);
    return new be(function() {
      var o = i.next();
      return o.done ? o : gr(r, o.value, o.value, o);
    });
  }, e;
}(Qc), rD = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o) {
      if (o) {
        Cw(o);
        var s = li(o);
        return r(
          s ? o.get(1) : o[1],
          s ? o.get(0) : o[0],
          i
        );
      }
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._iter.__iterator(ko, n);
    return new be(function() {
      for (; ; ) {
        var o = i.next();
        if (o.done)
          return o;
        var s = o.value;
        if (s) {
          Cw(s);
          var u = li(s);
          return gr(
            r,
            u ? s.get(0) : s[0],
            u ? s.get(1) : s[1],
            o
          );
        }
      }
    });
  }, e;
}($a);
tD.prototype.cacheResult = xd.prototype.cacheResult = eD.prototype.cacheResult = rD.prototype.cacheResult = Sm;
function nD(t) {
  var e = is(t);
  return e._iter = t, e.size = t.size, e.flip = function() {
    return t;
  }, e.reverse = function() {
    var r = t.reverse.apply(this);
    return r.flip = function() {
      return t.reverse();
    }, r;
  }, e.has = function(r) {
    return t.includes(r);
  }, e.includes = function(r) {
    return t.has(r);
  }, e.cacheResult = Sm, e.__iterateUncached = function(r, n) {
    var i = this;
    return t.__iterate(function(o, s) {
      return r(s, o, i) !== !1;
    }, n);
  }, e.__iteratorUncached = function(r, n) {
    if (r === so) {
      var i = t.__iterator(r, n);
      return new be(function() {
        var o = i.next();
        if (!o.done) {
          var s = o.value[0];
          o.value[0] = o.value[1], o.value[1] = s;
        }
        return o;
      });
    }
    return t.__iterator(
      r === ko ? Zl : ko,
      n
    );
  }, e;
}
function iD(t, e, r) {
  var n = is(t);
  return n.size = t.size, n.has = function(i) {
    return t.has(i);
  }, n.get = function(i, o) {
    var s = t.get(i, pe);
    return s === pe ? o : e.call(r, s, i, t);
  }, n.__iterateUncached = function(i, o) {
    var s = this;
    return t.__iterate(
      function(u, c, a) {
        return i(e.call(r, u, c, a), c, s) !== !1;
      },
      o
    );
  }, n.__iteratorUncached = function(i, o) {
    var s = t.__iterator(so, o);
    return new be(function() {
      var u = s.next();
      if (u.done)
        return u;
      var c = u.value, a = c[0];
      return gr(
        i,
        a,
        e.call(r, c[1], a, t),
        u
      );
    });
  }, n;
}
function bm(t, e) {
  var r = this, n = is(t);
  return n._iter = t, n.size = t.size, n.reverse = function() {
    return t;
  }, t.flip && (n.flip = function() {
    var i = nD(t);
    return i.reverse = function() {
      return t.flip();
    }, i;
  }), n.get = function(i, o) {
    return t.get(e ? i : -1 - i, o);
  }, n.has = function(i) {
    return t.has(e ? i : -1 - i);
  }, n.includes = function(i) {
    return t.includes(i);
  }, n.cacheResult = Sm, n.__iterate = function(i, o) {
    var s = this, u = 0;
    return o && oc(t), t.__iterate(
      function(c, a) {
        return i(c, e ? a : o ? s.size - ++u : u++, s);
      },
      !o
    );
  }, n.__iterator = function(i, o) {
    var s = 0;
    o && oc(t);
    var u = t.__iterator(so, !o);
    return new be(function() {
      var c = u.next();
      if (c.done)
        return c;
      var a = c.value;
      return gr(
        i,
        e ? a[0] : o ? r.size - ++s : s++,
        a[1],
        c
      );
    });
  }, n;
}
function oD(t, e, r, n) {
  var i = is(t);
  return n && (i.has = function(o) {
    var s = t.get(o, pe);
    return s !== pe && !!e.call(r, s, o, t);
  }, i.get = function(o, s) {
    var u = t.get(o, pe);
    return u !== pe && e.call(r, u, o, t) ? u : s;
  }), i.__iterateUncached = function(o, s) {
    var u = this, c = 0;
    return t.__iterate(function(a, f, h) {
      if (e.call(r, a, f, h))
        return c++, o(a, n ? f : c - 1, u);
    }, s), c;
  }, i.__iteratorUncached = function(o, s) {
    var u = t.__iterator(so, s), c = 0;
    return new be(function() {
      for (; ; ) {
        var a = u.next();
        if (a.done)
          return a;
        var f = a.value, h = f[0], p = f[1];
        if (e.call(r, p, h, t))
          return gr(o, n ? h : c++, p, a);
      }
    });
  }, i;
}
function TM(t, e, r) {
  var n = Gc().asMutable();
  return t.__iterate(function(i, o) {
    n.update(e.call(r, i, o, t), 0, function(s) {
      return s + 1;
    });
  }), n.asImmutable();
}
function PM(t, e, r) {
  var n = dr(t), i = (Do(t) ? ia() : Gc()).asMutable();
  t.__iterate(function(s, u) {
    i.update(
      e.call(r, s, u, t),
      function(c) {
        return c = c || [], c.push(n ? [u, s] : s), c;
      }
    );
  });
  var o = Em(t);
  return i.map(function(s) {
    return Te(t, o(s));
  }).asImmutable();
}
function kM(t, e, r) {
  var n = dr(t), i = [[], []];
  t.__iterate(function(s, u) {
    i[e.call(r, s, u, t) ? 1 : 0].push(
      n ? [u, s] : s
    );
  });
  var o = Em(t);
  return i.map(function(s) {
    return Te(t, o(s));
  });
}
function wm(t, e, r, n) {
  var i = t.size;
  if (Sd(e, r, i))
    return t;
  var o = Jl(e, i), s = Od(r, i);
  if (o !== o || s !== s)
    return wm(t.toSeq().cacheResult(), e, r, n);
  var u = s - o, c;
  u === u && (c = u < 0 ? 0 : u);
  var a = is(t);
  return a.size = c === 0 ? c : t.size && c || void 0, !n && dm(t) && c >= 0 && (a.get = function(f, h) {
    return f = qa(this, f), f >= 0 && f < c ? t.get(f + o, h) : h;
  }), a.__iterateUncached = function(f, h) {
    var p = this;
    if (c === 0)
      return 0;
    if (h)
      return this.cacheResult().__iterate(f, h);
    var d = 0, _ = !0, m = 0;
    return t.__iterate(function(b, O) {
      if (!(_ && (_ = d++ < o)))
        return m++, f(b, n ? O : m - 1, p) !== !1 && m !== c;
    }), m;
  }, a.__iteratorUncached = function(f, h) {
    if (c !== 0 && h)
      return this.cacheResult().__iterator(f, h);
    if (c === 0)
      return new be(hi);
    var p = t.__iterator(f, h), d = 0, _ = 0;
    return new be(function() {
      for (; d++ < o; )
        p.next();
      if (++_ > c)
        return hi();
      var m = p.next();
      return n || f === ko || m.done ? m : f === Zl ? gr(f, _ - 1, void 0, m) : gr(f, _ - 1, m.value[1], m);
    });
  }, a;
}
function CM(t, e, r) {
  var n = is(t);
  return n.__iterateUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterate(i, o);
    var u = 0;
    return t.__iterate(
      function(c, a, f) {
        return e.call(r, c, a, f) && ++u && i(c, a, s);
      }
    ), u;
  }, n.__iteratorUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterator(i, o);
    var u = t.__iterator(so, o), c = !0;
    return new be(function() {
      if (!c)
        return hi();
      var a = u.next();
      if (a.done)
        return a;
      var f = a.value, h = f[0], p = f[1];
      return e.call(r, p, h, s) ? i === so ? a : gr(i, h, p, a) : (c = !1, hi());
    });
  }, n;
}
function sD(t, e, r, n) {
  var i = is(t);
  return i.__iterateUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterate(o, s);
    var c = !0, a = 0;
    return t.__iterate(function(f, h, p) {
      if (!(c && (c = e.call(r, f, h, p))))
        return a++, o(f, n ? h : a - 1, u);
    }), a;
  }, i.__iteratorUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterator(o, s);
    var c = t.__iterator(so, s), a = !0, f = 0;
    return new be(function() {
      var h, p, d;
      do {
        if (h = c.next(), h.done)
          return n || o === ko ? h : o === Zl ? gr(o, f++, void 0, h) : gr(o, f++, h.value[1], h);
        var _ = h.value;
        p = _[0], d = _[1], a && (a = e.call(r, d, p, u));
      } while (a);
      return o === so ? h : gr(o, p, d, h);
    });
  }, i;
}
function jM(t, e) {
  var r = dr(t), n = [t].concat(e).map(function(s) {
    return li(s) ? r && (s = lo(s)) : s = r ? _m(s) : HA(Array.isArray(s) ? s : [s]), s;
  }).filter(function(s) {
    return s.size !== 0;
  });
  if (n.length === 0)
    return t;
  if (n.length === 1) {
    var i = n[0];
    if (i === t || r && dr(i) || ii(t) && ii(i))
      return i;
  }
  var o = new su(n);
  return r ? o = o.toKeyedSeq() : ii(t) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = n.reduce(function(s, u) {
    if (s !== void 0) {
      var c = u.size;
      if (c !== void 0)
        return s + c;
    }
  }, 0), o;
}
function aD(t, e, r) {
  var n = is(t);
  return n.__iterateUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterate(i, o);
    var s = 0, u = !1;
    function c(a, f) {
      a.__iterate(function(h, p) {
        return (!e || f < e) && li(h) ? c(h, f + 1) : (s++, i(h, r ? p : s - 1, n) === !1 && (u = !0)), !u;
      }, o);
    }
    return c(t, 0), s;
  }, n.__iteratorUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterator(i, o);
    var s = t.__iterator(i, o), u = [], c = 0;
    return new be(function() {
      for (; s; ) {
        var a = s.next();
        if (a.done !== !1) {
          s = u.pop();
          continue;
        }
        var f = a.value;
        if (i === so && (f = f[1]), (!e || u.length < e) && li(f))
          u.push(s), s = f.__iterator(i, o);
        else
          return r ? a : gr(i, c++, f, a);
      }
      return hi();
    });
  }, n;
}
function qM(t, e, r) {
  var n = Em(t);
  return t.toSeq().map(function(i, o) {
    return n(e.call(r, i, o, t));
  }).flatten(!0);
}
function MM(t, e) {
  var r = is(t);
  return r.size = t.size && t.size * 2 - 1, r.__iterateUncached = function(n, i) {
    var o = this, s = 0;
    return t.__iterate(
      function(u) {
        return (!s || n(e, s++, o) !== !1) && n(u, s++, o) !== !1;
      },
      i
    ), s;
  }, r.__iteratorUncached = function(n, i) {
    var o = t.__iterator(ko, i), s = 0, u;
    return new be(function() {
      return (!u || s % 2) && (u = o.next(), u.done) ? u : s % 2 ? gr(n, s++, e) : gr(n, s++, u.value, u);
    });
  }, r;
}
function sc(t, e, r) {
  e || (e = uD);
  var n = dr(t), i = 0, o = t.toSeq().map(function(s, u) {
    return [u, s, i++, r ? r(s, u, t) : s];
  }).valueSeq().toArray();
  return o.sort(function(s, u) {
    return e(s[3], u[3]) || s[2] - u[2];
  }).forEach(
    n ? function(s, u) {
      o[u].length = 2;
    } : function(s, u) {
      o[u] = s[1];
    }
  ), n ? $a(o) : ii(t) ? Fo(o) : Qc(o);
}
function Mh(t, e, r) {
  if (e || (e = uD), r) {
    var n = t.toSeq().map(function(i, o) {
      return [i, r(i, o, t)];
    }).reduce(function(i, o) {
      return kw(e, i[1], o[1]) ? o : i;
    });
    return n && n[0];
  }
  return t.reduce(function(i, o) {
    return kw(e, i, o) ? o : i;
  });
}
function kw(t, e, r) {
  var n = t(r, e);
  return n === 0 && r !== e && (r == null || r !== r) || n > 0;
}
function Fh(t, e, r, n) {
  var i = is(t), o = new su(r).map(function(s) {
    return s.size;
  });
  return i.size = n ? o.max() : o.min(), i.__iterate = function(s, u) {
    for (var c = this.__iterator(ko, u), a, f = 0; !(a = c.next()).done && s(a.value, f++, this) !== !1; )
      ;
    return f;
  }, i.__iteratorUncached = function(s, u) {
    var c = r.map(
      function(h) {
        return h = Ir(h), t_(u ? h.reverse() : h);
      }
    ), a = 0, f = !1;
    return new be(function() {
      var h;
      return f || (h = c.map(function(p) {
        return p.next();
      }), f = n ? h.every(function(p) {
        return p.done;
      }) : h.some(function(p) {
        return p.done;
      })), f ? hi() : gr(
        s,
        a++,
        e.apply(
          null,
          h.map(function(p) {
            return p.value;
          })
        )
      );
    });
  }, i;
}
function Te(t, e) {
  return t === e ? t : dm(t) ? e : t.constructor(e);
}
function Cw(t) {
  if (t !== Object(t))
    throw new TypeError("Expected [K, V] tuple: " + t);
}
function Em(t) {
  return dr(t) ? lo : ii(t) ? mu : Bc;
}
function is(t) {
  return Object.create(
    (dr(t) ? $a : ii(t) ? Fo : Qc).prototype
  );
}
function Sm() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : xi.prototype.cacheResult.call(this);
}
function uD(t, e) {
  return t === void 0 && e === void 0 ? 0 : t === void 0 ? 1 : e === void 0 ? -1 : t > e ? 1 : t < e ? -1 : 0;
}
function Yo(t, e) {
  e = e || 0;
  for (var r = Math.max(0, t.length - e), n = new Array(r), i = 0; i < r; i++)
    n[i] = t[i + e];
  return n;
}
function Om(t, e) {
  if (!t)
    throw new Error(e);
}
function Ji(t) {
  Om(
    t !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function cD(t) {
  if (WA(t) && typeof t != "string")
    return t;
  if (Do(t))
    return t.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + t
  );
}
var FM = Object.prototype.toString;
function NM(t) {
  if (!t || typeof t != "object" || FM.call(t) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(t);
  if (e === null)
    return !0;
  for (var r = e, n = Object.getPrototypeOf(e); n !== null; )
    r = n, n = Object.getPrototypeOf(r);
  return r === e;
}
function Ma(t) {
  return typeof t == "object" && (ns(t) || Array.isArray(t) || NM(t));
}
function pl(t) {
  try {
    return typeof t == "string" ? JSON.stringify(t) : String(t);
  } catch {
    return JSON.stringify(t);
  }
}
function zM(t, e) {
  return ns(t) ? t.has(e) : Ma(t) && Vc.call(t, e);
}
function fD(t, e, r) {
  return ns(t) ? t.get(e, r) : zM(t, e) ? typeof t.get == "function" ? t.get(e) : t[e] : r;
}
function kp(t) {
  if (Array.isArray(t))
    return Yo(t);
  var e = {};
  for (var r in t)
    Vc.call(t, r) && (e[r] = t[r]);
  return e;
}
function LM(t, e) {
  if (!Ma(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (ns(t)) {
    if (!t.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + t
      );
    return t.remove(e);
  }
  if (!Vc.call(t, e))
    return t;
  var r = kp(t);
  return Array.isArray(r) ? r.splice(e, 1) : delete r[e], r;
}
function UM(t, e, r) {
  if (!Ma(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (ns(t)) {
    if (!t.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + t
      );
    return t.set(e, r);
  }
  if (Vc.call(t, e) && r === t[e])
    return t;
  var n = kp(t);
  return n[e] = r, n;
}
function Yc(t, e, r, n) {
  n || (n = r, r = void 0);
  var i = lD(
    ns(t),
    t,
    cD(e),
    0,
    r,
    n
  );
  return i === pe ? r : i;
}
function lD(t, e, r, n, i, o) {
  var s = e === pe;
  if (n === r.length) {
    var u = s ? i : e, c = o(u);
    return c === u ? e : c;
  }
  if (!s && !Ma(e))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + r.slice(0, n).map(pl) + "]: " + e
    );
  var a = r[n], f = s ? pe : fD(e, a, pe), h = lD(
    f === pe ? t : ns(f),
    f,
    r,
    n + 1,
    i,
    o
  );
  return h === f ? e : h === pe ? LM(e, a) : UM(
    s ? t ? Eo() : {} : e,
    a,
    h
  );
}
function BM(t, e, r) {
  return Yc(t, e, pe, function() {
    return r;
  });
}
function Im(t, e) {
  return BM(this, t, e);
}
function $M(t, e) {
  return Yc(t, e, function() {
    return pe;
  });
}
function Am(t) {
  return $M(this, t);
}
function hD(t, e, r, n) {
  return Yc(t, [e], r, n);
}
function Dm(t, e, r) {
  return arguments.length === 1 ? t(this) : hD(this, t, e, r);
}
function Rm(t, e, r) {
  return Yc(this, t, e, r);
}
function pD() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return vD(this, t);
}
function dD(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  if (typeof t != "function")
    throw new TypeError("Invalid merger function: " + t);
  return vD(this, e, t);
}
function vD(t, e, r) {
  for (var n = [], i = 0; i < e.length; i++) {
    var o = lo(e[i]);
    o.size !== 0 && n.push(o);
  }
  return n.length === 0 ? t : t.toSeq().size === 0 && !t.__ownerID && n.length === 1 ? t.constructor(n[0]) : t.withMutations(function(s) {
    for (var u = r ? function(a, f) {
      hD(
        s,
        f,
        pe,
        function(h) {
          return h === pe ? a : r(h, a, f);
        }
      );
    } : function(a, f) {
      s.set(f, a);
    }, c = 0; c < n.length; c++)
      n[c].forEach(u);
  });
}
function xm(t, e, r) {
  return Tm(t, e, KM(r));
}
function Tm(t, e, r) {
  if (!Ma(t))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + t
    );
  if (ns(t))
    return typeof r == "function" && t.mergeWith ? t.mergeWith.apply(t, [r].concat(e)) : t.merge ? t.merge.apply(t, e) : t.concat.apply(t, e);
  for (var n = Array.isArray(t), i = t, o = n ? mu : lo, s = n ? function(c) {
    i === t && (i = kp(i)), i.push(c);
  } : function(c, a) {
    var f = Vc.call(i, a), h = f && r ? r(i[a], c, a) : c;
    (!f || h !== i[a]) && (i === t && (i = kp(i)), i[a] = h);
  }, u = 0; u < e.length; u++)
    o(e[u]).forEach(s);
  return i;
}
function KM(t) {
  function e(r, n, i) {
    return Ma(r) && Ma(n) && VM(r, n) ? Tm(r, [n], e) : t ? t(r, n, i) : n;
  }
  return e;
}
function VM(t, e) {
  var r = xi(t), n = xi(e);
  return ii(r) === ii(n) && dr(r) === dr(n);
}
function yD() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return xm(this, t);
}
function _D(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return xm(this, e, t);
}
function Pm(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return Yc(this, t, Eo(), function(n) {
    return Tm(n, e);
  });
}
function km(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return Yc(
    this,
    t,
    Eo(),
    function(n) {
      return xm(n, e);
    }
  );
}
function Xl(t) {
  var e = this.asMutable();
  return t(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
}
function th() {
  return this.__ownerID ? this : this.__ensureOwner(new pm());
}
function eh() {
  return this.__ensureOwner();
}
function Cm() {
  return this.__altered;
}
var Gc = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Eo() : gm(r) && !Do(r) ? r : Eo().withMutations(function(n) {
      var i = t(r);
      Ji(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    return Eo().withMutations(function(i) {
      for (var o = 0; o < r.length; o += 2) {
        if (o + 1 >= r.length)
          throw new Error("Missing value for key: " + r[o]);
        i.set(r[o], r[o + 1]);
      }
    });
  }, e.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, e.prototype.get = function(r, n) {
    return this._root ? this._root.get(0, void 0, r, n) : n;
  }, e.prototype.set = function(r, n) {
    return Mw(this, r, n);
  }, e.prototype.remove = function(r) {
    return Mw(this, r, pe);
  }, e.prototype.deleteAll = function(r) {
    var n = Ir(r);
    return n.size === 0 ? this : this.withMutations(function(i) {
      n.forEach(function(o) {
        return i.remove(o);
      });
    });
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : Eo();
  }, e.prototype.sort = function(r) {
    return ia(sc(this, r));
  }, e.prototype.sortBy = function(r, n) {
    return ia(sc(this, n, r));
  }, e.prototype.map = function(r, n) {
    var i = this;
    return this.withMutations(function(o) {
      o.forEach(function(s, u) {
        o.set(u, r.call(n, s, u, i));
      });
    });
  }, e.prototype.__iterator = function(r, n) {
    return new QM(this, r, n);
  }, e.prototype.__iterate = function(r, n) {
    var i = this, o = 0;
    return this._root && this._root.iterate(function(s) {
      return o++, r(s[1], s[0], i);
    }, n), o;
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? jm(this.size, this._root, r, this.__hash) : this.size === 0 ? Eo() : (this.__ownerID = r, this.__altered = !1, this);
  }, e;
}(lo);
Gc.isMap = gm;
var Qe = Gc.prototype;
Qe[JA] = !0;
Qe[Hl] = Qe.remove;
Qe.removeAll = Qe.deleteAll;
Qe.setIn = Im;
Qe.removeIn = Qe.deleteIn = Am;
Qe.update = Dm;
Qe.updateIn = Rm;
Qe.merge = Qe.concat = pD;
Qe.mergeWith = dD;
Qe.mergeDeep = yD;
Qe.mergeDeepWith = _D;
Qe.mergeIn = Pm;
Qe.mergeDeepIn = km;
Qe.withMutations = Xl;
Qe.wasAltered = Cm;
Qe.asImmutable = eh;
Qe["@@transducer/init"] = Qe.asMutable = th;
Qe["@@transducer/step"] = function(t, e) {
  return t.set(e[0], e[1]);
};
Qe["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var dl = function(t, e) {
  this.ownerID = t, this.entries = e;
};
dl.prototype.get = function(t, e, r, n) {
  for (var i = this.entries, o = 0, s = i.length; o < s; o++)
    if (Oi(r, i[o][0]))
      return i[o][1];
  return n;
};
dl.prototype.update = function(t, e, r, n, i, o, s) {
  for (var u = i === pe, c = this.entries, a = 0, f = c.length; a < f && !Oi(n, c[a][0]); a++)
    ;
  var h = a < f;
  if (h ? c[a][1] === i : u)
    return this;
  if (Hi(s), (u || !h) && Hi(o), !(u && c.length === 1)) {
    if (!h && !u && c.length >= ZM)
      return YM(t, c, n, i);
    var p = t && t === this.ownerID, d = p ? c : Yo(c);
    return h ? u ? a === f - 1 ? d.pop() : d[a] = d.pop() : d[a] = [n, i] : d.push([n, i]), p ? (this.entries = d, this) : new dl(t, d);
  }
};
var ac = function(t, e, r) {
  this.ownerID = t, this.bitmap = e, this.nodes = r;
};
ac.prototype.get = function(t, e, r, n) {
  e === void 0 && (e = gi(r));
  var i = 1 << ((t === 0 ? e : e >>> t) & Mn), o = this.bitmap;
  return o & i ? this.nodes[mD(o & i - 1)].get(
    t + Ue,
    e,
    r,
    n
  ) : n;
};
ac.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = gi(n));
  var u = (e === 0 ? r : r >>> e) & Mn, c = 1 << u, a = this.bitmap, f = (a & c) !== 0;
  if (!f && i === pe)
    return this;
  var h = mD(a & c - 1), p = this.nodes, d = f ? p[h] : void 0, _ = qm(
    d,
    t,
    e + Ue,
    r,
    n,
    i,
    o,
    s
  );
  if (_ === d)
    return this;
  if (!f && _ && p.length >= XM)
    return WM(t, p, a, u, _);
  if (f && !_ && p.length === 2 && Fw(p[h ^ 1]))
    return p[h ^ 1];
  if (f && _ && p.length === 1 && Fw(_))
    return _;
  var m = t && t === this.ownerID, b = f ? _ ? a : a ^ c : a | c, O = f ? _ ? gD(p, h, _, m) : JM(p, h, m) : HM(p, h, _, m);
  return m ? (this.bitmap = b, this.nodes = O, this) : new ac(t, b, O);
};
var vl = function(t, e, r) {
  this.ownerID = t, this.count = e, this.nodes = r;
};
vl.prototype.get = function(t, e, r, n) {
  e === void 0 && (e = gi(r));
  var i = (t === 0 ? e : e >>> t) & Mn, o = this.nodes[i];
  return o ? o.get(t + Ue, e, r, n) : n;
};
vl.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = gi(n));
  var u = (e === 0 ? r : r >>> e) & Mn, c = i === pe, a = this.nodes, f = a[u];
  if (c && !f)
    return this;
  var h = qm(
    f,
    t,
    e + Ue,
    r,
    n,
    i,
    o,
    s
  );
  if (h === f)
    return this;
  var p = this.count;
  if (!f)
    p++;
  else if (!h && (p--, p < t4))
    return GM(t, a, p, u);
  var d = t && t === this.ownerID, _ = gD(a, u, h, d);
  return d ? (this.count = p, this.nodes = _, this) : new vl(t, p, _);
};
var uc = function(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entries = r;
};
uc.prototype.get = function(t, e, r, n) {
  for (var i = this.entries, o = 0, s = i.length; o < s; o++)
    if (Oi(r, i[o][0]))
      return i[o][1];
  return n;
};
uc.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = gi(n));
  var u = i === pe;
  if (r !== this.keyHash)
    return u ? this : (Hi(s), Hi(o), Mm(this, t, e, r, [n, i]));
  for (var c = this.entries, a = 0, f = c.length; a < f && !Oi(n, c[a][0]); a++)
    ;
  var h = a < f;
  if (h ? c[a][1] === i : u)
    return this;
  if (Hi(s), (u || !h) && Hi(o), u && f === 2)
    return new na(t, this.keyHash, c[a ^ 1]);
  var p = t && t === this.ownerID, d = p ? c : Yo(c);
  return h ? u ? a === f - 1 ? d.pop() : d[a] = d.pop() : d[a] = [n, i] : d.push([n, i]), p ? (this.entries = d, this) : new uc(t, this.keyHash, d);
};
var na = function(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entry = r;
};
na.prototype.get = function(t, e, r, n) {
  return Oi(r, this.entry[0]) ? this.entry[1] : n;
};
na.prototype.update = function(t, e, r, n, i, o, s) {
  var u = i === pe, c = Oi(n, this.entry[0]);
  if (c ? i === this.entry[1] : u)
    return this;
  if (Hi(s), u) {
    Hi(o);
    return;
  }
  return c ? t && t === this.ownerID ? (this.entry[1] = i, this) : new na(t, this.keyHash, [n, i]) : (Hi(o), Mm(this, t, e, gi(n), [n, i]));
};
dl.prototype.iterate = uc.prototype.iterate = function(t, e) {
  for (var r = this.entries, n = 0, i = r.length - 1; n <= i; n++)
    if (t(r[e ? i - n : n]) === !1)
      return !1;
};
ac.prototype.iterate = vl.prototype.iterate = function(t, e) {
  for (var r = this.nodes, n = 0, i = r.length - 1; n <= i; n++) {
    var o = r[e ? i - n : n];
    if (o && o.iterate(t, e) === !1)
      return !1;
  }
};
na.prototype.iterate = function(t, e) {
  return t(this.entry);
};
var QM = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    this._type = n, this._reverse = i, this._stack = r._root && jw(r._root);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function() {
    for (var r = this._type, n = this._stack; n; ) {
      var i = n.node, o = n.index++, s = void 0;
      if (i.entry) {
        if (o === 0)
          return Hv(r, i.entry);
      } else if (i.entries) {
        if (s = i.entries.length - 1, o <= s)
          return Hv(
            r,
            i.entries[this._reverse ? s - o : o]
          );
      } else if (s = i.nodes.length - 1, o <= s) {
        var u = i.nodes[this._reverse ? s - o : o];
        if (u) {
          if (u.entry)
            return Hv(r, u.entry);
          n = this._stack = jw(u, n);
        }
        continue;
      }
      n = this._stack = this._stack.__prev;
    }
    return hi();
  }, e;
}(be);
function Hv(t, e) {
  return gr(t, e[0], e[1]);
}
function jw(t, e) {
  return {
    node: t,
    index: 0,
    __prev: e
  };
}
function jm(t, e, r, n) {
  var i = Object.create(Qe);
  return i.size = t, i._root = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var qw;
function Eo() {
  return qw || (qw = jm(0));
}
function Mw(t, e, r) {
  var n, i;
  if (t._root) {
    var o = Zy(), s = Zy();
    if (n = qm(
      t._root,
      t.__ownerID,
      0,
      void 0,
      e,
      r,
      o,
      s
    ), !s.value)
      return t;
    i = t.size + (o.value ? r === pe ? -1 : 1 : 0);
  } else {
    if (r === pe)
      return t;
    i = 1, n = new dl(t.__ownerID, [[e, r]]);
  }
  return t.__ownerID ? (t.size = i, t._root = n, t.__hash = void 0, t.__altered = !0, t) : n ? jm(i, n) : Eo();
}
function qm(t, e, r, n, i, o, s, u) {
  return t ? t.update(
    e,
    r,
    n,
    i,
    o,
    s,
    u
  ) : o === pe ? t : (Hi(u), Hi(s), new na(e, n, [i, o]));
}
function Fw(t) {
  return t.constructor === na || t.constructor === uc;
}
function Mm(t, e, r, n, i) {
  if (t.keyHash === n)
    return new uc(e, n, [t.entry, i]);
  var o = (r === 0 ? t.keyHash : t.keyHash >>> r) & Mn, s = (r === 0 ? n : n >>> r) & Mn, u, c = o === s ? [Mm(t, e, r + Ue, n, i)] : (u = new na(e, n, i), o < s ? [t, u] : [u, t]);
  return new ac(e, 1 << o | 1 << s, c);
}
function YM(t, e, r, n) {
  t || (t = new pm());
  for (var i = new na(t, gi(r), [r, n]), o = 0; o < e.length; o++) {
    var s = e[o];
    i = i.update(t, 0, void 0, s[0], s[1]);
  }
  return i;
}
function GM(t, e, r, n) {
  for (var i = 0, o = 0, s = new Array(r), u = 0, c = 1, a = e.length; u < a; u++, c <<= 1) {
    var f = e[u];
    f !== void 0 && u !== n && (i |= c, s[o++] = f);
  }
  return new ac(t, i, s);
}
function WM(t, e, r, n, i) {
  for (var o = 0, s = new Array(Wi), u = 0; r !== 0; u++, r >>>= 1)
    s[u] = r & 1 ? e[o++] : void 0;
  return s[n] = i, new vl(t, o + 1, s);
}
function mD(t) {
  return t -= t >> 1 & 1431655765, t = (t & 858993459) + (t >> 2 & 858993459), t = t + (t >> 4) & 252645135, t += t >> 8, t += t >> 16, t & 127;
}
function gD(t, e, r, n) {
  var i = n ? t : Yo(t);
  return i[e] = r, i;
}
function HM(t, e, r, n) {
  var i = t.length + 1;
  if (n && e + 1 === i)
    return t[e] = r, t;
  for (var o = new Array(i), s = 0, u = 0; u < i; u++)
    u === e ? (o[u] = r, s = -1) : o[u] = t[u + s];
  return o;
}
function JM(t, e, r) {
  var n = t.length - 1;
  if (r && e === n)
    return t.pop(), t;
  for (var i = new Array(n), o = 0, s = 0; s < n; s++)
    s === e && (o = 1), i[s] = t[s + o];
  return i;
}
var ZM = Wi / 4, XM = Wi / 2, t4 = Wi / 4, bD = "@@__IMMUTABLE_LIST__@@";
function wD(t) {
  return !!(t && t[bD]);
}
var Td = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = fp();
    if (r == null)
      return n;
    if (wD(r))
      return r;
    var i = t(r), o = i.size;
    return o === 0 ? n : (Ji(o), o > 0 && o < Wi ? yl(0, o, Ue, null, new Ra(i.toArray())) : n.withMutations(function(s) {
      s.setSize(o), i.forEach(function(u, c) {
        return s.set(c, u);
      });
    }));
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, e.prototype.get = function(r, n) {
    if (r = qa(this, r), r >= 0 && r < this.size) {
      r += this._origin;
      var i = ED(this, r);
      return i && i.array[r & Mn];
    }
    return n;
  }, e.prototype.set = function(r, n) {
    return e4(this, r, n);
  }, e.prototype.remove = function(r) {
    return this.has(r) ? r === 0 ? this.shift() : r === this.size - 1 ? this.pop() : this.splice(r, 1) : this;
  }, e.prototype.insert = function(r, n) {
    return this.splice(r, 0, n);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = Ue, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : fp();
  }, e.prototype.push = function() {
    var r = arguments, n = this.size;
    return this.withMutations(function(i) {
      ya(i, 0, n + r.length);
      for (var o = 0; o < r.length; o++)
        i.set(n + o, r[o]);
    });
  }, e.prototype.pop = function() {
    return ya(this, 0, -1);
  }, e.prototype.unshift = function() {
    var r = arguments;
    return this.withMutations(function(n) {
      ya(n, -r.length);
      for (var i = 0; i < r.length; i++)
        n.set(i, r[i]);
    });
  }, e.prototype.shift = function() {
    return ya(this, 1);
  }, e.prototype.concat = function() {
    for (var r = arguments, n = [], i = 0; i < arguments.length; i++) {
      var o = r[i], s = t(
        typeof o != "string" && GA(o) ? o : [o]
      );
      s.size !== 0 && n.push(s);
    }
    return n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(u) {
      n.forEach(function(c) {
        return c.forEach(function(a) {
          return u.push(a);
        });
      });
    });
  }, e.prototype.setSize = function(r) {
    return ya(this, 0, r);
  }, e.prototype.map = function(r, n) {
    var i = this;
    return this.withMutations(function(o) {
      for (var s = 0; s < i.size; s++)
        o.set(s, r.call(n, o.get(s), s, i));
    });
  }, e.prototype.slice = function(r, n) {
    var i = this.size;
    return Sd(r, n, i) ? this : ya(
      this,
      Jl(r, i),
      Od(n, i)
    );
  }, e.prototype.__iterator = function(r, n) {
    var i = n ? this.size : 0, o = Nw(this, n);
    return new be(function() {
      var s = o();
      return s === Gf ? hi() : gr(r, n ? --i : i++, s);
    });
  }, e.prototype.__iterate = function(r, n) {
    for (var i = n ? this.size : 0, o = Nw(this, n), s; (s = o()) !== Gf && r(s, n ? --i : i++, this) !== !1; )
      ;
    return i;
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? yl(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      r,
      this.__hash
    ) : this.size === 0 ? fp() : (this.__ownerID = r, this.__altered = !1, this);
  }, e;
}(mu);
Td.isList = wD;
var Cr = Td.prototype;
Cr[bD] = !0;
Cr[Hl] = Cr.remove;
Cr.merge = Cr.concat;
Cr.setIn = Im;
Cr.deleteIn = Cr.removeIn = Am;
Cr.update = Dm;
Cr.updateIn = Rm;
Cr.mergeIn = Pm;
Cr.mergeDeepIn = km;
Cr.withMutations = Xl;
Cr.wasAltered = Cm;
Cr.asImmutable = eh;
Cr["@@transducer/init"] = Cr.asMutable = th;
Cr["@@transducer/step"] = function(t, e) {
  return t.push(e);
};
Cr["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var Ra = function(t, e) {
  this.array = t, this.ownerID = e;
};
Ra.prototype.removeBefore = function(t, e, r) {
  if (r === e ? 1 << e : this.array.length === 0)
    return this;
  var n = r >>> e & Mn;
  if (n >= this.array.length)
    return new Ra([], t);
  var i = n === 0, o;
  if (e > 0) {
    var s = this.array[n];
    if (o = s && s.removeBefore(t, e - Ue, r), o === s && i)
      return this;
  }
  if (i && !o)
    return this;
  var u = cc(this, t);
  if (!i)
    for (var c = 0; c < n; c++)
      u.array[c] = void 0;
  return o && (u.array[n] = o), u;
};
Ra.prototype.removeAfter = function(t, e, r) {
  if (r === (e ? 1 << e : 0) || this.array.length === 0)
    return this;
  var n = r - 1 >>> e & Mn;
  if (n >= this.array.length)
    return this;
  var i;
  if (e > 0) {
    var o = this.array[n];
    if (i = o && o.removeAfter(t, e - Ue, r), i === o && n === this.array.length - 1)
      return this;
  }
  var s = cc(this, t);
  return s.array.splice(n + 1), i && (s.array[n] = i), s;
};
var Gf = {};
function Nw(t, e) {
  var r = t._origin, n = t._capacity, i = _l(n), o = t._tail;
  return s(t._root, t._level, 0);
  function s(a, f, h) {
    return f === 0 ? u(a, h) : c(a, f, h);
  }
  function u(a, f) {
    var h = f === i ? o && o.array : a && a.array, p = f > r ? 0 : r - f, d = n - f;
    return d > Wi && (d = Wi), function() {
      if (p === d)
        return Gf;
      var _ = e ? --d : p++;
      return h && h[_];
    };
  }
  function c(a, f, h) {
    var p, d = a && a.array, _ = h > r ? 0 : r - h >> f, m = (n - h >> f) + 1;
    return m > Wi && (m = Wi), function() {
      for (; ; ) {
        if (p) {
          var b = p();
          if (b !== Gf)
            return b;
          p = null;
        }
        if (_ === m)
          return Gf;
        var O = e ? --m : _++;
        p = s(
          d && d[O],
          f - Ue,
          h + (O << f)
        );
      }
    };
  }
}
function yl(t, e, r, n, i, o, s) {
  var u = Object.create(Cr);
  return u.size = e - t, u._origin = t, u._capacity = e, u._level = r, u._root = n, u._tail = i, u.__ownerID = o, u.__hash = s, u.__altered = !1, u;
}
var zw;
function fp() {
  return zw || (zw = yl(0, 0, Ue));
}
function e4(t, e, r) {
  if (e = qa(t, e), e !== e)
    return t;
  if (e >= t.size || e < 0)
    return t.withMutations(function(s) {
      e < 0 ? ya(s, e).set(0, r) : ya(s, 0, e + 1).set(e, r);
    });
  e += t._origin;
  var n = t._tail, i = t._root, o = Zy();
  return e >= _l(t._capacity) ? n = i_(n, t.__ownerID, 0, e, r, o) : i = i_(
    i,
    t.__ownerID,
    t._level,
    e,
    r,
    o
  ), o.value ? t.__ownerID ? (t._root = i, t._tail = n, t.__hash = void 0, t.__altered = !0, t) : yl(t._origin, t._capacity, t._level, i, n) : t;
}
function i_(t, e, r, n, i, o) {
  var s = n >>> r & Mn, u = t && s < t.array.length;
  if (!u && i === void 0)
    return t;
  var c;
  if (r > 0) {
    var a = t && t.array[s], f = i_(
      a,
      e,
      r - Ue,
      n,
      i,
      o
    );
    return f === a ? t : (c = cc(t, e), c.array[s] = f, c);
  }
  return u && t.array[s] === i ? t : (o && Hi(o), c = cc(t, e), i === void 0 && s === c.array.length - 1 ? c.array.pop() : c.array[s] = i, c);
}
function cc(t, e) {
  return e && t && e === t.ownerID ? t : new Ra(t ? t.array.slice() : [], e);
}
function ED(t, e) {
  if (e >= _l(t._capacity))
    return t._tail;
  if (e < 1 << t._level + Ue) {
    for (var r = t._root, n = t._level; r && n > 0; )
      r = r.array[e >>> n & Mn], n -= Ue;
    return r;
  }
}
function ya(t, e, r) {
  e !== void 0 && (e |= 0), r !== void 0 && (r |= 0);
  var n = t.__ownerID || new pm(), i = t._origin, o = t._capacity, s = i + e, u = r === void 0 ? o : r < 0 ? o + r : i + r;
  if (s === i && u === o)
    return t;
  if (s >= u)
    return t.clear();
  for (var c = t._level, a = t._root, f = 0; s + f < 0; )
    a = new Ra(
      a && a.array.length ? [void 0, a] : [],
      n
    ), c += Ue, f += 1 << c;
  f && (s += f, i += f, u += f, o += f);
  for (var h = _l(o), p = _l(u); p >= 1 << c + Ue; )
    a = new Ra(
      a && a.array.length ? [a] : [],
      n
    ), c += Ue;
  var d = t._tail, _ = p < h ? ED(t, u - 1) : p > h ? new Ra([], n) : d;
  if (d && p > h && s < o && d.array.length) {
    a = cc(a, n);
    for (var m = a, b = c; b > Ue; b -= Ue) {
      var O = h >>> b & Mn;
      m = m.array[O] = cc(m.array[O], n);
    }
    m.array[h >>> Ue & Mn] = d;
  }
  if (u < o && (_ = _ && _.removeAfter(n, 0, u)), s >= p)
    s -= p, u -= p, c = Ue, a = null, _ = _ && _.removeBefore(n, 0, s);
  else if (s > i || p < h) {
    for (f = 0; a; ) {
      var S = s >>> c & Mn;
      if (S !== p >>> c & Mn)
        break;
      S && (f += (1 << c) * S), c -= Ue, a = a.array[S];
    }
    a && s > i && (a = a.removeBefore(n, c, s - f)), a && p < h && (a = a.removeAfter(
      n,
      c,
      p - f
    )), f && (s -= f, u -= f);
  }
  return t.__ownerID ? (t.size = u - s, t._origin = s, t._capacity = u, t._level = c, t._root = a, t._tail = _, t.__hash = void 0, t.__altered = !0, t) : yl(s, u, c, a, _);
}
function _l(t) {
  return t < Wi ? 0 : t - 1 >>> Ue << Ue;
}
var ia = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Mf() : ZA(r) ? r : Mf().withMutations(function(n) {
      var i = lo(r);
      Ji(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, e.prototype.get = function(r, n) {
    var i = this._map.get(r);
    return i !== void 0 ? this._list.get(i)[1] : n;
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : Mf();
  }, e.prototype.set = function(r, n) {
    return Uw(this, r, n);
  }, e.prototype.remove = function(r) {
    return Uw(this, r, pe);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._list.__iterate(
      function(o) {
        return o && r(o[1], o[0], i);
      },
      n
    );
  }, e.prototype.__iterator = function(r, n) {
    return this._list.fromEntrySeq().__iterator(r, n);
  }, e.prototype.__ensureOwner = function(r) {
    if (r === this.__ownerID)
      return this;
    var n = this._map.__ensureOwner(r), i = this._list.__ensureOwner(r);
    return r ? Fm(n, i, r, this.__hash) : this.size === 0 ? Mf() : (this.__ownerID = r, this.__altered = !1, this._map = n, this._list = i, this);
  }, e;
}(Gc);
ia.isOrderedMap = ZA;
ia.prototype[Kc] = !0;
ia.prototype[Hl] = ia.prototype.remove;
function Fm(t, e, r, n) {
  var i = Object.create(ia.prototype);
  return i.size = t ? t.size : 0, i._map = t, i._list = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var Lw;
function Mf() {
  return Lw || (Lw = Fm(Eo(), fp()));
}
function Uw(t, e, r) {
  var n = t._map, i = t._list, o = n.get(e), s = o !== void 0, u, c;
  if (r === pe) {
    if (!s)
      return t;
    i.size >= Wi && i.size >= n.size * 2 ? (c = i.filter(function(a, f) {
      return a !== void 0 && o !== f;
    }), u = c.toKeyedSeq().map(function(a) {
      return a[0];
    }).flip().toMap(), t.__ownerID && (u.__ownerID = c.__ownerID = t.__ownerID)) : (u = n.remove(e), c = o === i.size - 1 ? i.pop() : i.set(o, void 0));
  } else if (s) {
    if (r === i.get(o)[1])
      return t;
    u = n, c = i.set(o, [e, r]);
  } else
    u = n.set(e, i.size), c = i.set(i.size, [e, r]);
  return t.__ownerID ? (t.size = u.size, t._map = u, t._list = c, t.__hash = void 0, t.__altered = !0, t) : Fm(u, c);
}
var SD = "@@__IMMUTABLE_STACK__@@";
function o_(t) {
  return !!(t && t[SD]);
}
var Nm = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Nh() : o_(r) ? r : Nh().pushAll(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, e.prototype.get = function(r, n) {
    var i = this._head;
    for (r = qa(this, r); i && r--; )
      i = i.next;
    return i ? i.value : n;
  }, e.prototype.peek = function() {
    return this._head && this._head.value;
  }, e.prototype.push = function() {
    var r = arguments;
    if (arguments.length === 0)
      return this;
    for (var n = this.size + arguments.length, i = this._head, o = arguments.length - 1; o >= 0; o--)
      i = {
        value: r[o],
        next: i
      };
    return this.__ownerID ? (this.size = n, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Ff(n, i);
  }, e.prototype.pushAll = function(r) {
    if (r = t(r), r.size === 0)
      return this;
    if (this.size === 0 && o_(r))
      return r;
    Ji(r.size);
    var n = this.size, i = this._head;
    return r.__iterate(
      function(o) {
        n++, i = {
          value: o,
          next: i
        };
      },
      /* reverse */
      !0
    ), this.__ownerID ? (this.size = n, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Ff(n, i);
  }, e.prototype.pop = function() {
    return this.slice(1);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Nh();
  }, e.prototype.slice = function(r, n) {
    if (Sd(r, n, this.size))
      return this;
    var i = Jl(r, this.size), o = Od(n, this.size);
    if (o !== this.size)
      return t.prototype.slice.call(this, r, n);
    for (var s = this.size - i, u = this._head; i--; )
      u = u.next;
    return this.__ownerID ? (this.size = s, this._head = u, this.__hash = void 0, this.__altered = !0, this) : Ff(s, u);
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? Ff(this.size, this._head, r, this.__hash) : this.size === 0 ? Nh() : (this.__ownerID = r, this.__altered = !1, this);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    if (n)
      return new su(this.toArray()).__iterate(
        function(u, c) {
          return r(u, c, i);
        },
        n
      );
    for (var o = 0, s = this._head; s && r(s.value, o++, this) !== !1; )
      s = s.next;
    return o;
  }, e.prototype.__iterator = function(r, n) {
    if (n)
      return new su(this.toArray()).__iterator(r, n);
    var i = 0, o = this._head;
    return new be(function() {
      if (o) {
        var s = o.value;
        return o = o.next, gr(r, i++, s);
      }
      return hi();
    });
  }, e;
}(mu);
Nm.isStack = o_;
var Un = Nm.prototype;
Un[SD] = !0;
Un.shift = Un.pop;
Un.unshift = Un.push;
Un.unshiftAll = Un.pushAll;
Un.withMutations = Xl;
Un.wasAltered = Cm;
Un.asImmutable = eh;
Un["@@transducer/init"] = Un.asMutable = th;
Un["@@transducer/step"] = function(t, e) {
  return t.unshift(e);
};
Un["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
function Ff(t, e, r, n) {
  var i = Object.create(Un);
  return i.size = t, i._head = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var Bw;
function Nh() {
  return Bw || (Bw = Ff(0));
}
var OD = "@@__IMMUTABLE_SET__@@";
function zm(t) {
  return !!(t && t[OD]);
}
function ID(t) {
  return zm(t) && Do(t);
}
function AD(t, e) {
  if (t === e)
    return !0;
  if (!li(e) || t.size !== void 0 && e.size !== void 0 && t.size !== e.size || t.__hash !== void 0 && e.__hash !== void 0 && t.__hash !== e.__hash || dr(t) !== dr(e) || ii(t) !== ii(e) || Do(t) !== Do(e))
    return !1;
  if (t.size === 0 && e.size === 0)
    return !0;
  var r = !Id(t);
  if (Do(t)) {
    var n = t.entries();
    return e.every(function(c, a) {
      var f = n.next().value;
      return f && Oi(f[1], c) && (r || Oi(f[0], a));
    }) && n.next().done;
  }
  var i = !1;
  if (t.size === void 0)
    if (e.size === void 0)
      typeof t.cacheResult == "function" && t.cacheResult();
    else {
      i = !0;
      var o = t;
      t = e, e = o;
    }
  var s = !0, u = e.__iterate(function(c, a) {
    if (r ? !t.has(c) : i ? !Oi(c, t.get(a, pe)) : !Oi(t.get(a, pe), c))
      return s = !1, !1;
  });
  return s && t.size === u;
}
function gu(t, e) {
  var r = function(n) {
    t.prototype[n] = e[n];
  };
  return Object.keys(e).forEach(r), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(r), t;
}
function Cp(t) {
  if (!t || typeof t != "object")
    return t;
  if (!li(t)) {
    if (!Ma(t))
      return t;
    t = xi(t);
  }
  if (dr(t)) {
    var e = {};
    return t.__iterate(function(n, i) {
      e[i] = Cp(n);
    }), e;
  }
  var r = [];
  return t.__iterate(function(n) {
    r.push(Cp(n));
  }), r;
}
var Pd = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Nf() : zm(r) && !Do(r) ? r : Nf().withMutations(function(n) {
      var i = t(r);
      Ji(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(r) {
    return this(lo(r).keySeq());
  }, e.intersect = function(r) {
    return r = Ir(r).toArray(), r.length ? en.intersect.apply(e(r.pop()), r) : Nf();
  }, e.union = function(r) {
    return r = Ir(r).toArray(), r.length ? en.union.apply(e(r.pop()), r) : Nf();
  }, e.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, e.prototype.has = function(r) {
    return this._map.has(r);
  }, e.prototype.add = function(r) {
    return zh(this, this._map.set(r, r));
  }, e.prototype.remove = function(r) {
    return zh(this, this._map.remove(r));
  }, e.prototype.clear = function() {
    return zh(this, this._map.clear());
  }, e.prototype.map = function(r, n) {
    var i = this, o = !1, s = zh(
      this,
      this._map.mapEntries(function(u) {
        var c = u[1], a = r.call(n, c, c, i);
        return a !== c && (o = !0), [a, a];
      }, n)
    );
    return o ? s : this;
  }, e.prototype.union = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    return r = r.filter(function(i) {
      return i.size !== 0;
    }), r.length === 0 ? this : this.size === 0 && !this.__ownerID && r.length === 1 ? this.constructor(r[0]) : this.withMutations(function(i) {
      for (var o = 0; o < r.length; o++)
        typeof r[o] == "string" ? i.add(r[o]) : t(r[o]).forEach(function(s) {
          return i.add(s);
        });
    });
  }, e.prototype.intersect = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (r.length === 0)
      return this;
    r = r.map(function(o) {
      return t(o);
    });
    var i = [];
    return this.forEach(function(o) {
      r.every(function(s) {
        return s.includes(o);
      }) || i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(s) {
        o.remove(s);
      });
    });
  }, e.prototype.subtract = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (r.length === 0)
      return this;
    r = r.map(function(o) {
      return t(o);
    });
    var i = [];
    return this.forEach(function(o) {
      r.some(function(s) {
        return s.includes(o);
      }) && i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(s) {
        o.remove(s);
      });
    });
  }, e.prototype.sort = function(r) {
    return ml(sc(this, r));
  }, e.prototype.sortBy = function(r, n) {
    return ml(sc(this, n, r));
  }, e.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._map.__iterate(function(o) {
      return r(o, o, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    return this._map.__iterator(r, n);
  }, e.prototype.__ensureOwner = function(r) {
    if (r === this.__ownerID)
      return this;
    var n = this._map.__ensureOwner(r);
    return r ? this.__make(n, r) : this.size === 0 ? this.__empty() : (this.__ownerID = r, this._map = n, this);
  }, e;
}(Bc);
Pd.isSet = zm;
var en = Pd.prototype;
en[OD] = !0;
en[Hl] = en.remove;
en.merge = en.concat = en.union;
en.withMutations = Xl;
en.asImmutable = eh;
en["@@transducer/init"] = en.asMutable = th;
en["@@transducer/step"] = function(t, e) {
  return t.add(e);
};
en["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
en.__empty = Nf;
en.__make = DD;
function zh(t, e) {
  return t.__ownerID ? (t.size = e.size, t._map = e, t) : e === t._map ? t : e.size === 0 ? t.__empty() : t.__make(e);
}
function DD(t, e) {
  var r = Object.create(en);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var $w;
function Nf() {
  return $w || ($w = DD(Eo()));
}
var r4 = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    if (!(this instanceof e))
      return new e(r, n, i);
    if (Om(i !== 0, "Cannot step a Range by 0"), r = r || 0, n === void 0 && (n = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), n < r && (i = -i), this._start = r, this._end = n, this._step = i, this.size = Math.max(0, Math.ceil((n - r) / i - 1) + 1), this.size === 0) {
      if (Jv)
        return Jv;
      Jv = this;
    }
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, e.prototype.get = function(r, n) {
    return this.has(r) ? this._start + qa(this, r) * this._step : n;
  }, e.prototype.includes = function(r) {
    var n = (r - this._start) / this._step;
    return n >= 0 && n < this.size && n === Math.floor(n);
  }, e.prototype.slice = function(r, n) {
    return Sd(r, n, this.size) ? this : (r = Jl(r, this.size), n = Od(n, this.size), n <= r ? new e(0, 0) : new e(
      this.get(r, this._end),
      this.get(n, this._end),
      this._step
    ));
  }, e.prototype.indexOf = function(r) {
    var n = r - this._start;
    if (n % this._step === 0) {
      var i = n / this._step;
      if (i >= 0 && i < this.size)
        return i;
    }
    return -1;
  }, e.prototype.lastIndexOf = function(r) {
    return this.indexOf(r);
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this.size, o = this._step, s = n ? this._start + (i - 1) * o : this._start, u = 0; u !== i && r(s, n ? i - ++u : u++, this) !== !1; )
      s += n ? -o : o;
    return u;
  }, e.prototype.__iterator = function(r, n) {
    var i = this.size, o = this._step, s = n ? this._start + (i - 1) * o : this._start, u = 0;
    return new be(function() {
      if (u === i)
        return hi();
      var c = s;
      return s += n ? -o : o, gr(r, n ? i - ++u : u++, c);
    });
  }, e.prototype.equals = function(r) {
    return r instanceof e ? this._start === r._start && this._end === r._end && this._step === r._step : AD(this, r);
  }, e;
}(Fo), Jv;
function RD(t, e, r) {
  for (var n = cD(e), i = 0; i !== n.length; )
    if (t = fD(t, n[i++], pe), t === pe)
      return r;
  return t;
}
function xD(t, e) {
  return RD(this, t, e);
}
function n4(t, e) {
  return RD(t, e, pe) !== pe;
}
function i4(t) {
  return n4(this, t);
}
function TD() {
  Ji(this.size);
  var t = {};
  return this.__iterate(function(e, r) {
    t[r] = e;
  }), t;
}
Ir.isIterable = li;
Ir.isKeyed = dr;
Ir.isIndexed = ii;
Ir.isAssociative = Id;
Ir.isOrdered = Do;
Ir.Iterator = be;
gu(Ir, {
  // ### Conversion to other types
  toArray: function() {
    Ji(this.size);
    var t = new Array(this.size || 0), e = dr(this), r = 0;
    return this.__iterate(function(n, i) {
      t[r++] = e ? [i, n] : n;
    }), t;
  },
  toIndexedSeq: function() {
    return new tD(this);
  },
  toJS: function() {
    return Cp(this);
  },
  toKeyedSeq: function() {
    return new xd(this, !0);
  },
  toMap: function() {
    return Gc(this.toKeyedSeq());
  },
  toObject: TD,
  toOrderedMap: function() {
    return ia(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return ml(dr(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return Pd(dr(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new eD(this);
  },
  toSeq: function() {
    return ii(this) ? this.toIndexedSeq() : dr(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return Nm(dr(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return Td(dr(this) ? this.valueSeq() : this);
  },
  // ### Common JavaScript methods and properties
  toString: function() {
    return "[Collection]";
  },
  __toString: function(t, e) {
    return this.size === 0 ? t + e : t + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  concat: function() {
    for (var t = [], e = arguments.length; e--; )
      t[e] = arguments[e];
    return Te(this, jM(this, t));
  },
  includes: function(t) {
    return this.some(function(e) {
      return Oi(e, t);
    });
  },
  entries: function() {
    return this.__iterator(so);
  },
  every: function(t, e) {
    Ji(this.size);
    var r = !0;
    return this.__iterate(function(n, i, o) {
      if (!t.call(e, n, i, o))
        return r = !1, !1;
    }), r;
  },
  filter: function(t, e) {
    return Te(this, oD(this, t, e, !0));
  },
  partition: function(t, e) {
    return kM(this, t, e);
  },
  find: function(t, e, r) {
    var n = this.findEntry(t, e);
    return n ? n[1] : r;
  },
  forEach: function(t, e) {
    return Ji(this.size), this.__iterate(e ? t.bind(e) : t);
  },
  join: function(t) {
    Ji(this.size), t = t !== void 0 ? "" + t : ",";
    var e = "", r = !0;
    return this.__iterate(function(n) {
      r ? r = !1 : e += t, e += n != null ? n.toString() : "";
    }), e;
  },
  keys: function() {
    return this.__iterator(Zl);
  },
  map: function(t, e) {
    return Te(this, iD(this, t, e));
  },
  reduce: function(t, e, r) {
    return Kw(
      this,
      t,
      e,
      r,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(t, e, r) {
    return Kw(
      this,
      t,
      e,
      r,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return Te(this, bm(this, !0));
  },
  slice: function(t, e) {
    return Te(this, wm(this, t, e, !0));
  },
  some: function(t, e) {
    return !this.every(Lh(t), e);
  },
  sort: function(t) {
    return Te(this, sc(this, t));
  },
  values: function() {
    return this.__iterator(ko);
  },
  // ### More sequential methods
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(t, e) {
    return oc(
      t ? this.toSeq().filter(t, e) : this
    );
  },
  countBy: function(t, e) {
    return TM(this, t, e);
  },
  equals: function(t) {
    return AD(this, t);
  },
  entrySeq: function() {
    var t = this;
    if (t._cache)
      return new su(t._cache);
    var e = t.toSeq().map(s4).toIndexedSeq();
    return e.fromEntrySeq = function() {
      return t.toSeq();
    }, e;
  },
  filterNot: function(t, e) {
    return this.filter(Lh(t), e);
  },
  findEntry: function(t, e, r) {
    var n = r;
    return this.__iterate(function(i, o, s) {
      if (t.call(e, i, o, s))
        return n = [o, i], !1;
    }), n;
  },
  findKey: function(t, e) {
    var r = this.findEntry(t, e);
    return r && r[0];
  },
  findLast: function(t, e, r) {
    return this.toKeyedSeq().reverse().find(t, e, r);
  },
  findLastEntry: function(t, e, r) {
    return this.toKeyedSeq().reverse().findEntry(t, e, r);
  },
  findLastKey: function(t, e) {
    return this.toKeyedSeq().reverse().findKey(t, e);
  },
  first: function(t) {
    return this.find(zA, null, t);
  },
  flatMap: function(t, e) {
    return Te(this, qM(this, t, e));
  },
  flatten: function(t) {
    return Te(this, aD(this, t, !0));
  },
  fromEntrySeq: function() {
    return new rD(this);
  },
  get: function(t, e) {
    return this.find(function(r, n) {
      return Oi(n, t);
    }, void 0, e);
  },
  getIn: xD,
  groupBy: function(t, e) {
    return PM(this, t, e);
  },
  has: function(t) {
    return this.get(t, pe) !== pe;
  },
  hasIn: i4,
  isSubset: function(t) {
    return t = typeof t.includes == "function" ? t : Ir(t), this.every(function(e) {
      return t.includes(e);
    });
  },
  isSuperset: function(t) {
    return t = typeof t.isSubset == "function" ? t : Ir(t), t.isSubset(this);
  },
  keyOf: function(t) {
    return this.findKey(function(e) {
      return Oi(e, t);
    });
  },
  keySeq: function() {
    return this.toSeq().map(o4).toIndexedSeq();
  },
  last: function(t) {
    return this.toSeq().reverse().first(t);
  },
  lastKeyOf: function(t) {
    return this.toKeyedSeq().reverse().keyOf(t);
  },
  max: function(t) {
    return Mh(this, t);
  },
  maxBy: function(t, e) {
    return Mh(this, e, t);
  },
  min: function(t) {
    return Mh(
      this,
      t ? Vw(t) : Yw
    );
  },
  minBy: function(t, e) {
    return Mh(
      this,
      e ? Vw(e) : Yw,
      t
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(t) {
    return t === 0 ? this : this.slice(Math.max(0, t));
  },
  skipLast: function(t) {
    return t === 0 ? this : this.slice(0, -Math.max(0, t));
  },
  skipWhile: function(t, e) {
    return Te(this, sD(this, t, e, !0));
  },
  skipUntil: function(t, e) {
    return this.skipWhile(Lh(t), e);
  },
  sortBy: function(t, e) {
    return Te(this, sc(this, e, t));
  },
  take: function(t) {
    return this.slice(0, Math.max(0, t));
  },
  takeLast: function(t) {
    return this.slice(-Math.max(0, t));
  },
  takeWhile: function(t, e) {
    return Te(this, CM(this, t, e));
  },
  takeUntil: function(t, e) {
    return this.takeWhile(Lh(t), e);
  },
  update: function(t) {
    return t(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  // ### Hashable Object
  hashCode: function() {
    return this.__hash || (this.__hash = a4(this));
  }
  // ### Internal
  // abstract __iterate(fn, reverse)
  // abstract __iterator(type, reverse)
});
var Dn = Ir.prototype;
Dn[BA] = !0;
Dn[Ad] = Dn.values;
Dn.toJSON = Dn.toArray;
Dn.__toStringMapper = pl;
Dn.inspect = Dn.toSource = function() {
  return this.toString();
};
Dn.chain = Dn.flatMap;
Dn.contains = Dn.includes;
gu(lo, {
  // ### More sequential methods
  flip: function() {
    return Te(this, nD(this));
  },
  mapEntries: function(t, e) {
    var r = this, n = 0;
    return Te(
      this,
      this.toSeq().map(function(i, o) {
        return t.call(e, [o, i], n++, r);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(t, e) {
    var r = this;
    return Te(
      this,
      this.toSeq().flip().map(function(n, i) {
        return t.call(e, n, i, r);
      }).flip()
    );
  }
});
var rh = lo.prototype;
rh[$A] = !0;
rh[Ad] = Dn.entries;
rh.toJSON = TD;
rh.__toStringMapper = function(t, e) {
  return pl(e) + ": " + pl(t);
};
gu(mu, {
  // ### Conversion to other types
  toKeyedSeq: function() {
    return new xd(this, !1);
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  filter: function(t, e) {
    return Te(this, oD(this, t, e, !1));
  },
  findIndex: function(t, e) {
    var r = this.findEntry(t, e);
    return r ? r[0] : -1;
  },
  indexOf: function(t) {
    var e = this.keyOf(t);
    return e === void 0 ? -1 : e;
  },
  lastIndexOf: function(t) {
    var e = this.lastKeyOf(t);
    return e === void 0 ? -1 : e;
  },
  reverse: function() {
    return Te(this, bm(this, !1));
  },
  slice: function(t, e) {
    return Te(this, wm(this, t, e, !1));
  },
  splice: function(t, e) {
    var r = arguments.length;
    if (e = Math.max(e || 0, 0), r === 0 || r === 2 && !e)
      return this;
    t = Jl(t, t < 0 ? this.count() : this.size);
    var n = this.slice(0, t);
    return Te(
      this,
      r === 1 ? n : n.concat(Yo(arguments, 2), this.slice(t + e))
    );
  },
  // ### More collection methods
  findLastIndex: function(t, e) {
    var r = this.findLastEntry(t, e);
    return r ? r[0] : -1;
  },
  first: function(t) {
    return this.get(0, t);
  },
  flatten: function(t) {
    return Te(this, aD(this, t, !1));
  },
  get: function(t, e) {
    return t = qa(this, t), t < 0 || this.size === 1 / 0 || this.size !== void 0 && t > this.size ? e : this.find(function(r, n) {
      return n === t;
    }, void 0, e);
  },
  has: function(t) {
    return t = qa(this, t), t >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || t < this.size : this.indexOf(t) !== -1);
  },
  interpose: function(t) {
    return Te(this, MM(this, t));
  },
  interleave: function() {
    var t = [this].concat(Yo(arguments)), e = Fh(this.toSeq(), Fo.of, t), r = e.flatten(!0);
    return e.size && (r.size = e.size * t.length), Te(this, r);
  },
  keySeq: function() {
    return r4(0, this.size);
  },
  last: function(t) {
    return this.get(-1, t);
  },
  skipWhile: function(t, e) {
    return Te(this, sD(this, t, e, !1));
  },
  zip: function() {
    var t = [this].concat(Yo(arguments));
    return Te(this, Fh(this, Qw, t));
  },
  zipAll: function() {
    var t = [this].concat(Yo(arguments));
    return Te(this, Fh(this, Qw, t, !0));
  },
  zipWith: function(t) {
    var e = Yo(arguments);
    return e[0] = this, Te(this, Fh(this, t, e));
  }
});
var Wc = mu.prototype;
Wc[KA] = !0;
Wc[Kc] = !0;
gu(Bc, {
  // ### ES6 Collection methods (ES6 Array and Map)
  get: function(t, e) {
    return this.has(t) ? t : e;
  },
  includes: function(t) {
    return this.has(t);
  },
  // ### More sequential methods
  keySeq: function() {
    return this.valueSeq();
  }
});
var fc = Bc.prototype;
fc.has = Dn.includes;
fc.contains = fc.includes;
fc.keys = fc.values;
gu($a, rh);
gu(Fo, Wc);
gu(Qc, fc);
function Kw(t, e, r, n, i, o) {
  return Ji(t.size), t.__iterate(function(s, u, c) {
    i ? (i = !1, r = s) : r = e.call(n, r, s, u, c);
  }, o), r;
}
function o4(t, e) {
  return e;
}
function s4(t, e) {
  return [e, t];
}
function Lh(t) {
  return function() {
    return !t.apply(this, arguments);
  };
}
function Vw(t) {
  return function() {
    return -t.apply(this, arguments);
  };
}
function Qw() {
  return Yo(arguments);
}
function Yw(t, e) {
  return t < e ? 1 : t > e ? -1 : 0;
}
function a4(t) {
  if (t.size === 1 / 0)
    return 0;
  var e = Do(t), r = dr(t), n = e ? 1 : 0, i = t.__iterate(
    r ? e ? function(o, s) {
      n = 31 * n + Gw(gi(o), gi(s)) | 0;
    } : function(o, s) {
      n = n + Gw(gi(o), gi(s)) | 0;
    } : e ? function(o) {
      n = 31 * n + gi(o) | 0;
    } : function(o) {
      n = n + gi(o) | 0;
    }
  );
  return u4(i, n);
}
function u4(t, e) {
  return e = Ef(e, 3432918353), e = Ef(e << 15 | e >>> -15, 461845907), e = Ef(e << 13 | e >>> -13, 5), e = (e + 3864292196 | 0) ^ t, e = Ef(e ^ e >>> 16, 2246822507), e = Ef(e ^ e >>> 13, 3266489909), e = Rd(e ^ e >>> 16), e;
}
function Gw(t, e) {
  return t ^ e + 2654435769 + (t << 6) + (t >> 2) | 0;
}
var ml = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? s_() : ID(r) ? r : s_().withMutations(function(n) {
      var i = Bc(r);
      Ji(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(r) {
    return this(lo(r).keySeq());
  }, e.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, e;
}(Pd);
ml.isOrderedSet = ID;
var bu = ml.prototype;
bu[Kc] = !0;
bu.zip = Wc.zip;
bu.zipWith = Wc.zipWith;
bu.zipAll = Wc.zipAll;
bu.__empty = s_;
bu.__make = PD;
function PD(t, e) {
  var r = Object.create(bu);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var Ww;
function s_() {
  return Ww || (Ww = PD(Mf()));
}
function c4(t) {
  if ($c(t))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (ns(t))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (t === null || typeof t != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var Ht = function(t, e) {
  var r;
  c4(t);
  var n = function(o) {
    var s = this;
    if (o instanceof n)
      return o;
    if (!(this instanceof n))
      return new n(o);
    if (!r) {
      r = !0;
      var u = Object.keys(t), c = i._indices = {};
      i._name = e, i._keys = u, i._defaultValues = t;
      for (var a = 0; a < u.length; a++) {
        var f = u[a];
        c[f] = a, i[f] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + Um(this) + ' with property "' + f + '" since that property name is part of the Record API.'
        ) : f4(i, f);
      }
    }
    return this.__ownerID = void 0, this._values = Td().withMutations(function(h) {
      h.setSize(s._keys.length), lo(o).forEach(function(p, d) {
        h.set(s._indices[d], p === s._defaultValues[d] ? void 0 : p);
      });
    }), this;
  }, i = n.prototype = Object.create(Me);
  return i.constructor = n, e && (n.displayName = e), n;
};
Ht.prototype.toString = function() {
  for (var t = Um(this) + " { ", e = this._keys, r, n = 0, i = e.length; n !== i; n++)
    r = e[n], t += (n ? ", " : "") + r + ": " + pl(this.get(r));
  return t + " }";
};
Ht.prototype.equals = function(t) {
  return this === t || $c(t) && lc(this).equals(lc(t));
};
Ht.prototype.hashCode = function() {
  return lc(this).hashCode();
};
Ht.prototype.has = function(t) {
  return this._indices.hasOwnProperty(t);
};
Ht.prototype.get = function(t, e) {
  if (!this.has(t))
    return e;
  var r = this._indices[t], n = this._values.get(r);
  return n === void 0 ? this._defaultValues[t] : n;
};
Ht.prototype.set = function(t, e) {
  if (this.has(t)) {
    var r = this._values.set(
      this._indices[t],
      e === this._defaultValues[t] ? void 0 : e
    );
    if (r !== this._values && !this.__ownerID)
      return Lm(this, r);
  }
  return this;
};
Ht.prototype.remove = function(t) {
  return this.set(t);
};
Ht.prototype.clear = function() {
  var t = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : Lm(this, t);
};
Ht.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
Ht.prototype.toSeq = function() {
  return lc(this);
};
Ht.prototype.toJS = function() {
  return Cp(this);
};
Ht.prototype.entries = function() {
  return this.__iterator(so);
};
Ht.prototype.__iterator = function(t, e) {
  return lc(this).__iterator(t, e);
};
Ht.prototype.__iterate = function(t, e) {
  return lc(this).__iterate(t, e);
};
Ht.prototype.__ensureOwner = function(t) {
  if (t === this.__ownerID)
    return this;
  var e = this._values.__ensureOwner(t);
  return t ? Lm(this, e, t) : (this.__ownerID = t, this._values = e, this);
};
Ht.isRecord = $c;
Ht.getDescriptiveName = Um;
var Me = Ht.prototype;
Me[QA] = !0;
Me[Hl] = Me.remove;
Me.deleteIn = Me.removeIn = Am;
Me.getIn = xD;
Me.hasIn = Dn.hasIn;
Me.merge = pD;
Me.mergeWith = dD;
Me.mergeIn = Pm;
Me.mergeDeep = yD;
Me.mergeDeepWith = _D;
Me.mergeDeepIn = km;
Me.setIn = Im;
Me.update = Dm;
Me.updateIn = Rm;
Me.withMutations = Xl;
Me.asMutable = th;
Me.asImmutable = eh;
Me[Ad] = Me.entries;
Me.toJSON = Me.toObject = Dn.toObject;
Me.inspect = Me.toSource = function() {
  return this.toString();
};
function Lm(t, e, r) {
  var n = Object.create(Object.getPrototypeOf(t));
  return n._values = e, n.__ownerID = r, n;
}
function Um(t) {
  return t.constructor.displayName || t.constructor.name || "Record";
}
function lc(t) {
  return _m(t._keys.map(function(e) {
    return [e, t.get(e)];
  }));
}
function f4(t, e) {
  try {
    Object.defineProperty(t, e, {
      get: function() {
        return this.get(e);
      },
      set: function(r) {
        Om(this.__ownerID, "Cannot set on an immutable record."), this.set(e, r);
      }
    });
  } catch {
  }
}
const l4 = {
  startDate: void 0,
  endDate: void 0,
  userLimit: 0,
  projectLimit: 0,
  isTrial: !1,
  isExpired: !1,
  functionalities: []
};
class h4 extends Ht(l4, "Subscription") {
  get isValid() {
    return !!this.startDate && !!this.endDate;
  }
  get isActive() {
    return !this.startDate || !this.endDate ? !1 : new jl(this.startDate, this.endDate).contains(Er.now());
  }
  get daysLeft() {
    return this.endDate ? this.endDate.getAbsoluteDifferenceInDays(Er.now()) : 0;
  }
  hasEndDateIncoming() {
    return this.endDate ? this.endDate.isAfterInDays(Er.now()) : !1;
  }
}
function p4(t) {
  const e = t;
  return e == null ? void 0 : e.code;
}
const d4 = 3;
function v4(t, e = d4) {
  return (r, n) => {
    const i = p4(n);
    if (!i)
      return !1;
    let o;
    return Array.isArray(t) ? o = t.includes(i) : o = t === i, r <= e && o;
  };
}
const y4 = new h4();
Mr({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  subscription: y4,
  hasFunctionality: () => !1
});
v4(Oq.TOO_MANY_REQUESTS);
Se.createContext({
  i18n: void 0
});
var _4 = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(t) {
  (function(e, r) {
    t.exports ? t.exports = r() : e.numeral = r();
  })(Hs, function() {
    var e, r, n = "2.0.6", i = {}, o = {}, s = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, u = {
      currentLocale: s.currentLocale,
      zeroFormat: s.zeroFormat,
      nullFormat: s.nullFormat,
      defaultFormat: s.defaultFormat,
      scalePercentBy100: s.scalePercentBy100
    };
    function c(a, f) {
      this._input = a, this._value = f;
    }
    return e = function(a) {
      var f, h, p, d;
      if (e.isNumeral(a))
        f = a.value();
      else if (a === 0 || typeof a > "u")
        f = 0;
      else if (a === null || r.isNaN(a))
        f = null;
      else if (typeof a == "string")
        if (u.zeroFormat && a === u.zeroFormat)
          f = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          f = null;
        else {
          for (h in i)
            if (d = typeof i[h].regexps.unformat == "function" ? i[h].regexps.unformat() : i[h].regexps.unformat, d && a.match(d)) {
              p = i[h].unformat;
              break;
            }
          p = p || e._.stringToNumber, f = p(a);
        }
      else
        f = Number(a) || null;
      return new c(a, f);
    }, e.version = n, e.isNumeral = function(a) {
      return a instanceof c;
    }, e._ = r = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(a, f, h) {
        var p = o[e.options.currentLocale], d = !1, _ = !1, m = 0, b = "", O = 1e12, S = 1e9, k = 1e6, T = 1e3, x = "", P = !1, R, D, I, j, Y, H, B;
        if (a = a || 0, D = Math.abs(a), e._.includes(f, "(") ? (d = !0, f = f.replace(/[\(|\)]/g, "")) : (e._.includes(f, "+") || e._.includes(f, "-")) && (Y = e._.includes(f, "+") ? f.indexOf("+") : a < 0 ? f.indexOf("-") : -1, f = f.replace(/[\+|\-]/g, "")), e._.includes(f, "a") && (R = f.match(/a(k|m|b|t)?/), R = R ? R[1] : !1, e._.includes(f, " a") && (b = " "), f = f.replace(new RegExp(b + "a[kmbt]?"), ""), D >= O && !R || R === "t" ? (b += p.abbreviations.trillion, a = a / O) : D < O && D >= S && !R || R === "b" ? (b += p.abbreviations.billion, a = a / S) : D < S && D >= k && !R || R === "m" ? (b += p.abbreviations.million, a = a / k) : (D < k && D >= T && !R || R === "k") && (b += p.abbreviations.thousand, a = a / T)), e._.includes(f, "[.]") && (_ = !0, f = f.replace("[.]", ".")), I = a.toString().split(".")[0], j = f.split(".")[1], H = f.indexOf(","), m = (f.split(".")[0].split(",")[0].match(/0/g) || []).length, j ? (e._.includes(j, "[") ? (j = j.replace("]", ""), j = j.split("["), x = e._.toFixed(a, j[0].length + j[1].length, h, j[1].length)) : x = e._.toFixed(a, j.length, h), I = x.split(".")[0], e._.includes(x, ".") ? x = p.delimiters.decimal + x.split(".")[1] : x = "", _ && Number(x.slice(1)) === 0 && (x = "")) : I = e._.toFixed(a, 0, h), b && !R && Number(I) >= 1e3 && b !== p.abbreviations.trillion)
          switch (I = String(Number(I) / 1e3), b) {
            case p.abbreviations.thousand:
              b = p.abbreviations.million;
              break;
            case p.abbreviations.million:
              b = p.abbreviations.billion;
              break;
            case p.abbreviations.billion:
              b = p.abbreviations.trillion;
              break;
          }
        if (e._.includes(I, "-") && (I = I.slice(1), P = !0), I.length < m)
          for (var tt = m - I.length; tt > 0; tt--)
            I = "0" + I;
        return H > -1 && (I = I.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + p.delimiters.thousands)), f.indexOf(".") === 0 && (I = ""), B = I + x + (b || ""), d ? B = (d && P ? "(" : "") + B + (d && P ? ")" : "") : Y >= 0 ? B = Y === 0 ? (P ? "-" : "+") + B : B + (P ? "-" : "+") : P && (B = "-" + B), B;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(a) {
        var f = o[u.currentLocale], h = a, p = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, d, _, m;
        if (u.zeroFormat && a === u.zeroFormat)
          _ = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          _ = null;
        else {
          _ = 1, f.delimiters.decimal !== "." && (a = a.replace(/\./g, "").replace(f.delimiters.decimal, "."));
          for (d in p)
            if (m = new RegExp("[^a-zA-Z]" + f.abbreviations[d] + "(?:\\)|(\\" + f.currency.symbol + ")?(?:\\))?)?$"), h.match(m)) {
              _ *= Math.pow(10, p[d]);
              break;
            }
          _ *= (a.split("-").length + Math.min(a.split("(").length - 1, a.split(")").length - 1)) % 2 ? 1 : -1, a = a.replace(/[^0-9\.]+/g, ""), _ *= Number(a);
        }
        return _;
      },
      isNaN: function(a) {
        return typeof a == "number" && isNaN(a);
      },
      includes: function(a, f) {
        return a.indexOf(f) !== -1;
      },
      insert: function(a, f, h) {
        return a.slice(0, h) + f + a.slice(h);
      },
      reduce: function(a, f) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof f != "function")
          throw new TypeError(f + " is not a function");
        var h = Object(a), p = h.length >>> 0, d = 0, _;
        if (arguments.length === 3)
          _ = arguments[2];
        else {
          for (; d < p && !(d in h); )
            d++;
          if (d >= p)
            throw new TypeError("Reduce of empty array with no initial value");
          _ = h[d++];
        }
        for (; d < p; d++)
          d in h && (_ = f(_, h[d], d, h));
        return _;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(a) {
        var f = a.toString().split(".");
        return f.length < 2 ? 1 : Math.pow(10, f[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var a = Array.prototype.slice.call(arguments);
        return a.reduce(function(f, h) {
          var p = r.multiplier(h);
          return f > p ? f : p;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(a, f, h, p) {
        var d = a.toString().split("."), _ = f - (p || 0), m, b, O, S;
        return d.length === 2 ? m = Math.min(Math.max(d[1].length, _), f) : m = _, O = Math.pow(10, m), S = (h(a + "e+" + m) / O).toFixed(m), p > f - m && (b = new RegExp("\\.?0{1," + (p - (f - m)) + "}$"), S = S.replace(b, "")), S;
      }
    }, e.options = u, e.formats = i, e.locales = o, e.locale = function(a) {
      return a && (u.currentLocale = a.toLowerCase()), u.currentLocale;
    }, e.localeData = function(a) {
      if (!a)
        return o[u.currentLocale];
      if (a = a.toLowerCase(), !o[a])
        throw new Error("Unknown locale : " + a);
      return o[a];
    }, e.reset = function() {
      for (var a in s)
        u[a] = s[a];
    }, e.zeroFormat = function(a) {
      u.zeroFormat = typeof a == "string" ? a : null;
    }, e.nullFormat = function(a) {
      u.nullFormat = typeof a == "string" ? a : null;
    }, e.defaultFormat = function(a) {
      u.defaultFormat = typeof a == "string" ? a : "0.0";
    }, e.register = function(a, f, h) {
      if (f = f.toLowerCase(), this[a + "s"][f])
        throw new TypeError(f + " " + a + " already registered.");
      return this[a + "s"][f] = h, h;
    }, e.validate = function(a, f) {
      var h, p, d, _, m, b, O, S;
      if (typeof a != "string" && (a += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", a)), a = a.trim(), a.match(/^\d+$/))
        return !0;
      if (a === "")
        return !1;
      try {
        O = e.localeData(f);
      } catch {
        O = e.localeData(e.locale());
      }
      return d = O.currency.symbol, m = O.abbreviations, h = O.delimiters.decimal, O.delimiters.thousands === "." ? p = "\\." : p = O.delimiters.thousands, S = a.match(/^[^\d]+/), S !== null && (a = a.substr(1), S[0] !== d) || (S = a.match(/[^\d]+$/), S !== null && (a = a.slice(0, -1), S[0] !== m.thousand && S[0] !== m.million && S[0] !== m.billion && S[0] !== m.trillion)) ? !1 : (b = new RegExp(p + "{2}"), a.match(/[^\d.,]/g) ? !1 : (_ = a.split(h), _.length > 2 ? !1 : _.length < 2 ? !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) : _[0].length === 1 ? !!_[0].match(/^\d+$/) && !_[0].match(b) && !!_[1].match(/^\d+$/) : !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) && !!_[1].match(/^\d+$/)));
    }, e.fn = c.prototype = {
      clone: function() {
        return e(this);
      },
      format: function(a, f) {
        var h = this._value, p = a || u.defaultFormat, d, _, m;
        if (f = f || Math.round, h === 0 && u.zeroFormat !== null)
          _ = u.zeroFormat;
        else if (h === null && u.nullFormat !== null)
          _ = u.nullFormat;
        else {
          for (d in i)
            if (p.match(i[d].regexps.format)) {
              m = i[d].format;
              break;
            }
          m = m || e._.numberToFormat, _ = m(h, p, f);
        }
        return _;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(a) {
        return this._value = Number(a), this;
      },
      add: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p + Math.round(f * d);
        }
        return this._value = r.reduce([this._value, a], h, 0) / f, this;
      },
      subtract: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p - Math.round(f * d);
        }
        return this._value = r.reduce([a], h, Math.round(this._value * f)) / f, this;
      },
      multiply: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) * Math.round(p * m) / Math.round(m * m);
        }
        return this._value = r.reduce([this._value, a], f, 1), this;
      },
      divide: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) / Math.round(p * m);
        }
        return this._value = r.reduce([this._value, a], f), this;
      },
      difference: function(a) {
        return Math.abs(e(this._value).subtract(a).value());
      }
    }, e.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(a) {
        var f = a % 10;
        return ~~(a % 100 / 10) === 1 ? "th" : f === 1 ? "st" : f === 2 ? "nd" : f === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      e.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " BPS") ? " " : "", d;
          return a = a * 1e4, f = f.replace(/\s?BPS/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "BPS"), d = d.join("")) : d = d + p + "BPS", d;
        },
        unformat: function(a) {
          return +(e._.stringToNumber(a) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var a = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, f = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, h = a.suffixes.concat(f.suffixes.filter(function(d) {
        return a.suffixes.indexOf(d) < 0;
      })), p = h.join("|");
      p = "(" + p.replace("B", "B(?!PS)") + ")", e.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(p)
        },
        format: function(d, _, m) {
          var b, O = e._.includes(_, "ib") ? f : a, S = e._.includes(_, " b") || e._.includes(_, " ib") ? " " : "", k, T, x;
          for (_ = _.replace(/\s?i?b/, ""), k = 0; k <= O.suffixes.length; k++)
            if (T = Math.pow(O.base, k), x = Math.pow(O.base, k + 1), d === null || d === 0 || d >= T && d < x) {
              S += O.suffixes[k], T > 0 && (d = d / T);
              break;
            }
          return b = e._.numberToFormat(d, _, m), b + S;
        },
        unformat: function(d) {
          var _ = e._.stringToNumber(d), m, b;
          if (_) {
            for (m = a.suffixes.length - 1; m >= 0; m--) {
              if (e._.includes(d, a.suffixes[m])) {
                b = Math.pow(a.base, m);
                break;
              }
              if (e._.includes(d, f.suffixes[m])) {
                b = Math.pow(f.base, m);
                break;
              }
            }
            _ *= b || 1;
          }
          return _;
        }
      });
    }(), function() {
      e.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d = {
            before: f.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: f.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, _, m, b;
          for (f = f.replace(/\s?\$\s?/, ""), _ = e._.numberToFormat(a, f, h), a >= 0 ? (d.before = d.before.replace(/[\-\(]/, ""), d.after = d.after.replace(/[\-\)]/, "")) : a < 0 && !e._.includes(d.before, "-") && !e._.includes(d.before, "(") && (d.before = "-" + d.before), b = 0; b < d.before.length; b++)
            switch (m = d.before[b], m) {
              case "$":
                _ = e._.insert(_, p.currency.symbol, b);
                break;
              case " ":
                _ = e._.insert(_, " ", b + p.currency.symbol.length - 1);
                break;
            }
          for (b = d.after.length - 1; b >= 0; b--)
            switch (m = d.after[b], m) {
              case "$":
                _ = b === d.after.length - 1 ? _ + p.currency.symbol : e._.insert(_, p.currency.symbol, -(d.after.length - (1 + b)));
                break;
              case " ":
                _ = b === d.after.length - 1 ? _ + " " : e._.insert(_, " ", -(d.after.length - (1 + b) + p.currency.symbol.length - 1));
                break;
            }
          return _;
        }
      });
    }(), function() {
      e.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(a, f, h) {
          var p, d = typeof a == "number" && !e._.isNaN(a) ? a.toExponential() : "0e+0", _ = d.split("e");
          return f = f.replace(/e[\+|\-]{1}0/, ""), p = e._.numberToFormat(Number(_[0]), f, h), p + "e" + _[1];
        },
        unformat: function(a) {
          var f = e._.includes(a, "e+") ? a.split("e+") : a.split("e-"), h = Number(f[0]), p = Number(f[1]);
          p = e._.includes(a, "e-") ? p *= -1 : p;
          function d(_, m, b, O) {
            var S = e._.correctionFactor(_, m), k = _ * S * (m * S) / (S * S);
            return k;
          }
          return e._.reduce([h, Math.pow(10, p)], d, 1);
        }
      });
    }(), function() {
      e.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d, _ = e._.includes(f, " o") ? " " : "";
          return f = f.replace(/\s?o/, ""), _ += p.ordinal(a), d = e._.numberToFormat(a, f, h), d + _;
        }
      });
    }(), function() {
      e.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " %") ? " " : "", d;
          return e.options.scalePercentBy100 && (a = a * 100), f = f.replace(/\s?\%/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "%"), d = d.join("")) : d = d + p + "%", d;
        },
        unformat: function(a) {
          var f = e._.stringToNumber(a);
          return e.options.scalePercentBy100 ? f * 0.01 : f;
        }
      });
    }(), function() {
      e.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(a, f, h) {
          var p = Math.floor(a / 60 / 60), d = Math.floor((a - p * 60 * 60) / 60), _ = Math.round(a - p * 60 * 60 - d * 60);
          return p + ":" + (d < 10 ? "0" + d : d) + ":" + (_ < 10 ? "0" + _ : _);
        },
        unformat: function(a) {
          var f = a.split(":"), h = 0;
          return f.length === 3 ? (h = h + Number(f[0]) * 60 * 60, h = h + Number(f[1]) * 60, h = h + Number(f[2])) : f.length === 2 && (h = h + Number(f[0]) * 60, h = h + Number(f[1])), Number(h);
        }
      });
    }(), e;
  });
})(_4);
um.EN;
var kD = /* @__PURE__ */ ((t) => (t[t.LOCAL = -1] = "LOCAL", t[t.CANADA = 0] = "CANADA", t[t.NORTH_EUROPE = 1] = "NORTH_EUROPE", t[t.EUROPE = 2] = "EUROPE", t[t.USA = 3] = "USA", t))(kD || {});
const m4 = {
  id: kD.LOCAL,
  name: ""
};
class g4 extends Ht(m4, "DataCenterAttribute") {
}
var CD = /* @__PURE__ */ ((t) => (t.EN_US = "M/D/YYYY h:mm A", t.EN_CA = "YYYY-MM-DD h:mm A", t.FR_CA = "DD/MM/YYYY HH:mm", t))(CD || {}), $u = /* @__PURE__ */ ((t) => (t.GUEST = "Guest", t.ADMIN = "Admin", t))($u || {}), lp = /* @__PURE__ */ ((t) => (t.UTC = "UTC", t.NEW_YORK = "America/New_York", t.DUBAI = "Asia/Asia/Dubai", t))(lp || {}), jD = /* @__PURE__ */ ((t) => (t.ACTIVE = "Active", t.INACTIVE = "Inactive", t))(jD || {});
const b4 = {
  role: $u.GUEST
};
class w4 extends Ht(b4, "HubUserPermissions") {
}
const E4 = {
  globalId: void 0,
  hashId: "",
  localId: -1,
  name: "",
  creationDate: Er.MIN_VALUE,
  demoDaysLeft: void 0,
  owner: "",
  dataCenterInfo: new g4(),
  metrics: void 0,
  projects: [],
  avatarImage: void 0,
  hasAPIAccessToken: !1,
  APIAccessTokenAcceptationTermsDate: void 0,
  isLinkedToOrganization: !1,
  url: "",
  subscription: void 0,
  projectTemplates: void 0,
  bimTrackRegionalApiUrl: void 0,
  requestingUserPermissions: new w4()
};
class SB extends Ht(E4, "Hub") {
  /**
   * @deprecated use hashId instead.
   */
  get id() {
    return this.hashId;
  }
  /**
   * @deprecated use dataCenterInfo.id instead.
   */
  get dataCenter() {
    return this.dataCenterInfo.id;
  }
  get avatarImageWithDefault() {
    return this.avatarImage;
  }
  get isSubscriptionExpired() {
    return this.subscription ? this.subscription.isExpired : !1;
  }
  get subscriptionPlanProjectLimit() {
    return this.subscription ? this.subscription.projectLimit : 0;
  }
  is(e) {
    return e ? this.id === e.id && this.localId === e.localId : !1;
  }
}
const S4 = {
  totalUsers: void 0
};
class OB extends Ht(S4, "HubMetrics") {
}
var Fi = /* @__PURE__ */ ((t) => (t.TEXT = "text", t.PREDEFINED = "predefined", t.TITLE = "title", t.DESCRIPTION = "description", t.STATUS = "status", t.TYPE = "type", t.PRIORITY = "priority", t.DISCIPLINE = "discipline", t.ZONE = "zone", t.PHASE = "phase", t.ASSIGNED_TO = "assignedto", t.DUE_DATE = "duedate", t.ISSUE_GROUP = "issuegroup", t.TEAM = "team", t.NOTIFY = "notify", t.CONFIDENTIALITY = "confidentiality", t.VISIBILITY = "visibility", t))(Fi || {}), Bm = /* @__PURE__ */ ((t) => (t.ADMIN = "Admin", t.EDITOR = "Editor", t.READER = "Reader", t))(Bm || {}), qD = /* @__PURE__ */ ((t) => (t[t.ACTIVE = 0] = "ACTIVE", t[t.ON_HOLD = 1] = "ON_HOLD", t[t.COMPLETION_PENDING = 2] = "COMPLETION_PENDING", t[t.COMPLETED = 3] = "COMPLETED", t))(qD || {});
const O4 = {
  statuses: [],
  types: [],
  priorities: [],
  zones: [],
  phases: [],
  disciplines: [],
  customAttributes: []
};
class I4 extends Ht(O4, "IssueAttributeOptions") {
}
const A4 = {
  id: -1,
  name: "",
  type: Fi.TEXT,
  values: void 0
};
class D4 extends Ht(A4, "ProjectAttribute") {
}
const R4 = {
  attributes: [],
  selectedColorAttributeForIssue: new D4(),
  integrations: [],
  issueMandatoryAttributes: []
};
class x4 extends Ht(R4, "ProjectSettings") {
}
const T4 = {
  role: Bm.READER,
  teams: [],
  isReviewer: !1
};
class P4 extends Ht(T4, "ProjectUserPermissions") {
}
const k4 = {
  id: -1,
  name: "",
  number: "",
  status: qD.ACTIVE,
  settings: new x4(),
  users: [],
  teams: [],
  requestingUserPermissions: new P4()
};
class IB extends Ht(k4, "Project") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
  getIssueGroupsOptions() {
    return this.getOptionsFor(Fi.ISSUE_GROUP);
  }
  getAttributesFor(e) {
    return this.settings.attributes.filter(
      (r) => r.type === e
    ) || [];
  }
  getSortedCustomAttributes() {
    return [
      ...this.getAttributesFor(Fi.TEXT),
      ...this.getAttributesFor(Fi.PREDEFINED)
    ].sort((e, r) => e.id - r.id);
  }
  getOptionsFor(e) {
    const r = this.settings.attributes.find(
      (n) => n.type === e
    );
    return r && r.values ? r.values : [];
  }
  getOptionsForIssue() {
    const e = this.getOptionsFor(Fi.STATUS), r = this.getOptionsFor(Fi.TYPE), n = this.getOptionsFor(Fi.PRIORITY), i = this.getOptionsFor(Fi.ZONE), o = this.getOptionsFor(Fi.PHASE), s = this.getOptionsFor(Fi.DISCIPLINE), u = this.getSortedCustomAttributes();
    return new I4({
      statuses: e,
      types: r,
      priorities: n,
      zones: i,
      phases: o,
      disciplines: s,
      customAttributes: u
    });
  }
  getStatusesBaseOnUser(e, r) {
    const n = e.teams ?? [];
    let i = this.getOptionsFor(Fi.STATUS).filter((o) => {
      const s = o.teams ? o.teams.map((u) => u.id) : [];
      return s.length === 0 || n.some((u) => s.indexOf(u.id) !== -1);
    });
    return i.some((o) => o.id === r.id) || (i = [...i, r].sort((o, s) => o.name.localeCompare(s.name))), i;
  }
  getIntegrationFor(e) {
    return this.settings.integrations.find(
      (r) => r.integration.name.toLowerCase() === e.toLowerCase()
    );
  }
  getIssueMandatoryAttributes() {
    return this.settings.issueMandatoryAttributes;
  }
  getAttributes() {
    return this.settings.attributes;
  }
}
const C4 = {
  id: -1,
  name: ""
};
class AB extends Ht(C4, "ProjectTemplate") {
}
const j4 = {
  id: -1,
  name: ""
};
class DB extends Ht(j4, "ProjectTeam") {
}
const q4 = {
  id: -1,
  name: "",
  siteUrl: ""
};
class M4 extends Ht(q4, "Integration") {
}
const F4 = {
  id: -1,
  name: "",
  color: void 0,
  teams: void 0
};
class RB extends Ht(F4, "ProjectAttributeValue") {
}
const N4 = {
  companyId: -1,
  companyName: "",
  projectId: -1,
  projectName: "",
  createRFIComment: !1
};
class xB extends Ht(N4, "ProcoreIntegrationData") {
}
const z4 = {
  id: -1,
  integration: new M4(),
  data: {}
};
class TB extends Ht(z4, "ProjectIntegration") {
}
const L4 = {
  id: "",
  name: ""
};
class PB extends Ht(L4, "PropertyAttribute") {
}
const U4 = {
  user: void 0,
  hub: void 0,
  project: void 0,
  bimTrackApiUrl: ""
};
class kB extends Ht(U4, "Session") {
}
const B4 = {
  id: "",
  name: "",
  format: CD.EN_US
};
class $4 extends Ht(B4, "DateFormatAttribute") {
}
const K4 = {
  id: um.EN,
  name: ""
};
class V4 extends Ht(K4, "LanguageAttribute") {
}
const Q4 = {
  id: lp.NEW_YORK,
  name: lp.NEW_YORK,
  nameIana: lp.NEW_YORK,
  offset: void 0
};
class Y4 extends Ht(Q4, "TimeZoneAttribute") {
}
const G4 = {
  firstName: "",
  lastName: "",
  title: "",
  company: "",
  country: void 0,
  industry: void 0,
  jobTitle: "",
  dateFormat: new $4(),
  avatarImage: "",
  language: new V4(),
  website: void 0,
  timeZone: new Y4()
};
class W4 extends Ht(G4, "UserProfile") {
  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
  get initials() {
    return this.firstName && this.lastName ? `${Array.from(this.firstName)[0]}${Array.from(this.lastName)[0]}` : "";
  }
  getDateTimeFormat() {
    return this.dateFormat.format;
  }
  getDateFormat() {
    return this.dateFormat.format.replace(/ .*/, "");
  }
  getTimeFormat() {
    return this.dateFormat.format.replace(/([^\s]+) /, "");
  }
}
const H4 = {
  id: 0,
  globalId: void 0,
  email: "",
  profile: new W4(),
  status: jD.INACTIVE,
  activationDate: void 0,
  invitationPending: !1,
  isPending: !1,
  lastHubProjectActivity: void 0,
  canResendInvite: void 0,
  hubOwner: !1,
  hubRole: $u.GUEST,
  projectOwner: !1,
  projectReviewer: !1,
  projectRole: void 0,
  projects: [],
  teams: [],
  isProviderExternal: !1,
  isLoggedWithSso: !1,
  isHubUserSsoRestricted: !1
};
class CB extends Ht(H4, "User") {
  get fullName() {
    return this.isValid() ? this.profile.fullName : `${this.profile.title}`.trim();
  }
  get fullNameAndEmail() {
    return `${this.fullName} (${this.email})`.trim();
  }
  get initials() {
    return this.profile.initials;
  }
  isNew() {
    return this.id === 0;
  }
  isOwner() {
    return this.hubOwner;
  }
  isAdmin() {
    return this.hubRole === $u.ADMIN;
  }
  isGuest() {
    return this.hubRole === $u.GUEST;
  }
  isProjectAdmin() {
    return this.projectRole === Bm.ADMIN;
  }
  isProjectOwner() {
    return this.projectOwner;
  }
  isTeamMember(e) {
    return this.teams.some((r) => r.id === e);
  }
  canEditUser(e) {
    return this.is(e) || this.hubRole === $u.GUEST ? !1 : this.isOwner() || !e.isOwner();
  }
  is(e) {
    return e ? this.globalId && e.globalId ? this.globalId === e.globalId : this.id === e.id : !1;
  }
  getDateTimeFormat() {
    return this.profile.getDateTimeFormat();
  }
  getDateFormat() {
    return this.profile.getDateFormat();
  }
  getTimeFormat() {
    return this.profile.getTimeFormat();
  }
  isValid() {
    return this.id > 0 || !!this.globalId;
  }
}
const J4 = {
  id: -1,
  name: ""
};
class jB extends Ht(J4, "UserProject") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
}
var Z4 = Object.defineProperty, X4 = (t, e, r) => e in t ? Z4(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Hw = (t, e, r) => (X4(t, typeof e != "symbol" ? e + "" : e, r), r), Js = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function tF(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var a_ = { exports: {} }, Jw = Object.hasOwnProperty, eF = Object.getPrototypeOf, Zw = Error.captureStackTrace, rF = jp;
function jp(t, e) {
  if (t && typeof t == "object" ? (e = t, t = void 0) : this.message = t, e)
    for (var r in e)
      this[r] = e[r];
  Jw.call(this, "name") || (this.name = Jw.call(eF(this), "name") ? this.name : this.constructor.name), Zw && !("stack" in this) && Zw(this, this.constructor);
}
jp.prototype = Object.create(Error.prototype, {
  constructor: { value: jp, configurable: !0, writable: !0 }
});
jp.prototype.name = "StandardError";
const nF = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non-Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi-Status",
  208: "Already Reported",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  307: "Temporary Redirect",
  308: "Permanent Redirect",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "URI Too Long",
  415: "Unsupported Media Type",
  416: "Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  421: "Misdirected Request",
  422: "Unprocessable Entity",
  423: "Locked",
  424: "Failed Dependency",
  425: "Unordered Collection",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  509: "Bandwidth Limit Exceeded",
  510: "Not Extended",
  511: "Network Authentication Required"
};
(function(t, e) {
  e = t.exports = o;
  var r = rF, n = nF, i = e;
  function o(a, f, h) {
    if (typeof a == "string" && (a = i[a]), typeof a != "number")
      throw new TypeError("Non-numeric HTTP code");
    typeof f == "object" && f != null && (h = f, f = null), r.call(this, f || n[a], h), this.code = a;
  }
  o.prototype = Object.create(r.prototype, {
    constructor: { value: o, configurable: !0, writable: !0 }
  }), o.prototype.name = "HttpError", Object.defineProperties(o.prototype, {
    statusCode: c("code"),
    statusMessage: c("message"),
    status: {
      configurable: !0,
      get: function() {
        return this.code;
      },
      set: function(a) {
        Object.defineProperty(this, "status", {
          value: a,
          configurable: !0,
          enumerable: !0,
          writable: !0
        });
      }
    }
  }), o.prototype.toString = function() {
    return this.name + ": " + this.code + " " + this.message;
  };
  for (var s in n) {
    var u = n[s];
    e[u.replace("'", "").replace(/[- ]/g, "_").toUpperCase()] = +s;
  }
  function c(a) {
    return {
      configurable: !0,
      get: function() {
        return this[a];
      },
      set: function(f) {
        return this[a] = f;
      }
    };
  }
})(a_, a_.exports);
var iF = a_.exports;
const oF = /* @__PURE__ */ tF(iF);
var qp = { exports: {} };
qp.exports;
(function(t, e) {
  var r = 200, n = "Expected a function", i = "__lodash_hash_undefined__", o = 1, s = 2, u = 1 / 0, c = 9007199254740991, a = "[object Arguments]", f = "[object Array]", h = "[object Boolean]", p = "[object Date]", d = "[object Error]", _ = "[object Function]", m = "[object GeneratorFunction]", b = "[object Map]", O = "[object Number]", S = "[object Object]", k = "[object Promise]", T = "[object RegExp]", x = "[object Set]", P = "[object String]", R = "[object Symbol]", D = "[object WeakMap]", I = "[object ArrayBuffer]", j = "[object DataView]", Y = "[object Float32Array]", H = "[object Float64Array]", B = "[object Int8Array]", tt = "[object Int16Array]", lt = "[object Int32Array]", te = "[object Uint8Array]", pt = "[object Uint8ClampedArray]", At = "[object Uint16Array]", ft = "[object Uint32Array]", Lt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, dt = /^\w*$/, mt = /^\./, st = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Nt = /[\\^$.*+?()[\]{}|]/g, Qt = /\\(\\)?/g, Rt = /^\[object .+?Constructor\]$/, xt = /^(?:0|[1-9]\d*)$/, N = {};
  N[Y] = N[H] = N[B] = N[tt] = N[lt] = N[te] = N[pt] = N[At] = N[ft] = !0, N[a] = N[f] = N[I] = N[h] = N[j] = N[p] = N[d] = N[_] = N[b] = N[O] = N[S] = N[T] = N[x] = N[P] = N[D] = !1;
  var ht = typeof Js == "object" && Js && Js.Object === Object && Js, gt = typeof self == "object" && self && self.Object === Object && self, X = ht || gt || Function("return this")(), wt = e && !e.nodeType && e, jt = wt && !0 && t && !t.nodeType && t, qt = jt && jt.exports === wt, U = qt && ht.process, $ = function() {
    try {
      return U && U.binding("util");
    } catch {
    }
  }(), W = $ && $.isTypedArray;
  function et(l, v) {
    for (var g = -1, E = l ? l.length : 0; ++g < E; )
      if (v(l[g], g, l))
        return !0;
    return !1;
  }
  function ot(l) {
    return function(v) {
      return v == null ? void 0 : v[l];
    };
  }
  function Dt(l, v) {
    for (var g = -1, E = Array(l); ++g < l; )
      E[g] = v(g);
    return E;
  }
  function St(l) {
    return function(v) {
      return l(v);
    };
  }
  function Et(l, v) {
    return l == null ? void 0 : l[v];
  }
  function ue(l) {
    var v = !1;
    if (l != null && typeof l.toString != "function")
      try {
        v = !!(l + "");
      } catch {
      }
    return v;
  }
  function ae(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E, M) {
      g[++v] = [M, E];
    }), g;
  }
  function ce(l, v) {
    return function(g) {
      return l(v(g));
    };
  }
  function Yt(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E) {
      g[++v] = E;
    }), g;
  }
  var Ot = Array.prototype, Oe = Function.prototype, Gt = Object.prototype, se = X["__core-js_shared__"], Zt = function() {
    var l = /[^.]+$/.exec(se && se.keys && se.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), fe = Oe.toString, vt = Gt.hasOwnProperty, Mt = Gt.toString, Fr = RegExp(
    "^" + fe.call(vt).replace(Nt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), We = X.Symbol, He = X.Uint8Array, Nr = Gt.propertyIsEnumerable, Ie = Ot.splice, Je = ce(Object.keys, Object), It = _e(X, "DataView"), Tt = _e(X, "Map"), ee = _e(X, "Promise"), ye = _e(X, "Set"), Ae = _e(X, "WeakMap"), Ut = _e(Object, "create"), zr = ne(It), Ze = ne(Tt), Xe = ne(ee), Lr = ne(ye), Ur = ne(Ae), re = We ? We.prototype : void 0, De = re ? re.valueOf : void 0, tr = re ? re.toString : void 0;
  function Pt(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Br() {
    this.__data__ = Ut ? Ut(null) : {};
  }
  function y(l) {
    return this.has(l) && delete this.__data__[l];
  }
  function w(l) {
    var v = this.__data__;
    if (Ut) {
      var g = v[l];
      return g === i ? void 0 : g;
    }
    return vt.call(v, l) ? v[l] : void 0;
  }
  function A(l) {
    var v = this.__data__;
    return Ut ? v[l] !== void 0 : vt.call(v, l);
  }
  function q(l, v) {
    var g = this.__data__;
    return g[l] = Ut && v === void 0 ? i : v, this;
  }
  Pt.prototype.clear = Br, Pt.prototype.delete = y, Pt.prototype.get = w, Pt.prototype.has = A, Pt.prototype.set = q;
  function F(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Q() {
    this.__data__ = [];
  }
  function L(l) {
    var v = this.__data__, g = nr(v, l);
    if (g < 0)
      return !1;
    var E = v.length - 1;
    return g == E ? v.pop() : Ie.call(v, g, 1), !0;
  }
  function z(l) {
    var v = this.__data__, g = nr(v, l);
    return g < 0 ? void 0 : v[g][1];
  }
  function it(l) {
    return nr(this.__data__, l) > -1;
  }
  function J(l, v) {
    var g = this.__data__, E = nr(g, l);
    return E < 0 ? g.push([l, v]) : g[E][1] = v, this;
  }
  F.prototype.clear = Q, F.prototype.delete = L, F.prototype.get = z, F.prototype.has = it, F.prototype.set = J;
  function K(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function ut() {
    this.__data__ = {
      hash: new Pt(),
      map: new (Tt || F)(),
      string: new Pt()
    };
  }
  function Bt(l) {
    return ir(this, l).delete(l);
  }
  function er(l) {
    return ir(this, l).get(l);
  }
  function bt(l) {
    return ir(this, l).has(l);
  }
  function cs(l, v) {
    return ir(this, l).set(l, v), this;
  }
  K.prototype.clear = ut, K.prototype.delete = Bt, K.prototype.get = er, K.prototype.has = bt, K.prototype.set = cs;
  function rr(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.__data__ = new K(); ++v < g; )
      this.add(l[v]);
  }
  function fs(l) {
    return this.__data__.set(l, i), this;
  }
  function ls(l) {
    return this.__data__.has(l);
  }
  rr.prototype.add = rr.prototype.push = fs, rr.prototype.has = ls;
  function kt(l) {
    this.__data__ = new F(l);
  }
  function hs() {
    this.__data__ = new F();
  }
  function ps(l) {
    return this.__data__.delete(l);
  }
  function ds(l) {
    return this.__data__.get(l);
  }
  function vs(l) {
    return this.__data__.has(l);
  }
  function ys(l, v) {
    var g = this.__data__;
    if (g instanceof F) {
      var E = g.__data__;
      if (!Tt || E.length < r - 1)
        return E.push([l, v]), this;
      g = this.__data__ = new K(E);
    }
    return g.set(l, v), this;
  }
  kt.prototype.clear = hs, kt.prototype.delete = ps, kt.prototype.get = ds, kt.prototype.has = vs, kt.prototype.set = ys;
  function _s(l, v) {
    var g = ie(l) || Jn(l) ? Dt(l.length, String) : [], E = g.length, M = !!E;
    for (var C in l)
      (v || vt.call(l, C)) && !(M && (C == "length" || Yn(C, E))) && g.push(C);
    return g;
  }
  function nr(l, v) {
    for (var g = l.length; g--; )
      if (Hn(l[g][0], v))
        return g;
    return -1;
  }
  var ms = ks();
  function gs(l, v) {
    return l && ms(l, v, cr);
  }
  function Kn(l, v) {
    v = or(v, l) ? [v] : Vn(v);
    for (var g = 0, E = v.length; l != null && g < E; )
      l = l[sr(v[g++])];
    return g && g == E ? l : void 0;
  }
  function bs(l) {
    return Mt.call(l);
  }
  function ws(l, v) {
    return l != null && v in Object(l);
  }
  function $r(l, v, g, E, M) {
    return l === v ? !0 : l == null || v == null || !ar(l) && !ur(v) ? l !== l && v !== v : Es(l, v, $r, g, E, M);
  }
  function Es(l, v, g, E, M, C) {
    var V = ie(l), G = ie(v), Z = f, rt = f;
    V || (Z = $t(l), Z = Z == a ? S : Z), G || (rt = $t(v), rt = rt == a ? S : rt);
    var at = Z == S && !ue(l), ct = rt == S && !ue(v), nt = Z == rt;
    if (nt && !at)
      return C || (C = new kt()), V || Bs(l) ? Qn(l, v, g, E, M, C) : Cs(l, v, Z, g, E, M, C);
    if (!(M & s)) {
      var yt = at && vt.call(l, "__wrapped__"), _t = ct && vt.call(v, "__wrapped__");
      if (yt || _t) {
        var Kt = yt ? l.value() : l, Ct = _t ? v.value() : v;
        return C || (C = new kt()), g(Kt, Ct, E, M, C);
      }
    }
    return nt ? (C || (C = new kt()), js(l, v, g, E, M, C)) : !1;
  }
  function Ss(l, v, g, E) {
    var M = g.length, C = M, V = !E;
    if (l == null)
      return !C;
    for (l = Object(l); M--; ) {
      var G = g[M];
      if (V && G[2] ? G[1] !== l[G[0]] : !(G[0] in l))
        return !1;
    }
    for (; ++M < C; ) {
      G = g[M];
      var Z = G[0], rt = l[Z], at = G[1];
      if (V && G[2]) {
        if (rt === void 0 && !(Z in l))
          return !1;
      } else {
        var ct = new kt();
        if (E)
          var nt = E(rt, at, Z, l, v, ct);
        if (!(nt === void 0 ? $r(at, rt, E, o | s, ct) : nt))
          return !1;
      }
    }
    return !0;
  }
  function Os(l) {
    if (!ar(l) || Ns(l))
      return !1;
    var v = Xn(l) || ue(l) ? Fr : Rt;
    return v.test(ne(l));
  }
  function Is(l) {
    return ur(l) && Vr(l.length) && !!N[Mt.call(l)];
  }
  function As(l) {
    return typeof l == "function" ? l : l == null ? Ys : typeof l == "object" ? ie(l) ? xs(l[0], l[1]) : Rs(l) : Gs(l);
  }
  function Ds(l) {
    if (!zs(l))
      return Je(l);
    var v = [];
    for (var g in Object(l))
      vt.call(l, g) && g != "constructor" && v.push(g);
    return v;
  }
  function Rs(l) {
    var v = qs(l);
    return v.length == 1 && v[0][2] ? Wn(v[0][0], v[0][1]) : function(g) {
      return g === l || Ss(g, l, v);
    };
  }
  function xs(l, v) {
    return or(l) && Gn(v) ? Wn(sr(l), v) : function(g) {
      var E = Ks(g, l);
      return E === void 0 && E === v ? Vs(g, l) : $r(v, E, void 0, o | s);
    };
  }
  function Ts(l) {
    return function(v) {
      return Kn(v, l);
    };
  }
  function Ps(l) {
    if (typeof l == "string")
      return l;
    if (Qr(l))
      return tr ? tr.call(l) : "";
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function Vn(l) {
    return ie(l) ? l : Ls(l);
  }
  function ks(l) {
    return function(v, g, E) {
      for (var M = -1, C = Object(v), V = E(v), G = V.length; G--; ) {
        var Z = V[l ? G : ++M];
        if (g(C[Z], Z, C) === !1)
          break;
      }
      return v;
    };
  }
  function Qn(l, v, g, E, M, C) {
    var V = M & s, G = l.length, Z = v.length;
    if (G != Z && !(V && Z > G))
      return !1;
    var rt = C.get(l);
    if (rt && C.get(v))
      return rt == v;
    var at = -1, ct = !0, nt = M & o ? new rr() : void 0;
    for (C.set(l, v), C.set(v, l); ++at < G; ) {
      var yt = l[at], _t = v[at];
      if (E)
        var Kt = V ? E(_t, yt, at, v, l, C) : E(yt, _t, at, l, v, C);
      if (Kt !== void 0) {
        if (Kt)
          continue;
        ct = !1;
        break;
      }
      if (nt) {
        if (!et(v, function(Ct, oe) {
          if (!nt.has(oe) && (yt === Ct || g(yt, Ct, E, M, C)))
            return nt.add(oe);
        })) {
          ct = !1;
          break;
        }
      } else if (!(yt === _t || g(yt, _t, E, M, C))) {
        ct = !1;
        break;
      }
    }
    return C.delete(l), C.delete(v), ct;
  }
  function Cs(l, v, g, E, M, C, V) {
    switch (g) {
      case j:
        if (l.byteLength != v.byteLength || l.byteOffset != v.byteOffset)
          return !1;
        l = l.buffer, v = v.buffer;
      case I:
        return !(l.byteLength != v.byteLength || !E(new He(l), new He(v)));
      case h:
      case p:
      case O:
        return Hn(+l, +v);
      case d:
        return l.name == v.name && l.message == v.message;
      case T:
      case P:
        return l == v + "";
      case b:
        var G = ae;
      case x:
        var Z = C & s;
        if (G || (G = Yt), l.size != v.size && !Z)
          return !1;
        var rt = V.get(l);
        if (rt)
          return rt == v;
        C |= o, V.set(l, v);
        var at = Qn(G(l), G(v), E, M, C, V);
        return V.delete(l), at;
      case R:
        if (De)
          return De.call(l) == De.call(v);
    }
    return !1;
  }
  function js(l, v, g, E, M, C) {
    var V = M & s, G = cr(l), Z = G.length, rt = cr(v), at = rt.length;
    if (Z != at && !V)
      return !1;
    for (var ct = Z; ct--; ) {
      var nt = G[ct];
      if (!(V ? nt in v : vt.call(v, nt)))
        return !1;
    }
    var yt = C.get(l);
    if (yt && C.get(v))
      return yt == v;
    var _t = !0;
    C.set(l, v), C.set(v, l);
    for (var Kt = V; ++ct < Z; ) {
      nt = G[ct];
      var Ct = l[nt], oe = v[nt];
      if (E)
        var ti = V ? E(oe, Ct, nt, v, l, C) : E(Ct, oe, nt, l, v, C);
      if (!(ti === void 0 ? Ct === oe || g(Ct, oe, E, M, C) : ti)) {
        _t = !1;
        break;
      }
      Kt || (Kt = nt == "constructor");
    }
    if (_t && !Kt) {
      var fr = l.constructor, lr = v.constructor;
      fr != lr && "constructor" in l && "constructor" in v && !(typeof fr == "function" && fr instanceof fr && typeof lr == "function" && lr instanceof lr) && (_t = !1);
    }
    return C.delete(l), C.delete(v), _t;
  }
  function ir(l, v) {
    var g = l.__data__;
    return Fs(v) ? g[typeof v == "string" ? "string" : "hash"] : g.map;
  }
  function qs(l) {
    for (var v = cr(l), g = v.length; g--; ) {
      var E = v[g], M = l[E];
      v[g] = [E, M, Gn(M)];
    }
    return v;
  }
  function _e(l, v) {
    var g = Et(l, v);
    return Os(g) ? g : void 0;
  }
  var $t = bs;
  (It && $t(new It(new ArrayBuffer(1))) != j || Tt && $t(new Tt()) != b || ee && $t(ee.resolve()) != k || ye && $t(new ye()) != x || Ae && $t(new Ae()) != D) && ($t = function(l) {
    var v = Mt.call(l), g = v == S ? l.constructor : void 0, E = g ? ne(g) : void 0;
    if (E)
      switch (E) {
        case zr:
          return j;
        case Ze:
          return b;
        case Xe:
          return k;
        case Lr:
          return x;
        case Ur:
          return D;
      }
    return v;
  });
  function Ms(l, v, g) {
    v = or(v, l) ? [v] : Vn(v);
    for (var E, M = -1, V = v.length; ++M < V; ) {
      var C = sr(v[M]);
      if (!(E = l != null && g(l, C)))
        break;
      l = l[C];
    }
    if (E)
      return E;
    var V = l ? l.length : 0;
    return !!V && Vr(V) && Yn(C, V) && (ie(l) || Jn(l));
  }
  function Yn(l, v) {
    return v = v ?? c, !!v && (typeof l == "number" || xt.test(l)) && l > -1 && l % 1 == 0 && l < v;
  }
  function or(l, v) {
    if (ie(l))
      return !1;
    var g = typeof l;
    return g == "number" || g == "symbol" || g == "boolean" || l == null || Qr(l) ? !0 : dt.test(l) || !Lt.test(l) || v != null && l in Object(v);
  }
  function Fs(l) {
    var v = typeof l;
    return v == "string" || v == "number" || v == "symbol" || v == "boolean" ? l !== "__proto__" : l === null;
  }
  function Ns(l) {
    return !!Zt && Zt in l;
  }
  function zs(l) {
    var v = l && l.constructor, g = typeof v == "function" && v.prototype || Gt;
    return l === g;
  }
  function Gn(l) {
    return l === l && !ar(l);
  }
  function Wn(l, v) {
    return function(g) {
      return g == null ? !1 : g[l] === v && (v !== void 0 || l in Object(g));
    };
  }
  var Ls = Kr(function(l) {
    l = $s(l);
    var v = [];
    return mt.test(l) && v.push(""), l.replace(st, function(g, E, M, C) {
      v.push(M ? C.replace(Qt, "$1") : E || g);
    }), v;
  });
  function sr(l) {
    if (typeof l == "string" || Qr(l))
      return l;
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function ne(l) {
    if (l != null) {
      try {
        return fe.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function Kr(l, v) {
    if (typeof l != "function" || v && typeof v != "function")
      throw new TypeError(n);
    var g = function() {
      var E = arguments, M = v ? v.apply(this, E) : E[0], C = g.cache;
      if (C.has(M))
        return C.get(M);
      var V = l.apply(this, E);
      return g.cache = C.set(M, V), V;
    };
    return g.cache = new (Kr.Cache || K)(), g;
  }
  Kr.Cache = K;
  function Hn(l, v) {
    return l === v || l !== l && v !== v;
  }
  function Jn(l) {
    return Us(l) && vt.call(l, "callee") && (!Nr.call(l, "callee") || Mt.call(l) == a);
  }
  var ie = Array.isArray;
  function Zn(l) {
    return l != null && Vr(l.length) && !Xn(l);
  }
  function Us(l) {
    return ur(l) && Zn(l);
  }
  function Xn(l) {
    var v = ar(l) ? Mt.call(l) : "";
    return v == _ || v == m;
  }
  function Vr(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= c;
  }
  function ar(l) {
    var v = typeof l;
    return !!l && (v == "object" || v == "function");
  }
  function ur(l) {
    return !!l && typeof l == "object";
  }
  function Qr(l) {
    return typeof l == "symbol" || ur(l) && Mt.call(l) == R;
  }
  var Bs = W ? St(W) : Is;
  function $s(l) {
    return l == null ? "" : Ps(l);
  }
  function Ks(l, v, g) {
    var E = l == null ? void 0 : Kn(l, v);
    return E === void 0 ? g : E;
  }
  function Vs(l, v) {
    return l != null && Ms(l, v, ws);
  }
  function cr(l) {
    return Zn(l) ? _s(l) : Ds(l);
  }
  function Qs(l, v) {
    var g = {};
    return v = As(v), gs(l, function(E, M, C) {
      g[v(E, M, C)] = E;
    }), g;
  }
  function Ys(l) {
    return l;
  }
  function Gs(l) {
    return or(l) ? ot(sr(l)) : Ts(l);
  }
  t.exports = Qs;
})(qp, qp.exports);
qp.exports;
var Sf = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xw;
function sF() {
  if (Xw)
    return Sf;
  Xw = 1;
  var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, c, a) {
    var f, h = {}, p = null, d = null;
    a !== void 0 && (p = "" + a), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (f in c)
      n.call(c, f) && !o.hasOwnProperty(f) && (h[f] = c[f]);
    if (u && u.defaultProps)
      for (f in c = u.defaultProps, c)
        h[f] === void 0 && (h[f] = c[f]);
    return { $$typeof: e, type: u, key: p, ref: d, props: h, _owner: i.current };
  }
  return Sf.Fragment = r, Sf.jsx = s, Sf.jsxs = s, Sf;
}
var Uh = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tE;
function aF() {
  return tE || (tE = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), a = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), _ = Symbol.iterator, m = "@@iterator";
    function b(y) {
      if (y === null || typeof y != "object")
        return null;
      var w = _ && y[_] || y[m];
      return typeof w == "function" ? w : null;
    }
    var O = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(y) {
      {
        for (var w = arguments.length, A = new Array(w > 1 ? w - 1 : 0), q = 1; q < w; q++)
          A[q - 1] = arguments[q];
        k("error", y, A);
      }
    }
    function k(y, w, A) {
      {
        var q = O.ReactDebugCurrentFrame, F = q.getStackAddendum();
        F !== "" && (w += "%s", A = A.concat([F]));
        var Q = A.map(function(L) {
          return String(L);
        });
        Q.unshift("Warning: " + w), Function.prototype.apply.call(console[y], console, Q);
      }
    }
    var T = !1, x = !1, P = !1, R = !1, D = !1, I;
    I = Symbol.for("react.module.reference");
    function j(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === n || y === o || D || y === i || y === a || y === f || R || y === d || T || x || P || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === h || y.$$typeof === s || y.$$typeof === u || y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === I || y.getModuleId !== void 0));
    }
    function Y(y, w, A) {
      var q = y.displayName;
      if (q)
        return q;
      var F = w.displayName || w.name || "";
      return F !== "" ? A + "(" + F + ")" : A;
    }
    function H(y) {
      return y.displayName || "Context";
    }
    function B(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case a:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case u:
            var w = y;
            return H(w) + ".Consumer";
          case s:
            var A = y;
            return H(A._context) + ".Provider";
          case c:
            return Y(y, y.render, "ForwardRef");
          case h:
            var q = y.displayName || null;
            return q !== null ? q : B(y.type) || "Memo";
          case p: {
            var F = y, Q = F._payload, L = F._init;
            try {
              return B(L(Q));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var tt = Object.assign, lt = 0, te, pt, At, ft, Lt, dt, mt;
    function st() {
    }
    st.__reactDisabledLog = !0;
    function Nt() {
      {
        if (lt === 0) {
          te = console.log, pt = console.info, At = console.warn, ft = console.error, Lt = console.group, dt = console.groupCollapsed, mt = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: st,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        lt++;
      }
    }
    function Qt() {
      {
        if (lt--, lt === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: tt({}, y, {
              value: te
            }),
            info: tt({}, y, {
              value: pt
            }),
            warn: tt({}, y, {
              value: At
            }),
            error: tt({}, y, {
              value: ft
            }),
            group: tt({}, y, {
              value: Lt
            }),
            groupCollapsed: tt({}, y, {
              value: dt
            }),
            groupEnd: tt({}, y, {
              value: mt
            })
          });
        }
        lt < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Rt = O.ReactCurrentDispatcher, xt;
    function N(y, w, A) {
      {
        if (xt === void 0)
          try {
            throw Error();
          } catch (F) {
            var q = F.stack.trim().match(/\n( *(at )?)/);
            xt = q && q[1] || "";
          }
        return `
` + xt + y;
      }
    }
    var ht = !1, gt;
    {
      var X = typeof WeakMap == "function" ? WeakMap : Map;
      gt = new X();
    }
    function wt(y, w) {
      if (!y || ht)
        return "";
      {
        var A = gt.get(y);
        if (A !== void 0)
          return A;
      }
      var q;
      ht = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Q;
      Q = Rt.current, Rt.current = null, Nt();
      try {
        if (w) {
          var L = function() {
            throw Error();
          };
          if (Object.defineProperty(L.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(L, []);
            } catch (bt) {
              q = bt;
            }
            Reflect.construct(y, [], L);
          } else {
            try {
              L.call();
            } catch (bt) {
              q = bt;
            }
            y.call(L.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bt) {
            q = bt;
          }
          y();
        }
      } catch (bt) {
        if (bt && q && typeof bt.stack == "string") {
          for (var z = bt.stack.split(`
`), it = q.stack.split(`
`), J = z.length - 1, K = it.length - 1; J >= 1 && K >= 0 && z[J] !== it[K]; )
            K--;
          for (; J >= 1 && K >= 0; J--, K--)
            if (z[J] !== it[K]) {
              if (J !== 1 || K !== 1)
                do
                  if (J--, K--, K < 0 || z[J] !== it[K]) {
                    var ut = `
` + z[J].replace(" at new ", " at ");
                    return y.displayName && ut.includes("<anonymous>") && (ut = ut.replace("<anonymous>", y.displayName)), typeof y == "function" && gt.set(y, ut), ut;
                  }
                while (J >= 1 && K >= 0);
              break;
            }
        }
      } finally {
        ht = !1, Rt.current = Q, Qt(), Error.prepareStackTrace = F;
      }
      var Bt = y ? y.displayName || y.name : "", er = Bt ? N(Bt) : "";
      return typeof y == "function" && gt.set(y, er), er;
    }
    function jt(y, w, A) {
      return wt(y, !1);
    }
    function qt(y) {
      var w = y.prototype;
      return !!(w && w.isReactComponent);
    }
    function U(y, w, A) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return wt(y, qt(y));
      if (typeof y == "string")
        return N(y);
      switch (y) {
        case a:
          return N("Suspense");
        case f:
          return N("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case c:
            return jt(y.render);
          case h:
            return U(y.type, w, A);
          case p: {
            var q = y, F = q._payload, Q = q._init;
            try {
              return U(Q(F), w, A);
            } catch {
            }
          }
        }
      return "";
    }
    var $ = Object.prototype.hasOwnProperty, W = {}, et = O.ReactDebugCurrentFrame;
    function ot(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        et.setExtraStackFrame(A);
      } else
        et.setExtraStackFrame(null);
    }
    function Dt(y, w, A, q, F) {
      {
        var Q = Function.call.bind($);
        for (var L in y)
          if (Q(y, L)) {
            var z = void 0;
            try {
              if (typeof y[L] != "function") {
                var it = Error((q || "React class") + ": " + A + " type `" + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[L] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw it.name = "Invariant Violation", it;
              }
              z = y[L](w, L, q, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (J) {
              z = J;
            }
            z && !(z instanceof Error) && (ot(F), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", A, L, typeof z), ot(null)), z instanceof Error && !(z.message in W) && (W[z.message] = !0, ot(F), S("Failed %s type: %s", A, z.message), ot(null));
          }
      }
    }
    var St = Array.isArray;
    function Et(y) {
      return St(y);
    }
    function ue(y) {
      {
        var w = typeof Symbol == "function" && Symbol.toStringTag, A = w && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return A;
      }
    }
    function ae(y) {
      try {
        return ce(y), !1;
      } catch {
        return !0;
      }
    }
    function ce(y) {
      return "" + y;
    }
    function Yt(y) {
      if (ae(y))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ue(y)), ce(y);
    }
    var Ot = O.ReactCurrentOwner, Oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Gt, se, Zt;
    Zt = {};
    function fe(y) {
      if ($.call(y, "ref")) {
        var w = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function vt(y) {
      if ($.call(y, "key")) {
        var w = Object.getOwnPropertyDescriptor(y, "key").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Mt(y, w) {
      if (typeof y.ref == "string" && Ot.current && w && Ot.current.stateNode !== w) {
        var A = B(Ot.current.type);
        Zt[A] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(Ot.current.type), y.ref), Zt[A] = !0);
      }
    }
    function Fr(y, w) {
      {
        var A = function() {
          Gt || (Gt = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: A,
          configurable: !0
        });
      }
    }
    function We(y, w) {
      {
        var A = function() {
          se || (se = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: A,
          configurable: !0
        });
      }
    }
    var He = function(y, w, A, q, F, Q, L) {
      var z = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: y,
        key: w,
        ref: A,
        props: L,
        // Record the component responsible for creating this element.
        _owner: Q
      };
      return z._store = {}, Object.defineProperty(z._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(z, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(z, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(z.props), Object.freeze(z)), z;
    };
    function Nr(y, w, A, q, F) {
      {
        var Q, L = {}, z = null, it = null;
        A !== void 0 && (Yt(A), z = "" + A), vt(w) && (Yt(w.key), z = "" + w.key), fe(w) && (it = w.ref, Mt(w, F));
        for (Q in w)
          $.call(w, Q) && !Oe.hasOwnProperty(Q) && (L[Q] = w[Q]);
        if (y && y.defaultProps) {
          var J = y.defaultProps;
          for (Q in J)
            L[Q] === void 0 && (L[Q] = J[Q]);
        }
        if (z || it) {
          var K = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          z && Fr(L, K), it && We(L, K);
        }
        return He(y, z, it, F, q, Ot.current, L);
      }
    }
    var Ie = O.ReactCurrentOwner, Je = O.ReactDebugCurrentFrame;
    function It(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        Je.setExtraStackFrame(A);
      } else
        Je.setExtraStackFrame(null);
    }
    var Tt;
    Tt = !1;
    function ee(y) {
      return typeof y == "object" && y !== null && y.$$typeof === e;
    }
    function ye() {
      {
        if (Ie.current) {
          var y = B(Ie.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function Ae(y) {
      {
        if (y !== void 0) {
          var w = y.fileName.replace(/^.*[\\\/]/, ""), A = y.lineNumber;
          return `

Check your code at ` + w + ":" + A + ".";
        }
        return "";
      }
    }
    var Ut = {};
    function zr(y) {
      {
        var w = ye();
        if (!w) {
          var A = typeof y == "string" ? y : y.displayName || y.name;
          A && (w = `

Check the top-level render call using <` + A + ">.");
        }
        return w;
      }
    }
    function Ze(y, w) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var A = zr(w);
        if (Ut[A])
          return;
        Ut[A] = !0;
        var q = "";
        y && y._owner && y._owner !== Ie.current && (q = " It was passed a child from " + B(y._owner.type) + "."), It(y), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, q), It(null);
      }
    }
    function Xe(y, w) {
      {
        if (typeof y != "object")
          return;
        if (Et(y))
          for (var A = 0; A < y.length; A++) {
            var q = y[A];
            ee(q) && Ze(q, w);
          }
        else if (ee(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var F = b(y);
          if (typeof F == "function" && F !== y.entries)
            for (var Q = F.call(y), L; !(L = Q.next()).done; )
              ee(L.value) && Ze(L.value, w);
        }
      }
    }
    function Lr(y) {
      {
        var w = y.type;
        if (w == null || typeof w == "string")
          return;
        var A;
        if (typeof w == "function")
          A = w.propTypes;
        else if (typeof w == "object" && (w.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        w.$$typeof === h))
          A = w.propTypes;
        else
          return;
        if (A) {
          var q = B(w);
          Dt(A, y.props, "prop", q, y);
        } else if (w.PropTypes !== void 0 && !Tt) {
          Tt = !0;
          var F = B(w);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof w.getDefaultProps == "function" && !w.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ur(y) {
      {
        for (var w = Object.keys(y.props), A = 0; A < w.length; A++) {
          var q = w[A];
          if (q !== "children" && q !== "key") {
            It(y), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), It(null);
            break;
          }
        }
        y.ref !== null && (It(y), S("Invalid attribute `ref` supplied to `React.Fragment`."), It(null));
      }
    }
    function re(y, w, A, q, F, Q) {
      {
        var L = j(y);
        if (!L) {
          var z = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var it = Ae(F);
          it ? z += it : z += ye();
          var J;
          y === null ? J = "null" : Et(y) ? J = "array" : y !== void 0 && y.$$typeof === e ? (J = "<" + (B(y.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : J = typeof y, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", J, z);
        }
        var K = Nr(y, w, A, F, Q);
        if (K == null)
          return K;
        if (L) {
          var ut = w.children;
          if (ut !== void 0)
            if (q)
              if (Et(ut)) {
                for (var Bt = 0; Bt < ut.length; Bt++)
                  Xe(ut[Bt], y);
                Object.freeze && Object.freeze(ut);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xe(ut, y);
        }
        return y === n ? Ur(K) : Lr(K), K;
      }
    }
    function De(y, w, A) {
      return re(y, w, A, !0);
    }
    function tr(y, w, A) {
      return re(y, w, A, !1);
    }
    var Pt = tr, Br = De;
    Uh.Fragment = n, Uh.jsx = Pt, Uh.jsxs = Br;
  }()), Uh;
}
process.env.NODE_ENV === "production" ? sF() : aF();
function kd(t, e, r, n) {
  Object.defineProperty(t, e, { get: r, set: n, enumerable: !0, configurable: !0 });
}
var uF = {};
kd(uF, "ErrorBoundary", () => MD);
var cF = {};
kd(cF, "ErrorBoundaryContext", () => $m);
const $m = Mr(null), Zv = {
  didCatch: !1,
  error: null
};
class MD extends Pl {
  constructor() {
    super(...arguments), Hw(this, "state", Zv), Hw(this, "resetErrorBoundary", (...e) => {
      var r, n;
      const { error: i } = this.state;
      i !== null && ((n = (r = this.props).onReset) == null || n.call(r, {
        args: e,
        reason: "imperative-api"
      }), this.setState(Zv));
    });
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  componentDidCatch(e, r) {
    var n, i;
    (i = (n = this.props).onError) == null || i.call(n, e, r);
  }
  componentDidUpdate(e, r) {
    var n, i;
    const { didCatch: o } = this.state, { resetKeys: s } = this.props;
    o && r.error !== null && fF(e.resetKeys, s) && ((i = (n = this.props).onReset) == null || i.call(n, {
      next: s,
      prev: e.resetKeys,
      reason: "keys"
    }), this.setState(Zv));
  }
  render() {
    const { children: e, fallbackRender: r, FallbackComponent: n, fallback: i } = this.props, { didCatch: o, error: s } = this.state;
    let u = e;
    if (o) {
      const c = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (kl(i))
        u = i;
      else if (typeof r == "function")
        u = r(c);
      else if (n)
        u = Tr(n, c);
      else
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return Tr($m.Provider, {
      value: {
        didCatch: o,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, u);
  }
}
function fF(t = [], e = []) {
  return t.length !== e.length || t.some((r, n) => !Object.is(r, e[n]));
}
var lF = {};
kd(lF, "useErrorBoundary", () => pF);
function hF(t) {
  if (t == null || typeof t.didCatch != "boolean" || typeof t.resetErrorBoundary != "function")
    throw new Error("ErrorBoundaryContext not found");
  return !0;
}
function pF() {
  const t = ca($m);
  hF(t);
  const [e, r] = Jo({
    error: null,
    hasError: !1
  }), n = Zo(() => ({
    resetBoundary: () => {
      t == null || t.resetErrorBoundary(), r({
        error: null,
        hasError: !1
      });
    },
    showBoundary: (i) => r({
      error: i,
      hasError: !0
    })
  }), [
    t == null ? void 0 : t.resetErrorBoundary
  ]);
  if (e.hasError)
    throw e.error;
  return n;
}
var dF = {};
kd(dF, "withErrorBoundary", () => vF);
function vF(t, e) {
  const r = Cl((i, o) => Tr(MD, e, Tr(t, {
    ...i,
    ref: o
  }))), n = t.displayName || t.name || "Unknown";
  return r.displayName = `withErrorBoundary(${n})`, r;
}
Mr({
  productKey: void 0,
  locationPathName: "",
  setLocationPathName: () => {
  },
  aptrinsic: () => {
  },
  logDebug: () => {
  },
  isInitialized: !1,
  initialize: () => {
  }
});
var Km = /* @__PURE__ */ ((t) => (t.EN = "en", t.FR = "fr", t))(Km || {});
class Cd {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    const r = {
      listener: e
    };
    return this.listeners.add(r), this.onSubscribe(), () => {
      this.listeners.delete(r), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const Vm = typeof window > "u" || "Deno" in window;
function _o() {
}
function yF(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function _F(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function mF(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function Bh(t, e, r) {
  return jd(t) ? typeof e == "function" ? {
    ...r,
    queryKey: t,
    queryFn: e
  } : {
    ...e,
    queryKey: t
  } : t;
}
function _a(t, e, r) {
  return jd(t) ? [{
    ...e,
    queryKey: t
  }, r] : [t || {}, e];
}
function eE(t, e) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: i,
    predicate: o,
    queryKey: s,
    stale: u
  } = t;
  if (jd(s)) {
    if (n) {
      if (e.queryHash !== Qm(s, e.options))
        return !1;
    } else if (!zu(e.queryKey, s))
      return !1;
  }
  if (r !== "all") {
    const c = e.isActive();
    if (r === "active" && !c || r === "inactive" && c)
      return !1;
  }
  return !(typeof u == "boolean" && e.isStale() !== u || typeof i < "u" && i !== e.state.fetchStatus || o && !o(e));
}
function rE(t, e) {
  const {
    exact: r,
    fetching: n,
    predicate: i,
    mutationKey: o
  } = t;
  if (jd(o)) {
    if (!e.options.mutationKey)
      return !1;
    if (r) {
      if (ru(e.options.mutationKey) !== ru(o))
        return !1;
    } else if (!zu(e.options.mutationKey, o))
      return !1;
  }
  return !(typeof n == "boolean" && e.state.status === "loading" !== n || i && !i(e));
}
function Qm(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || ru)(t);
}
function ru(t) {
  return JSON.stringify(t, (e, r) => u_(r) ? Object.keys(r).sort().reduce((n, i) => (n[i] = r[i], n), {}) : r);
}
function zu(t, e) {
  return FD(t, e);
}
function FD(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((r) => !FD(t[r], e[r])) : !1;
}
function ND(t, e) {
  if (t === e)
    return t;
  const r = nE(t) && nE(e);
  if (r || u_(t) && u_(e)) {
    const n = r ? t.length : Object.keys(t).length, i = r ? e : Object.keys(e), o = i.length, s = r ? [] : {};
    let u = 0;
    for (let c = 0; c < o; c++) {
      const a = r ? c : i[c];
      s[a] = ND(t[a], e[a]), s[a] === t[a] && u++;
    }
    return n === o && u === n ? t : s;
  }
  return e;
}
function nE(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function u_(t) {
  if (!iE(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const r = e.prototype;
  return !(!iE(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function iE(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function jd(t) {
  return Array.isArray(t);
}
function zD(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function oE(t) {
  zD(0).then(t);
}
function gF() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function bF(t, e, r) {
  return r.isDataEqual != null && r.isDataEqual(t, e) ? t : typeof r.structuralSharing == "function" ? r.structuralSharing(t, e) : r.structuralSharing !== !1 ? ND(t, e) : e;
}
class wF extends Cd {
  constructor() {
    super(), this.setup = (e) => {
      if (!Vm && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("visibilitychange", r, !1), window.addEventListener("focus", r, !1), () => {
          window.removeEventListener("visibilitychange", r), window.removeEventListener("focus", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused = e, e && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const c_ = new wF();
class EF extends Cd {
  constructor() {
    super(), this.setup = (e) => {
      if (!Vm && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("online", r, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setOnline(n) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online = e, e && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const Mp = new EF();
function SF(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function Ym(t) {
  return (t ?? "online") === "online" ? Mp.isOnline() : !0;
}
class LD {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
}
function Xv(t) {
  return t instanceof LD;
}
function UD(t) {
  let e = !1, r = 0, n = !1, i, o, s;
  const u = new Promise((b, O) => {
    o = b, s = O;
  }), c = (b) => {
    n || (d(new LD(b)), t.abort == null || t.abort());
  }, a = () => {
    e = !0;
  }, f = () => {
    e = !1;
  }, h = () => !c_.isFocused() || t.networkMode !== "always" && !Mp.isOnline(), p = (b) => {
    n || (n = !0, t.onSuccess == null || t.onSuccess(b), i == null || i(), o(b));
  }, d = (b) => {
    n || (n = !0, t.onError == null || t.onError(b), i == null || i(), s(b));
  }, _ = () => new Promise((b) => {
    i = (O) => {
      const S = n || !h();
      return S && b(O), S;
    }, t.onPause == null || t.onPause();
  }).then(() => {
    i = void 0, n || t.onContinue == null || t.onContinue();
  }), m = () => {
    if (n)
      return;
    let b;
    try {
      b = t.fn();
    } catch (O) {
      b = Promise.reject(O);
    }
    Promise.resolve(b).then(p).catch((O) => {
      var S, k;
      if (n)
        return;
      const T = (S = t.retry) != null ? S : 3, x = (k = t.retryDelay) != null ? k : SF, P = typeof x == "function" ? x(r, O) : x, R = T === !0 || typeof T == "number" && r < T || typeof T == "function" && T(r, O);
      if (e || !R) {
        d(O);
        return;
      }
      r++, t.onFail == null || t.onFail(r, O), zD(P).then(() => {
        if (h())
          return _();
      }).then(() => {
        e ? d(O) : m();
      });
    });
  };
  return Ym(t.networkMode) ? m() : _().then(m), {
    promise: u,
    cancel: c,
    continue: () => i != null && i() ? u : Promise.resolve(),
    cancelRetry: a,
    continueRetry: f
  };
}
const Gm = console;
function OF() {
  let t = [], e = 0, r = (c) => {
    c();
  }, n = (c) => {
    c();
  };
  const i = (c) => {
    let a;
    e++;
    try {
      a = c();
    } finally {
      e--, e || u();
    }
    return a;
  }, o = (c) => {
    e ? t.push(c) : oE(() => {
      r(c);
    });
  }, s = (c) => (...a) => {
    o(() => {
      c(...a);
    });
  }, u = () => {
    const c = t;
    t = [], c.length && oE(() => {
      n(() => {
        c.forEach((a) => {
          r(a);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: s,
    schedule: o,
    setNotifyFunction: (c) => {
      r = c;
    },
    setBatchNotifyFunction: (c) => {
      n = c;
    }
  };
}
const kn = OF();
class BD {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), _F(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (Vm ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class IF extends BD {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || Gm, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || AF(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, r) {
    const n = bF(this.state.data, e, this.options);
    return this.dispatch({
      data: n,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), n;
  }
  setState(e, r) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: r
    });
  }
  cancel(e) {
    var r;
    const n = this.promise;
    return (r = this.retryer) == null || r.cancel(e), n ? n.then(_o).catch(_o) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !mF(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnReconnect());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.indexOf(e) !== -1 && (this.observers = this.observers.filter((r) => r !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, r) {
    var n, i;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && r != null && r.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var o;
        return (o = this.retryer) == null || o.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const d = this.observers.find((_) => _.options.queryFn);
      d && this.setOptions(d.options);
    }
    Array.isArray(this.options.queryKey) || process.env.NODE_ENV !== "production" && this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
    const s = gF(), u = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, c = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => {
          if (s)
            return this.abortSignalConsumed = !0, s.signal;
        }
      });
    };
    c(u);
    const a = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(u)) : Promise.reject("Missing queryFn"), f = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: a
    };
    if (c(f), (n = this.options.behavior) == null || n.onFetch(f), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((i = f.fetchOptions) == null ? void 0 : i.meta)) {
      var h;
      this.dispatch({
        type: "fetch",
        meta: (h = f.fetchOptions) == null ? void 0 : h.meta
      });
    }
    const p = (d) => {
      if (Xv(d) && d.silent || this.dispatch({
        type: "error",
        error: d
      }), !Xv(d)) {
        var _, m, b, O;
        (_ = (m = this.cache.config).onError) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, this.state.data, d, this), process.env.NODE_ENV !== "production" && this.logger.error(d);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = UD({
      fn: f.fetchFn,
      abort: s == null ? void 0 : s.abort.bind(s),
      onSuccess: (d) => {
        var _, m, b, O;
        if (typeof d > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), p(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(d), (_ = (m = this.cache.config).onSuccess) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, d, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: p,
      onFail: (d, _) => {
        this.dispatch({
          type: "failed",
          failureCount: d,
          error: _
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: f.options.retry,
      retryDelay: f.options.retryDelay,
      networkMode: f.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const r = (n) => {
      var i, o;
      switch (e.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (i = e.meta) != null ? i : null,
            fetchStatus: Ym(this.options.networkMode) ? "fetching" : "paused",
            ...!n.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...n,
            data: e.data,
            dataUpdateCount: n.dataUpdateCount + 1,
            dataUpdatedAt: (o = e.dataUpdatedAt) != null ? o : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const s = e.error;
          return Xv(s) && s.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...n,
            error: s,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: s,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), kn.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
}
function AF(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = typeof e < "u", n = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class DF extends Cd {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, r, n) {
    var i;
    const o = r.queryKey, s = (i = r.queryHash) != null ? i : Qm(o, r);
    let u = this.get(s);
    return u || (u = new IF({
      cache: this,
      logger: e.getLogger(),
      queryKey: o,
      queryHash: s,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(o)
    }), this.add(u)), u;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = this.queriesMap[e.queryHash];
    r && (e.destroy(), this.queries = this.queries.filter((n) => n !== e), r === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    kn.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  find(e, r) {
    const [n] = _a(e, r);
    return typeof n.exact > "u" && (n.exact = !0), this.queries.find((i) => eE(n, i));
  }
  findAll(e, r) {
    const [n] = _a(e, r);
    return Object.keys(n).length > 0 ? this.queries.filter((i) => eE(n, i)) : this.queries;
  }
  notify(e) {
    kn.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  onFocus() {
    kn.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    kn.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
class RF extends BD {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || Gm, this.observers = [], this.state = e.state || xF(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((r) => r !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, r;
    return (e = (r = this.retryer) == null ? void 0 : r.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var R;
      return this.retryer = UD({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (D, I) => {
          this.dispatch({
            type: "failed",
            failureCount: D,
            error: I
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (R = this.options.retry) != null ? R : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, r = this.state.status === "loading";
    try {
      var n, i, o, s, u, c, a, f;
      if (!r) {
        var h, p, d, _;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((h = (p = this.mutationCache.config).onMutate) == null ? void 0 : h.call(p, this.state.variables, this));
        const D = await ((d = (_ = this.options).onMutate) == null ? void 0 : d.call(_, this.state.variables));
        D !== this.state.context && this.dispatch({
          type: "loading",
          context: D,
          variables: this.state.variables
        });
      }
      const R = await e();
      return await ((n = (i = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(i, R, this.state.variables, this.state.context, this)), await ((o = (s = this.options).onSuccess) == null ? void 0 : o.call(s, R, this.state.variables, this.state.context)), await ((u = (c = this.mutationCache.config).onSettled) == null ? void 0 : u.call(c, R, null, this.state.variables, this.state.context, this)), await ((a = (f = this.options).onSettled) == null ? void 0 : a.call(f, R, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: R
      }), R;
    } catch (R) {
      try {
        var m, b, O, S, k, T, x, P;
        throw await ((m = (b = this.mutationCache.config).onError) == null ? void 0 : m.call(b, R, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(R), await ((O = (S = this.options).onError) == null ? void 0 : O.call(S, R, this.state.variables, this.state.context)), await ((k = (T = this.mutationCache.config).onSettled) == null ? void 0 : k.call(T, void 0, R, this.state.variables, this.state.context, this)), await ((x = (P = this.options).onSettled) == null ? void 0 : x.call(P, void 0, R, this.state.variables, this.state.context)), R;
      } finally {
        this.dispatch({
          type: "error",
          error: R
        });
      }
    }
  }
  dispatch(e) {
    const r = (n) => {
      switch (e.type) {
        case "failed":
          return {
            ...n,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "loading":
          return {
            ...n,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !Ym(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...n,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: e.error,
            failureCount: n.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), kn.batch(() => {
      this.observers.forEach((n) => {
        n.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function xF() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class TF extends Cd {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, r, n) {
    const i = new RF({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(r),
      state: n,
      defaultOptions: r.mutationKey ? e.getMutationDefaults(r.mutationKey) : void 0
    });
    return this.add(i), i;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((r) => r !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    kn.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((r) => rE(e, r));
  }
  findAll(e) {
    return this.mutations.filter((r) => rE(e, r));
  }
  notify(e) {
    kn.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const r = this.mutations.filter((n) => n.state.isPaused);
      return kn.batch(() => r.reduce((n, i) => n.then(() => i.continue().catch(_o)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function PF() {
  return {
    onFetch: (t) => {
      t.fetchFn = () => {
        var e, r, n, i, o, s;
        const u = (e = t.fetchOptions) == null || (r = e.meta) == null ? void 0 : r.refetchPage, c = (n = t.fetchOptions) == null || (i = n.meta) == null ? void 0 : i.fetchMore, a = c == null ? void 0 : c.pageParam, f = (c == null ? void 0 : c.direction) === "forward", h = (c == null ? void 0 : c.direction) === "backward", p = ((o = t.state.data) == null ? void 0 : o.pages) || [], d = ((s = t.state.data) == null ? void 0 : s.pageParams) || [];
        let _ = d, m = !1;
        const b = (x) => {
          Object.defineProperty(x, "signal", {
            enumerable: !0,
            get: () => {
              var P;
              if ((P = t.signal) != null && P.aborted)
                m = !0;
              else {
                var R;
                (R = t.signal) == null || R.addEventListener("abort", () => {
                  m = !0;
                });
              }
              return t.signal;
            }
          });
        }, O = t.options.queryFn || (() => Promise.reject("Missing queryFn")), S = (x, P, R, D) => (_ = D ? [P, ..._] : [..._, P], D ? [R, ...x] : [...x, R]), k = (x, P, R, D) => {
          if (m)
            return Promise.reject("Cancelled");
          if (typeof R > "u" && !P && x.length)
            return Promise.resolve(x);
          const I = {
            queryKey: t.queryKey,
            pageParam: R,
            meta: t.options.meta
          };
          b(I);
          const j = O(I);
          return Promise.resolve(j).then((Y) => S(x, R, Y, D));
        };
        let T;
        if (!p.length)
          T = k([]);
        else if (f) {
          const x = typeof a < "u", P = x ? a : sE(t.options, p);
          T = k(p, x, P);
        } else if (h) {
          const x = typeof a < "u", P = x ? a : kF(t.options, p);
          T = k(p, x, P, !0);
        } else {
          _ = [];
          const x = typeof t.options.getNextPageParam > "u";
          T = !(u && p[0]) || u(p[0], 0, p) ? k([], x, d[0]) : Promise.resolve(S([], d[0], p[0]));
          for (let P = 1; P < p.length; P++)
            T = T.then((R) => {
              if (!(u && p[P]) || u(p[P], P, p)) {
                const D = x ? d[P] : sE(t.options, R);
                return k(R, x, D);
              }
              return Promise.resolve(S(R, d[P], p[P]));
            });
        }
        return T.then((x) => ({
          pages: x,
          pageParams: _
        }));
      };
    }
  };
}
function sE(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}
function kF(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}
class CF {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new DF(), this.mutationCache = e.mutationCache || new TF(), this.logger = e.logger || Gm, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && e.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = c_.subscribe(() => {
      c_.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = Mp.subscribe(() => {
      Mp.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, r;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (r = this.unsubscribeOnline) == null || r.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(e, r) {
    const [n] = _a(e, r);
    return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  getQueryData(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e, r, n) {
    const i = Bh(e, r, n), o = this.getQueryData(i.queryKey);
    return o ? Promise.resolve(o) : this.fetchQuery(i);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: r,
      state: n
    }) => {
      const i = n.data;
      return [r, i];
    });
  }
  setQueryData(e, r, n) {
    const i = this.queryCache.find(e), o = i == null ? void 0 : i.state.data, s = yF(r, o);
    if (typeof s > "u")
      return;
    const u = Bh(e), c = this.defaultQueryOptions(u);
    return this.queryCache.build(this, c).setData(s, {
      ...n,
      manual: !0
    });
  }
  setQueriesData(e, r, n) {
    return kn.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: i
    }) => [i, this.setQueryData(i, r, n)]));
  }
  getQueryState(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state;
  }
  removeQueries(e, r) {
    const [n] = _a(e, r), i = this.queryCache;
    kn.batch(() => {
      i.findAll(n).forEach((o) => {
        i.remove(o);
      });
    });
  }
  resetQueries(e, r, n) {
    const [i, o] = _a(e, r, n), s = this.queryCache, u = {
      type: "active",
      ...i
    };
    return kn.batch(() => (s.findAll(i).forEach((c) => {
      c.reset();
    }), this.refetchQueries(u, o)));
  }
  cancelQueries(e, r, n) {
    const [i, o = {}] = _a(e, r, n);
    typeof o.revert > "u" && (o.revert = !0);
    const s = kn.batch(() => this.queryCache.findAll(i).map((u) => u.cancel(o)));
    return Promise.all(s).then(_o).catch(_o);
  }
  invalidateQueries(e, r, n) {
    const [i, o] = _a(e, r, n);
    return kn.batch(() => {
      var s, u;
      if (this.queryCache.findAll(i).forEach((a) => {
        a.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const c = {
        ...i,
        type: (s = (u = i.refetchType) != null ? u : i.type) != null ? s : "active"
      };
      return this.refetchQueries(c, o);
    });
  }
  refetchQueries(e, r, n) {
    const [i, o] = _a(e, r, n), s = kn.batch(() => this.queryCache.findAll(i).filter((c) => !c.isDisabled()).map((c) => {
      var a;
      return c.fetch(void 0, {
        ...o,
        cancelRefetch: (a = o == null ? void 0 : o.cancelRefetch) != null ? a : !0,
        meta: {
          refetchPage: i.refetchPage
        }
      });
    }));
    let u = Promise.all(s).then(_o);
    return o != null && o.throwOnError || (u = u.catch(_o)), u;
  }
  fetchQuery(e, r, n) {
    const i = Bh(e, r, n), o = this.defaultQueryOptions(i);
    typeof o.retry > "u" && (o.retry = !1);
    const s = this.queryCache.build(this, o);
    return s.isStaleByTime(o.staleTime) ? s.fetch(o) : Promise.resolve(s.state.data);
  }
  prefetchQuery(e, r, n) {
    return this.fetchQuery(e, r, n).then(_o).catch(_o);
  }
  fetchInfiniteQuery(e, r, n) {
    const i = Bh(e, r, n);
    return i.behavior = PF(), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(e, r, n) {
    return this.fetchInfiniteQuery(e, r, n).then(_o).catch(_o);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, r) {
    const n = this.queryDefaults.find((i) => ru(e) === ru(i.queryKey));
    n ? n.defaultOptions = r : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: r
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const r = this.queryDefaults.find((n) => zu(e, n.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((n) => zu(e, n.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(e) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), r == null ? void 0 : r.defaultOptions;
  }
  setMutationDefaults(e, r) {
    const n = this.mutationDefaults.find((i) => ru(e) === ru(i.mutationKey));
    n ? n.defaultOptions = r : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: r
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const r = this.mutationDefaults.find((n) => zu(e, n.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((n) => zu(e, n.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(e) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), r == null ? void 0 : r.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const r = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e == null ? void 0 : e.queryKey),
      ...e,
      _defaulted: !0
    };
    return !r.queryHash && r.queryKey && (r.queryHash = Qm(r.queryKey, r)), typeof r.refetchOnReconnect > "u" && (r.refetchOnReconnect = r.networkMode !== "always"), typeof r.useErrorBoundary > "u" && (r.useErrorBoundary = !!r.suspense), r;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e == null ? void 0 : e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
var f_ = { exports: {} }, ty = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aE;
function jF() {
  if (aE)
    return ty;
  aE = 1;
  var t = Se;
  function e(h, p) {
    return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, i = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
  function u(h, p) {
    var d = p(), _ = n({ inst: { value: d, getSnapshot: p } }), m = _[0].inst, b = _[1];
    return o(function() {
      m.value = d, m.getSnapshot = p, c(m) && b({ inst: m });
    }, [h, d, p]), i(function() {
      return c(m) && b({ inst: m }), h(function() {
        c(m) && b({ inst: m });
      });
    }, [h]), s(d), d;
  }
  function c(h) {
    var p = h.getSnapshot;
    h = h.value;
    try {
      var d = p();
      return !r(h, d);
    } catch {
      return !0;
    }
  }
  function a(h, p) {
    return p();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : u;
  return ty.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : f, ty;
}
var uE = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cE;
function qF() {
  return cE || (cE = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Se, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(k) {
      {
        for (var T = arguments.length, x = new Array(T > 1 ? T - 1 : 0), P = 1; P < T; P++)
          x[P - 1] = arguments[P];
        n("error", k, x);
      }
    }
    function n(k, T, x) {
      {
        var P = e.ReactDebugCurrentFrame, R = P.getStackAddendum();
        R !== "" && (T += "%s", x = x.concat([R]));
        var D = x.map(function(I) {
          return String(I);
        });
        D.unshift("Warning: " + T), Function.prototype.apply.call(console[k], console, D);
      }
    }
    function i(k, T) {
      return k === T && (k !== 0 || 1 / k === 1 / T) || k !== k && T !== T;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = t.useState, u = t.useEffect, c = t.useLayoutEffect, a = t.useDebugValue, f = !1, h = !1;
    function p(k, T, x) {
      f || t.startTransition !== void 0 && (f = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var P = T();
      if (!h) {
        var R = T();
        o(P, R) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), h = !0);
      }
      var D = s({
        inst: {
          value: P,
          getSnapshot: T
        }
      }), I = D[0].inst, j = D[1];
      return c(function() {
        I.value = P, I.getSnapshot = T, d(I) && j({
          inst: I
        });
      }, [k, P, T]), u(function() {
        d(I) && j({
          inst: I
        });
        var Y = function() {
          d(I) && j({
            inst: I
          });
        };
        return k(Y);
      }, [k]), a(P), P;
    }
    function d(k) {
      var T = k.getSnapshot, x = k.value;
      try {
        var P = T();
        return !o(x, P);
      } catch {
        return !0;
      }
    }
    function _(k, T, x) {
      return T();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", b = !m, O = b ? _ : p, S = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : O;
    uE.useSyncExternalStore = S, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), uE;
}
process.env.NODE_ENV === "production" ? f_.exports = jF() : f_.exports = qF();
var MF = f_.exports;
MF.useSyncExternalStore;
const FF = /* @__PURE__ */ Yr.createContext(!1);
FF.Provider;
new CF();
Mr(void 0);
function wu(t) {
  function e(r, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = r, this.code = n;
  }
  return e.prototype = new Error(), e.prototype.name = t, e.prototype.constructor = e, e;
}
const NF = wu("LaunchDarklyUnexpectedResponseError"), zF = wu("LaunchDarklyInvalidEnvironmentIdError"), LF = wu("LaunchDarklyInvalidUserError"), UF = wu("LaunchDarklyInvalidEventKeyError"), BF = wu("LaunchDarklyInvalidArgumentError"), $F = wu("LaunchDarklyFlagFetchError");
for (var qB = { LDUnexpectedResponseError: NF, LDInvalidEnvironmentIdError: zF, LDInvalidUserError: LF, LDInvalidEventKeyError: UF, LDInvalidArgumentError: BF, LDInvalidDataError: wu("LaunchDarklyInvalidDataError"), LDFlagFetchError: $F, isHttpErrorRecoverable: function(t) {
  return !(t >= 400 && t < 500) || t === 400 || t === 408 || t === 429;
} }, MB = function(t) {
  var e = fE(t), r = e[0], n = e[1];
  return 3 * (r + n) / 4 - n;
}, FB = function(t) {
  var e, r, n = fE(t), i = n[0], o = n[1], s = new KF(function(a, f, h) {
    return 3 * (f + h) / 4 - h;
  }(0, i, o)), u = 0, c = o > 0 ? i - 4 : i;
  for (r = 0; r < c; r += 4)
    e = Ni[t.charCodeAt(r)] << 18 | Ni[t.charCodeAt(r + 1)] << 12 | Ni[t.charCodeAt(r + 2)] << 6 | Ni[t.charCodeAt(r + 3)], s[u++] = e >> 16 & 255, s[u++] = e >> 8 & 255, s[u++] = 255 & e;
  return o === 2 && (e = Ni[t.charCodeAt(r)] << 2 | Ni[t.charCodeAt(r + 1)] >> 4, s[u++] = 255 & e), o === 1 && (e = Ni[t.charCodeAt(r)] << 10 | Ni[t.charCodeAt(r + 1)] << 4 | Ni[t.charCodeAt(r + 2)] >> 2, s[u++] = e >> 8 & 255, s[u++] = 255 & e), s;
}, NB = function(t) {
  for (var e, r = t.length, n = r % 3, i = [], o = 16383, s = 0, u = r - n; s < u; s += o)
    i.push(QF(t, s, s + o > u ? u : s + o));
  return n === 1 ? (e = t[r - 1], i.push($o[e >> 2] + $o[e << 4 & 63] + "==")) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push($o[e >> 10] + $o[e >> 4 & 63] + $o[e << 2 & 63] + "=")), i.join("");
}, $o = [], Ni = [], KF = typeof Uint8Array < "u" ? Uint8Array : Array, ey = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Cu = 0, VF = ey.length; Cu < VF; ++Cu)
  $o[Cu] = ey[Cu], Ni[ey.charCodeAt(Cu)] = Cu;
function fE(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  return r === -1 && (r = e), [r, r === e ? 0 : 4 - r % 4];
}
function QF(t, e, r) {
  for (var n, i, o = [], s = e; s < r; s += 3)
    n = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), o.push($o[(i = n) >> 18 & 63] + $o[i >> 12 & 63] + $o[i >> 6 & 63] + $o[63 & i]);
  return o.join("");
}
Ni["-".charCodeAt(0)] = 62, Ni["_".charCodeAt(0)] = 63;
var YF = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function $D(t) {
  return typeof t == "string" && YF.test(t);
}
for (var zB, LB, Jr = [], ry = 0; ry < 256; ++ry)
  Jr.push((ry + 256).toString(16).substr(1));
function GF(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Jr[t[e + 0]] + Jr[t[e + 1]] + Jr[t[e + 2]] + Jr[t[e + 3]] + "-" + Jr[t[e + 4]] + Jr[t[e + 5]] + "-" + Jr[t[e + 6]] + Jr[t[e + 7]] + "-" + Jr[t[e + 8]] + Jr[t[e + 9]] + "-" + Jr[t[e + 10]] + Jr[t[e + 11]] + Jr[t[e + 12]] + Jr[t[e + 13]] + Jr[t[e + 14]] + Jr[t[e + 15]]).toLowerCase();
  if (!$D(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function WF(t) {
  if (!$D(t))
    throw TypeError("Invalid UUID");
  var e, r = new Uint8Array(16);
  return r[0] = (e = parseInt(t.slice(0, 8), 16)) >>> 24, r[1] = e >>> 16 & 255, r[2] = e >>> 8 & 255, r[3] = 255 & e, r[4] = (e = parseInt(t.slice(9, 13), 16)) >>> 8, r[5] = 255 & e, r[6] = (e = parseInt(t.slice(14, 18), 16)) >>> 8, r[7] = 255 & e, r[8] = (e = parseInt(t.slice(19, 23), 16)) >>> 8, r[9] = 255 & e, r[10] = (e = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = e / 4294967296 & 255, r[12] = e >>> 24 & 255, r[13] = e >>> 16 & 255, r[14] = e >>> 8 & 255, r[15] = 255 & e, r;
}
function KD(t, e, r) {
  function n(i, o, s, u) {
    if (typeof i == "string" && (i = function(f) {
      f = unescape(encodeURIComponent(f));
      for (var h = [], p = 0; p < f.length; ++p)
        h.push(f.charCodeAt(p));
      return h;
    }(i)), typeof o == "string" && (o = WF(o)), o.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + i.length);
    if (c.set(o), c.set(i, o.length), (c = r(c))[6] = 15 & c[6] | e, c[8] = 63 & c[8] | 128, s) {
      u = u || 0;
      for (var a = 0; a < 16; ++a)
        s[u + a] = c[a];
      return s;
    }
    return GF(c);
  }
  try {
    n.name = t;
  } catch {
  }
  return n.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", n.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", n;
}
function lE(t) {
  return 14 + (t + 64 >>> 9 << 4) + 1;
}
function Oa(t, e) {
  var r = (65535 & t) + (65535 & e);
  return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
}
function qd(t, e, r, n, i, o) {
  return Oa((s = Oa(Oa(e, t), Oa(n, o))) << (u = i) | s >>> 32 - u, r);
  var s, u;
}
function _n(t, e, r, n, i, o, s) {
  return qd(e & r | ~e & n, t, e, i, o, s);
}
function mn(t, e, r, n, i, o, s) {
  return qd(e & n | r & ~n, t, e, i, o, s);
}
function gn(t, e, r, n, i, o, s) {
  return qd(e ^ r ^ n, t, e, i, o, s);
}
function bn(t, e, r, n, i, o, s) {
  return qd(r ^ (e | ~n), t, e, i, o, s);
}
KD("v3", 48, function(t) {
  if (typeof t == "string") {
    var e = unescape(encodeURIComponent(t));
    t = new Uint8Array(e.length);
    for (var r = 0; r < e.length; ++r)
      t[r] = e.charCodeAt(r);
  }
  return function(n) {
    for (var i = [], o = 32 * n.length, s = "0123456789abcdef", u = 0; u < o; u += 8) {
      var c = n[u >> 5] >>> u % 32 & 255, a = parseInt(s.charAt(c >>> 4 & 15) + s.charAt(15 & c), 16);
      i.push(a);
    }
    return i;
  }(function(n, i) {
    n[i >> 5] |= 128 << i % 32, n[lE(i) - 1] = i;
    for (var o = 1732584193, s = -271733879, u = -1732584194, c = 271733878, a = 0; a < n.length; a += 16) {
      var f = o, h = s, p = u, d = c;
      o = _n(o, s, u, c, n[a], 7, -680876936), c = _n(c, o, s, u, n[a + 1], 12, -389564586), u = _n(u, c, o, s, n[a + 2], 17, 606105819), s = _n(s, u, c, o, n[a + 3], 22, -1044525330), o = _n(o, s, u, c, n[a + 4], 7, -176418897), c = _n(c, o, s, u, n[a + 5], 12, 1200080426), u = _n(u, c, o, s, n[a + 6], 17, -1473231341), s = _n(s, u, c, o, n[a + 7], 22, -45705983), o = _n(o, s, u, c, n[a + 8], 7, 1770035416), c = _n(c, o, s, u, n[a + 9], 12, -1958414417), u = _n(u, c, o, s, n[a + 10], 17, -42063), s = _n(s, u, c, o, n[a + 11], 22, -1990404162), o = _n(o, s, u, c, n[a + 12], 7, 1804603682), c = _n(c, o, s, u, n[a + 13], 12, -40341101), u = _n(u, c, o, s, n[a + 14], 17, -1502002290), o = mn(o, s = _n(s, u, c, o, n[a + 15], 22, 1236535329), u, c, n[a + 1], 5, -165796510), c = mn(c, o, s, u, n[a + 6], 9, -1069501632), u = mn(u, c, o, s, n[a + 11], 14, 643717713), s = mn(s, u, c, o, n[a], 20, -373897302), o = mn(o, s, u, c, n[a + 5], 5, -701558691), c = mn(c, o, s, u, n[a + 10], 9, 38016083), u = mn(u, c, o, s, n[a + 15], 14, -660478335), s = mn(s, u, c, o, n[a + 4], 20, -405537848), o = mn(o, s, u, c, n[a + 9], 5, 568446438), c = mn(c, o, s, u, n[a + 14], 9, -1019803690), u = mn(u, c, o, s, n[a + 3], 14, -187363961), s = mn(s, u, c, o, n[a + 8], 20, 1163531501), o = mn(o, s, u, c, n[a + 13], 5, -1444681467), c = mn(c, o, s, u, n[a + 2], 9, -51403784), u = mn(u, c, o, s, n[a + 7], 14, 1735328473), o = gn(o, s = mn(s, u, c, o, n[a + 12], 20, -1926607734), u, c, n[a + 5], 4, -378558), c = gn(c, o, s, u, n[a + 8], 11, -2022574463), u = gn(u, c, o, s, n[a + 11], 16, 1839030562), s = gn(s, u, c, o, n[a + 14], 23, -35309556), o = gn(o, s, u, c, n[a + 1], 4, -1530992060), c = gn(c, o, s, u, n[a + 4], 11, 1272893353), u = gn(u, c, o, s, n[a + 7], 16, -155497632), s = gn(s, u, c, o, n[a + 10], 23, -1094730640), o = gn(o, s, u, c, n[a + 13], 4, 681279174), c = gn(c, o, s, u, n[a], 11, -358537222), u = gn(u, c, o, s, n[a + 3], 16, -722521979), s = gn(s, u, c, o, n[a + 6], 23, 76029189), o = gn(o, s, u, c, n[a + 9], 4, -640364487), c = gn(c, o, s, u, n[a + 12], 11, -421815835), u = gn(u, c, o, s, n[a + 15], 16, 530742520), o = bn(o, s = gn(s, u, c, o, n[a + 2], 23, -995338651), u, c, n[a], 6, -198630844), c = bn(c, o, s, u, n[a + 7], 10, 1126891415), u = bn(u, c, o, s, n[a + 14], 15, -1416354905), s = bn(s, u, c, o, n[a + 5], 21, -57434055), o = bn(o, s, u, c, n[a + 12], 6, 1700485571), c = bn(c, o, s, u, n[a + 3], 10, -1894986606), u = bn(u, c, o, s, n[a + 10], 15, -1051523), s = bn(s, u, c, o, n[a + 1], 21, -2054922799), o = bn(o, s, u, c, n[a + 8], 6, 1873313359), c = bn(c, o, s, u, n[a + 15], 10, -30611744), u = bn(u, c, o, s, n[a + 6], 15, -1560198380), s = bn(s, u, c, o, n[a + 13], 21, 1309151649), o = bn(o, s, u, c, n[a + 4], 6, -145523070), c = bn(c, o, s, u, n[a + 11], 10, -1120210379), u = bn(u, c, o, s, n[a + 2], 15, 718787259), s = bn(s, u, c, o, n[a + 9], 21, -343485551), o = Oa(o, f), s = Oa(s, h), u = Oa(u, p), c = Oa(c, d);
    }
    return [o, s, u, c];
  }(function(n) {
    if (n.length === 0)
      return [];
    for (var i = 8 * n.length, o = new Uint32Array(lE(i)), s = 0; s < i; s += 8)
      o[s >> 5] |= (255 & n[s / 8]) << s % 32;
    return o;
  }(t), 8 * t.length));
});
function HF(t, e, r, n) {
  switch (t) {
    case 0:
      return e & r ^ ~e & n;
    case 1:
    case 3:
      return e ^ r ^ n;
    case 2:
      return e & r ^ e & n ^ r & n;
  }
}
function ny(t, e) {
  return t << e | t >>> 32 - e;
}
KD("v5", 80, function(t) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var n = unescape(encodeURIComponent(t));
    t = [];
    for (var i = 0; i < n.length; ++i)
      t.push(n.charCodeAt(i));
  } else
    Array.isArray(t) || (t = Array.prototype.slice.call(t));
  t.push(128);
  for (var o = t.length / 4 + 2, s = Math.ceil(o / 16), u = new Array(s), c = 0; c < s; ++c) {
    for (var a = new Uint32Array(16), f = 0; f < 16; ++f)
      a[f] = t[64 * c + 4 * f] << 24 | t[64 * c + 4 * f + 1] << 16 | t[64 * c + 4 * f + 2] << 8 | t[64 * c + 4 * f + 3];
    u[c] = a;
  }
  u[s - 1][14] = 8 * (t.length - 1) / Math.pow(2, 32), u[s - 1][14] = Math.floor(u[s - 1][14]), u[s - 1][15] = 8 * (t.length - 1) & 4294967295;
  for (var h = 0; h < s; ++h) {
    for (var p = new Uint32Array(80), d = 0; d < 16; ++d)
      p[d] = u[h][d];
    for (var _ = 16; _ < 80; ++_)
      p[_] = ny(p[_ - 3] ^ p[_ - 8] ^ p[_ - 14] ^ p[_ - 16], 1);
    for (var m = r[0], b = r[1], O = r[2], S = r[3], k = r[4], T = 0; T < 80; ++T) {
      var x = Math.floor(T / 20), P = ny(m, 5) + HF(x, b, O, S) + k + e[x] + p[T] >>> 0;
      k = S, S = O, O = ny(b, 30) >>> 0, b = m, m = P;
    }
    r[0] = r[0] + m >>> 0, r[1] = r[1] + b >>> 0, r[2] = r[2] + O >>> 0, r[3] = r[3] + S >>> 0, r[4] = r[4] + k >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, 255 & r[0], r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, 255 & r[1], r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, 255 & r[2], r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, 255 & r[3], r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, 255 & r[4]];
});
Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null });
const JF = (t, e) => e ?? !1;
Se.createContext({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  checkFlag: JF
});
var nh = "delete", Be = 5, Zi = 1 << Be, Fn = Zi - 1, de = {};
function l_() {
  return { value: !1 };
}
function Xi(t) {
  t && (t.value = !0);
}
function Wm() {
}
function hc(t) {
  return t.size === void 0 && (t.size = t.__iterate(VD)), t.size;
}
function Fa(t, e) {
  if (typeof e != "number") {
    var r = e >>> 0;
    if ("" + r !== e || r === 4294967295)
      return NaN;
    e = r;
  }
  return e < 0 ? hc(t) + e : e;
}
function VD() {
  return !0;
}
function Md(t, e, r) {
  return (t === 0 && !YD(t) || r !== void 0 && t <= -r) && (e === void 0 || r !== void 0 && e >= r);
}
function ih(t, e) {
  return QD(t, e, 0);
}
function Fd(t, e) {
  return QD(t, e, e);
}
function QD(t, e, r) {
  return t === void 0 ? r : YD(t) ? e === 1 / 0 ? e : Math.max(0, e + t) | 0 : e === void 0 || e === t ? t : Math.min(e, t) | 0;
}
function YD(t) {
  return t < 0 || t === 0 && 1 / t === -1 / 0;
}
var GD = "@@__IMMUTABLE_ITERABLE__@@";
function pi(t) {
  return !!(t && t[GD]);
}
var WD = "@@__IMMUTABLE_KEYED__@@";
function vr(t) {
  return !!(t && t[WD]);
}
var HD = "@@__IMMUTABLE_INDEXED__@@";
function oi(t) {
  return !!(t && t[HD]);
}
function Nd(t) {
  return vr(t) || oi(t);
}
var Ar = function(t) {
  return pi(t) ? t : Ti(t);
}, ho = /* @__PURE__ */ function(t) {
  function e(r) {
    return vr(r) ? r : Ka(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Ar), Eu = /* @__PURE__ */ function(t) {
  function e(r) {
    return oi(r) ? r : No(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Ar), Hc = /* @__PURE__ */ function(t) {
  function e(r) {
    return pi(r) && !Nd(r) ? r : tf(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Ar);
Ar.Keyed = ho;
Ar.Indexed = Eu;
Ar.Set = Hc;
var JD = "@@__IMMUTABLE_SEQ__@@";
function Hm(t) {
  return !!(t && t[JD]);
}
var ZD = "@@__IMMUTABLE_RECORD__@@";
function Jc(t) {
  return !!(t && t[ZD]);
}
function os(t) {
  return pi(t) || Jc(t);
}
var Zc = "@@__IMMUTABLE_ORDERED__@@";
function Ro(t) {
  return !!(t && t[Zc]);
}
var oh = 0, Co = 1, ao = 2, h_ = typeof Symbol == "function" && Symbol.iterator, XD = "@@iterator", zd = h_ || XD, we = function(t) {
  this.next = t;
};
we.prototype.toString = function() {
  return "[Iterator]";
};
we.KEYS = oh;
we.VALUES = Co;
we.ENTRIES = ao;
we.prototype.inspect = we.prototype.toSource = function() {
  return this.toString();
};
we.prototype[zd] = function() {
  return this;
};
function br(t, e, r, n) {
  var i = t === 0 ? e : t === 1 ? r : [e, r];
  return n ? n.value = i : n = {
    value: i,
    done: !1
  }, n;
}
function di() {
  return { value: void 0, done: !0 };
}
function tR(t) {
  return Array.isArray(t) ? !0 : !!Ld(t);
}
function hE(t) {
  return t && typeof t.next == "function";
}
function p_(t) {
  var e = Ld(t);
  return e && e.call(t);
}
function Ld(t) {
  var e = t && (h_ && t[h_] || t[XD]);
  if (typeof e == "function")
    return e;
}
function ZF(t) {
  var e = Ld(t);
  return e && e === t.entries;
}
function XF(t) {
  var e = Ld(t);
  return e && e === t.keys;
}
var Xc = Object.prototype.hasOwnProperty;
function eR(t) {
  return Array.isArray(t) || typeof t == "string" ? !0 : t && typeof t == "object" && Number.isInteger(t.length) && t.length >= 0 && (t.length === 0 ? (
    // Only {length: 0} is considered Array-like.
    Object.keys(t).length === 1
  ) : (
    // An object is only Array-like if it has a property where the last value
    // in the array-like may be found (which could be undefined).
    t.hasOwnProperty(t.length - 1)
  ));
}
var Ti = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Zm() : os(r) ? r.toSeq() : e3(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, e.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, e.prototype.__iterate = function(r, n) {
    var i = this._cache;
    if (i) {
      for (var o = i.length, s = 0; s !== o; ) {
        var u = i[n ? o - ++s : s++];
        if (r(u[1], u[0], this) === !1)
          break;
      }
      return s;
    }
    return this.__iterateUncached(r, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._cache;
    if (i) {
      var o = i.length, s = 0;
      return new we(function() {
        if (s === o)
          return di();
        var u = i[n ? o - ++s : s++];
        return br(r, u[0], u[1]);
      });
    }
    return this.__iteratorUncached(r, n);
  }, e;
}(Ar), Ka = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Zm().toKeyedSeq() : pi(r) ? vr(r) ? r.toSeq() : r.fromEntrySeq() : Jc(r) ? r.toSeq() : Xm(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toKeyedSeq = function() {
    return this;
  }, e;
}(Ti), No = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Zm() : pi(r) ? vr(r) ? r.entrySeq() : r.toIndexedSeq() : Jc(r) ? r.toSeq().entrySeq() : rR(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toIndexedSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, e;
}(Ti), tf = /* @__PURE__ */ function(t) {
  function e(r) {
    return (pi(r) && !Nd(r) ? r : No(r)).toSetSeq();
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toSetSeq = function() {
    return this;
  }, e;
}(Ti);
Ti.isSeq = Hm;
Ti.Keyed = Ka;
Ti.Set = tf;
Ti.Indexed = No;
Ti.prototype[JD] = !0;
var au = /* @__PURE__ */ function(t) {
  function e(r) {
    this._array = r, this.size = r.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return this.has(r) ? this._array[Fa(this, r)] : n;
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this._array, o = i.length, s = 0; s !== o; ) {
      var u = n ? o - ++s : s++;
      if (r(i[u], u, this) === !1)
        break;
    }
    return s;
  }, e.prototype.__iterator = function(r, n) {
    var i = this._array, o = i.length, s = 0;
    return new we(function() {
      if (s === o)
        return di();
      var u = n ? o - ++s : s++;
      return br(r, u, i[u]);
    });
  }, e;
}(No), Jm = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = Object.keys(r).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(r) : []
    );
    this._object = r, this._keys = n, this.size = n.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return n !== void 0 && !this.has(r) ? n : this._object[r];
  }, e.prototype.has = function(r) {
    return Xc.call(this._object, r);
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this._object, o = this._keys, s = o.length, u = 0; u !== s; ) {
      var c = o[n ? s - ++u : u++];
      if (r(i[c], c, this) === !1)
        break;
    }
    return u;
  }, e.prototype.__iterator = function(r, n) {
    var i = this._object, o = this._keys, s = o.length, u = 0;
    return new we(function() {
      if (u === s)
        return di();
      var c = o[n ? s - ++u : u++];
      return br(r, c, i[c]);
    });
  }, e;
}(Ka);
Jm.prototype[Zc] = !0;
var t3 = /* @__PURE__ */ function(t) {
  function e(r) {
    this._collection = r, this.size = r.length || r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.__iterateUncached = function(r, n) {
    if (n)
      return this.cacheResult().__iterate(r, n);
    var i = this._collection, o = p_(i), s = 0;
    if (hE(o))
      for (var u; !(u = o.next()).done && r(u.value, s++, this) !== !1; )
        ;
    return s;
  }, e.prototype.__iteratorUncached = function(r, n) {
    if (n)
      return this.cacheResult().__iterator(r, n);
    var i = this._collection, o = p_(i);
    if (!hE(o))
      return new we(di);
    var s = 0;
    return new we(function() {
      var u = o.next();
      return u.done ? u : br(r, s++, u.value);
    });
  }, e;
}(No), pE;
function Zm() {
  return pE || (pE = new au([]));
}
function Xm(t) {
  var e = tg(t);
  if (e)
    return e.fromEntrySeq();
  if (typeof t == "object")
    return new Jm(t);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + t
  );
}
function rR(t) {
  var e = tg(t);
  if (e)
    return e;
  throw new TypeError(
    "Expected Array or collection object of values: " + t
  );
}
function e3(t) {
  var e = tg(t);
  if (e)
    return ZF(t) ? e.fromEntrySeq() : XF(t) ? e.toSetSeq() : e;
  if (typeof t == "object")
    return new Jm(t);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + t
  );
}
function tg(t) {
  return eR(t) ? new au(t) : tR(t) ? new t3(t) : void 0;
}
var nR = "@@__IMMUTABLE_MAP__@@";
function eg(t) {
  return !!(t && t[nR]);
}
function iR(t) {
  return eg(t) && Ro(t);
}
function dE(t) {
  return !!(t && typeof t.equals == "function" && typeof t.hashCode == "function");
}
function Ii(t, e) {
  if (t === e || t !== t && e !== e)
    return !0;
  if (!t || !e)
    return !1;
  if (typeof t.valueOf == "function" && typeof e.valueOf == "function") {
    if (t = t.valueOf(), e = e.valueOf(), t === e || t !== t && e !== e)
      return !0;
    if (!t || !e)
      return !1;
  }
  return !!(dE(t) && dE(e) && t.equals(e));
}
var Of = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(t, e) {
  t |= 0, e |= 0;
  var r = t & 65535, n = e & 65535;
  return r * n + ((t >>> 16) * n + r * (e >>> 16) << 16 >>> 0) | 0;
};
function Ud(t) {
  return t >>> 1 & 1073741824 | t & 3221225471;
}
var r3 = Object.prototype.valueOf;
function bi(t) {
  if (t == null)
    return vE(t);
  if (typeof t.hashCode == "function")
    return Ud(t.hashCode(t));
  var e = u3(t);
  if (e == null)
    return vE(e);
  switch (typeof e) {
    case "boolean":
      return e ? 1108378657 : 1108378656;
    case "number":
      return n3(e);
    case "string":
      return e.length > c3 ? i3(e) : d_(e);
    case "object":
    case "function":
      return s3(e);
    case "symbol":
      return o3(e);
    default:
      if (typeof e.toString == "function")
        return d_(e.toString());
      throw new Error("Value type " + typeof e + " cannot be hashed.");
  }
}
function vE(t) {
  return t === null ? 1108378658 : (
    /* undefined */
    1108378659
  );
}
function n3(t) {
  if (t !== t || t === 1 / 0)
    return 0;
  var e = t | 0;
  for (e !== t && (e ^= t * 4294967295); t > 4294967295; )
    t /= 4294967295, e ^= t;
  return Ud(e);
}
function i3(t) {
  var e = sy[t];
  return e === void 0 && (e = d_(t), oy === f3 && (oy = 0, sy = {}), oy++, sy[t] = e), e;
}
function d_(t) {
  for (var e = 0, r = 0; r < t.length; r++)
    e = 31 * e + t.charCodeAt(r) | 0;
  return Ud(e);
}
function o3(t) {
  var e = mE[t];
  return e !== void 0 || (e = oR(), mE[t] = e), e;
}
function s3(t) {
  var e;
  if (v_ && (e = y_.get(t), e !== void 0) || (e = t[Ja], e !== void 0) || !_E && (e = t.propertyIsEnumerable && t.propertyIsEnumerable[Ja], e !== void 0 || (e = a3(t), e !== void 0)))
    return e;
  if (e = oR(), v_)
    y_.set(t, e);
  else {
    if (yE !== void 0 && yE(t) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (_E)
      Object.defineProperty(t, Ja, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: e
      });
    else if (t.propertyIsEnumerable !== void 0 && t.propertyIsEnumerable === t.constructor.prototype.propertyIsEnumerable)
      t.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, t.propertyIsEnumerable[Ja] = e;
    else if (t.nodeType !== void 0)
      t[Ja] = e;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return e;
}
var yE = Object.isExtensible, _E = function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
}();
function a3(t) {
  if (t && t.nodeType > 0)
    switch (t.nodeType) {
      case 1:
        return t.uniqueID;
      case 9:
        return t.documentElement && t.documentElement.uniqueID;
    }
}
function u3(t) {
  return t.valueOf !== r3 && typeof t.valueOf == "function" ? t.valueOf(t) : t;
}
function oR() {
  var t = ++iy;
  return iy & 1073741824 && (iy = 0), t;
}
var v_ = typeof WeakMap == "function", y_;
v_ && (y_ = /* @__PURE__ */ new WeakMap());
var mE = /* @__PURE__ */ Object.create(null), iy = 0, Ja = "__immutablehash__";
typeof Symbol == "function" && (Ja = Symbol(Ja));
var c3 = 16, f3 = 255, oy = 0, sy = {}, Bd = /* @__PURE__ */ function(t) {
  function e(r, n) {
    this._iter = r, this._useKeys = n, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return this._iter.get(r, n);
  }, e.prototype.has = function(r) {
    return this._iter.has(r);
  }, e.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, e.prototype.reverse = function() {
    var r = this, n = rg(this, !0);
    return this._useKeys || (n.valueSeq = function() {
      return r._iter.toSeq().reverse();
    }), n;
  }, e.prototype.map = function(r, n) {
    var i = this, o = fR(this, r, n);
    return this._useKeys || (o.valueSeq = function() {
      return i._iter.toSeq().map(r, n);
    }), o;
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o, s) {
      return r(o, s, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    return this._iter.__iterator(r, n);
  }, e;
}(Ka);
Bd.prototype[Zc] = !0;
var sR = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.includes = function(r) {
    return this._iter.includes(r);
  }, e.prototype.__iterate = function(r, n) {
    var i = this, o = 0;
    return n && hc(this), this._iter.__iterate(
      function(s) {
        return r(s, n ? i.size - ++o : o++, i);
      },
      n
    );
  }, e.prototype.__iterator = function(r, n) {
    var i = this, o = this._iter.__iterator(Co, n), s = 0;
    return n && hc(this), new we(function() {
      var u = o.next();
      return u.done ? u : br(
        r,
        n ? i.size - ++s : s++,
        u.value,
        u
      );
    });
  }, e;
}(No), aR = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.has = function(r) {
    return this._iter.includes(r);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o) {
      return r(o, o, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._iter.__iterator(Co, n);
    return new we(function() {
      var o = i.next();
      return o.done ? o : br(r, o.value, o.value, o);
    });
  }, e;
}(tf), uR = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o) {
      if (o) {
        bE(o);
        var s = pi(o);
        return r(
          s ? o.get(1) : o[1],
          s ? o.get(0) : o[0],
          i
        );
      }
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._iter.__iterator(Co, n);
    return new we(function() {
      for (; ; ) {
        var o = i.next();
        if (o.done)
          return o;
        var s = o.value;
        if (s) {
          bE(s);
          var u = pi(s);
          return br(
            r,
            u ? s.get(0) : s[0],
            u ? s.get(1) : s[1],
            o
          );
        }
      }
    });
  }, e;
}(Ka);
sR.prototype.cacheResult = Bd.prototype.cacheResult = aR.prototype.cacheResult = uR.prototype.cacheResult = og;
function cR(t) {
  var e = ss(t);
  return e._iter = t, e.size = t.size, e.flip = function() {
    return t;
  }, e.reverse = function() {
    var r = t.reverse.apply(this);
    return r.flip = function() {
      return t.reverse();
    }, r;
  }, e.has = function(r) {
    return t.includes(r);
  }, e.includes = function(r) {
    return t.has(r);
  }, e.cacheResult = og, e.__iterateUncached = function(r, n) {
    var i = this;
    return t.__iterate(function(o, s) {
      return r(s, o, i) !== !1;
    }, n);
  }, e.__iteratorUncached = function(r, n) {
    if (r === ao) {
      var i = t.__iterator(r, n);
      return new we(function() {
        var o = i.next();
        if (!o.done) {
          var s = o.value[0];
          o.value[0] = o.value[1], o.value[1] = s;
        }
        return o;
      });
    }
    return t.__iterator(
      r === Co ? oh : Co,
      n
    );
  }, e;
}
function fR(t, e, r) {
  var n = ss(t);
  return n.size = t.size, n.has = function(i) {
    return t.has(i);
  }, n.get = function(i, o) {
    var s = t.get(i, de);
    return s === de ? o : e.call(r, s, i, t);
  }, n.__iterateUncached = function(i, o) {
    var s = this;
    return t.__iterate(
      function(u, c, a) {
        return i(e.call(r, u, c, a), c, s) !== !1;
      },
      o
    );
  }, n.__iteratorUncached = function(i, o) {
    var s = t.__iterator(ao, o);
    return new we(function() {
      var u = s.next();
      if (u.done)
        return u;
      var c = u.value, a = c[0];
      return br(
        i,
        a,
        e.call(r, c[1], a, t),
        u
      );
    });
  }, n;
}
function rg(t, e) {
  var r = this, n = ss(t);
  return n._iter = t, n.size = t.size, n.reverse = function() {
    return t;
  }, t.flip && (n.flip = function() {
    var i = cR(t);
    return i.reverse = function() {
      return t.flip();
    }, i;
  }), n.get = function(i, o) {
    return t.get(e ? i : -1 - i, o);
  }, n.has = function(i) {
    return t.has(e ? i : -1 - i);
  }, n.includes = function(i) {
    return t.includes(i);
  }, n.cacheResult = og, n.__iterate = function(i, o) {
    var s = this, u = 0;
    return o && hc(t), t.__iterate(
      function(c, a) {
        return i(c, e ? a : o ? s.size - ++u : u++, s);
      },
      !o
    );
  }, n.__iterator = function(i, o) {
    var s = 0;
    o && hc(t);
    var u = t.__iterator(ao, !o);
    return new we(function() {
      var c = u.next();
      if (c.done)
        return c;
      var a = c.value;
      return br(
        i,
        e ? a[0] : o ? r.size - ++s : s++,
        a[1],
        c
      );
    });
  }, n;
}
function lR(t, e, r, n) {
  var i = ss(t);
  return n && (i.has = function(o) {
    var s = t.get(o, de);
    return s !== de && !!e.call(r, s, o, t);
  }, i.get = function(o, s) {
    var u = t.get(o, de);
    return u !== de && e.call(r, u, o, t) ? u : s;
  }), i.__iterateUncached = function(o, s) {
    var u = this, c = 0;
    return t.__iterate(function(a, f, h) {
      if (e.call(r, a, f, h))
        return c++, o(a, n ? f : c - 1, u);
    }, s), c;
  }, i.__iteratorUncached = function(o, s) {
    var u = t.__iterator(ao, s), c = 0;
    return new we(function() {
      for (; ; ) {
        var a = u.next();
        if (a.done)
          return a;
        var f = a.value, h = f[0], p = f[1];
        if (e.call(r, p, h, t))
          return br(o, n ? h : c++, p, a);
      }
    });
  }, i;
}
function l3(t, e, r) {
  var n = rf().asMutable();
  return t.__iterate(function(i, o) {
    n.update(e.call(r, i, o, t), 0, function(s) {
      return s + 1;
    });
  }), n.asImmutable();
}
function h3(t, e, r) {
  var n = vr(t), i = (Ro(t) ? sa() : rf()).asMutable();
  t.__iterate(function(s, u) {
    i.update(
      e.call(r, s, u, t),
      function(c) {
        return c = c || [], c.push(n ? [u, s] : s), c;
      }
    );
  });
  var o = ig(t);
  return i.map(function(s) {
    return Pe(t, o(s));
  }).asImmutable();
}
function p3(t, e, r) {
  var n = vr(t), i = [[], []];
  t.__iterate(function(s, u) {
    i[e.call(r, s, u, t) ? 1 : 0].push(
      n ? [u, s] : s
    );
  });
  var o = ig(t);
  return i.map(function(s) {
    return Pe(t, o(s));
  });
}
function ng(t, e, r, n) {
  var i = t.size;
  if (Md(e, r, i))
    return t;
  var o = ih(e, i), s = Fd(r, i);
  if (o !== o || s !== s)
    return ng(t.toSeq().cacheResult(), e, r, n);
  var u = s - o, c;
  u === u && (c = u < 0 ? 0 : u);
  var a = ss(t);
  return a.size = c === 0 ? c : t.size && c || void 0, !n && Hm(t) && c >= 0 && (a.get = function(f, h) {
    return f = Fa(this, f), f >= 0 && f < c ? t.get(f + o, h) : h;
  }), a.__iterateUncached = function(f, h) {
    var p = this;
    if (c === 0)
      return 0;
    if (h)
      return this.cacheResult().__iterate(f, h);
    var d = 0, _ = !0, m = 0;
    return t.__iterate(function(b, O) {
      if (!(_ && (_ = d++ < o)))
        return m++, f(b, n ? O : m - 1, p) !== !1 && m !== c;
    }), m;
  }, a.__iteratorUncached = function(f, h) {
    if (c !== 0 && h)
      return this.cacheResult().__iterator(f, h);
    if (c === 0)
      return new we(di);
    var p = t.__iterator(f, h), d = 0, _ = 0;
    return new we(function() {
      for (; d++ < o; )
        p.next();
      if (++_ > c)
        return di();
      var m = p.next();
      return n || f === Co || m.done ? m : f === oh ? br(f, _ - 1, void 0, m) : br(f, _ - 1, m.value[1], m);
    });
  }, a;
}
function d3(t, e, r) {
  var n = ss(t);
  return n.__iterateUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterate(i, o);
    var u = 0;
    return t.__iterate(
      function(c, a, f) {
        return e.call(r, c, a, f) && ++u && i(c, a, s);
      }
    ), u;
  }, n.__iteratorUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterator(i, o);
    var u = t.__iterator(ao, o), c = !0;
    return new we(function() {
      if (!c)
        return di();
      var a = u.next();
      if (a.done)
        return a;
      var f = a.value, h = f[0], p = f[1];
      return e.call(r, p, h, s) ? i === ao ? a : br(i, h, p, a) : (c = !1, di());
    });
  }, n;
}
function hR(t, e, r, n) {
  var i = ss(t);
  return i.__iterateUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterate(o, s);
    var c = !0, a = 0;
    return t.__iterate(function(f, h, p) {
      if (!(c && (c = e.call(r, f, h, p))))
        return a++, o(f, n ? h : a - 1, u);
    }), a;
  }, i.__iteratorUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterator(o, s);
    var c = t.__iterator(ao, s), a = !0, f = 0;
    return new we(function() {
      var h, p, d;
      do {
        if (h = c.next(), h.done)
          return n || o === Co ? h : o === oh ? br(o, f++, void 0, h) : br(o, f++, h.value[1], h);
        var _ = h.value;
        p = _[0], d = _[1], a && (a = e.call(r, d, p, u));
      } while (a);
      return o === ao ? h : br(o, p, d, h);
    });
  }, i;
}
function v3(t, e) {
  var r = vr(t), n = [t].concat(e).map(function(s) {
    return pi(s) ? r && (s = ho(s)) : s = r ? Xm(s) : rR(Array.isArray(s) ? s : [s]), s;
  }).filter(function(s) {
    return s.size !== 0;
  });
  if (n.length === 0)
    return t;
  if (n.length === 1) {
    var i = n[0];
    if (i === t || r && vr(i) || oi(t) && oi(i))
      return i;
  }
  var o = new au(n);
  return r ? o = o.toKeyedSeq() : oi(t) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = n.reduce(function(s, u) {
    if (s !== void 0) {
      var c = u.size;
      if (c !== void 0)
        return s + c;
    }
  }, 0), o;
}
function pR(t, e, r) {
  var n = ss(t);
  return n.__iterateUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterate(i, o);
    var s = 0, u = !1;
    function c(a, f) {
      a.__iterate(function(h, p) {
        return (!e || f < e) && pi(h) ? c(h, f + 1) : (s++, i(h, r ? p : s - 1, n) === !1 && (u = !0)), !u;
      }, o);
    }
    return c(t, 0), s;
  }, n.__iteratorUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterator(i, o);
    var s = t.__iterator(i, o), u = [], c = 0;
    return new we(function() {
      for (; s; ) {
        var a = s.next();
        if (a.done !== !1) {
          s = u.pop();
          continue;
        }
        var f = a.value;
        if (i === ao && (f = f[1]), (!e || u.length < e) && pi(f))
          u.push(s), s = f.__iterator(i, o);
        else
          return r ? a : br(i, c++, f, a);
      }
      return di();
    });
  }, n;
}
function y3(t, e, r) {
  var n = ig(t);
  return t.toSeq().map(function(i, o) {
    return n(e.call(r, i, o, t));
  }).flatten(!0);
}
function _3(t, e) {
  var r = ss(t);
  return r.size = t.size && t.size * 2 - 1, r.__iterateUncached = function(n, i) {
    var o = this, s = 0;
    return t.__iterate(
      function(u) {
        return (!s || n(e, s++, o) !== !1) && n(u, s++, o) !== !1;
      },
      i
    ), s;
  }, r.__iteratorUncached = function(n, i) {
    var o = t.__iterator(Co, i), s = 0, u;
    return new we(function() {
      return (!u || s % 2) && (u = o.next(), u.done) ? u : s % 2 ? br(n, s++, e) : br(n, s++, u.value, u);
    });
  }, r;
}
function pc(t, e, r) {
  e || (e = dR);
  var n = vr(t), i = 0, o = t.toSeq().map(function(s, u) {
    return [u, s, i++, r ? r(s, u, t) : s];
  }).valueSeq().toArray();
  return o.sort(function(s, u) {
    return e(s[3], u[3]) || s[2] - u[2];
  }).forEach(
    n ? function(s, u) {
      o[u].length = 2;
    } : function(s, u) {
      o[u] = s[1];
    }
  ), n ? Ka(o) : oi(t) ? No(o) : tf(o);
}
function $h(t, e, r) {
  if (e || (e = dR), r) {
    var n = t.toSeq().map(function(i, o) {
      return [i, r(i, o, t)];
    }).reduce(function(i, o) {
      return gE(e, i[1], o[1]) ? o : i;
    });
    return n && n[0];
  }
  return t.reduce(function(i, o) {
    return gE(e, i, o) ? o : i;
  });
}
function gE(t, e, r) {
  var n = t(r, e);
  return n === 0 && r !== e && (r == null || r !== r) || n > 0;
}
function Kh(t, e, r, n) {
  var i = ss(t), o = new au(r).map(function(s) {
    return s.size;
  });
  return i.size = n ? o.max() : o.min(), i.__iterate = function(s, u) {
    for (var c = this.__iterator(Co, u), a, f = 0; !(a = c.next()).done && s(a.value, f++, this) !== !1; )
      ;
    return f;
  }, i.__iteratorUncached = function(s, u) {
    var c = r.map(
      function(h) {
        return h = Ar(h), p_(u ? h.reverse() : h);
      }
    ), a = 0, f = !1;
    return new we(function() {
      var h;
      return f || (h = c.map(function(p) {
        return p.next();
      }), f = n ? h.every(function(p) {
        return p.done;
      }) : h.some(function(p) {
        return p.done;
      })), f ? di() : br(
        s,
        a++,
        e.apply(
          null,
          h.map(function(p) {
            return p.value;
          })
        )
      );
    });
  }, i;
}
function Pe(t, e) {
  return t === e ? t : Hm(t) ? e : t.constructor(e);
}
function bE(t) {
  if (t !== Object(t))
    throw new TypeError("Expected [K, V] tuple: " + t);
}
function ig(t) {
  return vr(t) ? ho : oi(t) ? Eu : Hc;
}
function ss(t) {
  return Object.create(
    (vr(t) ? Ka : oi(t) ? No : tf).prototype
  );
}
function og() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : Ti.prototype.cacheResult.call(this);
}
function dR(t, e) {
  return t === void 0 && e === void 0 ? 0 : t === void 0 ? 1 : e === void 0 ? -1 : t > e ? 1 : t < e ? -1 : 0;
}
function Go(t, e) {
  e = e || 0;
  for (var r = Math.max(0, t.length - e), n = new Array(r), i = 0; i < r; i++)
    n[i] = t[i + e];
  return n;
}
function sg(t, e) {
  if (!t)
    throw new Error(e);
}
function to(t) {
  sg(
    t !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function vR(t) {
  if (eR(t) && typeof t != "string")
    return t;
  if (Ro(t))
    return t.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + t
  );
}
var m3 = Object.prototype.toString;
function g3(t) {
  if (!t || typeof t != "object" || m3.call(t) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(t);
  if (e === null)
    return !0;
  for (var r = e, n = Object.getPrototypeOf(e); n !== null; )
    r = n, n = Object.getPrototypeOf(r);
  return r === e;
}
function Na(t) {
  return typeof t == "object" && (os(t) || Array.isArray(t) || g3(t));
}
function gl(t) {
  try {
    return typeof t == "string" ? JSON.stringify(t) : String(t);
  } catch {
    return JSON.stringify(t);
  }
}
function b3(t, e) {
  return os(t) ? t.has(e) : Na(t) && Xc.call(t, e);
}
function yR(t, e, r) {
  return os(t) ? t.get(e, r) : b3(t, e) ? typeof t.get == "function" ? t.get(e) : t[e] : r;
}
function Fp(t) {
  if (Array.isArray(t))
    return Go(t);
  var e = {};
  for (var r in t)
    Xc.call(t, r) && (e[r] = t[r]);
  return e;
}
function w3(t, e) {
  if (!Na(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (os(t)) {
    if (!t.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + t
      );
    return t.remove(e);
  }
  if (!Xc.call(t, e))
    return t;
  var r = Fp(t);
  return Array.isArray(r) ? r.splice(e, 1) : delete r[e], r;
}
function E3(t, e, r) {
  if (!Na(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (os(t)) {
    if (!t.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + t
      );
    return t.set(e, r);
  }
  if (Xc.call(t, e) && r === t[e])
    return t;
  var n = Fp(t);
  return n[e] = r, n;
}
function ef(t, e, r, n) {
  n || (n = r, r = void 0);
  var i = _R(
    os(t),
    t,
    vR(e),
    0,
    r,
    n
  );
  return i === de ? r : i;
}
function _R(t, e, r, n, i, o) {
  var s = e === de;
  if (n === r.length) {
    var u = s ? i : e, c = o(u);
    return c === u ? e : c;
  }
  if (!s && !Na(e))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + r.slice(0, n).map(gl) + "]: " + e
    );
  var a = r[n], f = s ? de : yR(e, a, de), h = _R(
    f === de ? t : os(f),
    f,
    r,
    n + 1,
    i,
    o
  );
  return h === f ? e : h === de ? w3(e, a) : E3(
    s ? t ? So() : {} : e,
    a,
    h
  );
}
function S3(t, e, r) {
  return ef(t, e, de, function() {
    return r;
  });
}
function ag(t, e) {
  return S3(this, t, e);
}
function O3(t, e) {
  return ef(t, e, function() {
    return de;
  });
}
function ug(t) {
  return O3(this, t);
}
function mR(t, e, r, n) {
  return ef(t, [e], r, n);
}
function cg(t, e, r) {
  return arguments.length === 1 ? t(this) : mR(this, t, e, r);
}
function fg(t, e, r) {
  return ef(this, t, e, r);
}
function gR() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return wR(this, t);
}
function bR(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  if (typeof t != "function")
    throw new TypeError("Invalid merger function: " + t);
  return wR(this, e, t);
}
function wR(t, e, r) {
  for (var n = [], i = 0; i < e.length; i++) {
    var o = ho(e[i]);
    o.size !== 0 && n.push(o);
  }
  return n.length === 0 ? t : t.toSeq().size === 0 && !t.__ownerID && n.length === 1 ? t.constructor(n[0]) : t.withMutations(function(s) {
    for (var u = r ? function(a, f) {
      mR(
        s,
        f,
        de,
        function(h) {
          return h === de ? a : r(h, a, f);
        }
      );
    } : function(a, f) {
      s.set(f, a);
    }, c = 0; c < n.length; c++)
      n[c].forEach(u);
  });
}
function lg(t, e, r) {
  return hg(t, e, I3(r));
}
function hg(t, e, r) {
  if (!Na(t))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + t
    );
  if (os(t))
    return typeof r == "function" && t.mergeWith ? t.mergeWith.apply(t, [r].concat(e)) : t.merge ? t.merge.apply(t, e) : t.concat.apply(t, e);
  for (var n = Array.isArray(t), i = t, o = n ? Eu : ho, s = n ? function(c) {
    i === t && (i = Fp(i)), i.push(c);
  } : function(c, a) {
    var f = Xc.call(i, a), h = f && r ? r(i[a], c, a) : c;
    (!f || h !== i[a]) && (i === t && (i = Fp(i)), i[a] = h);
  }, u = 0; u < e.length; u++)
    o(e[u]).forEach(s);
  return i;
}
function I3(t) {
  function e(r, n, i) {
    return Na(r) && Na(n) && A3(r, n) ? hg(r, [n], e) : t ? t(r, n, i) : n;
  }
  return e;
}
function A3(t, e) {
  var r = Ti(t), n = Ti(e);
  return oi(r) === oi(n) && vr(r) === vr(n);
}
function ER() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return lg(this, t);
}
function SR(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return lg(this, e, t);
}
function pg(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return ef(this, t, So(), function(n) {
    return hg(n, e);
  });
}
function dg(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return ef(
    this,
    t,
    So(),
    function(n) {
      return lg(n, e);
    }
  );
}
function sh(t) {
  var e = this.asMutable();
  return t(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
}
function ah() {
  return this.__ownerID ? this : this.__ensureOwner(new Wm());
}
function uh() {
  return this.__ensureOwner();
}
function vg() {
  return this.__altered;
}
var rf = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? So() : eg(r) && !Ro(r) ? r : So().withMutations(function(n) {
      var i = t(r);
      to(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    return So().withMutations(function(i) {
      for (var o = 0; o < r.length; o += 2) {
        if (o + 1 >= r.length)
          throw new Error("Missing value for key: " + r[o]);
        i.set(r[o], r[o + 1]);
      }
    });
  }, e.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, e.prototype.get = function(r, n) {
    return this._root ? this._root.get(0, void 0, r, n) : n;
  }, e.prototype.set = function(r, n) {
    return SE(this, r, n);
  }, e.prototype.remove = function(r) {
    return SE(this, r, de);
  }, e.prototype.deleteAll = function(r) {
    var n = Ar(r);
    return n.size === 0 ? this : this.withMutations(function(i) {
      n.forEach(function(o) {
        return i.remove(o);
      });
    });
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : So();
  }, e.prototype.sort = function(r) {
    return sa(pc(this, r));
  }, e.prototype.sortBy = function(r, n) {
    return sa(pc(this, n, r));
  }, e.prototype.map = function(r, n) {
    var i = this;
    return this.withMutations(function(o) {
      o.forEach(function(s, u) {
        o.set(u, r.call(n, s, u, i));
      });
    });
  }, e.prototype.__iterator = function(r, n) {
    return new D3(this, r, n);
  }, e.prototype.__iterate = function(r, n) {
    var i = this, o = 0;
    return this._root && this._root.iterate(function(s) {
      return o++, r(s[1], s[0], i);
    }, n), o;
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? yg(this.size, this._root, r, this.__hash) : this.size === 0 ? So() : (this.__ownerID = r, this.__altered = !1, this);
  }, e;
}(ho);
rf.isMap = eg;
var Ye = rf.prototype;
Ye[nR] = !0;
Ye[nh] = Ye.remove;
Ye.removeAll = Ye.deleteAll;
Ye.setIn = ag;
Ye.removeIn = Ye.deleteIn = ug;
Ye.update = cg;
Ye.updateIn = fg;
Ye.merge = Ye.concat = gR;
Ye.mergeWith = bR;
Ye.mergeDeep = ER;
Ye.mergeDeepWith = SR;
Ye.mergeIn = pg;
Ye.mergeDeepIn = dg;
Ye.withMutations = sh;
Ye.wasAltered = vg;
Ye.asImmutable = uh;
Ye["@@transducer/init"] = Ye.asMutable = ah;
Ye["@@transducer/step"] = function(t, e) {
  return t.set(e[0], e[1]);
};
Ye["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var bl = function(t, e) {
  this.ownerID = t, this.entries = e;
};
bl.prototype.get = function(t, e, r, n) {
  for (var i = this.entries, o = 0, s = i.length; o < s; o++)
    if (Ii(r, i[o][0]))
      return i[o][1];
  return n;
};
bl.prototype.update = function(t, e, r, n, i, o, s) {
  for (var u = i === de, c = this.entries, a = 0, f = c.length; a < f && !Ii(n, c[a][0]); a++)
    ;
  var h = a < f;
  if (h ? c[a][1] === i : u)
    return this;
  if (Xi(s), (u || !h) && Xi(o), !(u && c.length === 1)) {
    if (!h && !u && c.length >= C3)
      return R3(t, c, n, i);
    var p = t && t === this.ownerID, d = p ? c : Go(c);
    return h ? u ? a === f - 1 ? d.pop() : d[a] = d.pop() : d[a] = [n, i] : d.push([n, i]), p ? (this.entries = d, this) : new bl(t, d);
  }
};
var dc = function(t, e, r) {
  this.ownerID = t, this.bitmap = e, this.nodes = r;
};
dc.prototype.get = function(t, e, r, n) {
  e === void 0 && (e = bi(r));
  var i = 1 << ((t === 0 ? e : e >>> t) & Fn), o = this.bitmap;
  return o & i ? this.nodes[OR(o & i - 1)].get(
    t + Be,
    e,
    r,
    n
  ) : n;
};
dc.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = bi(n));
  var u = (e === 0 ? r : r >>> e) & Fn, c = 1 << u, a = this.bitmap, f = (a & c) !== 0;
  if (!f && i === de)
    return this;
  var h = OR(a & c - 1), p = this.nodes, d = f ? p[h] : void 0, _ = _g(
    d,
    t,
    e + Be,
    r,
    n,
    i,
    o,
    s
  );
  if (_ === d)
    return this;
  if (!f && _ && p.length >= j3)
    return T3(t, p, a, u, _);
  if (f && !_ && p.length === 2 && OE(p[h ^ 1]))
    return p[h ^ 1];
  if (f && _ && p.length === 1 && OE(_))
    return _;
  var m = t && t === this.ownerID, b = f ? _ ? a : a ^ c : a | c, O = f ? _ ? IR(p, h, _, m) : k3(p, h, m) : P3(p, h, _, m);
  return m ? (this.bitmap = b, this.nodes = O, this) : new dc(t, b, O);
};
var wl = function(t, e, r) {
  this.ownerID = t, this.count = e, this.nodes = r;
};
wl.prototype.get = function(t, e, r, n) {
  e === void 0 && (e = bi(r));
  var i = (t === 0 ? e : e >>> t) & Fn, o = this.nodes[i];
  return o ? o.get(t + Be, e, r, n) : n;
};
wl.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = bi(n));
  var u = (e === 0 ? r : r >>> e) & Fn, c = i === de, a = this.nodes, f = a[u];
  if (c && !f)
    return this;
  var h = _g(
    f,
    t,
    e + Be,
    r,
    n,
    i,
    o,
    s
  );
  if (h === f)
    return this;
  var p = this.count;
  if (!f)
    p++;
  else if (!h && (p--, p < q3))
    return x3(t, a, p, u);
  var d = t && t === this.ownerID, _ = IR(a, u, h, d);
  return d ? (this.count = p, this.nodes = _, this) : new wl(t, p, _);
};
var vc = function(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entries = r;
};
vc.prototype.get = function(t, e, r, n) {
  for (var i = this.entries, o = 0, s = i.length; o < s; o++)
    if (Ii(r, i[o][0]))
      return i[o][1];
  return n;
};
vc.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = bi(n));
  var u = i === de;
  if (r !== this.keyHash)
    return u ? this : (Xi(s), Xi(o), mg(this, t, e, r, [n, i]));
  for (var c = this.entries, a = 0, f = c.length; a < f && !Ii(n, c[a][0]); a++)
    ;
  var h = a < f;
  if (h ? c[a][1] === i : u)
    return this;
  if (Xi(s), (u || !h) && Xi(o), u && f === 2)
    return new oa(t, this.keyHash, c[a ^ 1]);
  var p = t && t === this.ownerID, d = p ? c : Go(c);
  return h ? u ? a === f - 1 ? d.pop() : d[a] = d.pop() : d[a] = [n, i] : d.push([n, i]), p ? (this.entries = d, this) : new vc(t, this.keyHash, d);
};
var oa = function(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entry = r;
};
oa.prototype.get = function(t, e, r, n) {
  return Ii(r, this.entry[0]) ? this.entry[1] : n;
};
oa.prototype.update = function(t, e, r, n, i, o, s) {
  var u = i === de, c = Ii(n, this.entry[0]);
  if (c ? i === this.entry[1] : u)
    return this;
  if (Xi(s), u) {
    Xi(o);
    return;
  }
  return c ? t && t === this.ownerID ? (this.entry[1] = i, this) : new oa(t, this.keyHash, [n, i]) : (Xi(o), mg(this, t, e, bi(n), [n, i]));
};
bl.prototype.iterate = vc.prototype.iterate = function(t, e) {
  for (var r = this.entries, n = 0, i = r.length - 1; n <= i; n++)
    if (t(r[e ? i - n : n]) === !1)
      return !1;
};
dc.prototype.iterate = wl.prototype.iterate = function(t, e) {
  for (var r = this.nodes, n = 0, i = r.length - 1; n <= i; n++) {
    var o = r[e ? i - n : n];
    if (o && o.iterate(t, e) === !1)
      return !1;
  }
};
oa.prototype.iterate = function(t, e) {
  return t(this.entry);
};
var D3 = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    this._type = n, this._reverse = i, this._stack = r._root && wE(r._root);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function() {
    for (var r = this._type, n = this._stack; n; ) {
      var i = n.node, o = n.index++, s = void 0;
      if (i.entry) {
        if (o === 0)
          return ay(r, i.entry);
      } else if (i.entries) {
        if (s = i.entries.length - 1, o <= s)
          return ay(
            r,
            i.entries[this._reverse ? s - o : o]
          );
      } else if (s = i.nodes.length - 1, o <= s) {
        var u = i.nodes[this._reverse ? s - o : o];
        if (u) {
          if (u.entry)
            return ay(r, u.entry);
          n = this._stack = wE(u, n);
        }
        continue;
      }
      n = this._stack = this._stack.__prev;
    }
    return di();
  }, e;
}(we);
function ay(t, e) {
  return br(t, e[0], e[1]);
}
function wE(t, e) {
  return {
    node: t,
    index: 0,
    __prev: e
  };
}
function yg(t, e, r, n) {
  var i = Object.create(Ye);
  return i.size = t, i._root = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var EE;
function So() {
  return EE || (EE = yg(0));
}
function SE(t, e, r) {
  var n, i;
  if (t._root) {
    var o = l_(), s = l_();
    if (n = _g(
      t._root,
      t.__ownerID,
      0,
      void 0,
      e,
      r,
      o,
      s
    ), !s.value)
      return t;
    i = t.size + (o.value ? r === de ? -1 : 1 : 0);
  } else {
    if (r === de)
      return t;
    i = 1, n = new bl(t.__ownerID, [[e, r]]);
  }
  return t.__ownerID ? (t.size = i, t._root = n, t.__hash = void 0, t.__altered = !0, t) : n ? yg(i, n) : So();
}
function _g(t, e, r, n, i, o, s, u) {
  return t ? t.update(
    e,
    r,
    n,
    i,
    o,
    s,
    u
  ) : o === de ? t : (Xi(u), Xi(s), new oa(e, n, [i, o]));
}
function OE(t) {
  return t.constructor === oa || t.constructor === vc;
}
function mg(t, e, r, n, i) {
  if (t.keyHash === n)
    return new vc(e, n, [t.entry, i]);
  var o = (r === 0 ? t.keyHash : t.keyHash >>> r) & Fn, s = (r === 0 ? n : n >>> r) & Fn, u, c = o === s ? [mg(t, e, r + Be, n, i)] : (u = new oa(e, n, i), o < s ? [t, u] : [u, t]);
  return new dc(e, 1 << o | 1 << s, c);
}
function R3(t, e, r, n) {
  t || (t = new Wm());
  for (var i = new oa(t, bi(r), [r, n]), o = 0; o < e.length; o++) {
    var s = e[o];
    i = i.update(t, 0, void 0, s[0], s[1]);
  }
  return i;
}
function x3(t, e, r, n) {
  for (var i = 0, o = 0, s = new Array(r), u = 0, c = 1, a = e.length; u < a; u++, c <<= 1) {
    var f = e[u];
    f !== void 0 && u !== n && (i |= c, s[o++] = f);
  }
  return new dc(t, i, s);
}
function T3(t, e, r, n, i) {
  for (var o = 0, s = new Array(Zi), u = 0; r !== 0; u++, r >>>= 1)
    s[u] = r & 1 ? e[o++] : void 0;
  return s[n] = i, new wl(t, o + 1, s);
}
function OR(t) {
  return t -= t >> 1 & 1431655765, t = (t & 858993459) + (t >> 2 & 858993459), t = t + (t >> 4) & 252645135, t += t >> 8, t += t >> 16, t & 127;
}
function IR(t, e, r, n) {
  var i = n ? t : Go(t);
  return i[e] = r, i;
}
function P3(t, e, r, n) {
  var i = t.length + 1;
  if (n && e + 1 === i)
    return t[e] = r, t;
  for (var o = new Array(i), s = 0, u = 0; u < i; u++)
    u === e ? (o[u] = r, s = -1) : o[u] = t[u + s];
  return o;
}
function k3(t, e, r) {
  var n = t.length - 1;
  if (r && e === n)
    return t.pop(), t;
  for (var i = new Array(n), o = 0, s = 0; s < n; s++)
    s === e && (o = 1), i[s] = t[s + o];
  return i;
}
var C3 = Zi / 4, j3 = Zi / 2, q3 = Zi / 4, AR = "@@__IMMUTABLE_LIST__@@";
function DR(t) {
  return !!(t && t[AR]);
}
var $d = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = hp();
    if (r == null)
      return n;
    if (DR(r))
      return r;
    var i = t(r), o = i.size;
    return o === 0 ? n : (to(o), o > 0 && o < Zi ? El(0, o, Be, null, new xa(i.toArray())) : n.withMutations(function(s) {
      s.setSize(o), i.forEach(function(u, c) {
        return s.set(c, u);
      });
    }));
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, e.prototype.get = function(r, n) {
    if (r = Fa(this, r), r >= 0 && r < this.size) {
      r += this._origin;
      var i = RR(this, r);
      return i && i.array[r & Fn];
    }
    return n;
  }, e.prototype.set = function(r, n) {
    return M3(this, r, n);
  }, e.prototype.remove = function(r) {
    return this.has(r) ? r === 0 ? this.shift() : r === this.size - 1 ? this.pop() : this.splice(r, 1) : this;
  }, e.prototype.insert = function(r, n) {
    return this.splice(r, 0, n);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = Be, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : hp();
  }, e.prototype.push = function() {
    var r = arguments, n = this.size;
    return this.withMutations(function(i) {
      ma(i, 0, n + r.length);
      for (var o = 0; o < r.length; o++)
        i.set(n + o, r[o]);
    });
  }, e.prototype.pop = function() {
    return ma(this, 0, -1);
  }, e.prototype.unshift = function() {
    var r = arguments;
    return this.withMutations(function(n) {
      ma(n, -r.length);
      for (var i = 0; i < r.length; i++)
        n.set(i, r[i]);
    });
  }, e.prototype.shift = function() {
    return ma(this, 1);
  }, e.prototype.concat = function() {
    for (var r = arguments, n = [], i = 0; i < arguments.length; i++) {
      var o = r[i], s = t(
        typeof o != "string" && tR(o) ? o : [o]
      );
      s.size !== 0 && n.push(s);
    }
    return n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(u) {
      n.forEach(function(c) {
        return c.forEach(function(a) {
          return u.push(a);
        });
      });
    });
  }, e.prototype.setSize = function(r) {
    return ma(this, 0, r);
  }, e.prototype.map = function(r, n) {
    var i = this;
    return this.withMutations(function(o) {
      for (var s = 0; s < i.size; s++)
        o.set(s, r.call(n, o.get(s), s, i));
    });
  }, e.prototype.slice = function(r, n) {
    var i = this.size;
    return Md(r, n, i) ? this : ma(
      this,
      ih(r, i),
      Fd(n, i)
    );
  }, e.prototype.__iterator = function(r, n) {
    var i = n ? this.size : 0, o = IE(this, n);
    return new we(function() {
      var s = o();
      return s === Wf ? di() : br(r, n ? --i : i++, s);
    });
  }, e.prototype.__iterate = function(r, n) {
    for (var i = n ? this.size : 0, o = IE(this, n), s; (s = o()) !== Wf && r(s, n ? --i : i++, this) !== !1; )
      ;
    return i;
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? El(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      r,
      this.__hash
    ) : this.size === 0 ? hp() : (this.__ownerID = r, this.__altered = !1, this);
  }, e;
}(Eu);
$d.isList = DR;
var jr = $d.prototype;
jr[AR] = !0;
jr[nh] = jr.remove;
jr.merge = jr.concat;
jr.setIn = ag;
jr.deleteIn = jr.removeIn = ug;
jr.update = cg;
jr.updateIn = fg;
jr.mergeIn = pg;
jr.mergeDeepIn = dg;
jr.withMutations = sh;
jr.wasAltered = vg;
jr.asImmutable = uh;
jr["@@transducer/init"] = jr.asMutable = ah;
jr["@@transducer/step"] = function(t, e) {
  return t.push(e);
};
jr["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var xa = function(t, e) {
  this.array = t, this.ownerID = e;
};
xa.prototype.removeBefore = function(t, e, r) {
  if (r === e ? 1 << e : this.array.length === 0)
    return this;
  var n = r >>> e & Fn;
  if (n >= this.array.length)
    return new xa([], t);
  var i = n === 0, o;
  if (e > 0) {
    var s = this.array[n];
    if (o = s && s.removeBefore(t, e - Be, r), o === s && i)
      return this;
  }
  if (i && !o)
    return this;
  var u = yc(this, t);
  if (!i)
    for (var c = 0; c < n; c++)
      u.array[c] = void 0;
  return o && (u.array[n] = o), u;
};
xa.prototype.removeAfter = function(t, e, r) {
  if (r === (e ? 1 << e : 0) || this.array.length === 0)
    return this;
  var n = r - 1 >>> e & Fn;
  if (n >= this.array.length)
    return this;
  var i;
  if (e > 0) {
    var o = this.array[n];
    if (i = o && o.removeAfter(t, e - Be, r), i === o && n === this.array.length - 1)
      return this;
  }
  var s = yc(this, t);
  return s.array.splice(n + 1), i && (s.array[n] = i), s;
};
var Wf = {};
function IE(t, e) {
  var r = t._origin, n = t._capacity, i = Sl(n), o = t._tail;
  return s(t._root, t._level, 0);
  function s(a, f, h) {
    return f === 0 ? u(a, h) : c(a, f, h);
  }
  function u(a, f) {
    var h = f === i ? o && o.array : a && a.array, p = f > r ? 0 : r - f, d = n - f;
    return d > Zi && (d = Zi), function() {
      if (p === d)
        return Wf;
      var _ = e ? --d : p++;
      return h && h[_];
    };
  }
  function c(a, f, h) {
    var p, d = a && a.array, _ = h > r ? 0 : r - h >> f, m = (n - h >> f) + 1;
    return m > Zi && (m = Zi), function() {
      for (; ; ) {
        if (p) {
          var b = p();
          if (b !== Wf)
            return b;
          p = null;
        }
        if (_ === m)
          return Wf;
        var O = e ? --m : _++;
        p = s(
          d && d[O],
          f - Be,
          h + (O << f)
        );
      }
    };
  }
}
function El(t, e, r, n, i, o, s) {
  var u = Object.create(jr);
  return u.size = e - t, u._origin = t, u._capacity = e, u._level = r, u._root = n, u._tail = i, u.__ownerID = o, u.__hash = s, u.__altered = !1, u;
}
var AE;
function hp() {
  return AE || (AE = El(0, 0, Be));
}
function M3(t, e, r) {
  if (e = Fa(t, e), e !== e)
    return t;
  if (e >= t.size || e < 0)
    return t.withMutations(function(s) {
      e < 0 ? ma(s, e).set(0, r) : ma(s, 0, e + 1).set(e, r);
    });
  e += t._origin;
  var n = t._tail, i = t._root, o = l_();
  return e >= Sl(t._capacity) ? n = __(n, t.__ownerID, 0, e, r, o) : i = __(
    i,
    t.__ownerID,
    t._level,
    e,
    r,
    o
  ), o.value ? t.__ownerID ? (t._root = i, t._tail = n, t.__hash = void 0, t.__altered = !0, t) : El(t._origin, t._capacity, t._level, i, n) : t;
}
function __(t, e, r, n, i, o) {
  var s = n >>> r & Fn, u = t && s < t.array.length;
  if (!u && i === void 0)
    return t;
  var c;
  if (r > 0) {
    var a = t && t.array[s], f = __(
      a,
      e,
      r - Be,
      n,
      i,
      o
    );
    return f === a ? t : (c = yc(t, e), c.array[s] = f, c);
  }
  return u && t.array[s] === i ? t : (o && Xi(o), c = yc(t, e), i === void 0 && s === c.array.length - 1 ? c.array.pop() : c.array[s] = i, c);
}
function yc(t, e) {
  return e && t && e === t.ownerID ? t : new xa(t ? t.array.slice() : [], e);
}
function RR(t, e) {
  if (e >= Sl(t._capacity))
    return t._tail;
  if (e < 1 << t._level + Be) {
    for (var r = t._root, n = t._level; r && n > 0; )
      r = r.array[e >>> n & Fn], n -= Be;
    return r;
  }
}
function ma(t, e, r) {
  e !== void 0 && (e |= 0), r !== void 0 && (r |= 0);
  var n = t.__ownerID || new Wm(), i = t._origin, o = t._capacity, s = i + e, u = r === void 0 ? o : r < 0 ? o + r : i + r;
  if (s === i && u === o)
    return t;
  if (s >= u)
    return t.clear();
  for (var c = t._level, a = t._root, f = 0; s + f < 0; )
    a = new xa(
      a && a.array.length ? [void 0, a] : [],
      n
    ), c += Be, f += 1 << c;
  f && (s += f, i += f, u += f, o += f);
  for (var h = Sl(o), p = Sl(u); p >= 1 << c + Be; )
    a = new xa(
      a && a.array.length ? [a] : [],
      n
    ), c += Be;
  var d = t._tail, _ = p < h ? RR(t, u - 1) : p > h ? new xa([], n) : d;
  if (d && p > h && s < o && d.array.length) {
    a = yc(a, n);
    for (var m = a, b = c; b > Be; b -= Be) {
      var O = h >>> b & Fn;
      m = m.array[O] = yc(m.array[O], n);
    }
    m.array[h >>> Be & Fn] = d;
  }
  if (u < o && (_ = _ && _.removeAfter(n, 0, u)), s >= p)
    s -= p, u -= p, c = Be, a = null, _ = _ && _.removeBefore(n, 0, s);
  else if (s > i || p < h) {
    for (f = 0; a; ) {
      var S = s >>> c & Fn;
      if (S !== p >>> c & Fn)
        break;
      S && (f += (1 << c) * S), c -= Be, a = a.array[S];
    }
    a && s > i && (a = a.removeBefore(n, c, s - f)), a && p < h && (a = a.removeAfter(
      n,
      c,
      p - f
    )), f && (s -= f, u -= f);
  }
  return t.__ownerID ? (t.size = u - s, t._origin = s, t._capacity = u, t._level = c, t._root = a, t._tail = _, t.__hash = void 0, t.__altered = !0, t) : El(s, u, c, a, _);
}
function Sl(t) {
  return t < Zi ? 0 : t - 1 >>> Be << Be;
}
var sa = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? zf() : iR(r) ? r : zf().withMutations(function(n) {
      var i = ho(r);
      to(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, e.prototype.get = function(r, n) {
    var i = this._map.get(r);
    return i !== void 0 ? this._list.get(i)[1] : n;
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : zf();
  }, e.prototype.set = function(r, n) {
    return RE(this, r, n);
  }, e.prototype.remove = function(r) {
    return RE(this, r, de);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._list.__iterate(
      function(o) {
        return o && r(o[1], o[0], i);
      },
      n
    );
  }, e.prototype.__iterator = function(r, n) {
    return this._list.fromEntrySeq().__iterator(r, n);
  }, e.prototype.__ensureOwner = function(r) {
    if (r === this.__ownerID)
      return this;
    var n = this._map.__ensureOwner(r), i = this._list.__ensureOwner(r);
    return r ? gg(n, i, r, this.__hash) : this.size === 0 ? zf() : (this.__ownerID = r, this.__altered = !1, this._map = n, this._list = i, this);
  }, e;
}(rf);
sa.isOrderedMap = iR;
sa.prototype[Zc] = !0;
sa.prototype[nh] = sa.prototype.remove;
function gg(t, e, r, n) {
  var i = Object.create(sa.prototype);
  return i.size = t ? t.size : 0, i._map = t, i._list = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var DE;
function zf() {
  return DE || (DE = gg(So(), hp()));
}
function RE(t, e, r) {
  var n = t._map, i = t._list, o = n.get(e), s = o !== void 0, u, c;
  if (r === de) {
    if (!s)
      return t;
    i.size >= Zi && i.size >= n.size * 2 ? (c = i.filter(function(a, f) {
      return a !== void 0 && o !== f;
    }), u = c.toKeyedSeq().map(function(a) {
      return a[0];
    }).flip().toMap(), t.__ownerID && (u.__ownerID = c.__ownerID = t.__ownerID)) : (u = n.remove(e), c = o === i.size - 1 ? i.pop() : i.set(o, void 0));
  } else if (s) {
    if (r === i.get(o)[1])
      return t;
    u = n, c = i.set(o, [e, r]);
  } else
    u = n.set(e, i.size), c = i.set(i.size, [e, r]);
  return t.__ownerID ? (t.size = u.size, t._map = u, t._list = c, t.__hash = void 0, t.__altered = !0, t) : gg(u, c);
}
var xR = "@@__IMMUTABLE_STACK__@@";
function m_(t) {
  return !!(t && t[xR]);
}
var bg = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Vh() : m_(r) ? r : Vh().pushAll(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, e.prototype.get = function(r, n) {
    var i = this._head;
    for (r = Fa(this, r); i && r--; )
      i = i.next;
    return i ? i.value : n;
  }, e.prototype.peek = function() {
    return this._head && this._head.value;
  }, e.prototype.push = function() {
    var r = arguments;
    if (arguments.length === 0)
      return this;
    for (var n = this.size + arguments.length, i = this._head, o = arguments.length - 1; o >= 0; o--)
      i = {
        value: r[o],
        next: i
      };
    return this.__ownerID ? (this.size = n, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Lf(n, i);
  }, e.prototype.pushAll = function(r) {
    if (r = t(r), r.size === 0)
      return this;
    if (this.size === 0 && m_(r))
      return r;
    to(r.size);
    var n = this.size, i = this._head;
    return r.__iterate(
      function(o) {
        n++, i = {
          value: o,
          next: i
        };
      },
      /* reverse */
      !0
    ), this.__ownerID ? (this.size = n, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Lf(n, i);
  }, e.prototype.pop = function() {
    return this.slice(1);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Vh();
  }, e.prototype.slice = function(r, n) {
    if (Md(r, n, this.size))
      return this;
    var i = ih(r, this.size), o = Fd(n, this.size);
    if (o !== this.size)
      return t.prototype.slice.call(this, r, n);
    for (var s = this.size - i, u = this._head; i--; )
      u = u.next;
    return this.__ownerID ? (this.size = s, this._head = u, this.__hash = void 0, this.__altered = !0, this) : Lf(s, u);
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? Lf(this.size, this._head, r, this.__hash) : this.size === 0 ? Vh() : (this.__ownerID = r, this.__altered = !1, this);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    if (n)
      return new au(this.toArray()).__iterate(
        function(u, c) {
          return r(u, c, i);
        },
        n
      );
    for (var o = 0, s = this._head; s && r(s.value, o++, this) !== !1; )
      s = s.next;
    return o;
  }, e.prototype.__iterator = function(r, n) {
    if (n)
      return new au(this.toArray()).__iterator(r, n);
    var i = 0, o = this._head;
    return new we(function() {
      if (o) {
        var s = o.value;
        return o = o.next, br(r, i++, s);
      }
      return di();
    });
  }, e;
}(Eu);
bg.isStack = m_;
var Bn = bg.prototype;
Bn[xR] = !0;
Bn.shift = Bn.pop;
Bn.unshift = Bn.push;
Bn.unshiftAll = Bn.pushAll;
Bn.withMutations = sh;
Bn.wasAltered = vg;
Bn.asImmutable = uh;
Bn["@@transducer/init"] = Bn.asMutable = ah;
Bn["@@transducer/step"] = function(t, e) {
  return t.unshift(e);
};
Bn["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
function Lf(t, e, r, n) {
  var i = Object.create(Bn);
  return i.size = t, i._head = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var xE;
function Vh() {
  return xE || (xE = Lf(0));
}
var TR = "@@__IMMUTABLE_SET__@@";
function wg(t) {
  return !!(t && t[TR]);
}
function PR(t) {
  return wg(t) && Ro(t);
}
function kR(t, e) {
  if (t === e)
    return !0;
  if (!pi(e) || t.size !== void 0 && e.size !== void 0 && t.size !== e.size || t.__hash !== void 0 && e.__hash !== void 0 && t.__hash !== e.__hash || vr(t) !== vr(e) || oi(t) !== oi(e) || Ro(t) !== Ro(e))
    return !1;
  if (t.size === 0 && e.size === 0)
    return !0;
  var r = !Nd(t);
  if (Ro(t)) {
    var n = t.entries();
    return e.every(function(c, a) {
      var f = n.next().value;
      return f && Ii(f[1], c) && (r || Ii(f[0], a));
    }) && n.next().done;
  }
  var i = !1;
  if (t.size === void 0)
    if (e.size === void 0)
      typeof t.cacheResult == "function" && t.cacheResult();
    else {
      i = !0;
      var o = t;
      t = e, e = o;
    }
  var s = !0, u = e.__iterate(function(c, a) {
    if (r ? !t.has(c) : i ? !Ii(c, t.get(a, de)) : !Ii(t.get(a, de), c))
      return s = !1, !1;
  });
  return s && t.size === u;
}
function Su(t, e) {
  var r = function(n) {
    t.prototype[n] = e[n];
  };
  return Object.keys(e).forEach(r), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(r), t;
}
function Np(t) {
  if (!t || typeof t != "object")
    return t;
  if (!pi(t)) {
    if (!Na(t))
      return t;
    t = Ti(t);
  }
  if (vr(t)) {
    var e = {};
    return t.__iterate(function(n, i) {
      e[i] = Np(n);
    }), e;
  }
  var r = [];
  return t.__iterate(function(n) {
    r.push(Np(n));
  }), r;
}
var Kd = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Uf() : wg(r) && !Ro(r) ? r : Uf().withMutations(function(n) {
      var i = t(r);
      to(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(r) {
    return this(ho(r).keySeq());
  }, e.intersect = function(r) {
    return r = Ar(r).toArray(), r.length ? rn.intersect.apply(e(r.pop()), r) : Uf();
  }, e.union = function(r) {
    return r = Ar(r).toArray(), r.length ? rn.union.apply(e(r.pop()), r) : Uf();
  }, e.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, e.prototype.has = function(r) {
    return this._map.has(r);
  }, e.prototype.add = function(r) {
    return Qh(this, this._map.set(r, r));
  }, e.prototype.remove = function(r) {
    return Qh(this, this._map.remove(r));
  }, e.prototype.clear = function() {
    return Qh(this, this._map.clear());
  }, e.prototype.map = function(r, n) {
    var i = this, o = !1, s = Qh(
      this,
      this._map.mapEntries(function(u) {
        var c = u[1], a = r.call(n, c, c, i);
        return a !== c && (o = !0), [a, a];
      }, n)
    );
    return o ? s : this;
  }, e.prototype.union = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    return r = r.filter(function(i) {
      return i.size !== 0;
    }), r.length === 0 ? this : this.size === 0 && !this.__ownerID && r.length === 1 ? this.constructor(r[0]) : this.withMutations(function(i) {
      for (var o = 0; o < r.length; o++)
        typeof r[o] == "string" ? i.add(r[o]) : t(r[o]).forEach(function(s) {
          return i.add(s);
        });
    });
  }, e.prototype.intersect = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (r.length === 0)
      return this;
    r = r.map(function(o) {
      return t(o);
    });
    var i = [];
    return this.forEach(function(o) {
      r.every(function(s) {
        return s.includes(o);
      }) || i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(s) {
        o.remove(s);
      });
    });
  }, e.prototype.subtract = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (r.length === 0)
      return this;
    r = r.map(function(o) {
      return t(o);
    });
    var i = [];
    return this.forEach(function(o) {
      r.some(function(s) {
        return s.includes(o);
      }) && i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(s) {
        o.remove(s);
      });
    });
  }, e.prototype.sort = function(r) {
    return Ol(pc(this, r));
  }, e.prototype.sortBy = function(r, n) {
    return Ol(pc(this, n, r));
  }, e.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._map.__iterate(function(o) {
      return r(o, o, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    return this._map.__iterator(r, n);
  }, e.prototype.__ensureOwner = function(r) {
    if (r === this.__ownerID)
      return this;
    var n = this._map.__ensureOwner(r);
    return r ? this.__make(n, r) : this.size === 0 ? this.__empty() : (this.__ownerID = r, this._map = n, this);
  }, e;
}(Hc);
Kd.isSet = wg;
var rn = Kd.prototype;
rn[TR] = !0;
rn[nh] = rn.remove;
rn.merge = rn.concat = rn.union;
rn.withMutations = sh;
rn.asImmutable = uh;
rn["@@transducer/init"] = rn.asMutable = ah;
rn["@@transducer/step"] = function(t, e) {
  return t.add(e);
};
rn["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
rn.__empty = Uf;
rn.__make = CR;
function Qh(t, e) {
  return t.__ownerID ? (t.size = e.size, t._map = e, t) : e === t._map ? t : e.size === 0 ? t.__empty() : t.__make(e);
}
function CR(t, e) {
  var r = Object.create(rn);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var TE;
function Uf() {
  return TE || (TE = CR(So()));
}
var F3 = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    if (!(this instanceof e))
      return new e(r, n, i);
    if (sg(i !== 0, "Cannot step a Range by 0"), r = r || 0, n === void 0 && (n = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), n < r && (i = -i), this._start = r, this._end = n, this._step = i, this.size = Math.max(0, Math.ceil((n - r) / i - 1) + 1), this.size === 0) {
      if (uy)
        return uy;
      uy = this;
    }
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, e.prototype.get = function(r, n) {
    return this.has(r) ? this._start + Fa(this, r) * this._step : n;
  }, e.prototype.includes = function(r) {
    var n = (r - this._start) / this._step;
    return n >= 0 && n < this.size && n === Math.floor(n);
  }, e.prototype.slice = function(r, n) {
    return Md(r, n, this.size) ? this : (r = ih(r, this.size), n = Fd(n, this.size), n <= r ? new e(0, 0) : new e(
      this.get(r, this._end),
      this.get(n, this._end),
      this._step
    ));
  }, e.prototype.indexOf = function(r) {
    var n = r - this._start;
    if (n % this._step === 0) {
      var i = n / this._step;
      if (i >= 0 && i < this.size)
        return i;
    }
    return -1;
  }, e.prototype.lastIndexOf = function(r) {
    return this.indexOf(r);
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this.size, o = this._step, s = n ? this._start + (i - 1) * o : this._start, u = 0; u !== i && r(s, n ? i - ++u : u++, this) !== !1; )
      s += n ? -o : o;
    return u;
  }, e.prototype.__iterator = function(r, n) {
    var i = this.size, o = this._step, s = n ? this._start + (i - 1) * o : this._start, u = 0;
    return new we(function() {
      if (u === i)
        return di();
      var c = s;
      return s += n ? -o : o, br(r, n ? i - ++u : u++, c);
    });
  }, e.prototype.equals = function(r) {
    return r instanceof e ? this._start === r._start && this._end === r._end && this._step === r._step : kR(this, r);
  }, e;
}(No), uy;
function jR(t, e, r) {
  for (var n = vR(e), i = 0; i !== n.length; )
    if (t = yR(t, n[i++], de), t === de)
      return r;
  return t;
}
function qR(t, e) {
  return jR(this, t, e);
}
function N3(t, e) {
  return jR(t, e, de) !== de;
}
function z3(t) {
  return N3(this, t);
}
function MR() {
  to(this.size);
  var t = {};
  return this.__iterate(function(e, r) {
    t[r] = e;
  }), t;
}
Ar.isIterable = pi;
Ar.isKeyed = vr;
Ar.isIndexed = oi;
Ar.isAssociative = Nd;
Ar.isOrdered = Ro;
Ar.Iterator = we;
Su(Ar, {
  // ### Conversion to other types
  toArray: function() {
    to(this.size);
    var t = new Array(this.size || 0), e = vr(this), r = 0;
    return this.__iterate(function(n, i) {
      t[r++] = e ? [i, n] : n;
    }), t;
  },
  toIndexedSeq: function() {
    return new sR(this);
  },
  toJS: function() {
    return Np(this);
  },
  toKeyedSeq: function() {
    return new Bd(this, !0);
  },
  toMap: function() {
    return rf(this.toKeyedSeq());
  },
  toObject: MR,
  toOrderedMap: function() {
    return sa(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Ol(vr(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return Kd(vr(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new aR(this);
  },
  toSeq: function() {
    return oi(this) ? this.toIndexedSeq() : vr(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return bg(vr(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return $d(vr(this) ? this.valueSeq() : this);
  },
  // ### Common JavaScript methods and properties
  toString: function() {
    return "[Collection]";
  },
  __toString: function(t, e) {
    return this.size === 0 ? t + e : t + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  concat: function() {
    for (var t = [], e = arguments.length; e--; )
      t[e] = arguments[e];
    return Pe(this, v3(this, t));
  },
  includes: function(t) {
    return this.some(function(e) {
      return Ii(e, t);
    });
  },
  entries: function() {
    return this.__iterator(ao);
  },
  every: function(t, e) {
    to(this.size);
    var r = !0;
    return this.__iterate(function(n, i, o) {
      if (!t.call(e, n, i, o))
        return r = !1, !1;
    }), r;
  },
  filter: function(t, e) {
    return Pe(this, lR(this, t, e, !0));
  },
  partition: function(t, e) {
    return p3(this, t, e);
  },
  find: function(t, e, r) {
    var n = this.findEntry(t, e);
    return n ? n[1] : r;
  },
  forEach: function(t, e) {
    return to(this.size), this.__iterate(e ? t.bind(e) : t);
  },
  join: function(t) {
    to(this.size), t = t !== void 0 ? "" + t : ",";
    var e = "", r = !0;
    return this.__iterate(function(n) {
      r ? r = !1 : e += t, e += n != null ? n.toString() : "";
    }), e;
  },
  keys: function() {
    return this.__iterator(oh);
  },
  map: function(t, e) {
    return Pe(this, fR(this, t, e));
  },
  reduce: function(t, e, r) {
    return PE(
      this,
      t,
      e,
      r,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(t, e, r) {
    return PE(
      this,
      t,
      e,
      r,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return Pe(this, rg(this, !0));
  },
  slice: function(t, e) {
    return Pe(this, ng(this, t, e, !0));
  },
  some: function(t, e) {
    return !this.every(Yh(t), e);
  },
  sort: function(t) {
    return Pe(this, pc(this, t));
  },
  values: function() {
    return this.__iterator(Co);
  },
  // ### More sequential methods
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(t, e) {
    return hc(
      t ? this.toSeq().filter(t, e) : this
    );
  },
  countBy: function(t, e) {
    return l3(this, t, e);
  },
  equals: function(t) {
    return kR(this, t);
  },
  entrySeq: function() {
    var t = this;
    if (t._cache)
      return new au(t._cache);
    var e = t.toSeq().map(U3).toIndexedSeq();
    return e.fromEntrySeq = function() {
      return t.toSeq();
    }, e;
  },
  filterNot: function(t, e) {
    return this.filter(Yh(t), e);
  },
  findEntry: function(t, e, r) {
    var n = r;
    return this.__iterate(function(i, o, s) {
      if (t.call(e, i, o, s))
        return n = [o, i], !1;
    }), n;
  },
  findKey: function(t, e) {
    var r = this.findEntry(t, e);
    return r && r[0];
  },
  findLast: function(t, e, r) {
    return this.toKeyedSeq().reverse().find(t, e, r);
  },
  findLastEntry: function(t, e, r) {
    return this.toKeyedSeq().reverse().findEntry(t, e, r);
  },
  findLastKey: function(t, e) {
    return this.toKeyedSeq().reverse().findKey(t, e);
  },
  first: function(t) {
    return this.find(VD, null, t);
  },
  flatMap: function(t, e) {
    return Pe(this, y3(this, t, e));
  },
  flatten: function(t) {
    return Pe(this, pR(this, t, !0));
  },
  fromEntrySeq: function() {
    return new uR(this);
  },
  get: function(t, e) {
    return this.find(function(r, n) {
      return Ii(n, t);
    }, void 0, e);
  },
  getIn: qR,
  groupBy: function(t, e) {
    return h3(this, t, e);
  },
  has: function(t) {
    return this.get(t, de) !== de;
  },
  hasIn: z3,
  isSubset: function(t) {
    return t = typeof t.includes == "function" ? t : Ar(t), this.every(function(e) {
      return t.includes(e);
    });
  },
  isSuperset: function(t) {
    return t = typeof t.isSubset == "function" ? t : Ar(t), t.isSubset(this);
  },
  keyOf: function(t) {
    return this.findKey(function(e) {
      return Ii(e, t);
    });
  },
  keySeq: function() {
    return this.toSeq().map(L3).toIndexedSeq();
  },
  last: function(t) {
    return this.toSeq().reverse().first(t);
  },
  lastKeyOf: function(t) {
    return this.toKeyedSeq().reverse().keyOf(t);
  },
  max: function(t) {
    return $h(this, t);
  },
  maxBy: function(t, e) {
    return $h(this, e, t);
  },
  min: function(t) {
    return $h(
      this,
      t ? kE(t) : jE
    );
  },
  minBy: function(t, e) {
    return $h(
      this,
      e ? kE(e) : jE,
      t
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(t) {
    return t === 0 ? this : this.slice(Math.max(0, t));
  },
  skipLast: function(t) {
    return t === 0 ? this : this.slice(0, -Math.max(0, t));
  },
  skipWhile: function(t, e) {
    return Pe(this, hR(this, t, e, !0));
  },
  skipUntil: function(t, e) {
    return this.skipWhile(Yh(t), e);
  },
  sortBy: function(t, e) {
    return Pe(this, pc(this, e, t));
  },
  take: function(t) {
    return this.slice(0, Math.max(0, t));
  },
  takeLast: function(t) {
    return this.slice(-Math.max(0, t));
  },
  takeWhile: function(t, e) {
    return Pe(this, d3(this, t, e));
  },
  takeUntil: function(t, e) {
    return this.takeWhile(Yh(t), e);
  },
  update: function(t) {
    return t(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  // ### Hashable Object
  hashCode: function() {
    return this.__hash || (this.__hash = B3(this));
  }
  // ### Internal
  // abstract __iterate(fn, reverse)
  // abstract __iterator(type, reverse)
});
var Rn = Ar.prototype;
Rn[GD] = !0;
Rn[zd] = Rn.values;
Rn.toJSON = Rn.toArray;
Rn.__toStringMapper = gl;
Rn.inspect = Rn.toSource = function() {
  return this.toString();
};
Rn.chain = Rn.flatMap;
Rn.contains = Rn.includes;
Su(ho, {
  // ### More sequential methods
  flip: function() {
    return Pe(this, cR(this));
  },
  mapEntries: function(t, e) {
    var r = this, n = 0;
    return Pe(
      this,
      this.toSeq().map(function(i, o) {
        return t.call(e, [o, i], n++, r);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(t, e) {
    var r = this;
    return Pe(
      this,
      this.toSeq().flip().map(function(n, i) {
        return t.call(e, n, i, r);
      }).flip()
    );
  }
});
var ch = ho.prototype;
ch[WD] = !0;
ch[zd] = Rn.entries;
ch.toJSON = MR;
ch.__toStringMapper = function(t, e) {
  return gl(e) + ": " + gl(t);
};
Su(Eu, {
  // ### Conversion to other types
  toKeyedSeq: function() {
    return new Bd(this, !1);
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  filter: function(t, e) {
    return Pe(this, lR(this, t, e, !1));
  },
  findIndex: function(t, e) {
    var r = this.findEntry(t, e);
    return r ? r[0] : -1;
  },
  indexOf: function(t) {
    var e = this.keyOf(t);
    return e === void 0 ? -1 : e;
  },
  lastIndexOf: function(t) {
    var e = this.lastKeyOf(t);
    return e === void 0 ? -1 : e;
  },
  reverse: function() {
    return Pe(this, rg(this, !1));
  },
  slice: function(t, e) {
    return Pe(this, ng(this, t, e, !1));
  },
  splice: function(t, e) {
    var r = arguments.length;
    if (e = Math.max(e || 0, 0), r === 0 || r === 2 && !e)
      return this;
    t = ih(t, t < 0 ? this.count() : this.size);
    var n = this.slice(0, t);
    return Pe(
      this,
      r === 1 ? n : n.concat(Go(arguments, 2), this.slice(t + e))
    );
  },
  // ### More collection methods
  findLastIndex: function(t, e) {
    var r = this.findLastEntry(t, e);
    return r ? r[0] : -1;
  },
  first: function(t) {
    return this.get(0, t);
  },
  flatten: function(t) {
    return Pe(this, pR(this, t, !1));
  },
  get: function(t, e) {
    return t = Fa(this, t), t < 0 || this.size === 1 / 0 || this.size !== void 0 && t > this.size ? e : this.find(function(r, n) {
      return n === t;
    }, void 0, e);
  },
  has: function(t) {
    return t = Fa(this, t), t >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || t < this.size : this.indexOf(t) !== -1);
  },
  interpose: function(t) {
    return Pe(this, _3(this, t));
  },
  interleave: function() {
    var t = [this].concat(Go(arguments)), e = Kh(this.toSeq(), No.of, t), r = e.flatten(!0);
    return e.size && (r.size = e.size * t.length), Pe(this, r);
  },
  keySeq: function() {
    return F3(0, this.size);
  },
  last: function(t) {
    return this.get(-1, t);
  },
  skipWhile: function(t, e) {
    return Pe(this, hR(this, t, e, !1));
  },
  zip: function() {
    var t = [this].concat(Go(arguments));
    return Pe(this, Kh(this, CE, t));
  },
  zipAll: function() {
    var t = [this].concat(Go(arguments));
    return Pe(this, Kh(this, CE, t, !0));
  },
  zipWith: function(t) {
    var e = Go(arguments);
    return e[0] = this, Pe(this, Kh(this, t, e));
  }
});
var nf = Eu.prototype;
nf[HD] = !0;
nf[Zc] = !0;
Su(Hc, {
  // ### ES6 Collection methods (ES6 Array and Map)
  get: function(t, e) {
    return this.has(t) ? t : e;
  },
  includes: function(t) {
    return this.has(t);
  },
  // ### More sequential methods
  keySeq: function() {
    return this.valueSeq();
  }
});
var _c = Hc.prototype;
_c.has = Rn.includes;
_c.contains = _c.includes;
_c.keys = _c.values;
Su(Ka, ch);
Su(No, nf);
Su(tf, _c);
function PE(t, e, r, n, i, o) {
  return to(t.size), t.__iterate(function(s, u, c) {
    i ? (i = !1, r = s) : r = e.call(n, r, s, u, c);
  }, o), r;
}
function L3(t, e) {
  return e;
}
function U3(t, e) {
  return [e, t];
}
function Yh(t) {
  return function() {
    return !t.apply(this, arguments);
  };
}
function kE(t) {
  return function() {
    return -t.apply(this, arguments);
  };
}
function CE() {
  return Go(arguments);
}
function jE(t, e) {
  return t < e ? 1 : t > e ? -1 : 0;
}
function B3(t) {
  if (t.size === 1 / 0)
    return 0;
  var e = Ro(t), r = vr(t), n = e ? 1 : 0, i = t.__iterate(
    r ? e ? function(o, s) {
      n = 31 * n + qE(bi(o), bi(s)) | 0;
    } : function(o, s) {
      n = n + qE(bi(o), bi(s)) | 0;
    } : e ? function(o) {
      n = 31 * n + bi(o) | 0;
    } : function(o) {
      n = n + bi(o) | 0;
    }
  );
  return $3(i, n);
}
function $3(t, e) {
  return e = Of(e, 3432918353), e = Of(e << 15 | e >>> -15, 461845907), e = Of(e << 13 | e >>> -13, 5), e = (e + 3864292196 | 0) ^ t, e = Of(e ^ e >>> 16, 2246822507), e = Of(e ^ e >>> 13, 3266489909), e = Ud(e ^ e >>> 16), e;
}
function qE(t, e) {
  return t ^ e + 2654435769 + (t << 6) + (t >> 2) | 0;
}
var Ol = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? g_() : PR(r) ? r : g_().withMutations(function(n) {
      var i = Hc(r);
      to(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(r) {
    return this(ho(r).keySeq());
  }, e.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, e;
}(Kd);
Ol.isOrderedSet = PR;
var Ou = Ol.prototype;
Ou[Zc] = !0;
Ou.zip = nf.zip;
Ou.zipWith = nf.zipWith;
Ou.zipAll = nf.zipAll;
Ou.__empty = g_;
Ou.__make = FR;
function FR(t, e) {
  var r = Object.create(Ou);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var ME;
function g_() {
  return ME || (ME = FR(zf()));
}
function K3(t) {
  if (Jc(t))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (os(t))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (t === null || typeof t != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var Jt = function(t, e) {
  var r;
  K3(t);
  var n = function(o) {
    var s = this;
    if (o instanceof n)
      return o;
    if (!(this instanceof n))
      return new n(o);
    if (!r) {
      r = !0;
      var u = Object.keys(t), c = i._indices = {};
      i._name = e, i._keys = u, i._defaultValues = t;
      for (var a = 0; a < u.length; a++) {
        var f = u[a];
        c[f] = a, i[f] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + Sg(this) + ' with property "' + f + '" since that property name is part of the Record API.'
        ) : V3(i, f);
      }
    }
    return this.__ownerID = void 0, this._values = $d().withMutations(function(h) {
      h.setSize(s._keys.length), ho(o).forEach(function(p, d) {
        h.set(s._indices[d], p === s._defaultValues[d] ? void 0 : p);
      });
    }), this;
  }, i = n.prototype = Object.create(Fe);
  return i.constructor = n, e && (n.displayName = e), n;
};
Jt.prototype.toString = function() {
  for (var t = Sg(this) + " { ", e = this._keys, r, n = 0, i = e.length; n !== i; n++)
    r = e[n], t += (n ? ", " : "") + r + ": " + gl(this.get(r));
  return t + " }";
};
Jt.prototype.equals = function(t) {
  return this === t || Jc(t) && mc(this).equals(mc(t));
};
Jt.prototype.hashCode = function() {
  return mc(this).hashCode();
};
Jt.prototype.has = function(t) {
  return this._indices.hasOwnProperty(t);
};
Jt.prototype.get = function(t, e) {
  if (!this.has(t))
    return e;
  var r = this._indices[t], n = this._values.get(r);
  return n === void 0 ? this._defaultValues[t] : n;
};
Jt.prototype.set = function(t, e) {
  if (this.has(t)) {
    var r = this._values.set(
      this._indices[t],
      e === this._defaultValues[t] ? void 0 : e
    );
    if (r !== this._values && !this.__ownerID)
      return Eg(this, r);
  }
  return this;
};
Jt.prototype.remove = function(t) {
  return this.set(t);
};
Jt.prototype.clear = function() {
  var t = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : Eg(this, t);
};
Jt.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
Jt.prototype.toSeq = function() {
  return mc(this);
};
Jt.prototype.toJS = function() {
  return Np(this);
};
Jt.prototype.entries = function() {
  return this.__iterator(ao);
};
Jt.prototype.__iterator = function(t, e) {
  return mc(this).__iterator(t, e);
};
Jt.prototype.__iterate = function(t, e) {
  return mc(this).__iterate(t, e);
};
Jt.prototype.__ensureOwner = function(t) {
  if (t === this.__ownerID)
    return this;
  var e = this._values.__ensureOwner(t);
  return t ? Eg(this, e, t) : (this.__ownerID = t, this._values = e, this);
};
Jt.isRecord = Jc;
Jt.getDescriptiveName = Sg;
var Fe = Jt.prototype;
Fe[ZD] = !0;
Fe[nh] = Fe.remove;
Fe.deleteIn = Fe.removeIn = ug;
Fe.getIn = qR;
Fe.hasIn = Rn.hasIn;
Fe.merge = gR;
Fe.mergeWith = bR;
Fe.mergeIn = pg;
Fe.mergeDeep = ER;
Fe.mergeDeepWith = SR;
Fe.mergeDeepIn = dg;
Fe.setIn = ag;
Fe.update = cg;
Fe.updateIn = fg;
Fe.withMutations = sh;
Fe.asMutable = ah;
Fe.asImmutable = uh;
Fe[zd] = Fe.entries;
Fe.toJSON = Fe.toObject = Rn.toObject;
Fe.inspect = Fe.toSource = function() {
  return this.toString();
};
function Eg(t, e, r) {
  var n = Object.create(Object.getPrototypeOf(t));
  return n._values = e, n.__ownerID = r, n;
}
function Sg(t) {
  return t.constructor.displayName || t.constructor.name || "Record";
}
function mc(t) {
  return Xm(t._keys.map(function(e) {
    return [e, t.get(e)];
  }));
}
function V3(t, e) {
  try {
    Object.defineProperty(t, e, {
      get: function() {
        return this.get(e);
      },
      set: function(r) {
        sg(this.__ownerID, "Cannot set on an immutable record."), this.set(e, r);
      }
    });
  } catch {
  }
}
const Q3 = {
  startDate: void 0,
  endDate: void 0,
  userLimit: 0,
  projectLimit: 0,
  isTrial: !1,
  isExpired: !1,
  functionalities: []
};
class Y3 extends Jt(Q3, "Subscription") {
  get isValid() {
    return !!this.startDate && !!this.endDate;
  }
  get isActive() {
    return !this.startDate || !this.endDate ? !1 : new jl(this.startDate, this.endDate).contains(Er.now());
  }
  get daysLeft() {
    return this.endDate ? this.endDate.getAbsoluteDifferenceInDays(Er.now()) : 0;
  }
  hasEndDateIncoming() {
    return this.endDate ? this.endDate.isAfterInDays(Er.now()) : !1;
  }
}
function G3(t) {
  const e = t;
  return e == null ? void 0 : e.code;
}
const W3 = 3;
function H3(t, e = W3) {
  return (r, n) => {
    const i = G3(n);
    if (!i)
      return !1;
    let o;
    return Array.isArray(t) ? o = t.includes(i) : o = t === i, r <= e && o;
  };
}
const J3 = new Y3();
Mr({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  subscription: J3,
  hasFunctionality: () => !1
});
H3(oF.TOO_MANY_REQUESTS);
Se.createContext({
  i18n: void 0
});
var Z3 = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(t) {
  (function(e, r) {
    t.exports ? t.exports = r() : e.numeral = r();
  })(Js, function() {
    var e, r, n = "2.0.6", i = {}, o = {}, s = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, u = {
      currentLocale: s.currentLocale,
      zeroFormat: s.zeroFormat,
      nullFormat: s.nullFormat,
      defaultFormat: s.defaultFormat,
      scalePercentBy100: s.scalePercentBy100
    };
    function c(a, f) {
      this._input = a, this._value = f;
    }
    return e = function(a) {
      var f, h, p, d;
      if (e.isNumeral(a))
        f = a.value();
      else if (a === 0 || typeof a > "u")
        f = 0;
      else if (a === null || r.isNaN(a))
        f = null;
      else if (typeof a == "string")
        if (u.zeroFormat && a === u.zeroFormat)
          f = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          f = null;
        else {
          for (h in i)
            if (d = typeof i[h].regexps.unformat == "function" ? i[h].regexps.unformat() : i[h].regexps.unformat, d && a.match(d)) {
              p = i[h].unformat;
              break;
            }
          p = p || e._.stringToNumber, f = p(a);
        }
      else
        f = Number(a) || null;
      return new c(a, f);
    }, e.version = n, e.isNumeral = function(a) {
      return a instanceof c;
    }, e._ = r = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(a, f, h) {
        var p = o[e.options.currentLocale], d = !1, _ = !1, m = 0, b = "", O = 1e12, S = 1e9, k = 1e6, T = 1e3, x = "", P = !1, R, D, I, j, Y, H, B;
        if (a = a || 0, D = Math.abs(a), e._.includes(f, "(") ? (d = !0, f = f.replace(/[\(|\)]/g, "")) : (e._.includes(f, "+") || e._.includes(f, "-")) && (Y = e._.includes(f, "+") ? f.indexOf("+") : a < 0 ? f.indexOf("-") : -1, f = f.replace(/[\+|\-]/g, "")), e._.includes(f, "a") && (R = f.match(/a(k|m|b|t)?/), R = R ? R[1] : !1, e._.includes(f, " a") && (b = " "), f = f.replace(new RegExp(b + "a[kmbt]?"), ""), D >= O && !R || R === "t" ? (b += p.abbreviations.trillion, a = a / O) : D < O && D >= S && !R || R === "b" ? (b += p.abbreviations.billion, a = a / S) : D < S && D >= k && !R || R === "m" ? (b += p.abbreviations.million, a = a / k) : (D < k && D >= T && !R || R === "k") && (b += p.abbreviations.thousand, a = a / T)), e._.includes(f, "[.]") && (_ = !0, f = f.replace("[.]", ".")), I = a.toString().split(".")[0], j = f.split(".")[1], H = f.indexOf(","), m = (f.split(".")[0].split(",")[0].match(/0/g) || []).length, j ? (e._.includes(j, "[") ? (j = j.replace("]", ""), j = j.split("["), x = e._.toFixed(a, j[0].length + j[1].length, h, j[1].length)) : x = e._.toFixed(a, j.length, h), I = x.split(".")[0], e._.includes(x, ".") ? x = p.delimiters.decimal + x.split(".")[1] : x = "", _ && Number(x.slice(1)) === 0 && (x = "")) : I = e._.toFixed(a, 0, h), b && !R && Number(I) >= 1e3 && b !== p.abbreviations.trillion)
          switch (I = String(Number(I) / 1e3), b) {
            case p.abbreviations.thousand:
              b = p.abbreviations.million;
              break;
            case p.abbreviations.million:
              b = p.abbreviations.billion;
              break;
            case p.abbreviations.billion:
              b = p.abbreviations.trillion;
              break;
          }
        if (e._.includes(I, "-") && (I = I.slice(1), P = !0), I.length < m)
          for (var tt = m - I.length; tt > 0; tt--)
            I = "0" + I;
        return H > -1 && (I = I.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + p.delimiters.thousands)), f.indexOf(".") === 0 && (I = ""), B = I + x + (b || ""), d ? B = (d && P ? "(" : "") + B + (d && P ? ")" : "") : Y >= 0 ? B = Y === 0 ? (P ? "-" : "+") + B : B + (P ? "-" : "+") : P && (B = "-" + B), B;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(a) {
        var f = o[u.currentLocale], h = a, p = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, d, _, m;
        if (u.zeroFormat && a === u.zeroFormat)
          _ = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          _ = null;
        else {
          _ = 1, f.delimiters.decimal !== "." && (a = a.replace(/\./g, "").replace(f.delimiters.decimal, "."));
          for (d in p)
            if (m = new RegExp("[^a-zA-Z]" + f.abbreviations[d] + "(?:\\)|(\\" + f.currency.symbol + ")?(?:\\))?)?$"), h.match(m)) {
              _ *= Math.pow(10, p[d]);
              break;
            }
          _ *= (a.split("-").length + Math.min(a.split("(").length - 1, a.split(")").length - 1)) % 2 ? 1 : -1, a = a.replace(/[^0-9\.]+/g, ""), _ *= Number(a);
        }
        return _;
      },
      isNaN: function(a) {
        return typeof a == "number" && isNaN(a);
      },
      includes: function(a, f) {
        return a.indexOf(f) !== -1;
      },
      insert: function(a, f, h) {
        return a.slice(0, h) + f + a.slice(h);
      },
      reduce: function(a, f) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof f != "function")
          throw new TypeError(f + " is not a function");
        var h = Object(a), p = h.length >>> 0, d = 0, _;
        if (arguments.length === 3)
          _ = arguments[2];
        else {
          for (; d < p && !(d in h); )
            d++;
          if (d >= p)
            throw new TypeError("Reduce of empty array with no initial value");
          _ = h[d++];
        }
        for (; d < p; d++)
          d in h && (_ = f(_, h[d], d, h));
        return _;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(a) {
        var f = a.toString().split(".");
        return f.length < 2 ? 1 : Math.pow(10, f[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var a = Array.prototype.slice.call(arguments);
        return a.reduce(function(f, h) {
          var p = r.multiplier(h);
          return f > p ? f : p;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(a, f, h, p) {
        var d = a.toString().split("."), _ = f - (p || 0), m, b, O, S;
        return d.length === 2 ? m = Math.min(Math.max(d[1].length, _), f) : m = _, O = Math.pow(10, m), S = (h(a + "e+" + m) / O).toFixed(m), p > f - m && (b = new RegExp("\\.?0{1," + (p - (f - m)) + "}$"), S = S.replace(b, "")), S;
      }
    }, e.options = u, e.formats = i, e.locales = o, e.locale = function(a) {
      return a && (u.currentLocale = a.toLowerCase()), u.currentLocale;
    }, e.localeData = function(a) {
      if (!a)
        return o[u.currentLocale];
      if (a = a.toLowerCase(), !o[a])
        throw new Error("Unknown locale : " + a);
      return o[a];
    }, e.reset = function() {
      for (var a in s)
        u[a] = s[a];
    }, e.zeroFormat = function(a) {
      u.zeroFormat = typeof a == "string" ? a : null;
    }, e.nullFormat = function(a) {
      u.nullFormat = typeof a == "string" ? a : null;
    }, e.defaultFormat = function(a) {
      u.defaultFormat = typeof a == "string" ? a : "0.0";
    }, e.register = function(a, f, h) {
      if (f = f.toLowerCase(), this[a + "s"][f])
        throw new TypeError(f + " " + a + " already registered.");
      return this[a + "s"][f] = h, h;
    }, e.validate = function(a, f) {
      var h, p, d, _, m, b, O, S;
      if (typeof a != "string" && (a += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", a)), a = a.trim(), a.match(/^\d+$/))
        return !0;
      if (a === "")
        return !1;
      try {
        O = e.localeData(f);
      } catch {
        O = e.localeData(e.locale());
      }
      return d = O.currency.symbol, m = O.abbreviations, h = O.delimiters.decimal, O.delimiters.thousands === "." ? p = "\\." : p = O.delimiters.thousands, S = a.match(/^[^\d]+/), S !== null && (a = a.substr(1), S[0] !== d) || (S = a.match(/[^\d]+$/), S !== null && (a = a.slice(0, -1), S[0] !== m.thousand && S[0] !== m.million && S[0] !== m.billion && S[0] !== m.trillion)) ? !1 : (b = new RegExp(p + "{2}"), a.match(/[^\d.,]/g) ? !1 : (_ = a.split(h), _.length > 2 ? !1 : _.length < 2 ? !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) : _[0].length === 1 ? !!_[0].match(/^\d+$/) && !_[0].match(b) && !!_[1].match(/^\d+$/) : !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) && !!_[1].match(/^\d+$/)));
    }, e.fn = c.prototype = {
      clone: function() {
        return e(this);
      },
      format: function(a, f) {
        var h = this._value, p = a || u.defaultFormat, d, _, m;
        if (f = f || Math.round, h === 0 && u.zeroFormat !== null)
          _ = u.zeroFormat;
        else if (h === null && u.nullFormat !== null)
          _ = u.nullFormat;
        else {
          for (d in i)
            if (p.match(i[d].regexps.format)) {
              m = i[d].format;
              break;
            }
          m = m || e._.numberToFormat, _ = m(h, p, f);
        }
        return _;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(a) {
        return this._value = Number(a), this;
      },
      add: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p + Math.round(f * d);
        }
        return this._value = r.reduce([this._value, a], h, 0) / f, this;
      },
      subtract: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p - Math.round(f * d);
        }
        return this._value = r.reduce([a], h, Math.round(this._value * f)) / f, this;
      },
      multiply: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) * Math.round(p * m) / Math.round(m * m);
        }
        return this._value = r.reduce([this._value, a], f, 1), this;
      },
      divide: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) / Math.round(p * m);
        }
        return this._value = r.reduce([this._value, a], f), this;
      },
      difference: function(a) {
        return Math.abs(e(this._value).subtract(a).value());
      }
    }, e.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(a) {
        var f = a % 10;
        return ~~(a % 100 / 10) === 1 ? "th" : f === 1 ? "st" : f === 2 ? "nd" : f === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      e.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " BPS") ? " " : "", d;
          return a = a * 1e4, f = f.replace(/\s?BPS/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "BPS"), d = d.join("")) : d = d + p + "BPS", d;
        },
        unformat: function(a) {
          return +(e._.stringToNumber(a) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var a = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, f = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, h = a.suffixes.concat(f.suffixes.filter(function(d) {
        return a.suffixes.indexOf(d) < 0;
      })), p = h.join("|");
      p = "(" + p.replace("B", "B(?!PS)") + ")", e.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(p)
        },
        format: function(d, _, m) {
          var b, O = e._.includes(_, "ib") ? f : a, S = e._.includes(_, " b") || e._.includes(_, " ib") ? " " : "", k, T, x;
          for (_ = _.replace(/\s?i?b/, ""), k = 0; k <= O.suffixes.length; k++)
            if (T = Math.pow(O.base, k), x = Math.pow(O.base, k + 1), d === null || d === 0 || d >= T && d < x) {
              S += O.suffixes[k], T > 0 && (d = d / T);
              break;
            }
          return b = e._.numberToFormat(d, _, m), b + S;
        },
        unformat: function(d) {
          var _ = e._.stringToNumber(d), m, b;
          if (_) {
            for (m = a.suffixes.length - 1; m >= 0; m--) {
              if (e._.includes(d, a.suffixes[m])) {
                b = Math.pow(a.base, m);
                break;
              }
              if (e._.includes(d, f.suffixes[m])) {
                b = Math.pow(f.base, m);
                break;
              }
            }
            _ *= b || 1;
          }
          return _;
        }
      });
    }(), function() {
      e.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d = {
            before: f.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: f.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, _, m, b;
          for (f = f.replace(/\s?\$\s?/, ""), _ = e._.numberToFormat(a, f, h), a >= 0 ? (d.before = d.before.replace(/[\-\(]/, ""), d.after = d.after.replace(/[\-\)]/, "")) : a < 0 && !e._.includes(d.before, "-") && !e._.includes(d.before, "(") && (d.before = "-" + d.before), b = 0; b < d.before.length; b++)
            switch (m = d.before[b], m) {
              case "$":
                _ = e._.insert(_, p.currency.symbol, b);
                break;
              case " ":
                _ = e._.insert(_, " ", b + p.currency.symbol.length - 1);
                break;
            }
          for (b = d.after.length - 1; b >= 0; b--)
            switch (m = d.after[b], m) {
              case "$":
                _ = b === d.after.length - 1 ? _ + p.currency.symbol : e._.insert(_, p.currency.symbol, -(d.after.length - (1 + b)));
                break;
              case " ":
                _ = b === d.after.length - 1 ? _ + " " : e._.insert(_, " ", -(d.after.length - (1 + b) + p.currency.symbol.length - 1));
                break;
            }
          return _;
        }
      });
    }(), function() {
      e.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(a, f, h) {
          var p, d = typeof a == "number" && !e._.isNaN(a) ? a.toExponential() : "0e+0", _ = d.split("e");
          return f = f.replace(/e[\+|\-]{1}0/, ""), p = e._.numberToFormat(Number(_[0]), f, h), p + "e" + _[1];
        },
        unformat: function(a) {
          var f = e._.includes(a, "e+") ? a.split("e+") : a.split("e-"), h = Number(f[0]), p = Number(f[1]);
          p = e._.includes(a, "e-") ? p *= -1 : p;
          function d(_, m, b, O) {
            var S = e._.correctionFactor(_, m), k = _ * S * (m * S) / (S * S);
            return k;
          }
          return e._.reduce([h, Math.pow(10, p)], d, 1);
        }
      });
    }(), function() {
      e.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d, _ = e._.includes(f, " o") ? " " : "";
          return f = f.replace(/\s?o/, ""), _ += p.ordinal(a), d = e._.numberToFormat(a, f, h), d + _;
        }
      });
    }(), function() {
      e.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " %") ? " " : "", d;
          return e.options.scalePercentBy100 && (a = a * 100), f = f.replace(/\s?\%/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "%"), d = d.join("")) : d = d + p + "%", d;
        },
        unformat: function(a) {
          var f = e._.stringToNumber(a);
          return e.options.scalePercentBy100 ? f * 0.01 : f;
        }
      });
    }(), function() {
      e.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(a, f, h) {
          var p = Math.floor(a / 60 / 60), d = Math.floor((a - p * 60 * 60) / 60), _ = Math.round(a - p * 60 * 60 - d * 60);
          return p + ":" + (d < 10 ? "0" + d : d) + ":" + (_ < 10 ? "0" + _ : _);
        },
        unformat: function(a) {
          var f = a.split(":"), h = 0;
          return f.length === 3 ? (h = h + Number(f[0]) * 60 * 60, h = h + Number(f[1]) * 60, h = h + Number(f[2])) : f.length === 2 && (h = h + Number(f[0]) * 60, h = h + Number(f[1])), Number(h);
        }
      });
    }(), e;
  });
})(Z3);
Km.EN;
var NR = /* @__PURE__ */ ((t) => (t[t.LOCAL = -1] = "LOCAL", t[t.CANADA = 0] = "CANADA", t[t.NORTH_EUROPE = 1] = "NORTH_EUROPE", t[t.EUROPE = 2] = "EUROPE", t[t.USA = 3] = "USA", t))(NR || {});
const X3 = {
  id: NR.LOCAL,
  name: ""
};
class tN extends Jt(X3, "DataCenterAttribute") {
}
var zR = /* @__PURE__ */ ((t) => (t.EN_US = "M/D/YYYY h:mm A", t.EN_CA = "YYYY-MM-DD h:mm A", t.FR_CA = "DD/MM/YYYY HH:mm", t))(zR || {}), Ku = /* @__PURE__ */ ((t) => (t.GUEST = "Guest", t.ADMIN = "Admin", t))(Ku || {}), pp = /* @__PURE__ */ ((t) => (t.UTC = "UTC", t.NEW_YORK = "America/New_York", t.DUBAI = "Asia/Asia/Dubai", t))(pp || {}), LR = /* @__PURE__ */ ((t) => (t.ACTIVE = "Active", t.INACTIVE = "Inactive", t))(LR || {});
const eN = {
  role: Ku.GUEST
};
class rN extends Jt(eN, "HubUserPermissions") {
}
const nN = {
  globalId: void 0,
  hashId: "",
  localId: -1,
  name: "",
  creationDate: Er.MIN_VALUE,
  demoDaysLeft: void 0,
  owner: "",
  dataCenterInfo: new tN(),
  metrics: void 0,
  projects: [],
  avatarImage: void 0,
  hasAPIAccessToken: !1,
  APIAccessTokenAcceptationTermsDate: void 0,
  isLinkedToOrganization: !1,
  url: "",
  subscription: void 0,
  projectTemplates: void 0,
  bimTrackRegionalApiUrl: void 0,
  requestingUserPermissions: new rN()
};
class UB extends Jt(nN, "Hub") {
  /**
   * @deprecated use hashId instead.
   */
  get id() {
    return this.hashId;
  }
  /**
   * @deprecated use dataCenterInfo.id instead.
   */
  get dataCenter() {
    return this.dataCenterInfo.id;
  }
  get avatarImageWithDefault() {
    return this.avatarImage;
  }
  get isSubscriptionExpired() {
    return this.subscription ? this.subscription.isExpired : !1;
  }
  get subscriptionPlanProjectLimit() {
    return this.subscription ? this.subscription.projectLimit : 0;
  }
  is(e) {
    return e ? this.id === e.id && this.localId === e.localId : !1;
  }
}
const iN = {
  totalUsers: void 0
};
class BB extends Jt(iN, "HubMetrics") {
}
var zi = /* @__PURE__ */ ((t) => (t.TEXT = "text", t.PREDEFINED = "predefined", t.TITLE = "title", t.DESCRIPTION = "description", t.STATUS = "status", t.TYPE = "type", t.PRIORITY = "priority", t.DISCIPLINE = "discipline", t.ZONE = "zone", t.PHASE = "phase", t.ASSIGNED_TO = "assignedto", t.DUE_DATE = "duedate", t.ISSUE_GROUP = "issuegroup", t.TEAM = "team", t.NOTIFY = "notify", t.CONFIDENTIALITY = "confidentiality", t.VISIBILITY = "visibility", t))(zi || {}), Og = /* @__PURE__ */ ((t) => (t.ADMIN = "Admin", t.EDITOR = "Editor", t.READER = "Reader", t))(Og || {}), UR = /* @__PURE__ */ ((t) => (t[t.ACTIVE = 0] = "ACTIVE", t[t.ON_HOLD = 1] = "ON_HOLD", t[t.COMPLETION_PENDING = 2] = "COMPLETION_PENDING", t[t.COMPLETED = 3] = "COMPLETED", t))(UR || {});
const oN = {
  statuses: [],
  types: [],
  priorities: [],
  zones: [],
  phases: [],
  disciplines: [],
  customAttributes: []
};
class sN extends Jt(oN, "IssueAttributeOptions") {
}
const aN = {
  id: -1,
  name: "",
  type: zi.TEXT,
  values: void 0
};
class uN extends Jt(aN, "ProjectAttribute") {
}
const cN = {
  attributes: [],
  selectedColorAttributeForIssue: new uN(),
  integrations: [],
  issueMandatoryAttributes: []
};
class fN extends Jt(cN, "ProjectSettings") {
}
const lN = {
  role: Og.READER,
  teams: [],
  isReviewer: !1
};
class hN extends Jt(lN, "ProjectUserPermissions") {
}
const pN = {
  id: -1,
  name: "",
  number: "",
  status: UR.ACTIVE,
  settings: new fN(),
  users: [],
  teams: [],
  requestingUserPermissions: new hN()
};
class $B extends Jt(pN, "Project") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
  getIssueGroupsOptions() {
    return this.getOptionsFor(zi.ISSUE_GROUP);
  }
  getAttributesFor(e) {
    return this.settings.attributes.filter(
      (r) => r.type === e
    ) || [];
  }
  getSortedCustomAttributes() {
    return [
      ...this.getAttributesFor(zi.TEXT),
      ...this.getAttributesFor(zi.PREDEFINED)
    ].sort((e, r) => e.id - r.id);
  }
  getOptionsFor(e) {
    const r = this.settings.attributes.find(
      (n) => n.type === e
    );
    return r && r.values ? r.values : [];
  }
  getOptionsForIssue() {
    const e = this.getOptionsFor(zi.STATUS), r = this.getOptionsFor(zi.TYPE), n = this.getOptionsFor(zi.PRIORITY), i = this.getOptionsFor(zi.ZONE), o = this.getOptionsFor(zi.PHASE), s = this.getOptionsFor(zi.DISCIPLINE), u = this.getSortedCustomAttributes();
    return new sN({
      statuses: e,
      types: r,
      priorities: n,
      zones: i,
      phases: o,
      disciplines: s,
      customAttributes: u
    });
  }
  getStatusesBaseOnUser(e, r) {
    const n = e.teams ?? [];
    let i = this.getOptionsFor(zi.STATUS).filter((o) => {
      const s = o.teams ? o.teams.map((u) => u.id) : [];
      return s.length === 0 || n.some((u) => s.indexOf(u.id) !== -1);
    });
    return i.some((o) => o.id === r.id) || (i = [...i, r].sort((o, s) => o.name.localeCompare(s.name))), i;
  }
  getIntegrationFor(e) {
    return this.settings.integrations.find(
      (r) => r.integration.name.toLowerCase() === e.toLowerCase()
    );
  }
  getIssueMandatoryAttributes() {
    return this.settings.issueMandatoryAttributes;
  }
  getAttributes() {
    return this.settings.attributes;
  }
}
const dN = {
  id: -1,
  name: ""
};
class KB extends Jt(dN, "ProjectTemplate") {
}
const vN = {
  id: -1,
  name: ""
};
class VB extends Jt(vN, "ProjectTeam") {
}
const yN = {
  id: -1,
  name: "",
  siteUrl: ""
};
class _N extends Jt(yN, "Integration") {
}
const mN = {
  id: -1,
  name: "",
  color: void 0,
  teams: void 0
};
class QB extends Jt(mN, "ProjectAttributeValue") {
}
const gN = {
  companyId: -1,
  companyName: "",
  projectId: -1,
  projectName: "",
  createRFIComment: !1
};
class YB extends Jt(gN, "ProcoreIntegrationData") {
}
const bN = {
  id: -1,
  integration: new _N(),
  data: {}
};
class GB extends Jt(bN, "ProjectIntegration") {
}
const wN = {
  id: "",
  name: ""
};
class WB extends Jt(wN, "PropertyAttribute") {
}
const EN = {
  user: void 0,
  hub: void 0,
  project: void 0,
  bimTrackApiUrl: ""
};
class HB extends Jt(EN, "Session") {
}
const SN = {
  id: "",
  name: "",
  format: zR.EN_US
};
class ON extends Jt(SN, "DateFormatAttribute") {
}
const IN = {
  id: Km.EN,
  name: ""
};
class AN extends Jt(IN, "LanguageAttribute") {
}
const DN = {
  id: pp.NEW_YORK,
  name: pp.NEW_YORK,
  nameIana: pp.NEW_YORK,
  offset: void 0
};
class RN extends Jt(DN, "TimeZoneAttribute") {
}
const xN = {
  firstName: "",
  lastName: "",
  title: "",
  company: "",
  country: void 0,
  industry: void 0,
  jobTitle: "",
  dateFormat: new ON(),
  avatarImage: "",
  language: new AN(),
  website: void 0,
  timeZone: new RN()
};
class TN extends Jt(xN, "UserProfile") {
  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
  get initials() {
    return this.firstName && this.lastName ? `${Array.from(this.firstName)[0]}${Array.from(this.lastName)[0]}` : "";
  }
  getDateTimeFormat() {
    return this.dateFormat.format;
  }
  getDateFormat() {
    return this.dateFormat.format.replace(/ .*/, "");
  }
  getTimeFormat() {
    return this.dateFormat.format.replace(/([^\s]+) /, "");
  }
}
const PN = {
  id: 0,
  globalId: void 0,
  email: "",
  profile: new TN(),
  status: LR.INACTIVE,
  activationDate: void 0,
  invitationPending: !1,
  isPending: !1,
  lastHubProjectActivity: void 0,
  canResendInvite: void 0,
  hubOwner: !1,
  hubRole: Ku.GUEST,
  projectOwner: !1,
  projectReviewer: !1,
  projectRole: void 0,
  projects: [],
  teams: [],
  isProviderExternal: !1
};
class JB extends Jt(PN, "User") {
  get fullName() {
    return this.isValid() ? this.profile.fullName : `${this.profile.title}`.trim();
  }
  get fullNameAndEmail() {
    return `${this.fullName} (${this.email})`.trim();
  }
  get initials() {
    return this.profile.initials;
  }
  isNew() {
    return this.id === 0;
  }
  isOwner() {
    return this.hubOwner;
  }
  isAdmin() {
    return this.hubRole === Ku.ADMIN;
  }
  isGuest() {
    return this.hubRole === Ku.GUEST;
  }
  isProjectAdmin() {
    return this.projectRole === Og.ADMIN;
  }
  isProjectOwner() {
    return this.projectOwner;
  }
  isTeamMember(e) {
    return this.teams.some((r) => r.id === e);
  }
  canEditUser(e) {
    return this.is(e) || this.hubRole === Ku.GUEST ? !1 : this.isOwner() || !e.isOwner();
  }
  is(e) {
    return e ? this.globalId && e.globalId ? this.globalId === e.globalId : this.id === e.id : !1;
  }
  getDateTimeFormat() {
    return this.profile.getDateTimeFormat();
  }
  getDateFormat() {
    return this.profile.getDateFormat();
  }
  getTimeFormat() {
    return this.profile.getTimeFormat();
  }
  isValid() {
    return this.id > 0 || !!this.globalId;
  }
}
const kN = {
  id: -1,
  name: ""
};
class ZB extends Jt(kN, "UserProject") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
}
var CN = Object.defineProperty, jN = (t, e, r) => e in t ? CN(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, FE = (t, e, r) => (jN(t, typeof e != "symbol" ? e + "" : e, r), r), Bf = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qN(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var b_ = { exports: {} }, NE = Object.hasOwnProperty, MN = Object.getPrototypeOf, zE = Error.captureStackTrace, FN = zp;
function zp(t, e) {
  if (t && typeof t == "object" ? (e = t, t = void 0) : this.message = t, e)
    for (var r in e)
      this[r] = e[r];
  NE.call(this, "name") || (this.name = NE.call(MN(this), "name") ? this.name : this.constructor.name), zE && !("stack" in this) && zE(this, this.constructor);
}
zp.prototype = Object.create(Error.prototype, {
  constructor: { value: zp, configurable: !0, writable: !0 }
});
zp.prototype.name = "StandardError";
const NN = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non-Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi-Status",
  208: "Already Reported",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  307: "Temporary Redirect",
  308: "Permanent Redirect",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Payload Too Large",
  414: "URI Too Long",
  415: "Unsupported Media Type",
  416: "Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  421: "Misdirected Request",
  422: "Unprocessable Entity",
  423: "Locked",
  424: "Failed Dependency",
  425: "Unordered Collection",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates",
  507: "Insufficient Storage",
  508: "Loop Detected",
  509: "Bandwidth Limit Exceeded",
  510: "Not Extended",
  511: "Network Authentication Required"
};
(function(t, e) {
  e = t.exports = o;
  var r = FN, n = NN, i = e;
  function o(a, f, h) {
    if (typeof a == "string" && (a = i[a]), typeof a != "number")
      throw new TypeError("Non-numeric HTTP code");
    typeof f == "object" && f != null && (h = f, f = null), r.call(this, f || n[a], h), this.code = a;
  }
  o.prototype = Object.create(r.prototype, {
    constructor: { value: o, configurable: !0, writable: !0 }
  }), o.prototype.name = "HttpError", Object.defineProperties(o.prototype, {
    statusCode: c("code"),
    statusMessage: c("message"),
    status: {
      configurable: !0,
      get: function() {
        return this.code;
      },
      set: function(a) {
        Object.defineProperty(this, "status", {
          value: a,
          configurable: !0,
          enumerable: !0,
          writable: !0
        });
      }
    }
  }), o.prototype.toString = function() {
    return this.name + ": " + this.code + " " + this.message;
  };
  for (var s in n) {
    var u = n[s];
    e[u.replace("'", "").replace(/[- ]/g, "_").toUpperCase()] = +s;
  }
  function c(a) {
    return {
      configurable: !0,
      get: function() {
        return this[a];
      },
      set: function(f) {
        return this[a] = f;
      }
    };
  }
})(b_, b_.exports);
var zN = b_.exports;
const LN = /* @__PURE__ */ qN(zN);
var Lp = { exports: {} };
Lp.exports;
(function(t, e) {
  var r = 200, n = "Expected a function", i = "__lodash_hash_undefined__", o = 1, s = 2, u = 1 / 0, c = 9007199254740991, a = "[object Arguments]", f = "[object Array]", h = "[object Boolean]", p = "[object Date]", d = "[object Error]", _ = "[object Function]", m = "[object GeneratorFunction]", b = "[object Map]", O = "[object Number]", S = "[object Object]", k = "[object Promise]", T = "[object RegExp]", x = "[object Set]", P = "[object String]", R = "[object Symbol]", D = "[object WeakMap]", I = "[object ArrayBuffer]", j = "[object DataView]", Y = "[object Float32Array]", H = "[object Float64Array]", B = "[object Int8Array]", tt = "[object Int16Array]", lt = "[object Int32Array]", te = "[object Uint8Array]", pt = "[object Uint8ClampedArray]", At = "[object Uint16Array]", ft = "[object Uint32Array]", Lt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, dt = /^\w*$/, mt = /^\./, st = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Nt = /[\\^$.*+?()[\]{}|]/g, Qt = /\\(\\)?/g, Rt = /^\[object .+?Constructor\]$/, xt = /^(?:0|[1-9]\d*)$/, N = {};
  N[Y] = N[H] = N[B] = N[tt] = N[lt] = N[te] = N[pt] = N[At] = N[ft] = !0, N[a] = N[f] = N[I] = N[h] = N[j] = N[p] = N[d] = N[_] = N[b] = N[O] = N[S] = N[T] = N[x] = N[P] = N[D] = !1;
  var ht = typeof Bf == "object" && Bf && Bf.Object === Object && Bf, gt = typeof self == "object" && self && self.Object === Object && self, X = ht || gt || Function("return this")(), wt = e && !e.nodeType && e, jt = wt && !0 && t && !t.nodeType && t, qt = jt && jt.exports === wt, U = qt && ht.process, $ = function() {
    try {
      return U && U.binding("util");
    } catch {
    }
  }(), W = $ && $.isTypedArray;
  function et(l, v) {
    for (var g = -1, E = l ? l.length : 0; ++g < E; )
      if (v(l[g], g, l))
        return !0;
    return !1;
  }
  function ot(l) {
    return function(v) {
      return v == null ? void 0 : v[l];
    };
  }
  function Dt(l, v) {
    for (var g = -1, E = Array(l); ++g < l; )
      E[g] = v(g);
    return E;
  }
  function St(l) {
    return function(v) {
      return l(v);
    };
  }
  function Et(l, v) {
    return l == null ? void 0 : l[v];
  }
  function ue(l) {
    var v = !1;
    if (l != null && typeof l.toString != "function")
      try {
        v = !!(l + "");
      } catch {
      }
    return v;
  }
  function ae(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E, M) {
      g[++v] = [M, E];
    }), g;
  }
  function ce(l, v) {
    return function(g) {
      return l(v(g));
    };
  }
  function Yt(l) {
    var v = -1, g = Array(l.size);
    return l.forEach(function(E) {
      g[++v] = E;
    }), g;
  }
  var Ot = Array.prototype, Oe = Function.prototype, Gt = Object.prototype, se = X["__core-js_shared__"], Zt = function() {
    var l = /[^.]+$/.exec(se && se.keys && se.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), fe = Oe.toString, vt = Gt.hasOwnProperty, Mt = Gt.toString, Fr = RegExp(
    "^" + fe.call(vt).replace(Nt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), We = X.Symbol, He = X.Uint8Array, Nr = Gt.propertyIsEnumerable, Ie = Ot.splice, Je = ce(Object.keys, Object), It = _e(X, "DataView"), Tt = _e(X, "Map"), ee = _e(X, "Promise"), ye = _e(X, "Set"), Ae = _e(X, "WeakMap"), Ut = _e(Object, "create"), zr = ne(It), Ze = ne(Tt), Xe = ne(ee), Lr = ne(ye), Ur = ne(Ae), re = We ? We.prototype : void 0, De = re ? re.valueOf : void 0, tr = re ? re.toString : void 0;
  function Pt(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Br() {
    this.__data__ = Ut ? Ut(null) : {};
  }
  function y(l) {
    return this.has(l) && delete this.__data__[l];
  }
  function w(l) {
    var v = this.__data__;
    if (Ut) {
      var g = v[l];
      return g === i ? void 0 : g;
    }
    return vt.call(v, l) ? v[l] : void 0;
  }
  function A(l) {
    var v = this.__data__;
    return Ut ? v[l] !== void 0 : vt.call(v, l);
  }
  function q(l, v) {
    var g = this.__data__;
    return g[l] = Ut && v === void 0 ? i : v, this;
  }
  Pt.prototype.clear = Br, Pt.prototype.delete = y, Pt.prototype.get = w, Pt.prototype.has = A, Pt.prototype.set = q;
  function F(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function Q() {
    this.__data__ = [];
  }
  function L(l) {
    var v = this.__data__, g = nr(v, l);
    if (g < 0)
      return !1;
    var E = v.length - 1;
    return g == E ? v.pop() : Ie.call(v, g, 1), !0;
  }
  function z(l) {
    var v = this.__data__, g = nr(v, l);
    return g < 0 ? void 0 : v[g][1];
  }
  function it(l) {
    return nr(this.__data__, l) > -1;
  }
  function J(l, v) {
    var g = this.__data__, E = nr(g, l);
    return E < 0 ? g.push([l, v]) : g[E][1] = v, this;
  }
  F.prototype.clear = Q, F.prototype.delete = L, F.prototype.get = z, F.prototype.has = it, F.prototype.set = J;
  function K(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.clear(); ++v < g; ) {
      var E = l[v];
      this.set(E[0], E[1]);
    }
  }
  function ut() {
    this.__data__ = {
      hash: new Pt(),
      map: new (Tt || F)(),
      string: new Pt()
    };
  }
  function Bt(l) {
    return ir(this, l).delete(l);
  }
  function er(l) {
    return ir(this, l).get(l);
  }
  function bt(l) {
    return ir(this, l).has(l);
  }
  function cs(l, v) {
    return ir(this, l).set(l, v), this;
  }
  K.prototype.clear = ut, K.prototype.delete = Bt, K.prototype.get = er, K.prototype.has = bt, K.prototype.set = cs;
  function rr(l) {
    var v = -1, g = l ? l.length : 0;
    for (this.__data__ = new K(); ++v < g; )
      this.add(l[v]);
  }
  function fs(l) {
    return this.__data__.set(l, i), this;
  }
  function ls(l) {
    return this.__data__.has(l);
  }
  rr.prototype.add = rr.prototype.push = fs, rr.prototype.has = ls;
  function kt(l) {
    this.__data__ = new F(l);
  }
  function hs() {
    this.__data__ = new F();
  }
  function ps(l) {
    return this.__data__.delete(l);
  }
  function ds(l) {
    return this.__data__.get(l);
  }
  function vs(l) {
    return this.__data__.has(l);
  }
  function ys(l, v) {
    var g = this.__data__;
    if (g instanceof F) {
      var E = g.__data__;
      if (!Tt || E.length < r - 1)
        return E.push([l, v]), this;
      g = this.__data__ = new K(E);
    }
    return g.set(l, v), this;
  }
  kt.prototype.clear = hs, kt.prototype.delete = ps, kt.prototype.get = ds, kt.prototype.has = vs, kt.prototype.set = ys;
  function _s(l, v) {
    var g = ie(l) || Jn(l) ? Dt(l.length, String) : [], E = g.length, M = !!E;
    for (var C in l)
      (v || vt.call(l, C)) && !(M && (C == "length" || Yn(C, E))) && g.push(C);
    return g;
  }
  function nr(l, v) {
    for (var g = l.length; g--; )
      if (Hn(l[g][0], v))
        return g;
    return -1;
  }
  var ms = ks();
  function gs(l, v) {
    return l && ms(l, v, cr);
  }
  function Kn(l, v) {
    v = or(v, l) ? [v] : Vn(v);
    for (var g = 0, E = v.length; l != null && g < E; )
      l = l[sr(v[g++])];
    return g && g == E ? l : void 0;
  }
  function bs(l) {
    return Mt.call(l);
  }
  function ws(l, v) {
    return l != null && v in Object(l);
  }
  function $r(l, v, g, E, M) {
    return l === v ? !0 : l == null || v == null || !ar(l) && !ur(v) ? l !== l && v !== v : Es(l, v, $r, g, E, M);
  }
  function Es(l, v, g, E, M, C) {
    var V = ie(l), G = ie(v), Z = f, rt = f;
    V || (Z = $t(l), Z = Z == a ? S : Z), G || (rt = $t(v), rt = rt == a ? S : rt);
    var at = Z == S && !ue(l), ct = rt == S && !ue(v), nt = Z == rt;
    if (nt && !at)
      return C || (C = new kt()), V || Bs(l) ? Qn(l, v, g, E, M, C) : Cs(l, v, Z, g, E, M, C);
    if (!(M & s)) {
      var yt = at && vt.call(l, "__wrapped__"), _t = ct && vt.call(v, "__wrapped__");
      if (yt || _t) {
        var Kt = yt ? l.value() : l, Ct = _t ? v.value() : v;
        return C || (C = new kt()), g(Kt, Ct, E, M, C);
      }
    }
    return nt ? (C || (C = new kt()), js(l, v, g, E, M, C)) : !1;
  }
  function Ss(l, v, g, E) {
    var M = g.length, C = M, V = !E;
    if (l == null)
      return !C;
    for (l = Object(l); M--; ) {
      var G = g[M];
      if (V && G[2] ? G[1] !== l[G[0]] : !(G[0] in l))
        return !1;
    }
    for (; ++M < C; ) {
      G = g[M];
      var Z = G[0], rt = l[Z], at = G[1];
      if (V && G[2]) {
        if (rt === void 0 && !(Z in l))
          return !1;
      } else {
        var ct = new kt();
        if (E)
          var nt = E(rt, at, Z, l, v, ct);
        if (!(nt === void 0 ? $r(at, rt, E, o | s, ct) : nt))
          return !1;
      }
    }
    return !0;
  }
  function Os(l) {
    if (!ar(l) || Ns(l))
      return !1;
    var v = Xn(l) || ue(l) ? Fr : Rt;
    return v.test(ne(l));
  }
  function Is(l) {
    return ur(l) && Vr(l.length) && !!N[Mt.call(l)];
  }
  function As(l) {
    return typeof l == "function" ? l : l == null ? Ys : typeof l == "object" ? ie(l) ? xs(l[0], l[1]) : Rs(l) : Gs(l);
  }
  function Ds(l) {
    if (!zs(l))
      return Je(l);
    var v = [];
    for (var g in Object(l))
      vt.call(l, g) && g != "constructor" && v.push(g);
    return v;
  }
  function Rs(l) {
    var v = qs(l);
    return v.length == 1 && v[0][2] ? Wn(v[0][0], v[0][1]) : function(g) {
      return g === l || Ss(g, l, v);
    };
  }
  function xs(l, v) {
    return or(l) && Gn(v) ? Wn(sr(l), v) : function(g) {
      var E = Ks(g, l);
      return E === void 0 && E === v ? Vs(g, l) : $r(v, E, void 0, o | s);
    };
  }
  function Ts(l) {
    return function(v) {
      return Kn(v, l);
    };
  }
  function Ps(l) {
    if (typeof l == "string")
      return l;
    if (Qr(l))
      return tr ? tr.call(l) : "";
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function Vn(l) {
    return ie(l) ? l : Ls(l);
  }
  function ks(l) {
    return function(v, g, E) {
      for (var M = -1, C = Object(v), V = E(v), G = V.length; G--; ) {
        var Z = V[l ? G : ++M];
        if (g(C[Z], Z, C) === !1)
          break;
      }
      return v;
    };
  }
  function Qn(l, v, g, E, M, C) {
    var V = M & s, G = l.length, Z = v.length;
    if (G != Z && !(V && Z > G))
      return !1;
    var rt = C.get(l);
    if (rt && C.get(v))
      return rt == v;
    var at = -1, ct = !0, nt = M & o ? new rr() : void 0;
    for (C.set(l, v), C.set(v, l); ++at < G; ) {
      var yt = l[at], _t = v[at];
      if (E)
        var Kt = V ? E(_t, yt, at, v, l, C) : E(yt, _t, at, l, v, C);
      if (Kt !== void 0) {
        if (Kt)
          continue;
        ct = !1;
        break;
      }
      if (nt) {
        if (!et(v, function(Ct, oe) {
          if (!nt.has(oe) && (yt === Ct || g(yt, Ct, E, M, C)))
            return nt.add(oe);
        })) {
          ct = !1;
          break;
        }
      } else if (!(yt === _t || g(yt, _t, E, M, C))) {
        ct = !1;
        break;
      }
    }
    return C.delete(l), C.delete(v), ct;
  }
  function Cs(l, v, g, E, M, C, V) {
    switch (g) {
      case j:
        if (l.byteLength != v.byteLength || l.byteOffset != v.byteOffset)
          return !1;
        l = l.buffer, v = v.buffer;
      case I:
        return !(l.byteLength != v.byteLength || !E(new He(l), new He(v)));
      case h:
      case p:
      case O:
        return Hn(+l, +v);
      case d:
        return l.name == v.name && l.message == v.message;
      case T:
      case P:
        return l == v + "";
      case b:
        var G = ae;
      case x:
        var Z = C & s;
        if (G || (G = Yt), l.size != v.size && !Z)
          return !1;
        var rt = V.get(l);
        if (rt)
          return rt == v;
        C |= o, V.set(l, v);
        var at = Qn(G(l), G(v), E, M, C, V);
        return V.delete(l), at;
      case R:
        if (De)
          return De.call(l) == De.call(v);
    }
    return !1;
  }
  function js(l, v, g, E, M, C) {
    var V = M & s, G = cr(l), Z = G.length, rt = cr(v), at = rt.length;
    if (Z != at && !V)
      return !1;
    for (var ct = Z; ct--; ) {
      var nt = G[ct];
      if (!(V ? nt in v : vt.call(v, nt)))
        return !1;
    }
    var yt = C.get(l);
    if (yt && C.get(v))
      return yt == v;
    var _t = !0;
    C.set(l, v), C.set(v, l);
    for (var Kt = V; ++ct < Z; ) {
      nt = G[ct];
      var Ct = l[nt], oe = v[nt];
      if (E)
        var ti = V ? E(oe, Ct, nt, v, l, C) : E(Ct, oe, nt, l, v, C);
      if (!(ti === void 0 ? Ct === oe || g(Ct, oe, E, M, C) : ti)) {
        _t = !1;
        break;
      }
      Kt || (Kt = nt == "constructor");
    }
    if (_t && !Kt) {
      var fr = l.constructor, lr = v.constructor;
      fr != lr && "constructor" in l && "constructor" in v && !(typeof fr == "function" && fr instanceof fr && typeof lr == "function" && lr instanceof lr) && (_t = !1);
    }
    return C.delete(l), C.delete(v), _t;
  }
  function ir(l, v) {
    var g = l.__data__;
    return Fs(v) ? g[typeof v == "string" ? "string" : "hash"] : g.map;
  }
  function qs(l) {
    for (var v = cr(l), g = v.length; g--; ) {
      var E = v[g], M = l[E];
      v[g] = [E, M, Gn(M)];
    }
    return v;
  }
  function _e(l, v) {
    var g = Et(l, v);
    return Os(g) ? g : void 0;
  }
  var $t = bs;
  (It && $t(new It(new ArrayBuffer(1))) != j || Tt && $t(new Tt()) != b || ee && $t(ee.resolve()) != k || ye && $t(new ye()) != x || Ae && $t(new Ae()) != D) && ($t = function(l) {
    var v = Mt.call(l), g = v == S ? l.constructor : void 0, E = g ? ne(g) : void 0;
    if (E)
      switch (E) {
        case zr:
          return j;
        case Ze:
          return b;
        case Xe:
          return k;
        case Lr:
          return x;
        case Ur:
          return D;
      }
    return v;
  });
  function Ms(l, v, g) {
    v = or(v, l) ? [v] : Vn(v);
    for (var E, M = -1, V = v.length; ++M < V; ) {
      var C = sr(v[M]);
      if (!(E = l != null && g(l, C)))
        break;
      l = l[C];
    }
    if (E)
      return E;
    var V = l ? l.length : 0;
    return !!V && Vr(V) && Yn(C, V) && (ie(l) || Jn(l));
  }
  function Yn(l, v) {
    return v = v ?? c, !!v && (typeof l == "number" || xt.test(l)) && l > -1 && l % 1 == 0 && l < v;
  }
  function or(l, v) {
    if (ie(l))
      return !1;
    var g = typeof l;
    return g == "number" || g == "symbol" || g == "boolean" || l == null || Qr(l) ? !0 : dt.test(l) || !Lt.test(l) || v != null && l in Object(v);
  }
  function Fs(l) {
    var v = typeof l;
    return v == "string" || v == "number" || v == "symbol" || v == "boolean" ? l !== "__proto__" : l === null;
  }
  function Ns(l) {
    return !!Zt && Zt in l;
  }
  function zs(l) {
    var v = l && l.constructor, g = typeof v == "function" && v.prototype || Gt;
    return l === g;
  }
  function Gn(l) {
    return l === l && !ar(l);
  }
  function Wn(l, v) {
    return function(g) {
      return g == null ? !1 : g[l] === v && (v !== void 0 || l in Object(g));
    };
  }
  var Ls = Kr(function(l) {
    l = $s(l);
    var v = [];
    return mt.test(l) && v.push(""), l.replace(st, function(g, E, M, C) {
      v.push(M ? C.replace(Qt, "$1") : E || g);
    }), v;
  });
  function sr(l) {
    if (typeof l == "string" || Qr(l))
      return l;
    var v = l + "";
    return v == "0" && 1 / l == -u ? "-0" : v;
  }
  function ne(l) {
    if (l != null) {
      try {
        return fe.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function Kr(l, v) {
    if (typeof l != "function" || v && typeof v != "function")
      throw new TypeError(n);
    var g = function() {
      var E = arguments, M = v ? v.apply(this, E) : E[0], C = g.cache;
      if (C.has(M))
        return C.get(M);
      var V = l.apply(this, E);
      return g.cache = C.set(M, V), V;
    };
    return g.cache = new (Kr.Cache || K)(), g;
  }
  Kr.Cache = K;
  function Hn(l, v) {
    return l === v || l !== l && v !== v;
  }
  function Jn(l) {
    return Us(l) && vt.call(l, "callee") && (!Nr.call(l, "callee") || Mt.call(l) == a);
  }
  var ie = Array.isArray;
  function Zn(l) {
    return l != null && Vr(l.length) && !Xn(l);
  }
  function Us(l) {
    return ur(l) && Zn(l);
  }
  function Xn(l) {
    var v = ar(l) ? Mt.call(l) : "";
    return v == _ || v == m;
  }
  function Vr(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= c;
  }
  function ar(l) {
    var v = typeof l;
    return !!l && (v == "object" || v == "function");
  }
  function ur(l) {
    return !!l && typeof l == "object";
  }
  function Qr(l) {
    return typeof l == "symbol" || ur(l) && Mt.call(l) == R;
  }
  var Bs = W ? St(W) : Is;
  function $s(l) {
    return l == null ? "" : Ps(l);
  }
  function Ks(l, v, g) {
    var E = l == null ? void 0 : Kn(l, v);
    return E === void 0 ? g : E;
  }
  function Vs(l, v) {
    return l != null && Ms(l, v, ws);
  }
  function cr(l) {
    return Zn(l) ? _s(l) : Ds(l);
  }
  function Qs(l, v) {
    var g = {};
    return v = As(v), gs(l, function(E, M, C) {
      g[v(E, M, C)] = E;
    }), g;
  }
  function Ys(l) {
    return l;
  }
  function Gs(l) {
    return or(l) ? ot(sr(l)) : Ts(l);
  }
  t.exports = Qs;
})(Lp, Lp.exports);
Lp.exports;
var If = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LE;
function UN() {
  if (LE)
    return If;
  LE = 1;
  var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, c, a) {
    var f, h = {}, p = null, d = null;
    a !== void 0 && (p = "" + a), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (d = c.ref);
    for (f in c)
      n.call(c, f) && !o.hasOwnProperty(f) && (h[f] = c[f]);
    if (u && u.defaultProps)
      for (f in c = u.defaultProps, c)
        h[f] === void 0 && (h[f] = c[f]);
    return { $$typeof: e, type: u, key: p, ref: d, props: h, _owner: i.current };
  }
  return If.Fragment = r, If.jsx = s, If.jsxs = s, If;
}
var Gh = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var UE;
function BN() {
  return UE || (UE = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Se, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), a = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), _ = Symbol.iterator, m = "@@iterator";
    function b(y) {
      if (y === null || typeof y != "object")
        return null;
      var w = _ && y[_] || y[m];
      return typeof w == "function" ? w : null;
    }
    var O = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(y) {
      {
        for (var w = arguments.length, A = new Array(w > 1 ? w - 1 : 0), q = 1; q < w; q++)
          A[q - 1] = arguments[q];
        k("error", y, A);
      }
    }
    function k(y, w, A) {
      {
        var q = O.ReactDebugCurrentFrame, F = q.getStackAddendum();
        F !== "" && (w += "%s", A = A.concat([F]));
        var Q = A.map(function(L) {
          return String(L);
        });
        Q.unshift("Warning: " + w), Function.prototype.apply.call(console[y], console, Q);
      }
    }
    var T = !1, x = !1, P = !1, R = !1, D = !1, I;
    I = Symbol.for("react.module.reference");
    function j(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === n || y === o || D || y === i || y === a || y === f || R || y === d || T || x || P || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === h || y.$$typeof === s || y.$$typeof === u || y.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === I || y.getModuleId !== void 0));
    }
    function Y(y, w, A) {
      var q = y.displayName;
      if (q)
        return q;
      var F = w.displayName || w.name || "";
      return F !== "" ? A + "(" + F + ")" : A;
    }
    function H(y) {
      return y.displayName || "Context";
    }
    function B(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case a:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case u:
            var w = y;
            return H(w) + ".Consumer";
          case s:
            var A = y;
            return H(A._context) + ".Provider";
          case c:
            return Y(y, y.render, "ForwardRef");
          case h:
            var q = y.displayName || null;
            return q !== null ? q : B(y.type) || "Memo";
          case p: {
            var F = y, Q = F._payload, L = F._init;
            try {
              return B(L(Q));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var tt = Object.assign, lt = 0, te, pt, At, ft, Lt, dt, mt;
    function st() {
    }
    st.__reactDisabledLog = !0;
    function Nt() {
      {
        if (lt === 0) {
          te = console.log, pt = console.info, At = console.warn, ft = console.error, Lt = console.group, dt = console.groupCollapsed, mt = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: st,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        lt++;
      }
    }
    function Qt() {
      {
        if (lt--, lt === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: tt({}, y, {
              value: te
            }),
            info: tt({}, y, {
              value: pt
            }),
            warn: tt({}, y, {
              value: At
            }),
            error: tt({}, y, {
              value: ft
            }),
            group: tt({}, y, {
              value: Lt
            }),
            groupCollapsed: tt({}, y, {
              value: dt
            }),
            groupEnd: tt({}, y, {
              value: mt
            })
          });
        }
        lt < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Rt = O.ReactCurrentDispatcher, xt;
    function N(y, w, A) {
      {
        if (xt === void 0)
          try {
            throw Error();
          } catch (F) {
            var q = F.stack.trim().match(/\n( *(at )?)/);
            xt = q && q[1] || "";
          }
        return `
` + xt + y;
      }
    }
    var ht = !1, gt;
    {
      var X = typeof WeakMap == "function" ? WeakMap : Map;
      gt = new X();
    }
    function wt(y, w) {
      if (!y || ht)
        return "";
      {
        var A = gt.get(y);
        if (A !== void 0)
          return A;
      }
      var q;
      ht = !0;
      var F = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Q;
      Q = Rt.current, Rt.current = null, Nt();
      try {
        if (w) {
          var L = function() {
            throw Error();
          };
          if (Object.defineProperty(L.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(L, []);
            } catch (bt) {
              q = bt;
            }
            Reflect.construct(y, [], L);
          } else {
            try {
              L.call();
            } catch (bt) {
              q = bt;
            }
            y.call(L.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bt) {
            q = bt;
          }
          y();
        }
      } catch (bt) {
        if (bt && q && typeof bt.stack == "string") {
          for (var z = bt.stack.split(`
`), it = q.stack.split(`
`), J = z.length - 1, K = it.length - 1; J >= 1 && K >= 0 && z[J] !== it[K]; )
            K--;
          for (; J >= 1 && K >= 0; J--, K--)
            if (z[J] !== it[K]) {
              if (J !== 1 || K !== 1)
                do
                  if (J--, K--, K < 0 || z[J] !== it[K]) {
                    var ut = `
` + z[J].replace(" at new ", " at ");
                    return y.displayName && ut.includes("<anonymous>") && (ut = ut.replace("<anonymous>", y.displayName)), typeof y == "function" && gt.set(y, ut), ut;
                  }
                while (J >= 1 && K >= 0);
              break;
            }
        }
      } finally {
        ht = !1, Rt.current = Q, Qt(), Error.prepareStackTrace = F;
      }
      var Bt = y ? y.displayName || y.name : "", er = Bt ? N(Bt) : "";
      return typeof y == "function" && gt.set(y, er), er;
    }
    function jt(y, w, A) {
      return wt(y, !1);
    }
    function qt(y) {
      var w = y.prototype;
      return !!(w && w.isReactComponent);
    }
    function U(y, w, A) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return wt(y, qt(y));
      if (typeof y == "string")
        return N(y);
      switch (y) {
        case a:
          return N("Suspense");
        case f:
          return N("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case c:
            return jt(y.render);
          case h:
            return U(y.type, w, A);
          case p: {
            var q = y, F = q._payload, Q = q._init;
            try {
              return U(Q(F), w, A);
            } catch {
            }
          }
        }
      return "";
    }
    var $ = Object.prototype.hasOwnProperty, W = {}, et = O.ReactDebugCurrentFrame;
    function ot(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        et.setExtraStackFrame(A);
      } else
        et.setExtraStackFrame(null);
    }
    function Dt(y, w, A, q, F) {
      {
        var Q = Function.call.bind($);
        for (var L in y)
          if (Q(y, L)) {
            var z = void 0;
            try {
              if (typeof y[L] != "function") {
                var it = Error((q || "React class") + ": " + A + " type `" + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[L] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw it.name = "Invariant Violation", it;
              }
              z = y[L](w, L, q, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (J) {
              z = J;
            }
            z && !(z instanceof Error) && (ot(F), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", A, L, typeof z), ot(null)), z instanceof Error && !(z.message in W) && (W[z.message] = !0, ot(F), S("Failed %s type: %s", A, z.message), ot(null));
          }
      }
    }
    var St = Array.isArray;
    function Et(y) {
      return St(y);
    }
    function ue(y) {
      {
        var w = typeof Symbol == "function" && Symbol.toStringTag, A = w && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return A;
      }
    }
    function ae(y) {
      try {
        return ce(y), !1;
      } catch {
        return !0;
      }
    }
    function ce(y) {
      return "" + y;
    }
    function Yt(y) {
      if (ae(y))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ue(y)), ce(y);
    }
    var Ot = O.ReactCurrentOwner, Oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Gt, se, Zt;
    Zt = {};
    function fe(y) {
      if ($.call(y, "ref")) {
        var w = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function vt(y) {
      if ($.call(y, "key")) {
        var w = Object.getOwnPropertyDescriptor(y, "key").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Mt(y, w) {
      if (typeof y.ref == "string" && Ot.current && w && Ot.current.stateNode !== w) {
        var A = B(Ot.current.type);
        Zt[A] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(Ot.current.type), y.ref), Zt[A] = !0);
      }
    }
    function Fr(y, w) {
      {
        var A = function() {
          Gt || (Gt = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: A,
          configurable: !0
        });
      }
    }
    function We(y, w) {
      {
        var A = function() {
          se || (se = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        A.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: A,
          configurable: !0
        });
      }
    }
    var He = function(y, w, A, q, F, Q, L) {
      var z = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: y,
        key: w,
        ref: A,
        props: L,
        // Record the component responsible for creating this element.
        _owner: Q
      };
      return z._store = {}, Object.defineProperty(z._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(z, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(z, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.freeze && (Object.freeze(z.props), Object.freeze(z)), z;
    };
    function Nr(y, w, A, q, F) {
      {
        var Q, L = {}, z = null, it = null;
        A !== void 0 && (Yt(A), z = "" + A), vt(w) && (Yt(w.key), z = "" + w.key), fe(w) && (it = w.ref, Mt(w, F));
        for (Q in w)
          $.call(w, Q) && !Oe.hasOwnProperty(Q) && (L[Q] = w[Q]);
        if (y && y.defaultProps) {
          var J = y.defaultProps;
          for (Q in J)
            L[Q] === void 0 && (L[Q] = J[Q]);
        }
        if (z || it) {
          var K = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          z && Fr(L, K), it && We(L, K);
        }
        return He(y, z, it, F, q, Ot.current, L);
      }
    }
    var Ie = O.ReactCurrentOwner, Je = O.ReactDebugCurrentFrame;
    function It(y) {
      if (y) {
        var w = y._owner, A = U(y.type, y._source, w ? w.type : null);
        Je.setExtraStackFrame(A);
      } else
        Je.setExtraStackFrame(null);
    }
    var Tt;
    Tt = !1;
    function ee(y) {
      return typeof y == "object" && y !== null && y.$$typeof === e;
    }
    function ye() {
      {
        if (Ie.current) {
          var y = B(Ie.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function Ae(y) {
      {
        if (y !== void 0) {
          var w = y.fileName.replace(/^.*[\\\/]/, ""), A = y.lineNumber;
          return `

Check your code at ` + w + ":" + A + ".";
        }
        return "";
      }
    }
    var Ut = {};
    function zr(y) {
      {
        var w = ye();
        if (!w) {
          var A = typeof y == "string" ? y : y.displayName || y.name;
          A && (w = `

Check the top-level render call using <` + A + ">.");
        }
        return w;
      }
    }
    function Ze(y, w) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var A = zr(w);
        if (Ut[A])
          return;
        Ut[A] = !0;
        var q = "";
        y && y._owner && y._owner !== Ie.current && (q = " It was passed a child from " + B(y._owner.type) + "."), It(y), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, q), It(null);
      }
    }
    function Xe(y, w) {
      {
        if (typeof y != "object")
          return;
        if (Et(y))
          for (var A = 0; A < y.length; A++) {
            var q = y[A];
            ee(q) && Ze(q, w);
          }
        else if (ee(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var F = b(y);
          if (typeof F == "function" && F !== y.entries)
            for (var Q = F.call(y), L; !(L = Q.next()).done; )
              ee(L.value) && Ze(L.value, w);
        }
      }
    }
    function Lr(y) {
      {
        var w = y.type;
        if (w == null || typeof w == "string")
          return;
        var A;
        if (typeof w == "function")
          A = w.propTypes;
        else if (typeof w == "object" && (w.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        w.$$typeof === h))
          A = w.propTypes;
        else
          return;
        if (A) {
          var q = B(w);
          Dt(A, y.props, "prop", q, y);
        } else if (w.PropTypes !== void 0 && !Tt) {
          Tt = !0;
          var F = B(w);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", F || "Unknown");
        }
        typeof w.getDefaultProps == "function" && !w.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ur(y) {
      {
        for (var w = Object.keys(y.props), A = 0; A < w.length; A++) {
          var q = w[A];
          if (q !== "children" && q !== "key") {
            It(y), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), It(null);
            break;
          }
        }
        y.ref !== null && (It(y), S("Invalid attribute `ref` supplied to `React.Fragment`."), It(null));
      }
    }
    function re(y, w, A, q, F, Q) {
      {
        var L = j(y);
        if (!L) {
          var z = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var it = Ae(F);
          it ? z += it : z += ye();
          var J;
          y === null ? J = "null" : Et(y) ? J = "array" : y !== void 0 && y.$$typeof === e ? (J = "<" + (B(y.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : J = typeof y, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", J, z);
        }
        var K = Nr(y, w, A, F, Q);
        if (K == null)
          return K;
        if (L) {
          var ut = w.children;
          if (ut !== void 0)
            if (q)
              if (Et(ut)) {
                for (var Bt = 0; Bt < ut.length; Bt++)
                  Xe(ut[Bt], y);
                Object.freeze && Object.freeze(ut);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xe(ut, y);
        }
        return y === n ? Ur(K) : Lr(K), K;
      }
    }
    function De(y, w, A) {
      return re(y, w, A, !0);
    }
    function tr(y, w, A) {
      return re(y, w, A, !1);
    }
    var Pt = tr, Br = De;
    Gh.Fragment = n, Gh.jsx = Pt, Gh.jsxs = Br;
  }()), Gh;
}
process.env.NODE_ENV === "production" ? UN() : BN();
function Vd(t, e, r, n) {
  Object.defineProperty(t, e, { get: r, set: n, enumerable: !0, configurable: !0 });
}
var $N = {};
Vd($N, "ErrorBoundary", () => BR);
var KN = {};
Vd(KN, "ErrorBoundaryContext", () => Ig);
const Ig = Mr(null), cy = {
  didCatch: !1,
  error: null
};
class BR extends Pl {
  constructor() {
    super(...arguments), FE(this, "state", cy), FE(this, "resetErrorBoundary", (...e) => {
      var r, n;
      const { error: i } = this.state;
      i !== null && ((n = (r = this.props).onReset) == null || n.call(r, {
        args: e,
        reason: "imperative-api"
      }), this.setState(cy));
    });
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  componentDidCatch(e, r) {
    var n, i;
    (i = (n = this.props).onError) == null || i.call(n, e, r);
  }
  componentDidUpdate(e, r) {
    var n, i;
    const { didCatch: o } = this.state, { resetKeys: s } = this.props;
    o && r.error !== null && VN(e.resetKeys, s) && ((i = (n = this.props).onReset) == null || i.call(n, {
      next: s,
      prev: e.resetKeys,
      reason: "keys"
    }), this.setState(cy));
  }
  render() {
    const { children: e, fallbackRender: r, FallbackComponent: n, fallback: i } = this.props, { didCatch: o, error: s } = this.state;
    let u = e;
    if (o) {
      const c = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (kl(i))
        u = i;
      else if (typeof r == "function")
        u = r(c);
      else if (n)
        u = Tr(n, c);
      else
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return Tr(Ig.Provider, {
      value: {
        didCatch: o,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, u);
  }
}
function VN(t = [], e = []) {
  return t.length !== e.length || t.some((r, n) => !Object.is(r, e[n]));
}
var QN = {};
Vd(QN, "useErrorBoundary", () => GN);
function YN(t) {
  if (t == null || typeof t.didCatch != "boolean" || typeof t.resetErrorBoundary != "function")
    throw new Error("ErrorBoundaryContext not found");
  return !0;
}
function GN() {
  const t = ca(Ig);
  YN(t);
  const [e, r] = Jo({
    error: null,
    hasError: !1
  }), n = Zo(() => ({
    resetBoundary: () => {
      t == null || t.resetErrorBoundary(), r({
        error: null,
        hasError: !1
      });
    },
    showBoundary: (i) => r({
      error: i,
      hasError: !0
    })
  }), [
    t == null ? void 0 : t.resetErrorBoundary
  ]);
  if (e.hasError)
    throw e.error;
  return n;
}
var WN = {};
Vd(WN, "withErrorBoundary", () => HN);
function HN(t, e) {
  const r = Cl((i, o) => Tr(BR, e, Tr(t, {
    ...i,
    ref: o
  }))), n = t.displayName || t.name || "Unknown";
  return r.displayName = `withErrorBoundary(${n})`, r;
}
Mr({
  productKey: void 0,
  locationPathName: "",
  setLocationPathName: () => {
  },
  aptrinsic: () => {
  },
  logDebug: () => {
  },
  isInitialized: !1,
  initialize: () => {
  }
});
var Ag = /* @__PURE__ */ ((t) => (t.EN = "en", t.FR = "fr", t))(Ag || {});
class Qd {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    const r = {
      listener: e
    };
    return this.listeners.add(r), this.onSubscribe(), () => {
      this.listeners.delete(r), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const Dg = typeof window > "u" || "Deno" in window;
function mo() {
}
function JN(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ZN(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function XN(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function Wh(t, e, r) {
  return Yd(t) ? typeof e == "function" ? {
    ...r,
    queryKey: t,
    queryFn: e
  } : {
    ...e,
    queryKey: t
  } : t;
}
function ga(t, e, r) {
  return Yd(t) ? [{
    ...e,
    queryKey: t
  }, r] : [t || {}, e];
}
function BE(t, e) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: i,
    predicate: o,
    queryKey: s,
    stale: u
  } = t;
  if (Yd(s)) {
    if (n) {
      if (e.queryHash !== Rg(s, e.options))
        return !1;
    } else if (!Lu(e.queryKey, s))
      return !1;
  }
  if (r !== "all") {
    const c = e.isActive();
    if (r === "active" && !c || r === "inactive" && c)
      return !1;
  }
  return !(typeof u == "boolean" && e.isStale() !== u || typeof i < "u" && i !== e.state.fetchStatus || o && !o(e));
}
function $E(t, e) {
  const {
    exact: r,
    fetching: n,
    predicate: i,
    mutationKey: o
  } = t;
  if (Yd(o)) {
    if (!e.options.mutationKey)
      return !1;
    if (r) {
      if (nu(e.options.mutationKey) !== nu(o))
        return !1;
    } else if (!Lu(e.options.mutationKey, o))
      return !1;
  }
  return !(typeof n == "boolean" && e.state.status === "loading" !== n || i && !i(e));
}
function Rg(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || nu)(t);
}
function nu(t) {
  return JSON.stringify(t, (e, r) => w_(r) ? Object.keys(r).sort().reduce((n, i) => (n[i] = r[i], n), {}) : r);
}
function Lu(t, e) {
  return $R(t, e);
}
function $R(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((r) => !$R(t[r], e[r])) : !1;
}
function KR(t, e) {
  if (t === e)
    return t;
  const r = KE(t) && KE(e);
  if (r || w_(t) && w_(e)) {
    const n = r ? t.length : Object.keys(t).length, i = r ? e : Object.keys(e), o = i.length, s = r ? [] : {};
    let u = 0;
    for (let c = 0; c < o; c++) {
      const a = r ? c : i[c];
      s[a] = KR(t[a], e[a]), s[a] === t[a] && u++;
    }
    return n === o && u === n ? t : s;
  }
  return e;
}
function KE(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function w_(t) {
  if (!VE(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const r = e.prototype;
  return !(!VE(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function VE(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Yd(t) {
  return Array.isArray(t);
}
function VR(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function QE(t) {
  VR(0).then(t);
}
function tz() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function ez(t, e, r) {
  return r.isDataEqual != null && r.isDataEqual(t, e) ? t : typeof r.structuralSharing == "function" ? r.structuralSharing(t, e) : r.structuralSharing !== !1 ? KR(t, e) : e;
}
class rz extends Qd {
  constructor() {
    super(), this.setup = (e) => {
      if (!Dg && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("visibilitychange", r, !1), window.addEventListener("focus", r, !1), () => {
          window.removeEventListener("visibilitychange", r), window.removeEventListener("focus", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused = e, e && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const E_ = new rz();
class nz extends Qd {
  constructor() {
    super(), this.setup = (e) => {
      if (!Dg && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("online", r, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", r);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var r;
    this.setup = e, (r = this.cleanup) == null || r.call(this), this.cleanup = e((n) => {
      typeof n == "boolean" ? this.setOnline(n) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online = e, e && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const Up = new nz();
function iz(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function xg(t) {
  return (t ?? "online") === "online" ? Up.isOnline() : !0;
}
class QR {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
}
function fy(t) {
  return t instanceof QR;
}
function YR(t) {
  let e = !1, r = 0, n = !1, i, o, s;
  const u = new Promise((b, O) => {
    o = b, s = O;
  }), c = (b) => {
    n || (d(new QR(b)), t.abort == null || t.abort());
  }, a = () => {
    e = !0;
  }, f = () => {
    e = !1;
  }, h = () => !E_.isFocused() || t.networkMode !== "always" && !Up.isOnline(), p = (b) => {
    n || (n = !0, t.onSuccess == null || t.onSuccess(b), i == null || i(), o(b));
  }, d = (b) => {
    n || (n = !0, t.onError == null || t.onError(b), i == null || i(), s(b));
  }, _ = () => new Promise((b) => {
    i = (O) => {
      const S = n || !h();
      return S && b(O), S;
    }, t.onPause == null || t.onPause();
  }).then(() => {
    i = void 0, n || t.onContinue == null || t.onContinue();
  }), m = () => {
    if (n)
      return;
    let b;
    try {
      b = t.fn();
    } catch (O) {
      b = Promise.reject(O);
    }
    Promise.resolve(b).then(p).catch((O) => {
      var S, k;
      if (n)
        return;
      const T = (S = t.retry) != null ? S : 3, x = (k = t.retryDelay) != null ? k : iz, P = typeof x == "function" ? x(r, O) : x, R = T === !0 || typeof T == "number" && r < T || typeof T == "function" && T(r, O);
      if (e || !R) {
        d(O);
        return;
      }
      r++, t.onFail == null || t.onFail(r, O), VR(P).then(() => {
        if (h())
          return _();
      }).then(() => {
        e ? d(O) : m();
      });
    });
  };
  return xg(t.networkMode) ? m() : _().then(m), {
    promise: u,
    cancel: c,
    continue: () => i != null && i() ? u : Promise.resolve(),
    cancelRetry: a,
    continueRetry: f
  };
}
const Tg = console;
function oz() {
  let t = [], e = 0, r = (c) => {
    c();
  }, n = (c) => {
    c();
  };
  const i = (c) => {
    let a;
    e++;
    try {
      a = c();
    } finally {
      e--, e || u();
    }
    return a;
  }, o = (c) => {
    e ? t.push(c) : QE(() => {
      r(c);
    });
  }, s = (c) => (...a) => {
    o(() => {
      c(...a);
    });
  }, u = () => {
    const c = t;
    t = [], c.length && QE(() => {
      n(() => {
        c.forEach((a) => {
          r(a);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: s,
    schedule: o,
    setNotifyFunction: (c) => {
      r = c;
    },
    setBatchNotifyFunction: (c) => {
      n = c;
    }
  };
}
const Cn = oz();
class GR {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), ZN(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (Dg ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class sz extends GR {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || Tg, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || az(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, r) {
    const n = ez(this.state.data, e, this.options);
    return this.dispatch({
      data: n,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), n;
  }
  setState(e, r) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: r
    });
  }
  cancel(e) {
    var r;
    const n = this.promise;
    return (r = this.retryer) == null || r.cancel(e), n ? n.then(mo).catch(mo) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !XN(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const r = this.observers.find((n) => n.shouldFetchOnReconnect());
    r && r.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.indexOf(e) !== -1 && (this.observers = this.observers.filter((r) => r !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, r) {
    var n, i;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && r != null && r.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var o;
        return (o = this.retryer) == null || o.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const d = this.observers.find((_) => _.options.queryFn);
      d && this.setOptions(d.options);
    }
    Array.isArray(this.options.queryKey) || process.env.NODE_ENV !== "production" && this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
    const s = tz(), u = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, c = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => {
          if (s)
            return this.abortSignalConsumed = !0, s.signal;
        }
      });
    };
    c(u);
    const a = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(u)) : Promise.reject("Missing queryFn"), f = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: a
    };
    if (c(f), (n = this.options.behavior) == null || n.onFetch(f), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((i = f.fetchOptions) == null ? void 0 : i.meta)) {
      var h;
      this.dispatch({
        type: "fetch",
        meta: (h = f.fetchOptions) == null ? void 0 : h.meta
      });
    }
    const p = (d) => {
      if (fy(d) && d.silent || this.dispatch({
        type: "error",
        error: d
      }), !fy(d)) {
        var _, m, b, O;
        (_ = (m = this.cache.config).onError) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, this.state.data, d, this), process.env.NODE_ENV !== "production" && this.logger.error(d);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = YR({
      fn: f.fetchFn,
      abort: s == null ? void 0 : s.abort.bind(s),
      onSuccess: (d) => {
        var _, m, b, O;
        if (typeof d > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), p(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(d), (_ = (m = this.cache.config).onSuccess) == null || _.call(m, d, this), (b = (O = this.cache.config).onSettled) == null || b.call(O, d, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: p,
      onFail: (d, _) => {
        this.dispatch({
          type: "failed",
          failureCount: d,
          error: _
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: f.options.retry,
      retryDelay: f.options.retryDelay,
      networkMode: f.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const r = (n) => {
      var i, o;
      switch (e.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (i = e.meta) != null ? i : null,
            fetchStatus: xg(this.options.networkMode) ? "fetching" : "paused",
            ...!n.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...n,
            data: e.data,
            dataUpdateCount: n.dataUpdateCount + 1,
            dataUpdatedAt: (o = e.dataUpdatedAt) != null ? o : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const s = e.error;
          return fy(s) && s.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...n,
            error: s,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: s,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), Cn.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
}
function az(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = typeof e < "u", n = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class uz extends Qd {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, r, n) {
    var i;
    const o = r.queryKey, s = (i = r.queryHash) != null ? i : Rg(o, r);
    let u = this.get(s);
    return u || (u = new sz({
      cache: this,
      logger: e.getLogger(),
      queryKey: o,
      queryHash: s,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(o)
    }), this.add(u)), u;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = this.queriesMap[e.queryHash];
    r && (e.destroy(), this.queries = this.queries.filter((n) => n !== e), r === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    Cn.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  find(e, r) {
    const [n] = ga(e, r);
    return typeof n.exact > "u" && (n.exact = !0), this.queries.find((i) => BE(n, i));
  }
  findAll(e, r) {
    const [n] = ga(e, r);
    return Object.keys(n).length > 0 ? this.queries.filter((i) => BE(n, i)) : this.queries;
  }
  notify(e) {
    Cn.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  onFocus() {
    Cn.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    Cn.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
class cz extends GR {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || Tg, this.observers = [], this.state = e.state || fz(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.indexOf(e) === -1 && (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((r) => r !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, r;
    return (e = (r = this.retryer) == null ? void 0 : r.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var R;
      return this.retryer = YR({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (D, I) => {
          this.dispatch({
            type: "failed",
            failureCount: D,
            error: I
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (R = this.options.retry) != null ? R : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, r = this.state.status === "loading";
    try {
      var n, i, o, s, u, c, a, f;
      if (!r) {
        var h, p, d, _;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((h = (p = this.mutationCache.config).onMutate) == null ? void 0 : h.call(p, this.state.variables, this));
        const D = await ((d = (_ = this.options).onMutate) == null ? void 0 : d.call(_, this.state.variables));
        D !== this.state.context && this.dispatch({
          type: "loading",
          context: D,
          variables: this.state.variables
        });
      }
      const R = await e();
      return await ((n = (i = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(i, R, this.state.variables, this.state.context, this)), await ((o = (s = this.options).onSuccess) == null ? void 0 : o.call(s, R, this.state.variables, this.state.context)), await ((u = (c = this.mutationCache.config).onSettled) == null ? void 0 : u.call(c, R, null, this.state.variables, this.state.context, this)), await ((a = (f = this.options).onSettled) == null ? void 0 : a.call(f, R, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: R
      }), R;
    } catch (R) {
      try {
        var m, b, O, S, k, T, x, P;
        throw await ((m = (b = this.mutationCache.config).onError) == null ? void 0 : m.call(b, R, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(R), await ((O = (S = this.options).onError) == null ? void 0 : O.call(S, R, this.state.variables, this.state.context)), await ((k = (T = this.mutationCache.config).onSettled) == null ? void 0 : k.call(T, void 0, R, this.state.variables, this.state.context, this)), await ((x = (P = this.options).onSettled) == null ? void 0 : x.call(P, void 0, R, this.state.variables, this.state.context)), R;
      } finally {
        this.dispatch({
          type: "error",
          error: R
        });
      }
    }
  }
  dispatch(e) {
    const r = (n) => {
      switch (e.type) {
        case "failed":
          return {
            ...n,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "loading":
          return {
            ...n,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !xg(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...n,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: e.error,
            failureCount: n.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...n,
            ...e.state
          };
      }
    };
    this.state = r(this.state), Cn.batch(() => {
      this.observers.forEach((n) => {
        n.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function fz() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class lz extends Qd {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, r, n) {
    const i = new cz({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(r),
      state: n,
      defaultOptions: r.mutationKey ? e.getMutationDefaults(r.mutationKey) : void 0
    });
    return this.add(i), i;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((r) => r !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    Cn.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((r) => $E(e, r));
  }
  findAll(e) {
    return this.mutations.filter((r) => $E(e, r));
  }
  notify(e) {
    Cn.batch(() => {
      this.listeners.forEach(({
        listener: r
      }) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const r = this.mutations.filter((n) => n.state.isPaused);
      return Cn.batch(() => r.reduce((n, i) => n.then(() => i.continue().catch(mo)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function hz() {
  return {
    onFetch: (t) => {
      t.fetchFn = () => {
        var e, r, n, i, o, s;
        const u = (e = t.fetchOptions) == null || (r = e.meta) == null ? void 0 : r.refetchPage, c = (n = t.fetchOptions) == null || (i = n.meta) == null ? void 0 : i.fetchMore, a = c == null ? void 0 : c.pageParam, f = (c == null ? void 0 : c.direction) === "forward", h = (c == null ? void 0 : c.direction) === "backward", p = ((o = t.state.data) == null ? void 0 : o.pages) || [], d = ((s = t.state.data) == null ? void 0 : s.pageParams) || [];
        let _ = d, m = !1;
        const b = (x) => {
          Object.defineProperty(x, "signal", {
            enumerable: !0,
            get: () => {
              var P;
              if ((P = t.signal) != null && P.aborted)
                m = !0;
              else {
                var R;
                (R = t.signal) == null || R.addEventListener("abort", () => {
                  m = !0;
                });
              }
              return t.signal;
            }
          });
        }, O = t.options.queryFn || (() => Promise.reject("Missing queryFn")), S = (x, P, R, D) => (_ = D ? [P, ..._] : [..._, P], D ? [R, ...x] : [...x, R]), k = (x, P, R, D) => {
          if (m)
            return Promise.reject("Cancelled");
          if (typeof R > "u" && !P && x.length)
            return Promise.resolve(x);
          const I = {
            queryKey: t.queryKey,
            pageParam: R,
            meta: t.options.meta
          };
          b(I);
          const j = O(I);
          return Promise.resolve(j).then((Y) => S(x, R, Y, D));
        };
        let T;
        if (!p.length)
          T = k([]);
        else if (f) {
          const x = typeof a < "u", P = x ? a : YE(t.options, p);
          T = k(p, x, P);
        } else if (h) {
          const x = typeof a < "u", P = x ? a : pz(t.options, p);
          T = k(p, x, P, !0);
        } else {
          _ = [];
          const x = typeof t.options.getNextPageParam > "u";
          T = !(u && p[0]) || u(p[0], 0, p) ? k([], x, d[0]) : Promise.resolve(S([], d[0], p[0]));
          for (let P = 1; P < p.length; P++)
            T = T.then((R) => {
              if (!(u && p[P]) || u(p[P], P, p)) {
                const D = x ? d[P] : YE(t.options, R);
                return k(R, x, D);
              }
              return Promise.resolve(S(R, d[P], p[P]));
            });
        }
        return T.then((x) => ({
          pages: x,
          pageParams: _
        }));
      };
    }
  };
}
function YE(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}
function pz(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}
class dz {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new uz(), this.mutationCache = e.mutationCache || new lz(), this.logger = e.logger || Tg, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && e.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = E_.subscribe(() => {
      E_.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = Up.subscribe(() => {
      Up.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, r;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (r = this.unsubscribeOnline) == null || r.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(e, r) {
    const [n] = ga(e, r);
    return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  getQueryData(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e, r, n) {
    const i = Wh(e, r, n), o = this.getQueryData(i.queryKey);
    return o ? Promise.resolve(o) : this.fetchQuery(i);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: r,
      state: n
    }) => {
      const i = n.data;
      return [r, i];
    });
  }
  setQueryData(e, r, n) {
    const i = this.queryCache.find(e), o = i == null ? void 0 : i.state.data, s = JN(r, o);
    if (typeof s > "u")
      return;
    const u = Wh(e), c = this.defaultQueryOptions(u);
    return this.queryCache.build(this, c).setData(s, {
      ...n,
      manual: !0
    });
  }
  setQueriesData(e, r, n) {
    return Cn.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: i
    }) => [i, this.setQueryData(i, r, n)]));
  }
  getQueryState(e, r) {
    var n;
    return (n = this.queryCache.find(e, r)) == null ? void 0 : n.state;
  }
  removeQueries(e, r) {
    const [n] = ga(e, r), i = this.queryCache;
    Cn.batch(() => {
      i.findAll(n).forEach((o) => {
        i.remove(o);
      });
    });
  }
  resetQueries(e, r, n) {
    const [i, o] = ga(e, r, n), s = this.queryCache, u = {
      type: "active",
      ...i
    };
    return Cn.batch(() => (s.findAll(i).forEach((c) => {
      c.reset();
    }), this.refetchQueries(u, o)));
  }
  cancelQueries(e, r, n) {
    const [i, o = {}] = ga(e, r, n);
    typeof o.revert > "u" && (o.revert = !0);
    const s = Cn.batch(() => this.queryCache.findAll(i).map((u) => u.cancel(o)));
    return Promise.all(s).then(mo).catch(mo);
  }
  invalidateQueries(e, r, n) {
    const [i, o] = ga(e, r, n);
    return Cn.batch(() => {
      var s, u;
      if (this.queryCache.findAll(i).forEach((a) => {
        a.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const c = {
        ...i,
        type: (s = (u = i.refetchType) != null ? u : i.type) != null ? s : "active"
      };
      return this.refetchQueries(c, o);
    });
  }
  refetchQueries(e, r, n) {
    const [i, o] = ga(e, r, n), s = Cn.batch(() => this.queryCache.findAll(i).filter((c) => !c.isDisabled()).map((c) => {
      var a;
      return c.fetch(void 0, {
        ...o,
        cancelRefetch: (a = o == null ? void 0 : o.cancelRefetch) != null ? a : !0,
        meta: {
          refetchPage: i.refetchPage
        }
      });
    }));
    let u = Promise.all(s).then(mo);
    return o != null && o.throwOnError || (u = u.catch(mo)), u;
  }
  fetchQuery(e, r, n) {
    const i = Wh(e, r, n), o = this.defaultQueryOptions(i);
    typeof o.retry > "u" && (o.retry = !1);
    const s = this.queryCache.build(this, o);
    return s.isStaleByTime(o.staleTime) ? s.fetch(o) : Promise.resolve(s.state.data);
  }
  prefetchQuery(e, r, n) {
    return this.fetchQuery(e, r, n).then(mo).catch(mo);
  }
  fetchInfiniteQuery(e, r, n) {
    const i = Wh(e, r, n);
    return i.behavior = hz(), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(e, r, n) {
    return this.fetchInfiniteQuery(e, r, n).then(mo).catch(mo);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, r) {
    const n = this.queryDefaults.find((i) => nu(e) === nu(i.queryKey));
    n ? n.defaultOptions = r : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: r
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const r = this.queryDefaults.find((n) => Lu(e, n.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((n) => Lu(e, n.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(e) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), r == null ? void 0 : r.defaultOptions;
  }
  setMutationDefaults(e, r) {
    const n = this.mutationDefaults.find((i) => nu(e) === nu(i.mutationKey));
    n ? n.defaultOptions = r : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: r
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const r = this.mutationDefaults.find((n) => Lu(e, n.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((n) => Lu(e, n.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(e) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), r == null ? void 0 : r.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const r = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e == null ? void 0 : e.queryKey),
      ...e,
      _defaulted: !0
    };
    return !r.queryHash && r.queryKey && (r.queryHash = Rg(r.queryKey, r)), typeof r.refetchOnReconnect > "u" && (r.refetchOnReconnect = r.networkMode !== "always"), typeof r.useErrorBoundary > "u" && (r.useErrorBoundary = !!r.suspense), r;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e == null ? void 0 : e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
var S_ = { exports: {} }, ly = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var GE;
function vz() {
  if (GE)
    return ly;
  GE = 1;
  var t = Se;
  function e(h, p) {
    return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, i = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
  function u(h, p) {
    var d = p(), _ = n({ inst: { value: d, getSnapshot: p } }), m = _[0].inst, b = _[1];
    return o(function() {
      m.value = d, m.getSnapshot = p, c(m) && b({ inst: m });
    }, [h, d, p]), i(function() {
      return c(m) && b({ inst: m }), h(function() {
        c(m) && b({ inst: m });
      });
    }, [h]), s(d), d;
  }
  function c(h) {
    var p = h.getSnapshot;
    h = h.value;
    try {
      var d = p();
      return !r(h, d);
    } catch {
      return !0;
    }
  }
  function a(h, p) {
    return p();
  }
  var f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : u;
  return ly.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : f, ly;
}
var WE = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var HE;
function yz() {
  return HE || (HE = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Se, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(k) {
      {
        for (var T = arguments.length, x = new Array(T > 1 ? T - 1 : 0), P = 1; P < T; P++)
          x[P - 1] = arguments[P];
        n("error", k, x);
      }
    }
    function n(k, T, x) {
      {
        var P = e.ReactDebugCurrentFrame, R = P.getStackAddendum();
        R !== "" && (T += "%s", x = x.concat([R]));
        var D = x.map(function(I) {
          return String(I);
        });
        D.unshift("Warning: " + T), Function.prototype.apply.call(console[k], console, D);
      }
    }
    function i(k, T) {
      return k === T && (k !== 0 || 1 / k === 1 / T) || k !== k && T !== T;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = t.useState, u = t.useEffect, c = t.useLayoutEffect, a = t.useDebugValue, f = !1, h = !1;
    function p(k, T, x) {
      f || t.startTransition !== void 0 && (f = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var P = T();
      if (!h) {
        var R = T();
        o(P, R) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), h = !0);
      }
      var D = s({
        inst: {
          value: P,
          getSnapshot: T
        }
      }), I = D[0].inst, j = D[1];
      return c(function() {
        I.value = P, I.getSnapshot = T, d(I) && j({
          inst: I
        });
      }, [k, P, T]), u(function() {
        d(I) && j({
          inst: I
        });
        var Y = function() {
          d(I) && j({
            inst: I
          });
        };
        return k(Y);
      }, [k]), a(P), P;
    }
    function d(k) {
      var T = k.getSnapshot, x = k.value;
      try {
        var P = T();
        return !o(x, P);
      } catch {
        return !0;
      }
    }
    function _(k, T, x) {
      return T();
    }
    var m = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", b = !m, O = b ? _ : p, S = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : O;
    WE.useSyncExternalStore = S, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), WE;
}
process.env.NODE_ENV === "production" ? S_.exports = vz() : S_.exports = yz();
var _z = S_.exports;
_z.useSyncExternalStore;
const mz = /* @__PURE__ */ Yr.createContext(!1);
mz.Provider;
new dz();
Mr(void 0);
function Iu(t) {
  function e(r, n) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = r, this.code = n;
  }
  return e.prototype = new Error(), e.prototype.name = t, e.prototype.constructor = e, e;
}
const gz = Iu("LaunchDarklyUnexpectedResponseError"), bz = Iu("LaunchDarklyInvalidEnvironmentIdError"), wz = Iu("LaunchDarklyInvalidUserError"), Ez = Iu("LaunchDarklyInvalidEventKeyError"), Sz = Iu("LaunchDarklyInvalidArgumentError"), Oz = Iu("LaunchDarklyFlagFetchError");
for (var XB = { LDUnexpectedResponseError: gz, LDInvalidEnvironmentIdError: bz, LDInvalidUserError: wz, LDInvalidEventKeyError: Ez, LDInvalidArgumentError: Sz, LDInvalidDataError: Iu("LaunchDarklyInvalidDataError"), LDFlagFetchError: Oz, isHttpErrorRecoverable: function(t) {
  return !(t >= 400 && t < 500) || t === 400 || t === 408 || t === 429;
} }, t$ = function(t) {
  var e = JE(t), r = e[0], n = e[1];
  return 3 * (r + n) / 4 - n;
}, e$ = function(t) {
  var e, r, n = JE(t), i = n[0], o = n[1], s = new Iz(function(a, f, h) {
    return 3 * (f + h) / 4 - h;
  }(0, i, o)), u = 0, c = o > 0 ? i - 4 : i;
  for (r = 0; r < c; r += 4)
    e = Li[t.charCodeAt(r)] << 18 | Li[t.charCodeAt(r + 1)] << 12 | Li[t.charCodeAt(r + 2)] << 6 | Li[t.charCodeAt(r + 3)], s[u++] = e >> 16 & 255, s[u++] = e >> 8 & 255, s[u++] = 255 & e;
  return o === 2 && (e = Li[t.charCodeAt(r)] << 2 | Li[t.charCodeAt(r + 1)] >> 4, s[u++] = 255 & e), o === 1 && (e = Li[t.charCodeAt(r)] << 10 | Li[t.charCodeAt(r + 1)] << 4 | Li[t.charCodeAt(r + 2)] >> 2, s[u++] = e >> 8 & 255, s[u++] = 255 & e), s;
}, r$ = function(t) {
  for (var e, r = t.length, n = r % 3, i = [], o = 16383, s = 0, u = r - n; s < u; s += o)
    i.push(Dz(t, s, s + o > u ? u : s + o));
  return n === 1 ? (e = t[r - 1], i.push(Ko[e >> 2] + Ko[e << 4 & 63] + "==")) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(Ko[e >> 10] + Ko[e >> 4 & 63] + Ko[e << 2 & 63] + "=")), i.join("");
}, Ko = [], Li = [], Iz = typeof Uint8Array < "u" ? Uint8Array : Array, hy = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ju = 0, Az = hy.length; ju < Az; ++ju)
  Ko[ju] = hy[ju], Li[hy.charCodeAt(ju)] = ju;
function JE(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  return r === -1 && (r = e), [r, r === e ? 0 : 4 - r % 4];
}
function Dz(t, e, r) {
  for (var n, i, o = [], s = e; s < r; s += 3)
    n = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), o.push(Ko[(i = n) >> 18 & 63] + Ko[i >> 12 & 63] + Ko[i >> 6 & 63] + Ko[63 & i]);
  return o.join("");
}
Li["-".charCodeAt(0)] = 62, Li["_".charCodeAt(0)] = 63;
var Rz = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function WR(t) {
  return typeof t == "string" && Rz.test(t);
}
for (var n$, i$, Zr = [], py = 0; py < 256; ++py)
  Zr.push((py + 256).toString(16).substr(1));
function xz(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Zr[t[e + 0]] + Zr[t[e + 1]] + Zr[t[e + 2]] + Zr[t[e + 3]] + "-" + Zr[t[e + 4]] + Zr[t[e + 5]] + "-" + Zr[t[e + 6]] + Zr[t[e + 7]] + "-" + Zr[t[e + 8]] + Zr[t[e + 9]] + "-" + Zr[t[e + 10]] + Zr[t[e + 11]] + Zr[t[e + 12]] + Zr[t[e + 13]] + Zr[t[e + 14]] + Zr[t[e + 15]]).toLowerCase();
  if (!WR(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function Tz(t) {
  if (!WR(t))
    throw TypeError("Invalid UUID");
  var e, r = new Uint8Array(16);
  return r[0] = (e = parseInt(t.slice(0, 8), 16)) >>> 24, r[1] = e >>> 16 & 255, r[2] = e >>> 8 & 255, r[3] = 255 & e, r[4] = (e = parseInt(t.slice(9, 13), 16)) >>> 8, r[5] = 255 & e, r[6] = (e = parseInt(t.slice(14, 18), 16)) >>> 8, r[7] = 255 & e, r[8] = (e = parseInt(t.slice(19, 23), 16)) >>> 8, r[9] = 255 & e, r[10] = (e = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = e / 4294967296 & 255, r[12] = e >>> 24 & 255, r[13] = e >>> 16 & 255, r[14] = e >>> 8 & 255, r[15] = 255 & e, r;
}
function HR(t, e, r) {
  function n(i, o, s, u) {
    if (typeof i == "string" && (i = function(f) {
      f = unescape(encodeURIComponent(f));
      for (var h = [], p = 0; p < f.length; ++p)
        h.push(f.charCodeAt(p));
      return h;
    }(i)), typeof o == "string" && (o = Tz(o)), o.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var c = new Uint8Array(16 + i.length);
    if (c.set(o), c.set(i, o.length), (c = r(c))[6] = 15 & c[6] | e, c[8] = 63 & c[8] | 128, s) {
      u = u || 0;
      for (var a = 0; a < 16; ++a)
        s[u + a] = c[a];
      return s;
    }
    return xz(c);
  }
  try {
    n.name = t;
  } catch {
  }
  return n.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", n.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", n;
}
function ZE(t) {
  return 14 + (t + 64 >>> 9 << 4) + 1;
}
function Ia(t, e) {
  var r = (65535 & t) + (65535 & e);
  return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
}
function Gd(t, e, r, n, i, o) {
  return Ia((s = Ia(Ia(e, t), Ia(n, o))) << (u = i) | s >>> 32 - u, r);
  var s, u;
}
function wn(t, e, r, n, i, o, s) {
  return Gd(e & r | ~e & n, t, e, i, o, s);
}
function En(t, e, r, n, i, o, s) {
  return Gd(e & n | r & ~n, t, e, i, o, s);
}
function Sn(t, e, r, n, i, o, s) {
  return Gd(e ^ r ^ n, t, e, i, o, s);
}
function On(t, e, r, n, i, o, s) {
  return Gd(r ^ (e | ~n), t, e, i, o, s);
}
HR("v3", 48, function(t) {
  if (typeof t == "string") {
    var e = unescape(encodeURIComponent(t));
    t = new Uint8Array(e.length);
    for (var r = 0; r < e.length; ++r)
      t[r] = e.charCodeAt(r);
  }
  return function(n) {
    for (var i = [], o = 32 * n.length, s = "0123456789abcdef", u = 0; u < o; u += 8) {
      var c = n[u >> 5] >>> u % 32 & 255, a = parseInt(s.charAt(c >>> 4 & 15) + s.charAt(15 & c), 16);
      i.push(a);
    }
    return i;
  }(function(n, i) {
    n[i >> 5] |= 128 << i % 32, n[ZE(i) - 1] = i;
    for (var o = 1732584193, s = -271733879, u = -1732584194, c = 271733878, a = 0; a < n.length; a += 16) {
      var f = o, h = s, p = u, d = c;
      o = wn(o, s, u, c, n[a], 7, -680876936), c = wn(c, o, s, u, n[a + 1], 12, -389564586), u = wn(u, c, o, s, n[a + 2], 17, 606105819), s = wn(s, u, c, o, n[a + 3], 22, -1044525330), o = wn(o, s, u, c, n[a + 4], 7, -176418897), c = wn(c, o, s, u, n[a + 5], 12, 1200080426), u = wn(u, c, o, s, n[a + 6], 17, -1473231341), s = wn(s, u, c, o, n[a + 7], 22, -45705983), o = wn(o, s, u, c, n[a + 8], 7, 1770035416), c = wn(c, o, s, u, n[a + 9], 12, -1958414417), u = wn(u, c, o, s, n[a + 10], 17, -42063), s = wn(s, u, c, o, n[a + 11], 22, -1990404162), o = wn(o, s, u, c, n[a + 12], 7, 1804603682), c = wn(c, o, s, u, n[a + 13], 12, -40341101), u = wn(u, c, o, s, n[a + 14], 17, -1502002290), o = En(o, s = wn(s, u, c, o, n[a + 15], 22, 1236535329), u, c, n[a + 1], 5, -165796510), c = En(c, o, s, u, n[a + 6], 9, -1069501632), u = En(u, c, o, s, n[a + 11], 14, 643717713), s = En(s, u, c, o, n[a], 20, -373897302), o = En(o, s, u, c, n[a + 5], 5, -701558691), c = En(c, o, s, u, n[a + 10], 9, 38016083), u = En(u, c, o, s, n[a + 15], 14, -660478335), s = En(s, u, c, o, n[a + 4], 20, -405537848), o = En(o, s, u, c, n[a + 9], 5, 568446438), c = En(c, o, s, u, n[a + 14], 9, -1019803690), u = En(u, c, o, s, n[a + 3], 14, -187363961), s = En(s, u, c, o, n[a + 8], 20, 1163531501), o = En(o, s, u, c, n[a + 13], 5, -1444681467), c = En(c, o, s, u, n[a + 2], 9, -51403784), u = En(u, c, o, s, n[a + 7], 14, 1735328473), o = Sn(o, s = En(s, u, c, o, n[a + 12], 20, -1926607734), u, c, n[a + 5], 4, -378558), c = Sn(c, o, s, u, n[a + 8], 11, -2022574463), u = Sn(u, c, o, s, n[a + 11], 16, 1839030562), s = Sn(s, u, c, o, n[a + 14], 23, -35309556), o = Sn(o, s, u, c, n[a + 1], 4, -1530992060), c = Sn(c, o, s, u, n[a + 4], 11, 1272893353), u = Sn(u, c, o, s, n[a + 7], 16, -155497632), s = Sn(s, u, c, o, n[a + 10], 23, -1094730640), o = Sn(o, s, u, c, n[a + 13], 4, 681279174), c = Sn(c, o, s, u, n[a], 11, -358537222), u = Sn(u, c, o, s, n[a + 3], 16, -722521979), s = Sn(s, u, c, o, n[a + 6], 23, 76029189), o = Sn(o, s, u, c, n[a + 9], 4, -640364487), c = Sn(c, o, s, u, n[a + 12], 11, -421815835), u = Sn(u, c, o, s, n[a + 15], 16, 530742520), o = On(o, s = Sn(s, u, c, o, n[a + 2], 23, -995338651), u, c, n[a], 6, -198630844), c = On(c, o, s, u, n[a + 7], 10, 1126891415), u = On(u, c, o, s, n[a + 14], 15, -1416354905), s = On(s, u, c, o, n[a + 5], 21, -57434055), o = On(o, s, u, c, n[a + 12], 6, 1700485571), c = On(c, o, s, u, n[a + 3], 10, -1894986606), u = On(u, c, o, s, n[a + 10], 15, -1051523), s = On(s, u, c, o, n[a + 1], 21, -2054922799), o = On(o, s, u, c, n[a + 8], 6, 1873313359), c = On(c, o, s, u, n[a + 15], 10, -30611744), u = On(u, c, o, s, n[a + 6], 15, -1560198380), s = On(s, u, c, o, n[a + 13], 21, 1309151649), o = On(o, s, u, c, n[a + 4], 6, -145523070), c = On(c, o, s, u, n[a + 11], 10, -1120210379), u = On(u, c, o, s, n[a + 2], 15, 718787259), s = On(s, u, c, o, n[a + 9], 21, -343485551), o = Ia(o, f), s = Ia(s, h), u = Ia(u, p), c = Ia(c, d);
    }
    return [o, s, u, c];
  }(function(n) {
    if (n.length === 0)
      return [];
    for (var i = 8 * n.length, o = new Uint32Array(ZE(i)), s = 0; s < i; s += 8)
      o[s >> 5] |= (255 & n[s / 8]) << s % 32;
    return o;
  }(t), 8 * t.length));
});
function Pz(t, e, r, n) {
  switch (t) {
    case 0:
      return e & r ^ ~e & n;
    case 1:
    case 3:
      return e ^ r ^ n;
    case 2:
      return e & r ^ e & n ^ r & n;
  }
}
function dy(t, e) {
  return t << e | t >>> 32 - e;
}
HR("v5", 80, function(t) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var n = unescape(encodeURIComponent(t));
    t = [];
    for (var i = 0; i < n.length; ++i)
      t.push(n.charCodeAt(i));
  } else
    Array.isArray(t) || (t = Array.prototype.slice.call(t));
  t.push(128);
  for (var o = t.length / 4 + 2, s = Math.ceil(o / 16), u = new Array(s), c = 0; c < s; ++c) {
    for (var a = new Uint32Array(16), f = 0; f < 16; ++f)
      a[f] = t[64 * c + 4 * f] << 24 | t[64 * c + 4 * f + 1] << 16 | t[64 * c + 4 * f + 2] << 8 | t[64 * c + 4 * f + 3];
    u[c] = a;
  }
  u[s - 1][14] = 8 * (t.length - 1) / Math.pow(2, 32), u[s - 1][14] = Math.floor(u[s - 1][14]), u[s - 1][15] = 8 * (t.length - 1) & 4294967295;
  for (var h = 0; h < s; ++h) {
    for (var p = new Uint32Array(80), d = 0; d < 16; ++d)
      p[d] = u[h][d];
    for (var _ = 16; _ < 80; ++_)
      p[_] = dy(p[_ - 3] ^ p[_ - 8] ^ p[_ - 14] ^ p[_ - 16], 1);
    for (var m = r[0], b = r[1], O = r[2], S = r[3], k = r[4], T = 0; T < 80; ++T) {
      var x = Math.floor(T / 20), P = dy(m, 5) + Pz(x, b, O, S) + k + e[x] + p[T] >>> 0;
      k = S, S = O, O = dy(b, 30) >>> 0, b = m, m = P;
    }
    r[0] = r[0] + m >>> 0, r[1] = r[1] + b >>> 0, r[2] = r[2] + O >>> 0, r[3] = r[3] + S >>> 0, r[4] = r[4] + k >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, 255 & r[0], r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, 255 & r[1], r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, 255 & r[2], r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, 255 & r[3], r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, 255 & r[4]];
});
Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null });
const kz = (t, e) => e ?? !1;
Se.createContext({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  checkFlag: kz
});
var fh = "delete", $e = 5, eo = 1 << $e, Nn = eo - 1, ve = {};
function O_() {
  return { value: !1 };
}
function ro(t) {
  t && (t.value = !0);
}
function Pg() {
}
function gc(t) {
  return t.size === void 0 && (t.size = t.__iterate(JR)), t.size;
}
function za(t, e) {
  if (typeof e != "number") {
    var r = e >>> 0;
    if ("" + r !== e || r === 4294967295)
      return NaN;
    e = r;
  }
  return e < 0 ? gc(t) + e : e;
}
function JR() {
  return !0;
}
function Wd(t, e, r) {
  return (t === 0 && !XR(t) || r !== void 0 && t <= -r) && (e === void 0 || r !== void 0 && e >= r);
}
function lh(t, e) {
  return ZR(t, e, 0);
}
function Hd(t, e) {
  return ZR(t, e, e);
}
function ZR(t, e, r) {
  return t === void 0 ? r : XR(t) ? e === 1 / 0 ? e : Math.max(0, e + t) | 0 : e === void 0 || e === t ? t : Math.min(e, t) | 0;
}
function XR(t) {
  return t < 0 || t === 0 && 1 / t === -1 / 0;
}
var tx = "@@__IMMUTABLE_ITERABLE__@@";
function vi(t) {
  return !!(t && t[tx]);
}
var ex = "@@__IMMUTABLE_KEYED__@@";
function yr(t) {
  return !!(t && t[ex]);
}
var rx = "@@__IMMUTABLE_INDEXED__@@";
function si(t) {
  return !!(t && t[rx]);
}
function Jd(t) {
  return yr(t) || si(t);
}
var Dr = function(t) {
  return vi(t) ? t : Pi(t);
}, po = /* @__PURE__ */ function(t) {
  function e(r) {
    return yr(r) ? r : Va(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Dr), Au = /* @__PURE__ */ function(t) {
  function e(r) {
    return si(r) ? r : zo(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Dr), of = /* @__PURE__ */ function(t) {
  function e(r) {
    return vi(r) && !Jd(r) ? r : cf(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}(Dr);
Dr.Keyed = po;
Dr.Indexed = Au;
Dr.Set = of;
var nx = "@@__IMMUTABLE_SEQ__@@";
function kg(t) {
  return !!(t && t[nx]);
}
var ix = "@@__IMMUTABLE_RECORD__@@";
function sf(t) {
  return !!(t && t[ix]);
}
function as(t) {
  return vi(t) || sf(t);
}
var af = "@@__IMMUTABLE_ORDERED__@@";
function xo(t) {
  return !!(t && t[af]);
}
var hh = 0, jo = 1, uo = 2, I_ = typeof Symbol == "function" && Symbol.iterator, ox = "@@iterator", Zd = I_ || ox, Ee = function(t) {
  this.next = t;
};
Ee.prototype.toString = function() {
  return "[Iterator]";
};
Ee.KEYS = hh;
Ee.VALUES = jo;
Ee.ENTRIES = uo;
Ee.prototype.inspect = Ee.prototype.toSource = function() {
  return this.toString();
};
Ee.prototype[Zd] = function() {
  return this;
};
function wr(t, e, r, n) {
  var i = t === 0 ? e : t === 1 ? r : [e, r];
  return n ? n.value = i : n = {
    value: i,
    done: !1
  }, n;
}
function yi() {
  return { value: void 0, done: !0 };
}
function sx(t) {
  return Array.isArray(t) ? !0 : !!Xd(t);
}
function XE(t) {
  return t && typeof t.next == "function";
}
function A_(t) {
  var e = Xd(t);
  return e && e.call(t);
}
function Xd(t) {
  var e = t && (I_ && t[I_] || t[ox]);
  if (typeof e == "function")
    return e;
}
function Cz(t) {
  var e = Xd(t);
  return e && e === t.entries;
}
function jz(t) {
  var e = Xd(t);
  return e && e === t.keys;
}
var uf = Object.prototype.hasOwnProperty;
function ax(t) {
  return Array.isArray(t) || typeof t == "string" ? !0 : t && typeof t == "object" && Number.isInteger(t.length) && t.length >= 0 && (t.length === 0 ? (
    // Only {length: 0} is considered Array-like.
    Object.keys(t).length === 1
  ) : (
    // An object is only Array-like if it has a property where the last value
    // in the array-like may be found (which could be undefined).
    t.hasOwnProperty(t.length - 1)
  ));
}
var Pi = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? jg() : as(r) ? r.toSeq() : Mz(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, e.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, e.prototype.__iterate = function(r, n) {
    var i = this._cache;
    if (i) {
      for (var o = i.length, s = 0; s !== o; ) {
        var u = i[n ? o - ++s : s++];
        if (r(u[1], u[0], this) === !1)
          break;
      }
      return s;
    }
    return this.__iterateUncached(r, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._cache;
    if (i) {
      var o = i.length, s = 0;
      return new Ee(function() {
        if (s === o)
          return yi();
        var u = i[n ? o - ++s : s++];
        return wr(r, u[0], u[1]);
      });
    }
    return this.__iteratorUncached(r, n);
  }, e;
}(Dr), Va = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? jg().toKeyedSeq() : vi(r) ? yr(r) ? r.toSeq() : r.fromEntrySeq() : sf(r) ? r.toSeq() : qg(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toKeyedSeq = function() {
    return this;
  }, e;
}(Pi), zo = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? jg() : vi(r) ? yr(r) ? r.entrySeq() : r.toIndexedSeq() : sf(r) ? r.toSeq().entrySeq() : ux(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toIndexedSeq = function() {
    return this;
  }, e.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, e;
}(Pi), cf = /* @__PURE__ */ function(t) {
  function e(r) {
    return (vi(r) && !Jd(r) ? r : zo(r)).toSetSeq();
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return e(arguments);
  }, e.prototype.toSetSeq = function() {
    return this;
  }, e;
}(Pi);
Pi.isSeq = kg;
Pi.Keyed = Va;
Pi.Set = cf;
Pi.Indexed = zo;
Pi.prototype[nx] = !0;
var uu = /* @__PURE__ */ function(t) {
  function e(r) {
    this._array = r, this.size = r.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return this.has(r) ? this._array[za(this, r)] : n;
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this._array, o = i.length, s = 0; s !== o; ) {
      var u = n ? o - ++s : s++;
      if (r(i[u], u, this) === !1)
        break;
    }
    return s;
  }, e.prototype.__iterator = function(r, n) {
    var i = this._array, o = i.length, s = 0;
    return new Ee(function() {
      if (s === o)
        return yi();
      var u = n ? o - ++s : s++;
      return wr(r, u, i[u]);
    });
  }, e;
}(zo), Cg = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = Object.keys(r).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(r) : []
    );
    this._object = r, this._keys = n, this.size = n.length;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return n !== void 0 && !this.has(r) ? n : this._object[r];
  }, e.prototype.has = function(r) {
    return uf.call(this._object, r);
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this._object, o = this._keys, s = o.length, u = 0; u !== s; ) {
      var c = o[n ? s - ++u : u++];
      if (r(i[c], c, this) === !1)
        break;
    }
    return u;
  }, e.prototype.__iterator = function(r, n) {
    var i = this._object, o = this._keys, s = o.length, u = 0;
    return new Ee(function() {
      if (u === s)
        return yi();
      var c = o[n ? s - ++u : u++];
      return wr(r, c, i[c]);
    });
  }, e;
}(Va);
Cg.prototype[af] = !0;
var qz = /* @__PURE__ */ function(t) {
  function e(r) {
    this._collection = r, this.size = r.length || r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.__iterateUncached = function(r, n) {
    if (n)
      return this.cacheResult().__iterate(r, n);
    var i = this._collection, o = A_(i), s = 0;
    if (XE(o))
      for (var u; !(u = o.next()).done && r(u.value, s++, this) !== !1; )
        ;
    return s;
  }, e.prototype.__iteratorUncached = function(r, n) {
    if (n)
      return this.cacheResult().__iterator(r, n);
    var i = this._collection, o = A_(i);
    if (!XE(o))
      return new Ee(yi);
    var s = 0;
    return new Ee(function() {
      var u = o.next();
      return u.done ? u : wr(r, s++, u.value);
    });
  }, e;
}(zo), tS;
function jg() {
  return tS || (tS = new uu([]));
}
function qg(t) {
  var e = Mg(t);
  if (e)
    return e.fromEntrySeq();
  if (typeof t == "object")
    return new Cg(t);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + t
  );
}
function ux(t) {
  var e = Mg(t);
  if (e)
    return e;
  throw new TypeError(
    "Expected Array or collection object of values: " + t
  );
}
function Mz(t) {
  var e = Mg(t);
  if (e)
    return Cz(t) ? e.fromEntrySeq() : jz(t) ? e.toSetSeq() : e;
  if (typeof t == "object")
    return new Cg(t);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + t
  );
}
function Mg(t) {
  return ax(t) ? new uu(t) : sx(t) ? new qz(t) : void 0;
}
var cx = "@@__IMMUTABLE_MAP__@@";
function Fg(t) {
  return !!(t && t[cx]);
}
function fx(t) {
  return Fg(t) && xo(t);
}
function eS(t) {
  return !!(t && typeof t.equals == "function" && typeof t.hashCode == "function");
}
function Ai(t, e) {
  if (t === e || t !== t && e !== e)
    return !0;
  if (!t || !e)
    return !1;
  if (typeof t.valueOf == "function" && typeof e.valueOf == "function") {
    if (t = t.valueOf(), e = e.valueOf(), t === e || t !== t && e !== e)
      return !0;
    if (!t || !e)
      return !1;
  }
  return !!(eS(t) && eS(e) && t.equals(e));
}
var Af = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(t, e) {
  t |= 0, e |= 0;
  var r = t & 65535, n = e & 65535;
  return r * n + ((t >>> 16) * n + r * (e >>> 16) << 16 >>> 0) | 0;
};
function tv(t) {
  return t >>> 1 & 1073741824 | t & 3221225471;
}
var Fz = Object.prototype.valueOf;
function wi(t) {
  if (t == null)
    return rS(t);
  if (typeof t.hashCode == "function")
    return tv(t.hashCode(t));
  var e = $z(t);
  if (e == null)
    return rS(e);
  switch (typeof e) {
    case "boolean":
      return e ? 1108378657 : 1108378656;
    case "number":
      return Nz(e);
    case "string":
      return e.length > Kz ? zz(e) : D_(e);
    case "object":
    case "function":
      return Uz(e);
    case "symbol":
      return Lz(e);
    default:
      if (typeof e.toString == "function")
        return D_(e.toString());
      throw new Error("Value type " + typeof e + " cannot be hashed.");
  }
}
function rS(t) {
  return t === null ? 1108378658 : (
    /* undefined */
    1108378659
  );
}
function Nz(t) {
  if (t !== t || t === 1 / 0)
    return 0;
  var e = t | 0;
  for (e !== t && (e ^= t * 4294967295); t > 4294967295; )
    t /= 4294967295, e ^= t;
  return tv(e);
}
function zz(t) {
  var e = _y[t];
  return e === void 0 && (e = D_(t), yy === Vz && (yy = 0, _y = {}), yy++, _y[t] = e), e;
}
function D_(t) {
  for (var e = 0, r = 0; r < t.length; r++)
    e = 31 * e + t.charCodeAt(r) | 0;
  return tv(e);
}
function Lz(t) {
  var e = oS[t];
  return e !== void 0 || (e = lx(), oS[t] = e), e;
}
function Uz(t) {
  var e;
  if (R_ && (e = x_.get(t), e !== void 0) || (e = t[Za], e !== void 0) || !iS && (e = t.propertyIsEnumerable && t.propertyIsEnumerable[Za], e !== void 0 || (e = Bz(t), e !== void 0)))
    return e;
  if (e = lx(), R_)
    x_.set(t, e);
  else {
    if (nS !== void 0 && nS(t) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (iS)
      Object.defineProperty(t, Za, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: e
      });
    else if (t.propertyIsEnumerable !== void 0 && t.propertyIsEnumerable === t.constructor.prototype.propertyIsEnumerable)
      t.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, t.propertyIsEnumerable[Za] = e;
    else if (t.nodeType !== void 0)
      t[Za] = e;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return e;
}
var nS = Object.isExtensible, iS = function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
}();
function Bz(t) {
  if (t && t.nodeType > 0)
    switch (t.nodeType) {
      case 1:
        return t.uniqueID;
      case 9:
        return t.documentElement && t.documentElement.uniqueID;
    }
}
function $z(t) {
  return t.valueOf !== Fz && typeof t.valueOf == "function" ? t.valueOf(t) : t;
}
function lx() {
  var t = ++vy;
  return vy & 1073741824 && (vy = 0), t;
}
var R_ = typeof WeakMap == "function", x_;
R_ && (x_ = /* @__PURE__ */ new WeakMap());
var oS = /* @__PURE__ */ Object.create(null), vy = 0, Za = "__immutablehash__";
typeof Symbol == "function" && (Za = Symbol(Za));
var Kz = 16, Vz = 255, yy = 0, _y = {}, ev = /* @__PURE__ */ function(t) {
  function e(r, n) {
    this._iter = r, this._useKeys = n, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function(r, n) {
    return this._iter.get(r, n);
  }, e.prototype.has = function(r) {
    return this._iter.has(r);
  }, e.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, e.prototype.reverse = function() {
    var r = this, n = Ng(this, !0);
    return this._useKeys || (n.valueSeq = function() {
      return r._iter.toSeq().reverse();
    }), n;
  }, e.prototype.map = function(r, n) {
    var i = this, o = yx(this, r, n);
    return this._useKeys || (o.valueSeq = function() {
      return i._iter.toSeq().map(r, n);
    }), o;
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o, s) {
      return r(o, s, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    return this._iter.__iterator(r, n);
  }, e;
}(Va);
ev.prototype[af] = !0;
var hx = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.includes = function(r) {
    return this._iter.includes(r);
  }, e.prototype.__iterate = function(r, n) {
    var i = this, o = 0;
    return n && gc(this), this._iter.__iterate(
      function(s) {
        return r(s, n ? i.size - ++o : o++, i);
      },
      n
    );
  }, e.prototype.__iterator = function(r, n) {
    var i = this, o = this._iter.__iterator(jo, n), s = 0;
    return n && gc(this), new Ee(function() {
      var u = o.next();
      return u.done ? u : wr(
        r,
        n ? i.size - ++s : s++,
        u.value,
        u
      );
    });
  }, e;
}(zo), px = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.has = function(r) {
    return this._iter.includes(r);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o) {
      return r(o, o, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._iter.__iterator(jo, n);
    return new Ee(function() {
      var o = i.next();
      return o.done ? o : wr(r, o.value, o.value, o);
    });
  }, e;
}(cf), dx = /* @__PURE__ */ function(t) {
  function e(r) {
    this._iter = r, this.size = r.size;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._iter.__iterate(function(o) {
      if (o) {
        aS(o);
        var s = vi(o);
        return r(
          s ? o.get(1) : o[1],
          s ? o.get(0) : o[0],
          i
        );
      }
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    var i = this._iter.__iterator(jo, n);
    return new Ee(function() {
      for (; ; ) {
        var o = i.next();
        if (o.done)
          return o;
        var s = o.value;
        if (s) {
          aS(s);
          var u = vi(s);
          return wr(
            r,
            u ? s.get(0) : s[0],
            u ? s.get(1) : s[1],
            o
          );
        }
      }
    });
  }, e;
}(Va);
hx.prototype.cacheResult = ev.prototype.cacheResult = px.prototype.cacheResult = dx.prototype.cacheResult = Ug;
function vx(t) {
  var e = us(t);
  return e._iter = t, e.size = t.size, e.flip = function() {
    return t;
  }, e.reverse = function() {
    var r = t.reverse.apply(this);
    return r.flip = function() {
      return t.reverse();
    }, r;
  }, e.has = function(r) {
    return t.includes(r);
  }, e.includes = function(r) {
    return t.has(r);
  }, e.cacheResult = Ug, e.__iterateUncached = function(r, n) {
    var i = this;
    return t.__iterate(function(o, s) {
      return r(s, o, i) !== !1;
    }, n);
  }, e.__iteratorUncached = function(r, n) {
    if (r === uo) {
      var i = t.__iterator(r, n);
      return new Ee(function() {
        var o = i.next();
        if (!o.done) {
          var s = o.value[0];
          o.value[0] = o.value[1], o.value[1] = s;
        }
        return o;
      });
    }
    return t.__iterator(
      r === jo ? hh : jo,
      n
    );
  }, e;
}
function yx(t, e, r) {
  var n = us(t);
  return n.size = t.size, n.has = function(i) {
    return t.has(i);
  }, n.get = function(i, o) {
    var s = t.get(i, ve);
    return s === ve ? o : e.call(r, s, i, t);
  }, n.__iterateUncached = function(i, o) {
    var s = this;
    return t.__iterate(
      function(u, c, a) {
        return i(e.call(r, u, c, a), c, s) !== !1;
      },
      o
    );
  }, n.__iteratorUncached = function(i, o) {
    var s = t.__iterator(uo, o);
    return new Ee(function() {
      var u = s.next();
      if (u.done)
        return u;
      var c = u.value, a = c[0];
      return wr(
        i,
        a,
        e.call(r, c[1], a, t),
        u
      );
    });
  }, n;
}
function Ng(t, e) {
  var r = this, n = us(t);
  return n._iter = t, n.size = t.size, n.reverse = function() {
    return t;
  }, t.flip && (n.flip = function() {
    var i = vx(t);
    return i.reverse = function() {
      return t.flip();
    }, i;
  }), n.get = function(i, o) {
    return t.get(e ? i : -1 - i, o);
  }, n.has = function(i) {
    return t.has(e ? i : -1 - i);
  }, n.includes = function(i) {
    return t.includes(i);
  }, n.cacheResult = Ug, n.__iterate = function(i, o) {
    var s = this, u = 0;
    return o && gc(t), t.__iterate(
      function(c, a) {
        return i(c, e ? a : o ? s.size - ++u : u++, s);
      },
      !o
    );
  }, n.__iterator = function(i, o) {
    var s = 0;
    o && gc(t);
    var u = t.__iterator(uo, !o);
    return new Ee(function() {
      var c = u.next();
      if (c.done)
        return c;
      var a = c.value;
      return wr(
        i,
        e ? a[0] : o ? r.size - ++s : s++,
        a[1],
        c
      );
    });
  }, n;
}
function _x(t, e, r, n) {
  var i = us(t);
  return n && (i.has = function(o) {
    var s = t.get(o, ve);
    return s !== ve && !!e.call(r, s, o, t);
  }, i.get = function(o, s) {
    var u = t.get(o, ve);
    return u !== ve && e.call(r, u, o, t) ? u : s;
  }), i.__iterateUncached = function(o, s) {
    var u = this, c = 0;
    return t.__iterate(function(a, f, h) {
      if (e.call(r, a, f, h))
        return c++, o(a, n ? f : c - 1, u);
    }, s), c;
  }, i.__iteratorUncached = function(o, s) {
    var u = t.__iterator(uo, s), c = 0;
    return new Ee(function() {
      for (; ; ) {
        var a = u.next();
        if (a.done)
          return a;
        var f = a.value, h = f[0], p = f[1];
        if (e.call(r, p, h, t))
          return wr(o, n ? h : c++, p, a);
      }
    });
  }, i;
}
function Qz(t, e, r) {
  var n = lf().asMutable();
  return t.__iterate(function(i, o) {
    n.update(e.call(r, i, o, t), 0, function(s) {
      return s + 1;
    });
  }), n.asImmutable();
}
function Yz(t, e, r) {
  var n = yr(t), i = (xo(t) ? ua() : lf()).asMutable();
  t.__iterate(function(s, u) {
    i.update(
      e.call(r, s, u, t),
      function(c) {
        return c = c || [], c.push(n ? [u, s] : s), c;
      }
    );
  });
  var o = Lg(t);
  return i.map(function(s) {
    return ke(t, o(s));
  }).asImmutable();
}
function Gz(t, e, r) {
  var n = yr(t), i = [[], []];
  t.__iterate(function(s, u) {
    i[e.call(r, s, u, t) ? 1 : 0].push(
      n ? [u, s] : s
    );
  });
  var o = Lg(t);
  return i.map(function(s) {
    return ke(t, o(s));
  });
}
function zg(t, e, r, n) {
  var i = t.size;
  if (Wd(e, r, i))
    return t;
  var o = lh(e, i), s = Hd(r, i);
  if (o !== o || s !== s)
    return zg(t.toSeq().cacheResult(), e, r, n);
  var u = s - o, c;
  u === u && (c = u < 0 ? 0 : u);
  var a = us(t);
  return a.size = c === 0 ? c : t.size && c || void 0, !n && kg(t) && c >= 0 && (a.get = function(f, h) {
    return f = za(this, f), f >= 0 && f < c ? t.get(f + o, h) : h;
  }), a.__iterateUncached = function(f, h) {
    var p = this;
    if (c === 0)
      return 0;
    if (h)
      return this.cacheResult().__iterate(f, h);
    var d = 0, _ = !0, m = 0;
    return t.__iterate(function(b, O) {
      if (!(_ && (_ = d++ < o)))
        return m++, f(b, n ? O : m - 1, p) !== !1 && m !== c;
    }), m;
  }, a.__iteratorUncached = function(f, h) {
    if (c !== 0 && h)
      return this.cacheResult().__iterator(f, h);
    if (c === 0)
      return new Ee(yi);
    var p = t.__iterator(f, h), d = 0, _ = 0;
    return new Ee(function() {
      for (; d++ < o; )
        p.next();
      if (++_ > c)
        return yi();
      var m = p.next();
      return n || f === jo || m.done ? m : f === hh ? wr(f, _ - 1, void 0, m) : wr(f, _ - 1, m.value[1], m);
    });
  }, a;
}
function Wz(t, e, r) {
  var n = us(t);
  return n.__iterateUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterate(i, o);
    var u = 0;
    return t.__iterate(
      function(c, a, f) {
        return e.call(r, c, a, f) && ++u && i(c, a, s);
      }
    ), u;
  }, n.__iteratorUncached = function(i, o) {
    var s = this;
    if (o)
      return this.cacheResult().__iterator(i, o);
    var u = t.__iterator(uo, o), c = !0;
    return new Ee(function() {
      if (!c)
        return yi();
      var a = u.next();
      if (a.done)
        return a;
      var f = a.value, h = f[0], p = f[1];
      return e.call(r, p, h, s) ? i === uo ? a : wr(i, h, p, a) : (c = !1, yi());
    });
  }, n;
}
function mx(t, e, r, n) {
  var i = us(t);
  return i.__iterateUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterate(o, s);
    var c = !0, a = 0;
    return t.__iterate(function(f, h, p) {
      if (!(c && (c = e.call(r, f, h, p))))
        return a++, o(f, n ? h : a - 1, u);
    }), a;
  }, i.__iteratorUncached = function(o, s) {
    var u = this;
    if (s)
      return this.cacheResult().__iterator(o, s);
    var c = t.__iterator(uo, s), a = !0, f = 0;
    return new Ee(function() {
      var h, p, d;
      do {
        if (h = c.next(), h.done)
          return n || o === jo ? h : o === hh ? wr(o, f++, void 0, h) : wr(o, f++, h.value[1], h);
        var _ = h.value;
        p = _[0], d = _[1], a && (a = e.call(r, d, p, u));
      } while (a);
      return o === uo ? h : wr(o, p, d, h);
    });
  }, i;
}
function Hz(t, e) {
  var r = yr(t), n = [t].concat(e).map(function(s) {
    return vi(s) ? r && (s = po(s)) : s = r ? qg(s) : ux(Array.isArray(s) ? s : [s]), s;
  }).filter(function(s) {
    return s.size !== 0;
  });
  if (n.length === 0)
    return t;
  if (n.length === 1) {
    var i = n[0];
    if (i === t || r && yr(i) || si(t) && si(i))
      return i;
  }
  var o = new uu(n);
  return r ? o = o.toKeyedSeq() : si(t) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = n.reduce(function(s, u) {
    if (s !== void 0) {
      var c = u.size;
      if (c !== void 0)
        return s + c;
    }
  }, 0), o;
}
function gx(t, e, r) {
  var n = us(t);
  return n.__iterateUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterate(i, o);
    var s = 0, u = !1;
    function c(a, f) {
      a.__iterate(function(h, p) {
        return (!e || f < e) && vi(h) ? c(h, f + 1) : (s++, i(h, r ? p : s - 1, n) === !1 && (u = !0)), !u;
      }, o);
    }
    return c(t, 0), s;
  }, n.__iteratorUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterator(i, o);
    var s = t.__iterator(i, o), u = [], c = 0;
    return new Ee(function() {
      for (; s; ) {
        var a = s.next();
        if (a.done !== !1) {
          s = u.pop();
          continue;
        }
        var f = a.value;
        if (i === uo && (f = f[1]), (!e || u.length < e) && vi(f))
          u.push(s), s = f.__iterator(i, o);
        else
          return r ? a : wr(i, c++, f, a);
      }
      return yi();
    });
  }, n;
}
function Jz(t, e, r) {
  var n = Lg(t);
  return t.toSeq().map(function(i, o) {
    return n(e.call(r, i, o, t));
  }).flatten(!0);
}
function Zz(t, e) {
  var r = us(t);
  return r.size = t.size && t.size * 2 - 1, r.__iterateUncached = function(n, i) {
    var o = this, s = 0;
    return t.__iterate(
      function(u) {
        return (!s || n(e, s++, o) !== !1) && n(u, s++, o) !== !1;
      },
      i
    ), s;
  }, r.__iteratorUncached = function(n, i) {
    var o = t.__iterator(jo, i), s = 0, u;
    return new Ee(function() {
      return (!u || s % 2) && (u = o.next(), u.done) ? u : s % 2 ? wr(n, s++, e) : wr(n, s++, u.value, u);
    });
  }, r;
}
function bc(t, e, r) {
  e || (e = bx);
  var n = yr(t), i = 0, o = t.toSeq().map(function(s, u) {
    return [u, s, i++, r ? r(s, u, t) : s];
  }).valueSeq().toArray();
  return o.sort(function(s, u) {
    return e(s[3], u[3]) || s[2] - u[2];
  }).forEach(
    n ? function(s, u) {
      o[u].length = 2;
    } : function(s, u) {
      o[u] = s[1];
    }
  ), n ? Va(o) : si(t) ? zo(o) : cf(o);
}
function Hh(t, e, r) {
  if (e || (e = bx), r) {
    var n = t.toSeq().map(function(i, o) {
      return [i, r(i, o, t)];
    }).reduce(function(i, o) {
      return sS(e, i[1], o[1]) ? o : i;
    });
    return n && n[0];
  }
  return t.reduce(function(i, o) {
    return sS(e, i, o) ? o : i;
  });
}
function sS(t, e, r) {
  var n = t(r, e);
  return n === 0 && r !== e && (r == null || r !== r) || n > 0;
}
function Jh(t, e, r, n) {
  var i = us(t), o = new uu(r).map(function(s) {
    return s.size;
  });
  return i.size = n ? o.max() : o.min(), i.__iterate = function(s, u) {
    for (var c = this.__iterator(jo, u), a, f = 0; !(a = c.next()).done && s(a.value, f++, this) !== !1; )
      ;
    return f;
  }, i.__iteratorUncached = function(s, u) {
    var c = r.map(
      function(h) {
        return h = Dr(h), A_(u ? h.reverse() : h);
      }
    ), a = 0, f = !1;
    return new Ee(function() {
      var h;
      return f || (h = c.map(function(p) {
        return p.next();
      }), f = n ? h.every(function(p) {
        return p.done;
      }) : h.some(function(p) {
        return p.done;
      })), f ? yi() : wr(
        s,
        a++,
        e.apply(
          null,
          h.map(function(p) {
            return p.value;
          })
        )
      );
    });
  }, i;
}
function ke(t, e) {
  return t === e ? t : kg(t) ? e : t.constructor(e);
}
function aS(t) {
  if (t !== Object(t))
    throw new TypeError("Expected [K, V] tuple: " + t);
}
function Lg(t) {
  return yr(t) ? po : si(t) ? Au : of;
}
function us(t) {
  return Object.create(
    (yr(t) ? Va : si(t) ? zo : cf).prototype
  );
}
function Ug() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : Pi.prototype.cacheResult.call(this);
}
function bx(t, e) {
  return t === void 0 && e === void 0 ? 0 : t === void 0 ? 1 : e === void 0 ? -1 : t > e ? 1 : t < e ? -1 : 0;
}
function Wo(t, e) {
  e = e || 0;
  for (var r = Math.max(0, t.length - e), n = new Array(r), i = 0; i < r; i++)
    n[i] = t[i + e];
  return n;
}
function Bg(t, e) {
  if (!t)
    throw new Error(e);
}
function no(t) {
  Bg(
    t !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function wx(t) {
  if (ax(t) && typeof t != "string")
    return t;
  if (xo(t))
    return t.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + t
  );
}
var Xz = Object.prototype.toString;
function tL(t) {
  if (!t || typeof t != "object" || Xz.call(t) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(t);
  if (e === null)
    return !0;
  for (var r = e, n = Object.getPrototypeOf(e); n !== null; )
    r = n, n = Object.getPrototypeOf(r);
  return r === e;
}
function La(t) {
  return typeof t == "object" && (as(t) || Array.isArray(t) || tL(t));
}
function Il(t) {
  try {
    return typeof t == "string" ? JSON.stringify(t) : String(t);
  } catch {
    return JSON.stringify(t);
  }
}
function eL(t, e) {
  return as(t) ? t.has(e) : La(t) && uf.call(t, e);
}
function Ex(t, e, r) {
  return as(t) ? t.get(e, r) : eL(t, e) ? typeof t.get == "function" ? t.get(e) : t[e] : r;
}
function Bp(t) {
  if (Array.isArray(t))
    return Wo(t);
  var e = {};
  for (var r in t)
    uf.call(t, r) && (e[r] = t[r]);
  return e;
}
function rL(t, e) {
  if (!La(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (as(t)) {
    if (!t.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + t
      );
    return t.remove(e);
  }
  if (!uf.call(t, e))
    return t;
  var r = Bp(t);
  return Array.isArray(r) ? r.splice(e, 1) : delete r[e], r;
}
function nL(t, e, r) {
  if (!La(t))
    throw new TypeError(
      "Cannot update non-data-structure value: " + t
    );
  if (as(t)) {
    if (!t.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + t
      );
    return t.set(e, r);
  }
  if (uf.call(t, e) && r === t[e])
    return t;
  var n = Bp(t);
  return n[e] = r, n;
}
function ff(t, e, r, n) {
  n || (n = r, r = void 0);
  var i = Sx(
    as(t),
    t,
    wx(e),
    0,
    r,
    n
  );
  return i === ve ? r : i;
}
function Sx(t, e, r, n, i, o) {
  var s = e === ve;
  if (n === r.length) {
    var u = s ? i : e, c = o(u);
    return c === u ? e : c;
  }
  if (!s && !La(e))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + r.slice(0, n).map(Il) + "]: " + e
    );
  var a = r[n], f = s ? ve : Ex(e, a, ve), h = Sx(
    f === ve ? t : as(f),
    f,
    r,
    n + 1,
    i,
    o
  );
  return h === f ? e : h === ve ? rL(e, a) : nL(
    s ? t ? Oo() : {} : e,
    a,
    h
  );
}
function iL(t, e, r) {
  return ff(t, e, ve, function() {
    return r;
  });
}
function $g(t, e) {
  return iL(this, t, e);
}
function oL(t, e) {
  return ff(t, e, function() {
    return ve;
  });
}
function Kg(t) {
  return oL(this, t);
}
function Ox(t, e, r, n) {
  return ff(t, [e], r, n);
}
function Vg(t, e, r) {
  return arguments.length === 1 ? t(this) : Ox(this, t, e, r);
}
function Qg(t, e, r) {
  return ff(this, t, e, r);
}
function Ix() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return Dx(this, t);
}
function Ax(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  if (typeof t != "function")
    throw new TypeError("Invalid merger function: " + t);
  return Dx(this, e, t);
}
function Dx(t, e, r) {
  for (var n = [], i = 0; i < e.length; i++) {
    var o = po(e[i]);
    o.size !== 0 && n.push(o);
  }
  return n.length === 0 ? t : t.toSeq().size === 0 && !t.__ownerID && n.length === 1 ? t.constructor(n[0]) : t.withMutations(function(s) {
    for (var u = r ? function(a, f) {
      Ox(
        s,
        f,
        ve,
        function(h) {
          return h === ve ? a : r(h, a, f);
        }
      );
    } : function(a, f) {
      s.set(f, a);
    }, c = 0; c < n.length; c++)
      n[c].forEach(u);
  });
}
function Yg(t, e, r) {
  return Gg(t, e, sL(r));
}
function Gg(t, e, r) {
  if (!La(t))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + t
    );
  if (as(t))
    return typeof r == "function" && t.mergeWith ? t.mergeWith.apply(t, [r].concat(e)) : t.merge ? t.merge.apply(t, e) : t.concat.apply(t, e);
  for (var n = Array.isArray(t), i = t, o = n ? Au : po, s = n ? function(c) {
    i === t && (i = Bp(i)), i.push(c);
  } : function(c, a) {
    var f = uf.call(i, a), h = f && r ? r(i[a], c, a) : c;
    (!f || h !== i[a]) && (i === t && (i = Bp(i)), i[a] = h);
  }, u = 0; u < e.length; u++)
    o(e[u]).forEach(s);
  return i;
}
function sL(t) {
  function e(r, n, i) {
    return La(r) && La(n) && aL(r, n) ? Gg(r, [n], e) : t ? t(r, n, i) : n;
  }
  return e;
}
function aL(t, e) {
  var r = Pi(t), n = Pi(e);
  return si(r) === si(n) && yr(r) === yr(n);
}
function Rx() {
  for (var t = [], e = arguments.length; e--; )
    t[e] = arguments[e];
  return Yg(this, t);
}
function xx(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return Yg(this, e, t);
}
function Wg(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return ff(this, t, Oo(), function(n) {
    return Gg(n, e);
  });
}
function Hg(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0; )
    e[r] = arguments[r + 1];
  return ff(
    this,
    t,
    Oo(),
    function(n) {
      return Yg(n, e);
    }
  );
}
function ph(t) {
  var e = this.asMutable();
  return t(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
}
function dh() {
  return this.__ownerID ? this : this.__ensureOwner(new Pg());
}
function vh() {
  return this.__ensureOwner();
}
function Jg() {
  return this.__altered;
}
var lf = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Oo() : Fg(r) && !xo(r) ? r : Oo().withMutations(function(n) {
      var i = t(r);
      no(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    return Oo().withMutations(function(i) {
      for (var o = 0; o < r.length; o += 2) {
        if (o + 1 >= r.length)
          throw new Error("Missing value for key: " + r[o]);
        i.set(r[o], r[o + 1]);
      }
    });
  }, e.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, e.prototype.get = function(r, n) {
    return this._root ? this._root.get(0, void 0, r, n) : n;
  }, e.prototype.set = function(r, n) {
    return fS(this, r, n);
  }, e.prototype.remove = function(r) {
    return fS(this, r, ve);
  }, e.prototype.deleteAll = function(r) {
    var n = Dr(r);
    return n.size === 0 ? this : this.withMutations(function(i) {
      n.forEach(function(o) {
        return i.remove(o);
      });
    });
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : Oo();
  }, e.prototype.sort = function(r) {
    return ua(bc(this, r));
  }, e.prototype.sortBy = function(r, n) {
    return ua(bc(this, n, r));
  }, e.prototype.map = function(r, n) {
    var i = this;
    return this.withMutations(function(o) {
      o.forEach(function(s, u) {
        o.set(u, r.call(n, s, u, i));
      });
    });
  }, e.prototype.__iterator = function(r, n) {
    return new uL(this, r, n);
  }, e.prototype.__iterate = function(r, n) {
    var i = this, o = 0;
    return this._root && this._root.iterate(function(s) {
      return o++, r(s[1], s[0], i);
    }, n), o;
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? Zg(this.size, this._root, r, this.__hash) : this.size === 0 ? Oo() : (this.__ownerID = r, this.__altered = !1, this);
  }, e;
}(po);
lf.isMap = Fg;
var Ge = lf.prototype;
Ge[cx] = !0;
Ge[fh] = Ge.remove;
Ge.removeAll = Ge.deleteAll;
Ge.setIn = $g;
Ge.removeIn = Ge.deleteIn = Kg;
Ge.update = Vg;
Ge.updateIn = Qg;
Ge.merge = Ge.concat = Ix;
Ge.mergeWith = Ax;
Ge.mergeDeep = Rx;
Ge.mergeDeepWith = xx;
Ge.mergeIn = Wg;
Ge.mergeDeepIn = Hg;
Ge.withMutations = ph;
Ge.wasAltered = Jg;
Ge.asImmutable = vh;
Ge["@@transducer/init"] = Ge.asMutable = dh;
Ge["@@transducer/step"] = function(t, e) {
  return t.set(e[0], e[1]);
};
Ge["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var Al = function(t, e) {
  this.ownerID = t, this.entries = e;
};
Al.prototype.get = function(t, e, r, n) {
  for (var i = this.entries, o = 0, s = i.length; o < s; o++)
    if (Ai(r, i[o][0]))
      return i[o][1];
  return n;
};
Al.prototype.update = function(t, e, r, n, i, o, s) {
  for (var u = i === ve, c = this.entries, a = 0, f = c.length; a < f && !Ai(n, c[a][0]); a++)
    ;
  var h = a < f;
  if (h ? c[a][1] === i : u)
    return this;
  if (ro(s), (u || !h) && ro(o), !(u && c.length === 1)) {
    if (!h && !u && c.length >= dL)
      return cL(t, c, n, i);
    var p = t && t === this.ownerID, d = p ? c : Wo(c);
    return h ? u ? a === f - 1 ? d.pop() : d[a] = d.pop() : d[a] = [n, i] : d.push([n, i]), p ? (this.entries = d, this) : new Al(t, d);
  }
};
var wc = function(t, e, r) {
  this.ownerID = t, this.bitmap = e, this.nodes = r;
};
wc.prototype.get = function(t, e, r, n) {
  e === void 0 && (e = wi(r));
  var i = 1 << ((t === 0 ? e : e >>> t) & Nn), o = this.bitmap;
  return o & i ? this.nodes[Tx(o & i - 1)].get(
    t + $e,
    e,
    r,
    n
  ) : n;
};
wc.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = wi(n));
  var u = (e === 0 ? r : r >>> e) & Nn, c = 1 << u, a = this.bitmap, f = (a & c) !== 0;
  if (!f && i === ve)
    return this;
  var h = Tx(a & c - 1), p = this.nodes, d = f ? p[h] : void 0, _ = Xg(
    d,
    t,
    e + $e,
    r,
    n,
    i,
    o,
    s
  );
  if (_ === d)
    return this;
  if (!f && _ && p.length >= vL)
    return lL(t, p, a, u, _);
  if (f && !_ && p.length === 2 && lS(p[h ^ 1]))
    return p[h ^ 1];
  if (f && _ && p.length === 1 && lS(_))
    return _;
  var m = t && t === this.ownerID, b = f ? _ ? a : a ^ c : a | c, O = f ? _ ? Px(p, h, _, m) : pL(p, h, m) : hL(p, h, _, m);
  return m ? (this.bitmap = b, this.nodes = O, this) : new wc(t, b, O);
};
var Dl = function(t, e, r) {
  this.ownerID = t, this.count = e, this.nodes = r;
};
Dl.prototype.get = function(t, e, r, n) {
  e === void 0 && (e = wi(r));
  var i = (t === 0 ? e : e >>> t) & Nn, o = this.nodes[i];
  return o ? o.get(t + $e, e, r, n) : n;
};
Dl.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = wi(n));
  var u = (e === 0 ? r : r >>> e) & Nn, c = i === ve, a = this.nodes, f = a[u];
  if (c && !f)
    return this;
  var h = Xg(
    f,
    t,
    e + $e,
    r,
    n,
    i,
    o,
    s
  );
  if (h === f)
    return this;
  var p = this.count;
  if (!f)
    p++;
  else if (!h && (p--, p < yL))
    return fL(t, a, p, u);
  var d = t && t === this.ownerID, _ = Px(a, u, h, d);
  return d ? (this.count = p, this.nodes = _, this) : new Dl(t, p, _);
};
var Ec = function(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entries = r;
};
Ec.prototype.get = function(t, e, r, n) {
  for (var i = this.entries, o = 0, s = i.length; o < s; o++)
    if (Ai(r, i[o][0]))
      return i[o][1];
  return n;
};
Ec.prototype.update = function(t, e, r, n, i, o, s) {
  r === void 0 && (r = wi(n));
  var u = i === ve;
  if (r !== this.keyHash)
    return u ? this : (ro(s), ro(o), t1(this, t, e, r, [n, i]));
  for (var c = this.entries, a = 0, f = c.length; a < f && !Ai(n, c[a][0]); a++)
    ;
  var h = a < f;
  if (h ? c[a][1] === i : u)
    return this;
  if (ro(s), (u || !h) && ro(o), u && f === 2)
    return new aa(t, this.keyHash, c[a ^ 1]);
  var p = t && t === this.ownerID, d = p ? c : Wo(c);
  return h ? u ? a === f - 1 ? d.pop() : d[a] = d.pop() : d[a] = [n, i] : d.push([n, i]), p ? (this.entries = d, this) : new Ec(t, this.keyHash, d);
};
var aa = function(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entry = r;
};
aa.prototype.get = function(t, e, r, n) {
  return Ai(r, this.entry[0]) ? this.entry[1] : n;
};
aa.prototype.update = function(t, e, r, n, i, o, s) {
  var u = i === ve, c = Ai(n, this.entry[0]);
  if (c ? i === this.entry[1] : u)
    return this;
  if (ro(s), u) {
    ro(o);
    return;
  }
  return c ? t && t === this.ownerID ? (this.entry[1] = i, this) : new aa(t, this.keyHash, [n, i]) : (ro(o), t1(this, t, e, wi(n), [n, i]));
};
Al.prototype.iterate = Ec.prototype.iterate = function(t, e) {
  for (var r = this.entries, n = 0, i = r.length - 1; n <= i; n++)
    if (t(r[e ? i - n : n]) === !1)
      return !1;
};
wc.prototype.iterate = Dl.prototype.iterate = function(t, e) {
  for (var r = this.nodes, n = 0, i = r.length - 1; n <= i; n++) {
    var o = r[e ? i - n : n];
    if (o && o.iterate(t, e) === !1)
      return !1;
  }
};
aa.prototype.iterate = function(t, e) {
  return t(this.entry);
};
var uL = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    this._type = n, this._reverse = i, this._stack = r._root && uS(r._root);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function() {
    for (var r = this._type, n = this._stack; n; ) {
      var i = n.node, o = n.index++, s = void 0;
      if (i.entry) {
        if (o === 0)
          return my(r, i.entry);
      } else if (i.entries) {
        if (s = i.entries.length - 1, o <= s)
          return my(
            r,
            i.entries[this._reverse ? s - o : o]
          );
      } else if (s = i.nodes.length - 1, o <= s) {
        var u = i.nodes[this._reverse ? s - o : o];
        if (u) {
          if (u.entry)
            return my(r, u.entry);
          n = this._stack = uS(u, n);
        }
        continue;
      }
      n = this._stack = this._stack.__prev;
    }
    return yi();
  }, e;
}(Ee);
function my(t, e) {
  return wr(t, e[0], e[1]);
}
function uS(t, e) {
  return {
    node: t,
    index: 0,
    __prev: e
  };
}
function Zg(t, e, r, n) {
  var i = Object.create(Ge);
  return i.size = t, i._root = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var cS;
function Oo() {
  return cS || (cS = Zg(0));
}
function fS(t, e, r) {
  var n, i;
  if (t._root) {
    var o = O_(), s = O_();
    if (n = Xg(
      t._root,
      t.__ownerID,
      0,
      void 0,
      e,
      r,
      o,
      s
    ), !s.value)
      return t;
    i = t.size + (o.value ? r === ve ? -1 : 1 : 0);
  } else {
    if (r === ve)
      return t;
    i = 1, n = new Al(t.__ownerID, [[e, r]]);
  }
  return t.__ownerID ? (t.size = i, t._root = n, t.__hash = void 0, t.__altered = !0, t) : n ? Zg(i, n) : Oo();
}
function Xg(t, e, r, n, i, o, s, u) {
  return t ? t.update(
    e,
    r,
    n,
    i,
    o,
    s,
    u
  ) : o === ve ? t : (ro(u), ro(s), new aa(e, n, [i, o]));
}
function lS(t) {
  return t.constructor === aa || t.constructor === Ec;
}
function t1(t, e, r, n, i) {
  if (t.keyHash === n)
    return new Ec(e, n, [t.entry, i]);
  var o = (r === 0 ? t.keyHash : t.keyHash >>> r) & Nn, s = (r === 0 ? n : n >>> r) & Nn, u, c = o === s ? [t1(t, e, r + $e, n, i)] : (u = new aa(e, n, i), o < s ? [t, u] : [u, t]);
  return new wc(e, 1 << o | 1 << s, c);
}
function cL(t, e, r, n) {
  t || (t = new Pg());
  for (var i = new aa(t, wi(r), [r, n]), o = 0; o < e.length; o++) {
    var s = e[o];
    i = i.update(t, 0, void 0, s[0], s[1]);
  }
  return i;
}
function fL(t, e, r, n) {
  for (var i = 0, o = 0, s = new Array(r), u = 0, c = 1, a = e.length; u < a; u++, c <<= 1) {
    var f = e[u];
    f !== void 0 && u !== n && (i |= c, s[o++] = f);
  }
  return new wc(t, i, s);
}
function lL(t, e, r, n, i) {
  for (var o = 0, s = new Array(eo), u = 0; r !== 0; u++, r >>>= 1)
    s[u] = r & 1 ? e[o++] : void 0;
  return s[n] = i, new Dl(t, o + 1, s);
}
function Tx(t) {
  return t -= t >> 1 & 1431655765, t = (t & 858993459) + (t >> 2 & 858993459), t = t + (t >> 4) & 252645135, t += t >> 8, t += t >> 16, t & 127;
}
function Px(t, e, r, n) {
  var i = n ? t : Wo(t);
  return i[e] = r, i;
}
function hL(t, e, r, n) {
  var i = t.length + 1;
  if (n && e + 1 === i)
    return t[e] = r, t;
  for (var o = new Array(i), s = 0, u = 0; u < i; u++)
    u === e ? (o[u] = r, s = -1) : o[u] = t[u + s];
  return o;
}
function pL(t, e, r) {
  var n = t.length - 1;
  if (r && e === n)
    return t.pop(), t;
  for (var i = new Array(n), o = 0, s = 0; s < n; s++)
    s === e && (o = 1), i[s] = t[s + o];
  return i;
}
var dL = eo / 4, vL = eo / 2, yL = eo / 4, kx = "@@__IMMUTABLE_LIST__@@";
function Cx(t) {
  return !!(t && t[kx]);
}
var rv = /* @__PURE__ */ function(t) {
  function e(r) {
    var n = dp();
    if (r == null)
      return n;
    if (Cx(r))
      return r;
    var i = t(r), o = i.size;
    return o === 0 ? n : (no(o), o > 0 && o < eo ? Rl(0, o, $e, null, new Ta(i.toArray())) : n.withMutations(function(s) {
      s.setSize(o), i.forEach(function(u, c) {
        return s.set(c, u);
      });
    }));
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, e.prototype.get = function(r, n) {
    if (r = za(this, r), r >= 0 && r < this.size) {
      r += this._origin;
      var i = jx(this, r);
      return i && i.array[r & Nn];
    }
    return n;
  }, e.prototype.set = function(r, n) {
    return _L(this, r, n);
  }, e.prototype.remove = function(r) {
    return this.has(r) ? r === 0 ? this.shift() : r === this.size - 1 ? this.pop() : this.splice(r, 1) : this;
  }, e.prototype.insert = function(r, n) {
    return this.splice(r, 0, n);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = $e, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : dp();
  }, e.prototype.push = function() {
    var r = arguments, n = this.size;
    return this.withMutations(function(i) {
      ba(i, 0, n + r.length);
      for (var o = 0; o < r.length; o++)
        i.set(n + o, r[o]);
    });
  }, e.prototype.pop = function() {
    return ba(this, 0, -1);
  }, e.prototype.unshift = function() {
    var r = arguments;
    return this.withMutations(function(n) {
      ba(n, -r.length);
      for (var i = 0; i < r.length; i++)
        n.set(i, r[i]);
    });
  }, e.prototype.shift = function() {
    return ba(this, 1);
  }, e.prototype.concat = function() {
    for (var r = arguments, n = [], i = 0; i < arguments.length; i++) {
      var o = r[i], s = t(
        typeof o != "string" && sx(o) ? o : [o]
      );
      s.size !== 0 && n.push(s);
    }
    return n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(u) {
      n.forEach(function(c) {
        return c.forEach(function(a) {
          return u.push(a);
        });
      });
    });
  }, e.prototype.setSize = function(r) {
    return ba(this, 0, r);
  }, e.prototype.map = function(r, n) {
    var i = this;
    return this.withMutations(function(o) {
      for (var s = 0; s < i.size; s++)
        o.set(s, r.call(n, o.get(s), s, i));
    });
  }, e.prototype.slice = function(r, n) {
    var i = this.size;
    return Wd(r, n, i) ? this : ba(
      this,
      lh(r, i),
      Hd(n, i)
    );
  }, e.prototype.__iterator = function(r, n) {
    var i = n ? this.size : 0, o = hS(this, n);
    return new Ee(function() {
      var s = o();
      return s === Hf ? yi() : wr(r, n ? --i : i++, s);
    });
  }, e.prototype.__iterate = function(r, n) {
    for (var i = n ? this.size : 0, o = hS(this, n), s; (s = o()) !== Hf && r(s, n ? --i : i++, this) !== !1; )
      ;
    return i;
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? Rl(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      r,
      this.__hash
    ) : this.size === 0 ? dp() : (this.__ownerID = r, this.__altered = !1, this);
  }, e;
}(Au);
rv.isList = Cx;
var qr = rv.prototype;
qr[kx] = !0;
qr[fh] = qr.remove;
qr.merge = qr.concat;
qr.setIn = $g;
qr.deleteIn = qr.removeIn = Kg;
qr.update = Vg;
qr.updateIn = Qg;
qr.mergeIn = Wg;
qr.mergeDeepIn = Hg;
qr.withMutations = ph;
qr.wasAltered = Jg;
qr.asImmutable = vh;
qr["@@transducer/init"] = qr.asMutable = dh;
qr["@@transducer/step"] = function(t, e) {
  return t.push(e);
};
qr["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
var Ta = function(t, e) {
  this.array = t, this.ownerID = e;
};
Ta.prototype.removeBefore = function(t, e, r) {
  if (r === e ? 1 << e : this.array.length === 0)
    return this;
  var n = r >>> e & Nn;
  if (n >= this.array.length)
    return new Ta([], t);
  var i = n === 0, o;
  if (e > 0) {
    var s = this.array[n];
    if (o = s && s.removeBefore(t, e - $e, r), o === s && i)
      return this;
  }
  if (i && !o)
    return this;
  var u = Sc(this, t);
  if (!i)
    for (var c = 0; c < n; c++)
      u.array[c] = void 0;
  return o && (u.array[n] = o), u;
};
Ta.prototype.removeAfter = function(t, e, r) {
  if (r === (e ? 1 << e : 0) || this.array.length === 0)
    return this;
  var n = r - 1 >>> e & Nn;
  if (n >= this.array.length)
    return this;
  var i;
  if (e > 0) {
    var o = this.array[n];
    if (i = o && o.removeAfter(t, e - $e, r), i === o && n === this.array.length - 1)
      return this;
  }
  var s = Sc(this, t);
  return s.array.splice(n + 1), i && (s.array[n] = i), s;
};
var Hf = {};
function hS(t, e) {
  var r = t._origin, n = t._capacity, i = xl(n), o = t._tail;
  return s(t._root, t._level, 0);
  function s(a, f, h) {
    return f === 0 ? u(a, h) : c(a, f, h);
  }
  function u(a, f) {
    var h = f === i ? o && o.array : a && a.array, p = f > r ? 0 : r - f, d = n - f;
    return d > eo && (d = eo), function() {
      if (p === d)
        return Hf;
      var _ = e ? --d : p++;
      return h && h[_];
    };
  }
  function c(a, f, h) {
    var p, d = a && a.array, _ = h > r ? 0 : r - h >> f, m = (n - h >> f) + 1;
    return m > eo && (m = eo), function() {
      for (; ; ) {
        if (p) {
          var b = p();
          if (b !== Hf)
            return b;
          p = null;
        }
        if (_ === m)
          return Hf;
        var O = e ? --m : _++;
        p = s(
          d && d[O],
          f - $e,
          h + (O << f)
        );
      }
    };
  }
}
function Rl(t, e, r, n, i, o, s) {
  var u = Object.create(qr);
  return u.size = e - t, u._origin = t, u._capacity = e, u._level = r, u._root = n, u._tail = i, u.__ownerID = o, u.__hash = s, u.__altered = !1, u;
}
var pS;
function dp() {
  return pS || (pS = Rl(0, 0, $e));
}
function _L(t, e, r) {
  if (e = za(t, e), e !== e)
    return t;
  if (e >= t.size || e < 0)
    return t.withMutations(function(s) {
      e < 0 ? ba(s, e).set(0, r) : ba(s, 0, e + 1).set(e, r);
    });
  e += t._origin;
  var n = t._tail, i = t._root, o = O_();
  return e >= xl(t._capacity) ? n = T_(n, t.__ownerID, 0, e, r, o) : i = T_(
    i,
    t.__ownerID,
    t._level,
    e,
    r,
    o
  ), o.value ? t.__ownerID ? (t._root = i, t._tail = n, t.__hash = void 0, t.__altered = !0, t) : Rl(t._origin, t._capacity, t._level, i, n) : t;
}
function T_(t, e, r, n, i, o) {
  var s = n >>> r & Nn, u = t && s < t.array.length;
  if (!u && i === void 0)
    return t;
  var c;
  if (r > 0) {
    var a = t && t.array[s], f = T_(
      a,
      e,
      r - $e,
      n,
      i,
      o
    );
    return f === a ? t : (c = Sc(t, e), c.array[s] = f, c);
  }
  return u && t.array[s] === i ? t : (o && ro(o), c = Sc(t, e), i === void 0 && s === c.array.length - 1 ? c.array.pop() : c.array[s] = i, c);
}
function Sc(t, e) {
  return e && t && e === t.ownerID ? t : new Ta(t ? t.array.slice() : [], e);
}
function jx(t, e) {
  if (e >= xl(t._capacity))
    return t._tail;
  if (e < 1 << t._level + $e) {
    for (var r = t._root, n = t._level; r && n > 0; )
      r = r.array[e >>> n & Nn], n -= $e;
    return r;
  }
}
function ba(t, e, r) {
  e !== void 0 && (e |= 0), r !== void 0 && (r |= 0);
  var n = t.__ownerID || new Pg(), i = t._origin, o = t._capacity, s = i + e, u = r === void 0 ? o : r < 0 ? o + r : i + r;
  if (s === i && u === o)
    return t;
  if (s >= u)
    return t.clear();
  for (var c = t._level, a = t._root, f = 0; s + f < 0; )
    a = new Ta(
      a && a.array.length ? [void 0, a] : [],
      n
    ), c += $e, f += 1 << c;
  f && (s += f, i += f, u += f, o += f);
  for (var h = xl(o), p = xl(u); p >= 1 << c + $e; )
    a = new Ta(
      a && a.array.length ? [a] : [],
      n
    ), c += $e;
  var d = t._tail, _ = p < h ? jx(t, u - 1) : p > h ? new Ta([], n) : d;
  if (d && p > h && s < o && d.array.length) {
    a = Sc(a, n);
    for (var m = a, b = c; b > $e; b -= $e) {
      var O = h >>> b & Nn;
      m = m.array[O] = Sc(m.array[O], n);
    }
    m.array[h >>> $e & Nn] = d;
  }
  if (u < o && (_ = _ && _.removeAfter(n, 0, u)), s >= p)
    s -= p, u -= p, c = $e, a = null, _ = _ && _.removeBefore(n, 0, s);
  else if (s > i || p < h) {
    for (f = 0; a; ) {
      var S = s >>> c & Nn;
      if (S !== p >>> c & Nn)
        break;
      S && (f += (1 << c) * S), c -= $e, a = a.array[S];
    }
    a && s > i && (a = a.removeBefore(n, c, s - f)), a && p < h && (a = a.removeAfter(
      n,
      c,
      p - f
    )), f && (s -= f, u -= f);
  }
  return t.__ownerID ? (t.size = u - s, t._origin = s, t._capacity = u, t._level = c, t._root = a, t._tail = _, t.__hash = void 0, t.__altered = !0, t) : Rl(s, u, c, a, _);
}
function xl(t) {
  return t < eo ? 0 : t - 1 >>> $e << $e;
}
var ua = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? $f() : fx(r) ? r : $f().withMutations(function(n) {
      var i = po(r);
      no(i.size), i.forEach(function(o, s) {
        return n.set(s, o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, e.prototype.get = function(r, n) {
    var i = this._map.get(r);
    return i !== void 0 ? this._list.get(i)[1] : n;
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : $f();
  }, e.prototype.set = function(r, n) {
    return vS(this, r, n);
  }, e.prototype.remove = function(r) {
    return vS(this, r, ve);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._list.__iterate(
      function(o) {
        return o && r(o[1], o[0], i);
      },
      n
    );
  }, e.prototype.__iterator = function(r, n) {
    return this._list.fromEntrySeq().__iterator(r, n);
  }, e.prototype.__ensureOwner = function(r) {
    if (r === this.__ownerID)
      return this;
    var n = this._map.__ensureOwner(r), i = this._list.__ensureOwner(r);
    return r ? e1(n, i, r, this.__hash) : this.size === 0 ? $f() : (this.__ownerID = r, this.__altered = !1, this._map = n, this._list = i, this);
  }, e;
}(lf);
ua.isOrderedMap = fx;
ua.prototype[af] = !0;
ua.prototype[fh] = ua.prototype.remove;
function e1(t, e, r, n) {
  var i = Object.create(ua.prototype);
  return i.size = t ? t.size : 0, i._map = t, i._list = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var dS;
function $f() {
  return dS || (dS = e1(Oo(), dp()));
}
function vS(t, e, r) {
  var n = t._map, i = t._list, o = n.get(e), s = o !== void 0, u, c;
  if (r === ve) {
    if (!s)
      return t;
    i.size >= eo && i.size >= n.size * 2 ? (c = i.filter(function(a, f) {
      return a !== void 0 && o !== f;
    }), u = c.toKeyedSeq().map(function(a) {
      return a[0];
    }).flip().toMap(), t.__ownerID && (u.__ownerID = c.__ownerID = t.__ownerID)) : (u = n.remove(e), c = o === i.size - 1 ? i.pop() : i.set(o, void 0));
  } else if (s) {
    if (r === i.get(o)[1])
      return t;
    u = n, c = i.set(o, [e, r]);
  } else
    u = n.set(e, i.size), c = i.set(i.size, [e, r]);
  return t.__ownerID ? (t.size = u.size, t._map = u, t._list = c, t.__hash = void 0, t.__altered = !0, t) : e1(u, c);
}
var qx = "@@__IMMUTABLE_STACK__@@";
function P_(t) {
  return !!(t && t[qx]);
}
var r1 = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Zh() : P_(r) ? r : Zh().pushAll(r);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, e.prototype.get = function(r, n) {
    var i = this._head;
    for (r = za(this, r); i && r--; )
      i = i.next;
    return i ? i.value : n;
  }, e.prototype.peek = function() {
    return this._head && this._head.value;
  }, e.prototype.push = function() {
    var r = arguments;
    if (arguments.length === 0)
      return this;
    for (var n = this.size + arguments.length, i = this._head, o = arguments.length - 1; o >= 0; o--)
      i = {
        value: r[o],
        next: i
      };
    return this.__ownerID ? (this.size = n, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Kf(n, i);
  }, e.prototype.pushAll = function(r) {
    if (r = t(r), r.size === 0)
      return this;
    if (this.size === 0 && P_(r))
      return r;
    no(r.size);
    var n = this.size, i = this._head;
    return r.__iterate(
      function(o) {
        n++, i = {
          value: o,
          next: i
        };
      },
      /* reverse */
      !0
    ), this.__ownerID ? (this.size = n, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Kf(n, i);
  }, e.prototype.pop = function() {
    return this.slice(1);
  }, e.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Zh();
  }, e.prototype.slice = function(r, n) {
    if (Wd(r, n, this.size))
      return this;
    var i = lh(r, this.size), o = Hd(n, this.size);
    if (o !== this.size)
      return t.prototype.slice.call(this, r, n);
    for (var s = this.size - i, u = this._head; i--; )
      u = u.next;
    return this.__ownerID ? (this.size = s, this._head = u, this.__hash = void 0, this.__altered = !0, this) : Kf(s, u);
  }, e.prototype.__ensureOwner = function(r) {
    return r === this.__ownerID ? this : r ? Kf(this.size, this._head, r, this.__hash) : this.size === 0 ? Zh() : (this.__ownerID = r, this.__altered = !1, this);
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    if (n)
      return new uu(this.toArray()).__iterate(
        function(u, c) {
          return r(u, c, i);
        },
        n
      );
    for (var o = 0, s = this._head; s && r(s.value, o++, this) !== !1; )
      s = s.next;
    return o;
  }, e.prototype.__iterator = function(r, n) {
    if (n)
      return new uu(this.toArray()).__iterator(r, n);
    var i = 0, o = this._head;
    return new Ee(function() {
      if (o) {
        var s = o.value;
        return o = o.next, wr(r, i++, s);
      }
      return yi();
    });
  }, e;
}(Au);
r1.isStack = P_;
var $n = r1.prototype;
$n[qx] = !0;
$n.shift = $n.pop;
$n.unshift = $n.push;
$n.unshiftAll = $n.pushAll;
$n.withMutations = ph;
$n.wasAltered = Jg;
$n.asImmutable = vh;
$n["@@transducer/init"] = $n.asMutable = dh;
$n["@@transducer/step"] = function(t, e) {
  return t.unshift(e);
};
$n["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
function Kf(t, e, r, n) {
  var i = Object.create($n);
  return i.size = t, i._head = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}
var yS;
function Zh() {
  return yS || (yS = Kf(0));
}
var Mx = "@@__IMMUTABLE_SET__@@";
function n1(t) {
  return !!(t && t[Mx]);
}
function Fx(t) {
  return n1(t) && xo(t);
}
function Nx(t, e) {
  if (t === e)
    return !0;
  if (!vi(e) || t.size !== void 0 && e.size !== void 0 && t.size !== e.size || t.__hash !== void 0 && e.__hash !== void 0 && t.__hash !== e.__hash || yr(t) !== yr(e) || si(t) !== si(e) || xo(t) !== xo(e))
    return !1;
  if (t.size === 0 && e.size === 0)
    return !0;
  var r = !Jd(t);
  if (xo(t)) {
    var n = t.entries();
    return e.every(function(c, a) {
      var f = n.next().value;
      return f && Ai(f[1], c) && (r || Ai(f[0], a));
    }) && n.next().done;
  }
  var i = !1;
  if (t.size === void 0)
    if (e.size === void 0)
      typeof t.cacheResult == "function" && t.cacheResult();
    else {
      i = !0;
      var o = t;
      t = e, e = o;
    }
  var s = !0, u = e.__iterate(function(c, a) {
    if (r ? !t.has(c) : i ? !Ai(c, t.get(a, ve)) : !Ai(t.get(a, ve), c))
      return s = !1, !1;
  });
  return s && t.size === u;
}
function Du(t, e) {
  var r = function(n) {
    t.prototype[n] = e[n];
  };
  return Object.keys(e).forEach(r), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(r), t;
}
function $p(t) {
  if (!t || typeof t != "object")
    return t;
  if (!vi(t)) {
    if (!La(t))
      return t;
    t = Pi(t);
  }
  if (yr(t)) {
    var e = {};
    return t.__iterate(function(n, i) {
      e[i] = $p(n);
    }), e;
  }
  var r = [];
  return t.__iterate(function(n) {
    r.push($p(n));
  }), r;
}
var nv = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? Vf() : n1(r) && !xo(r) ? r : Vf().withMutations(function(n) {
      var i = t(r);
      no(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(r) {
    return this(po(r).keySeq());
  }, e.intersect = function(r) {
    return r = Dr(r).toArray(), r.length ? nn.intersect.apply(e(r.pop()), r) : Vf();
  }, e.union = function(r) {
    return r = Dr(r).toArray(), r.length ? nn.union.apply(e(r.pop()), r) : Vf();
  }, e.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, e.prototype.has = function(r) {
    return this._map.has(r);
  }, e.prototype.add = function(r) {
    return Xh(this, this._map.set(r, r));
  }, e.prototype.remove = function(r) {
    return Xh(this, this._map.remove(r));
  }, e.prototype.clear = function() {
    return Xh(this, this._map.clear());
  }, e.prototype.map = function(r, n) {
    var i = this, o = !1, s = Xh(
      this,
      this._map.mapEntries(function(u) {
        var c = u[1], a = r.call(n, c, c, i);
        return a !== c && (o = !0), [a, a];
      }, n)
    );
    return o ? s : this;
  }, e.prototype.union = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    return r = r.filter(function(i) {
      return i.size !== 0;
    }), r.length === 0 ? this : this.size === 0 && !this.__ownerID && r.length === 1 ? this.constructor(r[0]) : this.withMutations(function(i) {
      for (var o = 0; o < r.length; o++)
        typeof r[o] == "string" ? i.add(r[o]) : t(r[o]).forEach(function(s) {
          return i.add(s);
        });
    });
  }, e.prototype.intersect = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (r.length === 0)
      return this;
    r = r.map(function(o) {
      return t(o);
    });
    var i = [];
    return this.forEach(function(o) {
      r.every(function(s) {
        return s.includes(o);
      }) || i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(s) {
        o.remove(s);
      });
    });
  }, e.prototype.subtract = function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (r.length === 0)
      return this;
    r = r.map(function(o) {
      return t(o);
    });
    var i = [];
    return this.forEach(function(o) {
      r.some(function(s) {
        return s.includes(o);
      }) && i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(s) {
        o.remove(s);
      });
    });
  }, e.prototype.sort = function(r) {
    return Tl(bc(this, r));
  }, e.prototype.sortBy = function(r, n) {
    return Tl(bc(this, n, r));
  }, e.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, e.prototype.__iterate = function(r, n) {
    var i = this;
    return this._map.__iterate(function(o) {
      return r(o, o, i);
    }, n);
  }, e.prototype.__iterator = function(r, n) {
    return this._map.__iterator(r, n);
  }, e.prototype.__ensureOwner = function(r) {
    if (r === this.__ownerID)
      return this;
    var n = this._map.__ensureOwner(r);
    return r ? this.__make(n, r) : this.size === 0 ? this.__empty() : (this.__ownerID = r, this._map = n, this);
  }, e;
}(of);
nv.isSet = n1;
var nn = nv.prototype;
nn[Mx] = !0;
nn[fh] = nn.remove;
nn.merge = nn.concat = nn.union;
nn.withMutations = ph;
nn.asImmutable = vh;
nn["@@transducer/init"] = nn.asMutable = dh;
nn["@@transducer/step"] = function(t, e) {
  return t.add(e);
};
nn["@@transducer/result"] = function(t) {
  return t.asImmutable();
};
nn.__empty = Vf;
nn.__make = zx;
function Xh(t, e) {
  return t.__ownerID ? (t.size = e.size, t._map = e, t) : e === t._map ? t : e.size === 0 ? t.__empty() : t.__make(e);
}
function zx(t, e) {
  var r = Object.create(nn);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var _S;
function Vf() {
  return _S || (_S = zx(Oo()));
}
var mL = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    if (!(this instanceof e))
      return new e(r, n, i);
    if (Bg(i !== 0, "Cannot step a Range by 0"), r = r || 0, n === void 0 && (n = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), n < r && (i = -i), this._start = r, this._end = n, this._step = i, this.size = Math.max(0, Math.ceil((n - r) / i - 1) + 1), this.size === 0) {
      if (gy)
        return gy;
      gy = this;
    }
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, e.prototype.get = function(r, n) {
    return this.has(r) ? this._start + za(this, r) * this._step : n;
  }, e.prototype.includes = function(r) {
    var n = (r - this._start) / this._step;
    return n >= 0 && n < this.size && n === Math.floor(n);
  }, e.prototype.slice = function(r, n) {
    return Wd(r, n, this.size) ? this : (r = lh(r, this.size), n = Hd(n, this.size), n <= r ? new e(0, 0) : new e(
      this.get(r, this._end),
      this.get(n, this._end),
      this._step
    ));
  }, e.prototype.indexOf = function(r) {
    var n = r - this._start;
    if (n % this._step === 0) {
      var i = n / this._step;
      if (i >= 0 && i < this.size)
        return i;
    }
    return -1;
  }, e.prototype.lastIndexOf = function(r) {
    return this.indexOf(r);
  }, e.prototype.__iterate = function(r, n) {
    for (var i = this.size, o = this._step, s = n ? this._start + (i - 1) * o : this._start, u = 0; u !== i && r(s, n ? i - ++u : u++, this) !== !1; )
      s += n ? -o : o;
    return u;
  }, e.prototype.__iterator = function(r, n) {
    var i = this.size, o = this._step, s = n ? this._start + (i - 1) * o : this._start, u = 0;
    return new Ee(function() {
      if (u === i)
        return yi();
      var c = s;
      return s += n ? -o : o, wr(r, n ? i - ++u : u++, c);
    });
  }, e.prototype.equals = function(r) {
    return r instanceof e ? this._start === r._start && this._end === r._end && this._step === r._step : Nx(this, r);
  }, e;
}(zo), gy;
function Lx(t, e, r) {
  for (var n = wx(e), i = 0; i !== n.length; )
    if (t = Ex(t, n[i++], ve), t === ve)
      return r;
  return t;
}
function Ux(t, e) {
  return Lx(this, t, e);
}
function gL(t, e) {
  return Lx(t, e, ve) !== ve;
}
function bL(t) {
  return gL(this, t);
}
function Bx() {
  no(this.size);
  var t = {};
  return this.__iterate(function(e, r) {
    t[r] = e;
  }), t;
}
Dr.isIterable = vi;
Dr.isKeyed = yr;
Dr.isIndexed = si;
Dr.isAssociative = Jd;
Dr.isOrdered = xo;
Dr.Iterator = Ee;
Du(Dr, {
  // ### Conversion to other types
  toArray: function() {
    no(this.size);
    var t = new Array(this.size || 0), e = yr(this), r = 0;
    return this.__iterate(function(n, i) {
      t[r++] = e ? [i, n] : n;
    }), t;
  },
  toIndexedSeq: function() {
    return new hx(this);
  },
  toJS: function() {
    return $p(this);
  },
  toKeyedSeq: function() {
    return new ev(this, !0);
  },
  toMap: function() {
    return lf(this.toKeyedSeq());
  },
  toObject: Bx,
  toOrderedMap: function() {
    return ua(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Tl(yr(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return nv(yr(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new px(this);
  },
  toSeq: function() {
    return si(this) ? this.toIndexedSeq() : yr(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return r1(yr(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return rv(yr(this) ? this.valueSeq() : this);
  },
  // ### Common JavaScript methods and properties
  toString: function() {
    return "[Collection]";
  },
  __toString: function(t, e) {
    return this.size === 0 ? t + e : t + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  concat: function() {
    for (var t = [], e = arguments.length; e--; )
      t[e] = arguments[e];
    return ke(this, Hz(this, t));
  },
  includes: function(t) {
    return this.some(function(e) {
      return Ai(e, t);
    });
  },
  entries: function() {
    return this.__iterator(uo);
  },
  every: function(t, e) {
    no(this.size);
    var r = !0;
    return this.__iterate(function(n, i, o) {
      if (!t.call(e, n, i, o))
        return r = !1, !1;
    }), r;
  },
  filter: function(t, e) {
    return ke(this, _x(this, t, e, !0));
  },
  partition: function(t, e) {
    return Gz(this, t, e);
  },
  find: function(t, e, r) {
    var n = this.findEntry(t, e);
    return n ? n[1] : r;
  },
  forEach: function(t, e) {
    return no(this.size), this.__iterate(e ? t.bind(e) : t);
  },
  join: function(t) {
    no(this.size), t = t !== void 0 ? "" + t : ",";
    var e = "", r = !0;
    return this.__iterate(function(n) {
      r ? r = !1 : e += t, e += n != null ? n.toString() : "";
    }), e;
  },
  keys: function() {
    return this.__iterator(hh);
  },
  map: function(t, e) {
    return ke(this, yx(this, t, e));
  },
  reduce: function(t, e, r) {
    return mS(
      this,
      t,
      e,
      r,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(t, e, r) {
    return mS(
      this,
      t,
      e,
      r,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return ke(this, Ng(this, !0));
  },
  slice: function(t, e) {
    return ke(this, zg(this, t, e, !0));
  },
  some: function(t, e) {
    return !this.every(tp(t), e);
  },
  sort: function(t) {
    return ke(this, bc(this, t));
  },
  values: function() {
    return this.__iterator(jo);
  },
  // ### More sequential methods
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(t, e) {
    return gc(
      t ? this.toSeq().filter(t, e) : this
    );
  },
  countBy: function(t, e) {
    return Qz(this, t, e);
  },
  equals: function(t) {
    return Nx(this, t);
  },
  entrySeq: function() {
    var t = this;
    if (t._cache)
      return new uu(t._cache);
    var e = t.toSeq().map(EL).toIndexedSeq();
    return e.fromEntrySeq = function() {
      return t.toSeq();
    }, e;
  },
  filterNot: function(t, e) {
    return this.filter(tp(t), e);
  },
  findEntry: function(t, e, r) {
    var n = r;
    return this.__iterate(function(i, o, s) {
      if (t.call(e, i, o, s))
        return n = [o, i], !1;
    }), n;
  },
  findKey: function(t, e) {
    var r = this.findEntry(t, e);
    return r && r[0];
  },
  findLast: function(t, e, r) {
    return this.toKeyedSeq().reverse().find(t, e, r);
  },
  findLastEntry: function(t, e, r) {
    return this.toKeyedSeq().reverse().findEntry(t, e, r);
  },
  findLastKey: function(t, e) {
    return this.toKeyedSeq().reverse().findKey(t, e);
  },
  first: function(t) {
    return this.find(JR, null, t);
  },
  flatMap: function(t, e) {
    return ke(this, Jz(this, t, e));
  },
  flatten: function(t) {
    return ke(this, gx(this, t, !0));
  },
  fromEntrySeq: function() {
    return new dx(this);
  },
  get: function(t, e) {
    return this.find(function(r, n) {
      return Ai(n, t);
    }, void 0, e);
  },
  getIn: Ux,
  groupBy: function(t, e) {
    return Yz(this, t, e);
  },
  has: function(t) {
    return this.get(t, ve) !== ve;
  },
  hasIn: bL,
  isSubset: function(t) {
    return t = typeof t.includes == "function" ? t : Dr(t), this.every(function(e) {
      return t.includes(e);
    });
  },
  isSuperset: function(t) {
    return t = typeof t.isSubset == "function" ? t : Dr(t), t.isSubset(this);
  },
  keyOf: function(t) {
    return this.findKey(function(e) {
      return Ai(e, t);
    });
  },
  keySeq: function() {
    return this.toSeq().map(wL).toIndexedSeq();
  },
  last: function(t) {
    return this.toSeq().reverse().first(t);
  },
  lastKeyOf: function(t) {
    return this.toKeyedSeq().reverse().keyOf(t);
  },
  max: function(t) {
    return Hh(this, t);
  },
  maxBy: function(t, e) {
    return Hh(this, e, t);
  },
  min: function(t) {
    return Hh(
      this,
      t ? gS(t) : wS
    );
  },
  minBy: function(t, e) {
    return Hh(
      this,
      e ? gS(e) : wS,
      t
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(t) {
    return t === 0 ? this : this.slice(Math.max(0, t));
  },
  skipLast: function(t) {
    return t === 0 ? this : this.slice(0, -Math.max(0, t));
  },
  skipWhile: function(t, e) {
    return ke(this, mx(this, t, e, !0));
  },
  skipUntil: function(t, e) {
    return this.skipWhile(tp(t), e);
  },
  sortBy: function(t, e) {
    return ke(this, bc(this, e, t));
  },
  take: function(t) {
    return this.slice(0, Math.max(0, t));
  },
  takeLast: function(t) {
    return this.slice(-Math.max(0, t));
  },
  takeWhile: function(t, e) {
    return ke(this, Wz(this, t, e));
  },
  takeUntil: function(t, e) {
    return this.takeWhile(tp(t), e);
  },
  update: function(t) {
    return t(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  // ### Hashable Object
  hashCode: function() {
    return this.__hash || (this.__hash = SL(this));
  }
  // ### Internal
  // abstract __iterate(fn, reverse)
  // abstract __iterator(type, reverse)
});
var xn = Dr.prototype;
xn[tx] = !0;
xn[Zd] = xn.values;
xn.toJSON = xn.toArray;
xn.__toStringMapper = Il;
xn.inspect = xn.toSource = function() {
  return this.toString();
};
xn.chain = xn.flatMap;
xn.contains = xn.includes;
Du(po, {
  // ### More sequential methods
  flip: function() {
    return ke(this, vx(this));
  },
  mapEntries: function(t, e) {
    var r = this, n = 0;
    return ke(
      this,
      this.toSeq().map(function(i, o) {
        return t.call(e, [o, i], n++, r);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(t, e) {
    var r = this;
    return ke(
      this,
      this.toSeq().flip().map(function(n, i) {
        return t.call(e, n, i, r);
      }).flip()
    );
  }
});
var yh = po.prototype;
yh[ex] = !0;
yh[Zd] = xn.entries;
yh.toJSON = Bx;
yh.__toStringMapper = function(t, e) {
  return Il(e) + ": " + Il(t);
};
Du(Au, {
  // ### Conversion to other types
  toKeyedSeq: function() {
    return new ev(this, !1);
  },
  // ### ES6 Collection methods (ES6 Array and Map)
  filter: function(t, e) {
    return ke(this, _x(this, t, e, !1));
  },
  findIndex: function(t, e) {
    var r = this.findEntry(t, e);
    return r ? r[0] : -1;
  },
  indexOf: function(t) {
    var e = this.keyOf(t);
    return e === void 0 ? -1 : e;
  },
  lastIndexOf: function(t) {
    var e = this.lastKeyOf(t);
    return e === void 0 ? -1 : e;
  },
  reverse: function() {
    return ke(this, Ng(this, !1));
  },
  slice: function(t, e) {
    return ke(this, zg(this, t, e, !1));
  },
  splice: function(t, e) {
    var r = arguments.length;
    if (e = Math.max(e || 0, 0), r === 0 || r === 2 && !e)
      return this;
    t = lh(t, t < 0 ? this.count() : this.size);
    var n = this.slice(0, t);
    return ke(
      this,
      r === 1 ? n : n.concat(Wo(arguments, 2), this.slice(t + e))
    );
  },
  // ### More collection methods
  findLastIndex: function(t, e) {
    var r = this.findLastEntry(t, e);
    return r ? r[0] : -1;
  },
  first: function(t) {
    return this.get(0, t);
  },
  flatten: function(t) {
    return ke(this, gx(this, t, !1));
  },
  get: function(t, e) {
    return t = za(this, t), t < 0 || this.size === 1 / 0 || this.size !== void 0 && t > this.size ? e : this.find(function(r, n) {
      return n === t;
    }, void 0, e);
  },
  has: function(t) {
    return t = za(this, t), t >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || t < this.size : this.indexOf(t) !== -1);
  },
  interpose: function(t) {
    return ke(this, Zz(this, t));
  },
  interleave: function() {
    var t = [this].concat(Wo(arguments)), e = Jh(this.toSeq(), zo.of, t), r = e.flatten(!0);
    return e.size && (r.size = e.size * t.length), ke(this, r);
  },
  keySeq: function() {
    return mL(0, this.size);
  },
  last: function(t) {
    return this.get(-1, t);
  },
  skipWhile: function(t, e) {
    return ke(this, mx(this, t, e, !1));
  },
  zip: function() {
    var t = [this].concat(Wo(arguments));
    return ke(this, Jh(this, bS, t));
  },
  zipAll: function() {
    var t = [this].concat(Wo(arguments));
    return ke(this, Jh(this, bS, t, !0));
  },
  zipWith: function(t) {
    var e = Wo(arguments);
    return e[0] = this, ke(this, Jh(this, t, e));
  }
});
var hf = Au.prototype;
hf[rx] = !0;
hf[af] = !0;
Du(of, {
  // ### ES6 Collection methods (ES6 Array and Map)
  get: function(t, e) {
    return this.has(t) ? t : e;
  },
  includes: function(t) {
    return this.has(t);
  },
  // ### More sequential methods
  keySeq: function() {
    return this.valueSeq();
  }
});
var Oc = of.prototype;
Oc.has = xn.includes;
Oc.contains = Oc.includes;
Oc.keys = Oc.values;
Du(Va, yh);
Du(zo, hf);
Du(cf, Oc);
function mS(t, e, r, n, i, o) {
  return no(t.size), t.__iterate(function(s, u, c) {
    i ? (i = !1, r = s) : r = e.call(n, r, s, u, c);
  }, o), r;
}
function wL(t, e) {
  return e;
}
function EL(t, e) {
  return [e, t];
}
function tp(t) {
  return function() {
    return !t.apply(this, arguments);
  };
}
function gS(t) {
  return function() {
    return -t.apply(this, arguments);
  };
}
function bS() {
  return Wo(arguments);
}
function wS(t, e) {
  return t < e ? 1 : t > e ? -1 : 0;
}
function SL(t) {
  if (t.size === 1 / 0)
    return 0;
  var e = xo(t), r = yr(t), n = e ? 1 : 0, i = t.__iterate(
    r ? e ? function(o, s) {
      n = 31 * n + ES(wi(o), wi(s)) | 0;
    } : function(o, s) {
      n = n + ES(wi(o), wi(s)) | 0;
    } : e ? function(o) {
      n = 31 * n + wi(o) | 0;
    } : function(o) {
      n = n + wi(o) | 0;
    }
  );
  return OL(i, n);
}
function OL(t, e) {
  return e = Af(e, 3432918353), e = Af(e << 15 | e >>> -15, 461845907), e = Af(e << 13 | e >>> -13, 5), e = (e + 3864292196 | 0) ^ t, e = Af(e ^ e >>> 16, 2246822507), e = Af(e ^ e >>> 13, 3266489909), e = tv(e ^ e >>> 16), e;
}
function ES(t, e) {
  return t ^ e + 2654435769 + (t << 6) + (t >> 2) | 0;
}
var Tl = /* @__PURE__ */ function(t) {
  function e(r) {
    return r == null ? k_() : Fx(r) ? r : k_().withMutations(function(n) {
      var i = of(r);
      no(i.size), i.forEach(function(o) {
        return n.add(o);
      });
    });
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function() {
    return this(arguments);
  }, e.fromKeys = function(r) {
    return this(po(r).keySeq());
  }, e.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, e;
}(nv);
Tl.isOrderedSet = Fx;
var Ru = Tl.prototype;
Ru[af] = !0;
Ru.zip = hf.zip;
Ru.zipWith = hf.zipWith;
Ru.zipAll = hf.zipAll;
Ru.__empty = k_;
Ru.__make = $x;
function $x(t, e) {
  var r = Object.create(Ru);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}
var SS;
function k_() {
  return SS || (SS = $x($f()));
}
function IL(t) {
  if (sf(t))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (as(t))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (t === null || typeof t != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var Xt = function(t, e) {
  var r;
  IL(t);
  var n = function(o) {
    var s = this;
    if (o instanceof n)
      return o;
    if (!(this instanceof n))
      return new n(o);
    if (!r) {
      r = !0;
      var u = Object.keys(t), c = i._indices = {};
      i._name = e, i._keys = u, i._defaultValues = t;
      for (var a = 0; a < u.length; a++) {
        var f = u[a];
        c[f] = a, i[f] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + o1(this) + ' with property "' + f + '" since that property name is part of the Record API.'
        ) : AL(i, f);
      }
    }
    return this.__ownerID = void 0, this._values = rv().withMutations(function(h) {
      h.setSize(s._keys.length), po(o).forEach(function(p, d) {
        h.set(s._indices[d], p === s._defaultValues[d] ? void 0 : p);
      });
    }), this;
  }, i = n.prototype = Object.create(Ne);
  return i.constructor = n, e && (n.displayName = e), n;
};
Xt.prototype.toString = function() {
  for (var t = o1(this) + " { ", e = this._keys, r, n = 0, i = e.length; n !== i; n++)
    r = e[n], t += (n ? ", " : "") + r + ": " + Il(this.get(r));
  return t + " }";
};
Xt.prototype.equals = function(t) {
  return this === t || sf(t) && Ic(this).equals(Ic(t));
};
Xt.prototype.hashCode = function() {
  return Ic(this).hashCode();
};
Xt.prototype.has = function(t) {
  return this._indices.hasOwnProperty(t);
};
Xt.prototype.get = function(t, e) {
  if (!this.has(t))
    return e;
  var r = this._indices[t], n = this._values.get(r);
  return n === void 0 ? this._defaultValues[t] : n;
};
Xt.prototype.set = function(t, e) {
  if (this.has(t)) {
    var r = this._values.set(
      this._indices[t],
      e === this._defaultValues[t] ? void 0 : e
    );
    if (r !== this._values && !this.__ownerID)
      return i1(this, r);
  }
  return this;
};
Xt.prototype.remove = function(t) {
  return this.set(t);
};
Xt.prototype.clear = function() {
  var t = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : i1(this, t);
};
Xt.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
Xt.prototype.toSeq = function() {
  return Ic(this);
};
Xt.prototype.toJS = function() {
  return $p(this);
};
Xt.prototype.entries = function() {
  return this.__iterator(uo);
};
Xt.prototype.__iterator = function(t, e) {
  return Ic(this).__iterator(t, e);
};
Xt.prototype.__iterate = function(t, e) {
  return Ic(this).__iterate(t, e);
};
Xt.prototype.__ensureOwner = function(t) {
  if (t === this.__ownerID)
    return this;
  var e = this._values.__ensureOwner(t);
  return t ? i1(this, e, t) : (this.__ownerID = t, this._values = e, this);
};
Xt.isRecord = sf;
Xt.getDescriptiveName = o1;
var Ne = Xt.prototype;
Ne[ix] = !0;
Ne[fh] = Ne.remove;
Ne.deleteIn = Ne.removeIn = Kg;
Ne.getIn = Ux;
Ne.hasIn = xn.hasIn;
Ne.merge = Ix;
Ne.mergeWith = Ax;
Ne.mergeIn = Wg;
Ne.mergeDeep = Rx;
Ne.mergeDeepWith = xx;
Ne.mergeDeepIn = Hg;
Ne.setIn = $g;
Ne.update = Vg;
Ne.updateIn = Qg;
Ne.withMutations = ph;
Ne.asMutable = dh;
Ne.asImmutable = vh;
Ne[Zd] = Ne.entries;
Ne.toJSON = Ne.toObject = xn.toObject;
Ne.inspect = Ne.toSource = function() {
  return this.toString();
};
function i1(t, e, r) {
  var n = Object.create(Object.getPrototypeOf(t));
  return n._values = e, n.__ownerID = r, n;
}
function o1(t) {
  return t.constructor.displayName || t.constructor.name || "Record";
}
function Ic(t) {
  return qg(t._keys.map(function(e) {
    return [e, t.get(e)];
  }));
}
function AL(t, e) {
  try {
    Object.defineProperty(t, e, {
      get: function() {
        return this.get(e);
      },
      set: function(r) {
        Bg(this.__ownerID, "Cannot set on an immutable record."), this.set(e, r);
      }
    });
  } catch {
  }
}
const DL = {
  startDate: void 0,
  endDate: void 0,
  userLimit: 0,
  projectLimit: 0,
  isTrial: !1,
  isExpired: !1,
  functionalities: []
};
class RL extends Xt(DL, "Subscription") {
  get isValid() {
    return !!this.startDate && !!this.endDate;
  }
  get isActive() {
    return !this.startDate || !this.endDate ? !1 : new jl(this.startDate, this.endDate).contains(Er.now());
  }
  get daysLeft() {
    return this.endDate ? this.endDate.getAbsoluteDifferenceInDays(Er.now()) : 0;
  }
  hasEndDateIncoming() {
    return this.endDate ? this.endDate.isAfterInDays(Er.now()) : !1;
  }
}
function xL(t) {
  const e = t;
  return e == null ? void 0 : e.code;
}
const TL = 3;
function PL(t, e = TL) {
  return (r, n) => {
    const i = xL(n);
    if (!i)
      return !1;
    let o;
    return Array.isArray(t) ? o = t.includes(i) : o = t === i, r <= e && o;
  };
}
const kL = new RL();
Mr({
  isInitialized: !1,
  isLoading: !1,
  error: void 0,
  retry: () => Promise.resolve(),
  subscription: kL,
  hasFunctionality: () => !1
});
PL(LN.TOO_MANY_REQUESTS);
Se.createContext({
  i18n: void 0
});
var CL = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(t) {
  (function(e, r) {
    t.exports ? t.exports = r() : e.numeral = r();
  })(Bf, function() {
    var e, r, n = "2.0.6", i = {}, o = {}, s = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, u = {
      currentLocale: s.currentLocale,
      zeroFormat: s.zeroFormat,
      nullFormat: s.nullFormat,
      defaultFormat: s.defaultFormat,
      scalePercentBy100: s.scalePercentBy100
    };
    function c(a, f) {
      this._input = a, this._value = f;
    }
    return e = function(a) {
      var f, h, p, d;
      if (e.isNumeral(a))
        f = a.value();
      else if (a === 0 || typeof a > "u")
        f = 0;
      else if (a === null || r.isNaN(a))
        f = null;
      else if (typeof a == "string")
        if (u.zeroFormat && a === u.zeroFormat)
          f = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          f = null;
        else {
          for (h in i)
            if (d = typeof i[h].regexps.unformat == "function" ? i[h].regexps.unformat() : i[h].regexps.unformat, d && a.match(d)) {
              p = i[h].unformat;
              break;
            }
          p = p || e._.stringToNumber, f = p(a);
        }
      else
        f = Number(a) || null;
      return new c(a, f);
    }, e.version = n, e.isNumeral = function(a) {
      return a instanceof c;
    }, e._ = r = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(a, f, h) {
        var p = o[e.options.currentLocale], d = !1, _ = !1, m = 0, b = "", O = 1e12, S = 1e9, k = 1e6, T = 1e3, x = "", P = !1, R, D, I, j, Y, H, B;
        if (a = a || 0, D = Math.abs(a), e._.includes(f, "(") ? (d = !0, f = f.replace(/[\(|\)]/g, "")) : (e._.includes(f, "+") || e._.includes(f, "-")) && (Y = e._.includes(f, "+") ? f.indexOf("+") : a < 0 ? f.indexOf("-") : -1, f = f.replace(/[\+|\-]/g, "")), e._.includes(f, "a") && (R = f.match(/a(k|m|b|t)?/), R = R ? R[1] : !1, e._.includes(f, " a") && (b = " "), f = f.replace(new RegExp(b + "a[kmbt]?"), ""), D >= O && !R || R === "t" ? (b += p.abbreviations.trillion, a = a / O) : D < O && D >= S && !R || R === "b" ? (b += p.abbreviations.billion, a = a / S) : D < S && D >= k && !R || R === "m" ? (b += p.abbreviations.million, a = a / k) : (D < k && D >= T && !R || R === "k") && (b += p.abbreviations.thousand, a = a / T)), e._.includes(f, "[.]") && (_ = !0, f = f.replace("[.]", ".")), I = a.toString().split(".")[0], j = f.split(".")[1], H = f.indexOf(","), m = (f.split(".")[0].split(",")[0].match(/0/g) || []).length, j ? (e._.includes(j, "[") ? (j = j.replace("]", ""), j = j.split("["), x = e._.toFixed(a, j[0].length + j[1].length, h, j[1].length)) : x = e._.toFixed(a, j.length, h), I = x.split(".")[0], e._.includes(x, ".") ? x = p.delimiters.decimal + x.split(".")[1] : x = "", _ && Number(x.slice(1)) === 0 && (x = "")) : I = e._.toFixed(a, 0, h), b && !R && Number(I) >= 1e3 && b !== p.abbreviations.trillion)
          switch (I = String(Number(I) / 1e3), b) {
            case p.abbreviations.thousand:
              b = p.abbreviations.million;
              break;
            case p.abbreviations.million:
              b = p.abbreviations.billion;
              break;
            case p.abbreviations.billion:
              b = p.abbreviations.trillion;
              break;
          }
        if (e._.includes(I, "-") && (I = I.slice(1), P = !0), I.length < m)
          for (var tt = m - I.length; tt > 0; tt--)
            I = "0" + I;
        return H > -1 && (I = I.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + p.delimiters.thousands)), f.indexOf(".") === 0 && (I = ""), B = I + x + (b || ""), d ? B = (d && P ? "(" : "") + B + (d && P ? ")" : "") : Y >= 0 ? B = Y === 0 ? (P ? "-" : "+") + B : B + (P ? "-" : "+") : P && (B = "-" + B), B;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(a) {
        var f = o[u.currentLocale], h = a, p = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, d, _, m;
        if (u.zeroFormat && a === u.zeroFormat)
          _ = 0;
        else if (u.nullFormat && a === u.nullFormat || !a.replace(/[^0-9]+/g, "").length)
          _ = null;
        else {
          _ = 1, f.delimiters.decimal !== "." && (a = a.replace(/\./g, "").replace(f.delimiters.decimal, "."));
          for (d in p)
            if (m = new RegExp("[^a-zA-Z]" + f.abbreviations[d] + "(?:\\)|(\\" + f.currency.symbol + ")?(?:\\))?)?$"), h.match(m)) {
              _ *= Math.pow(10, p[d]);
              break;
            }
          _ *= (a.split("-").length + Math.min(a.split("(").length - 1, a.split(")").length - 1)) % 2 ? 1 : -1, a = a.replace(/[^0-9\.]+/g, ""), _ *= Number(a);
        }
        return _;
      },
      isNaN: function(a) {
        return typeof a == "number" && isNaN(a);
      },
      includes: function(a, f) {
        return a.indexOf(f) !== -1;
      },
      insert: function(a, f, h) {
        return a.slice(0, h) + f + a.slice(h);
      },
      reduce: function(a, f) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof f != "function")
          throw new TypeError(f + " is not a function");
        var h = Object(a), p = h.length >>> 0, d = 0, _;
        if (arguments.length === 3)
          _ = arguments[2];
        else {
          for (; d < p && !(d in h); )
            d++;
          if (d >= p)
            throw new TypeError("Reduce of empty array with no initial value");
          _ = h[d++];
        }
        for (; d < p; d++)
          d in h && (_ = f(_, h[d], d, h));
        return _;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(a) {
        var f = a.toString().split(".");
        return f.length < 2 ? 1 : Math.pow(10, f[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var a = Array.prototype.slice.call(arguments);
        return a.reduce(function(f, h) {
          var p = r.multiplier(h);
          return f > p ? f : p;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(a, f, h, p) {
        var d = a.toString().split("."), _ = f - (p || 0), m, b, O, S;
        return d.length === 2 ? m = Math.min(Math.max(d[1].length, _), f) : m = _, O = Math.pow(10, m), S = (h(a + "e+" + m) / O).toFixed(m), p > f - m && (b = new RegExp("\\.?0{1," + (p - (f - m)) + "}$"), S = S.replace(b, "")), S;
      }
    }, e.options = u, e.formats = i, e.locales = o, e.locale = function(a) {
      return a && (u.currentLocale = a.toLowerCase()), u.currentLocale;
    }, e.localeData = function(a) {
      if (!a)
        return o[u.currentLocale];
      if (a = a.toLowerCase(), !o[a])
        throw new Error("Unknown locale : " + a);
      return o[a];
    }, e.reset = function() {
      for (var a in s)
        u[a] = s[a];
    }, e.zeroFormat = function(a) {
      u.zeroFormat = typeof a == "string" ? a : null;
    }, e.nullFormat = function(a) {
      u.nullFormat = typeof a == "string" ? a : null;
    }, e.defaultFormat = function(a) {
      u.defaultFormat = typeof a == "string" ? a : "0.0";
    }, e.register = function(a, f, h) {
      if (f = f.toLowerCase(), this[a + "s"][f])
        throw new TypeError(f + " " + a + " already registered.");
      return this[a + "s"][f] = h, h;
    }, e.validate = function(a, f) {
      var h, p, d, _, m, b, O, S;
      if (typeof a != "string" && (a += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", a)), a = a.trim(), a.match(/^\d+$/))
        return !0;
      if (a === "")
        return !1;
      try {
        O = e.localeData(f);
      } catch {
        O = e.localeData(e.locale());
      }
      return d = O.currency.symbol, m = O.abbreviations, h = O.delimiters.decimal, O.delimiters.thousands === "." ? p = "\\." : p = O.delimiters.thousands, S = a.match(/^[^\d]+/), S !== null && (a = a.substr(1), S[0] !== d) || (S = a.match(/[^\d]+$/), S !== null && (a = a.slice(0, -1), S[0] !== m.thousand && S[0] !== m.million && S[0] !== m.billion && S[0] !== m.trillion)) ? !1 : (b = new RegExp(p + "{2}"), a.match(/[^\d.,]/g) ? !1 : (_ = a.split(h), _.length > 2 ? !1 : _.length < 2 ? !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) : _[0].length === 1 ? !!_[0].match(/^\d+$/) && !_[0].match(b) && !!_[1].match(/^\d+$/) : !!_[0].match(/^\d+.*\d$/) && !_[0].match(b) && !!_[1].match(/^\d+$/)));
    }, e.fn = c.prototype = {
      clone: function() {
        return e(this);
      },
      format: function(a, f) {
        var h = this._value, p = a || u.defaultFormat, d, _, m;
        if (f = f || Math.round, h === 0 && u.zeroFormat !== null)
          _ = u.zeroFormat;
        else if (h === null && u.nullFormat !== null)
          _ = u.nullFormat;
        else {
          for (d in i)
            if (p.match(i[d].regexps.format)) {
              m = i[d].format;
              break;
            }
          m = m || e._.numberToFormat, _ = m(h, p, f);
        }
        return _;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(a) {
        return this._value = Number(a), this;
      },
      add: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p + Math.round(f * d);
        }
        return this._value = r.reduce([this._value, a], h, 0) / f, this;
      },
      subtract: function(a) {
        var f = r.correctionFactor.call(null, this._value, a);
        function h(p, d, _, m) {
          return p - Math.round(f * d);
        }
        return this._value = r.reduce([a], h, Math.round(this._value * f)) / f, this;
      },
      multiply: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) * Math.round(p * m) / Math.round(m * m);
        }
        return this._value = r.reduce([this._value, a], f, 1), this;
      },
      divide: function(a) {
        function f(h, p, d, _) {
          var m = r.correctionFactor(h, p);
          return Math.round(h * m) / Math.round(p * m);
        }
        return this._value = r.reduce([this._value, a], f), this;
      },
      difference: function(a) {
        return Math.abs(e(this._value).subtract(a).value());
      }
    }, e.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(a) {
        var f = a % 10;
        return ~~(a % 100 / 10) === 1 ? "th" : f === 1 ? "st" : f === 2 ? "nd" : f === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      e.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " BPS") ? " " : "", d;
          return a = a * 1e4, f = f.replace(/\s?BPS/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "BPS"), d = d.join("")) : d = d + p + "BPS", d;
        },
        unformat: function(a) {
          return +(e._.stringToNumber(a) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var a = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, f = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, h = a.suffixes.concat(f.suffixes.filter(function(d) {
        return a.suffixes.indexOf(d) < 0;
      })), p = h.join("|");
      p = "(" + p.replace("B", "B(?!PS)") + ")", e.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(p)
        },
        format: function(d, _, m) {
          var b, O = e._.includes(_, "ib") ? f : a, S = e._.includes(_, " b") || e._.includes(_, " ib") ? " " : "", k, T, x;
          for (_ = _.replace(/\s?i?b/, ""), k = 0; k <= O.suffixes.length; k++)
            if (T = Math.pow(O.base, k), x = Math.pow(O.base, k + 1), d === null || d === 0 || d >= T && d < x) {
              S += O.suffixes[k], T > 0 && (d = d / T);
              break;
            }
          return b = e._.numberToFormat(d, _, m), b + S;
        },
        unformat: function(d) {
          var _ = e._.stringToNumber(d), m, b;
          if (_) {
            for (m = a.suffixes.length - 1; m >= 0; m--) {
              if (e._.includes(d, a.suffixes[m])) {
                b = Math.pow(a.base, m);
                break;
              }
              if (e._.includes(d, f.suffixes[m])) {
                b = Math.pow(f.base, m);
                break;
              }
            }
            _ *= b || 1;
          }
          return _;
        }
      });
    }(), function() {
      e.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d = {
            before: f.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: f.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, _, m, b;
          for (f = f.replace(/\s?\$\s?/, ""), _ = e._.numberToFormat(a, f, h), a >= 0 ? (d.before = d.before.replace(/[\-\(]/, ""), d.after = d.after.replace(/[\-\)]/, "")) : a < 0 && !e._.includes(d.before, "-") && !e._.includes(d.before, "(") && (d.before = "-" + d.before), b = 0; b < d.before.length; b++)
            switch (m = d.before[b], m) {
              case "$":
                _ = e._.insert(_, p.currency.symbol, b);
                break;
              case " ":
                _ = e._.insert(_, " ", b + p.currency.symbol.length - 1);
                break;
            }
          for (b = d.after.length - 1; b >= 0; b--)
            switch (m = d.after[b], m) {
              case "$":
                _ = b === d.after.length - 1 ? _ + p.currency.symbol : e._.insert(_, p.currency.symbol, -(d.after.length - (1 + b)));
                break;
              case " ":
                _ = b === d.after.length - 1 ? _ + " " : e._.insert(_, " ", -(d.after.length - (1 + b) + p.currency.symbol.length - 1));
                break;
            }
          return _;
        }
      });
    }(), function() {
      e.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(a, f, h) {
          var p, d = typeof a == "number" && !e._.isNaN(a) ? a.toExponential() : "0e+0", _ = d.split("e");
          return f = f.replace(/e[\+|\-]{1}0/, ""), p = e._.numberToFormat(Number(_[0]), f, h), p + "e" + _[1];
        },
        unformat: function(a) {
          var f = e._.includes(a, "e+") ? a.split("e+") : a.split("e-"), h = Number(f[0]), p = Number(f[1]);
          p = e._.includes(a, "e-") ? p *= -1 : p;
          function d(_, m, b, O) {
            var S = e._.correctionFactor(_, m), k = _ * S * (m * S) / (S * S);
            return k;
          }
          return e._.reduce([h, Math.pow(10, p)], d, 1);
        }
      });
    }(), function() {
      e.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(a, f, h) {
          var p = e.locales[e.options.currentLocale], d, _ = e._.includes(f, " o") ? " " : "";
          return f = f.replace(/\s?o/, ""), _ += p.ordinal(a), d = e._.numberToFormat(a, f, h), d + _;
        }
      });
    }(), function() {
      e.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(a, f, h) {
          var p = e._.includes(f, " %") ? " " : "", d;
          return e.options.scalePercentBy100 && (a = a * 100), f = f.replace(/\s?\%/, ""), d = e._.numberToFormat(a, f, h), e._.includes(d, ")") ? (d = d.split(""), d.splice(-1, 0, p + "%"), d = d.join("")) : d = d + p + "%", d;
        },
        unformat: function(a) {
          var f = e._.stringToNumber(a);
          return e.options.scalePercentBy100 ? f * 0.01 : f;
        }
      });
    }(), function() {
      e.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(a, f, h) {
          var p = Math.floor(a / 60 / 60), d = Math.floor((a - p * 60 * 60) / 60), _ = Math.round(a - p * 60 * 60 - d * 60);
          return p + ":" + (d < 10 ? "0" + d : d) + ":" + (_ < 10 ? "0" + _ : _);
        },
        unformat: function(a) {
          var f = a.split(":"), h = 0;
          return f.length === 3 ? (h = h + Number(f[0]) * 60 * 60, h = h + Number(f[1]) * 60, h = h + Number(f[2])) : f.length === 2 && (h = h + Number(f[0]) * 60, h = h + Number(f[1])), Number(h);
        }
      });
    }(), e;
  });
})(CL);
Ag.EN;
var Kx = /* @__PURE__ */ ((t) => (t[t.LOCAL = -1] = "LOCAL", t[t.CANADA = 0] = "CANADA", t[t.NORTH_EUROPE = 1] = "NORTH_EUROPE", t[t.EUROPE = 2] = "EUROPE", t[t.USA = 3] = "USA", t))(Kx || {});
const jL = {
  id: Kx.LOCAL,
  name: ""
};
class qL extends Xt(jL, "DataCenterAttribute") {
}
const ML = {
  globalId: void 0,
  hashId: "",
  localId: -1,
  name: "",
  creationDate: Er.MIN_VALUE,
  demoDaysLeft: void 0,
  owner: "",
  dataCenterInfo: new qL(),
  metrics: void 0,
  projects: [],
  avatarImage: void 0,
  hasAPIAccessToken: !1,
  APIAccessTokenAcceptationTermsDate: void 0,
  isLinkedToOrganization: !1,
  url: "",
  subscription: void 0,
  projectTemplates: void 0,
  bimTrackRegionalApiUrl: void 0
};
class o$ extends Xt(ML, "Hub") {
  /**
   * @deprecated use hashId instead.
   */
  get id() {
    return this.hashId;
  }
  /**
   * @deprecated use dataCenterInfo.id instead.
   */
  get dataCenter() {
    return this.dataCenterInfo.id;
  }
  get avatarImageWithDefault() {
    return this.avatarImage;
  }
  get isSubscriptionExpired() {
    return this.subscription ? this.subscription.isExpired : !1;
  }
  get subscriptionPlanProjectLimit() {
    return this.subscription ? this.subscription.projectLimit : 0;
  }
  is(e) {
    return e ? this.id === e.id && this.localId === e.localId : !1;
  }
}
const FL = {
  totalUsers: void 0
};
class s$ extends Xt(FL, "HubMetrics") {
}
var Ui = /* @__PURE__ */ ((t) => (t.TEXT = "text", t.PREDEFINED = "predefined", t.TITLE = "title", t.DESCRIPTION = "description", t.STATUS = "status", t.TYPE = "type", t.PRIORITY = "priority", t.DISCIPLINE = "discipline", t.ZONE = "zone", t.PHASE = "phase", t.ASSIGNED_TO = "assignedto", t.DUE_DATE = "duedate", t.ISSUE_GROUP = "issuegroup", t.TEAM = "team", t.NOTIFY = "notify", t.CONFIDENTIALITY = "confidentiality", t.VISIBILITY = "visibility", t))(Ui || {}), s1 = /* @__PURE__ */ ((t) => (t.ADMIN = "Admin", t.EDITOR = "Editor", t.READER = "Reader", t))(s1 || {}), Vx = /* @__PURE__ */ ((t) => (t[t.ACTIVE = 0] = "ACTIVE", t[t.ON_HOLD = 1] = "ON_HOLD", t[t.COMPLETION_PENDING = 2] = "COMPLETION_PENDING", t[t.COMPLETED = 3] = "COMPLETED", t))(Vx || {});
const NL = {
  statuses: [],
  types: [],
  priorities: [],
  zones: [],
  phases: [],
  disciplines: [],
  customAttributes: []
};
class zL extends Xt(NL, "IssueAttributeOptions") {
}
const LL = {
  id: -1,
  name: "",
  type: Ui.TEXT,
  values: void 0
};
class UL extends Xt(LL, "ProjectAttribute") {
}
const BL = {
  attributes: [],
  selectedColorAttributeForIssue: new UL(),
  integrations: [],
  issueMandatoryAttributes: []
};
class $L extends Xt(BL, "ProjectSettings") {
}
const KL = {
  role: s1.READER,
  teams: [],
  isReviewer: !1
};
class VL extends Xt(KL, "ProjectUserPermissions") {
}
const QL = {
  id: -1,
  name: "",
  status: Vx.ACTIVE,
  settings: new $L(),
  users: [],
  teams: [],
  requestingUserPermissions: new VL()
};
class a$ extends Xt(QL, "Project") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
  getIssueGroupsOptions() {
    return this.getOptionsFor(Ui.ISSUE_GROUP);
  }
  getAttributesFor(e) {
    return this.settings.attributes.filter(
      (r) => r.type === e
    ) || [];
  }
  getSortedCustomAttributes() {
    return [
      ...this.getAttributesFor(Ui.TEXT),
      ...this.getAttributesFor(Ui.PREDEFINED)
    ].sort((e, r) => e.id - r.id);
  }
  getOptionsFor(e) {
    const r = this.settings.attributes.find(
      (n) => n.type === e
    );
    return r && r.values ? r.values : [];
  }
  getOptionsForIssue() {
    const e = this.getOptionsFor(Ui.STATUS), r = this.getOptionsFor(Ui.TYPE), n = this.getOptionsFor(Ui.PRIORITY), i = this.getOptionsFor(Ui.ZONE), o = this.getOptionsFor(Ui.PHASE), s = this.getOptionsFor(Ui.DISCIPLINE), u = this.getSortedCustomAttributes();
    return new zL({
      statuses: e,
      types: r,
      priorities: n,
      zones: i,
      phases: o,
      disciplines: s,
      customAttributes: u
    });
  }
  getStatusesBaseOnUser(e, r) {
    const n = e.teams ?? [];
    let i = this.getOptionsFor(Ui.STATUS).filter((o) => {
      const s = o.teams ? o.teams.map((u) => u.id) : [];
      return s.length === 0 || n.some((u) => s.indexOf(u.id) !== -1);
    });
    return i.some((o) => o.id === r.id) || (i = [...i, r].sort((o, s) => o.name.localeCompare(s.name))), i;
  }
  getIntegrationFor(e) {
    return this.settings.integrations.find(
      (r) => r.integration.name.toLowerCase() === e.toLowerCase()
    );
  }
  getIssueMandatoryAttributes() {
    return this.settings.issueMandatoryAttributes;
  }
  getAttributes() {
    return this.settings.attributes;
  }
}
const YL = {
  id: -1,
  name: ""
};
class u$ extends Xt(YL, "ProjectTemplate") {
}
const GL = {
  id: -1,
  name: ""
};
class c$ extends Xt(GL, "ProjectTeam") {
}
const WL = {
  id: -1,
  name: "",
  siteUrl: ""
};
class HL extends Xt(WL, "Integration") {
}
const JL = {
  id: -1,
  name: "",
  color: void 0,
  teams: void 0
};
class f$ extends Xt(JL, "ProjectAttributeValue") {
}
const ZL = {
  companyId: -1,
  companyName: "",
  projectId: -1,
  projectName: "",
  createRFIComment: !1
};
class l$ extends Xt(ZL, "ProcoreIntegrationData") {
}
const XL = {
  id: -1,
  integration: new HL(),
  data: {}
};
class h$ extends Xt(XL, "ProjectIntegration") {
}
const tU = {
  id: "",
  name: ""
};
class p$ extends Xt(tU, "PropertyAttribute") {
}
const eU = {
  user: void 0,
  hub: void 0,
  project: void 0,
  bimTrackApiUrl: ""
};
class d$ extends Xt(eU, "Session") {
}
var Qx = /* @__PURE__ */ ((t) => (t.EN_US = "M/D/YYYY h:mm A", t.EN_CA = "YYYY-MM-DD h:mm A", t.FR_CA = "DD/MM/YYYY HH:mm", t))(Qx || {}), Jf = /* @__PURE__ */ ((t) => (t.GUEST = "Guest", t.ADMIN = "Admin", t))(Jf || {}), vp = /* @__PURE__ */ ((t) => (t.UTC = "UTC", t.NEW_YORK = "America/New_York", t.DUBAI = "Asia/Asia/Dubai", t))(vp || {}), Yx = /* @__PURE__ */ ((t) => (t.ACTIVE = "Active", t.INACTIVE = "Inactive", t))(Yx || {});
const rU = {
  id: "",
  name: "",
  format: Qx.EN_US
};
class nU extends Xt(rU, "DateFormatAttribute") {
}
const iU = {
  id: Ag.EN,
  name: ""
};
class oU extends Xt(iU, "LanguageAttribute") {
}
const sU = {
  id: vp.NEW_YORK,
  name: vp.NEW_YORK,
  nameIana: vp.NEW_YORK,
  offset: void 0
};
class aU extends Xt(sU, "TimeZoneAttribute") {
}
const uU = {
  firstName: "",
  lastName: "",
  title: "",
  company: "",
  country: void 0,
  industry: void 0,
  jobTitle: "",
  dateFormat: new nU(),
  avatarImage: "",
  language: new oU(),
  website: void 0,
  timeZone: new aU()
};
class cU extends Xt(uU, "UserProfile") {
  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
  get initials() {
    return this.firstName && this.lastName ? `${Array.from(this.firstName)[0]}${Array.from(this.lastName)[0]}` : "";
  }
  getDateTimeFormat() {
    return this.dateFormat.format;
  }
  getDateFormat() {
    return this.dateFormat.format.replace(/ .*/, "");
  }
  getTimeFormat() {
    return this.dateFormat.format.replace(/([^\s]+) /, "");
  }
}
const fU = {
  id: -1,
  globalId: void 0,
  email: "",
  profile: new cU(),
  status: Yx.INACTIVE,
  activationDate: void 0,
  invitationPending: !1,
  isPending: !1,
  lastHubProjectActivity: void 0,
  canResendInvite: void 0,
  hubOwner: !1,
  hubRole: Jf.GUEST,
  projectOwner: !1,
  projectReviewer: !1,
  projectRole: void 0,
  projects: [],
  teams: [],
  isProviderExternal: !1
};
class v$ extends Xt(fU, "User") {
  get fullName() {
    return this.isValid() ? this.profile.fullName : `${this.profile.title}`.trim();
  }
  get fullNameAndEmail() {
    return `${this.fullName} (${this.email})`.trim();
  }
  get initials() {
    return this.profile.initials;
  }
  isNew() {
    return this.id === 0;
  }
  isOwner() {
    return this.hubOwner;
  }
  isAdmin() {
    return this.hubRole === Jf.ADMIN;
  }
  isGuest() {
    return this.hubRole === Jf.GUEST;
  }
  isProjectAdmin() {
    return this.projectRole === s1.ADMIN;
  }
  isProjectOwner() {
    return this.projectOwner;
  }
  isTeamMember(e) {
    return this.teams.some((r) => r.id === e);
  }
  canEditUser(e) {
    return this.is(e) || this.hubRole === Jf.GUEST ? !1 : this.isOwner() || !e.isOwner();
  }
  is(e) {
    return e ? this.id === e.id : !1;
  }
  getDateTimeFormat() {
    return this.profile.getDateTimeFormat();
  }
  getDateFormat() {
    return this.profile.getDateFormat();
  }
  getTimeFormat() {
    return this.profile.getTimeFormat();
  }
  isValid() {
    return this.id > 0;
  }
}
const lU = {
  id: -1,
  name: ""
};
class y$ extends Xt(lU, "UserProject") {
  is(e) {
    return e ? this.id === e.id : !1;
  }
  hasId(e) {
    return e ? this.id === e : !1;
  }
}
var hU = typeof Js == "object" && Js && Js.Object === Object && Js, pU = hU, dU = pU, vU = typeof self == "object" && self && self.Object === Object && self, yU = dU || vU || Function("return this")(), _U = yU, mU = _U, gU = mU.Symbol, a1 = gU, OS = a1;
OS && OS.toStringTag;
var IS = a1;
IS && IS.toStringTag;
var AS = a1, DS = AS ? AS.prototype : void 0;
DS && DS.toString;
var bU = typeof Hs == "object" && Hs && Hs.Object === Object && Hs, wU = bU, EU = wU, SU = typeof self == "object" && self && self.Object === Object && self, OU = EU || SU || Function("return this")(), IU = OU, AU = IU, DU = AU.Symbol, u1 = DU, RS = u1;
RS && RS.toStringTag;
var xS = u1;
xS && xS.toStringTag;
var TS = u1, PS = TS ? TS.prototype : void 0;
PS && PS.toString;
var RU = typeof Ws == "object" && Ws && Ws.Object === Object && Ws, xU = RU, TU = xU, PU = typeof self == "object" && self && self.Object === Object && self, kU = TU || PU || Function("return this")(), CU = kU, jU = CU, qU = jU.Symbol, c1 = qU, kS = c1;
kS && kS.toStringTag;
var CS = c1;
CS && CS.toStringTag;
var jS = c1, qS = jS ? jS.prototype : void 0;
qS && qS.toString;
var MU = 9007199254740991, FU = Math.floor;
function NU(t, e) {
  var r = "";
  if (!t || e < 1 || e > MU)
    return r;
  do
    e % 2 && (r += t), e = FU(e / 2), e && (t += t);
  while (e);
  return r;
}
var zU = NU, LU = typeof Ho == "object" && Ho && Ho.Object === Object && Ho, UU = LU, BU = UU, $U = typeof self == "object" && self && self.Object === Object && self, KU = BU || $U || Function("return this")(), VU = KU, QU = VU, YU = QU.Symbol, f1 = YU;
function GU(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, i = Array(n); ++r < n; )
    i[r] = e(t[r], r, t);
  return i;
}
var WU = GU, HU = Array.isArray, JU = HU, MS = f1, Gx = Object.prototype, ZU = Gx.hasOwnProperty, XU = Gx.toString, Df = MS ? MS.toStringTag : void 0;
function t6(t) {
  var e = ZU.call(t, Df), r = t[Df];
  try {
    t[Df] = void 0;
    var n = !0;
  } catch {
  }
  var i = XU.call(t);
  return n && (e ? t[Df] = r : delete t[Df]), i;
}
var e6 = t6, r6 = Object.prototype, n6 = r6.toString;
function i6(t) {
  return n6.call(t);
}
var o6 = i6, FS = f1, s6 = e6, a6 = o6, u6 = "[object Null]", c6 = "[object Undefined]", NS = FS ? FS.toStringTag : void 0;
function f6(t) {
  return t == null ? t === void 0 ? c6 : u6 : NS && NS in Object(t) ? s6(t) : a6(t);
}
var l6 = f6;
function h6(t) {
  return t != null && typeof t == "object";
}
var p6 = h6, d6 = l6, v6 = p6, y6 = "[object Symbol]";
function _6(t) {
  return typeof t == "symbol" || v6(t) && d6(t) == y6;
}
var Wx = _6, zS = f1, m6 = WU, g6 = JU, b6 = Wx, w6 = 1 / 0, LS = zS ? zS.prototype : void 0, US = LS ? LS.toString : void 0;
function Hx(t) {
  if (typeof t == "string")
    return t;
  if (g6(t))
    return m6(t, Hx) + "";
  if (b6(t))
    return US ? US.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -w6 ? "-0" : e;
}
var Jx = Hx;
function E6(t, e, r) {
  var n = -1, i = t.length;
  e < 0 && (e = -e > i ? 0 : i + e), r = r > i ? i : r, r < 0 && (r += i), i = e > r ? 0 : r - e >>> 0, e >>>= 0;
  for (var o = Array(i); ++n < i; )
    o[n] = t[n + e];
  return o;
}
var S6 = E6, O6 = S6;
function I6(t, e, r) {
  var n = t.length;
  return r = r === void 0 ? n : r, !e && r >= n ? t : O6(t, e, r);
}
var A6 = I6, D6 = "\\ud800-\\udfff", R6 = "\\u0300-\\u036f", x6 = "\\ufe20-\\ufe2f", T6 = "\\u20d0-\\u20ff", P6 = R6 + x6 + T6, k6 = "\\ufe0e\\ufe0f", C6 = "\\u200d", j6 = RegExp("[" + C6 + D6 + P6 + k6 + "]");
function q6(t) {
  return j6.test(t);
}
var l1 = q6;
function M6(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
var F6 = M6, N6 = F6, z6 = N6("length"), L6 = z6, Zx = "\\ud800-\\udfff", U6 = "\\u0300-\\u036f", B6 = "\\ufe20-\\ufe2f", $6 = "\\u20d0-\\u20ff", K6 = U6 + B6 + $6, V6 = "\\ufe0e\\ufe0f", Q6 = "[" + Zx + "]", C_ = "[" + K6 + "]", j_ = "\\ud83c[\\udffb-\\udfff]", Y6 = "(?:" + C_ + "|" + j_ + ")", Xx = "[^" + Zx + "]", tT = "(?:\\ud83c[\\udde6-\\uddff]){2}", eT = "[\\ud800-\\udbff][\\udc00-\\udfff]", G6 = "\\u200d", rT = Y6 + "?", nT = "[" + V6 + "]?", W6 = "(?:" + G6 + "(?:" + [Xx, tT, eT].join("|") + ")" + nT + rT + ")*", H6 = nT + rT + W6, J6 = "(?:" + [Xx + C_ + "?", C_, tT, eT, Q6].join("|") + ")", BS = RegExp(j_ + "(?=" + j_ + ")|" + J6 + H6, "g");
function Z6(t) {
  for (var e = BS.lastIndex = 0; BS.test(t); )
    ++e;
  return e;
}
var X6 = Z6, t8 = L6, e8 = l1, r8 = X6;
function n8(t) {
  return e8(t) ? r8(t) : t8(t);
}
var iT = n8;
function i8(t) {
  return t.split("");
}
var o8 = i8, oT = "\\ud800-\\udfff", s8 = "\\u0300-\\u036f", a8 = "\\ufe20-\\ufe2f", u8 = "\\u20d0-\\u20ff", c8 = s8 + a8 + u8, f8 = "\\ufe0e\\ufe0f", l8 = "[" + oT + "]", q_ = "[" + c8 + "]", M_ = "\\ud83c[\\udffb-\\udfff]", h8 = "(?:" + q_ + "|" + M_ + ")", sT = "[^" + oT + "]", aT = "(?:\\ud83c[\\udde6-\\uddff]){2}", uT = "[\\ud800-\\udbff][\\udc00-\\udfff]", p8 = "\\u200d", cT = h8 + "?", fT = "[" + f8 + "]?", d8 = "(?:" + p8 + "(?:" + [sT, aT, uT].join("|") + ")" + fT + cT + ")*", v8 = fT + cT + d8, y8 = "(?:" + [sT + q_ + "?", q_, aT, uT, l8].join("|") + ")", _8 = RegExp(M_ + "(?=" + M_ + ")|" + y8 + v8, "g");
function m8(t) {
  return t.match(_8) || [];
}
var g8 = m8, b8 = o8, w8 = l1, E8 = g8;
function S8(t) {
  return w8(t) ? E8(t) : b8(t);
}
var O8 = S8, $S = zU, I8 = Jx, A8 = A6, D8 = l1, R8 = iT, x8 = O8, T8 = Math.ceil;
function P8(t, e) {
  e = e === void 0 ? " " : I8(e);
  var r = e.length;
  if (r < 2)
    return r ? $S(e, t) : e;
  var n = $S(e, T8(t / R8(e)));
  return D8(e) ? A8(x8(n), 0, t).join("") : n.slice(0, t);
}
var k8 = P8, C8 = /\s/;
function j8(t) {
  for (var e = t.length; e-- && C8.test(t.charAt(e)); )
    ;
  return e;
}
var q8 = j8, M8 = q8, F8 = /^\s+/;
function N8(t) {
  return t && t.slice(0, M8(t) + 1).replace(F8, "");
}
var z8 = N8;
function L8(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var U8 = L8, B8 = z8, KS = U8, $8 = Wx, VS = 0 / 0, K8 = /^[-+]0x[0-9a-f]+$/i, V8 = /^0b[01]+$/i, Q8 = /^0o[0-7]+$/i, Y8 = parseInt;
function G8(t) {
  if (typeof t == "number")
    return t;
  if ($8(t))
    return VS;
  if (KS(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = KS(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = B8(t);
  var r = V8.test(t);
  return r || Q8.test(t) ? Y8(t.slice(2), r ? 2 : 8) : K8.test(t) ? VS : +t;
}
var W8 = G8, H8 = W8, QS = 1 / 0, J8 = 17976931348623157e292;
function Z8(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = H8(t), t === QS || t === -QS) {
    var e = t < 0 ? -1 : 1;
    return e * J8;
  }
  return t === t ? t : 0;
}
var X8 = Z8, t9 = X8;
function e9(t) {
  var e = t9(t), r = e % 1;
  return e === e ? r ? e - r : e : 0;
}
var r9 = e9, n9 = Jx;
function i9(t) {
  return t == null ? "" : n9(t);
}
var o9 = i9, s9 = k8, a9 = iT, u9 = r9, c9 = o9;
function f9(t, e, r) {
  t = c9(t), e = u9(e);
  var n = e ? a9(t) : 0;
  return e && n < e ? s9(e - n, r) + t : t;
}
var l9 = f9;
const h9 = /* @__PURE__ */ Kp(l9);
function p9(t) {
  if (t !== md.LOCAL)
    return `bt${h9(t.toString(), 2, "0")}`;
}
function d9(t, e) {
  return t.replace(/(?<preDash>-)?(?<dataCenterName>bt\d{2})(?<postDash>-)?/gis, (...r) => {
    const n = r.at(-1), i = p9(e);
    return i ? `${(n == null ? void 0 : n.preDash) ?? ""}${i}${(n == null ? void 0 : n.postDash) ?? ""}` : n != null && n.preDash && (n != null && n.postDash) ? "-" : "";
  });
}
function _$(t) {
  return d9(t, md.LOCAL);
}
var lT = { exports: {} };
/* @license
Papa Parse
v5.5.2
https://github.com/mholt/PapaParse
License: MIT
*/
(function(t, e) {
  ((r, n) => {
    t.exports = n();
  })(Ho, function r() {
    var n = typeof self < "u" ? self : typeof window < "u" ? window : n !== void 0 ? n : {}, i, o = !n.document && !!n.postMessage, s = n.IS_PAPA_WORKER || !1, u = {}, c = 0, a = {};
    function f(D) {
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, (function(I) {
        var j = x(I);
        j.chunkSize = parseInt(j.chunkSize), I.step || I.chunk || (j.chunkSize = null), this._handle = new m(j), (this._handle.streamer = this)._config = j;
      }).call(this, D), this.parseChunk = function(I, j) {
        var Y = parseInt(this._config.skipFirstNLines) || 0;
        if (this.isFirstChunk && 0 < Y) {
          let B = this._config.newline;
          B || (H = this._config.quoteChar || '"', B = this._handle.guessLineEndings(I, H)), I = [...I.split(B).slice(Y)].join(B);
        }
        this.isFirstChunk && R(this._config.beforeFirstChunk) && (H = this._config.beforeFirstChunk(I)) !== void 0 && (I = H), this.isFirstChunk = !1, this._halted = !1;
        var Y = this._partialLine + I, H = (this._partialLine = "", this._handle.parse(Y, this._baseIndex, !this._finished));
        if (!this._handle.paused() && !this._handle.aborted()) {
          if (I = H.meta.cursor, Y = (this._finished || (this._partialLine = Y.substring(I - this._baseIndex), this._baseIndex = I), H && H.data && (this._rowCount += H.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview), s)
            n.postMessage({ results: H, workerId: a.WORKER_ID, finished: Y });
          else if (R(this._config.chunk) && !j) {
            if (this._config.chunk(H, this._handle), this._handle.paused() || this._handle.aborted())
              return void (this._halted = !0);
            this._completeResults = H = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(H.data), this._completeResults.errors = this._completeResults.errors.concat(H.errors), this._completeResults.meta = H.meta), this._completed || !Y || !R(this._config.complete) || H && H.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), Y || H && H.meta.paused || this._nextChunk(), H;
        }
        this._halted = !0;
      }, this._sendError = function(I) {
        R(this._config.error) ? this._config.error(I) : s && this._config.error && n.postMessage({ workerId: a.WORKER_ID, error: I, finished: !1 });
      };
    }
    function h(D) {
      var I;
      (D = D || {}).chunkSize || (D.chunkSize = a.RemoteChunkSize), f.call(this, D), this._nextChunk = o ? function() {
        this._readChunk(), this._chunkLoaded();
      } : function() {
        this._readChunk();
      }, this.stream = function(j) {
        this._input = j, this._nextChunk();
      }, this._readChunk = function() {
        if (this._finished)
          this._chunkLoaded();
        else {
          if (I = new XMLHttpRequest(), this._config.withCredentials && (I.withCredentials = this._config.withCredentials), o || (I.onload = P(this._chunkLoaded, this), I.onerror = P(this._chunkError, this)), I.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !o), this._config.downloadRequestHeaders) {
            var j, Y = this._config.downloadRequestHeaders;
            for (j in Y)
              I.setRequestHeader(j, Y[j]);
          }
          var H;
          this._config.chunkSize && (H = this._start + this._config.chunkSize - 1, I.setRequestHeader("Range", "bytes=" + this._start + "-" + H));
          try {
            I.send(this._config.downloadRequestBody);
          } catch (B) {
            this._chunkError(B.message);
          }
          o && I.status === 0 && this._chunkError();
        }
      }, this._chunkLoaded = function() {
        I.readyState === 4 && (I.status < 200 || 400 <= I.status ? this._chunkError() : (this._start += this._config.chunkSize || I.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((j) => (j = j.getResponseHeader("Content-Range")) !== null ? parseInt(j.substring(j.lastIndexOf("/") + 1)) : -1)(I), this.parseChunk(I.responseText)));
      }, this._chunkError = function(j) {
        j = I.statusText || j, this._sendError(new Error(j));
      };
    }
    function p(D) {
      (D = D || {}).chunkSize || (D.chunkSize = a.LocalChunkSize), f.call(this, D);
      var I, j, Y = typeof FileReader < "u";
      this.stream = function(H) {
        this._input = H, j = H.slice || H.webkitSlice || H.mozSlice, Y ? ((I = new FileReader()).onload = P(this._chunkLoaded, this), I.onerror = P(this._chunkError, this)) : I = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function() {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function() {
        var H = this._input, B = (this._config.chunkSize && (B = Math.min(this._start + this._config.chunkSize, this._input.size), H = j.call(H, this._start, B)), I.readAsText(H, this._config.encoding));
        Y || this._chunkLoaded({ target: { result: B } });
      }, this._chunkLoaded = function(H) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(H.target.result);
      }, this._chunkError = function() {
        this._sendError(I.error);
      };
    }
    function d(D) {
      var I;
      f.call(this, D = D || {}), this.stream = function(j) {
        return I = j, this._nextChunk();
      }, this._nextChunk = function() {
        var j, Y;
        if (!this._finished)
          return j = this._config.chunkSize, I = j ? (Y = I.substring(0, j), I.substring(j)) : (Y = I, ""), this._finished = !I, this.parseChunk(Y);
      };
    }
    function _(D) {
      f.call(this, D = D || {});
      var I = [], j = !0, Y = !1;
      this.pause = function() {
        f.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function() {
        f.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function(H) {
        this._input = H, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function() {
        Y && I.length === 1 && (this._finished = !0);
      }, this._nextChunk = function() {
        this._checkIsFinished(), I.length ? this.parseChunk(I.shift()) : j = !0;
      }, this._streamData = P(function(H) {
        try {
          I.push(typeof H == "string" ? H : H.toString(this._config.encoding)), j && (j = !1, this._checkIsFinished(), this.parseChunk(I.shift()));
        } catch (B) {
          this._streamError(B);
        }
      }, this), this._streamError = P(function(H) {
        this._streamCleanUp(), this._sendError(H);
      }, this), this._streamEnd = P(function() {
        this._streamCleanUp(), Y = !0, this._streamData("");
      }, this), this._streamCleanUp = P(function() {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }
    function m(D) {
      var I, j, Y, H, B = Math.pow(2, 53), tt = -B, lt = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, te = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, pt = this, At = 0, ft = 0, Lt = !1, dt = !1, mt = [], st = { data: [], errors: [], meta: {} };
      function Nt(N) {
        return D.skipEmptyLines === "greedy" ? N.join("").trim() === "" : N.length === 1 && N[0].length === 0;
      }
      function Qt() {
        if (st && Y && (xt("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + a.DefaultDelimiter + "'"), Y = !1), D.skipEmptyLines && (st.data = st.data.filter(function(X) {
          return !Nt(X);
        })), Rt()) {
          let X = function(wt, jt) {
            R(D.transformHeader) && (wt = D.transformHeader(wt, jt)), mt.push(wt);
          };
          if (st)
            if (Array.isArray(st.data[0])) {
              for (var N = 0; Rt() && N < st.data.length; N++)
                st.data[N].forEach(X);
              st.data.splice(0, 1);
            } else
              st.data.forEach(X);
        }
        function ht(X, wt) {
          for (var jt = D.header ? {} : [], qt = 0; qt < X.length; qt++) {
            var U = qt, $ = X[qt], $ = ((W, et) => ((ot) => (D.dynamicTypingFunction && D.dynamicTyping[ot] === void 0 && (D.dynamicTyping[ot] = D.dynamicTypingFunction(ot)), (D.dynamicTyping[ot] || D.dynamicTyping) === !0))(W) ? et === "true" || et === "TRUE" || et !== "false" && et !== "FALSE" && (((ot) => {
              if (lt.test(ot) && (ot = parseFloat(ot), tt < ot && ot < B))
                return 1;
            })(et) ? parseFloat(et) : te.test(et) ? new Date(et) : et === "" ? null : et) : et)(U = D.header ? qt >= mt.length ? "__parsed_extra" : mt[qt] : U, $ = D.transform ? D.transform($, U) : $);
            U === "__parsed_extra" ? (jt[U] = jt[U] || [], jt[U].push($)) : jt[U] = $;
          }
          return D.header && (qt > mt.length ? xt("FieldMismatch", "TooManyFields", "Too many fields: expected " + mt.length + " fields but parsed " + qt, ft + wt) : qt < mt.length && xt("FieldMismatch", "TooFewFields", "Too few fields: expected " + mt.length + " fields but parsed " + qt, ft + wt)), jt;
        }
        var gt;
        st && (D.header || D.dynamicTyping || D.transform) && (gt = 1, !st.data.length || Array.isArray(st.data[0]) ? (st.data = st.data.map(ht), gt = st.data.length) : st.data = ht(st.data, 0), D.header && st.meta && (st.meta.fields = mt), ft += gt);
      }
      function Rt() {
        return D.header && mt.length === 0;
      }
      function xt(N, ht, gt, X) {
        N = { type: N, code: ht, message: gt }, X !== void 0 && (N.row = X), st.errors.push(N);
      }
      R(D.step) && (H = D.step, D.step = function(N) {
        st = N, Rt() ? Qt() : (Qt(), st.data.length !== 0 && (At += N.data.length, D.preview && At > D.preview ? j.abort() : (st.data = st.data[0], H(st, pt))));
      }), this.parse = function(N, ht, gt) {
        var X = D.quoteChar || '"', X = (D.newline || (D.newline = this.guessLineEndings(N, X)), Y = !1, D.delimiter ? R(D.delimiter) && (D.delimiter = D.delimiter(N), st.meta.delimiter = D.delimiter) : ((X = ((wt, jt, qt, U, $) => {
          var W, et, ot, Dt;
          $ = $ || [",", "	", "|", ";", a.RECORD_SEP, a.UNIT_SEP];
          for (var St = 0; St < $.length; St++) {
            for (var Et, ue = $[St], ae = 0, ce = 0, Yt = 0, Ot = (ot = void 0, new O({ comments: U, delimiter: ue, newline: jt, preview: 10 }).parse(wt)), Oe = 0; Oe < Ot.data.length; Oe++)
              qt && Nt(Ot.data[Oe]) ? Yt++ : (Et = Ot.data[Oe].length, ce += Et, ot === void 0 ? ot = Et : 0 < Et && (ae += Math.abs(Et - ot), ot = Et));
            0 < Ot.data.length && (ce /= Ot.data.length - Yt), (et === void 0 || ae <= et) && (Dt === void 0 || Dt < ce) && 1.99 < ce && (et = ae, W = ue, Dt = ce);
          }
          return { successful: !!(D.delimiter = W), bestDelimiter: W };
        })(N, D.newline, D.skipEmptyLines, D.comments, D.delimitersToGuess)).successful ? D.delimiter = X.bestDelimiter : (Y = !0, D.delimiter = a.DefaultDelimiter), st.meta.delimiter = D.delimiter), x(D));
        return D.preview && D.header && X.preview++, I = N, j = new O(X), st = j.parse(I, ht, gt), Qt(), Lt ? { meta: { paused: !0 } } : st || { meta: { paused: !1 } };
      }, this.paused = function() {
        return Lt;
      }, this.pause = function() {
        Lt = !0, j.abort(), I = R(D.chunk) ? "" : I.substring(j.getCharIndex());
      }, this.resume = function() {
        pt.streamer._halted ? (Lt = !1, pt.streamer.parseChunk(I, !0)) : setTimeout(pt.resume, 3);
      }, this.aborted = function() {
        return dt;
      }, this.abort = function() {
        dt = !0, j.abort(), st.meta.aborted = !0, R(D.complete) && D.complete(st), I = "";
      }, this.guessLineEndings = function(wt, X) {
        wt = wt.substring(0, 1048576);
        var X = new RegExp(b(X) + "([^]*?)" + b(X), "gm"), gt = (wt = wt.replace(X, "")).split("\r"), X = wt.split(`
`), wt = 1 < X.length && X[0].length < gt[0].length;
        if (gt.length === 1 || wt)
          return `
`;
        for (var jt = 0, qt = 0; qt < gt.length; qt++)
          gt[qt][0] === `
` && jt++;
        return jt >= gt.length / 2 ? `\r
` : "\r";
      };
    }
    function b(D) {
      return D.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function O(D) {
      var I = (D = D || {}).delimiter, j = D.newline, Y = D.comments, H = D.step, B = D.preview, tt = D.fastMode, lt = null, te = !1, pt = D.quoteChar == null ? '"' : D.quoteChar, At = pt;
      if (D.escapeChar !== void 0 && (At = D.escapeChar), (typeof I != "string" || -1 < a.BAD_DELIMITERS.indexOf(I)) && (I = ","), Y === I)
        throw new Error("Comment character same as delimiter");
      Y === !0 ? Y = "#" : (typeof Y != "string" || -1 < a.BAD_DELIMITERS.indexOf(Y)) && (Y = !1), j !== `
` && j !== "\r" && j !== `\r
` && (j = `
`);
      var ft = 0, Lt = !1;
      this.parse = function(dt, mt, st) {
        if (typeof dt != "string")
          throw new Error("Input must be a string");
        var Nt = dt.length, Qt = I.length, Rt = j.length, xt = Y.length, N = R(H), ht = [], gt = [], X = [], wt = ft = 0;
        if (!dt)
          return ae();
        if (tt || tt !== !1 && dt.indexOf(pt) === -1) {
          for (var jt = dt.split(j), qt = 0; qt < jt.length; qt++) {
            if (X = jt[qt], ft += X.length, qt !== jt.length - 1)
              ft += j.length;
            else if (st)
              return ae();
            if (!Y || X.substring(0, xt) !== Y) {
              if (N) {
                if (ht = [], Dt(X.split(I)), ce(), Lt)
                  return ae();
              } else
                Dt(X.split(I));
              if (B && B <= qt)
                return ht = ht.slice(0, B), ae(!0);
            }
          }
          return ae();
        }
        for (var U = dt.indexOf(I, ft), $ = dt.indexOf(j, ft), W = new RegExp(b(At) + b(pt), "g"), et = dt.indexOf(pt, ft); ; )
          if (dt[ft] === pt)
            for (et = ft, ft++; ; ) {
              if ((et = dt.indexOf(pt, et + 1)) === -1)
                return st || gt.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: ht.length, index: ft }), Et();
              if (et === Nt - 1)
                return Et(dt.substring(ft, et).replace(W, pt));
              if (pt === At && dt[et + 1] === At)
                et++;
              else if (pt === At || et === 0 || dt[et - 1] !== At) {
                U !== -1 && U < et + 1 && (U = dt.indexOf(I, et + 1));
                var ot = St(($ = $ !== -1 && $ < et + 1 ? dt.indexOf(j, et + 1) : $) === -1 ? U : Math.min(U, $));
                if (dt.substr(et + 1 + ot, Qt) === I) {
                  X.push(dt.substring(ft, et).replace(W, pt)), dt[ft = et + 1 + ot + Qt] !== pt && (et = dt.indexOf(pt, ft)), U = dt.indexOf(I, ft), $ = dt.indexOf(j, ft);
                  break;
                }
                if (ot = St($), dt.substring(et + 1 + ot, et + 1 + ot + Rt) === j) {
                  if (X.push(dt.substring(ft, et).replace(W, pt)), ue(et + 1 + ot + Rt), U = dt.indexOf(I, ft), et = dt.indexOf(pt, ft), N && (ce(), Lt))
                    return ae();
                  if (B && ht.length >= B)
                    return ae(!0);
                  break;
                }
                gt.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: ht.length, index: ft }), et++;
              }
            }
          else if (Y && X.length === 0 && dt.substring(ft, ft + xt) === Y) {
            if ($ === -1)
              return ae();
            ft = $ + Rt, $ = dt.indexOf(j, ft), U = dt.indexOf(I, ft);
          } else if (U !== -1 && (U < $ || $ === -1))
            X.push(dt.substring(ft, U)), ft = U + Qt, U = dt.indexOf(I, ft);
          else {
            if ($ === -1)
              break;
            if (X.push(dt.substring(ft, $)), ue($ + Rt), N && (ce(), Lt))
              return ae();
            if (B && ht.length >= B)
              return ae(!0);
          }
        return Et();
        function Dt(Yt) {
          ht.push(Yt), wt = ft;
        }
        function St(Yt) {
          var Ot = 0;
          return Ot = Yt !== -1 && (Yt = dt.substring(et + 1, Yt)) && Yt.trim() === "" ? Yt.length : Ot;
        }
        function Et(Yt) {
          return st || (Yt === void 0 && (Yt = dt.substring(ft)), X.push(Yt), ft = Nt, Dt(X), N && ce()), ae();
        }
        function ue(Yt) {
          ft = Yt, Dt(X), X = [], $ = dt.indexOf(j, ft);
        }
        function ae(Yt) {
          if (D.header && !mt && ht.length && !te) {
            var Ot = ht[0], Oe = {}, Gt = new Set(Ot);
            let se = !1;
            for (let Zt = 0; Zt < Ot.length; Zt++) {
              let fe = Ot[Zt];
              if (Oe[fe = R(D.transformHeader) ? D.transformHeader(fe, Zt) : fe]) {
                let vt, Mt = Oe[fe];
                for (; vt = fe + "_" + Mt, Mt++, Gt.has(vt); )
                  ;
                Gt.add(vt), Ot[Zt] = vt, Oe[fe]++, se = !0, (lt = lt === null ? {} : lt)[vt] = fe;
              } else
                Oe[fe] = 1, Ot[Zt] = fe;
              Gt.add(fe);
            }
            se && console.warn("Duplicate headers found and renamed."), te = !0;
          }
          return { data: ht, errors: gt, meta: { delimiter: I, linebreak: j, aborted: Lt, truncated: !!Yt, cursor: wt + (mt || 0), renamedHeaders: lt } };
        }
        function ce() {
          H(ae()), ht = [], gt = [];
        }
      }, this.abort = function() {
        Lt = !0;
      }, this.getCharIndex = function() {
        return ft;
      };
    }
    function S(D) {
      var I = D.data, j = u[I.workerId], Y = !1;
      if (I.error)
        j.userError(I.error, I.file);
      else if (I.results && I.results.data) {
        var H = { abort: function() {
          Y = !0, k(I.workerId, { data: [], errors: [], meta: { aborted: !0 } });
        }, pause: T, resume: T };
        if (R(j.userStep)) {
          for (var B = 0; B < I.results.data.length && (j.userStep({ data: I.results.data[B], errors: I.results.errors, meta: I.results.meta }, H), !Y); B++)
            ;
          delete I.results;
        } else
          R(j.userChunk) && (j.userChunk(I.results, H, I.file), delete I.results);
      }
      I.finished && !Y && k(I.workerId, I.results);
    }
    function k(D, I) {
      var j = u[D];
      R(j.userComplete) && j.userComplete(I), j.terminate(), delete u[D];
    }
    function T() {
      throw new Error("Not implemented.");
    }
    function x(D) {
      if (typeof D != "object" || D === null)
        return D;
      var I, j = Array.isArray(D) ? [] : {};
      for (I in D)
        j[I] = x(D[I]);
      return j;
    }
    function P(D, I) {
      return function() {
        D.apply(I, arguments);
      };
    }
    function R(D) {
      return typeof D == "function";
    }
    return a.parse = function(D, I) {
      var j = (I = I || {}).dynamicTyping || !1;
      if (R(j) && (I.dynamicTypingFunction = j, j = {}), I.dynamicTyping = j, I.transform = !!R(I.transform) && I.transform, !I.worker || !a.WORKERS_SUPPORTED)
        return j = null, a.NODE_STREAM_INPUT, typeof D == "string" ? (D = ((Y) => Y.charCodeAt(0) !== 65279 ? Y : Y.slice(1))(D), j = new (I.download ? h : d)(I)) : D.readable === !0 && R(D.read) && R(D.on) ? j = new _(I) : (n.File && D instanceof File || D instanceof Object) && (j = new p(I)), j.stream(D);
      (j = (() => {
        var Y;
        return !!a.WORKERS_SUPPORTED && (Y = (() => {
          var H = n.URL || n.webkitURL || null, B = r.toString();
          return a.BLOB_URL || (a.BLOB_URL = H.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", B, ")();"], { type: "text/javascript" })));
        })(), (Y = new n.Worker(Y)).onmessage = S, Y.id = c++, u[Y.id] = Y);
      })()).userStep = I.step, j.userChunk = I.chunk, j.userComplete = I.complete, j.userError = I.error, I.step = R(I.step), I.chunk = R(I.chunk), I.complete = R(I.complete), I.error = R(I.error), delete I.worker, j.postMessage({ input: D, config: I, workerId: j.id });
    }, a.unparse = function(D, I) {
      var j = !1, Y = !0, H = ",", B = `\r
`, tt = '"', lt = tt + tt, te = !1, pt = null, At = !1, ft = ((() => {
        if (typeof I == "object") {
          if (typeof I.delimiter != "string" || a.BAD_DELIMITERS.filter(function(mt) {
            return I.delimiter.indexOf(mt) !== -1;
          }).length || (H = I.delimiter), typeof I.quotes != "boolean" && typeof I.quotes != "function" && !Array.isArray(I.quotes) || (j = I.quotes), typeof I.skipEmptyLines != "boolean" && typeof I.skipEmptyLines != "string" || (te = I.skipEmptyLines), typeof I.newline == "string" && (B = I.newline), typeof I.quoteChar == "string" && (tt = I.quoteChar), typeof I.header == "boolean" && (Y = I.header), Array.isArray(I.columns)) {
            if (I.columns.length === 0)
              throw new Error("Option columns is empty");
            pt = I.columns;
          }
          I.escapeChar !== void 0 && (lt = I.escapeChar + tt), I.escapeFormulae instanceof RegExp ? At = I.escapeFormulae : typeof I.escapeFormulae == "boolean" && I.escapeFormulae && (At = /^[=+\-@\t\r].*$/);
        }
      })(), new RegExp(b(tt), "g"));
      if (typeof D == "string" && (D = JSON.parse(D)), Array.isArray(D)) {
        if (!D.length || Array.isArray(D[0]))
          return Lt(null, D, te);
        if (typeof D[0] == "object")
          return Lt(pt || Object.keys(D[0]), D, te);
      } else if (typeof D == "object")
        return typeof D.data == "string" && (D.data = JSON.parse(D.data)), Array.isArray(D.data) && (D.fields || (D.fields = D.meta && D.meta.fields || pt), D.fields || (D.fields = Array.isArray(D.data[0]) ? D.fields : typeof D.data[0] == "object" ? Object.keys(D.data[0]) : []), Array.isArray(D.data[0]) || typeof D.data[0] == "object" || (D.data = [D.data])), Lt(D.fields || [], D.data || [], te);
      throw new Error("Unable to serialize unrecognized input");
      function Lt(mt, st, Nt) {
        var Qt = "", Rt = (typeof mt == "string" && (mt = JSON.parse(mt)), typeof st == "string" && (st = JSON.parse(st)), Array.isArray(mt) && 0 < mt.length), xt = !Array.isArray(st[0]);
        if (Rt && Y) {
          for (var N = 0; N < mt.length; N++)
            0 < N && (Qt += H), Qt += dt(mt[N], N);
          0 < st.length && (Qt += B);
        }
        for (var ht = 0; ht < st.length; ht++) {
          var gt = (Rt ? mt : st[ht]).length, X = !1, wt = Rt ? Object.keys(st[ht]).length === 0 : st[ht].length === 0;
          if (Nt && !Rt && (X = Nt === "greedy" ? st[ht].join("").trim() === "" : st[ht].length === 1 && st[ht][0].length === 0), Nt === "greedy" && Rt) {
            for (var jt = [], qt = 0; qt < gt; qt++) {
              var U = xt ? mt[qt] : qt;
              jt.push(st[ht][U]);
            }
            X = jt.join("").trim() === "";
          }
          if (!X) {
            for (var $ = 0; $ < gt; $++) {
              0 < $ && !wt && (Qt += H);
              var W = Rt && xt ? mt[$] : $;
              Qt += dt(st[ht][W], $);
            }
            ht < st.length - 1 && (!Nt || 0 < gt && !wt) && (Qt += B);
          }
        }
        return Qt;
      }
      function dt(mt, st) {
        var Nt, Qt;
        return mt == null ? "" : mt.constructor === Date ? JSON.stringify(mt).slice(1, 25) : (Qt = !1, At && typeof mt == "string" && At.test(mt) && (mt = "'" + mt, Qt = !0), Nt = mt.toString().replace(ft, lt), (Qt = Qt || j === !0 || typeof j == "function" && j(mt, st) || Array.isArray(j) && j[st] || ((Rt, xt) => {
          for (var N = 0; N < xt.length; N++)
            if (-1 < Rt.indexOf(xt[N]))
              return !0;
          return !1;
        })(Nt, a.BAD_DELIMITERS) || -1 < Nt.indexOf(H) || Nt.charAt(0) === " " || Nt.charAt(Nt.length - 1) === " ") ? tt + Nt + tt : Nt);
      }
    }, a.RECORD_SEP = String.fromCharCode(30), a.UNIT_SEP = String.fromCharCode(31), a.BYTE_ORDER_MARK = "\uFEFF", a.BAD_DELIMITERS = ["\r", `
`, '"', a.BYTE_ORDER_MARK], a.WORKERS_SUPPORTED = !o && !!n.Worker, a.NODE_STREAM_INPUT = 1, a.LocalChunkSize = 10485760, a.RemoteChunkSize = 5242880, a.DefaultDelimiter = ",", a.Parser = O, a.ParserHandle = m, a.NetworkStreamer = h, a.FileStreamer = p, a.StringStreamer = d, a.ReadableStreamStreamer = _, n.jQuery && ((i = n.jQuery).fn.parse = function(D) {
      var I = D.config || {}, j = [];
      return this.each(function(B) {
        if (!(i(this).prop("tagName").toUpperCase() === "INPUT" && i(this).attr("type").toLowerCase() === "file" && n.FileReader) || !this.files || this.files.length === 0)
          return !0;
        for (var tt = 0; tt < this.files.length; tt++)
          j.push({ file: this.files[tt], inputElem: this, instanceConfig: i.extend({}, I) });
      }), Y(), this;
      function Y() {
        if (j.length === 0)
          R(D.complete) && D.complete();
        else {
          var B, tt, lt, te, pt = j[0];
          if (R(D.before)) {
            var At = D.before(pt.file, pt.inputElem);
            if (typeof At == "object") {
              if (At.action === "abort")
                return B = "AbortError", tt = pt.file, lt = pt.inputElem, te = At.reason, void (R(D.error) && D.error({ name: B }, tt, lt, te));
              if (At.action === "skip")
                return void H();
              typeof At.config == "object" && (pt.instanceConfig = i.extend(pt.instanceConfig, At.config));
            } else if (At === "skip")
              return void H();
          }
          var ft = pt.instanceConfig.complete;
          pt.instanceConfig.complete = function(Lt) {
            R(ft) && ft(Lt, pt.file, pt.inputElem), H();
          }, a.parse(pt.file, pt.instanceConfig);
        }
      }
      function H() {
        j.splice(0, 1), Y();
      }
    }), s && (n.onmessage = function(D) {
      D = D.data, a.WORKER_ID === void 0 && D && (a.WORKER_ID = D.workerId), typeof D.input == "string" ? n.postMessage({ workerId: a.WORKER_ID, results: a.parse(D.input, D.config), finished: !0 }) : (n.File && D.input instanceof File || D.input instanceof Object) && (D = a.parse(D.input, D.config)) && n.postMessage({ workerId: a.WORKER_ID, results: D, finished: !0 });
    }), (h.prototype = Object.create(f.prototype)).constructor = h, (p.prototype = Object.create(f.prototype)).constructor = p, (d.prototype = Object.create(d.prototype)).constructor = d, (_.prototype = Object.create(f.prototype)).constructor = _, a;
  });
})(lT);
var v9 = lT.exports;
const hT = /* @__PURE__ */ Kp(v9), m$ = async (t) => {
  const e = await new Promise((r) => {
    hT.parse(t, {
      header: !0,
      skipEmptyLines: !0,
      dynamicTyping: !0,
      complete: (n) => {
        r(n);
      }
    });
  });
  return e.meta.fields ? e.meta.fields.map((r, n) => ({
    name: r,
    position: n
  })) : [];
}, g$ = (t) => new Promise((e, r) => {
  const n = new FileReader();
  n.onload = () => {
    let i = new TextDecoder("utf-8").decode(n.result);
    i.charCodeAt(0) === 65279 && (i = i.slice(1)), i.includes("�") && (i = new TextDecoder("ISO-8859-1").decode(n.result)), hT.parse(i, {
      header: !0,
      skipEmptyLines: !0,
      beforeFirstChunk(o) {
        i.charCodeAt(0) === 65279 && (i = i.slice(1));
      },
      complete: (o) => {
        e(o.data);
      },
      error: (o) => {
        r(o);
      }
    });
  }, n.onerror = (i) => {
    r(i);
  }, n.readAsArrayBuffer(t);
}), b$ = (t, e) => {
  const r = y9(t, e), n = 9;
  let i;
  if (r.length === 1)
    i = r[0].text;
  else if (r.length > n) {
    i = r.slice(0, n).map((s) => s.text).join(", ");
    const o = r.slice(n, r.length).reduce((s, u) => s + u.nbRows, 0);
    i += e("andNMoreRows", { count: o });
  } else
    i = r.slice(0, r.length - 1).map((o) => o.text).join(", "), i += ` ${e("and")} ${r[r.length - 1].text}`;
  return i;
}, y9 = (t, e) => {
  t.sort((o, s) => o - s);
  const r = [];
  let n = t[0], i = t[0];
  for (let o = 1; o <= t.length; o++) {
    const s = t[o];
    s === i + 1 || (r.push(
      n === i ? { text: `${n}`, nbRows: 1 } : { text: `${n} ${e("to")} ${i}`, nbRows: i - n + 1 }
    ), n = s), i = s;
  }
  return r;
}, pT = (t, e = !1) => {
  let r = t.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return e && (r = r.replace(/[^\w\s-]/g, "")), r.toLowerCase().trim();
}, YS = (t) => pT(t, !0), w$ = (t) => pT(t), E$ = (t, e) => YS(t).toLowerCase().trim() === YS(e).toLowerCase().trim();
class S$ {
  readString(e) {
    const r = localStorage.getItem(e);
    if (r)
      return r;
  }
  readObject(e) {
    const r = this.readString(e);
    if (r)
      return JSON.parse(r);
  }
  writeString(e, r) {
    localStorage.setItem(e, r);
  }
  writeObject(e, r) {
    this.writeString(e, JSON.stringify(r));
  }
  remove(e) {
    localStorage.removeItem(e);
  }
}
var _9 = /* @__PURE__ */ ((t) => (t.Ifc = "application/vnd.newforma.viewer.ifc", t.Sheet = "application/vnd.newforma.viewer.pdf", t.SheetImg = "application/vnd.newforma.viewer.pdf.img", t.SheetInfo = "application/vnd.newforma.viewer.pdf.info+json", t.AnyFile = "application/vnd.newforma.viewer.any", t.IfcError = "application/vnd.newforma.viewer.ifc.err", t.IfcLog = "application/vnd.newforma.viewer.ifc.log", t.IfcSiteOrigin = "application/vnd.newforma.viewer.ifc.site+json", t.IfcBt3d = "application/vnd.newforma.viewer.ifc.bt3d;content-encoding=gzip", t.IfcProperty = "application/vnd.newforma.viewer.ifc.property;content-encoding=gzip", t))(_9 || {});
export {
  Zf as BaseClient,
  XS as BlobClient,
  _1 as BrowserCultureInfo,
  F_ as Client,
  ZS as Credentials,
  gI as DataCenter,
  aC as DataCenterAttribute,
  bI as DateFormat,
  CC as DateFormatAttribute,
  VT as FederatedComponent,
  V9 as Functionalities,
  JT as GainSightGate,
  YT as GainSightProvider,
  S9 as HeadClient,
  JS as HttpError,
  fa as HttpMethod,
  S0 as HttpStatusCode,
  j9 as Hub,
  q9 as HubMetrics,
  cC as HubUserPermissions,
  Uu as HubUserRole,
  sl as I18n,
  kf as I18nMain,
  C9 as I18nProvider,
  AC as Integration,
  hC as IntegrationName,
  vC as IssueAttributeOptions,
  Zs as Language,
  qC as LanguageAttribute,
  I9 as LaunchDarklyProvider,
  S$ as LocalStorageService,
  ZT as LocaleSetup,
  X2 as MAX_RETRY_COUNT,
  K9 as Modules,
  R9 as NotImplementedError,
  x9 as NotSupportedValueError,
  L9 as ProcoreIntegrationData,
  M9 as Project,
  _C as ProjectAttribute,
  Ci as ProjectAttributeType,
  z9 as ProjectAttributeValue,
  pC as ProjectFileProviders,
  U9 as ProjectIntegration,
  gC as ProjectSettings,
  EI as ProjectStatus,
  N9 as ProjectTeam,
  F9 as ProjectTemplate,
  wC as ProjectUserPermissions,
  O0 as ProjectUserRole,
  B9 as PropertyAttribute,
  qu as RemoteModuleStatus,
  ET as RequestCanceledError,
  wT as RequestTimeoutError,
  $9 as Session,
  Op as Subscription,
  Z2 as SubscriptionApi,
  J2 as SubscriptionAssembler,
  W2 as SubscriptionFunctionalityAssembler,
  T9 as SubscriptionProvider,
  IT as TIMEOUT_IN_MILLIS,
  ap as TimeZone,
  FC as TimeZoneAttribute,
  Q9 as User,
  zC as UserProfile,
  Y9 as UserProject,
  wI as UserStatus,
  _9 as ViewerMimeTypes,
  W9 as assertIsDefined,
  H9 as buildFetchKeys,
  tC as canRetryQuery,
  E$ as compareStrings,
  sC as dataCenterAttributeDefaultProps,
  kC as dateFormatAttributeDefaultProps,
  iC as defaultFormatter,
  G9 as enumKeys,
  b$ as formatRows,
  vI as getHttpErrorCode,
  y9 as groupConsecutiveNumbers,
  fC as hubDefaultProps,
  lC as hubMetricsDefaultProps,
  uC as hubUserPermissionsDefaultProps,
  IC as integrationDefaultProps,
  J9 as isReadyToFetch,
  dC as issueAttributeOptionsDefaultProps,
  jC as languageAttributeDefaultProps,
  TT as loadRemoteModule,
  xT as loadRemoteScript,
  YS as normalizeString,
  m$ as parseCsvColumns,
  g$ as parseCsvContent,
  RC as procoreIntegrationDataDefaultProps,
  yC as projectAttributeDefaultProps,
  DC as projectAttributeValueDefaultProps,
  EC as projectDefaultProps,
  xC as projectIntegrationDefaultProps,
  mC as projectSettingsDefaultProps,
  OC as projectTeamDefaultProps,
  SC as projectTemplateDefaultProps,
  bC as projectUserPermissionsDefaultProps,
  TC as propertyAttributeDefaultProps,
  w$ as removeAccents,
  d9 as replaceDataCenterNameInUrl,
  O9 as resetRemoteModuleCache,
  PC as sessionDefaultProps,
  Z9 as stripApiVersionAndTrailingSlashesFromUrl,
  _$ as stripDataCenterNameFromUrl,
  h1 as stripTrailingSlashesFromUrl,
  Y2 as subscriptionDefaultProps,
  MC as timeZoneAttributeDefaultProps,
  D9 as useErrorMapper,
  HT as useGainSight,
  k9 as useI18n,
  A9 as useLaunchDarkly,
  PT as useRemoteModule,
  P9 as useSubscription,
  NC as userDefaultProfileProps,
  LC as userDefaultProps,
  UC as userDefaultUserProject
};
